(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.Jc.Ge === region.Ez.Ge)
	{
		return 'on line ' + region.Jc.Ge;
	}
	return 'on lines ' + region.Jc.Ge + ' through ' + region.Ez.Ge;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.Fz,
		impl.Ka,
		impl.Jq,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'outerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		dZ: func(record.dZ),
		wC: record.wC,
		vU: record.vU
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.dZ;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.wC;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.vU) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.Fz,
		impl.Ka,
		impl.Jq,
		function(sendToApp, initialModel) {
			var view = impl.Ke;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.Fz,
		impl.Ka,
		impl.Jq,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.ws && impl.ws(sendToApp)
			var view = impl.Ke;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.k8);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.q6) && (_VirtualDom_doc.title = title = doc.q6);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.Hg;
	var onUrlRequest = impl.Hh;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		ws: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.H2 === next.H2
							&& curr.Fl === next.Fl
							&& curr.HD.a === next.HD.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		Fz: function(flags)
		{
			return A3(impl.Fz, flags, _Browser_getUrl(), key);
		},
		Ke: impl.Ke,
		Ka: impl.Ka,
		Jq: impl.Jq
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { Fe: 'hidden', Di: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { Fe: 'mozHidden', Di: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { Fe: 'msHidden', Di: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { Fe: 'webkitHidden', Di: 'webkitvisibilitychange' }
		: { Fe: 'hidden', Di: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		Bn: _Browser_getScene(),
		Cj: {
			Cs: _Browser_window.pageXOffset,
			Ct: _Browser_window.pageYOffset,
			Cr: _Browser_doc.documentElement.clientWidth,
			y_: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		Cr: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		y_: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			Bn: {
				Cr: node.scrollWidth,
				y_: node.scrollHeight
			},
			Cj: {
				Cs: node.scrollLeft,
				Ct: node.scrollTop,
				Cr: node.clientWidth,
				y_: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			Bn: _Browser_getScene(),
			Cj: {
				Cs: x,
				Ct: y,
				Cr: _Browser_doc.documentElement.clientWidth,
				y_: _Browser_doc.documentElement.clientHeight
			},
			Eu: {
				Cs: x + rect.left,
				Ct: y + rect.top,
				Cr: rect.width,
				y_: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.da.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.da.b, xhr)); });
		$elm$core$Maybe$isJust(request.dt) && _Http_track(router, xhr, request.dt.a);

		try {
			xhr.open(request.dg, request.Cd, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.Cd));
		}

		_Http_configureRequest(xhr, request);

		request.k8.a && xhr.setRequestHeader('Content-Type', request.k8.a);
		xhr.send(request.k8.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.dd; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.ds.a || 0;
	xhr.responseType = request.da.d;
	xhr.withCredentials = request.CE;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		Cd: xhr.responseURL,
		Jh: xhr.status,
		Ji: xhr.statusText,
		dd: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			IW: event.loaded,
			v: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			A$: event.loaded,
			v: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.GH) { flags += 'm'; }
	if (options.De) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;


// BYTES

function _Bytes_width(bytes)
{
	return bytes.byteLength;
}

var _Bytes_getHostEndianness = F2(function(le, be)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(new Uint8Array(new Uint32Array([1]))[0] === 1 ? le : be));
	});
});


// ENCODERS

function _Bytes_encode(encoder)
{
	var mutableBytes = new DataView(new ArrayBuffer($elm$bytes$Bytes$Encode$getWidth(encoder)));
	$elm$bytes$Bytes$Encode$write(encoder)(mutableBytes)(0);
	return mutableBytes;
}


// SIGNED INTEGERS

var _Bytes_write_i8  = F3(function(mb, i, n) { mb.setInt8(i, n); return i + 1; });
var _Bytes_write_i16 = F4(function(mb, i, n, isLE) { mb.setInt16(i, n, isLE); return i + 2; });
var _Bytes_write_i32 = F4(function(mb, i, n, isLE) { mb.setInt32(i, n, isLE); return i + 4; });


// UNSIGNED INTEGERS

var _Bytes_write_u8  = F3(function(mb, i, n) { mb.setUint8(i, n); return i + 1 ;});
var _Bytes_write_u16 = F4(function(mb, i, n, isLE) { mb.setUint16(i, n, isLE); return i + 2; });
var _Bytes_write_u32 = F4(function(mb, i, n, isLE) { mb.setUint32(i, n, isLE); return i + 4; });


// FLOATS

var _Bytes_write_f32 = F4(function(mb, i, n, isLE) { mb.setFloat32(i, n, isLE); return i + 4; });
var _Bytes_write_f64 = F4(function(mb, i, n, isLE) { mb.setFloat64(i, n, isLE); return i + 8; });


// BYTES

var _Bytes_write_bytes = F3(function(mb, offset, bytes)
{
	for (var i = 0, len = bytes.byteLength, limit = len - 4; i <= limit; i += 4)
	{
		mb.setUint32(offset + i, bytes.getUint32(i));
	}
	for (; i < len; i++)
	{
		mb.setUint8(offset + i, bytes.getUint8(i));
	}
	return offset + len;
});


// STRINGS

function _Bytes_getStringWidth(string)
{
	for (var width = 0, i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		width +=
			(code < 0x80) ? 1 :
			(code < 0x800) ? 2 :
			(code < 0xD800 || 0xDBFF < code) ? 3 : (i++, 4);
	}
	return width;
}

var _Bytes_write_string = F3(function(mb, offset, string)
{
	for (var i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		offset +=
			(code < 0x80)
				? (mb.setUint8(offset, code)
				, 1
				)
				:
			(code < 0x800)
				? (mb.setUint16(offset, 0xC080 /* 0b1100000010000000 */
					| (code >>> 6 & 0x1F /* 0b00011111 */) << 8
					| code & 0x3F /* 0b00111111 */)
				, 2
				)
				:
			(code < 0xD800 || 0xDBFF < code)
				? (mb.setUint16(offset, 0xE080 /* 0b1110000010000000 */
					| (code >>> 12 & 0xF /* 0b00001111 */) << 8
					| code >>> 6 & 0x3F /* 0b00111111 */)
				, mb.setUint8(offset + 2, 0x80 /* 0b10000000 */
					| code & 0x3F /* 0b00111111 */)
				, 3
				)
				:
			(code = (code - 0xD800) * 0x400 + string.charCodeAt(++i) - 0xDC00 + 0x10000
			, mb.setUint32(offset, 0xF0808080 /* 0b11110000100000001000000010000000 */
				| (code >>> 18 & 0x7 /* 0b00000111 */) << 24
				| (code >>> 12 & 0x3F /* 0b00111111 */) << 16
				| (code >>> 6 & 0x3F /* 0b00111111 */) << 8
				| code & 0x3F /* 0b00111111 */)
			, 4
			);
	}
	return offset;
});


// DECODER

var _Bytes_decode = F2(function(decoder, bytes)
{
	try {
		return $elm$core$Maybe$Just(A2(decoder, bytes, 0).b);
	} catch(e) {
		return $elm$core$Maybe$Nothing;
	}
});

var _Bytes_read_i8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getInt8(offset)); });
var _Bytes_read_i16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getInt16(offset, isLE)); });
var _Bytes_read_i32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getInt32(offset, isLE)); });
var _Bytes_read_u8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getUint8(offset)); });
var _Bytes_read_u16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getUint16(offset, isLE)); });
var _Bytes_read_u32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getUint32(offset, isLE)); });
var _Bytes_read_f32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getFloat32(offset, isLE)); });
var _Bytes_read_f64 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 8, bytes.getFloat64(offset, isLE)); });

var _Bytes_read_bytes = F3(function(len, bytes, offset)
{
	return _Utils_Tuple2(offset + len, new DataView(bytes.buffer, bytes.byteOffset + offset, len));
});

var _Bytes_read_string = F3(function(len, bytes, offset)
{
	var string = '';
	var end = offset + len;
	for (; offset < end;)
	{
		var byte = bytes.getUint8(offset++);
		string +=
			(byte < 128)
				? String.fromCharCode(byte)
				:
			((byte & 0xE0 /* 0b11100000 */) === 0xC0 /* 0b11000000 */)
				? String.fromCharCode((byte & 0x1F /* 0b00011111 */) << 6 | bytes.getUint8(offset++) & 0x3F /* 0b00111111 */)
				:
			((byte & 0xF0 /* 0b11110000 */) === 0xE0 /* 0b11100000 */)
				? String.fromCharCode(
					(byte & 0xF /* 0b00001111 */) << 12
					| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
					| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
				)
				:
				(byte =
					((byte & 0x7 /* 0b00000111 */) << 18
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 12
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
						| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
					) - 0x10000
				, String.fromCharCode(Math.floor(byte / 0x400) + 0xD800, byte % 0x400 + 0xDC00)
				);
	}
	return _Utils_Tuple2(offset, string);
});

var _Bytes_decodeFailure = F2(function() { throw 0; });
var $author$project$Login$Model$OnUrlChange = function (a) {
	return {$: 7, a: a};
};
var $author$project$Login$Model$OnUrlRequest = function (a) {
	return {$: 8, a: a};
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$List$cons = _List_cons;
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.N) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.ad),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.ad);
		} else {
			var treeLen = builder.N * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.ag) : builder.ag;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.N);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.ad) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.ad);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{ag: nodeList, N: (len / $elm$core$Array$branchFactor) | 0, ad: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {E3: fragment, Fl: host, qv: path, HD: port_, H2: protocol, l: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $Janiczek$cmd_extra$Cmd$Extra$addCmd = F2(
	function (cmd, _v0) {
		var model = _v0.a;
		var oldCmd = _v0.b;
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[oldCmd, cmd])));
	});
var $author$project$Login$Route$Signin = function (a) {
	return {$: 9, a: a};
};
var $author$project$Login$Route$SigninRouteOptions = F6(
	function (parentBrokerageId, affiliateBrokerageId, email, name, token, location) {
		return {xe: affiliateBrokerageId, aW: email, Gh: location, h$: name, nu: parentBrokerageId, B4: token};
	});
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {eg: frag, en: params, d4: unvisited, kr: value, ez: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.d4;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.kr);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.kr);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.qv),
					$elm$url$Url$Parser$prepareQuery(url.l),
					url.E3,
					$elm$core$Basics$identity)));
	});
var $author$project$Login$Route$AccountSetup = {$: 0};
var $author$project$Login$Route$ActivateAccount = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Login$Route$AffiliateSignup = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Login$Route$AffiliateSignupRouteOptions = F2(
	function (email, name) {
		return {aW: email, h$: name};
	});
var $author$project$Login$Route$AlertSubscriberNew = function (a) {
	return {$: 3, a: a};
};
var $author$project$Login$Route$AlertSubscriberUnsubscribe = function (a) {
	return {$: 4, a: a};
};
var $author$project$Login$Route$ConfirmBindForm = function (a) {
	return {$: 5, a: a};
};
var $author$project$Login$Route$ForgotPassword = {$: 6};
var $author$project$Login$Route$Ransomware = {$: 7};
var $author$project$Login$Route$ResetPassword = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Login$Route$SurplusLinesLicense = function (a) {
	return {$: 10, a: a};
};
var $author$project$Model$Ids$BrokerageId = $elm$core$Basics$identity;
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$url$Url$Parser$Internal$Parser = $elm$core$Basics$identity;
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return function (dict) {
			return func(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, key, dict)));
		};
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Login$Route$affiliateBrokerageIdQueryParser = A2(
	$elm$url$Url$Parser$Query$custom,
	'affiliateBrokerageId',
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$head,
		$elm$core$Maybe$map($elm$core$Basics$identity)));
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.ez;
			var unvisited = _v0.d4;
			var params = _v0.en;
			var frag = _v0.eg;
			var value = _v0.kr;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $author$project$Login$Route$brokerageIdParser = A2(
	$elm$url$Url$Parser$custom,
	'BROKERAGE_ID',
	A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $elm$core$Basics$identity));
var $author$project$Model$Ids$ClientId = $elm$core$Basics$identity;
var $author$project$Login$Route$clientIdParser = A2(
	$elm$url$Url$Parser$custom,
	'CLIENT_ID',
	A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $elm$core$Basics$identity));
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.ez;
		var unvisited = _v0.d4;
		var params = _v0.en;
		var frag = _v0.eg;
		var value = _v0.kr;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.ez;
			var unvisited = _v1.d4;
			var params = _v1.en;
			var frag = _v1.eg;
			var value = _v1.kr;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$url$Url$Parser$Query$map = F2(
	function (func, _v0) {
		var a = _v0;
		return function (dict) {
			return func(
				a(dict));
		};
	});
var $elm$url$Url$Parser$Query$map2 = F3(
	function (func, _v0, _v1) {
		var a = _v0;
		var b = _v1;
		return function (dict) {
			return A2(
				func,
				a(dict),
				b(dict));
		};
	});
var $elm$url$Url$Parser$Query$map6 = F7(
	function (func, _v0, _v1, _v2, _v3, _v4, _v5) {
		var a = _v0;
		var b = _v1;
		var c = _v2;
		var d = _v3;
		var e = _v4;
		var f = _v5;
		return function (dict) {
			return A6(
				func,
				a(dict),
				b(dict),
				c(dict),
				d(dict),
				e(dict),
				f(dict));
		};
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $author$project$Login$Route$parentBrokerageIdQueryParser = A2(
	$elm$url$Url$Parser$Query$custom,
	'parentBrokerageId',
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$head,
		$elm$core$Maybe$map($elm$core$Basics$identity)));
var $author$project$Data$Session$CreatePassword = 0;
var $author$project$Data$Session$ResetPassword = 1;
var $author$project$Data$Session$passwordActionFromMaybe = function (m) {
	if (!m.$) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Model$Ids$PolicyId = $elm$core$Basics$identity;
var $author$project$Login$Route$policyIdParser = A2(
	$elm$url$Url$Parser$custom,
	'POLICY_ID',
	A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $elm$core$Basics$identity));
var $elm$url$Url$Parser$query = function (_v0) {
	var queryParser = _v0;
	return function (_v1) {
		var visited = _v1.ez;
		var unvisited = _v1.d4;
		var params = _v1.en;
		var frag = _v1.eg;
		var value = _v1.kr;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					queryParser(params)))
			]);
	};
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$questionMark = F2(
	function (parser, queryParser) {
		return A2(
			$elm$url$Url$Parser$slash,
			parser,
			$elm$url$Url$Parser$query(queryParser));
	});
var $author$project$Model$Ids$QuoteRequestId = $elm$core$Basics$identity;
var $author$project$Login$Route$quoteRequestIdParser = A2(
	$elm$url$Url$Parser$custom,
	'QUOTE_REQUEST_ID',
	A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $elm$core$Basics$identity));
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.ez;
		var unvisited = _v0.d4;
		var params = _v0.en;
		var frag = _v0.eg;
		var value = _v0.kr;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $elm$url$Url$Parser$Query$string = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$Maybe$Just(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Login$Route$routes = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Login$Route$Signin,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$top,
				A7(
					$elm$url$Url$Parser$Query$map6,
					$author$project$Login$Route$SigninRouteOptions,
					$author$project$Login$Route$parentBrokerageIdQueryParser,
					$author$project$Login$Route$affiliateBrokerageIdQueryParser,
					$elm$url$Url$Parser$Query$string('email'),
					$elm$url$Url$Parser$Query$string('name'),
					$elm$url$Url$Parser$Query$string('token'),
					$elm$url$Url$Parser$Query$string('location')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Login$Route$Signin,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s('signin'),
				A7(
					$elm$url$Url$Parser$Query$map6,
					$author$project$Login$Route$SigninRouteOptions,
					$author$project$Login$Route$parentBrokerageIdQueryParser,
					$author$project$Login$Route$affiliateBrokerageIdQueryParser,
					$elm$url$Url$Parser$Query$string('email'),
					$elm$url$Url$Parser$Query$string('name'),
					$elm$url$Url$Parser$Query$string('token'),
					$elm$url$Url$Parser$Query$string('location')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Login$Route$AccountSetup,
			$elm$url$Url$Parser$s('account-setup')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Login$Route$ActivateAccount,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('activate'),
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$string,
					$elm$url$Url$Parser$Query$string('redirect')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Login$Route$AffiliateSignup,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('signup'),
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$Login$Route$brokerageIdParser,
					A2(
						$elm$url$Url$Parser$questionMark,
						$author$project$Login$Route$brokerageIdParser,
						A3(
							$elm$url$Url$Parser$Query$map2,
							$author$project$Login$Route$AffiliateSignupRouteOptions,
							$elm$url$Url$Parser$Query$string('email'),
							$elm$url$Url$Parser$Query$string('name')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Login$Route$ConfirmBindForm,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('confirm-bind'),
				$author$project$Login$Route$quoteRequestIdParser)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Login$Route$ForgotPassword,
			$elm$url$Url$Parser$s('forgot')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Login$Route$Ransomware,
			$elm$url$Url$Parser$s('ransomware')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Login$Route$ResetPassword,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reset'),
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$string,
					A2(
						$elm$url$Url$Parser$Query$map,
						$author$project$Data$Session$passwordActionFromMaybe,
						$elm$url$Url$Parser$Query$string('setup'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Login$Route$SurplusLinesLicense,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('surplus_lines'),
				$author$project$Login$Route$policyIdParser)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Login$Route$AlertSubscriberNew,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('clients'),
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$Login$Route$clientIdParser,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('alerts'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('subscribers'),
							$elm$url$Url$Parser$s('new')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Login$Route$AlertSubscriberUnsubscribe,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('clients'),
				A2(
					$elm$url$Url$Parser$slash,
					$author$project$Login$Route$clientIdParser,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('alerts'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('subscribers'),
							$elm$url$Url$Parser$s('unsubscribe'))))))
		]));
var $author$project$Login$Route$fromLocation = function (location) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Login$Route$Signin(
			A6($author$project$Login$Route$SigninRouteOptions, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)),
		A2($elm$url$Url$Parser$parse, $author$project$Login$Route$routes, location));
};
var $author$project$Login$Model$GotLocalTimeZone = function (a) {
	return {$: 6, a: a};
};
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$here = _Time_here(0);
var $author$project$Login$Update$getLocalTimeZone = A2($elm$core$Task$perform, $author$project$Login$Model$GotLocalTimeZone, $elm$time$Time$here);
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$UserTracking$identify = _Platform_outgoingPort(
	'identify',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string($.aW)),
					_Utils_Tuple2(
					'role',
					$elm$json$Json$Encode$string($.i5)),
					_Utils_Tuple2(
					'userId',
					$elm$json$Json$Encode$string($.ae))
				]));
	});
var $author$project$Data$Session$isImpersonated = function (_v0) {
	var impersonatorId = _v0.sG;
	if (impersonatorId.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Data$User$adminRoleToString = function (adminRole) {
	switch (adminRole) {
		case 0:
			return 'Actuary';
		case 1:
			return 'Claims';
		case 2:
			return 'Default';
		case 3:
			return 'Developer';
		case 4:
			return 'IT';
		case 5:
			return 'Legal';
		case 6:
			return 'Product Manager';
		case 7:
			return 'Risk + Response';
		case 9:
			return 'Support Rotation';
		case 8:
			return 'Superuser';
		case 10:
			return 'Territory Manager';
		case 11:
			return 'Underwriter';
		case 12:
			return 'Underwriting Assistant';
		case 14:
			return 'Underwriting Manager';
		default:
			return 'UA/Underwriter';
	}
};
var $author$project$Data$Session$roleToLabel = function (role) {
	switch (role.$) {
		case 0:
			return 'Broker';
		case 3:
			return 'Underwriter';
		case 5:
			return 'Policyholder';
		case 1:
			return 'Coverholder';
		case 2:
			return 'Risk Capital Partner';
		case 6:
			return 'External Developer';
		default:
			var adminRole = role.a;
			return $author$project$Data$User$adminRoleToString(adminRole);
	}
};
var $elm$core$String$cons = _String_cons;
var $elm_community$string_extra$String$Extra$changeCase = F2(
	function (mutator, word) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var head = _v0.a;
					var tail = _v0.b;
					return A2(
						$elm$core$String$cons,
						mutator(head),
						tail);
				},
				$elm$core$String$uncons(word)));
	});
var $elm$core$Char$toUpper = _Char_toUpper;
var $elm_community$string_extra$String$Extra$toSentenceCase = function (word) {
	return A2($elm_community$string_extra$String$Extra$changeCase, $elm$core$Char$toUpper, word);
};
var $author$project$Model$Ids$userIdToString = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$UserTracking$identifyUser = F2(
	function (session, role) {
		return $author$project$Data$Session$isImpersonated(session) ? $elm$core$Platform$Cmd$none : $author$project$UserTracking$identify(
			{
				aW: session.aW,
				i5: $elm_community$string_extra$String$Extra$toSentenceCase(
					$author$project$Data$Session$roleToLabel(role)),
				ae: $author$project$Model$Ids$userIdToString(session.ae)
			});
	});
var $author$project$Data$Environment$Development = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$Environment$Production = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Environment$Staging = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$FeatureFlag$Off = 0;
var $author$project$Data$FeatureFlag$off = 0;
var $author$project$Data$FeatureFlag$On = 1;
var $author$project$Data$FeatureFlag$on = 1;
var $author$project$Login$FeatureFlags$constructFeatureFlags = function (environment) {
	var onlyShowIfNotProduction = function () {
		switch (environment.$) {
			case 0:
				return $author$project$Data$FeatureFlag$on;
			case 2:
				return $author$project$Data$FeatureFlag$on;
			default:
				return $author$project$Data$FeatureFlag$off;
		}
	}();
	return {An: onlyShowIfNotProduction};
};
var $author$project$Login$Page$Signin = function (a) {
	return {$: 7, a: a};
};
var $author$project$Login$SigninV2$Model$Model = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $krisajenkins$remotedata$RemoteData$NotAsked = {$: 0};
var $author$project$Data$Password$Password = $elm$core$Basics$identity;
var $author$project$Login$SigninV2$Model$PasswordFlow = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$ValidationNext$Unvalidated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$Email$Email = $elm$core$Basics$identity;
var $author$project$Data$Email$initial = function (email) {
	return email;
};
var $author$project$Login$SigninV2$Model$initialModel = function () {
	var tokenDetails = {B5: $krisajenkins$remotedata$RemoteData$NotAsked};
	var details = {
		aW: $author$project$Model$ValidationNext$Unvalidated(
			$author$project$Data$Email$initial('')),
		ze: false,
		zg: false,
		zi: false,
		zk: true,
		zm: false,
		z8: A6($author$project$Login$Route$SigninRouteOptions, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
		d$: $author$project$Model$ValidationNext$Unvalidated(''),
		BH: $krisajenkins$remotedata$RemoteData$NotAsked
	};
	return A2(
		$author$project$Login$SigninV2$Model$Model,
		details,
		$author$project$Login$SigninV2$Model$PasswordFlow(tokenDetails));
}();
var $author$project$Login$Page$initial = $author$project$Login$Page$Signin($author$project$Login$SigninV2$Model$initialModel);
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Login$Main$initialModel = F3(
	function (key, url, initialValue) {
		var env = function () {
			var _v0 = _Utils_Tuple2(initialValue.zl, initialValue.zk);
			_v0$2:
			while (true) {
				if (_v0.a) {
					if (!_v0.b) {
						return $author$project$Data$Environment$Staging(url);
					} else {
						break _v0$2;
					}
				} else {
					if (_v0.b) {
						return $author$project$Data$Environment$Production(url);
					} else {
						break _v0$2;
					}
				}
			}
			return $author$project$Data$Environment$Development(url);
		}();
		return {
			w3: initialValue.w3,
			xB: initialValue.xB,
			x6: initialValue.x6,
			x9: initialValue.x9,
			yh: initialValue.yh,
			EF: env,
			yI: $author$project$Login$FeatureFlags$constructFeatureFlags(env),
			yO: initialValue.yO,
			zk: initialValue.zk,
			zl: initialValue.zl,
			zm: initialValue.zm,
			mL: key,
			Gg: $elm$time$Time$utc,
			Ac: $author$project$Login$Page$initial,
			l: '',
			Il: $elm$core$Maybe$Nothing,
			IL: $author$project$Login$Route$Signin(
				A6($author$project$Login$Route$SigninRouteOptions, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)),
			Cf: initialValue.Cf
		};
	});
var $author$project$BrowserVersion$Unknown = {$: 6};
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$Data$InitialValue$InitialValue = function (account) {
	return function (affiliateBrokerage) {
		return function (browserVersion) {
			return function (csrfToken) {
				return function (currentVersion) {
					return function (dateAtStartup) {
						return function (isStaging) {
							return function (flashMessage) {
								return function (isProduction) {
									return function (userEmail) {
										return function (isTravelersRequestUrl) {
											return {w3: account, xd: affiliateBrokerage, xB: browserVersion, x6: csrfToken, x9: currentVersion, yh: dateAtStartup, yO: flashMessage, zk: isProduction, zl: isStaging, zm: isTravelersRequestUrl, Cf: userEmail};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$Session$Authenticated = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Data$Session$RequiresMfa = {$: 2};
var $author$project$Data$Session$RequiresMfaSetup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Session$Unauthenticated = {$: 3};
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $author$project$Data$Session$QRCode = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Data$Session$qrCodeDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Session$QRCode,
	A2($elm$json$Json$Decode$field, 'qr_code_string', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'shared_secret', $elm$json$Json$Decode$string));
var $author$project$Data$Session$Admin = function (a) {
	return {$: 4, a: a};
};
var $author$project$Data$Session$Broker = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Data$Session$Coverholder = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Session$ExternalDeveloper = {$: 6};
var $author$project$Data$Session$Policyholder = function (a) {
	return {$: 5, a: a};
};
var $author$project$Data$Session$RiskCapitalPartner = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$Ids$RiskCapitalPartnerId = $elm$core$Basics$identity;
var $author$project$Data$Session$Underwriter = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Enum$AdminRole$Actuary = 0;
var $author$project$Api$Enum$AdminRole$Claims = 1;
var $author$project$Api$Enum$AdminRole$Default = 2;
var $author$project$Api$Enum$AdminRole$Developer = 3;
var $author$project$Api$Enum$AdminRole$It = 4;
var $author$project$Api$Enum$AdminRole$Legal = 5;
var $author$project$Api$Enum$AdminRole$ProductManager = 6;
var $author$project$Api$Enum$AdminRole$RiskAndResponse = 7;
var $author$project$Api$Enum$AdminRole$Superuser = 8;
var $author$project$Api$Enum$AdminRole$SupportRotation = 9;
var $author$project$Api$Enum$AdminRole$TerritoryManager = 10;
var $author$project$Api$Enum$AdminRole$Underwriter = 11;
var $author$project$Api$Enum$AdminRole$UnderwritingAssistant = 12;
var $author$project$Api$Enum$AdminRole$UnderwritingAssistantUnderwriter = 13;
var $author$project$Api$Enum$AdminRole$UnderwritingManager = 14;
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$fail = _Json_fail;
var $author$project$Data$User$adminRoleDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		switch (s) {
			case 'Default':
				return $elm$json$Json$Decode$succeed(2);
			case 'Actuary':
				return $elm$json$Json$Decode$succeed(0);
			case 'Claims':
				return $elm$json$Json$Decode$succeed(1);
			case 'Developer':
				return $elm$json$Json$Decode$succeed(3);
			case 'IT':
				return $elm$json$Json$Decode$succeed(4);
			case 'Legal':
				return $elm$json$Json$Decode$succeed(5);
			case 'Product Manager':
				return $elm$json$Json$Decode$succeed(6);
			case 'Risk + Response':
				return $elm$json$Json$Decode$succeed(7);
			case 'Superuser':
				return $elm$json$Json$Decode$succeed(8);
			case 'Support Rotation':
				return $elm$json$Json$Decode$succeed(9);
			case 'Territory Manager':
				return $elm$json$Json$Decode$succeed(10);
			case 'Underwriter':
				return $elm$json$Json$Decode$succeed(11);
			case 'Underwriting Assistant':
				return $elm$json$Json$Decode$succeed(12);
			case 'Underwriting Manager':
				return $elm$json$Json$Decode$succeed(14);
			case 'UA/Underwriter':
				return $elm$json$Json$Decode$succeed(13);
			default:
				return $elm$json$Json$Decode$fail('Invalid AdminRole ' + s);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Session$PolicyholderClient = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Data$Buyer$PolicyAndSecurityContact = 2;
var $author$project$Data$Buyer$PolicyContact = 0;
var $author$project$Data$Buyer$SecurityContact = 1;
var $author$project$Data$Buyer$ThirdPartyContact = 3;
var $author$project$Data$Session$buyerRoleFromString = function (roleStr) {
	if (!roleStr.$) {
		switch (roleStr.a) {
			case 'policy_contact':
				return $elm$json$Json$Decode$succeed(
					$elm$core$Maybe$Just(0));
			case 'security_contact':
				return $elm$json$Json$Decode$succeed(
					$elm$core$Maybe$Just(1));
			case 'policy_and_security_contact':
				return $elm$json$Json$Decode$succeed(
					$elm$core$Maybe$Just(2));
			case 'third_party_contact':
				return $elm$json$Json$Decode$succeed(
					$elm$core$Maybe$Just(3));
			default:
				return $elm$json$Json$Decode$fail('Invalid client user role.');
		}
	} else {
		return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
	}
};
var $author$project$Data$Client$clientIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $elm$json$Json$Decode$map3 = _Json_map3;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$Data$Session$clientDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Data$Session$PolicyholderClient,
	A2($elm$json$Json$Decode$field, 'client_id', $author$project$Data$Client$clientIdDecoder),
	A2($elm$json$Json$Decode$field, 'client_name', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$andThen,
		$author$project$Data$Session$buyerRoleFromString,
		A2(
			$elm$json$Json$Decode$field,
			'client_user_role',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string))));
var $author$project$Coverholders$Data$Role$CanScan = 0;
var $author$project$Coverholders$Data$Role$decodeRole = function (raw) {
	if (raw === 'can_scan') {
		return $elm$json$Json$Decode$succeed(0);
	} else {
		var err = raw;
		return $elm$json$Json$Decode$fail(err);
	}
};
var $author$project$Coverholders$Data$Role$decoder = A2($elm$json$Json$Decode$andThen, $author$project$Coverholders$Data$Role$decodeRole, $elm$json$Json$Decode$string);
var $author$project$Data$Brokerage$idDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$NonEmpty$NonEmpty = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$NonEmpty$fromList = function (a) {
	if (!a.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var x = a.a;
		var xs = a.b;
		return $elm$core$Maybe$Just(
			A2($author$project$NonEmpty$NonEmpty, x, xs));
	}
};
var $author$project$Data$Session$nonEmptyClientsDecoder = function (clients) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$json$Json$Decode$fail('At least one client is required for the policyholder role.'),
		A2(
			$elm$core$Maybe$map,
			$elm$json$Json$Decode$succeed,
			$author$project$NonEmpty$fromList(clients)));
};
var $author$project$Data$Broker$AffiliateBroker = 0;
var $author$project$Data$Broker$BrokerageOwner = 1;
var $author$project$Data$Broker$Standard = 2;
var $author$project$Data$Broker$relationshipTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (t) {
		switch (t) {
			case 'affiliate':
				return $elm$json$Json$Decode$succeed(0);
			case 'owner':
				return $elm$json$Json$Decode$succeed(1);
			case 'standard':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid relationship type ' + t);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Brokerage$Retailer = 0;
var $author$project$Data$Brokerage$Wholesaler = 1;
var $elm$core$String$toUpper = _String_toUpper;
var $author$project$Data$Brokerage$typeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $elm$core$String$toUpper(str);
		switch (_v0) {
			case 'RETAILER':
				return $elm$json$Json$Decode$succeed(0);
			case 'WHOLESALER':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Did not recognize ' + str);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$UnderwriterRole$All = 0;
var $author$project$Data$UnderwriterRole$Cyber = 1;
var $author$project$Data$UnderwriterRole$CyberObserver = 3;
var $author$project$Data$UnderwriterRole$CyberUK = 2;
var $author$project$Data$UnderwriterRole$FI = 4;
var $author$project$Data$UnderwriterRole$underwriterRoleDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		switch (s) {
			case 'All':
				return $elm$json$Json$Decode$succeed(0);
			case 'Cyber':
				return $elm$json$Json$Decode$succeed(1);
			case 'Cyber UK':
				return $elm$json$Json$Decode$succeed(2);
			case 'Cyber Observer':
				return $elm$json$Json$Decode$succeed(3);
			case 'FI':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('Invalid UnderwriterRole ' + s);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Session$roleDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (role) {
		switch (role) {
			case 'Admin':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Session$Admin,
					A2($elm$json$Json$Decode$field, 'role', $author$project$Data$User$adminRoleDecoder));
			case 'Broker':
				return A4(
					$elm$json$Json$Decode$map3,
					$author$project$Data$Session$Broker,
					A2($elm$json$Json$Decode$field, 'brokerage_id', $author$project$Data$Brokerage$idDecoder),
					A2($elm$json$Json$Decode$field, 'brokerage_type', $author$project$Data$Brokerage$typeDecoder),
					A2($elm$json$Json$Decode$field, 'relationship_type', $author$project$Data$Broker$relationshipTypeDecoder));
			case 'Buyer':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Session$Policyholder,
					A2(
						$elm$json$Json$Decode$andThen,
						$author$project$Data$Session$nonEmptyClientsDecoder,
						A2(
							$elm$json$Json$Decode$field,
							'clients',
							$elm$json$Json$Decode$list($author$project$Data$Session$clientDecoder))));
			case 'Coverholder':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Session$Coverholder,
					A2($elm$json$Json$Decode$field, 'role', $author$project$Coverholders$Data$Role$decoder));
			case 'RiskCapitalPartner':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Session$RiskCapitalPartner,
					A2(
						$elm$json$Json$Decode$field,
						'risk_capital_partner_id',
						A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string)));
			case 'Underwriter':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Session$Underwriter,
					A2($elm$json$Json$Decode$field, 'role', $author$project$Data$UnderwriterRole$underwriterRoleDecoder));
			case 'ExternalDeveloper':
				return $elm$json$Json$Decode$succeed($author$project$Data$Session$ExternalDeveloper);
			default:
				return $elm$json$Json$Decode$fail('Unrecognized role: ' + role);
		}
	},
	A2($elm$json$Json$Decode$field, 'role_type', $elm$json$Json$Decode$string));
var $author$project$Data$Session$Session = F8(
	function (email, name, photoUrl, id, userId, impersonatorId, permissions, locationAfterSignin) {
		return {aW: email, Fm: id, sG: impersonatorId, zG: locationAfterSignin, h$: name, Ak: permissions, Al: photoUrl, ae: userId};
	});
var $author$project$Model$Ids$SessionId = $elm$core$Basics$identity;
var $author$project$Data$Session$AdminPermissions$AdminPermissions = $elm$core$Basics$identity;
var $author$project$Api$Enum$AdminPermission$AdminRoleWrite = 0;
var $author$project$Api$Enum$AdminPermission$BreachResponseRead = 1;
var $author$project$Api$Enum$AdminPermission$BreachResponseWrite = 2;
var $author$project$Api$Enum$AdminPermission$BrokeragesMerge = 3;
var $author$project$Api$Enum$AdminPermission$BrokeragesUpdateCommission = 4;
var $author$project$Api$Enum$AdminPermission$BrokersChangeBrokerage = 5;
var $author$project$Api$Enum$AdminPermission$BrokersUpdateUnderwriterAssignments = 6;
var $author$project$Api$Enum$AdminPermission$ClaimsRead = 7;
var $author$project$Api$Enum$AdminPermission$ClaimsViewPayments = 8;
var $author$project$Api$Enum$AdminPermission$ClaimsWrite = 9;
var $author$project$Api$Enum$AdminPermission$DataMigrationsRun = 10;
var $author$project$Api$Enum$AdminPermission$FeatureFlagsRead = 11;
var $author$project$Api$Enum$AdminPermission$FeatureFlagsWrite = 12;
var $author$project$Api$Enum$AdminPermission$ObanWebWrite = 13;
var $author$project$Api$Enum$AdminPermission$PoliciesAmendIssuedCoverage = 14;
var $author$project$Api$Enum$AdminPermission$PoliciesCancelPolicy = 15;
var $author$project$Api$Enum$AdminPermission$PoliciesCreateInvoice = 16;
var $author$project$Api$Enum$AdminPermission$PoliciesEditBoundCoverage = 17;
var $author$project$Api$Enum$AdminPermission$PoliciesEditUnderwriterAssignments = 18;
var $author$project$Api$Enum$AdminPermission$PoliciesGeneratePolicyDocument = 19;
var $author$project$Api$Enum$AdminPermission$PoliciesPostBindEditSubmission = 20;
var $author$project$Api$Enum$AdminPermission$PoliciesRemoveInvoice = 21;
var $author$project$Api$Enum$AdminPermission$PoliciesRescindBind = 22;
var $author$project$Api$Enum$AdminPermission$PoliciesStartRenewal = 23;
var $author$project$Api$Enum$AdminPermission$PoliciesUndoBind = 24;
var $author$project$Api$Enum$AdminPermission$PoliciesUpdateRating = 25;
var $author$project$Api$Enum$AdminPermission$PoliciesVoidPolicies = 26;
var $author$project$Api$Enum$AdminPermission$RatingEngineRead = 27;
var $author$project$Api$Enum$AdminPermission$RatingEngineWrite = 28;
var $author$project$Api$Enum$AdminPermission$ThreatsRead = 29;
var $author$project$Api$Enum$AdminPermission$ThreatsWrite = 30;
var $author$project$Api$Enum$AdminPermission$UnderwritingRulesWrite = 31;
var $author$project$Api$Enum$AdminPermission$UsersBulkImport = 32;
var $author$project$Api$Enum$AdminPermission$UsersEmailUpdate = 33;
var $author$project$Api$Enum$AdminPermission$UsersExternalResetMfa = 34;
var $author$project$Api$Enum$AdminPermission$UsersInternalResetMfa = 35;
var $author$project$Api$Enum$AdminPermission$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'ADMIN_ROLE_WRITE':
				return $elm$json$Json$Decode$succeed(0);
			case 'BREACH_RESPONSE_READ':
				return $elm$json$Json$Decode$succeed(1);
			case 'BREACH_RESPONSE_WRITE':
				return $elm$json$Json$Decode$succeed(2);
			case 'BROKERAGES_MERGE':
				return $elm$json$Json$Decode$succeed(3);
			case 'BROKERAGES_UPDATE_COMMISSION':
				return $elm$json$Json$Decode$succeed(4);
			case 'BROKERS_CHANGE_BROKERAGE':
				return $elm$json$Json$Decode$succeed(5);
			case 'BROKERS_UPDATE_UNDERWRITER_ASSIGNMENTS':
				return $elm$json$Json$Decode$succeed(6);
			case 'CLAIMS_READ':
				return $elm$json$Json$Decode$succeed(7);
			case 'CLAIMS_VIEW_PAYMENTS':
				return $elm$json$Json$Decode$succeed(8);
			case 'CLAIMS_WRITE':
				return $elm$json$Json$Decode$succeed(9);
			case 'DATA_MIGRATIONS_RUN':
				return $elm$json$Json$Decode$succeed(10);
			case 'FEATURE_FLAGS_READ':
				return $elm$json$Json$Decode$succeed(11);
			case 'FEATURE_FLAGS_WRITE':
				return $elm$json$Json$Decode$succeed(12);
			case 'OBAN_WEB_WRITE':
				return $elm$json$Json$Decode$succeed(13);
			case 'POLICIES_AMEND_ISSUED_COVERAGE':
				return $elm$json$Json$Decode$succeed(14);
			case 'POLICIES_CANCEL_POLICY':
				return $elm$json$Json$Decode$succeed(15);
			case 'POLICIES_CREATE_INVOICE':
				return $elm$json$Json$Decode$succeed(16);
			case 'POLICIES_EDIT_BOUND_COVERAGE':
				return $elm$json$Json$Decode$succeed(17);
			case 'POLICIES_EDIT_UNDERWRITER_ASSIGNMENTS':
				return $elm$json$Json$Decode$succeed(18);
			case 'POLICIES_GENERATE_POLICY_DOCUMENT':
				return $elm$json$Json$Decode$succeed(19);
			case 'POLICIES_POST_BIND_EDIT_SUBMISSION':
				return $elm$json$Json$Decode$succeed(20);
			case 'POLICIES_REMOVE_INVOICE':
				return $elm$json$Json$Decode$succeed(21);
			case 'POLICIES_RESCIND_BIND':
				return $elm$json$Json$Decode$succeed(22);
			case 'POLICIES_START_RENEWAL':
				return $elm$json$Json$Decode$succeed(23);
			case 'POLICIES_UNDO_BIND':
				return $elm$json$Json$Decode$succeed(24);
			case 'POLICIES_UPDATE_RATING':
				return $elm$json$Json$Decode$succeed(25);
			case 'POLICIES_VOID_POLICIES':
				return $elm$json$Json$Decode$succeed(26);
			case 'RATING_ENGINE_READ':
				return $elm$json$Json$Decode$succeed(27);
			case 'RATING_ENGINE_WRITE':
				return $elm$json$Json$Decode$succeed(28);
			case 'THREATS_READ':
				return $elm$json$Json$Decode$succeed(29);
			case 'THREATS_WRITE':
				return $elm$json$Json$Decode$succeed(30);
			case 'UNDERWRITING_RULES_WRITE':
				return $elm$json$Json$Decode$succeed(31);
			case 'USERS_BULK_IMPORT':
				return $elm$json$Json$Decode$succeed(32);
			case 'USERS_EMAIL_UPDATE':
				return $elm$json$Json$Decode$succeed(33);
			case 'USERS_EXTERNAL_RESET_MFA':
				return $elm$json$Json$Decode$succeed(34);
			case 'USERS_INTERNAL_RESET_MFA':
				return $elm$json$Json$Decode$succeed(35);
			default:
				return $elm$json$Json$Decode$fail('Invalid AdminPermission type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $Gizra$elm_all_set$EverySet$EverySet = $elm$core$Basics$identity;
var $pzp1997$assoc_list$AssocList$D = $elm$core$Basics$identity;
var $pzp1997$assoc_list$AssocList$empty = _List_Nil;
var $Gizra$elm_all_set$EverySet$empty = $pzp1997$assoc_list$AssocList$empty;
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $pzp1997$assoc_list$AssocList$remove = F2(
	function (targetKey, _v0) {
		var alist = _v0;
		return A2(
			$elm$core$List$filter,
			function (_v1) {
				var key = _v1.a;
				return !_Utils_eq(key, targetKey);
			},
			alist);
	});
var $pzp1997$assoc_list$AssocList$insert = F3(
	function (key, value, dict) {
		var _v0 = A2($pzp1997$assoc_list$AssocList$remove, key, dict);
		var alteredAlist = _v0;
		return A2(
			$elm$core$List$cons,
			_Utils_Tuple2(key, value),
			alteredAlist);
	});
var $Gizra$elm_all_set$EverySet$insert = F2(
	function (k, _v0) {
		var d = _v0;
		return A3($pzp1997$assoc_list$AssocList$insert, k, 0, d);
	});
var $Gizra$elm_all_set$EverySet$fromList = function (xs) {
	return A3($elm$core$List$foldl, $Gizra$elm_all_set$EverySet$insert, $Gizra$elm_all_set$EverySet$empty, xs);
};
var $author$project$Data$Session$AdminPermissions$decoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $Gizra$elm_all_set$EverySet$fromList),
	$elm$json$Json$Decode$list($author$project$Api$Enum$AdminPermission$decoder));
var $author$project$Model$Ids$UserId = $elm$core$Basics$identity;
var $author$project$Model$Ids$Decode$user = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Data$User$idDecoder = $author$project$Model$Ids$Decode$user;
var $author$project$Data$Session$AdminPermissions$none = $Gizra$elm_all_set$EverySet$empty;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (path, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					return A2(
						$elm$json$Json$Decode$at,
						path,
						nullOr(valDecoder));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				_List_fromArray(
					[key]),
				valDecoder,
				fallback),
			decoder);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Data$Session$sessionIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Data$Session$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'permissions',
	$author$project$Data$Session$AdminPermissions$decoder,
	$author$project$Data$Session$AdminPermissions$none,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'impersonator_id',
		$elm$json$Json$Decode$nullable($author$project$Data$User$idDecoder),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'user_id',
			$author$project$Data$User$idDecoder,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'id',
				$author$project$Data$Session$sessionIdDecoder,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'photo_url',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'name',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'email',
							$elm$json$Json$Decode$string,
							'',
							$elm$json$Json$Decode$succeed($author$project$Data$Session$Session))))))));
var $author$project$Data$Session$NoRedirect = {$: 1};
var $author$project$Data$Session$RedirectTo = function (a) {
	return {$: 0, a: a};
};
var $elm_community$maybe_extra$Maybe$Extra$unwrap = F3(
	function (_default, f, m) {
		if (m.$ === 1) {
			return _default;
		} else {
			var a = m.a;
			return f(a);
		}
	});
var $author$project$Data$Session$redirectDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$Data$Session$NoRedirect, $author$project$Data$Session$RedirectTo),
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Data$Session$sessionDecoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (partialSession, redirect) {
			return partialSession(redirect);
		}),
	A2($elm$json$Json$Decode$field, 'session', $author$project$Data$Session$decoder),
	A2($elm$json$Json$Decode$field, 'location', $author$project$Data$Session$redirectDecoder));
var $author$project$Data$Session$accountDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A3(
			$elm$json$Json$Decode$map2,
			$author$project$Data$Session$Authenticated,
			$author$project$Data$Session$sessionDecoder,
			A2($elm$json$Json$Decode$field, 'account', $author$project$Data$Session$roleDecoder)),
			A2($elm$json$Json$Decode$map, $author$project$Data$Session$RequiresMfaSetup, $author$project$Data$Session$qrCodeDecoder),
			A2(
			$elm$json$Json$Decode$map,
			function (_v0) {
				return $author$project$Data$Session$RequiresMfa;
			},
			A2($elm$json$Json$Decode$field, 'requires_mfa', $elm$json$Json$Decode$bool)),
			$elm$json$Json$Decode$succeed($author$project$Data$Session$Unauthenticated)
		]));
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {Dv: col, DE: contextStack, HW: problem, IM: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.IM, s.Dv, x, s.rY));
	});
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.G4, s.c);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{Dv: 1, rY: s.rY, p: s.p, G4: s.G4 + 1, IM: s.IM + 1, c: s.c}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{Dv: s.Dv + 1, rY: s.rY, p: s.p, G4: newOffset, IM: s.IM, c: s.c}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.HW;
	if (problem.$ === 12) {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.c),
			s.G4) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$Advanced$commit = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, true, a, s);
	};
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.G4, s1.G4, s0.c),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$core$Basics$not = _Basics_not;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.G4, s.IM, s.Dv, s.c);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{Dv: newCol, rY: s.rY, p: s.p, G4: newOffset, IM: newRow, c: s.c});
	};
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $elm$core$Basics$modBy = _Basics_modBy;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn) && A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2(
				$justinmimbs$date$Date$daysBeforeMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn))) + d) : $elm$core$Result$Err(
			'Invalid calendar date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(mn) + (', ' + ($elm$core$String$fromInt(d) + ')'))))));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 365, od) || ((od === 366) && $justinmimbs$date$Date$isLeapYear(y))) ? $elm$core$Result$Ok(
			$justinmimbs$date$Date$daysBeforeYear(y) + od) : $elm$core$Result$Err(
			'Invalid ordinal date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(od) + ')'))));
	});
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn) && (A3($justinmimbs$date$Date$isBetweenInt, 1, 52, wn) || ((wn === 53) && $justinmimbs$date$Date$is53WeekYear(wy)))) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn) : $elm$core$Result$Err(
			'Invalid week date (' + ($elm$core$String$fromInt(wy) + (', ' + ($elm$core$String$fromInt(wn) + (', ' + ($elm$core$String$fromInt(wdn) + ')'))))));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 0:
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 1:
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return c === '-';
									}),
									$elm$parser$Parser$succeed(0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (!result.$) {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {Dv: col, HW: problem, IM: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.IM, p.Dv, p.HW);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{Dv: 1, rY: _List_Nil, p: 1, G4: 0, IM: 1, c: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq('T'))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($justinmimbs$date$Date$deadEndToString),
				$elm$core$Maybe$withDefault('')))));
var $author$project$Decode$date = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		var _v0 = $justinmimbs$date$Date$fromIsoString(s);
		if (!_v0.$) {
			var d = _v0.a;
			return $elm$json$Json$Decode$succeed(d);
		} else {
			var error = _v0.a;
			return $elm$json$Json$Decode$fail(error);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$BrowserVersion$Chrome = {$: 0};
var $author$project$BrowserVersion$Edge = {$: 4};
var $author$project$BrowserVersion$Firefox = {$: 1};
var $author$project$BrowserVersion$InternetExplorer = function (a) {
	return {$: 5, a: a};
};
var $author$project$BrowserVersion$Opera = {$: 3};
var $author$project$BrowserVersion$Safari = {$: 2};
var $author$project$BrowserVersion$Version11 = 1;
var $author$project$BrowserVersion$VersionLt11 = 0;
var $author$project$BrowserVersion$decoder = A2(
	$elm$json$Json$Decode$map,
	function (browserString) {
		switch (browserString) {
			case 'chrome':
				return $author$project$BrowserVersion$Chrome;
			case 'firefox':
				return $author$project$BrowserVersion$Firefox;
			case 'safari':
				return $author$project$BrowserVersion$Safari;
			case 'edge':
				return $author$project$BrowserVersion$Edge;
			case 'opera':
				return $author$project$BrowserVersion$Opera;
			case 'lt-ie11':
				return $author$project$BrowserVersion$InternetExplorer(0);
			case 'ie11':
				return $author$project$BrowserVersion$InternetExplorer(1);
			default:
				return $author$project$BrowserVersion$Unknown;
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Brokerage$Brokerage = function (id) {
	return function (affiliateRelationship) {
		return function (approvedAt) {
			return function (brokers) {
				return function (brokerageTeams) {
					return function (commissionBasisPoints) {
						return function (name) {
							return function (productLineCommissions) {
								return function (productTypes) {
									return function (logo) {
										return function (renewalCommissionBasisPoints) {
											return function (type_) {
												return {CD: affiliateRelationship, rx: approvedAt, Db: brokerageTeams, Dc: brokers, lA: commissionBasisPoints, Fm: id, Gj: logo, h$: name, HX: productLineCommissions, vX: productTypes, nL: renewalCommissionBasisPoints, av: type_};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$Brokerage$ProductLineCommission = F3(
	function (productType, basisPoints, renewalBasisPoints) {
		return {c3: basisPoints, AC: productType, Is: renewalBasisPoints};
	});
var $author$project$Decode$connectionToList = function (nodeDecoder) {
	return A2(
		$elm$json$Json$Decode$field,
		'edges',
		$elm$json$Json$Decode$list(
			A2($elm$json$Json$Decode$field, 'node', nodeDecoder)));
};
var $author$project$Data$AffiliateRelationship$AffiliateRelationship = F4(
	function (parentBrokerageId, parentBrokerageName, parentBrokerageCommissionBasisPoints, managers) {
		return {Gm: managers, Hq: parentBrokerageCommissionBasisPoints, nu: parentBrokerageId, Hr: parentBrokerageName};
	});
var $author$project$Model$Ids$Decode$brokerage = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Data$AffiliateRelationshipManager$AffiliateRelationshipManager = F3(
	function (id, name, email) {
		return {aW: email, Fm: id, h$: name};
	});
var $author$project$Data$AffiliateRelationshipManager$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'email',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$author$project$Model$Ids$Decode$user,
			$elm$json$Json$Decode$succeed($author$project$Data$AffiliateRelationshipManager$AffiliateRelationshipManager))));
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt = F3(
	function (path, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$at, path, valDecoder),
			decoder);
	});
var $author$project$Data$AffiliateRelationship$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'managers',
	$elm$json$Json$Decode$list($author$project$Data$AffiliateRelationshipManager$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['parentBrokerage', 'commissionBasisPoints']),
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['parentBrokerage', 'name']),
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['parentBrokerage', 'id']),
				$author$project$Model$Ids$Decode$brokerage,
				$elm$json$Json$Decode$succeed($author$project$Data$AffiliateRelationship$AffiliateRelationship)))));
var $author$project$Data$Broker$Broker = F4(
	function (id, brokerageName, name, email) {
		return {li: brokerageName, aW: email, Fm: id, h$: name};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var $author$project$Data$Broker$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'email',
	$elm$json$Json$Decode$string,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'name',
		$elm$json$Json$Decode$string,
		'',
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$author$project$Model$Ids$Decode$user,
				$elm$json$Json$Decode$succeed($author$project$Data$Broker$Broker)))));
var $author$project$Model$Ids$AddressId = $elm$core$Basics$identity;
var $author$project$Data$BrokerageTeam$BrokerageTeam = F6(
	function (id, addressId, brokerageId, brokers, teamLeader, teamName) {
		return {eH: addressId, lh: brokerageId, Dc: brokers, Fm: id, JE: teamLeader, JF: teamName};
	});
var $author$project$Model$Ids$BrokerageTeamId = $elm$core$Basics$identity;
var $author$project$Data$BrokerageTeam$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'teamName',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'teamLeader',
		$author$project$Data$Broker$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'brokers',
			$elm$json$Json$Decode$list($author$project$Data$Broker$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'brokerageId',
				A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'addressId',
					A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string),
						$elm$json$Json$Decode$succeed($author$project$Data$BrokerageTeam$BrokerageTeam)))))));
var $author$project$Data$Upload$Upload = F6(
	function (id, insertedAt, name, size, updatedAt, url) {
		return {Fm: id, FJ: insertedAt, h$: name, v: size, wT: updatedAt, Cd: url};
	});
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $rtfeldman$elm_iso8601_date_strings$DeadEnds$problemToString = function (p) {
	switch (p.$) {
		case 0:
			var s = p.a;
			return 'expecting \'' + (s + '\'');
		case 1:
			return 'expecting int';
		case 2:
			return 'expecting hex';
		case 3:
			return 'expecting octal';
		case 4:
			return 'expecting binary';
		case 5:
			return 'expecting float';
		case 6:
			return 'expecting number';
		case 7:
			return 'expecting variable';
		case 8:
			var s = p.a;
			return 'expecting symbol \'' + (s + '\'');
		case 9:
			var s = p.a;
			return 'expecting keyword \'' + (s + '\'');
		case 10:
			return 'expecting end';
		case 11:
			return 'unexpected char';
		case 12:
			var s = p.a;
			return 'problem ' + s;
		default:
			return 'bad repeat';
	}
};
var $rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndToString = function (deadend) {
	return $rtfeldman$elm_iso8601_date_strings$DeadEnds$problemToString(deadend.HW) + (' at row ' + ($elm$core$String$fromInt(deadend.IM) + (', col ' + $elm$core$String$fromInt(deadend.Dv))));
};
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndsToString = function (deadEnds) {
	return $elm$core$String$concat(
		A2(
			$elm$core$List$intersperse,
			'; ',
			A2($elm$core$List$map, $rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndToString, deadEnds)));
};
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.c);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.G4, offset) < 0,
					0,
					{Dv: col, rY: s0.rY, p: s0.p, G4: offset, IM: row, c: s0.c});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.G4, s.IM, s.Dv, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $elm$core$Basics$round = _Basics_round;
var $elm$core$String$toFloat = _String_toFloat;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$append = _String_append;
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
										$elm$parser$Parser$succeed(0)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(str);
		if (_v0.$ === 1) {
			var deadEnds = _v0.a;
			return $elm$json$Json$Decode$fail(
				$rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndsToString(deadEnds));
		} else {
			var time = _v0.a;
			return $elm$json$Json$Decode$succeed(time);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Upload$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'url',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'updatedAt',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'size',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'insertedAt',
					$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Data$Upload$Upload)))))));
var $author$project$Loadable$Loaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Loadable$NotLoaded = {$: 1};
var $author$project$Decode$loadable = F2(
	function (field, valDecoder) {
		return A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			field,
			A2($elm$json$Json$Decode$map, $author$project$Loadable$Loaded, valDecoder),
			$author$project$Loadable$NotLoaded);
	});
var $author$project$Data$ProductLine$AdmittedCyber = {$: 0};
var $author$project$Data$ProductLine$Cyber = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$ProductLine$CyberEu = {$: 2};
var $author$project$Data$ProductLine$CyberEuExcess = {$: 3};
var $author$project$Data$ProductLine$CyberExcess = function (a) {
	return {$: 4, a: a};
};
var $author$project$Data$ProductLine$CyberReinsurance = {$: 5};
var $author$project$Data$ProductLine$CyberUkDeclaration = {$: 7};
var $author$project$Data$ProductLine$CyberUkOpenMarket = {$: 6};
var $author$project$Data$ProductLine$ExcessFi = {$: 8};
var $author$project$Data$ProductLine$FiAssetManagement = {$: 9};
var $author$project$Data$ProductLine$FiSelect = {$: 10};
var $author$project$Data$ProductLine$Retail = 0;
var $author$project$Data$ProductLine$TechEO = function (a) {
	return {$: 11, a: a};
};
var $author$project$Data$ProductLine$TechEOExcess = {$: 12};
var $author$project$Data$ProductLine$Wholesale = 1;
var $author$project$Data$ProductLine$typeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'ADMITTED_CYBER':
				return $elm$json$Json$Decode$succeed($author$project$Data$ProductLine$AdmittedCyber);
			case 'CYBER':
				return $elm$json$Json$Decode$succeed(
					$author$project$Data$ProductLine$Cyber(1));
			case 'CYBER_ES_RETAIL':
				return $elm$json$Json$Decode$succeed(
					$author$project$Data$ProductLine$Cyber(0));
			case 'CYBER_EU':
				return $elm$json$Json$Decode$succeed($author$project$Data$ProductLine$CyberEu);
			case 'CYBER_EU_Excess':
				return $elm$json$Json$Decode$succeed($author$project$Data$ProductLine$CyberEuExcess);
			case 'CYBER_EXCESS':
				return $elm$json$Json$Decode$succeed(
					$author$project$Data$ProductLine$CyberExcess(1));
			case 'CYBER_EXCESS_RETAIL':
				return $elm$json$Json$Decode$succeed(
					$author$project$Data$ProductLine$CyberExcess(0));
			case 'CYBER_REINSURANCE':
				return $elm$json$Json$Decode$succeed($author$project$Data$ProductLine$CyberReinsurance);
			case 'CYBER_UK_OPEN_MARKET':
				return $elm$json$Json$Decode$succeed($author$project$Data$ProductLine$CyberUkOpenMarket);
			case 'CYBER_UK_DECLARATION':
				return $elm$json$Json$Decode$succeed($author$project$Data$ProductLine$CyberUkDeclaration);
			case 'EXCESS_FI':
				return $elm$json$Json$Decode$succeed($author$project$Data$ProductLine$ExcessFi);
			case 'FI_ASSET_MANAGEMENT':
				return $elm$json$Json$Decode$succeed($author$project$Data$ProductLine$FiAssetManagement);
			case 'FI_SELECT':
				return $elm$json$Json$Decode$succeed($author$project$Data$ProductLine$FiSelect);
			case 'TECH_EO':
				return $elm$json$Json$Decode$succeed(
					$author$project$Data$ProductLine$TechEO(1));
			case 'TECH_EO_RETAIL':
				return $elm$json$Json$Decode$succeed(
					$author$project$Data$ProductLine$TechEO(0));
			case 'TECH_EO_EXCESS':
				return $elm$json$Json$Decode$succeed($author$project$Data$ProductLine$TechEOExcess);
			default:
				return $elm$json$Json$Decode$fail('Did not recognize ' + str);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Brokerage$decoder = function () {
	var decodeCommissions = A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'renewalBasisPoints',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'basisPoints',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'productType',
				$author$project$Data$ProductLine$typeDecoder,
				$elm$json$Json$Decode$succeed($author$project$Data$Brokerage$ProductLineCommission))));
	return A2(
		$elm$json$Json$Decode$andThen,
		function (brokerageId) {
			return A3(
				$author$project$Decode$loadable,
				'type',
				$author$project$Data$Brokerage$typeDecoder,
				A3(
					$author$project$Decode$loadable,
					'renewalCommissionBasisPoints',
					$elm$json$Json$Decode$int,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'logo',
						$elm$json$Json$Decode$nullable($author$project$Data$Upload$decoder),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'productTypes',
							$elm$json$Json$Decode$list($author$project$Data$ProductLine$typeDecoder),
							_List_Nil,
							A3(
								$author$project$Decode$loadable,
								'productLineCommissions',
								$elm$json$Json$Decode$list(decodeCommissions),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'name',
									$elm$json$Json$Decode$string,
									A3(
										$author$project$Decode$loadable,
										'commissionBasisPoints',
										$elm$json$Json$Decode$int,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'brokerageTeams',
											$author$project$Decode$connectionToList($author$project$Data$BrokerageTeam$decoder),
											_List_Nil,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'brokers',
												$author$project$Decode$connectionToList($author$project$Data$Broker$decoder),
												_List_Nil,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'approvedAt',
													$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
													$elm$core$Maybe$Nothing,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'affiliateRelationship',
														$elm$json$Json$Decode$nullable($author$project$Data$AffiliateRelationship$decoder),
														$elm$core$Maybe$Nothing,
														A2(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
															brokerageId,
															$elm$json$Json$Decode$succeed($author$project$Data$Brokerage$Brokerage)))))))))))));
		},
		A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Brokerage$idDecoder));
}();
var $author$project$Data$InitialValue$maybeStringDecoder = A2(
	$elm$json$Json$Decode$map,
	function (s) {
		if (s.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (s.a === '') {
				return $elm$core$Maybe$Nothing;
			} else {
				var value = s;
				return value;
			}
		}
	},
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Data$InitialValue$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'isTravelersRequestUrl',
	$elm$json$Json$Decode$bool,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'userEmail',
		$author$project$Data$InitialValue$maybeStringDecoder,
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'isProduction',
			$elm$json$Json$Decode$bool,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'flashMessage',
				$author$project$Data$InitialValue$maybeStringDecoder,
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'isStaging',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'dateAtStartup',
						$author$project$Decode$date,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'currentVersion',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'csrfToken',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'browserVersion',
									$author$project$BrowserVersion$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'affiliateBrokerage',
										$elm$json$Json$Decode$nullable($author$project$Data$Brokerage$decoder),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'initialData',
											$author$project$Data$Session$accountDecoder,
											$elm$json$Json$Decode$succeed($author$project$Data$InitialValue$InitialValue))))))))))));
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $justinmimbs$date$Date$fromOrdinalDate = F2(
	function (y, od) {
		var daysInY = $justinmimbs$date$Date$isLeapYear(y) ? 366 : 365;
		return $justinmimbs$date$Date$daysBeforeYear(y) + A3($elm$core$Basics$clamp, 1, daysInY, od);
	});
var $author$project$Data$Session$initialAccount = $author$project$Data$Session$Unauthenticated;
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$Data$InitialValue$initialize = function (value) {
	return A2(
		$elm$core$Result$withDefault,
		{
			w3: $author$project$Data$Session$initialAccount,
			xd: $elm$core$Maybe$Nothing,
			xB: $author$project$BrowserVersion$Unknown,
			x6: '',
			x9: '',
			yh: A2($justinmimbs$date$Date$fromOrdinalDate, 2018, 1),
			yO: $elm$core$Maybe$Nothing,
			zk: true,
			zl: false,
			zm: false,
			Cf: $elm$core$Maybe$Nothing
		},
		A2($elm$json$Json$Decode$decodeValue, $author$project$Data$InitialValue$decoder, value));
};
var $author$project$UserTracking$EventName$Login = 3;
var $author$project$Login$Page$AccountSetup = function (a) {
	return {$: 0, a: a};
};
var $author$project$Login$Model$AccountSetupMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Login$Page$AffiliateSignup = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Login$Model$AffiliateSignupMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Login$Page$AlertSubscriberNew = function (a) {
	return {$: 2, a: a};
};
var $author$project$Login$Model$AlertSubscriberNewMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Login$Page$AlertSubscriberUnsubscribe = function (a) {
	return {$: 3, a: a};
};
var $author$project$Login$Model$AlertSubscriberUnsubscribeMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Login$Page$ConfirmBindForm = function (a) {
	return {$: 4, a: a};
};
var $author$project$Login$Model$ConfirmBindFormMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Login$Page$ForgotPassword = function (a) {
	return {$: 5, a: a};
};
var $author$project$Login$Model$ForgotPasswordMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Login$Ransomware$Model$NonAuth = 1;
var $author$project$Login$Page$Ransomware = function (a) {
	return {$: 6, a: a};
};
var $author$project$Login$Model$RansomwareMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Login$Model$SigninMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Login$Page$SurplusLinesLicense = function (a) {
	return {$: 8, a: a};
};
var $author$project$Login$Model$SurplusLinesLicenseMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Login$AccountSetup$init = function (isTravelersRequestUrl) {
	return _Utils_Tuple2(
		{
			aW: $author$project$Model$ValidationNext$Unvalidated(
				$author$project$Data$Email$initial('')),
			gW: $krisajenkins$remotedata$RemoteData$NotAsked,
			zm: isTravelersRequestUrl
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Login$AffiliateSignup$Model$GetBrokeragesCompleted = function (a) {
	return {$: 2, a: a};
};
var $krisajenkins$remotedata$RemoteData$Loading = {$: 1};
var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
	return {$: 2, a: a};
};
var $krisajenkins$remotedata$RemoteData$Success = function (a) {
	return {$: 3, a: a};
};
var $krisajenkins$remotedata$RemoteData$fromResult = function (result) {
	if (result.$ === 1) {
		var e = result.a;
		return $krisajenkins$remotedata$RemoteData$Failure(e);
	} else {
		var x = result.a;
		return $krisajenkins$remotedata$RemoteData$Success(x);
	}
};
var $author$project$Request$Account$GetParentAndAffiliateBrokeragesResponse = F2(
	function (affiliateBrokerage, parentBrokerage) {
		return {xd: affiliateBrokerage, Hp: parentBrokerage};
	});
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.Jh));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {A8: reqs, BZ: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.dt;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.A8));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.BZ)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					CE: r.CE,
					k8: r.k8,
					da: A2(_Http_mapExpect, func, r.da),
					dd: r.dd,
					dg: r.dg,
					ds: r.ds,
					dt: r.dt,
					Cd: r.Cd
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{CE: false, k8: r.k8, da: r.da, dd: r.dd, dg: r.dg, ds: r.ds, dt: r.dt, Cd: r.Cd}));
};
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Request$Account$getParentAndAffiliateBrokerages = F4(
	function (msg, _v0, _v1, _v2) {
		var parentBrokerageId = _v0;
		var affiliateBrokerageId = _v1;
		var ids = A2(
			$elm$core$String$join,
			',',
			_List_fromArray(
				[parentBrokerageId, affiliateBrokerageId]));
		var decoder = A2(
			$elm$json$Json$Decode$map,
			function (list) {
				var parent = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (b) {
							return _Utils_eq(b.Fm, parentBrokerageId);
						},
						list));
				var affiliate = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (b) {
							return _Utils_eq(b.Fm, affiliateBrokerageId);
						},
						list));
				var _v3 = _Utils_Tuple2(parent, affiliate);
				if ((!_v3.a.$) && (!_v3.b.$)) {
					var p = _v3.a.a;
					var a = _v3.b.a;
					return $elm$core$Maybe$Just(
						A2($author$project$Request$Account$GetParentAndAffiliateBrokeragesResponse, a, p));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			A2(
				$elm$json$Json$Decode$field,
				'data',
				$elm$json$Json$Decode$list($author$project$Data$Brokerage$decoder)));
		return $elm$http$Http$request(
			{
				k8: $elm$http$Http$emptyBody,
				da: A2($elm$http$Http$expectJson, msg, decoder),
				dd: _List_Nil,
				dg: 'GET',
				ds: $elm$core$Maybe$Nothing,
				dt: $elm$core$Maybe$Nothing,
				Cd: A2(
					$elm$url$Url$Builder$absolute,
					_List_fromArray(
						['brokerages']),
					_List_fromArray(
						[
							A2($elm$url$Url$Builder$string, 'ids', ids)
						]))
			});
	});
var $author$project$Login$AffiliateSignup$Update$init = F5(
	function (email, name, parentBrokerageId, affiliateBrokerageId, csrfToken) {
		return _Utils_Tuple2(
			{
				aW: $author$project$Model$ValidationNext$Unvalidated(
					$author$project$Data$Email$initial(
						A2($elm$core$Maybe$withDefault, '', email))),
				E7: $krisajenkins$remotedata$RemoteData$Loading,
				h$: $author$project$Model$ValidationNext$Unvalidated(
					A2($elm$core$Maybe$withDefault, '', name)),
				IZ: $krisajenkins$remotedata$RemoteData$NotAsked
			},
			A4(
				$author$project$Request$Account$getParentAndAffiliateBrokerages,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Login$AffiliateSignup$Model$GetBrokeragesCompleted),
				parentBrokerageId,
				affiliateBrokerageId,
				csrfToken));
	});
var $author$project$Login$AlertSubscriberNew$Model$GotClientName = function (a) {
	return {$: 5, a: a};
};
var $author$project$PublicApi$Scalar$Id = $elm$core$Basics$identity;
var $author$project$PublicApi$Scalar$Date = $elm$core$Basics$identity;
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $elm$core$String$fromFloat = _String_fromNumber;
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$elm$json$Json$Decode$string,
			A2($elm$json$Json$Decode$map, $elm$core$String$fromFloat, $elm$json$Json$Decode$float),
			A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int),
			A2(
			$elm$json$Json$Decode$map,
			function (bool) {
				return bool ? 'true' : 'false';
			},
			$elm$json$Json$Decode$bool)
		]));
var $author$project$PublicApi$Scalar$defaultCodecs = {
	e: {
		yl: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		mc: function (_v0) {
			var raw = _v0;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	g: {
		yl: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		mc: function (_v1) {
			var raw = _v1;
			return $elm$json$Json$Encode$string(raw);
		}
	}
};
var $author$project$PublicApi$Scalar$Codecs = $elm$core$Basics$identity;
var $author$project$PublicApi$Scalar$defineCodecs = function (definitions) {
	return definitions;
};
var $elm_community$json_extra$Json$Decode$Extra$fromResult = function (result) {
	if (!result.$) {
		var successValue = result.a;
		return $elm$json$Json$Decode$succeed(successValue);
	} else {
		var errorMessage = result.a;
		return $elm$json$Json$Decode$fail(errorMessage);
	}
};
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {yi: d, zT: m, Cu: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		vD: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		Cu: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.Cu, 0, date.vD);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.yi;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.zT;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.vD;
	});
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		Co: 1 + (((rd - week1Day1) / 7) | 0),
		Cp: wy,
		Kj: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.Co;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.Cp;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.qg(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.tr(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.qg(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.r8(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.eA(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.eA(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.eA(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.wZ(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.eA(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.eA(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.G4, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	r8: $justinmimbs$date$Date$withOrdinalSuffix,
	tr: $justinmimbs$date$Date$monthToName,
	qg: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	wZ: $justinmimbs$date$Date$weekdayToName,
	eA: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
var $author$project$PublicApiScalarCodecs$codecs = $author$project$PublicApi$Scalar$defineCodecs(
	{
		e: {
			yl: A2(
				$elm$json$Json$Decode$andThen,
				A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromIsoString, $elm_community$json_extra$Json$Decode$Extra$fromResult),
				$elm$json$Json$Decode$string),
			mc: A2($elm$core$Basics$composeR, $justinmimbs$date$Date$toIsoString, $elm$json$Json$Encode$string)
		},
		g: $author$project$PublicApi$Scalar$defaultCodecs.g
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required = F3(
	function (fieldName, raw, encode) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument,
			fieldName,
			encode(raw));
	});
var $dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Document$Hash$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {fi: charsProcessed, g3: hash, er: seed, ju: shift};
	});
var $dillonkearns$elm_graphql$Graphql$Document$Hash$c1 = 3432918353;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$c2 = 461845907;
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $elm$core$Bitwise$or = _Bitwise_or;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$finalize = function (data) {
	var acc = (!(!data.g3)) ? (data.er ^ A2(
		$dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy,
		$dillonkearns$elm_graphql$Graphql$Document$Hash$c2,
		A2(
			$dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy,
			15,
			A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, $dillonkearns$elm_graphql$Graphql$Document$Hash$c1, data.g3)))) : data.er;
	var h0 = acc ^ data.fi;
	var h1 = A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $elm$core$String$foldl = _String_foldl;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$mix = F2(
	function (h1, k1) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy,
			5,
			A2(
				$dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy,
				13,
				h1 ^ A2(
					$dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy,
					$dillonkearns$elm_graphql$Graphql$Document$Hash$c2,
					A2(
						$dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy,
						15,
						A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, $dillonkearns$elm_graphql$Graphql$Document$Hash$c1, k1))))) + 3864292196;
	});
var $dillonkearns$elm_graphql$Graphql$Document$Hash$hashFold = F2(
	function (c, data) {
		var res = data.g3 | ((255 & $elm$core$Char$toCode(c)) << data.ju);
		var _v0 = data.ju;
		if (_v0 === 24) {
			return {
				fi: data.fi + 1,
				g3: 0,
				er: A2($dillonkearns$elm_graphql$Graphql$Document$Hash$mix, data.er, res),
				ju: 0
			};
		} else {
			return {fi: data.fi + 1, g3: res, er: data.er, ju: data.ju + 8};
		}
	});
var $dillonkearns$elm_graphql$Graphql$Document$Hash$hashString = F2(
	function (seed, str) {
		return $dillonkearns$elm_graphql$Graphql$Document$Hash$finalize(
			A3(
				$elm$core$String$foldl,
				$dillonkearns$elm_graphql$Graphql$Document$Hash$hashFold,
				A4($dillonkearns$elm_graphql$Graphql$Document$Hash$HashData, 0, seed, 0, 0),
				str));
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$List = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$Object = function (a) {
	return {$: 3, a: a};
};
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize = function (value) {
	var serializeJson = function (json) {
		var decoder = $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					A2(
						$elm$core$Basics$composeL,
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$List,
						$elm$core$List$map($dillonkearns$elm_graphql$Graphql$Internal$Encode$Json)),
					$elm$json$Json$Decode$list($elm$json$Json$Decode$value)),
					A2(
					$elm$json$Json$Decode$map,
					A2(
						$elm$core$Basics$composeL,
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$Object,
						$elm$core$List$map(
							$elm$core$Tuple$mapSecond($dillonkearns$elm_graphql$Graphql$Internal$Encode$Json))),
					$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value))
				]));
		var _v2 = A2($elm$json$Json$Decode$decodeValue, decoder, json);
		if (!_v2.$) {
			var v = _v2.a;
			return $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize(v);
		} else {
			return A2($elm$json$Json$Encode$encode, 0, json);
		}
	};
	switch (value.$) {
		case 0:
			var enumValue = value.a;
			return enumValue;
		case 1:
			var json = value.a;
			return serializeJson(json);
		case 2:
			var values = value.a;
			return '[' + (A2(
				$elm$core$String$join,
				', ',
				A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize, values)) + ']');
		default:
			var keyValuePairs = value.a;
			return '{' + (A2(
				$elm$core$String$join,
				', ',
				A2(
					$elm$core$List$map,
					function (_v1) {
						var key = _v1.a;
						var objectValue = _v1.b;
						return key + (': ' + $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize(objectValue));
					},
					keyValuePairs)) + '}');
	}
};
var $dillonkearns$elm_graphql$Graphql$Document$Argument$argToString = function (_v0) {
	var name = _v0.a;
	var value = _v0.b;
	return name + (': ' + $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize(value));
};
var $dillonkearns$elm_graphql$Graphql$Document$Argument$serialize = function (args) {
	if (!args.b) {
		return '';
	} else {
		var nonemptyArgs = args;
		return '(' + (A2(
			$elm$core$String$join,
			', ',
			A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$Document$Argument$argToString, nonemptyArgs)) + ')');
	}
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$maybeAliasHash = function (field) {
	return A2(
		$elm$core$Maybe$map,
		$dillonkearns$elm_graphql$Graphql$Document$Hash$hashString(0),
		function () {
			if (!field.$) {
				var name = field.a;
				var _arguments = field.b;
				var children = field.c;
				return $elm$core$List$isEmpty(_arguments) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(_arguments));
			} else {
				var typeString = field.a.B9;
				var fieldName = field.a.yJ;
				var _arguments = field.b;
				return (fieldName === '__typename') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$elm$core$String$concat(
						A2(
							$elm$core$List$append,
							_List_fromArray(
								[typeString]),
							$elm$core$List$singleton(
								$dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(_arguments)))));
			}
		}());
};
var $dillonkearns$elm_graphql$Graphql$RawField$name = function (field) {
	if (!field.$) {
		var fieldName = field.a;
		var argumentList = field.b;
		var fieldList = field.c;
		return fieldName;
	} else {
		var typeString = field.a.B9;
		var fieldName = field.a.yJ;
		var argumentList = field.b;
		return fieldName;
	}
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$alias = function (field) {
	return A2(
		$elm$core$Maybe$map,
		function (aliasHash) {
			return _Utils_ap(
				$dillonkearns$elm_graphql$Graphql$RawField$name(field),
				$elm$core$String$fromInt(aliasHash));
		},
		$dillonkearns$elm_graphql$Graphql$Document$Field$maybeAliasHash(field));
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName = function (field) {
	return A2(
		$elm$core$Maybe$withDefault,
		$dillonkearns$elm_graphql$Graphql$RawField$name(field),
		$dillonkearns$elm_graphql$Graphql$Document$Field$alias(field));
};
var $dillonkearns$elm_graphql$Graphql$RawField$Leaf = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$leaf = F2(
	function (details, args) {
		return A2($dillonkearns$elm_graphql$Graphql$RawField$Leaf, details, args);
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField = F4(
	function (typeString, fieldName, args, decoder) {
		var newLeaf = A2(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$leaf,
			{yJ: fieldName, B9: typeString},
			args);
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			_List_fromArray(
				[newLeaf]),
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2($elm$json$Json$Decode$field, fieldName, decoder),
						A2(
						$elm$json$Json$Decode$field,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(newLeaf),
						decoder)
					])));
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$fromJson = function (jsonValue) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(jsonValue);
};
var $author$project$PublicApi$Scalar$unwrapEncoder = F2(
	function (getter, _v0) {
		var unwrappedCodecs = _v0;
		return A2(
			$elm$core$Basics$composeR,
			getter(unwrappedCodecs).mc,
			$dillonkearns$elm_graphql$Graphql$Internal$Encode$fromJson);
	});
var $author$project$PublicApi$Query$getClientName = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'String',
		'getClientName',
		_List_fromArray(
			[
				A3(
				$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required,
				'clientId',
				requiredArgs____.xM,
				A2(
					$author$project$PublicApi$Scalar$unwrapEncoder,
					function ($) {
						return $.g;
					},
					$author$project$PublicApiScalarCodecs$codecs))
			]),
		$elm$json$Json$Decode$string);
};
var $dillonkearns$elm_graphql$Graphql$Http$Query = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Http$Request = $elm$core$Basics$identity;
var $dillonkearns$elm_graphql$Graphql$Document$decoder = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return A2($elm$json$Json$Decode$field, 'data', decoder_);
};
var $dillonkearns$elm_graphql$Graphql$Http$queryRequest = F2(
	function (baseUrl, query) {
		return {
			k5: baseUrl,
			x: A2($dillonkearns$elm_graphql$Graphql$Http$Query, $elm$core$Maybe$Nothing, query),
			da: $dillonkearns$elm_graphql$Graphql$Document$decoder(query),
			dd: _List_Nil,
			em: $elm$core$Maybe$Nothing,
			ep: _List_Nil,
			ds: $elm$core$Maybe$Nothing,
			eB: false
		};
	});
var $elm$http$Http$riskyRequest = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{CE: true, k8: r.k8, da: r.da, dd: r.dd, dg: r.dg, ds: r.ds, dt: r.dt, Cd: r.Cd}));
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Http$HttpError = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$convertResult = function (httpResult) {
	if (!httpResult.$) {
		var successOrError = httpResult.a;
		if (!successOrError.$) {
			var value = successOrError.a;
			return $elm$core$Result$Ok(value);
		} else {
			var _v2 = successOrError.a;
			var possiblyParsedData = _v2.a;
			var error = _v2.b;
			return $elm$core$Result$Err(
				A2($dillonkearns$elm_graphql$Graphql$Http$GraphqlError, possiblyParsedData, error));
		}
	} else {
		var httpError = httpResult.a;
		return $elm$core$Result$Err(
			$dillonkearns$elm_graphql$Graphql$Http$HttpError(httpError));
	}
};
var $dillonkearns$elm_graphql$Graphql$Http$BadPayload = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$BadStatus = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$NetworkError = {$: 2};
var $dillonkearns$elm_graphql$Graphql$Http$Timeout = {$: 1};
var $dillonkearns$elm_graphql$Graphql$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			function (response) {
				switch (response.$) {
					case 0:
						var url = response.a;
						return $elm$core$Result$Err(
							$dillonkearns$elm_graphql$Graphql$Http$BadUrl(url));
					case 1:
						return $elm$core$Result$Err($dillonkearns$elm_graphql$Graphql$Http$Timeout);
					case 2:
						return $elm$core$Result$Err($dillonkearns$elm_graphql$Graphql$Http$NetworkError);
					case 3:
						var metadata = response.a;
						var body = response.b;
						return $elm$core$Result$Err(
							A2($dillonkearns$elm_graphql$Graphql$Http$BadStatus, metadata, body));
					default:
						var metadata = response.a;
						var body = response.b;
						var _v1 = A2($elm$json$Json$Decode$decodeString, decoder, body);
						if (!_v1.$) {
							var value = _v1.a;
							return $elm$core$Result$Ok(value);
						} else {
							var err = _v1.a;
							return $elm$core$Result$Err(
								$dillonkearns$elm_graphql$Graphql$Http$BadPayload(err));
						}
				}
			});
	});
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$Get = 0;
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$Post = 1;
var $elm$core$Basics$ge = _Utils_ge;
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$maxLength = 2000;
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $lukewestby$elm_string_interpolate$String$Interpolate$applyInterpolation = F2(
	function (replacements, _v0) {
		var match = _v0.Gp;
		var ordinalString = A2(
			$elm$core$Basics$composeL,
			$elm$core$String$dropLeft(1),
			$elm$core$String$dropRight(1))(match);
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				function (value) {
					return A2($elm$core$Array$get, value, replacements);
				},
				$elm$core$String$toInt(ordinalString)));
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{ag: nodeList, N: nodeListSize, ad: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {Fv: index, Gp: match, nn: number, Jn: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{De: false, GH: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $lukewestby$elm_string_interpolate$String$Interpolate$interpolationRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('\\{\\d+\\}'));
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $lukewestby$elm_string_interpolate$String$Interpolate$interpolate = F2(
	function (string, args) {
		var asArray = $elm$core$Array$fromList(args);
		return A3(
			$elm$regex$Regex$replace,
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolationRegex,
			$lukewestby$elm_string_interpolate$String$Interpolate$applyInterpolation(asArray),
			string);
	});
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $j_maas$elm_ordered_containers$OrderedDict$OrderedDict = $elm$core$Basics$identity;
var $j_maas$elm_ordered_containers$OrderedDict$empty = {y: $elm$core$Dict$empty, ah: _List_Nil};
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $elm$core$Dict$singleton = F2(
	function (key, value) {
		return A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
	});
var $elm$core$Set$singleton = function (key) {
	return A2($elm$core$Dict$singleton, key, 0);
};
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $elm$core$Set$size = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$size(dict);
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$findConflictingTypeFields = function (rawFields) {
	var compositeCount = $elm$core$List$length(
		A2(
			$elm$core$List$filterMap,
			function (field) {
				if (!field.$) {
					return $elm$core$Maybe$Just(0);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			rawFields));
	if (compositeCount <= 1) {
		return $elm$core$Set$empty;
	} else {
		var levelBelowNodes = A2(
			$elm$core$List$concatMap,
			function (field) {
				if (field.$ === 1) {
					return _List_Nil;
				} else {
					var children = field.c;
					return children;
				}
			},
			rawFields);
		var fieldTypes = A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, acc) {
					var fieldName = _v1.a;
					var fieldType = _v1.b;
					return A3(
						$elm$core$Dict$update,
						fieldName,
						function (maybeFieldTypes) {
							if (maybeFieldTypes.$ === 1) {
								return $elm$core$Maybe$Just(
									$elm$core$Set$singleton(fieldType));
							} else {
								var fieldTypes_ = maybeFieldTypes.a;
								return $elm$core$Maybe$Just(
									A2($elm$core$Set$insert, fieldType, fieldTypes_));
							}
						},
						acc);
				}),
			$elm$core$Dict$empty,
			A2(
				$elm$core$List$filterMap,
				function (field) {
					if (field.$ === 1) {
						var typeString = field.a.B9;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(
								$dillonkearns$elm_graphql$Graphql$RawField$name(field),
								typeString));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				levelBelowNodes));
		return $elm$core$Set$fromList(
			$elm$core$Dict$keys(
				A2(
					$elm$core$Dict$filter,
					F2(
						function (fieldType, fields) {
							return function (size) {
								return size > 1;
							}(
								$elm$core$Set$size(fields));
						}),
					fieldTypes)));
	}
};
var $j_maas$elm_ordered_containers$OrderedDict$get = F2(
	function (key, _v0) {
		var orderedDict = _v0;
		return A2($elm$core$Dict$get, key, orderedDict.y);
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $j_maas$elm_ordered_containers$OrderedDict$insert = F3(
	function (key, value, _v0) {
		var orderedDict = _v0;
		var filteredOrder = A2($elm$core$Dict$member, key, orderedDict.y) ? A2(
			$elm$core$List$filter,
			function (k) {
				return !_Utils_eq(k, key);
			},
			orderedDict.ah) : orderedDict.ah;
		var newOrder = _Utils_ap(
			filteredOrder,
			_List_fromArray(
				[key]));
		return {
			y: A3($elm$core$Dict$insert, key, value, orderedDict.y),
			ah: newOrder
		};
	});
var $j_maas$elm_ordered_containers$OrderedDict$remove = F2(
	function (key, _v0) {
		var orderedDict = _v0;
		return {
			y: A2($elm$core$Dict$remove, key, orderedDict.y),
			ah: A2($elm$core$Dict$member, key, orderedDict.y) ? A2(
				$elm$core$List$filter,
				function (k) {
					return !_Utils_eq(k, key);
				},
				orderedDict.ah) : orderedDict.ah
		};
	});
var $j_maas$elm_ordered_containers$OrderedDict$update = F3(
	function (key, alter, original) {
		var orderedDict = original;
		var _v0 = A2($elm$core$Dict$get, key, orderedDict.y);
		if (!_v0.$) {
			var oldItem = _v0.a;
			var _v1 = alter(
				$elm$core$Maybe$Just(oldItem));
			if (!_v1.$) {
				var newItem = _v1.a;
				return {
					y: A3(
						$elm$core$Dict$update,
						key,
						$elm$core$Basics$always(
							$elm$core$Maybe$Just(newItem)),
						orderedDict.y),
					ah: orderedDict.ah
				};
			} else {
				return A2($j_maas$elm_ordered_containers$OrderedDict$remove, key, original);
			}
		} else {
			var _v2 = alter($elm$core$Maybe$Nothing);
			if (!_v2.$) {
				var newItem = _v2.a;
				return A3($j_maas$elm_ordered_containers$OrderedDict$insert, key, newItem, original);
			} else {
				return original;
			}
		}
	});
var $dillonkearns$elm_graphql$Graphql$Document$Field$canAllowHashing = F2(
	function (forceHashing, rawFields) {
		var fieldCounts = A3(
			$elm$core$List$foldl,
			F2(
				function (fld, acc) {
					return A3(
						$j_maas$elm_ordered_containers$OrderedDict$update,
						fld,
						function (val) {
							return $elm$core$Maybe$Just(
								function () {
									if (val.$ === 1) {
										return 0;
									} else {
										var count = val.a;
										return count + 1;
									}
								}());
						},
						acc);
				}),
			$j_maas$elm_ordered_containers$OrderedDict$empty,
			A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$RawField$name, rawFields));
		var conflictingTypeFields = $dillonkearns$elm_graphql$Graphql$Document$Field$findConflictingTypeFields(rawFields);
		return A2(
			$elm$core$List$map,
			function (field) {
				return _Utils_Tuple3(
					field,
					A2(
						$elm$core$Set$member,
						$dillonkearns$elm_graphql$Graphql$RawField$name(field),
						forceHashing) ? $dillonkearns$elm_graphql$Graphql$Document$Field$alias(field) : ((!A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$j_maas$elm_ordered_containers$OrderedDict$get,
							$dillonkearns$elm_graphql$Graphql$RawField$name(field),
							fieldCounts))) ? $elm$core$Maybe$Nothing : $dillonkearns$elm_graphql$Graphql$Document$Field$alias(field)),
					conflictingTypeFields);
			},
			rawFields);
	});
var $dillonkearns$elm_graphql$Graphql$Document$Indent$generate = function (indentationLevel) {
	return A2($elm$core$String$repeat, indentationLevel, '  ');
};
var $dillonkearns$elm_graphql$Graphql$RawField$Composite = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $dillonkearns$elm_graphql$Graphql$Document$Field$mergeFields = function (rawFields) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (field, mergedSoFar) {
				if (!field.$) {
					var newChildren = field.c;
					return A3(
						$j_maas$elm_ordered_containers$OrderedDict$update,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(field),
						function (maybeChildrenSoFar) {
							if (maybeChildrenSoFar.$ === 1) {
								return $elm$core$Maybe$Just(field);
							} else {
								if (!maybeChildrenSoFar.a.$) {
									var _v2 = maybeChildrenSoFar.a;
									var existingFieldName = _v2.a;
									var existingArgs = _v2.b;
									var existingChildren = _v2.c;
									return $elm$core$Maybe$Just(
										A3(
											$dillonkearns$elm_graphql$Graphql$RawField$Composite,
											existingFieldName,
											existingArgs,
											_Utils_ap(existingChildren, newChildren)));
								} else {
									return $elm$core$Maybe$Just(field);
								}
							}
						},
						mergedSoFar);
				} else {
					return A3(
						$j_maas$elm_ordered_containers$OrderedDict$update,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(field),
						function (maybeChildrenSoFar) {
							return $elm$core$Maybe$Just(
								A2($elm$core$Maybe$withDefault, field, maybeChildrenSoFar));
						},
						mergedSoFar);
				}
			}),
		$j_maas$elm_ordered_containers$OrderedDict$empty,
		rawFields);
};
var $j_maas$elm_ordered_containers$OrderedDict$values = function (_v0) {
	var orderedDict = _v0;
	return A2(
		$elm$core$List$filterMap,
		function (key) {
			return A2($elm$core$Dict$get, key, orderedDict.y);
		},
		orderedDict.ah);
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$mergedFields = function (children) {
	return $j_maas$elm_ordered_containers$OrderedDict$values(
		$dillonkearns$elm_graphql$Graphql$Document$Field$mergeFields(children));
};
var $dillonkearns$elm_graphql$Graphql$RawField$typename = A2(
	$dillonkearns$elm_graphql$Graphql$RawField$Leaf,
	{yJ: '__typename', B9: ''},
	_List_Nil);
var $dillonkearns$elm_graphql$Graphql$Document$Field$nonemptyChildren = function (children) {
	return $elm$core$List$isEmpty(children) ? A2($elm$core$List$cons, $dillonkearns$elm_graphql$Graphql$RawField$typename, children) : children;
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$serialize = F4(
	function (forceHashing, aliasName, mIndentationLevel, field) {
		var prefix = function () {
			if (!aliasName.$) {
				var aliasName_ = aliasName.a;
				return _Utils_ap(
					aliasName_,
					function () {
						if (!mIndentationLevel.$) {
							return ': ';
						} else {
							return ':';
						}
					}());
			} else {
				return '';
			}
		}();
		return A2(
			$elm$core$Maybe$map,
			function (string) {
				return _Utils_ap(
					$dillonkearns$elm_graphql$Graphql$Document$Indent$generate(
						A2($elm$core$Maybe$withDefault, 0, mIndentationLevel)),
					_Utils_ap(prefix, string));
			},
			function () {
				if (!field.$) {
					var fieldName = field.a;
					var args = field.b;
					var children = field.c;
					if (mIndentationLevel.$ === 1) {
						return $elm$core$Maybe$Just(
							(fieldName + ($dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(args) + ('{' + A3($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildrenHelp, forceHashing, $elm$core$Maybe$Nothing, children)))) + '}');
					} else {
						var indentationLevel = mIndentationLevel.a;
						return $elm$core$Maybe$Just(
							(fieldName + ($dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(args) + (' {\n' + A3(
								$dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildrenHelp,
								forceHashing,
								$elm$core$Maybe$Just(indentationLevel),
								children)))) + ('\n' + ($dillonkearns$elm_graphql$Graphql$Document$Indent$generate(indentationLevel) + '}')));
					}
				} else {
					var fieldName = field.a.yJ;
					var args = field.b;
					return $elm$core$Maybe$Just(
						_Utils_ap(
							fieldName,
							$dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(args)));
				}
			}());
	});
var $dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildrenHelp = F3(
	function (forceHashing, indentationLevel, children) {
		return A2(
			$elm$core$String$join,
			function () {
				if (!indentationLevel.$) {
					return '\n';
				} else {
					return ' ';
				}
			}(),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				A2(
					$elm$core$List$map,
					function (_v0) {
						var field = _v0.a;
						var maybeAlias = _v0.b;
						var conflictingTypeFields = _v0.c;
						return A4(
							$dillonkearns$elm_graphql$Graphql$Document$Field$serialize,
							conflictingTypeFields,
							maybeAlias,
							A2(
								$elm$core$Maybe$map,
								$elm$core$Basics$add(1),
								indentationLevel),
							field);
					},
					A2(
						$dillonkearns$elm_graphql$Graphql$Document$Field$canAllowHashing,
						forceHashing,
						$dillonkearns$elm_graphql$Graphql$Document$Field$nonemptyChildren(
							$dillonkearns$elm_graphql$Graphql$Document$Field$mergedFields(children))))));
	});
var $dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren = F2(
	function (indentationLevel, children) {
		return A3($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildrenHelp, $elm$core$Set$empty, indentationLevel, children);
	});
var $dillonkearns$elm_graphql$Graphql$Document$serialize = F2(
	function (operationType, queries) {
		return A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'{0} {\n{1}\n}',
			_List_fromArray(
				[
					operationType,
					A2(
					$dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren,
					$elm$core$Maybe$Just(0),
					queries)
				]));
	});
var $dillonkearns$elm_graphql$Graphql$Document$serializeQuery = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return A2($dillonkearns$elm_graphql$Graphql$Document$serialize, 'query', fields);
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrl = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return '{' + (A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Nothing, fields) + '}');
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrlWithOperationName = F2(
	function (operationName, _v0) {
		var fields = _v0.a;
		var decoder_ = _v0.b;
		return 'query ' + (operationName + (' {' + (A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Nothing, fields) + '}')));
	});
var $dillonkearns$elm_graphql$Graphql$Document$serializeWithOperationName = F3(
	function (operationType, operationName, queries) {
		return A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'{0} {1} {\n{2}\n}',
			_List_fromArray(
				[
					operationType,
					operationName,
					A2(
					$dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren,
					$elm$core$Maybe$Just(0),
					queries)
				]));
	});
var $dillonkearns$elm_graphql$Graphql$Document$serializeQueryWithOperationName = F2(
	function (operationName, _v0) {
		var fields = _v0.a;
		var decoder_ = _v0.b;
		return A3($dillonkearns$elm_graphql$Graphql$Document$serializeWithOperationName, 'query', operationName, fields);
	});
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$replace = F2(
	function (old, _new) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$core$String$split(old),
			$elm$core$String$join(_new));
	});
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryEscape = A2(
	$elm$core$Basics$composeR,
	$elm$url$Url$percentEncode,
	A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$replace, '%20', '+'));
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryEscape(key) + ('=' + $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryEscape(value));
};
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$joinUrlEncoded = function (args) {
	return A2(
		$elm$core$String$join,
		'&',
		A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryPair, args));
};
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams = F2(
	function (queryParams, url) {
		return $elm$core$List$isEmpty(queryParams) ? url : (url + ('?' + $dillonkearns$elm_graphql$Graphql$Http$QueryParams$joinUrlEncoded(queryParams)));
	});
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$build = F5(
	function (forceMethod, url, queryParams, maybeOperationName, queryDocument) {
		var _v0 = function () {
			if (!maybeOperationName.$) {
				var operationName = maybeOperationName.a;
				return _Utils_Tuple2(
					A2($dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrlWithOperationName, operationName, queryDocument),
					_List_fromArray(
						[
							_Utils_Tuple2('operationName', operationName)
						]));
			} else {
				return _Utils_Tuple2(
					$dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrl(queryDocument),
					_List_Nil);
			}
		}();
		var serializedQueryForGetRequest = _v0.a;
		var operationNameParamForGetRequest = _v0.b;
		var urlForGetRequest = A2(
			$dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams,
			_Utils_ap(
				queryParams,
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2('query', serializedQueryForGetRequest),
					operationNameParamForGetRequest)),
			url);
		if (_Utils_eq(
			forceMethod,
			$elm$core$Maybe$Just(1)) || ((_Utils_cmp(
			$elm$core$String$length(urlForGetRequest),
			$dillonkearns$elm_graphql$Graphql$Http$QueryHelper$maxLength) > -1) && (!_Utils_eq(
			forceMethod,
			$elm$core$Maybe$Just(0))))) {
			var _v2 = function () {
				if (!maybeOperationName.$) {
					var operationName = maybeOperationName.a;
					return _Utils_Tuple2(
						A2($dillonkearns$elm_graphql$Graphql$Document$serializeQueryWithOperationName, operationName, queryDocument),
						_List_fromArray(
							[
								_Utils_Tuple2(
								'operationName',
								$elm$json$Json$Encode$string(operationName))
							]));
				} else {
					return _Utils_Tuple2(
						$dillonkearns$elm_graphql$Graphql$Document$serializeQuery(queryDocument),
						_List_Nil);
				}
			}();
			var serializedQuery = _v2.a;
			var operationNameParamForPostRequest = _v2.b;
			return {
				k8: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'query',
								$elm$json$Json$Encode$string(serializedQuery)),
							operationNameParamForPostRequest))),
				dg: 1,
				Cd: A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams, queryParams, url)
			};
		} else {
			return {k8: $elm$http$Http$emptyBody, dg: 0, Cd: urlForGetRequest};
		}
	});
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$ParsedData = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$GraphqlError = F3(
	function (message, locations, details) {
		return {x: details, Gi: locations, dZ: message};
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$Location = F2(
	function (line, column) {
		return {Dx: column, Ge: line};
	});
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$locationDecoder = A3(
	$elm$json$Json$Decode$map2,
	$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$Location,
	A2($elm$json$Json$Decode$field, 'line', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'column', $elm$json$Json$Decode$int));
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$decoder = A2(
	$elm$json$Json$Decode$field,
	'errors',
	$elm$json$Json$Decode$list(
		A4(
			$elm$json$Json$Decode$map3,
			$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$GraphqlError,
			A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string),
			$elm$json$Json$Decode$maybe(
				A2(
					$elm$json$Json$Decode$field,
					'locations',
					$elm$json$Json$Decode$list($dillonkearns$elm_graphql$Graphql$Http$GraphqlError$locationDecoder))),
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Dict$remove('locations'),
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Dict$remove('message'),
					$elm$json$Json$Decode$dict($elm$json$Json$Decode$value))))));
var $dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData = function (data) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Result$Err,
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Tuple$pair(data),
			$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$decoder));
};
var $dillonkearns$elm_graphql$Graphql$Http$nullJsonValue = function (a) {
	nullJsonValue:
	while (true) {
		var _v0 = A2($elm$json$Json$Decode$decodeString, $elm$json$Json$Decode$value, 'null');
		if (!_v0.$) {
			var value = _v0.a;
			return value;
		} else {
			var $temp$a = 0;
			a = $temp$a;
			continue nullJsonValue;
		}
	}
};
var $dillonkearns$elm_graphql$Graphql$Http$errorDecoder = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$andThen,
				$dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData,
				A2($elm$json$Json$Decode$map, $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$ParsedData, decoder)),
				A2(
				$elm$json$Json$Decode$andThen,
				$dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData,
				A2(
					$elm$json$Json$Decode$map,
					$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData,
					A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$value))),
				A2(
				$elm$json$Json$Decode$andThen,
				$dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData,
				$elm$json$Json$Decode$succeed(
					$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData(
						$dillonkearns$elm_graphql$Graphql$Http$nullJsonValue(0))))
			]));
};
var $dillonkearns$elm_graphql$Graphql$Http$decoderOrError = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_graphql$Graphql$Http$errorDecoder(decoder),
				A2($elm$json$Json$Decode$map, $elm$core$Result$Ok, decoder)
			]));
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeMutation = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return A2($dillonkearns$elm_graphql$Graphql$Document$serialize, 'mutation', fields);
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeMutationWithOperationName = F2(
	function (operationName, _v0) {
		var fields = _v0.a;
		var decoder_ = _v0.b;
		return A3($dillonkearns$elm_graphql$Graphql$Document$serializeWithOperationName, 'mutation', operationName, fields);
	});
var $dillonkearns$elm_graphql$Graphql$Http$toReadyRequest = function (_v0) {
	var request = _v0;
	var _v1 = request.x;
	if (!_v1.$) {
		var forcedRequestMethod = _v1.a;
		var querySelectionSet = _v1.b;
		var queryRequestDetails = A5(
			$dillonkearns$elm_graphql$Graphql$Http$QueryHelper$build,
			function () {
				if (!forcedRequestMethod.$) {
					if (!forcedRequestMethod.a) {
						var _v4 = forcedRequestMethod.a;
						return $elm$core$Maybe$Just(0);
					} else {
						var _v5 = forcedRequestMethod.a;
						return $elm$core$Maybe$Nothing;
					}
				} else {
					return $elm$core$Maybe$Just(1);
				}
			}(),
			request.k5,
			request.ep,
			request.em,
			querySelectionSet);
		return {
			k8: queryRequestDetails.k8,
			yl: $dillonkearns$elm_graphql$Graphql$Http$decoderOrError(request.da),
			dd: request.dd,
			dg: function () {
				var _v2 = queryRequestDetails.dg;
				if (!_v2) {
					return 'GET';
				} else {
					return 'Post';
				}
			}(),
			ds: request.ds,
			Cd: queryRequestDetails.Cd
		};
	} else {
		var mutationSelectionSet = _v1.a;
		var serializedMutation = function () {
			var _v7 = request.em;
			if (!_v7.$) {
				var operationName = _v7.a;
				return A2($dillonkearns$elm_graphql$Graphql$Document$serializeMutationWithOperationName, operationName, mutationSelectionSet);
			} else {
				return $dillonkearns$elm_graphql$Graphql$Document$serializeMutation(mutationSelectionSet);
			}
		}();
		return {
			k8: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					A2(
						$elm$core$List$append,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'query',
								$elm$json$Json$Encode$string(serializedMutation))
							]),
						function () {
							var _v6 = request.em;
							if (!_v6.$) {
								var operationName = _v6.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'operationName',
										$elm$json$Json$Encode$string(operationName))
									]);
							} else {
								return _List_Nil;
							}
						}()))),
			yl: $dillonkearns$elm_graphql$Graphql$Http$decoderOrError(request.da),
			dd: request.dd,
			dg: 'POST',
			ds: request.ds,
			Cd: A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams, request.ep, request.k5)
		};
	}
};
var $dillonkearns$elm_graphql$Graphql$Http$toHttpRequestRecord = F2(
	function (resultToMessage, fullRequest) {
		var request = fullRequest;
		return function (readyRequest) {
			return {
				k8: readyRequest.k8,
				da: A2(
					$dillonkearns$elm_graphql$Graphql$Http$expectJson,
					A2($elm$core$Basics$composeR, $dillonkearns$elm_graphql$Graphql$Http$convertResult, resultToMessage),
					readyRequest.yl),
				dd: readyRequest.dd,
				dg: readyRequest.dg,
				ds: readyRequest.ds,
				dt: $elm$core$Maybe$Nothing,
				Cd: readyRequest.Cd
			};
		}(
			$dillonkearns$elm_graphql$Graphql$Http$toReadyRequest(fullRequest));
	});
var $dillonkearns$elm_graphql$Graphql$Http$send = F2(
	function (resultToMessage, fullRequest) {
		var request = fullRequest;
		return (request.eB ? $elm$http$Http$riskyRequest : $elm$http$Http$request)(
			A2($dillonkearns$elm_graphql$Graphql$Http$toHttpRequestRecord, resultToMessage, fullRequest));
	});
var $author$project$ApiRequest$publicQuery = F2(
	function (msg, selectionSet) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$Http$send,
			A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, msg),
			A2($dillonkearns$elm_graphql$Graphql$Http$queryRequest, '/qp', selectionSet));
	});
var $author$project$Login$AlertSubscriberUnsubscribe$Update$getClientName = F2(
	function (clientId, msg) {
		var clientRequiredArguments = {
			xM: function (_v0) {
				var id = _v0;
				return id;
			}(clientId)
		};
		var clientName = $author$project$PublicApi$Query$getClientName(clientRequiredArguments);
		return A2($author$project$ApiRequest$publicQuery, msg, clientName);
	});
var $author$project$Login$AlertSubscriberNew$Model$Unselected = 2;
var $author$project$Login$AlertSubscriberNew$Update$initialModel = F2(
	function (clientId, isTravelersRequestUrl) {
		return {
			xM: clientId,
			ft: $krisajenkins$remotedata$RemoteData$Loading,
			aW: $author$project$Model$ValidationNext$Unvalidated(''),
			E1: $krisajenkins$remotedata$RemoteData$NotAsked,
			zm: isTravelersRequestUrl,
			h$: $author$project$Model$ValidationNext$Unvalidated(''),
			Jp: $author$project$Model$ValidationNext$Unvalidated(2)
		};
	});
var $author$project$Login$AlertSubscriberNew$Update$init = F2(
	function (clientId, isTravelersRequestUrl) {
		return _Utils_Tuple2(
			A2($author$project$Login$AlertSubscriberNew$Update$initialModel, clientId, isTravelersRequestUrl),
			A2($author$project$Login$AlertSubscriberUnsubscribe$Update$getClientName, clientId, $author$project$Login$AlertSubscriberNew$Model$GotClientName));
	});
var $author$project$Login$AlertSubscriberUnsubscribe$Model$GotClientName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Login$AlertSubscriberUnsubscribe$Model$initialModel = F2(
	function (clientId, isTravelersRequestUrl) {
		return {
			xM: clientId,
			ft: $krisajenkins$remotedata$RemoteData$Loading,
			aW: $author$project$Model$ValidationNext$Unvalidated(''),
			E1: $krisajenkins$remotedata$RemoteData$NotAsked,
			zm: isTravelersRequestUrl
		};
	});
var $author$project$Login$AlertSubscriberUnsubscribe$Update$init = F2(
	function (clientId, isTravelersRequestUrl) {
		return _Utils_Tuple2(
			A2($author$project$Login$AlertSubscriberUnsubscribe$Model$initialModel, clientId, isTravelersRequestUrl),
			A2($author$project$Login$AlertSubscriberUnsubscribe$Update$getClientName, clientId, $author$project$Login$AlertSubscriberUnsubscribe$Model$GotClientName));
	});
var $author$project$Login$ConfirmBindForm$GetOrSubmitFormCompleted = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite = F3(
	function (fieldName, args, fields) {
		return A3($dillonkearns$elm_graphql$Graphql$RawField$Composite, fieldName, args, fields);
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField = F4(
	function (fieldName, args, _v0, decoderTransform) {
		var fields = _v0.a;
		var decoder = _v0.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite, fieldName, args, fields)
				]),
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$field,
						fieldName,
						decoderTransform(decoder)),
						A2(
						$elm$json$Json$Decode$field,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(
							A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite, fieldName, args, fields)),
						decoderTransform(decoder))
					])));
	});
var $author$project$PublicApi$Query$brokerConfirmBindForm = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'brokerConfirmBindForm',
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required,
					'quoteRequestId',
					requiredArgs____.AO,
					A2(
						$author$project$PublicApi$Scalar$unwrapEncoder,
						function ($) {
							return $.g;
						},
						$author$project$PublicApiScalarCodecs$codecs))
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Data$ConfirmBindForm$BoundForm = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$ConfirmBindForm$BoundFormData = function (policyId) {
	return function (clientName) {
		return function (effectiveDate) {
			return function (expirationDate) {
				return function (boundAt) {
					return function (policyFeeCents) {
						return function (hasTria) {
							return function (underwriterName) {
								return function (underwriterEmail) {
									return function (boundQuoteOption) {
										return {C7: boundAt, C8: boundQuoteOption, ft: clientName, bx: effectiveDate, bB: expirationDate, am: hasTria, vS: policyFeeCents, n: policyId, rg: underwriterEmail, rh: underwriterName};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$PublicApi$Scalar$unwrapCodecs = function (_v0) {
	var unwrappedCodecs = _v0;
	return unwrappedCodecs;
};
var $author$project$PublicApi$Object$BrokerConfirmBindFormBound$boundAt = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'PublicApiScalarCodecs.Date',
	'boundAt',
	_List_Nil,
	$author$project$PublicApi$Scalar$unwrapCodecs($author$project$PublicApiScalarCodecs$codecs).e.yl);
var $author$project$PublicApi$Object$BrokerConfirmBindFormBound$boundQuoteOption = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'boundQuoteOption', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$PublicApi$Object$BrokerConfirmBindFormBound$clientName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'clientName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$PublicApi$Object$BrokerConfirmBindFormBound$effectiveDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'PublicApiScalarCodecs.Date',
	'effectiveDate',
	_List_Nil,
	$author$project$PublicApi$Scalar$unwrapCodecs($author$project$PublicApiScalarCodecs$codecs).e.yl);
var $author$project$PublicApi$Object$BrokerConfirmBindFormBound$expirationDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'PublicApiScalarCodecs.Date',
	'expirationDate',
	_List_Nil,
	$author$project$PublicApi$Scalar$unwrapCodecs($author$project$PublicApiScalarCodecs$codecs).e.yl);
var $author$project$PublicApi$Object$BrokerConfirmBindFormBound$hasTria = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hasTria', _List_Nil, $elm$json$Json$Decode$bool);
var $dillonkearns$elm_graphql$Graphql$SelectionSet$map = F2(
	function (mapFunction, _v0) {
		var selectionFields = _v0.a;
		var selectionDecoder = _v0.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			selectionFields,
			A2($elm$json$Json$Decode$map, mapFunction, selectionDecoder));
	});
var $author$project$ApiRequest$mapPublicScalarId = F2(
	function (idConstructorFun, publicApiObjectField) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
			function (_v0) {
				var id = _v0;
				return idConstructorFun(id);
			},
			publicApiObjectField);
	});
var $author$project$PublicApi$Object$BrokerConfirmBindFormBound$policyFeeCents = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'policyFeeCents', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$PublicApi$Object$BrokerConfirmBindFormBound$policyId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'PublicApiScalarCodecs.Id',
	'policyId',
	_List_Nil,
	$author$project$PublicApi$Scalar$unwrapCodecs($author$project$PublicApiScalarCodecs$codecs).g.yl);
var $author$project$Data$ConfirmBindForm$QuoteOption = F6(
	function (id, premiumCents, hasTria, triaCents, limitCents, deductibleCents) {
		return {cI: deductibleCents, am: hasTria, Fm: id, hN: limitCents, iq: premiumCents, ov: triaCents};
	});
var $author$project$Model$Ids$QuoteOptionId = $elm$core$Basics$identity;
var $author$project$PublicApi$Object$BrokerConfirmBindFormQuoteOption$deductibleCents = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'deductibleCents', _List_Nil, $elm$json$Json$Decode$int);
var $dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded = F2(
	function (constant, _v0) {
		var objectFields = _v0.a;
		var objectDecoder = _v0.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			objectFields,
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Basics$apR,
				$elm$json$Json$Decode$succeed(constant),
				objectDecoder));
	});
var $author$project$PublicApi$Object$BrokerConfirmBindFormQuoteOption$id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'PublicApiScalarCodecs.Id',
	'id',
	_List_Nil,
	$author$project$PublicApi$Scalar$unwrapCodecs($author$project$PublicApiScalarCodecs$codecs).g.yl);
var $author$project$PublicApi$Object$BrokerConfirmBindFormQuoteOption$limitCents = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'limitCents', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$PublicApi$Object$BrokerConfirmBindFormQuoteOption$premiumCents = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'premiumCents', _List_Nil, $elm$json$Json$Decode$int);
var $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed = function (constructor) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
		_List_Nil,
		$elm$json$Json$Decode$succeed(constructor));
};
var $author$project$PublicApi$Object$BrokerConfirmBindFormQuoteOption$triaCents = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'triaCents', _List_Nil, $elm$json$Json$Decode$int);
var $dillonkearns$elm_graphql$Graphql$SelectionSet$with = F2(
	function (_v0, _v1) {
		var selectionFields1 = _v0.a;
		var selectionDecoder1 = _v0.b;
		var selectionFields2 = _v1.a;
		var selectionDecoder2 = _v1.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			_Utils_ap(selectionFields1, selectionFields2),
			A3($elm$json$Json$Decode$map2, $elm$core$Basics$apR, selectionDecoder1, selectionDecoder2));
	});
var $author$project$Data$ConfirmBindForm$quoteOptionSelection = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$PublicApi$Object$BrokerConfirmBindFormQuoteOption$deductibleCents,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$PublicApi$Object$BrokerConfirmBindFormQuoteOption$limitCents,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$PublicApi$Object$BrokerConfirmBindFormQuoteOption$triaCents,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
				true,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$PublicApi$Object$BrokerConfirmBindFormQuoteOption$premiumCents,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						A2($author$project$ApiRequest$mapPublicScalarId, $elm$core$Basics$identity, $author$project$PublicApi$Object$BrokerConfirmBindFormQuoteOption$id),
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Data$ConfirmBindForm$QuoteOption)))))));
var $author$project$PublicApi$Object$BrokerConfirmBindFormBound$underwriterEmail = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'underwriterEmail', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$PublicApi$Object$BrokerConfirmBindFormBound$underwriterName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'underwriterName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Data$ConfirmBindForm$boundFormDataSelection = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$PublicApi$Object$BrokerConfirmBindFormBound$boundQuoteOption($author$project$Data$ConfirmBindForm$quoteOptionSelection),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$PublicApi$Object$BrokerConfirmBindFormBound$underwriterEmail,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$PublicApi$Object$BrokerConfirmBindFormBound$underwriterName,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$PublicApi$Object$BrokerConfirmBindFormBound$hasTria,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$PublicApi$Object$BrokerConfirmBindFormBound$policyFeeCents,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$PublicApi$Object$BrokerConfirmBindFormBound$boundAt,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$PublicApi$Object$BrokerConfirmBindFormBound$expirationDate,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$PublicApi$Object$BrokerConfirmBindFormBound$effectiveDate,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$PublicApi$Object$BrokerConfirmBindFormBound$clientName,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										A2($author$project$ApiRequest$mapPublicScalarId, $elm$core$Basics$identity, $author$project$PublicApi$Object$BrokerConfirmBindFormBound$policyId),
										$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Data$ConfirmBindForm$BoundFormData)))))))))));
var $author$project$Data$ConfirmBindForm$boundFormSelection = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Data$ConfirmBindForm$boundFormDataSelection,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Data$ConfirmBindForm$BoundForm));
var $author$project$Data$ConfirmBindForm$ChangedForm = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$ConfirmBindForm$ChangedFormData = F3(
	function (clientName, underwriterName, underwriterEmail) {
		return {ft: clientName, rg: underwriterEmail, rh: underwriterName};
	});
var $author$project$PublicApi$Object$BrokerConfirmBindFormChanged$clientName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'clientName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$PublicApi$Object$BrokerConfirmBindFormChanged$underwriterEmail = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'underwriterEmail', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$PublicApi$Object$BrokerConfirmBindFormChanged$underwriterName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'underwriterName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Data$ConfirmBindForm$changedFormDataSelection = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$PublicApi$Object$BrokerConfirmBindFormChanged$underwriterEmail,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$PublicApi$Object$BrokerConfirmBindFormChanged$underwriterName,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$PublicApi$Object$BrokerConfirmBindFormChanged$clientName,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Data$ConfirmBindForm$ChangedFormData))));
var $author$project$Data$ConfirmBindForm$changedFormSelection = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Data$ConfirmBindForm$changedFormDataSelection,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Data$ConfirmBindForm$ChangedForm));
var $author$project$Data$ConfirmBindForm$ExpiredForm = function (a) {
	return {$: 3, a: a};
};
var $author$project$Data$ConfirmBindForm$ExpiredFormData = F3(
	function (expirationDate, underwriterName, underwriterEmail) {
		return {bB: expirationDate, rg: underwriterEmail, rh: underwriterName};
	});
var $author$project$PublicApi$Object$BrokerConfirmBindFormExpired$expirationDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'PublicApiScalarCodecs.Date',
	'expirationDate',
	_List_Nil,
	$author$project$PublicApi$Scalar$unwrapCodecs($author$project$PublicApiScalarCodecs$codecs).e.yl);
var $author$project$PublicApi$Object$BrokerConfirmBindFormExpired$underwriterEmail = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'underwriterEmail', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$PublicApi$Object$BrokerConfirmBindFormExpired$underwriterName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'underwriterName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Data$ConfirmBindForm$expiredFormDataSelection = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$PublicApi$Object$BrokerConfirmBindFormExpired$underwriterEmail,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$PublicApi$Object$BrokerConfirmBindFormExpired$underwriterName,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$PublicApi$Object$BrokerConfirmBindFormExpired$expirationDate,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Data$ConfirmBindForm$ExpiredFormData))));
var $author$project$Data$ConfirmBindForm$expiredFormSelection = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Data$ConfirmBindForm$expiredFormDataSelection,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Data$ConfirmBindForm$ExpiredForm));
var $dillonkearns$elm_graphql$Graphql$SelectionSet$FragmentSelectionSet = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment = F2(
	function (fragmentTypeName, _v0) {
		var fields = _v0.a;
		var decoder = _v0.b;
		return A3($dillonkearns$elm_graphql$Graphql$SelectionSet$FragmentSelectionSet, fragmentTypeName, fields, decoder);
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFailureMessage = F2(
	function (typeSpecificSelections, typeName) {
		return A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'Unhandled type `{0}` in exhaustive fragment handling. The following types had handlers registered to handle them: [{1}]. This happens if you are parsing either a Union or Interface. Do you need to rerun the `@dillonkearns/elm-graphql` command line tool?',
			_List_fromArray(
				[
					typeName,
					A2(
					$elm$core$String$join,
					', ',
					A2(
						$elm$core$List$map,
						function (_v0) {
							var fragmentType = _v0.a;
							var fields = _v0.b;
							var decoder = _v0.c;
							return fragmentType;
						},
						typeSpecificSelections))
				]));
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection = function (typeSpecificSelections) {
	var selections = A2(
		$elm$core$List$map,
		function (_v1) {
			var typeName = _v1.a;
			var fields = _v1.b;
			var decoder = _v1.c;
			return A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite, '...on ' + typeName, _List_Nil, fields);
		},
		typeSpecificSelections);
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
		A2($elm$core$List$cons, $dillonkearns$elm_graphql$Graphql$RawField$typename, selections),
		A2(
			$elm$json$Json$Decode$andThen,
			function (typeName) {
				return A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Decode$fail(
						A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFailureMessage, typeSpecificSelections, typeName)),
					A2(
						$elm$core$Dict$get,
						typeName,
						$elm$core$Dict$fromList(
							A2(
								$elm$core$List$map,
								function (_v0) {
									var thisTypeName = _v0.a;
									var fields = _v0.b;
									var decoder = _v0.c;
									return _Utils_Tuple2(thisTypeName, decoder);
								},
								typeSpecificSelections))));
			},
			A2(
				$elm$json$Json$Decode$field,
				$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName($dillonkearns$elm_graphql$Graphql$RawField$typename),
				$elm$json$Json$Decode$string)));
};
var $author$project$PublicApi$Union$BrokerConfirmBindForm$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BrokerConfirmBindFormBound', selections____.G6),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BrokerConfirmBindFormChanged', selections____.G7),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BrokerConfirmBindFormExpired', selections____.G8),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BrokerConfirmBindFormReady', selections____.G9)
			]));
};
var $author$project$Data$ConfirmBindForm$ReadyForm = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$ConfirmBindForm$ReadyFormData = F8(
	function (clientName, effectiveDate, expirationDate, policyFeeCents, underwriterName, underwriterEmail, quoteOptions, selectedQuoteOptionId) {
		return {ft: clientName, bx: effectiveDate, bB: expirationDate, vS: policyFeeCents, Ia: quoteOptions, IV: selectedQuoteOptionId, rg: underwriterEmail, rh: underwriterName};
	});
var $author$project$PublicApi$Object$BrokerConfirmBindFormReady$clientName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'clientName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$PublicApi$Object$BrokerConfirmBindFormReady$effectiveDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'PublicApiScalarCodecs.Date',
	'effectiveDate',
	_List_Nil,
	$author$project$PublicApi$Scalar$unwrapCodecs($author$project$PublicApiScalarCodecs$codecs).e.yl);
var $author$project$PublicApi$Object$BrokerConfirmBindFormReady$expirationDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'PublicApiScalarCodecs.Date',
	'expirationDate',
	_List_Nil,
	$author$project$PublicApi$Scalar$unwrapCodecs($author$project$PublicApiScalarCodecs$codecs).e.yl);
var $author$project$PublicApi$Object$BrokerConfirmBindFormReady$policyFeeCents = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'policyFeeCents', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$PublicApi$Object$BrokerConfirmBindFormReady$quoteOptions = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'quoteOptions',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$PublicApi$Object$BrokerConfirmBindFormReady$underwriterEmail = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'underwriterEmail', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$PublicApi$Object$BrokerConfirmBindFormReady$underwriterName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'underwriterName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Data$ConfirmBindForm$readyFormDataSelection = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
	'',
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$PublicApi$Object$BrokerConfirmBindFormReady$quoteOptions($author$project$Data$ConfirmBindForm$quoteOptionSelection),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$PublicApi$Object$BrokerConfirmBindFormReady$underwriterEmail,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$PublicApi$Object$BrokerConfirmBindFormReady$underwriterName,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$PublicApi$Object$BrokerConfirmBindFormReady$policyFeeCents,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$PublicApi$Object$BrokerConfirmBindFormReady$expirationDate,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$PublicApi$Object$BrokerConfirmBindFormReady$effectiveDate,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$PublicApi$Object$BrokerConfirmBindFormReady$clientName,
								$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Data$ConfirmBindForm$ReadyFormData)))))))));
var $author$project$Data$ConfirmBindForm$readyFormSelection = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Data$ConfirmBindForm$readyFormDataSelection,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Data$ConfirmBindForm$ReadyForm));
var $author$project$Data$ConfirmBindForm$formSelection = $author$project$PublicApi$Union$BrokerConfirmBindForm$fragments(
	{G6: $author$project$Data$ConfirmBindForm$boundFormSelection, G7: $author$project$Data$ConfirmBindForm$changedFormSelection, G8: $author$project$Data$ConfirmBindForm$expiredFormSelection, G9: $author$project$Data$ConfirmBindForm$readyFormSelection});
var $author$project$Login$ConfirmBindForm$getInitialFormDataCmd = F2(
	function (_v0, msg) {
		var quoteRequestId = _v0;
		var requiredArgs = {AO: quoteRequestId};
		var query = A2($author$project$PublicApi$Query$brokerConfirmBindForm, requiredArgs, $author$project$Data$ConfirmBindForm$formSelection);
		return A2($author$project$ApiRequest$publicQuery, msg, query);
	});
var $author$project$Login$ConfirmBindForm$init = F2(
	function (quoteRequestId, isTravelersRequestUrl) {
		var initialModel = {dA: $krisajenkins$remotedata$RemoteData$NotAsked, zm: isTravelersRequestUrl, AO: quoteRequestId};
		var initialCmd = A2($author$project$Login$ConfirmBindForm$getInitialFormDataCmd, quoteRequestId, $author$project$Login$ConfirmBindForm$GetOrSubmitFormCompleted);
		return _Utils_Tuple2(initialModel, initialCmd);
	});
var $author$project$Login$ForgotPassword$Update$init = function (isTravelersRequestUrl) {
	return _Utils_Tuple2(
		{
			aW: $author$project$Model$ValidationNext$Unvalidated(
				$author$project$Data$Email$initial('')),
			gW: $krisajenkins$remotedata$RemoteData$NotAsked,
			zm: isTravelersRequestUrl
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Login$Ransomware$Model$NoOp = {$: 10};
var $author$project$Model$ValidationNext$Valid = function (a) {
	return {$: 1, a: a};
};
var $author$project$Login$Ransomware$Model$SignedIn = 0;
var $author$project$Login$Ransomware$Model$initialModel = {
	xw: '',
	ft: $author$project$Model$ValidationNext$Unvalidated(''),
	x2: $elm$core$Maybe$Nothing,
	yg: '',
	yr: $elm$core$Maybe$Nothing,
	aW: $author$project$Model$ValidationNext$Unvalidated(''),
	bG: $author$project$Model$ValidationNext$Unvalidated(0),
	zm: false,
	D: $elm$core$Maybe$Nothing,
	Ad: 0,
	AQ: '',
	AS: $elm$core$Maybe$Nothing,
	Bx: $krisajenkins$remotedata$RemoteData$NotAsked,
	By: $krisajenkins$remotedata$RemoteData$NotAsked
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$string = function (value) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(
		$elm$json$Json$Encode$string(value));
};
var $author$project$Api$Mutation$logInteraction = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'Bool',
		'logInteraction',
		_List_fromArray(
			[
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'eventCategory', requiredArgs____.yC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'eventType', requiredArgs____.yD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
			]),
		$elm$json$Json$Decode$bool);
};
var $dillonkearns$elm_graphql$Graphql$Http$Mutation = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$mutationRequest = F2(
	function (baseUrl, mutationSelectionSet) {
		return {
			k5: baseUrl,
			x: $dillonkearns$elm_graphql$Graphql$Http$Mutation(mutationSelectionSet),
			da: $dillonkearns$elm_graphql$Graphql$Document$decoder(mutationSelectionSet),
			dd: _List_Nil,
			em: $elm$core$Maybe$Nothing,
			ep: _List_Nil,
			ds: $elm$core$Maybe$Nothing,
			eB: false
		};
	});
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $dillonkearns$elm_graphql$Graphql$Http$withHeader = F3(
	function (key, value, _v0) {
		var request = _v0;
		return _Utils_update(
			request,
			{
				dd: A2(
					$elm$core$List$cons,
					A2($elm$http$Http$header, key, value),
					request.dd)
			});
	});
var $author$project$ApiRequest$withAuth = function (_v0) {
	var sessionId = _v0;
	return A2($dillonkearns$elm_graphql$Graphql$Http$withHeader, 'authorization', 'token ' + sessionId);
};
var $author$project$ApiRequest$mutation = F3(
	function (sessionId, onCompleteMsg, selectionSet) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$Http$send,
			A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, onCompleteMsg),
			A2(
				$author$project$ApiRequest$withAuth,
				sessionId,
				A2($dillonkearns$elm_graphql$Graphql$Http$mutationRequest, '/q', selectionSet)));
	});
var $author$project$ApiRequest$Mutations$Reporting$logEvent = F3(
	function (sessionId, callback, event) {
		return A3(
			$author$project$ApiRequest$mutation,
			sessionId,
			callback,
			$author$project$Api$Mutation$logInteraction(event));
	});
var $author$project$Login$Ransomware$Update$init = F4(
	function (email_, pageView_, sessionId, isTravelersRequestUrl) {
		var _v0 = function () {
			if (!email_.$) {
				var e = email_.a;
				return _Utils_Tuple2(
					$author$project$Model$ValidationNext$Valid(e),
					A3(
						$author$project$ApiRequest$Mutations$Reporting$logEvent,
						sessionId,
						$elm$core$Basics$always($author$project$Login$Ransomware$Model$NoOp),
						{yC: 'RansomwareCalculatorViewed', yD: 'PageView'}));
			} else {
				return _Utils_Tuple2(
					$author$project$Model$ValidationNext$Unvalidated(''),
					$elm$core$Platform$Cmd$none);
			}
		}();
		var email = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				$author$project$Login$Ransomware$Model$initialModel,
				{aW: email, zm: isTravelersRequestUrl, Ad: pageView_}),
			cmd);
	});
var $author$project$Login$SigninV2$Model$TokenSigninCompleted = function (a) {
	return {$: 14, a: a};
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $author$project$Broker$Route$Signin = function (a) {
	return {$: 29, a: a};
};
var $author$project$Broker$Route$SigninRouteOptions = F6(
	function (parentBrokerageId, affiliateBrokerageId, email, name, token, location) {
		return {xe: affiliateBrokerageId, aW: email, Gh: location, h$: name, nu: parentBrokerageId, B4: token};
	});
var $author$project$Broker$Route$defaultSigninRoute = $author$project$Broker$Route$Signin(
	A6($author$project$Broker$Route$SigninRouteOptions, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
var $author$project$Data$Brokerage$idToString = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$Broker$Route$reduceParams = function (params) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, accum) {
				var name = _v0.a;
				var value = _v0.b;
				return A2(
					$elm$core$Maybe$withDefault,
					accum,
					A2(
						$elm$core$Maybe$map,
						function (p) {
							return A2($elm$core$List$cons, p, accum);
						},
						A2(
							$elm$core$Maybe$map,
							$elm$url$Url$Builder$string(name),
							value)));
			}),
		_List_Nil,
		params);
};
var $elm$core$String$toLower = _String_toLower;
var $author$project$Data$ProductLine$toString = function (type_) {
	switch (type_.$) {
		case 0:
			return 'Admitted Cyber';
		case 1:
			if (!type_.a) {
				var _v1 = type_.a;
				return 'CyberRisk';
			} else {
				var _v2 = type_.a;
				return 'Cyber';
			}
		case 2:
			return 'Cyber EU';
		case 3:
			return 'Cyber EU Excess';
		case 4:
			if (!type_.a) {
				var _v3 = type_.a;
				return 'CyberRisk Excess';
			} else {
				var _v4 = type_.a;
				return 'Cyber Excess';
			}
		case 5:
			return 'Cyber Reinsurance';
		case 6:
			return 'Cyber UK Open Market';
		case 7:
			return 'Cyber UK Declaration';
		case 8:
			return 'Excess FI';
		case 9:
			return 'FI Asset Management';
		case 10:
			return 'FI Select';
		case 11:
			if (!type_.a) {
				var _v5 = type_.a;
				return 'CyberRisk Tech';
			} else {
				var _v6 = type_.a;
				return 'Tech E&O Wholesale';
			}
		case 12:
			return 'Tech E&O Excess';
		default:
			return 'Travelers External';
	}
};
var $author$project$Broker$Route$toUrl = function (route) {
	switch (route.$) {
		case 0:
			var token = route.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['activate', token]),
				_List_Nil);
		case 1:
			var parentBrokerageId = route.a;
			var affiliateBrokerageId = route.b;
			var email = route.c.aW;
			var name = route.c.h$;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['signup', parentBrokerageId, affiliateBrokerageId]),
				$author$project$Broker$Route$reduceParams(
					_List_fromArray(
						[
							_Utils_Tuple2('email', email),
							_Utils_Tuple2('name', name)
						])));
		case 2:
			var clientId = route.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['clients', clientId, 'alerts', 'subscribers', 'new']),
				_List_Nil);
		case 3:
			var clientId = route.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['clients', clientId, 'alerts', 'subscribers', 'unsubscribe']),
				_List_Nil);
		case 4:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['brokerteam']),
				_List_Nil);
		case 5:
			var clientId = route.a;
			var policyId = route.b;
			var claimId = route.c;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['clients', clientId, 'policies', policyId, 'claims', claimId]),
				_List_Nil);
		case 6:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['claims']),
				_List_Nil);
		case 7:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['claims-resources']),
				_List_Nil);
		case 8:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['black/dlpreview']),
				_List_Nil);
		case 9:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['black/planreview']),
				_List_Nil);
		case 10:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['black/tabletop']),
				_List_Nil);
		case 11:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['black']),
				_List_Nil);
		case 12:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['black/onboarding']),
				_List_Nil);
		case 13:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['black/phishing']),
				_List_Nil);
		case 14:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['black/prebreach']),
				_List_Nil);
		case 15:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['black/thirdpartyscan']),
				_List_Nil);
		case 16:
			var clientId = route.a;
			var productType = route.b;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[
						'clients',
						clientId,
						'dlp',
						$elm$core$String$toLower(
						$author$project$Data$ProductLine$toString(productType))
					]),
				_List_Nil);
		case 17:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['flightdashboard']),
				_List_Nil);
		case 18:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['forgot']),
				_List_Nil);
		case 19:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['']),
				_List_Nil);
		case 20:
			var clientId = route.a;
			var quoteRequestId = route.b;
			var edit = route.c.yA;
			var editValue = edit ? $elm$core$Maybe$Just('true') : $elm$core$Maybe$Nothing;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['clients', clientId, 'quotes', quoteRequestId]),
				$author$project$Broker$Route$reduceParams(
					_List_fromArray(
						[
							_Utils_Tuple2('edit', editValue)
						])));
		case 28:
			var clientId = route.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['clients', clientId]),
				_List_Nil);
		case 21:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['404']),
				_List_Nil);
		case 22:
			var clientId = route.a;
			var policyId = route.b;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['clients', clientId, 'policies', policyId]),
				_List_Nil);
		case 23:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['productselect']),
				_List_Nil);
		case 24:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['ransomware']),
				_List_Nil);
		case 25:
			var tokenId = route.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['reset', tokenId]),
				_List_Nil);
		case 26:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['resources']),
				_List_Nil);
		case 27:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['settings']),
				_List_Nil);
		case 29:
			var parentBrokerageId = route.a.nu;
			var affiliateBrokerageId = route.a.xe;
			var email = route.a.aW;
			var name = route.a.h$;
			var token = route.a.B4;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['signin']),
				$author$project$Broker$Route$reduceParams(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'parentBrokerageId',
							A2($elm$core$Maybe$map, $author$project$Data$Brokerage$idToString, parentBrokerageId)),
							_Utils_Tuple2(
							'affiliateBrokerageId',
							A2($elm$core$Maybe$map, $author$project$Data$Brokerage$idToString, affiliateBrokerageId)),
							_Utils_Tuple2('email', email),
							_Utils_Tuple2('name', name),
							_Utils_Tuple2('token', token)
						])));
		case 30:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['signout']),
				_List_Nil);
		default:
			var policyId = route.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['surplus_lines', policyId]),
				_List_Nil);
	}
};
var $author$project$Request$Account$doSignin = F3(
	function (msg, csrfToken, body) {
		var url = $author$project$Broker$Route$toUrl($author$project$Broker$Route$defaultSigninRoute);
		var decoder = A2($elm$json$Json$Decode$field, 'data', $author$project$Data$Session$accountDecoder);
		return $elm$http$Http$request(
			{
				k8: $elm$http$Http$jsonBody(body),
				da: A2($elm$http$Http$expectJson, msg, decoder),
				dd: _List_fromArray(
					[
						A2($elm$http$Http$header, 'x-csrf-token', csrfToken)
					]),
				dg: 'POST',
				ds: $elm$core$Maybe$Nothing,
				dt: $elm$core$Maybe$Nothing,
				Cd: url
			});
	});
var $author$project$Request$Account$tokenSignin = F4(
	function (msg, token, maybeLocation, csrfToken) {
		var location = A2($elm$core$Maybe$withDefault, '', maybeLocation);
		return A3(
			$author$project$Request$Account$doSignin,
			msg,
			csrfToken,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'token',
						$elm$json$Json$Encode$string(token)),
						_Utils_Tuple2(
						'location',
						$elm$json$Json$Encode$string(location))
					])));
	});
var $author$project$Login$SigninV2$Update$init = F5(
	function (options, csrfToken, account, isTravelersRequestUrl, isProduction) {
		var tokenDetails = {B5: $krisajenkins$remotedata$RemoteData$NotAsked};
		var details = {
			aW: $author$project$Model$ValidationNext$Unvalidated(
				$author$project$Data$Email$initial('')),
			ze: false,
			zg: false,
			zi: false,
			zk: isProduction,
			zm: isTravelersRequestUrl,
			z8: options,
			d$: $author$project$Model$ValidationNext$Unvalidated(''),
			BH: $krisajenkins$remotedata$RemoteData$NotAsked
		};
		var _v0 = _Utils_Tuple2(account, options.B4);
		if ((!_v0.a.$) && (!_v0.a.b.$)) {
			var _v1 = _v0.a;
			var _v2 = _v1.b;
			return _Utils_Tuple2(
				A2(
					$author$project$Login$SigninV2$Model$Model,
					details,
					$author$project$Login$SigninV2$Model$PasswordFlow(tokenDetails)),
				$elm$browser$Browser$Navigation$load('/'));
		} else {
			if (!_v0.b.$) {
				var t = _v0.b.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Login$SigninV2$Model$Model,
						details,
						$author$project$Login$SigninV2$Model$PasswordFlow(
							_Utils_update(
								tokenDetails,
								{B5: $krisajenkins$remotedata$RemoteData$Loading}))),
					A4(
						$author$project$Request$Account$tokenSignin,
						A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Login$SigninV2$Model$TokenSigninCompleted),
						t,
						options.Gh,
						csrfToken));
			} else {
				return _Utils_Tuple2(
					A2(
						$author$project$Login$SigninV2$Model$Model,
						details,
						$author$project$Login$SigninV2$Model$PasswordFlow(tokenDetails)),
					$elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Login$SurplusLinesLicense$Model$ReceivedInitialFormData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Login$SurplusLinesLicense$Model$InitialFormData = F3(
	function (policyholderState, status, surplusLinesLicense) {
		return {HC: policyholderState, BS: status, Ju: surplusLinesLicense};
	});
var $author$project$PublicApi$Object$InitialPublicSurplusLinesFilingForm$policyholderState = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'policyholderState', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$PublicApi$Query$publicSurplusLinesFilingForm = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'publicSurplusLinesFilingForm',
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required,
					'policyId',
					requiredArgs____.n,
					A2(
						$author$project$PublicApi$Scalar$unwrapEncoder,
						function ($) {
							return $.g;
						},
						$author$project$PublicApiScalarCodecs$codecs))
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$PublicApi$Enum$PublicSurplusLinesFilingFormStatus$Active = 0;
var $author$project$PublicApi$Enum$PublicSurplusLinesFilingFormStatus$Expired = 1;
var $author$project$PublicApi$Enum$PublicSurplusLinesFilingFormStatus$Submitted = 2;
var $author$project$PublicApi$Enum$PublicSurplusLinesFilingFormStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'ACTIVE':
				return $elm$json$Json$Decode$succeed(0);
			case 'EXPIRED':
				return $elm$json$Json$Decode$succeed(1);
			case 'SUBMITTED':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid PublicSurplusLinesFilingFormStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$PublicApi$Object$InitialPublicSurplusLinesFilingForm$status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.PublicSurplusLinesFilingFormStatus.PublicSurplusLinesFilingFormStatus', 'status', _List_Nil, $author$project$PublicApi$Enum$PublicSurplusLinesFilingFormStatus$decoder);
var $author$project$PublicApi$Object$InitialPublicSurplusLinesFilingForm$surplusLinesFiling = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'surplusLinesFiling',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Login$SurplusLinesLicense$Model$SurplusLinesLicense = function (licenseNumber) {
	return function (filingAgency) {
		return function (expirationDate) {
			return function (fein) {
				return function (address) {
					return function (addressTwo) {
						return function (city) {
							return function (state) {
								return function (postalCode) {
									return function (filerEmail) {
										return function (filerPhoneNumber) {
											return {a7: address, CC: addressTwo, Dk: city, bB: expirationDate, EQ: fein, ES: filerEmail, ET: filerPhoneNumber, EU: filingAgency, F9: licenseNumber, Z: postalCode, Jg: state};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$PublicApi$Object$SurplusLinesFiling$surplusAddress = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'surplusAddress',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$PublicApi$Object$SurplusLinesFiling$surplusAddressTwo = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'surplusAddressTwo',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$PublicApi$Object$SurplusLinesFiling$surplusCity = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'surplusCity',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$PublicApi$Object$SurplusLinesFiling$surplusExpirationDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe PublicApiScalarCodecs.Date)',
	'surplusExpirationDate',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$PublicApi$Scalar$unwrapCodecs($author$project$PublicApiScalarCodecs$codecs).e.yl));
var $author$project$PublicApi$Object$SurplusLinesFiling$surplusFein = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'surplusFein',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$PublicApi$Object$SurplusLinesFiling$surplusFilerEmail = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'surplusFilerEmail',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$PublicApi$Object$SurplusLinesFiling$surplusFilerPhoneNumber = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'surplusFilerPhoneNumber',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$PublicApi$Object$SurplusLinesFiling$surplusFilingAgency = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'surplusFilingAgency',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$PublicApi$Object$SurplusLinesFiling$surplusLicenseNumber = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'surplusLicenseNumber',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$PublicApi$Object$SurplusLinesFiling$surplusPostalCode = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'surplusPostalCode',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$PublicApi$Object$SurplusLinesFiling$surplusState = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'surplusState',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Login$SurplusLinesLicense$Update$surplusLinesLicenseSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$PublicApi$Object$SurplusLinesFiling$surplusFilerPhoneNumber,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$PublicApi$Object$SurplusLinesFiling$surplusFilerEmail,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$PublicApi$Object$SurplusLinesFiling$surplusPostalCode,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$PublicApi$Object$SurplusLinesFiling$surplusState,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$PublicApi$Object$SurplusLinesFiling$surplusCity,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$PublicApi$Object$SurplusLinesFiling$surplusAddressTwo,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$PublicApi$Object$SurplusLinesFiling$surplusAddress,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$PublicApi$Object$SurplusLinesFiling$surplusFein,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$PublicApi$Object$SurplusLinesFiling$surplusExpirationDate,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$PublicApi$Object$SurplusLinesFiling$surplusFilingAgency,
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$PublicApi$Object$SurplusLinesFiling$surplusLicenseNumber,
											$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Login$SurplusLinesLicense$Model$SurplusLinesLicense))))))))))));
var $author$project$Login$SurplusLinesLicense$Update$getInitialFormData = F2(
	function (policyId, msg) {
		var selectionSet = A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$PublicApi$Object$InitialPublicSurplusLinesFilingForm$surplusLinesFiling($author$project$Login$SurplusLinesLicense$Update$surplusLinesLicenseSelectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$PublicApi$Object$InitialPublicSurplusLinesFilingForm$status,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$PublicApi$Object$InitialPublicSurplusLinesFilingForm$policyholderState,
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Login$SurplusLinesLicense$Model$InitialFormData))));
		var requiredArguments = {
			n: function (_v0) {
				var id = _v0;
				return id;
			}(policyId)
		};
		var query = A2($author$project$PublicApi$Query$publicSurplusLinesFilingForm, requiredArguments, selectionSet);
		return A2($author$project$ApiRequest$publicQuery, msg, query);
	});
var $author$project$CorvusDatePicker$CorvusDatePicker = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $CurrySoftware$elm_datepicker$DatePicker$DatePicker = $elm$core$Basics$identity;
var $CurrySoftware$elm_datepicker$DatePicker$initFromDate = function (date) {
	return {
		bE: $elm$core$Maybe$Just(date),
		dV: false,
		df: $elm$core$Maybe$Nothing,
		dD: false,
		d3: date
	};
};
var $author$project$CorvusDatePicker$init = F2(
	function (today, date) {
		return function (picker) {
			return A2($author$project$CorvusDatePicker$CorvusDatePicker, picker, $elm$core$Maybe$Nothing);
		}(
			$CurrySoftware$elm_datepicker$DatePicker$initFromDate(
				A2($elm$core$Maybe$withDefault, today, date)));
	});
var $author$project$Login$SurplusLinesLicense$Model$Loading = 3;
var $author$project$Login$SurplusLinesLicense$Model$Model = F5(
	function (a, b, c, d, e) {
		return {$: 0, a: a, b: b, c: c, d: d, e: e};
	});
var $author$project$Login$SurplusLinesLicense$Model$PolicyholderState = $elm$core$Basics$identity;
var $author$project$Login$SurplusLinesLicense$Model$NotValidated = 0;
var $author$project$Data$PhoneNumber$PhoneNumberUK = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$PhoneNumber$PhoneNumberUS = function (a) {
	return {$: 0, a: a};
};
var $author$project$View$Util$removePhoneNumberFormatting = function (formattedPhoneNumber) {
	return A3(
		$elm$regex$Regex$replace,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('[^0-9]')),
		function (_v0) {
			return '';
		},
		formattedPhoneNumber);
};
var $author$project$Data$PhoneNumber$initial = function (phoneNumber) {
	var cleanPhoneNumber = $author$project$View$Util$removePhoneNumberFormatting(phoneNumber);
	return ($elm$core$String$length(cleanPhoneNumber) > 10) ? $author$project$Data$PhoneNumber$PhoneNumberUK(phoneNumber) : $author$project$Data$PhoneNumber$PhoneNumberUS(phoneNumber);
};
var $author$project$Model$ValidationNext$unvalidated = $author$project$Model$ValidationNext$Unvalidated;
var $author$project$Model$ValidationNext$valid = $author$project$Model$ValidationNext$Valid;
var $author$project$Login$SurplusLinesLicense$Model$emptyForm = function (datePicker) {
	return {
		w7: $author$project$Model$ValidationNext$unvalidated(''),
		w8: $author$project$Model$ValidationNext$unvalidated(''),
		w9: $author$project$Model$ValidationNext$valid(''),
		xa: $author$project$Model$ValidationNext$unvalidated(''),
		xb: $author$project$Model$ValidationNext$unvalidated(''),
		xl: $author$project$Model$ValidationNext$unvalidated(''),
		aW: $author$project$Model$ValidationNext$unvalidated(
			$author$project$Data$Email$initial('')),
		bB: $author$project$Model$ValidationNext$unvalidated($elm$core$Maybe$Nothing),
		yG: datePicker,
		EQ: $author$project$Model$ValidationNext$unvalidated(''),
		yK: $author$project$Model$ValidationNext$unvalidated(''),
		g2: 0,
		zd: false,
		F9: $author$project$Model$ValidationNext$unvalidated(''),
		dG: $author$project$Model$ValidationNext$unvalidated(
			$author$project$Data$PhoneNumber$initial('')),
		J_: $author$project$Model$ValidationNext$unvalidated('')
	};
};
var $author$project$Login$SurplusLinesLicense$Model$initialModel = F3(
	function (policyId, datePicker, isTravelersRequestUrl) {
		return A5(
			$author$project$Login$SurplusLinesLicense$Model$Model,
			policyId,
			'',
			$author$project$Login$SurplusLinesLicense$Model$emptyForm(datePicker),
			3,
			isTravelersRequestUrl);
	});
var $author$project$Login$SurplusLinesLicense$Update$init = F3(
	function (policyId, date, isTravelersRequestUrl) {
		var datePicker = A2($author$project$CorvusDatePicker$init, date, $elm$core$Maybe$Nothing);
		return _Utils_Tuple2(
			A3($author$project$Login$SurplusLinesLicense$Model$initialModel, policyId, datePicker, isTravelersRequestUrl),
			A2($author$project$Login$SurplusLinesLicense$Update$getInitialFormData, policyId, $author$project$Login$SurplusLinesLicense$Model$ReceivedInitialFormData));
	});
var $author$project$Login$SigninV2$Model$ResetPasswordFlow = function (a) {
	return {$: 3, a: a};
};
var $author$project$Login$SigninV2$Update$initResetPassword = F4(
	function (account, resetPasswordData, isTravelersRequestUrl, isProduction) {
		var options = {xe: $elm$core$Maybe$Nothing, aW: $elm$core$Maybe$Nothing, Gh: $elm$core$Maybe$Nothing, h$: $elm$core$Maybe$Nothing, nu: $elm$core$Maybe$Nothing, B4: $elm$core$Maybe$Nothing};
		var details = {
			aW: $author$project$Model$ValidationNext$Unvalidated(
				$author$project$Data$Email$initial('')),
			ze: false,
			zg: false,
			zi: false,
			zk: isProduction,
			zm: isTravelersRequestUrl,
			z8: options,
			d$: $author$project$Model$ValidationNext$Unvalidated(''),
			BH: $krisajenkins$remotedata$RemoteData$NotAsked
		};
		if ((!account.$) && (!account.b.$)) {
			var _v1 = account.b;
			return _Utils_Tuple2(
				A2(
					$author$project$Login$SigninV2$Model$Model,
					details,
					$author$project$Login$SigninV2$Model$ResetPasswordFlow(resetPasswordData)),
				$elm$browser$Browser$Navigation$load('/'));
		} else {
			return _Utils_Tuple2(
				A2(
					$author$project$Login$SigninV2$Model$Model,
					details,
					$author$project$Login$SigninV2$Model$ResetPasswordFlow(resetPasswordData)),
				$elm$core$Platform$Cmd$none);
		}
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Login$Update$mapCmd = F2(
	function (msg, pair) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map(msg),
			pair);
	});
var $author$project$Data$Session$initial = {aW: '', Fm: '', sG: $elm$core$Maybe$Nothing, zG: $author$project$Data$Session$NoRedirect, h$: '', Ak: $author$project$Data$Session$AdminPermissions$none, Al: '', ae: ''};
var $author$project$Data$Session$session = function (_with) {
	var _v0 = _with.w3;
	switch (_v0.$) {
		case 0:
			var s = _v0.a;
			return s;
		case 2:
			return $author$project$Data$Session$initial;
		case 1:
			return $author$project$Data$Session$initial;
		default:
			return $author$project$Data$Session$initial;
	}
};
var $author$project$Data$Session$sessionId = function (_with) {
	return $author$project$Data$Session$session(_with).Fm;
};
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $author$project$Login$Update$setPage = F3(
	function (model, pageFunc, tuple) {
		return A2(
			$elm$core$Tuple$mapFirst,
			function (subModel) {
				return _Utils_update(
					model,
					{
						Ac: pageFunc(subModel)
					});
			},
			tuple);
	});
var $author$project$Login$Update$mapRouteToModelCmd = F2(
	function (route, model) {
		switch (route.$) {
			case 0:
				return A2(
					$author$project$Login$Update$mapCmd,
					$author$project$Login$Model$AccountSetupMsg,
					A3(
						$author$project$Login$Update$setPage,
						model,
						$author$project$Login$Page$AccountSetup,
						$author$project$Login$AccountSetup$init(model.zm)));
			case 1:
				var tokenId = route.a;
				var resetPasswordData = {
					aW: model.Cf,
					yO: model.yO,
					FP: true,
					zm: model.zm,
					d$: $author$project$Model$ValidationNext$Unvalidated(''),
					vO: $author$project$Model$ValidationNext$Unvalidated(''),
					Iz: $krisajenkins$remotedata$RemoteData$NotAsked,
					IA: tokenId,
					I5: 0
				};
				return A2(
					$author$project$Login$Update$mapCmd,
					$author$project$Login$Model$SigninMsg,
					A3(
						$author$project$Login$Update$setPage,
						model,
						$author$project$Login$Page$Signin,
						A4($author$project$Login$SigninV2$Update$initResetPassword, model.w3, resetPasswordData, model.zm, model.zk)));
			case 2:
				var parentBrokerageId = route.a;
				var affiliateBrokerageId = route.b;
				var email = route.c.aW;
				var name = route.c.h$;
				return A2(
					$author$project$Login$Update$mapCmd,
					$author$project$Login$Model$AffiliateSignupMsg,
					A3(
						$author$project$Login$Update$setPage,
						model,
						A2($author$project$Login$Page$AffiliateSignup, parentBrokerageId, affiliateBrokerageId),
						A5($author$project$Login$AffiliateSignup$Update$init, email, name, parentBrokerageId, affiliateBrokerageId, model.x6)));
			case 3:
				var clientId = route.a;
				return A2(
					$author$project$Login$Update$mapCmd,
					$author$project$Login$Model$AlertSubscriberNewMsg,
					A3(
						$author$project$Login$Update$setPage,
						model,
						$author$project$Login$Page$AlertSubscriberNew,
						A2($author$project$Login$AlertSubscriberNew$Update$init, clientId, model.zm)));
			case 4:
				var clientId = route.a;
				return A2(
					$author$project$Login$Update$mapCmd,
					$author$project$Login$Model$AlertSubscriberUnsubscribeMsg,
					A3(
						$author$project$Login$Update$setPage,
						model,
						$author$project$Login$Page$AlertSubscriberUnsubscribe,
						A2($author$project$Login$AlertSubscriberUnsubscribe$Update$init, clientId, model.zm)));
			case 5:
				var quoteRequestId = route.a;
				return A2(
					$author$project$Login$Update$mapCmd,
					$author$project$Login$Model$ConfirmBindFormMsg,
					A3(
						$author$project$Login$Update$setPage,
						model,
						$author$project$Login$Page$ConfirmBindForm,
						A2($author$project$Login$ConfirmBindForm$init, quoteRequestId, model.zm)));
			case 6:
				return A2(
					$author$project$Login$Update$mapCmd,
					$author$project$Login$Model$ForgotPasswordMsg,
					A3(
						$author$project$Login$Update$setPage,
						model,
						$author$project$Login$Page$ForgotPassword,
						$author$project$Login$ForgotPassword$Update$init(model.zm)));
			case 7:
				return A2(
					$author$project$Login$Update$mapCmd,
					$author$project$Login$Model$RansomwareMsg,
					A3(
						$author$project$Login$Update$setPage,
						model,
						$author$project$Login$Page$Ransomware,
						A4(
							$author$project$Login$Ransomware$Update$init,
							$elm$core$Maybe$Nothing,
							1,
							$author$project$Data$Session$sessionId(model),
							model.zm)));
			case 8:
				var tokenId = route.a;
				var passwordAction = route.b;
				var resetPasswordData = {
					aW: model.Cf,
					yO: model.yO,
					FP: false,
					zm: model.zm,
					d$: $author$project$Model$ValidationNext$Unvalidated(''),
					vO: $author$project$Model$ValidationNext$Unvalidated(''),
					Iz: $krisajenkins$remotedata$RemoteData$NotAsked,
					IA: tokenId,
					I5: passwordAction
				};
				return A2(
					$author$project$Login$Update$mapCmd,
					$author$project$Login$Model$SigninMsg,
					A3(
						$author$project$Login$Update$setPage,
						model,
						$author$project$Login$Page$Signin,
						A4($author$project$Login$SigninV2$Update$initResetPassword, model.w3, resetPasswordData, model.zm, model.zk)));
			case 9:
				var options = route.a;
				return A2(
					$author$project$Login$Update$mapCmd,
					$author$project$Login$Model$SigninMsg,
					A3(
						$author$project$Login$Update$setPage,
						model,
						$author$project$Login$Page$Signin,
						A5($author$project$Login$SigninV2$Update$init, options, model.x6, model.w3, model.zm, model.zk)));
			default:
				var policyId = route.a;
				return A2(
					$author$project$Login$Update$mapCmd,
					$author$project$Login$Model$SurplusLinesLicenseMsg,
					A3(
						$author$project$Login$Update$setPage,
						model,
						$author$project$Login$Page$SurplusLinesLicense,
						A3($author$project$Login$SurplusLinesLicense$Update$init, policyId, model.yh, model.zm)));
		}
	});
var $author$project$Login$Page$pageToSegment = function (page) {
	switch (page.$) {
		case 0:
			return 'Account Setup Page';
		case 1:
			return 'Affiliate Signup Page';
		case 2:
			return 'Client Alerts Subscribe Page';
		case 3:
			return 'Client Alerts Unsubscribe Page';
		case 4:
			return 'Confirm Bind Form Page';
		case 5:
			return 'Forgot Password Page';
		case 6:
			return 'Ransomware Calculator Page';
		case 7:
			var _v1 = page.a;
			var flow = _v1.b;
			if (flow.$ === 3) {
				return 'Reset Password Page';
			} else {
				return 'Sign In Page';
			}
		default:
			return 'Surplus Lines Certificate Page';
	}
};
var $author$project$UserTracking$EventName$appToString = function (app) {
	switch (app) {
		case 0:
			return 'Admin';
		case 1:
			return 'Broker';
		case 2:
			return 'Coverholder';
		case 3:
			return 'Login';
		case 4:
			return 'Policyholder';
		case 5:
			return 'RCP';
		default:
			return 'Underwriter';
	}
};
var $author$project$UserTracking$EventName$pageName = F2(
	function (app, name) {
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					$author$project$UserTracking$EventName$appToString(app),
					name
				]));
	});
var $author$project$UserTracking$pageView = _Platform_outgoingPort(
	'pageView',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string($.h$)),
					_Utils_Tuple2(
					'properties',
					$elm$core$Basics$identity($.qE))
				]));
	});
var $author$project$UserTracking$trackUnknownUserPage = F3(
	function (app, pageToString, page) {
		return $author$project$UserTracking$pageView(
			{
				h$: A2(
					$author$project$UserTracking$EventName$pageName,
					app,
					pageToString(page)),
				qE: $elm$json$Json$Encode$object(_List_Nil)
			});
	});
var $author$project$Login$Update$setRouteWithTracking = F3(
	function (route, scrollCmd, _v0) {
		var model_ = _v0.a;
		var otherCmd = _v0.b;
		var model = _Utils_update(
			model_,
			{IL: route});
		var _v1 = A2($author$project$Login$Update$mapRouteToModelCmd, route, model);
		var newModel = _v1.a;
		var cmd = _v1.b;
		var trackPageViewCmd = A3($author$project$UserTracking$trackUnknownUserPage, 3, $author$project$Login$Page$pageToSegment, newModel.Ac);
		return _Utils_Tuple2(
			newModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[otherCmd, cmd, scrollCmd, trackPageViewCmd])));
	});
var $Janiczek$cmd_extra$Cmd$Extra$withCmd = F2(
	function (cmd, model) {
		return _Utils_Tuple2(model, cmd);
	});
var $author$project$Login$Main$init = F3(
	function (value, location, key) {
		var initialValue = $author$project$Data$InitialValue$initialize(value);
		var identifyCmdIfAuthenticated = function (account) {
			switch (account.$) {
				case 0:
					var session = account.a;
					var role = account.b;
					return A2($author$project$UserTracking$identifyUser, session, role);
				case 1:
					return $elm$core$Platform$Cmd$none;
				case 2:
					return $elm$core$Platform$Cmd$none;
				default:
					return $elm$core$Platform$Cmd$none;
			}
		};
		var cmd = $elm$core$Platform$Cmd$none;
		return A2(
			$Janiczek$cmd_extra$Cmd$Extra$addCmd,
			$author$project$Login$Update$getLocalTimeZone,
			A3(
				$author$project$Login$Update$setRouteWithTracking,
				$author$project$Login$Route$fromLocation(location),
				cmd,
				A2(
					$Janiczek$cmd_extra$Cmd$Extra$withCmd,
					identifyCmdIfAuthenticated(initialValue.w3),
					A3($author$project$Login$Main$initialModel, key, location, initialValue))));
	});
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$Login$SigninV2$Model$NoOp = {$: 10};
var $author$project$Ports$copyTextToClipboardComplete = _Platform_incomingPort('copyTextToClipboardComplete', $elm$json$Json$Decode$bool);
var $author$project$Login$SigninV2$Update$subscriptions = $author$project$Ports$copyTextToClipboardComplete(
	function (_v0) {
		return $author$project$Login$SigninV2$Model$NoOp;
	});
var $author$project$Login$Update$pageSubscriptions = function (model) {
	var _v0 = model.Ac;
	if (_v0.$ === 7) {
		return A2($elm$core$Platform$Sub$map, $author$project$Login$Model$SigninMsg, $author$project$Login$SigninV2$Update$subscriptions);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Login$Update$subscriptions = function (model) {
	return $author$project$Login$Update$pageSubscriptions(model);
};
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$Ports$scrollToId = _Platform_outgoingPort(
	'scrollToId',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string($.Fm)),
					_Utils_Tuple2(
					'offset',
					$elm$json$Json$Encode$int($.G4))
				]));
	});
var $author$project$Ports$scrollToTop = _Platform_outgoingPort('scrollToTop', $elm$json$Json$Encode$int);
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.H2;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.E3,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.l,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.HD,
					_Utils_ap(http, url.Fl)),
				url.qv)));
};
var $author$project$Login$UserTracking$Events$AccountSetup = 2;
var $author$project$Login$AccountSetup$CreateAccountCompleted = function (a) {
	return {$: 2, a: a};
};
var $author$project$Login$UserTracking$Events$NeedHelpLinkClicked = {$: 3};
var $author$project$Login$UserTracking$Events$ResetPasswordButtonClicked = {$: 1};
var $author$project$Login$UserTracking$Events$SignInWithExistingAccountLinkClicked = {$: 6};
var $author$project$Login$UserTracking$Events$WhoIsCorvusLinkClicked = function (a) {
	return {$: 0, a: a};
};
var $author$project$UserTracking$EventName$ButtonClicked = {$: 0};
var $author$project$UserTracking$EventName$LinkClicked = {$: 1};
var $author$project$UserTracking$EventName$actionToString = function (action) {
	switch (action.$) {
		case 0:
			return 'Button Clicked';
		case 1:
			return 'Link Clicked';
		case 2:
			return 'Modal Opened';
		case 3:
			return 'Section Expanded';
		default:
			var text = action.a;
			return text;
	}
};
var $author$project$UserTracking$EventName$eventType = F3(
	function (app, action, text) {
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					$author$project$UserTracking$EventName$appToString(app) + ':',
					text,
					$author$project$UserTracking$EventName$actionToString(action)
				]));
	});
var $author$project$UserTracking$trackingData = F4(
	function (app, action, eventText, payload) {
		return {
			sl: $elm$json$Json$Encode$object(payload),
			yD: A3($author$project$UserTracking$EventName$eventType, app, action, eventText)
		};
	});
var $author$project$Login$UserTracking$Events$trackingData = $author$project$UserTracking$trackingData(3);
var $author$project$Login$UserTracking$Events$whoIsCorvusClickedFromToString = function (clickedFrom) {
	switch (clickedFrom) {
		case 2:
			return 'Account Setup';
		case 1:
			return 'Forgot Password';
		default:
			return 'Sign In';
	}
};
var $author$project$Login$UserTracking$Events$encodeEvent = function (event) {
	switch (event.$) {
		case 1:
			return A3($author$project$Login$UserTracking$Events$trackingData, $author$project$UserTracking$EventName$ButtonClicked, 'Reset Password', _List_Nil);
		case 0:
			var from = event.a;
			return A3(
				$author$project$Login$UserTracking$Events$trackingData,
				$author$project$UserTracking$EventName$LinkClicked,
				'Who Is Corvus?',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'from',
						$elm$json$Json$Encode$string(
							$author$project$Login$UserTracking$Events$whoIsCorvusClickedFromToString(from)))
					]));
		case 2:
			return A3($author$project$Login$UserTracking$Events$trackingData, $author$project$UserTracking$EventName$LinkClicked, 'Sign In with MFA I Need Help', _List_Nil);
		case 3:
			return A3($author$project$Login$UserTracking$Events$trackingData, $author$project$UserTracking$EventName$ButtonClicked, 'Need Help?', _List_Nil);
		case 4:
			return A3($author$project$Login$UserTracking$Events$trackingData, $author$project$UserTracking$EventName$ButtonClicked, 'Sign In', _List_Nil);
		case 5:
			return A3($author$project$Login$UserTracking$Events$trackingData, $author$project$UserTracking$EventName$LinkClicked, 'Forgot Your Password?', _List_Nil);
		case 6:
			return A3($author$project$Login$UserTracking$Events$trackingData, $author$project$UserTracking$EventName$LinkClicked, 'Sign in with existing account', _List_Nil);
		case 7:
			return A3($author$project$Login$UserTracking$Events$trackingData, $author$project$UserTracking$EventName$LinkClicked, 'Sign in with your password', _List_Nil);
		case 8:
			return A3($author$project$Login$UserTracking$Events$trackingData, $author$project$UserTracking$EventName$ButtonClicked, 'Confirm Bind (Desktop)', _List_Nil);
		default:
			return A3($author$project$Login$UserTracking$Events$trackingData, $author$project$UserTracking$EventName$ButtonClicked, 'Confirm Bind (Mobile)', _List_Nil);
	}
};
var $author$project$Broker$Route$ForgotPassword = {$: 18};
var $author$project$Data$Session$passwordActionToString = function (action) {
	if (!action) {
		return 'create';
	} else {
		return 'reset';
	}
};
var $author$project$Data$Email$toString = function (_v0) {
	var string = _v0;
	return string;
};
var $author$project$Request$Account$forgetPassword = F4(
	function (msg, email, csrfToken, action) {
		var url = $author$project$Broker$Route$toUrl($author$project$Broker$Route$ForgotPassword);
		var decoder = $elm$json$Json$Decode$succeed('');
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'email',
						$elm$json$Json$Encode$string(
							$author$project$Data$Email$toString(email))),
						_Utils_Tuple2(
						'source',
						$elm$json$Json$Encode$string(
							$author$project$Data$Session$passwordActionToString(action)))
					])));
		return $elm$http$Http$request(
			{
				k8: body,
				da: A2($elm$http$Http$expectJson, msg, decoder),
				dd: _List_fromArray(
					[
						A2($elm$http$Http$header, 'x-csrf-token', csrfToken)
					]),
				dg: 'POST',
				ds: $elm$core$Maybe$Nothing,
				dt: $elm$core$Maybe$Nothing,
				Cd: url
			});
	});
var $author$project$Login$Route$navigateToUrl = F2(
	function (key, url) {
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$browser$Browser$Navigation$pushUrl, key, url),
					$author$project$Ports$scrollToTop(0)
				]));
	});
var $author$project$Login$Route$reduceParams = function (params) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, accum) {
				var name = _v0.a;
				var value = _v0.b;
				return A2(
					$elm$core$Maybe$withDefault,
					accum,
					A2(
						$elm$core$Maybe$map,
						function (p) {
							return A2($elm$core$List$cons, p, accum);
						},
						A2(
							$elm$core$Maybe$map,
							$elm$url$Url$Builder$string(name),
							value)));
			}),
		_List_Nil,
		params);
};
var $author$project$Login$Route$toUrl = function (route) {
	switch (route.$) {
		case 0:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['account-setup']),
				_List_Nil);
		case 1:
			var token = route.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['activate', token]),
				_List_Nil);
		case 2:
			var parentBrokerageId = route.a;
			var affiliateBrokerageId = route.b;
			var email = route.c.aW;
			var name = route.c.h$;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['signup', parentBrokerageId, affiliateBrokerageId]),
				$author$project$Login$Route$reduceParams(
					_List_fromArray(
						[
							_Utils_Tuple2('email', email),
							_Utils_Tuple2('name', name)
						])));
		case 3:
			var clientId = route.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['clients', clientId, 'alerts', 'subscribers', 'new']),
				_List_Nil);
		case 4:
			var clientId = route.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['clients', clientId, 'alerts', 'subscribers', 'unsubscribe']),
				_List_Nil);
		case 5:
			var quoteRequestId = route.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['confirm-bind', quoteRequestId]),
				_List_Nil);
		case 6:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['forgot']),
				_List_Nil);
		case 7:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['ransomware']),
				_List_Nil);
		case 8:
			var tokenId = route.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['reset', tokenId]),
				_List_Nil);
		case 9:
			var parentBrokerageId = route.a.nu;
			var affiliateBrokerageId = route.a.xe;
			var email = route.a.aW;
			var name = route.a.h$;
			var token = route.a.B4;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['signin']),
				$author$project$Login$Route$reduceParams(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'parentBrokerageId',
							A2($elm$core$Maybe$map, $author$project$Data$Brokerage$idToString, parentBrokerageId)),
							_Utils_Tuple2(
							'affiliateBrokerageId',
							A2($elm$core$Maybe$map, $author$project$Data$Brokerage$idToString, affiliateBrokerageId)),
							_Utils_Tuple2('email', email),
							_Utils_Tuple2('name', name),
							_Utils_Tuple2('token', token)
						])));
		default:
			var policyId = route.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['surplus_lines', policyId]),
				_List_Nil);
	}
};
var $author$project$Login$Route$navigateTo = function (key) {
	return A2(
		$elm$core$Basics$composeL,
		$author$project$Login$Route$navigateToUrl(key),
		$author$project$Login$Route$toUrl);
};
var $author$project$UserTracking$LinkTracking$redirectTo = F2(
	function (navigateTo, redirect) {
		if (!redirect.$) {
			var route = redirect.a;
			return navigateTo(route);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$UserTracking$track = _Platform_outgoingPort(
	'track',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'eventPayload',
					$elm$core$Basics$identity($.sl)),
					_Utils_Tuple2(
					'eventType',
					$elm$json$Json$Encode$string($.yD))
				]));
	});
var $author$project$UserTracking$trackUnknownUserEvent = F2(
	function (encoder, event) {
		return $author$project$UserTracking$track(
			encoder(event));
	});
var $author$project$Model$ValidationNext$Invalid = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Model$ValidationNext$extract = function (validation) {
	switch (validation.$) {
		case 0:
			var value = validation.a;
			return value;
		case 2:
			var value = validation.b;
			return value;
		default:
			var value = validation.a;
			return value;
	}
};
var $author$project$Model$ValidationNext$validate = F2(
	function (fn, validation) {
		var value = $author$project$Model$ValidationNext$extract(validation);
		var _v0 = fn(value);
		if (_v0.$ === 1) {
			var msg = _v0.a;
			return A2($author$project$Model$ValidationNext$Invalid, msg, value);
		} else {
			var ok = _v0.a;
			return $author$project$Model$ValidationNext$Valid(ok);
		}
	});
var $author$project$Model$ValidationNext$update = F3(
	function (input, fn, validation) {
		switch (validation.$) {
			case 0:
				return $author$project$Model$ValidationNext$Unvalidated(input);
			case 1:
				return A2(
					$author$project$Model$ValidationNext$validate,
					fn,
					$author$project$Model$ValidationNext$Unvalidated(input));
			default:
				return A2(
					$author$project$Model$ValidationNext$validate,
					fn,
					$author$project$Model$ValidationNext$Unvalidated(input));
		}
	});
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $author$project$Model$Validators$andThen = $elm$core$Result$andThen;
var $elm$regex$Regex$contains = _Regex_contains;
var $author$project$Model$Validators$emailRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('.+@.+\\..+'));
var $author$project$Model$Validators$email = F2(
	function (fieldName, e) {
		return A2($elm$regex$Regex$contains, $author$project$Model$Validators$emailRegex, e) ? $elm$core$Result$Ok(e) : $elm$core$Result$Err(fieldName + ' does not look like an email address.');
	});
var $elm_community$string_extra$String$Extra$pluralize = F3(
	function (singular, plural, count) {
		return (count === 1) ? ('1 ' + singular) : ($elm$core$String$fromInt(count) + (' ' + plural));
	});
var $author$project$Model$Validators$maxLength = F3(
	function (fieldName, max, string) {
		return (_Utils_cmp(
			$elm$core$String$length(string),
			max) > 0) ? $elm$core$Result$Err(
			$elm$core$String$concat(
				_List_fromArray(
					[
						fieldName,
						' cannot be longer than ',
						A3($elm_community$string_extra$String$Extra$pluralize, 'character', 'characters', max),
						'.'
					]))) : $elm$core$Result$Ok(string);
	});
var $author$project$Model$Validators$minLength = F3(
	function (fieldName, min, string) {
		return (_Utils_cmp(
			$elm$core$String$length(string),
			min) < 0) ? $elm$core$Result$Err(
			$elm$core$String$concat(
				_List_fromArray(
					[
						fieldName,
						' cannot be shorter than ',
						A3($elm_community$string_extra$String$Extra$pluralize, 'character', 'characters', min),
						'.'
					]))) : $elm$core$Result$Ok(string);
	});
var $author$project$Model$Validators$lengthBetween = F4(
	function (fieldName, min, max, string) {
		return A2(
			$author$project$Model$Validators$andThen,
			A2($author$project$Model$Validators$minLength, fieldName, min),
			A3($author$project$Model$Validators$maxLength, fieldName, max, string));
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $author$project$Model$Validators$validateEmail = function (_v0) {
	var string = _v0;
	return A2(
		$elm$core$Result$map,
		$elm$core$Basics$identity,
		A2(
			$author$project$Model$Validators$andThen,
			A3($author$project$Model$Validators$lengthBetween, 'Email', 5, 128),
			A2($author$project$Model$Validators$email, 'Email', string)));
};
var $author$project$Login$AccountSetup$update = F4(
	function (msg, key, csrfToken, model) {
		switch (msg.$) {
			case 0:
				var userInput = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aW: A3(
								$author$project$Model$ValidationNext$update,
								$author$project$Data$Email$initial(userInput),
								$author$project$Model$Validators$validateEmail,
								model.aW),
							gW: $krisajenkins$remotedata$RemoteData$NotAsked
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var validated = _Utils_update(
					model,
					{
						aW: A2($author$project$Model$ValidationNext$validate, $author$project$Model$Validators$validateEmail, model.aW)
					});
				var trackCmd = A2($author$project$UserTracking$trackUnknownUserEvent, $author$project$Login$UserTracking$Events$encodeEvent, $author$project$Login$UserTracking$Events$ResetPasswordButtonClicked);
				var _v1 = validated.aW;
				if (_v1.$ === 1) {
					var email = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							validated,
							{gW: $krisajenkins$remotedata$RemoteData$Loading}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A4(
									$author$project$Request$Account$forgetPassword,
									A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Login$AccountSetup$CreateAccountCompleted),
									email,
									csrfToken,
									0),
									trackCmd
								])));
				} else {
					return _Utils_Tuple2(validated, trackCmd);
				}
			case 2:
				var data = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gW: data}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$UserTracking$trackUnknownUserEvent,
						$author$project$Login$UserTracking$Events$encodeEvent,
						$author$project$Login$UserTracking$Events$WhoIsCorvusLinkClicked(2)));
			case 4:
				return _Utils_Tuple2(
					model,
					A2($author$project$UserTracking$trackUnknownUserEvent, $author$project$Login$UserTracking$Events$encodeEvent, $author$project$Login$UserTracking$Events$NeedHelpLinkClicked));
			default:
				var redirect = msg.a;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$UserTracking$trackUnknownUserEvent, $author$project$Login$UserTracking$Events$encodeEvent, $author$project$Login$UserTracking$Events$SignInWithExistingAccountLinkClicked),
								A2(
								$author$project$UserTracking$LinkTracking$redirectTo,
								$author$project$Login$Route$navigateTo(key),
								redirect)
							])));
		}
	});
var $author$project$Login$AffiliateSignup$Model$SignupCompleted = function (a) {
	return {$: 4, a: a};
};
var $author$project$Data$Brokerage$encodeId = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Data$Brokerage$idToString);
var $author$project$Request$Account$brokerSignup = F6(
	function (msg, parentBrokerageId, affiliateBrokerageId, email, name, csrfToken) {
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'parent_brokerage_id',
						$author$project$Data$Brokerage$encodeId(parentBrokerageId)),
						_Utils_Tuple2(
						'email',
						$elm$json$Json$Encode$string(
							$author$project$Data$Email$toString(email))),
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(name)),
						_Utils_Tuple2(
						'affiliate_brokerage_id',
						$author$project$Data$Brokerage$encodeId(affiliateBrokerageId))
					])));
		return $elm$http$Http$request(
			{
				k8: body,
				da: A2(
					$elm$http$Http$expectJson,
					msg,
					$elm$json$Json$Decode$succeed(0)),
				dd: _List_fromArray(
					[
						A2($elm$http$Http$header, 'x-csrf-token', csrfToken)
					]),
				dg: 'POST',
				ds: $elm$core$Maybe$Nothing,
				dt: $elm$core$Maybe$Nothing,
				Cd: '/brokers'
			});
	});
var $author$project$Login$AffiliateSignup$Model$validate = function (model) {
	return _Utils_update(
		model,
		{
			aW: A2($author$project$Model$ValidationNext$validate, $author$project$Model$Validators$validateEmail, model.aW),
			h$: A2(
				$author$project$Model$ValidationNext$validate,
				A3($author$project$Model$Validators$lengthBetween, 'Name', 1, 256),
				model.h$)
		});
};
var $author$project$Login$AffiliateSignup$Update$update = F6(
	function (msg, parentBrokerageId, affiliateBrokerageId, csrfToken, mainModel, model) {
		switch (msg.$) {
			case 0:
				var validated = $author$project$Login$AffiliateSignup$Model$validate(model);
				var _v1 = _Utils_Tuple2(validated.aW, validated.h$);
				if ((_v1.a.$ === 1) && (_v1.b.$ === 1)) {
					var email = _v1.a.a;
					var name = _v1.b.a;
					return _Utils_Tuple2(
						_Utils_Tuple2(
							_Utils_update(
								validated,
								{IZ: $krisajenkins$remotedata$RemoteData$Loading}),
							A6(
								$author$project$Request$Account$brokerSignup,
								A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Login$AffiliateSignup$Model$SignupCompleted),
								parentBrokerageId,
								affiliateBrokerageId,
								email,
								name,
								csrfToken)),
						mainModel);
				} else {
					return _Utils_Tuple2(
						_Utils_Tuple2(validated, $elm$core$Platform$Cmd$none),
						mainModel);
				}
			case 1:
				var userInput = msg.a;
				return _Utils_Tuple2(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								aW: A3(
									$author$project$Model$ValidationNext$update,
									$author$project$Data$Email$initial(userInput),
									$author$project$Model$Validators$validateEmail,
									model.aW)
							}),
						$elm$core$Platform$Cmd$none),
					mainModel);
			case 2:
				var data = msg.a;
				return _Utils_Tuple2(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{E7: data}),
						$elm$core$Platform$Cmd$none),
					mainModel);
			case 3:
				var name = msg.a;
				return _Utils_Tuple2(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								h$: A3(
									$author$project$Model$ValidationNext$update,
									name,
									A3($author$project$Model$Validators$lengthBetween, 'Name', 1, 256),
									model.h$)
							}),
						$elm$core$Platform$Cmd$none),
					mainModel);
			default:
				var data = msg.a;
				return _Utils_Tuple2(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{IZ: data}),
						$elm$core$Platform$Cmd$none),
					_Utils_update(
						mainModel,
						{yO: $elm$core$Maybe$Nothing}));
		}
	});
var $author$project$Model$ValidationNext$isValid = function (validation) {
	if (validation.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Login$AlertSubscriberNew$Update$isValid = function (model) {
	return $author$project$Model$ValidationNext$isValid(model.h$) && ($author$project$Model$ValidationNext$isValid(model.aW) && $author$project$Model$ValidationNext$isValid(model.Jp));
};
var $author$project$Login$AlertSubscriberNew$Model$FormPosted = function (a) {
	return {$: 1, a: a};
};
var $author$project$PublicApi$Enum$AlertSubscriptionRole$Policyholder = 0;
var $author$project$PublicApi$Enum$AlertSubscriptionRole$Retailer = 1;
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$EnumValue = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum = F2(
	function (enumToString, value) {
		return $dillonkearns$elm_graphql$Graphql$Internal$Encode$EnumValue(
			enumToString(value));
	});
var $author$project$PublicApi$Enum$AlertSubscriptionRole$toString = function (enum____) {
	if (!enum____) {
		return 'POLICYHOLDER';
	} else {
		return 'RETAILER';
	}
};
var $author$project$PublicApi$Mutation$createAlertSubscription = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'Bool',
		'createAlertSubscription',
		_List_fromArray(
			[
				A3(
				$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required,
				'clientId',
				requiredArgs____.xM,
				A2(
					$author$project$PublicApi$Scalar$unwrapEncoder,
					function ($) {
						return $.g;
					},
					$author$project$PublicApiScalarCodecs$codecs)),
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'email', requiredArgs____.aW, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'name', requiredArgs____.h$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
				A3(
				$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required,
				'role',
				requiredArgs____.i5,
				$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$PublicApi$Enum$AlertSubscriptionRole$toString))
			]),
		$elm$json$Json$Decode$bool);
};
var $author$project$ApiRequest$publicMutation = F2(
	function (msg, selectionSet) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$Http$send,
			A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, msg),
			A2($dillonkearns$elm_graphql$Graphql$Http$mutationRequest, '/qp', selectionSet));
	});
var $author$project$Model$ValidationNext$toString = F2(
	function (fn, validation) {
		switch (validation.$) {
			case 0:
				var value = validation.a;
				return fn(value);
			case 1:
				var value = validation.a;
				return fn(value);
			default:
				var input = validation.b;
				return fn(input);
		}
	});
var $author$project$Data$Email$validatedToString = function (email) {
	return A2(
		$author$project$Model$ValidationNext$toString,
		function (_v0) {
			var e = _v0;
			return e;
		},
		email);
};
var $author$project$Login$AlertSubscriberNew$Update$postForm = function (model) {
	var alertSubscriptionRole = function () {
		var _v1 = model.Jp;
		if ((_v1.$ === 1) && (!_v1.a)) {
			var _v2 = _v1.a;
			return 1;
		} else {
			return 0;
		}
	}();
	var requiredArgs = {
		xM: function (_v0) {
			var id = _v0;
			return id;
		}(model.xM),
		aW: $author$project$Data$Email$validatedToString(model.aW),
		h$: A2($author$project$Model$ValidationNext$toString, $elm$core$Basics$identity, model.h$),
		i5: alertSubscriptionRole
	};
	var createAlertSubscription = $author$project$PublicApi$Mutation$createAlertSubscription(requiredArgs);
	return A2($author$project$ApiRequest$publicMutation, $author$project$Login$AlertSubscriberNew$Model$FormPosted, createAlertSubscription);
};
var $author$project$Login$AlertSubscriberNew$Update$subscriberTypeValidator = function (st) {
	if (st === 2) {
		return $elm$core$Result$Err('Please select a subscriber type');
	} else {
		return $elm$core$Result$Ok(st);
	}
};
var $author$project$Model$Validators$validateHumanName = A3($author$project$Model$Validators$lengthBetween, 'Name', 2, 128);
var $author$project$Login$AlertSubscriberNew$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var validatedModel = _Utils_update(
					model,
					{
						aW: A2($author$project$Model$ValidationNext$validate, $author$project$Model$Validators$validateEmail, model.aW),
						h$: A2($author$project$Model$ValidationNext$validate, $author$project$Model$Validators$validateHumanName, model.h$),
						Jp: A2($author$project$Model$ValidationNext$validate, $author$project$Login$AlertSubscriberNew$Update$subscriberTypeValidator, model.Jp)
					});
				var _v1 = $author$project$Login$AlertSubscriberNew$Update$isValid(validatedModel) ? _Utils_Tuple2(
					$author$project$Login$AlertSubscriberNew$Update$postForm(validatedModel),
					$krisajenkins$remotedata$RemoteData$Loading) : _Utils_Tuple2($elm$core$Platform$Cmd$none, model.E1);
				var cmd = _v1.a;
				var formResponse = _v1.b;
				var updatedModel = _Utils_update(
					validatedModel,
					{E1: formResponse});
				return _Utils_Tuple2(updatedModel, cmd);
			case 1:
				var response = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E1: response}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var name = msg.a;
				var updatedName = A3($author$project$Model$ValidationNext$update, name, $author$project$Model$Validators$validateHumanName, model.h$);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{h$: updatedName}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var email = msg.a;
				var updatedEmail = A3($author$project$Model$ValidationNext$update, email, $author$project$Model$Validators$validateEmail, model.aW);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aW: updatedEmail}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var subscriberType = msg.a;
				var updatedSubscriberType = A3($author$project$Model$ValidationNext$update, subscriberType, $author$project$Login$AlertSubscriberNew$Update$subscriberTypeValidator, model.Jp);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Jp: updatedSubscriberType}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var clientName = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ft: clientName}),
					$elm$core$Platform$Cmd$none);
			default:
				var initialmodel_ = A2($author$project$Login$AlertSubscriberNew$Update$initialModel, model.xM, model.zm);
				var model_ = _Utils_update(
					initialmodel_,
					{ft: model.ft});
				return _Utils_Tuple2(model_, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Login$AlertSubscriberUnsubscribe$Model$FormPosted = function (a) {
	return {$: 3, a: a};
};
var $author$project$PublicApi$Mutation$removeAlertSubscription = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'Bool',
		'removeAlertSubscription',
		_List_fromArray(
			[
				A3(
				$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required,
				'clientId',
				requiredArgs____.xM,
				A2(
					$author$project$PublicApi$Scalar$unwrapEncoder,
					function ($) {
						return $.g;
					},
					$author$project$PublicApiScalarCodecs$codecs)),
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'email', requiredArgs____.aW, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
			]),
		$elm$json$Json$Decode$bool);
};
var $author$project$Login$AlertSubscriberUnsubscribe$Update$postForm = function (model) {
	var requiredArgs = {
		xM: function (_v0) {
			var id = _v0;
			return id;
		}(model.xM),
		aW: $author$project$Data$Email$validatedToString(model.aW)
	};
	var createAlertSubscription = $author$project$PublicApi$Mutation$removeAlertSubscription(requiredArgs);
	return A2($author$project$ApiRequest$publicMutation, $author$project$Login$AlertSubscriberUnsubscribe$Model$FormPosted, createAlertSubscription);
};
var $author$project$Login$AlertSubscriberUnsubscribe$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var clientName = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ft: clientName}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var email = msg.a;
				var updatedEmail = A3($author$project$Model$ValidationNext$update, email, $author$project$Model$Validators$validateEmail, model.aW);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aW: updatedEmail}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var validatedModel = _Utils_update(
					model,
					{
						aW: A2($author$project$Model$ValidationNext$validate, $author$project$Model$Validators$validateEmail, model.aW)
					});
				var _v1 = $author$project$Model$ValidationNext$isValid(validatedModel.aW) ? _Utils_Tuple2(
					$author$project$Login$AlertSubscriberUnsubscribe$Update$postForm(validatedModel),
					$krisajenkins$remotedata$RemoteData$Loading) : _Utils_Tuple2($elm$core$Platform$Cmd$none, model.E1);
				var cmd = _v1.a;
				var formResponse = _v1.b;
				var updatedModel = _Utils_update(
					validatedModel,
					{E1: formResponse});
				return _Utils_Tuple2(updatedModel, cmd);
			default:
				var response = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E1: response}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Login$UserTracking$Events$ClickAndBindDesktopButtonClicked = {$: 8};
var $author$project$Login$UserTracking$Events$ClickAndBindMobileButtonClicked = {$: 9};
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $author$project$Login$ConfirmBindForm$mapSuccessReadyForm = F4(
	function (form, updateFn, buildCmdFn, defaultModel) {
		if ((form.$ === 3) && (!form.a.$)) {
			var readyFormData = form.a.a;
			var updatedFormData = updateFn(readyFormData);
			var updatedForm = $krisajenkins$remotedata$RemoteData$Success(
				$author$project$Data$ConfirmBindForm$ReadyForm(updatedFormData));
			var cmd = buildCmdFn(readyFormData);
			return _Utils_Tuple2(
				_Utils_update(
					defaultModel,
					{dA: updatedForm}),
				cmd);
		} else {
			return _Utils_Tuple2(defaultModel, $elm$core$Platform$Cmd$none);
		}
	});
var $elm$core$List$sortBy = _List_sortBy;
var $elm$json$Json$Encode$bool = _Json_wrap;
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool = function (value) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(
		$elm$json$Json$Encode$bool(value));
};
var $author$project$PublicApi$Mutation$submitBrokerConfirmBind = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'submitBrokerConfirmBind',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'hasTria', requiredArgs____.am, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required,
					'quoteOptionId',
					requiredArgs____.at,
					A2(
						$author$project$PublicApi$Scalar$unwrapEncoder,
						function ($) {
							return $.g;
						},
						$author$project$PublicApiScalarCodecs$codecs)),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required,
					'quoteRequestId',
					requiredArgs____.AO,
					A2(
						$author$project$PublicApi$Scalar$unwrapEncoder,
						function ($) {
							return $.g;
						},
						$author$project$PublicApiScalarCodecs$codecs))
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Login$ConfirmBindForm$submitFormCmd = F3(
	function (_v0, _v1, hasTria) {
		var quoteRequestId = _v0;
		var quoteOptionId = _v1;
		var requiredArgs = {am: hasTria, at: quoteOptionId, AO: quoteRequestId};
		var mutation = A2($author$project$PublicApi$Mutation$submitBrokerConfirmBind, requiredArgs, $author$project$Data$ConfirmBindForm$formSelection);
		return A2($author$project$ApiRequest$publicMutation, $author$project$Login$ConfirmBindForm$GetOrSubmitFormCompleted, mutation);
	});
var $elm_community$list_extra$List$Extra$updateIf = F3(
	function (predicate, update, list) {
		return A2(
			$elm$core$List$map,
			function (item) {
				return predicate(item) ? update(item) : item;
			},
			list);
	});
var $author$project$Login$ConfirmBindForm$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var quoteOptionId = msg.a;
				var buildSubmitCmd = function (formData) {
					var _v1 = formData;
					var quoteOptions = _v1.Ia;
					var optionHasTria = A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						true,
						function ($) {
							return $.am;
						},
						A2(
							$elm_community$list_extra$List$Extra$find,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Fm;
								},
								$elm$core$Basics$eq(quoteOptionId)),
							quoteOptions));
					return $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3($author$project$Login$ConfirmBindForm$submitFormCmd, model.AO, quoteOptionId, optionHasTria),
								A2($author$project$UserTracking$trackUnknownUserEvent, $author$project$Login$UserTracking$Events$encodeEvent, $author$project$Login$UserTracking$Events$ClickAndBindMobileButtonClicked)
							]));
				};
				return A4($author$project$Login$ConfirmBindForm$mapSuccessReadyForm, model.dA, $elm$core$Basics$identity, buildSubmitCmd, model);
			case 1:
				var res = msg.a;
				var updateFormData = function (formData) {
					var selectedQuoteOptionId = A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						formData.IV,
						function ($) {
							return $.Fm;
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$sortBy,
								function ($) {
									return $.iq;
								},
								formData.Ia)));
					return _Utils_update(
						formData,
						{IV: selectedQuoteOptionId});
				};
				return A4(
					$author$project$Login$ConfirmBindForm$mapSuccessReadyForm,
					res,
					updateFormData,
					function (_v2) {
						return $elm$core$Platform$Cmd$none;
					},
					_Utils_update(
						model,
						{dA: res}));
			case 2:
				var quoteOptionId = msg.a;
				var updateFormData = function (formData) {
					return _Utils_update(
						formData,
						{IV: quoteOptionId});
				};
				return A4(
					$author$project$Login$ConfirmBindForm$mapSuccessReadyForm,
					model.dA,
					updateFormData,
					function (_v3) {
						return $elm$core$Platform$Cmd$none;
					},
					model);
			case 3:
				var buildSubmitCmd = function (formData) {
					var _v4 = formData;
					var selectedQuoteOptionId = _v4.IV;
					var quoteOptions = _v4.Ia;
					var optionHasTria = A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						true,
						function ($) {
							return $.am;
						},
						A2(
							$elm_community$list_extra$List$Extra$find,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Fm;
								},
								$elm$core$Basics$eq(selectedQuoteOptionId)),
							quoteOptions));
					return $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3($author$project$Login$ConfirmBindForm$submitFormCmd, model.AO, selectedQuoteOptionId, optionHasTria),
								A2($author$project$UserTracking$trackUnknownUserEvent, $author$project$Login$UserTracking$Events$encodeEvent, $author$project$Login$UserTracking$Events$ClickAndBindDesktopButtonClicked)
							]));
				};
				return A4($author$project$Login$ConfirmBindForm$mapSuccessReadyForm, model.dA, $elm$core$Basics$identity, buildSubmitCmd, model);
			default:
				var quoteOption = msg.a;
				var hasTria = msg.b;
				var updateFormData = function (formData) {
					var updatedQuoteOption = _Utils_update(
						quoteOption,
						{am: hasTria});
					var updatedQuoteOptions = A3(
						$elm_community$list_extra$List$Extra$updateIf,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Fm;
							},
							$elm$core$Basics$eq(quoteOption.Fm)),
						$elm$core$Basics$always(updatedQuoteOption),
						formData.Ia);
					return _Utils_update(
						formData,
						{Ia: updatedQuoteOptions});
				};
				return A4(
					$author$project$Login$ConfirmBindForm$mapSuccessReadyForm,
					model.dA,
					updateFormData,
					function (_v5) {
						return $elm$core$Platform$Cmd$none;
					},
					model);
		}
	});
var $author$project$Login$ForgotPassword$Model$ForgetPasswordCompleted = function (a) {
	return {$: 2, a: a};
};
var $author$project$Login$UserTracking$Events$ForgotPassword = 1;
var $author$project$Login$ForgotPassword$Update$update = F4(
	function (msg, key, csrfToken, model) {
		switch (msg.$) {
			case 0:
				var userInput = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aW: A3(
								$author$project$Model$ValidationNext$update,
								$author$project$Data$Email$initial(userInput),
								$author$project$Model$Validators$validateEmail,
								model.aW),
							gW: $krisajenkins$remotedata$RemoteData$NotAsked
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var validated = _Utils_update(
					model,
					{
						aW: A2($author$project$Model$ValidationNext$validate, $author$project$Model$Validators$validateEmail, model.aW)
					});
				var trackCmd = A2($author$project$UserTracking$trackUnknownUserEvent, $author$project$Login$UserTracking$Events$encodeEvent, $author$project$Login$UserTracking$Events$ResetPasswordButtonClicked);
				var _v1 = validated.aW;
				if (_v1.$ === 1) {
					var email = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							validated,
							{gW: $krisajenkins$remotedata$RemoteData$Loading}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A4(
									$author$project$Request$Account$forgetPassword,
									A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Login$ForgotPassword$Model$ForgetPasswordCompleted),
									email,
									csrfToken,
									1),
									trackCmd
								])));
				} else {
					return _Utils_Tuple2(validated, trackCmd);
				}
			case 2:
				var data = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gW: data}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$UserTracking$trackUnknownUserEvent,
						$author$project$Login$UserTracking$Events$encodeEvent,
						$author$project$Login$UserTracking$Events$WhoIsCorvusLinkClicked(1)));
			case 4:
				return _Utils_Tuple2(
					model,
					A2($author$project$UserTracking$trackUnknownUserEvent, $author$project$Login$UserTracking$Events$encodeEvent, $author$project$Login$UserTracking$Events$NeedHelpLinkClicked));
			default:
				var redirect = msg.a;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$UserTracking$trackUnknownUserEvent, $author$project$Login$UserTracking$Events$encodeEvent, $author$project$Login$UserTracking$Events$SignInWithExistingAccountLinkClicked),
								A2(
								$author$project$UserTracking$LinkTracking$redirectTo,
								$author$project$Login$Route$navigateTo(key),
								redirect)
							])));
		}
	});
var $author$project$Login$Ransomware$View$centsToString = function (centsInt) {
	return A2(
		$elm$core$String$dropRight,
		2,
		$elm$core$String$fromInt(centsInt));
};
var $author$project$Model$NatureOfBusiness$cyber = _List_fromArray(
	['Accounting', 'Advertising Agencies', 'Airline / Airport', 'Application Service Provider', 'Architects & Engineers', 'Auctioneers', 'Audio / Video Design', 'Auditing & Bookkeeping', 'Auto Dealers', 'B2B / Wholesale Trade / Distributors', 'Banking / Finance / Funds Transfer', 'Biotech', 'Broadcasting & Production Services', 'Business Consulting', 'Clinic', 'Clinical Trials', 'Collection Agencies', 'Compliance Consultants', 'Computer Maintenance & Repair', 'Computer Recycling / Refurbish / Resale', 'Construction Services', 'Contractor Services', 'Contractor - Defense & Military', 'Credit Union', 'Data Management Service', 'Electronic Health Record', 'Employee Benefits Administration', 'Employee Screening / Background Checks', 'Employment Agencies', 'Employment Consultant', 'Environmental Consultant', 'Event Planner', 'Expert Witness', 'Financial Advisor / Investment Advisor', 'Freight Forwarding / Fulfillment Services', 'Graphic Design', 'Hardware Manufacturers', 'Health Department', 'Health Practitioner / Physicians / Dentists', 'Health Services - Medical Group', 'Healthcare Consultants', 'Higher Education (College / Univ.)', 'Hospitality (Hotels/Motels)', 'Hospitals', 'Human Resources Consultant', 'IT Project Managers and Outsourcing Companies', 'Installation & Consulting', 'Insurance Agent & Brokers', 'Insurance Carriers / MGUs / MGAs', 'Internet Service Provider', 'Labs', 'Legal Services', 'Library', 'Loan Servicing / Mortgage Broker', 'Long Term Care / Nursing Home / Assisted Living Facility / Skilled Nursing', 'Managed Care Org. (IPA, MSO, PPO, HMO)', 'Management Consultant', 'Manufacturer - Defense & Military', 'Manufacturing / Distribution', 'Market Research', 'Marketing Consultant', 'Medical Billers', 'Medical Group', 'Medical or Healthcare Related Software Development', 'Membership Organization', 'Miscellaneous Consultant', 'Municipality / Public Entity', 'Network Installation / Maintenance', 'Notary Services', 'Online Retailer', 'PKI (Public Key Infrastructure) or Cryptography', 'Pawn Shop', 'Payment Services / POS', 'Payroll Services', 'Pharmacy', 'Printers / Publishers', 'Property Managers', 'Public Relations', 'R&D', 'Radiology / Imaging Centers', 'Real Estate Agents', 'Real Estate Investment / PE Firms', 'Real Estate Operators and Lessors', 'Records / Document Services', 'Religious Organizations', 'Restaurant', 'Retail Sales', 'School Districts', 'Schools K-12 (Public Schools)', 'Schools K-12 (Private Schools)', 'Security Consultants', 'Social Service Agency', 'Software Development', 'Software Programming', 'Sports Clubs / Gyms / Country Clubs', 'Surgery Center', 'Systems Design', 'TPA', 'Telecommunications Carrier', 'Telecommunications Consulting', 'Telemarketing / Call Center', 'Testing Facilities', 'Title / Escrow Services', 'Tour Operator', 'Tradesman Services', 'Training Consultant', 'Translation Services', 'Transportation', 'Travel Agency', 'Utility Company', 'Veterinarian', 'Vocational School', 'Web Design']);
var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
	if (m.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Model$Validators$inRangeInclusiveInt = F4(
	function (fieldName, minValue, maxValue, value) {
		return (_Utils_cmp(value, minValue) < 0) ? $elm$core$Result$Err(
			fieldName + (' must be at least ' + ($elm$core$String$fromInt(minValue) + '.'))) : ((_Utils_cmp(value, maxValue) > 0) ? $elm$core$Result$Err(
			fieldName + (' can\'t be greater than ' + ($elm$core$String$fromInt(maxValue) + '.'))) : $elm$core$Result$Ok(value));
	});
var $author$project$Login$Ransomware$Update$revenueValidator = A3($author$project$Model$Validators$inRangeInclusiveInt, 'revenue', 0, 2000000000);
var $author$project$Login$Ransomware$Update$allRequiredQuestionsAnswered = function (model) {
	var revenue = A2($author$project$Model$ValidationNext$validate, $author$project$Login$Ransomware$Update$revenueValidator, model.bG);
	return $author$project$Model$ValidationNext$isValid(revenue) && $elm_community$maybe_extra$Maybe$Extra$isJust(model.D);
};
var $author$project$Login$Ransomware$Model$RansomwareCalculationComplete = function (a) {
	return {$: 12, a: a};
};
var $author$project$Login$Ransomware$Update$getRansomwareCalculationsCmd = function (rootQuery) {
	return A2($author$project$ApiRequest$publicQuery, $author$project$Login$Ransomware$Model$RansomwareCalculationComplete, rootQuery);
};
var $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent = {$: 1};
var $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present = function (a) {
	return {$: 0, a: a};
};
var $author$project$Login$Ransomware$Update$floatToOptionalArg = function (input) {
	if (!input.$) {
		var _float = input.a;
		return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(_float / 100);
	} else {
		return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
	}
};
var $elm$json$Json$Encode$float = _Json_wrap;
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$float = function (value) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(
		$elm$json$Json$Encode$float(value));
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$int = function (value) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(
		$elm$json$Json$Encode$int(value));
};
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$null = $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json($elm$json$Json$Encode$null);
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional = F3(
	function (fieldName, maybeValue, toValue) {
		switch (maybeValue.$) {
			case 0:
				var value = maybeValue.a;
				return $elm$core$Maybe$Just(
					A2(
						$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument,
						fieldName,
						toValue(value)));
			case 1:
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Just(
					A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument, fieldName, $dillonkearns$elm_graphql$Graphql$Internal$Encode$null));
		}
	});
var $author$project$PublicApi$Query$ransomwareCalculation = F3(
	function (fillInOptionals____, requiredArgs____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{lb: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, lz: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, lV: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, l4: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, nG: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'breachResponseCents', filledInOptionals____.lb, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'cogs', filledInOptionals____.lz, $dillonkearns$elm_graphql$Graphql$Internal$Encode$float),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'dataRecoveryCents', filledInOptionals____.lV, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'digitalExposure', filledInOptionals____.l4, $dillonkearns$elm_graphql$Graphql$Internal$Encode$float),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'ransomPaymentCents', filledInOptionals____.nG, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'ransomwareCalculation',
			_Utils_ap(
				optionalArgs____,
				_List_fromArray(
					[
						A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'natureOfBusiness', requiredArgs____.D, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
						A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'revenueCents', requiredArgs____.nP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)
					])),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Page$Ransomware$Model$RansomwareInfo = function (annualExposureCents) {
	return function (breachResponseCents) {
		return function (cogs) {
			return function (costFifteenDaysCents) {
				return function (costOneDayCents) {
					return function (costSixtyDaysCents) {
						return function (costThirtyDaysCents) {
							return function (dataRecoveryCents) {
								return function (digitalExposure) {
									return function (ransomPaymentCents) {
										return function (revenueCents) {
											return {kY: annualExposureCents, lb: breachResponseCents, lz: cogs, lG: costFifteenDaysCents, lH: costOneDayCents, lI: costSixtyDaysCents, lJ: costThirtyDaysCents, lV: dataRecoveryCents, l4: digitalExposure, nG: ransomPaymentCents, nP: revenueCents};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$PublicApi$Object$Ransomware$annualExposureCents = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'annualExposureCents', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$PublicApi$Object$Ransomware$breachResponseCents = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'breachResponseCents', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$PublicApi$Object$Ransomware$cogs = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'cogs', _List_Nil, $elm$json$Json$Decode$float);
var $author$project$PublicApi$Object$Ransomware$costFifteenDaysCents = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'costFifteenDaysCents', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$PublicApi$Object$Ransomware$costOneDayCents = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'costOneDayCents', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$PublicApi$Object$Ransomware$costSixtyDaysCents = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'costSixtyDaysCents', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$PublicApi$Object$Ransomware$costThirtyDaysCents = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'costThirtyDaysCents', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$PublicApi$Object$Ransomware$dataRecoveryCents = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'dataRecoveryCents', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$PublicApi$Object$Ransomware$digitalExposure = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'digitalExposure', _List_Nil, $elm$json$Json$Decode$float);
var $author$project$PublicApi$Object$Ransomware$ransomPaymentCents = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'ransomPaymentCents', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$PublicApi$Object$Ransomware$revenueCents = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'revenueCents', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$ApiRequest$SelectionSet$Ransomware$ransomwareSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$PublicApi$Object$Ransomware$revenueCents,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$PublicApi$Object$Ransomware$ransomPaymentCents,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$PublicApi$Object$Ransomware$digitalExposure,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$PublicApi$Object$Ransomware$dataRecoveryCents,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$PublicApi$Object$Ransomware$costThirtyDaysCents,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$PublicApi$Object$Ransomware$costSixtyDaysCents,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$PublicApi$Object$Ransomware$costOneDayCents,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$PublicApi$Object$Ransomware$costFifteenDaysCents,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$PublicApi$Object$Ransomware$cogs,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$PublicApi$Object$Ransomware$breachResponseCents,
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$PublicApi$Object$Ransomware$annualExposureCents,
											$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Page$Ransomware$Model$RansomwareInfo))))))))))));
var $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe = function (maybeValue) {
	if (!maybeValue.$) {
		var value = maybeValue.a;
		return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(value);
	} else {
		return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
	}
};
var $author$project$Login$Ransomware$Update$toOptionalArg = function (input) {
	return $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(
		A2(
			$elm$core$Maybe$map,
			function (_int) {
				return _int * 100;
			},
			$elm$core$String$toInt(input)));
};
var $author$project$Login$Ransomware$Update$ransomwareCalculationQuery = F3(
	function (model, revenue, nature) {
		var requiredArgs = {D: nature, nP: revenue * 100};
		var optionalArgs = function (_v0) {
			return {
				lb: $author$project$Login$Ransomware$Update$toOptionalArg(model.xw),
				lz: $author$project$Login$Ransomware$Update$floatToOptionalArg(model.x2),
				lV: $author$project$Login$Ransomware$Update$toOptionalArg(model.yg),
				l4: $author$project$Login$Ransomware$Update$floatToOptionalArg(model.yr),
				nG: $author$project$Login$Ransomware$Update$toOptionalArg(model.AQ)
			};
		};
		return A3($author$project$PublicApi$Query$ransomwareCalculation, optionalArgs, requiredArgs, $author$project$ApiRequest$SelectionSet$Ransomware$ransomwareSelectionSet);
	});
var $author$project$Login$Ransomware$Update$getCalculationCmd = function (model) {
	var revenue = $author$project$Model$ValidationNext$extract(model.bG);
	return $author$project$Login$Ransomware$Update$allRequiredQuestionsAnswered(model) ? $author$project$Login$Ransomware$Update$getRansomwareCalculationsCmd(
		A3(
			$author$project$Login$Ransomware$Update$ransomwareCalculationQuery,
			model,
			revenue,
			A2($elm$core$Maybe$withDefault, '', model.D))) : $elm$core$Platform$Cmd$none;
};
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Login$Ransomware$Model$SendNonBrokerEmailComplete = function (a) {
	return {$: 14, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject = function (maybeValues) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Object(
		A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var key = _v0.a;
				var value = _v0.b;
				return A2(
					$elm$core$Maybe$andThen,
					function (actualValue) {
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(key, actualValue));
					},
					value);
			},
			maybeValues));
};
var $author$project$PublicApi$InputObject$encodeRansomwareMinimalInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'natureOfBusiness',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.D))),
				_Utils_Tuple2(
				'revenue',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$int(input____.IF)))
			]));
};
var $author$project$PublicApi$Mutation$sendNonAuthRansomwareEmail = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'Bool',
		'sendNonAuthRansomwareEmail',
		_List_fromArray(
			[
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'clientName', requiredArgs____.ft, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'email', requiredArgs____.aW, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'isTrvRequest', requiredArgs____.FV, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool),
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'ransomwareInput', requiredArgs____.Ij, $author$project$PublicApi$InputObject$encodeRansomwareMinimalInput)
			]),
		$elm$json$Json$Decode$bool);
};
var $author$project$Login$Ransomware$Update$sendNonBrokerEmailCompleteCmd = F5(
	function (clientName, email, revenueCents, natureOfBusiness, isTravelersRequestUrl) {
		var requiredArgs = {
			ft: clientName,
			aW: email,
			FV: isTravelersRequestUrl,
			Ij: {
				D: A2($elm$core$Maybe$withDefault, '', natureOfBusiness),
				IF: (revenueCents / 100) | 0
			}
		};
		return A2(
			$author$project$ApiRequest$publicMutation,
			$author$project$Login$Ransomware$Model$SendNonBrokerEmailComplete,
			$author$project$PublicApi$Mutation$sendNonAuthRansomwareEmail(requiredArgs));
	});
var $elm$core$String$trim = _String_trim;
var $author$project$Model$Validators$validateTrimmedString = F2(
	function (originalString, validationFunc) {
		var trimmedString = $elm$core$String$trim(originalString);
		var validatedString = validationFunc(trimmedString);
		if (!validatedString.$) {
			return $elm$core$Result$Ok(originalString);
		} else {
			var errorMsg = validatedString.a;
			return $elm$core$Result$Err(errorMsg);
		}
	});
var $author$project$Model$Validators$validateClientName = function (clientName) {
	return A2(
		$author$project$Model$Validators$validateTrimmedString,
		clientName,
		A3($author$project$Model$Validators$lengthBetween, 'Client name', 2, 200));
};
var $author$project$Login$Ransomware$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var dollarString = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{xw: dollarString, Bx: $krisajenkins$remotedata$RemoteData$NotAsked}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var string = msg.a;
				var model_ = function () {
					var _v1 = $elm$core$String$toFloat(string);
					if (!_v1.$) {
						var _float = _v1.a;
						return _Utils_update(
							model,
							{
								x2: $elm$core$Maybe$Just(_float),
								Bx: $krisajenkins$remotedata$RemoteData$NotAsked
							});
					} else {
						return model;
					}
				}();
				return _Utils_Tuple2(model_, $elm$core$Platform$Cmd$none);
			case 1:
				var name = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ft: $author$project$Model$ValidationNext$Unvalidated(name)
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ft: A2($author$project$Model$ValidationNext$validate, $author$project$Model$Validators$validateClientName, model.ft),
							Bx: $krisajenkins$remotedata$RemoteData$NotAsked
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var dollarString = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{yg: dollarString, Bx: $krisajenkins$remotedata$RemoteData$NotAsked}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var string = msg.a;
				var model_ = function () {
					var _v2 = $elm$core$String$toFloat(string);
					if (!_v2.$) {
						var _float = _v2.a;
						return _Utils_update(
							model,
							{
								yr: $elm$core$Maybe$Just(_float),
								Bx: $krisajenkins$remotedata$RemoteData$NotAsked
							});
					} else {
						return model;
					}
				}();
				return _Utils_Tuple2(model_, $elm$core$Platform$Cmd$none);
			case 6:
				var string = msg.a;
				var emailInput = $author$project$Data$Email$initial(string);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aW: $author$project$Model$ValidationNext$Unvalidated(emailInput)
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				return _Utils_Tuple2(
					model,
					$author$project$Login$Ransomware$Update$getCalculationCmd(model));
			case 8:
				var revenueString = msg.a;
				var revenue = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(revenueString));
				var validatedRevenue = A2(
					$author$project$Model$ValidationNext$validate,
					$author$project$Login$Ransomware$Update$revenueValidator,
					$author$project$Model$ValidationNext$Unvalidated(revenue));
				var ransomware = function () {
					switch (validatedRevenue.$) {
						case 2:
							return $elm$core$Maybe$Nothing;
						case 1:
							return model.AS;
						default:
							return model.AS;
					}
				}();
				var validated = _Utils_update(
					model,
					{bG: validatedRevenue, AS: ransomware, Bx: $krisajenkins$remotedata$RemoteData$NotAsked});
				var cmd = function () {
					var _v3 = _Utils_Tuple2(model.bG, validatedRevenue);
					if ((_v3.a.$ === 2) && (_v3.b.$ === 1)) {
						var _v4 = _v3.a;
						return $author$project$Login$Ransomware$Update$getCalculationCmd(validated);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple2(validated, cmd);
			case 9:
				var nob = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							D: $elm$core$Maybe$Just(nob),
							Bx: $krisajenkins$remotedata$RemoteData$NotAsked
						}),
					$author$project$Login$Ransomware$Update$getCalculationCmd(model));
			case 10:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 11:
				var dollarString = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{AQ: dollarString, Bx: $krisajenkins$remotedata$RemoteData$NotAsked}),
					$elm$core$Platform$Cmd$none);
			case 12:
				if (msg.a.$ === 3) {
					var data = msg.a.a;
					var newModel = _Utils_update(
						model,
						{
							xw: $author$project$Login$Ransomware$View$centsToString(data.lb),
							x2: $elm$core$Maybe$Just(data.lz * 100),
							yg: $author$project$Login$Ransomware$View$centsToString(data.lV),
							yr: $elm$core$Maybe$Just(data.l4 * 100),
							AQ: $author$project$Login$Ransomware$View$centsToString(data.nG),
							AS: $elm$core$Maybe$Just(data)
						});
					return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 13:
				var validated = _Utils_update(
					model,
					{
						aW: A2($author$project$Model$ValidationNext$validate, $author$project$Model$Validators$validateEmail, model.aW)
					});
				var validNatureOfBusiness = A2(
					$elm$core$List$member,
					A2($elm$core$Maybe$withDefault, '', model.D),
					$author$project$Model$NatureOfBusiness$cyber);
				var _v6 = _Utils_Tuple3(validated.ft, model.AS, validated.aW);
				if (((_v6.a.$ === 1) && (!_v6.b.$)) && (_v6.c.$ === 1)) {
					var clientName = _v6.a.a;
					var ransomware = _v6.b.a;
					var email = _v6.c.a;
					return validNatureOfBusiness ? _Utils_Tuple2(
						_Utils_update(
							validated,
							{By: $krisajenkins$remotedata$RemoteData$Loading}),
						A5(
							$author$project$Login$Ransomware$Update$sendNonBrokerEmailCompleteCmd,
							clientName,
							$author$project$Data$Email$toString(email),
							ransomware.nP,
							model.D,
							model.zm)) : _Utils_Tuple2(validated, $elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(validated, $elm$core$Platform$Cmd$none);
				}
			default:
				var data = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{By: data}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Login$MfaSetup$DownloadApp = function (a) {
	return {$: 1, a: a};
};
var $author$project$Login$UserTracking$Events$ForgotYourPasswordLinkClicked = {$: 5};
var $author$project$Login$SigninV2$Model$GetAuthorizeUrl = function (a) {
	return {$: 4, a: a};
};
var $author$project$Login$MfaSetup$LocateQRCode = function (a) {
	return {$: 2, a: a};
};
var $author$project$Login$SigninV2$Model$MfaInputFlow = function (a) {
	return {$: 0, a: a};
};
var $author$project$Login$UserTracking$Events$MfaLoginNeedHelpLinkClicked = {$: 2};
var $author$project$Login$SigninV2$Model$MfaSetupFlow = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Login$UserTracking$Events$MfaSetupInvalidMfaCodeSubmission = function (a) {
	return {$: 0, a: a};
};
var $author$project$Login$UserTracking$Events$MfaSetupNeedHelpLinkClicked = function (a) {
	return {$: 1, a: a};
};
var $author$project$Login$UserTracking$Events$MfaSetupNextStepClicked = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Login$UserTracking$Events$MfaSetupPreviousStepClicked = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Login$UserTracking$Events$MfaSetupSignInAfterValidMfaCodeEntered = function (a) {
	return {$: 4, a: a};
};
var $author$project$Login$MfaSetup$ModalClosed = 1;
var $author$project$Login$MfaSetup$ModalOpen = 0;
var $author$project$Login$MfaSetup$RequiredMfaSetup = {$: 0};
var $author$project$Login$SigninV2$Model$ResetPasswordCompleted = function (a) {
	return {$: 21, a: a};
};
var $author$project$Login$MfaSetup$ScanQRCode = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Login$UserTracking$Events$SignIn = 0;
var $author$project$Login$UserTracking$Events$SignInButtonClicked = {$: 4};
var $author$project$Login$SigninV2$Model$SigninRequestCompleted = function (a) {
	return {$: 11, a: a};
};
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $author$project$Translate$extract = function (_v0) {
	var translated = _v0;
	return translated;
};
var $author$project$Translate$extractTemp = $author$project$Translate$extract;
var $author$project$Translate$Translate = $elm$core$Basics$identity;
var $author$project$Translation$translations = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('en_US', 'en_US'),
			_Utils_Tuple2('Welcome to the Corvus CrowBar', 'Welcome to the Corvus CrowBar'),
			_Utils_Tuple2('My Broker Team', 'My Broker Team'),
			_Utils_Tuple2('Loss Run Export', 'Loss Run Export'),
			_Utils_Tuple2('Generate Report', 'Generate Report'),
			_Utils_Tuple2('Search for Claims', 'Search for Claims'),
			_Utils_Tuple2('Could not retrieve claim.', 'Could not retrieve claim.'),
			_Utils_Tuple2('Claim At a Glance', 'Claim At a Glance'),
			_Utils_Tuple2('Policy At a Glance', 'Policy At a Glance'),
			_Utils_Tuple2('Claim Payments', 'Claim Payments'),
			_Utils_Tuple2('Corvus Claims Advocate', 'Corvus Claims Advocate'),
			_Utils_Tuple2('Claim Number:', 'Claim Number:'),
			_Utils_Tuple2('First Notice of Loss', 'First Notice of Loss'),
			_Utils_Tuple2('Date of Loss', 'Date of Loss'),
			_Utils_Tuple2('Cause of Loss', 'Cause of Loss'),
			_Utils_Tuple2('Reserve', 'Reserve'),
			_Utils_Tuple2('Paid to Date', 'Paid to Date'),
			_Utils_Tuple2('Closed Date', 'Closed Date'),
			_Utils_Tuple2('Policy Number', 'Policy Number'),
			_Utils_Tuple2('Policy Start Date', 'Policy Start Date'),
			_Utils_Tuple2('Policy End Date', 'Policy End Date'),
			_Utils_Tuple2('Edit', 'Edit'),
			_Utils_Tuple2('There are currently no payments for this claim.', 'There are currently no payments for this claim.'),
			_Utils_Tuple2('Payee', 'Payee'),
			_Utils_Tuple2('Amount', 'Amount'),
			_Utils_Tuple2('Payment Date', 'Payment Date'),
			_Utils_Tuple2('Added On', 'Added On'),
			_Utils_Tuple2('Total Payments:', 'Total Payments:'),
			_Utils_Tuple2('Your Corvus Claims Adjuster', 'Your Corvus Claims Adjuster'),
			_Utils_Tuple2('Your Corvus Claims Advocate', 'Your Corvus Claims Advocate'),
			_Utils_Tuple2('Unavailable', 'Unavailable'),
			_Utils_Tuple2('Search', 'Search'),
			_Utils_Tuple2('Smart Commercial Insurance', 'Smart Commercial Insurance'),
			_Utils_Tuple2('Signing in…', 'Signing in…'),
			_Utils_Tuple2('Who is Corvus?', 'Who is Corvus?'),
			_Utils_Tuple2('Forgot Your Password?', 'Forgot Your Password?'),
			_Utils_Tuple2('Forgot your password?', 'Forgot your password?'),
			_Utils_Tuple2('Sign in to manage your insurance with Corvus.', 'Sign in to manage your insurance with Corvus.'),
			_Utils_Tuple2('<a--1>Reset your Password</a--1> if you forgot it.', '<a--1>Reset your Password</a--1> if you forgot it.'),
			_Utils_Tuple2('Or, we can send a secure, single-use link to your email address so that you can log in without a password.', 'Or, we can send a secure, single-use link to your email address so that you can log in without a password.'),
			_Utils_Tuple2('Sign in with a link', 'Sign in with a link'),
			_Utils_Tuple2('Sign in', 'Sign in'),
			_Utils_Tuple2('Signed in', 'Signed in'),
			_Utils_Tuple2('Incorrect Email or Password.', 'Incorrect Email or Password.'),
			_Utils_Tuple2('There is an issue with your account. Please reach out to us at', 'There is an issue with your account. Please reach out to us at'),
			_Utils_Tuple2('\n            Please set up Multi Factor Authentication to continue.\n            If you have trouble scanning the code, you may enter the URL below the code into your authenticator application.\n            ', '\n            Please set up Multi Factor Authentication to continue.\n            If you have trouble scanning the code, you may enter the URL below the code into your authenticator application.\n            '),
			_Utils_Tuple2('\n            You can scan the QR code on the right using any authenticator app you already have on your phone.\n            If you do not have an authenticator app, you can download them from the app store.\n            ', '\n            You can scan the QR code on the right using any authenticator app you already have on your phone.\n            If you do not have an authenticator app, you can download them from the app store.\n            '),
			_Utils_Tuple2('Error while encoding to QRCode.', 'Error while encoding to QRCode.'),
			_Utils_Tuple2('Multifactor Authentication Setup', 'Multifactor Authentication Setup'),
			_Utils_Tuple2('We recommend:', 'We recommend:'),
			_Utils_Tuple2('Once you scan the QR code, it will reveal a six digit code. Enter the digits in the space below.', 'Once you scan the QR code, it will reveal a six digit code. Enter the digits in the space below.'),
			_Utils_Tuple2('Once you scan the QR code, it will reveal a 6-digit code.', 'Once you scan the QR code, it will reveal a 6-digit code.'),
			_Utils_Tuple2('6-Digit Code', '6-Digit Code'),
			_Utils_Tuple2('Enter the digits in the space below.', 'Enter the digits in the space below.'),
			_Utils_Tuple2('Verification failed. Please check the 6-digit code and try again.', 'Verification failed. Please check the 6-digit code and try again.'),
			_Utils_Tuple2('Enter the verification code generated by your Multi Factor Authentication application.', 'Enter the verification code generated by your Multi Factor Authentication application.'),
			_Utils_Tuple2('Need Help?', 'Need Help?'),
			_Utils_Tuple2('Need help?', 'Need help?'),
			_Utils_Tuple2('Code', 'Code'),
			_Utils_Tuple2('Verifying Code…', 'Verifying Code…'),
			_Utils_Tuple2('Verify Code', 'Verify Code'),
			_Utils_Tuple2('Additional Security', 'Additional Security'),
			_Utils_Tuple2('We strongly recommend that you add an additional security factor for your account. Multi-factor authentication (MFA) is a proven way to protect your data.', 'We strongly recommend that you add an additional security factor for your account. Multi-factor authentication (MFA) is a proven way to protect your data.'),
			_Utils_Tuple2('MFA', 'MFA'),
			_Utils_Tuple2('Actions for MFA', 'Actions for MFA'),
			_Utils_Tuple2('Let\'s set up MFA!', 'Let\'s set up MFA!'),
			_Utils_Tuple2('I\'ll do it another time', 'I\'ll do it another time'),
			_Utils_Tuple2('Ok, we\'ll remind you another time you sign in.', 'Ok, we\'ll remind you another time you sign in.'),
			_Utils_Tuple2('Continue', 'Continue'),
			_Utils_Tuple2('Something went wrong, please try again.', 'Something went wrong, please try again.'),
			_Utils_Tuple2('Invalid multi-factor authentication (MFA) token.', 'Invalid multi-factor authentication (MFA) token.'),
			_Utils_Tuple2('Email Address', 'Email Address'),
			_Utils_Tuple2('Name', 'Name'),
			_Utils_Tuple2('Password', 'Password'),
			_Utils_Tuple2('Confirm Password', 'Confirm Password'),
			_Utils_Tuple2('Resetting…', 'Resetting…'),
			_Utils_Tuple2('Reset Password', 'Reset Password'),
			_Utils_Tuple2('Reset password', 'Reset password'),
			_Utils_Tuple2('Reset your Password', 'Reset your Password'),
			_Utils_Tuple2('Couldn\'t find anyone using that email address.', 'Couldn\'t find anyone using that email address.'),
			_Utils_Tuple2('Success, check your email for a link to reset your password.', 'Success, check your email for a link to reset your password.'),
			_Utils_Tuple2('Success: Please check your email for a link to reset your password.', 'Success: Please check your email for a link to reset your password.'),
			_Utils_Tuple2('Go Back', 'Go Back'),
			_Utils_Tuple2('Enter your email below to receive a link to reset your password.', 'Enter your email below to receive a link to reset your password.'),
			_Utils_Tuple2('Sign in with your password', 'Sign in with your password'),
			_Utils_Tuple2('I was on this page when I ran into a problem: %{path}', 'I was on this page when I ran into a problem: %{path}'),
			_Utils_Tuple2('My userId is: %{userId}', 'My userId is: %{userId}'),
			_Utils_Tuple2('I\'m having some trouble on The CrowBar', 'I\'m having some trouble on The CrowBar'),
			_Utils_Tuple2('I was expecting…', 'I was expecting…'),
			_Utils_Tuple2('Your password must be at least 8 characters.', 'Your password must be at least 8 characters.'),
			_Utils_Tuple2('Create your password', 'Create your password'),
			_Utils_Tuple2('We\'re glad you\'re here.', 'We\'re glad you\'re here.'),
			_Utils_Tuple2('We look forward to working with you!', 'We look forward to working with you!'),
			_Utils_Tuple2('By creating your password, you\'ll have instant access to the cyber Risk Dashboard (for policyholders) or the Crowbar quoting platform (for brokers).', 'By creating your password, you\'ll have instant access to the cyber Risk Dashboard (for policyholders) or the Crowbar quoting platform (for brokers).'),
			_Utils_Tuple2('Complete your account', 'Complete your account'),
			_Utils_Tuple2('Password must be at least 20 characters.', 'Password must be at least 20 characters.'),
			_Utils_Tuple2('Failed to set your password, please try again.', 'Failed to set your password, please try again.'),
			_Utils_Tuple2('Passwords do not match.', 'Passwords do not match.'),
			_Utils_Tuple2('An email filtering solution', 'An email filtering solution'),
			_Utils_Tuple2('<anchor>An email filtering solution</anchor> with advanced security features enabled (e.g., URL Sandboxing, Blocking macro enabled Microsoft documents, Blocking executable file attachment extensions)', '<anchor>An email filtering solution</anchor> with advanced security features enabled (e.g., URL Sandboxing, Blocking macro enabled Microsoft documents, Blocking executable file attachment extensions)'),
			_Utils_Tuple2('<anchor>Data encryption practices</anchor> — at rest, in transit, on mobile devices and backups (if PII > 1M)', '<anchor>Data encryption practices</anchor> — at rest, in transit, on mobile devices and backups (if PII > 1M)'),
			_Utils_Tuple2('<anchor>Endpoint Detection and Response (EDR)</anchor> or Next-Generation Antivirus (NGAV) with third-party monitoring', '<anchor>Endpoint Detection and Response (EDR)</anchor> or Next-Generation Antivirus (NGAV) with third-party monitoring'),
			_Utils_Tuple2('<anchor>Endpoint Detection and Response (EDR)</anchor>', '<anchor>Endpoint Detection and Response (EDR)</anchor>'),
			_Utils_Tuple2('Endpoint Protection (EPP)', 'Endpoint Protection (EPP)'),
			_Utils_Tuple2('Least privileged access to PII/PHI (if PII > 1M)', 'Least privileged access to PII/PHI (if PII > 1M)'),
			_Utils_Tuple2('Privileged Account Management', 'Privileged Account Management'),
			_Utils_Tuple2('Privileged Accounts & Data Security', 'Privileged Accounts & Data Security'),
			_Utils_Tuple2('Actions for Privileged Accounts & Data Security', 'Actions for Privileged Accounts & Data Security'),
			_Utils_Tuple2('<anchor>MFA</anchor> for admin accounts', '<anchor>MFA</anchor> for admin accounts'),
			_Utils_Tuple2('<anchor>MFA</anchor> for administrative access', '<anchor>MFA</anchor> for administrative access'),
			_Utils_Tuple2('<anchor>MFA for backup access</anchor>', '<anchor>MFA for backup access</anchor>'),
			_Utils_Tuple2('<anchor>MFA for email access</anchor>', '<anchor>MFA for email access</anchor>'),
			_Utils_Tuple2('Multi-Factor Authentication (MFA) for email, <anchor>remote system access</anchor>', 'Multi-Factor Authentication (MFA) for email, <anchor>remote system access</anchor>'),
			_Utils_Tuple2('Multi-Factor Authentication (MFA) for <anchor>remote access</anchor>', 'Multi-Factor Authentication (MFA) for <anchor>remote access</anchor>'),
			_Utils_Tuple2('<anchor>Out of Band Authentication (OOBA)</anchor> prior to making payments or transferring funds. (Out of Band Authentication is a secondary verification method with the requester of a funds transfer through a communication channel separate from the original request.)', '<anchor>Out of Band Authentication (OOBA)</anchor> prior to making payments or transferring funds. (Out of Band Authentication is a secondary verification method with the requester of a funds transfer through a communication channel separate from the original request.)'),
			_Utils_Tuple2('<anchor>Out of Band Authentication (OOBA)</anchor> prior to making payments or transferring funds', '<anchor>Out of Band Authentication (OOBA)</anchor> prior to making payments or transferring funds'),
			_Utils_Tuple2('<anchor>Redundant backup copies</anchor> stored in two or more locations, with one off-site (offsite includes cloud-based backups)', '<anchor>Redundant backup copies</anchor> stored in two or more locations, with one off-site (offsite includes cloud-based backups)'),
			_Utils_Tuple2('<anchor>Redundant backup copies</anchor> stored in two or more locations, with one off-site (offsite includes cloud-based backups). Backup frequency should be at least daily. Backups should be tested at least twice a year.', '<anchor>Redundant backup copies</anchor> stored in two or more locations, with one off-site (offsite includes cloud-based backups). Backup frequency should be at least daily. Backups should be tested at least twice a year.'),
			_Utils_Tuple2('<anchor>Regularly tested backups</anchor>', '<anchor>Regularly tested backups</anchor>'),
			_Utils_Tuple2('<anchor>Segregated backups</anchor>, updated regularly (at least weekly)', '<anchor>Segregated backups</anchor>, updated regularly (at least weekly)'),
			_Utils_Tuple2('Backups', 'Backups'),
			_Utils_Tuple2('Actions for Backups', 'Actions for Backups'),
			_Utils_Tuple2('\'Data Backup & Recovery\' section', '\'Data Backup & Recovery\' section'),
			_Utils_Tuple2('Data Backup & Recovery', 'Data Backup & Recovery'),
			_Utils_Tuple2('\'Email Security\' section', '\'Email Security\' section'),
			_Utils_Tuple2('Email Security', 'Email Security'),
			_Utils_Tuple2('\'Endpoint & Network Security\' section', '\'Endpoint & Network Security\' section'),
			_Utils_Tuple2('Endpoint and Network Security', 'Endpoint and Network Security'),
			_Utils_Tuple2('Endpoint Security', 'Endpoint Security'),
			_Utils_Tuple2('Actions for Endpoint Security', 'Actions for Endpoint Security'),
			_Utils_Tuple2('\'Data Encryption\' section', '\'Data Encryption\' section'),
			_Utils_Tuple2('\'Data Security\' section', '\'Data Security\' section'),
			_Utils_Tuple2('Data Security', 'Data Security'),
			_Utils_Tuple2('\'Backup Solution\' questions', '\'Backup Solution\' questions'),
			_Utils_Tuple2('Do you have a backup solution?', 'Do you have a backup solution?'),
			_Utils_Tuple2('How frequently do you back up systems and data?', 'How frequently do you back up systems and data?'),
			_Utils_Tuple2('Continuously', 'Continuously'),
			_Utils_Tuple2('Daily', 'Daily'),
			_Utils_Tuple2('Weekly', 'Weekly'),
			_Utils_Tuple2('Monthly', 'Monthly'),
			_Utils_Tuple2('Less than monthly', 'Less than monthly'),
			_Utils_Tuple2('Never', 'Never'),
			_Utils_Tuple2('\'Email Filtering\' question', '\'Email Filtering\' question'),
			_Utils_Tuple2('\'MFA for Remote Access\' question', '\'MFA for Remote Access\' question'),
			_Utils_Tuple2('Do you enforce Multi-Factor Authentication (MFA) to secure all remote access to your network?', 'Do you enforce Multi-Factor Authentication (MFA) to secure all remote access to your network?'),
			_Utils_Tuple2('\'MFA for Email Access\' question', '\'MFA for Email Access\' question'),
			_Utils_Tuple2('Do you enforce Multi-Factor Authentication (MFA) for email access via webmail portal (i.e. Gmail), mailbox applications (i.e. Outlook Application) and non-corporate devices for all employees?', 'Do you enforce Multi-Factor Authentication (MFA) for email access via webmail portal (i.e. Gmail), mailbox applications (i.e. Outlook Application) and non-corporate devices for all employees?'),
			_Utils_Tuple2('\'MFA for Admin Access\' question', '\'MFA for Admin Access\' question'),
			_Utils_Tuple2('\'Verifying the validity of funds on electronic payments\' question', '\'Verifying the validity of funds on electronic payments\' question'),
			_Utils_Tuple2('\'Prior to executing an electronic payment\' question', '\'Prior to executing an electronic payment\' question'),
			_Utils_Tuple2('Dashboard', 'Dashboard'),
			_Utils_Tuple2('Scan Results', 'Scan Results'),
			_Utils_Tuple2('Environment Overview', 'Environment Overview'),
			_Utils_Tuple2('Security Questionnaire', 'Security Questionnaire'),
			_Utils_Tuple2('Action Center', 'Action Center'),
			_Utils_Tuple2('Preferred Vendors', 'Preferred Vendors'),
			_Utils_Tuple2('Integrations', 'Integrations'),
			_Utils_Tuple2('Your Policy', 'Your Policy'),
			_Utils_Tuple2('Manage Claims', 'Manage Claims'),
			_Utils_Tuple2('Claims Resources', 'Claims Resources'),
			_Utils_Tuple2('How smart is your security? Unlock personalized security insights using our 2 questionnaires.', 'How smart is your security? Unlock personalized security insights using our 2 questionnaires.'),
			_Utils_Tuple2('Save up to 25% on your retention at policy renewal by completing 2 questionnaires.', 'Save up to 25% on your retention at policy renewal by completing 2 questionnaires.'),
			_Utils_Tuple2('Save up to 25% on your retention simply by completing 2 questionnaires.', 'Save up to 25% on your retention simply by completing 2 questionnaires.'),
			_Utils_Tuple2('You’ve earned 25% off on your retention (up to $25k) for the duration of your policy.', 'You’ve earned 25% off on your retention (up to $25k) for the duration of your policy.'),
			_Utils_Tuple2('You’ve earned 25% off on your retention (up to $25k) effective upon renewal.', 'You’ve earned 25% off on your retention (up to $25k) effective upon renewal.'),
			_Utils_Tuple2('To see your personalized security recommendations, please check out the Action Center.', 'To see your personalized security recommendations, please check out the Action Center.'),
			_Utils_Tuple2('Go to Questionnaire', 'Go to Questionnaire'),
			_Utils_Tuple2('Go to Questionnaires', 'Go to Questionnaires'),
			_Utils_Tuple2('Go To Questionnaires', 'Go To Questionnaires'),
			_Utils_Tuple2('Corvus Score (External Scan)', 'Corvus Score (External Scan)'),
			_Utils_Tuple2('Security Questionnaire (Internal Controls)', 'Security Questionnaire (Internal Controls)'),
			_Utils_Tuple2('Time to Next Scan', 'Time to Next Scan'),
			_Utils_Tuple2('Time To Renewal', 'Time To Renewal'),
			_Utils_Tuple2('Review Environment', 'Review Environment'),
			_Utils_Tuple2('Overview', 'Overview'),
			_Utils_Tuple2('Scan-Based Actionable Findings', 'Scan-Based Actionable Findings'),
			_Utils_Tuple2('Best Practice', 'Best Practice'),
			_Utils_Tuple2('Best Practices', 'Best Practices'),
			_Utils_Tuple2('No Issue', 'No Issue'),
			_Utils_Tuple2('<tag1>Please download the </tag1><tag2>Full PDF Report</tag2><tag1> for more details.</tag1>', '<tag1>Please download the </tag1><tag2>Full PDF Report</tag2><tag1> for more details.</tag1>'),
			_Utils_Tuple2('Corvus Scan Findings', 'Corvus Scan Findings'),
			_Utils_Tuple2('Download Full Report (PDF)', 'Download Full Report (PDF)'),
			_Utils_Tuple2('Findings', 'Findings'),
			_Utils_Tuple2('Scanned: %{date_string}', 'Scanned: %{date_string}'),
			_Utils_Tuple2('The Corvus Scan evaluates an organization’s cyber security risk through the use of publicly available data. Our scan technology first performs automated asset discovery that leads to a security review of your public facing systems to map your organization’s external attack surface. Scan findings and recommendations help your organization identify, manage, and prioritize cyber security risk to enhance your cyber security posture. To learn more about the scan and how it works click <tag>here</tag>.', 'The Corvus Scan evaluates an organization’s cyber security risk through the use of publicly available data. Our scan technology first performs automated asset discovery that leads to a security review of your public facing systems to map your organization’s external attack surface. Scan findings and recommendations help your organization identify, manage, and prioritize cyber security risk to enhance your cyber security posture. To learn more about the scan and how it works click <tag>here</tag>.'),
			_Utils_Tuple2('No Action Required', 'No Action Required'),
			_Utils_Tuple2('You have no actionable insights', 'You have no actionable insights'),
			_Utils_Tuple2('Open Action Center', 'Open Action Center'),
			_Utils_Tuple2('Go To Action Center', 'Go To Action Center'),
			_Utils_Tuple2('These findings are generated and updated monthly, following the Corvus Scan.', 'These findings are generated and updated monthly, following the Corvus Scan.'),
			_Utils_Tuple2('This table includes Common Vulnerabilities and Exposures (<tag>What is a CVE?</tag>). If you need additional information about the CVEs listed below, you can click each code to learn more through the National Vulnerability Database.', 'This table includes Common Vulnerabilities and Exposures (<tag>What is a CVE?</tag>). If you need additional information about the CVEs listed below, you can click each code to learn more through the National Vulnerability Database.'),
			_Utils_Tuple2('These tables include Common Vulnerabilities and Exposures (<tag>What is a CVE?</tag>). If you need additional information about the CVEs listed below, you can click each code to learn more through the National Vulnerability Database.', 'These tables include Common Vulnerabilities and Exposures (<tag>What is a CVE?</tag>). If you need additional information about the CVEs listed below, you can click each code to learn more through the National Vulnerability Database.'),
			_Utils_Tuple2('Unable to display findings. Please contact support.', 'Unable to display findings. Please contact support.'),
			_Utils_Tuple2('View less', 'View less'),
			_Utils_Tuple2('View more', 'View more'),
			_Utils_Tuple2('Could not load the page.', 'Could not load the page.'),
			_Utils_Tuple2('Company Information', 'Company Information'),
			_Utils_Tuple2('External Perimeter', 'External Perimeter'),
			_Utils_Tuple2('Request Additional Information', 'Request Additional Information'),
			_Utils_Tuple2('Last Scanned:', 'Last Scanned:'),
			_Utils_Tuple2('Action', 'Action'),
			_Utils_Tuple2('Dispute', 'Dispute'),
			_Utils_Tuple2('Dispute Details', 'Dispute Details'),
			_Utils_Tuple2('Reason for dispute:', 'Reason for dispute:'),
			_Utils_Tuple2('Your External Perimeter is composed of domains, subdomains, IP addresses, and external services that the Corvus Scan derived from your organization\'s primary domain provided during the underwriting application process. We recommend that you review the assets identified on this page to ensure we are getting an accurate picture of your environment. Use the dispute buttons to raise any issues with what the scan has detected.', 'Your External Perimeter is composed of domains, subdomains, IP addresses, and external services that the Corvus Scan derived from your organization\'s primary domain provided during the underwriting application process. We recommend that you review the assets identified on this page to ensure we are getting an accurate picture of your environment. Use the dispute buttons to raise any issues with what the scan has detected.'),
			_Utils_Tuple2('Submitted', 'Submitted'),
			_Utils_Tuple2('Status', 'Status'),
			_Utils_Tuple2('Submit your request here. Include enough information so that we can quickly assist you and get you to the right team member.', 'Submit your request here. Include enough information so that we can quickly assist you and get you to the right team member.'),
			_Utils_Tuple2('Submit Request', 'Submit Request'),
			_Utils_Tuple2('Additional information request failed. If the problem persists, please contact Corvus Insurance for support at <anchor>cyberservices@travelers.com</anchor>.', 'Additional information request failed. If the problem persists, please contact Corvus Insurance for support at <anchor>cyberservices@travelers.com</anchor>.'),
			_Utils_Tuple2('Domain', 'Domain'),
			_Utils_Tuple2('Primary Domain', 'Primary Domain'),
			_Utils_Tuple2('Associated Domains', 'Associated Domains'),
			_Utils_Tuple2('Excluded Domains', 'Excluded Domains'),
			_Utils_Tuple2('Disputed', 'Disputed'),
			_Utils_Tuple2('Cancel', 'Cancel'),
			_Utils_Tuple2('Please elaborate', 'Please elaborate'),
			_Utils_Tuple2('Additional details (optional)', 'Additional details (optional)'),
			_Utils_Tuple2('Domain Dispute', 'Domain Dispute'),
			_Utils_Tuple2('Submit Dispute', 'Submit Dispute'),
			_Utils_Tuple2('Discard changes?', 'Discard changes?'),
			_Utils_Tuple2('Leaving will discard any unsaved response progress.', 'Leaving will discard any unsaved response progress.'),
			_Utils_Tuple2('Discard changes', 'Discard changes'),
			_Utils_Tuple2('Continue editing', 'Continue editing'),
			_Utils_Tuple2('Not yet', 'Not yet'),
			_Utils_Tuple2('We\'re working on this', 'We\'re working on this'),
			_Utils_Tuple2('You responded: Working on it', 'You responded: Working on it'),
			_Utils_Tuple2('This isn\'t relevant to our environment', 'This isn\'t relevant to our environment'),
			_Utils_Tuple2('You responded: Not relevant', 'You responded: Not relevant'),
			_Utils_Tuple2('We\'d like to discuss this with Corvus', 'We\'d like to discuss this with Corvus'),
			_Utils_Tuple2('You responded: Want to discuss', 'You responded: Want to discuss'),
			_Utils_Tuple2('Yes, we\'ve remediated this', 'Yes, we\'ve remediated this'),
			_Utils_Tuple2('You responded: Remediated', 'You responded: Remediated'),
			_Utils_Tuple2('From: Ransomware Assessment', 'From: Ransomware Assessment'),
			_Utils_Tuple2('From: Security Advanced Questionnaire', 'From: Security Advanced Questionnaire'),
			_Utils_Tuple2('From: Corvus Scan', 'From: Corvus Scan'),
			_Utils_Tuple2('All', 'All'),
			_Utils_Tuple2('https://help.corvusinsurance.com/common-vulnerabilities-and-exposures', 'https://help.corvusinsurance.com/common-vulnerabilities-and-exposures'),
			_Utils_Tuple2('Baseline security controls to protect your organization.', 'Baseline security controls to protect your organization.'),
			_Utils_Tuple2('Go To Questionnaire', 'Go To Questionnaire'),
			_Utils_Tuple2('Complete', 'Complete'),
			_Utils_Tuple2('Incomplete', 'Incomplete'),
			_Utils_Tuple2('Ransomware Assessment', 'Ransomware Assessment'),
			_Utils_Tuple2('These questions relate to the most effective controls in preventing and mitigating ransomware attacks. As you continue your security journey, be sure to come back and update this module.', 'These questions relate to the most effective controls in preventing and mitigating ransomware attacks. As you continue your security journey, be sure to come back and update this module.'),
			_Utils_Tuple2('The Security Questionnaires give you the ability to assess your internal cyber security program against industry-leading cybersecurity frameworks. Once a module is complete, you will receive a tailored list of recommendations through the Action Center.', 'The Security Questionnaires give you the ability to assess your internal cyber security program against industry-leading cybersecurity frameworks. Once a module is complete, you will receive a tailored list of recommendations through the Action Center.'),
			_Utils_Tuple2('The security questionnaire modules are provided for guidance purposes only and are not part of the renewal underwriting process. Eligibility for policy renewal is determined when you apply for coverage. Policy quotes, terms and conditions, discounts, and premiums are based on your renewal submission and made in accordance with our underwriting guidelines. The policy, not general descriptions or material within these modules, will form the contract between the insured and our insurance carrier partners. Coverage may not be available in all jurisdictions.', 'The security questionnaire modules are provided for guidance purposes only and are not part of the renewal underwriting process. Eligibility for policy renewal is determined when you apply for coverage. Policy quotes, terms and conditions, discounts, and premiums are based on your renewal submission and made in accordance with our underwriting guidelines. The policy, not general descriptions or material within these modules, will form the contract between the insured and our insurance carrier partners. Coverage may not be available in all jurisdictions.'),
			_Utils_Tuple2('Unable to load Security Questionnaire Portal. Please try again.', 'Unable to load Security Questionnaire Portal. Please try again.'),
			_Utils_Tuple2('IP Address', 'IP Address'),
			_Utils_Tuple2('Software', 'Software'),
			_Utils_Tuple2('Unknown', 'Unknown'),
			_Utils_Tuple2('# of Critical Vulns', '# of Critical Vulns'),
			_Utils_Tuple2('# of High Vulns', '# of High Vulns'),
			_Utils_Tuple2('CVEs', 'CVEs'),
			_Utils_Tuple2('External link providing more information about this CVE', 'External link providing more information about this CVE'),
			_Utils_Tuple2('Hi %{name}', 'Hi %{name}'),
			_Utils_Tuple2('Your Corvus CrowBar account has been created. Please activate your account by choosing a password.', 'Your Corvus CrowBar account has been created. Please activate your account by choosing a password.'),
			_Utils_Tuple2('Activate Your Account', 'Activate Your Account'),
			_Utils_Tuple2('Learn more about Corvus and the CrowBar on %{link}.', 'Learn more about Corvus and the CrowBar on %{link}.'),
			_Utils_Tuple2('Activate Your Account at %{reset_url}.', 'Activate Your Account at %{reset_url}.'),
			_Utils_Tuple2('Learn more about Corvus and the CrowBar on our website', 'Learn more about Corvus and the CrowBar on our website'),
			_Utils_Tuple2('If you did not request this change, you may ignore this email.', 'If you did not request this change, you may ignore this email.'),
			_Utils_Tuple2('Reset Corvus Password', 'Reset Corvus Password'),
			_Utils_Tuple2('Reset Corvus password at %{reset_url}', 'Reset Corvus password at %{reset_url}'),
			_Utils_Tuple2('We received a request to update your Corvus password.', 'We received a request to update your Corvus password.'),
			_Utils_Tuple2('- Corvus Underwriting Team', '- Corvus Underwriting Team'),
			_Utils_Tuple2('%{name} and The Corvus Team', '%{name} and The Corvus Team'),
			_Utils_Tuple2('- Corvus Risk + Response Team', '- Corvus Risk + Response Team'),
			_Utils_Tuple2('If you don\'t know why you\'re receiving this email or you didn\'t try to log in, please contact your territory manager.', 'If you don\'t know why you\'re receiving this email or you didn\'t try to log in, please contact your territory manager.'),
			_Utils_Tuple2('Or, paste the following link in your browser:', 'Or, paste the following link in your browser:'),
			_Utils_Tuple2('Sign In to the CrowBar', 'Sign In to the CrowBar'),
			_Utils_Tuple2('Sign in to the CrowBar with one click', 'Sign in to the CrowBar with one click'),
			_Utils_Tuple2('Sign in to the CrowBar at %{link}.', 'Sign in to the CrowBar at %{link}.'),
			_Utils_Tuple2('You\'re one click away from signing in. Use the link below to sign in to the CrowBar.', 'You\'re one click away from signing in. Use the link below to sign in to the CrowBar.'),
			_Utils_Tuple2('Sign in to the CrowBar', 'Sign in to the CrowBar'),
			_Utils_Tuple2('Hi %{name}!', 'Hi %{name}!'),
			_Utils_Tuple2('You\'re one click away from signing in. Click on the button below or paste the link into your browser to sign in to the CrowBar.', 'You\'re one click away from signing in. Click on the button below or paste the link into your browser to sign in to the CrowBar.'),
			_Utils_Tuple2('our website', 'our website'),
			_Utils_Tuple2('Quote Request for %{client_name} Declined', 'Quote Request for %{client_name} Declined'),
			_Utils_Tuple2('%{client_name} will need to mitigate this vulnerability outlined by the subjectivities. We will be happy to re-scan the organization and issue a binder. You do not need to re-submit the application — simply let me know that the update has been completed by phone or email.', '%{client_name} will need to mitigate this vulnerability outlined by the subjectivities. We will be happy to re-scan the organization and issue a binder. You do not need to re-submit the application — simply let me know that the update has been completed by phone or email.'),
			_Utils_Tuple2('Commission payable on this account is %{commission}.', 'Commission payable on this account is %{commission}.'),
			_Utils_Tuple2('Dear %{broker_name},', 'Dear %{broker_name},'),
			_Utils_Tuple2('I am pleased to offer the following Corvus Smart %{product_line} Insurance quote for %{client_name}.', 'I am pleased to offer the following Corvus Smart %{product_line} Insurance quote for %{client_name}.'),
			_Utils_Tuple2('Notes from Your Underwriter', 'Notes from Your Underwriter'),
			_Utils_Tuple2('Please let me know if you have any questions once you\'ve had the opportunity to review. Note that this quote is valid for thirty (30) days.', 'Please let me know if you have any questions once you\'ve had the opportunity to review. Note that this quote is valid for thirty (30) days.'),
			_Utils_Tuple2('Thanks, and I look forward to hearing from you.', 'Thanks, and I look forward to hearing from you.'),
			_Utils_Tuple2('Your Quote', 'Your Quote'),
			_Utils_Tuple2('Thank you for the submission. Unfortunately, we will need to take a pass on this opportunity.', 'Thank you for the submission. Unfortunately, we will need to take a pass on this opportunity.'),
			_Utils_Tuple2('Thank you for the submission. Unfortunately, we are unable to provide a quote at this time as this risk has already been submitted to us by another producer for the current term. Please feel free to reach out if you have any questions.', 'Thank you for the submission. Unfortunately, we are unable to provide a quote at this time as this risk has already been submitted to us by another producer for the current term. Please feel free to reach out if you have any questions.'),
			_Utils_Tuple2('Thank you for the submission. Unfortunately, we will have to take a pass on this opportunity because we are unable to compete with the insured\'s expiring premium.', 'Thank you for the submission. Unfortunately, we will have to take a pass on this opportunity because we are unable to compete with the insured\'s expiring premium.'),
			_Utils_Tuple2('Thank you for the submission. Unfortunately, we will have to take a pass on this opportunity because the insured\'s business activities fall outside the scope of our underwriting appetite.', 'Thank you for the submission. Unfortunately, we will have to take a pass on this opportunity because the insured\'s business activities fall outside the scope of our underwriting appetite.'),
			_Utils_Tuple2('Thank you for the submission. Unfortunately, we will have to take a pass on this opportunity due to the insured\'s claims history.', 'Thank you for the submission. Unfortunately, we will have to take a pass on this opportunity due to the insured\'s claims history.'),
			_Utils_Tuple2('Thank you for the submission. Unfortunately, we will have to take a pass on this opportunity due to the quality of the insured\'s cyber risk mitigation controls.', 'Thank you for the submission. Unfortunately, we will have to take a pass on this opportunity due to the quality of the insured\'s cyber risk mitigation controls.'),
			_Utils_Tuple2('Thank you for the submission. Unfortunately, we will have to take a pass on this opportunity because we are unable to offer the terms or coverage requested.', 'Thank you for the submission. Unfortunately, we will have to take a pass on this opportunity because we are unable to offer the terms or coverage requested.'),
			_Utils_Tuple2('Thank you for the submission. Unfortunately, we will have to take a pass on this opportunity because the applicant does not meet our minimum Corvus Score.', 'Thank you for the submission. Unfortunately, we will have to take a pass on this opportunity because the applicant does not meet our minimum Corvus Score.'),
			_Utils_Tuple2('The dynamic nature of the current market has led to rapidly increasing rates and higher than expected premium growth for nearly all major insurers. For the near term Corvus will not be writing standalone cyber new business accounts with more than $10MM in Gross Annual Revenue.', 'The dynamic nature of the current market has led to rapidly increasing rates and higher than expected premium growth for nearly all major insurers. For the near term Corvus will not be writing standalone cyber new business accounts with more than $10MM in Gross Annual Revenue.'),
			_Utils_Tuple2('However, we plan to re-engage with that market segment in the next 30 days. In the interim, please note that there is no disruption to our Smart Tech E&O + Cyber program or corresponding underwriting appetite, so please continue to send us your Tech E&O submissions.', 'However, we plan to re-engage with that market segment in the next 30 days. In the interim, please note that there is no disruption to our Smart Tech E&O + Cyber program or corresponding underwriting appetite, so please continue to send us your Tech E&O submissions.'),
			_Utils_Tuple2('Please let us know if you have any questions.', 'Please let us know if you have any questions.'),
			_Utils_Tuple2('Thank you for the consideration,', 'Thank you for the consideration,'),
			_Utils_Tuple2('Dear %{name},', 'Dear %{name},'),
			_Utils_Tuple2('Option %{index}', 'Option %{index}'),
			_Utils_Tuple2('Your %{product_line_name} Quote for %{client_name} is Ready!', 'Your %{product_line_name} Quote for %{client_name} is Ready!'),
			_Utils_Tuple2('Your Revised %{product_line_name} Quote for %{client_name} is Ready!', 'Your Revised %{product_line_name} Quote for %{client_name} is Ready!'),
			_Utils_Tuple2('Smart %{product_display} Documents Ready', 'Smart %{product_display} Documents Ready'),
			_Utils_Tuple2('Smart %{product_display} Documents Ready for %{client_name}', 'Smart %{product_display} Documents Ready for %{client_name}'),
			_Utils_Tuple2('Quote Request for %{client_name} needs more info', 'Quote Request for %{client_name} needs more info'),
			_Utils_Tuple2('Please see the revised %{client_name} %{product_line_name} quote.', 'Please see the revised %{client_name} %{product_line_name} quote.'),
			_Utils_Tuple2('More details on these subjectivities can be found below the option details section in the attached quote letter.', 'More details on these subjectivities can be found below the option details section in the attached quote letter.'),
			_Utils_Tuple2('Post-bind Subjectivities', 'Post-bind Subjectivities'),
			_Utils_Tuple2('Pre-bind Subjectivities', 'Pre-bind Subjectivities'),
			_Utils_Tuple2('Post-bind subjectivities are %{span_start}due within 7 days of binding coverage%{span_end}', 'Post-bind subjectivities are %{span_start}due within 7 days of binding coverage%{span_end}'),
			_Utils_Tuple2('Pre-bind subjectivities are %{span_start} due prior to binding coverage%{span_end}', 'Pre-bind subjectivities are %{span_start} due prior to binding coverage%{span_end}'),
			_Utils_Tuple2('%{productLine} not available', '%{productLine} not available'),
			_Utils_Tuple2('Loading…', 'Loading…'),
			_Utils_Tuple2('Quote', 'Quote'),
			_Utils_Tuple2('Renewal', 'Renewal'),
			_Utils_Tuple2('Submission', 'Submission'),
			_Utils_Tuple2('This is a work in progress, please be patient', 'This is a work in progress, please be patient'),
			_Utils_Tuple2('Welcome to the new Submission Experience', 'Welcome to the new Submission Experience'),
			_Utils_Tuple2('New', 'New'),
			_Utils_Tuple2('No Cyber Risk Score', 'No Cyber Risk Score'),
			_Utils_Tuple2('Unable to load your Scan Results. Please contact support.', 'Unable to load your Scan Results. Please contact support.'),
			_Utils_Tuple2('%{client_name} - Cyber Risk Scan Results', '%{client_name} - Cyber Risk Scan Results'),
			_Utils_Tuple2('Corvus Insurance', 'Corvus Insurance'),
			_Utils_Tuple2('Full Scan Report', 'Full Scan Report'),
			_Utils_Tuple2('%{client_name} - Full Scan Report', '%{client_name} - Full Scan Report'),
			_Utils_Tuple2('Primary Website', 'Primary Website'),
			_Utils_Tuple2('Smart Cyber Insurance', 'Smart Cyber Insurance'),
			_Utils_Tuple2('Renewal Date: %{date_string}', 'Renewal Date: %{date_string}'),
			_Utils_Tuple2('Scan Date: %{date_string}', 'Scan Date: %{date_string}'),
			_Utils_Tuple2('for %{client_name}', 'for %{client_name}'),
			_Utils_Tuple2('An error occurred and the domain could not be disputed. Please try again after a few seconds.', 'An error occurred and the domain could not be disputed. Please try again after a few seconds.'),
			_Utils_Tuple2('Your request is being created.', 'Your request is being created.'),
			_Utils_Tuple2('+', '+'),
			_Utils_Tuple2('No Issues', 'No Issues'),
			_Utils_Tuple2('Nothing to report here. Nice work!', 'Nothing to report here. Nice work!'),
			_Utils_Tuple2('Recommended Actions', 'Recommended Actions'),
			_Utils_Tuple2('Recommended Best Practice', 'Recommended Best Practice'),
			_Utils_Tuple2('Required Score', 'Required Score'),
			_Utils_Tuple2('Requirement Met', 'Requirement Met'),
			_Utils_Tuple2('Requirement Not Met', 'Requirement Not Met'),
			_Utils_Tuple2('Scan Summary', 'Scan Summary'),
			_Utils_Tuple2('Score Requirement', 'Score Requirement'),
			_Utils_Tuple2('The Cyber Risk Scan checked for additional items listed below, which are deemed satisfactory and do not require any action.', 'The Cyber Risk Scan checked for additional items listed below, which are deemed satisfactory and do not require any action.'),
			_Utils_Tuple2('The Cyber Risk Scan is the first part of your evaluation that determines your eligibility to bind or renew your policy. Below is a summary of the findings. %{tag}In order to bind or renew with Corvus, you’ll need to meet both the Score and Control requirements.%{tag_}', 'The Cyber Risk Scan is the first part of your evaluation that determines your eligibility to bind or renew your policy. Below is a summary of the findings. %{tag}In order to bind or renew with Corvus, you’ll need to meet both the Score and Control requirements.%{tag_}'),
			_Utils_Tuple2('Your Cyber Risk Score', 'Your Cyber Risk Score'),
			_Utils_Tuple2('Save Changes', 'Save Changes'),
			_Utils_Tuple2('View More', 'View More'),
			_Utils_Tuple2('Add User', 'Add User'),
			_Utils_Tuple2('User Id (Shortened)', 'User Id (Shortened)'),
			_Utils_Tuple2('edit', 'edit'),
			_Utils_Tuple2('Corvus\' predictive risk model has observed more instances of ransomware attacks at organizations utilizing risky software on publicly accessible systems.', 'Corvus\' predictive risk model has observed more instances of ransomware attacks at organizations utilizing risky software on publicly accessible systems.'),
			_Utils_Tuple2('Travelers\' predictive risk model has observed more instances of ransomware attacks at organizations utilizing risky software on publicly accessible systems.', 'Travelers\' predictive risk model has observed more instances of ransomware attacks at organizations utilizing risky software on publicly accessible systems.'),
			_Utils_Tuple2('Detection of Critical Severity Vulnerabilities.', 'Detection of Critical Severity Vulnerabilities.'),
			_Utils_Tuple2('Detection of High Severity Vulnerabilities.', 'Detection of High Severity Vulnerabilities.'),
			_Utils_Tuple2('Detection of Internet accessible RDP.', 'Detection of Internet accessible RDP.'),
			_Utils_Tuple2('Detection of Internet accessible SMB.', 'Detection of Internet accessible SMB.'),
			_Utils_Tuple2('Detection of On-premise Email Infrastructure.', 'Detection of On-premise Email Infrastructure.'),
			_Utils_Tuple2('Detection of Publicly Exposed Remote Access Services and Ports.', 'Detection of Publicly Exposed Remote Access Services and Ports.'),
			_Utils_Tuple2('Detection of Risky Software on Internet-Facing System(s).', 'Detection of Risky Software on Internet-Facing System(s).'),
			_Utils_Tuple2('Detection of Security Certificates Not Configured According to Best Practices.', 'Detection of Security Certificates Not Configured According to Best Practices.'),
			_Utils_Tuple2('Detection of a VPN solution.', 'Detection of a VPN solution.'),
			_Utils_Tuple2('Finding', 'Finding'),
			_Utils_Tuple2('General Remediation', 'General Remediation'),
			_Utils_Tuple2('If you\'re an existing policyholder, in-depth remediation guidance is available in the Action Center on your %{tag}dashboard%{tag_}.', 'If you\'re an existing policyholder, in-depth remediation guidance is available in the Action Center on your %{tag}dashboard%{tag_}.'),
			_Utils_Tuple2('Unable to load your Action Center.', 'Unable to load your Action Center.'),
			_Utils_Tuple2('In-depth remediation guidance and a full list of action items are available in the Action Center.', 'In-depth remediation guidance and a full list of action items are available in the Action Center.'),
			_Utils_Tuple2('Implement a Secure Email Gateway.', 'Implement a Secure Email Gateway.'),
			_Utils_Tuple2('Secure Email Gateway', 'Secure Email Gateway'),
			_Utils_Tuple2('Actions for Secure Email Gateway', 'Actions for Secure Email Gateway'),
			_Utils_Tuple2('No action required here, nice work.', 'No action required here, nice work.'),
			_Utils_Tuple2('Organizations should ensure that only services required for business functionality are publicly accessible.', 'Organizations should ensure that only services required for business functionality are publicly accessible.'),
			_Utils_Tuple2('Organizations should remove risky software from Internet-facing systems.', 'Organizations should remove risky software from Internet-facing systems.'),
			_Utils_Tuple2('Review your external facing systems and open ports to determine those that are required. Close ports and services that are not required to reduce your external attack surface.', 'Review your external facing systems and open ports to determine those that are required. Close ports and services that are not required to reduce your external attack surface.'),
			_Utils_Tuple2('Risky Software Detected', 'Risky Software Detected'),
			_Utils_Tuple2('Service Name', 'Service Name'),
			_Utils_Tuple2('The Cyber Risk Scan detected the presence of publicly accessible software on a system associated with your organization that could increase your risk of a security incident. Corvus defines risky software as legacy services that oftentimes have been deprecated. Corvus has identified that organizations with risky software on public facing systems are 2.8 times more likely to experience a security incident.', 'The Cyber Risk Scan detected the presence of publicly accessible software on a system associated with your organization that could increase your risk of a security incident. Corvus defines risky software as legacy services that oftentimes have been deprecated. Corvus has identified that organizations with risky software on public facing systems are 2.8 times more likely to experience a security incident.'),
			_Utils_Tuple2('The Cyber Risk Scan detected the presence of publicly accessible software on a system associated with your organization that could increase your risk of a security incident. Travelers defines risky software as legacy services that oftentimes have been deprecated. Travelers has identified that organizations with risky software on public facing systems are 2.8 times more likely to experience a security incident.', 'The Cyber Risk Scan detected the presence of publicly accessible software on a system associated with your organization that could increase your risk of a security incident. Travelers defines risky software as legacy services that oftentimes have been deprecated. Travelers has identified that organizations with risky software on public facing systems are 2.8 times more likely to experience a security incident.'),
			_Utils_Tuple2('The Cyber Risk Scan identified the following system(s) that had remote access ports publicly accessible to the Internet.', 'The Cyber Risk Scan identified the following system(s) that had remote access ports publicly accessible to the Internet.'),
			_Utils_Tuple2('Organizations should apply the appropriate patch to impacted software and ensure that a patch management process exists so that critical severity vulnerabilities are patched within 15 days.', 'Organizations should apply the appropriate patch to impacted software and ensure that a patch management process exists so that critical severity vulnerabilities are patched within 15 days.'),
			_Utils_Tuple2('Organizations should apply the appropriate patch to impacted software and ensure that a patch management process exists so that high severity vulnerabilities are patched within 30 days.', 'Organizations should apply the appropriate patch to impacted software and ensure that a patch management process exists so that high severity vulnerabilities are patched within 30 days.'),
			_Utils_Tuple2('The Cyber Risk Scan identified %{vuln_count} critical vulnerabilities on %{num_servers} servers associated with your organization.', 'The Cyber Risk Scan identified %{vuln_count} critical vulnerabilities on %{num_servers} servers associated with your organization.'),
			_Utils_Tuple2('The Cyber Risk Scan identified %{vuln_count} high vulnerabilities on %{num_servers} servers associated with your organization.', 'The Cyber Risk Scan identified %{vuln_count} high vulnerabilities on %{num_servers} servers associated with your organization.'),
			_Utils_Tuple2('Threat actors routinely scan the Internet for public-facing software vulnerabilities. Exploitation of those vulnerabilities provides initial access to the environment. Corvus observed ransomware threat actors leverage vulnerabilities in various external-facing software to gain access into the environment and deploy ransomware.', 'Threat actors routinely scan the Internet for public-facing software vulnerabilities. Exploitation of those vulnerabilities provides initial access to the environment. Corvus observed ransomware threat actors leverage vulnerabilities in various external-facing software to gain access into the environment and deploy ransomware.'),
			_Utils_Tuple2('Threat actors routinely scan the Internet for public-facing software vulnerabilities. Exploitation of those vulnerabilities provides initial access to the environment. Travelers observed ransomware threat actors leverage vulnerabilities in various external-facing software to gain access into the environment and deploy ransomware.', 'Threat actors routinely scan the Internet for public-facing software vulnerabilities. Exploitation of those vulnerabilities provides initial access to the environment. Travelers observed ransomware threat actors leverage vulnerabilities in various external-facing software to gain access into the environment and deploy ransomware.'),
			_Utils_Tuple2('Number of Critical Vulnerabilities', 'Number of Critical Vulnerabilities'),
			_Utils_Tuple2('Number of High Vulnerabilities', 'Number of High Vulnerabilities'),
			_Utils_Tuple2('Number of Vulnerabilities', 'Number of Vulnerabilities'),
			_Utils_Tuple2('Certificate Findings', 'Certificate Findings'),
			_Utils_Tuple2('Impacted Domain', 'Impacted Domain'),
			_Utils_Tuple2('Organizations should configure security certificates according to best practices which includes; non-expired certificates that are issued by a reputable certificate authority, secure hash algorithms (SHA-256) and a maximum certificate validity of 398 days.', 'Organizations should configure security certificates according to best practices which includes; non-expired certificates that are issued by a reputable certificate authority, secure hash algorithms (SHA-256) and a maximum certificate validity of 398 days.'),
			_Utils_Tuple2('Security Certificates ensure that communication to and from your servers is encrypted. This helps to prevent threat actors from reading or modifying information in transit.', 'Security Certificates ensure that communication to and from your servers is encrypted. This helps to prevent threat actors from reading or modifying information in transit.'),
			_Utils_Tuple2('The Cyber Risk Scan identified that the security certificate for the domain(s) listed below are not configured according to best practices:', 'The Cyber Risk Scan identified that the security certificate for the domain(s) listed below are not configured according to best practices:'),
			_Utils_Tuple2('Corvus has identified that organizations self-hosting their email or using a boutique email provider are 34% more likely to experience a security incident compared to organizations using a cloud-hosted email provider. This finding does not take into consideration version information or specific configurations.', 'Corvus has identified that organizations self-hosting their email or using a boutique email provider are 34% more likely to experience a security incident compared to organizations using a cloud-hosted email provider. This finding does not take into consideration version information or specific configurations.'),
			_Utils_Tuple2('Travelers has identified that organizations self-hosting their email or using a boutique email provider are 34% more likely to experience a security incident compared to organizations using a cloud-hosted email provider. This finding does not take into consideration version information or specific configurations.', 'Travelers has identified that organizations self-hosting their email or using a boutique email provider are 34% more likely to experience a security incident compared to organizations using a cloud-hosted email provider. This finding does not take into consideration version information or specific configurations.'),
			_Utils_Tuple2('Detected Email Provider', 'Detected Email Provider'),
			_Utils_Tuple2('Detected Email Provider Description', 'Detected Email Provider Description'),
			_Utils_Tuple2('Email Provider Category', 'Email Provider Category'),
			_Utils_Tuple2('Email Security Gateway that provides additional layers of security by filtering malicious content or spam and applying a policy to securely handle these email messages.', 'Email Security Gateway that provides additional layers of security by filtering malicious content or spam and applying a policy to securely handle these email messages.'),
			_Utils_Tuple2('Email forwarding service that consolidates multiple email domains to a single inbound email service. This does not necessarily include security features.', 'Email forwarding service that consolidates multiple email domains to a single inbound email service. This does not necessarily include security features.'),
			_Utils_Tuple2('Email provider that is known to be associated with malicious threat actors or has a history of low security standards. Consider migrating to a cloud based email provider with additional security features and implement an email security gateway.', 'Email provider that is known to be associated with malicious threat actors or has a history of low security standards. Consider migrating to a cloud based email provider with additional security features and implement an email security gateway.'),
			_Utils_Tuple2('Email provider that offers basic security features that need to be configured correctly. Examples include: email filtering, spam protection, and multi-factor authentication. Consider leveraging an email security provider for additional security benefits. This is not an Email Security provider, see guidance below.', 'Email provider that offers basic security features that need to be configured correctly. Examples include: email filtering, spam protection, and multi-factor authentication. Consider leveraging an email security provider for additional security benefits. This is not an Email Security provider, see guidance below.'),
			_Utils_Tuple2('Email provider that offers basic security features that need to be configured correctly. Examples include: email filtering, spam protection, and multi-factor authentication. Consider leveraging an email security provider for additional security features. This is not an Email Security provider, see guidance below.', 'Email provider that offers basic security features that need to be configured correctly. Examples include: email filtering, spam protection, and multi-factor authentication. Consider leveraging an email security provider for additional security features. This is not an Email Security provider, see guidance below.'),
			_Utils_Tuple2('Email providers that are self-hosted or through boutique email providers. Consider migrating to a cloud based email provider with additional security features and implement an email security gateway.', 'Email providers that are self-hosted or through boutique email providers. Consider migrating to a cloud based email provider with additional security features and implement an email security gateway.'),
			_Utils_Tuple2('Email service providers with specialized functionality for email archiving, email marketing, or other purposes.', 'Email service providers with specialized functionality for email archiving, email marketing, or other purposes.'),
			_Utils_Tuple2('Email service that filters for spam messages but does not offer other security features.', 'Email service that filters for spam messages but does not offer other security features.'),
			_Utils_Tuple2('Email services that are offered as additional services by Managed Service Providers (MSPs). Consider migrating to a cloud based email provider with additional security features and implement an email security gateway.', 'Email services that are offered as additional services by Managed Service Providers (MSPs). Consider migrating to a cloud based email provider with additional security features and implement an email security gateway.'),
			_Utils_Tuple2('Email services that are offered as additional services by web hosting providers. Consider migrating to a cloud based email provider with additional security features and implement an email security gateway.', 'Email services that are offered as additional services by web hosting providers. Consider migrating to a cloud based email provider with additional security features and implement an email security gateway.'),
			_Utils_Tuple2('Email services that are owned and managed by large organizations, holding companies, or shared with numerous companies. Consider leveraging an email security provider for additional security benefits.', 'Email services that are owned and managed by large organizations, holding companies, or shared with numerous companies. Consider leveraging an email security provider for additional security benefits.'),
			_Utils_Tuple2('For improved security and increased resiliency, we recommend exploring cloud-hosted email providers such as Microsoft 365 or Google Workspace. Additionally, leverage an email security gateway to provide enhanced security functionality.', 'For improved security and increased resiliency, we recommend exploring cloud-hosted email providers such as Microsoft 365 or Google Workspace. Additionally, leverage an email security gateway to provide enhanced security functionality.'),
			_Utils_Tuple2('No inbound email service detected. Confirm whether the primary email domain in use differs from the primary domain provided.', 'No inbound email service detected. Confirm whether the primary email domain in use differs from the primary domain provided.'),
			_Utils_Tuple2('Organizations should ensure a formal patch management process exists to remediate vulnerabilities as new updates become available. Furthermore, consider switching to an alternative remote access solution, such as Zero Trust Network Access (ZTNA).', 'Organizations should ensure a formal patch management process exists to remediate vulnerabilities as new updates become available. Furthermore, consider switching to an alternative remote access solution, such as Zero Trust Network Access (ZTNA).'),
			_Utils_Tuple2('Organizations should implement a secure email gateway for improved detection and prevention capabilities.', 'Organizations should implement a secure email gateway for improved detection and prevention capabilities.'),
			_Utils_Tuple2('Organizations should implement an alternative remote access solution, such as Zero Trust Network Access (ZTNA), to remediate the high risk VPN finding.', 'Organizations should implement an alternative remote access solution, such as Zero Trust Network Access (ZTNA), to remediate the high risk VPN finding.'),
			_Utils_Tuple2('Organizations should implement an alternative remote access technology.', 'Organizations should implement an alternative remote access technology.'),
			_Utils_Tuple2('RDP allows users to remotely connect to a Windows system. It\'s a common initial attack vector for ransomware attacks.', 'RDP allows users to remotely connect to a Windows system. It\'s a common initial attack vector for ransomware attacks.'),
			_Utils_Tuple2('Secure Message Block (SMB) allows for users to connect to systems and access files, printers, and other resources. Threat actors scan the Internet and attempt to exploit SMB or brute force username and password combinations to gain unauthorized access to systems. Most notably, exploits against SMB1, a legacy version of the service, was used as an attack technique for both the WannaCry and NotPetya mass ransomware attacks in 2017. Exposing SMB to the Internet significantly increases your attack surface that could lead to a full compromise of your network.', 'Secure Message Block (SMB) allows for users to connect to systems and access files, printers, and other resources. Threat actors scan the Internet and attempt to exploit SMB or brute force username and password combinations to gain unauthorized access to systems. Most notably, exploits against SMB1, a legacy version of the service, was used as an attack technique for both the WannaCry and NotPetya mass ransomware attacks in 2017. Exposing SMB to the Internet significantly increases your attack surface that could lead to a full compromise of your network.'),
			_Utils_Tuple2('Secure your organization by disabling inbound SMB access from the internet and legacy SMB protocols.', 'Secure your organization by disabling inbound SMB access from the internet and legacy SMB protocols.'),
			_Utils_Tuple2('The Cyber Risk Scan detected the presence of Remote Desktop Protocol (RDP) that was publicly accessible on a system associated with your organization.', 'The Cyber Risk Scan detected the presence of Remote Desktop Protocol (RDP) that was publicly accessible on a system associated with your organization.'),
			_Utils_Tuple2('The Cyber Risk Scan detected the presence of a VPN solution associated with your organization that is classified as a high risk. Corvus defines high risk VPNs as VPN devices that meet the following criteria: history of critical vulnerabilities, threat intelligence showing active exploitation of known vulnerabilities, known initial point of compromise and the highest statistically significant rate of security incidents found in industry wide claims data. Incident rates reflect the likelihood of an incident occurring in an environment where a specific VPN device is identified. The finding does not factor in device configurations or version information.', 'The Cyber Risk Scan detected the presence of a VPN solution associated with your organization that is classified as a high risk. Corvus defines high risk VPNs as VPN devices that meet the following criteria: history of critical vulnerabilities, threat intelligence showing active exploitation of known vulnerabilities, known initial point of compromise and the highest statistically significant rate of security incidents found in industry wide claims data. Incident rates reflect the likelihood of an incident occurring in an environment where a specific VPN device is identified. The finding does not factor in device configurations or version information.'),
			_Utils_Tuple2('The Cyber Risk Scan detected the presence of a VPN solution associated with your organization that is classified as a high risk. Travelers defines high risk VPNs as VPN devices that meet the following criteria: history of critical vulnerabilities, threat intelligence showing active exploitation of known vulnerabilities, known initial point of compromise and the highest statistically significant rate of security incidents found in industry wide claims data. Incident rates reflect the likelihood of an incident occurring in an environment where a specific VPN device is identified. The finding does not factor in device configurations or version information.', 'The Cyber Risk Scan detected the presence of a VPN solution associated with your organization that is classified as a high risk. Travelers defines high risk VPNs as VPN devices that meet the following criteria: history of critical vulnerabilities, threat intelligence showing active exploitation of known vulnerabilities, known initial point of compromise and the highest statistically significant rate of security incidents found in industry wide claims data. Incident rates reflect the likelihood of an incident occurring in an environment where a specific VPN device is identified. The finding does not factor in device configurations or version information.'),
			_Utils_Tuple2('The Cyber Risk Scan identified the following moderate to low risk VPN solution:', 'The Cyber Risk Scan identified the following moderate to low risk VPN solution:'),
			_Utils_Tuple2('The Cyber Risk Scan identified the presence of externally accessible SMB on the following systems associated with your organization.', 'The Cyber Risk Scan identified the presence of externally accessible SMB on the following systems associated with your organization.'),
			_Utils_Tuple2('The Cyber Risk Scan identified the following email provider:', 'The Cyber Risk Scan identified the following email provider:'),
			_Utils_Tuple2('The detected VPN has a history of numerous critical vulnerabilities that threat actors exploit. These exploits are known to lead to ransomware incidents. Corvus has identified that organizations using this VPN solution are three times more likely to experience a security incident.', 'The detected VPN has a history of numerous critical vulnerabilities that threat actors exploit. These exploits are known to lead to ransomware incidents. Corvus has identified that organizations using this VPN solution are three times more likely to experience a security incident.'),
			_Utils_Tuple2('The detected VPN has a history of numerous critical vulnerabilities that threat actors exploit. These exploits are known to lead to ransomware incidents. Travelers has identified that organizations using this VPN solution are three times more likely to experience a security incident.', 'The detected VPN has a history of numerous critical vulnerabilities that threat actors exploit. These exploits are known to lead to ransomware incidents. Travelers has identified that organizations using this VPN solution are three times more likely to experience a security incident.'),
			_Utils_Tuple2('The detected VPN has a history of several critical vulnerabilities which threat actors exploit. These exploits are known to lead to ransomware incidents. Corvus has identified that organizations using this VPN solution are 1.5x more likely to experience a security incident.', 'The detected VPN has a history of several critical vulnerabilities which threat actors exploit. These exploits are known to lead to ransomware incidents. Corvus has identified that organizations using this VPN solution are 1.5x more likely to experience a security incident.'),
			_Utils_Tuple2('The detected VPN has a history of several critical vulnerabilities which threat actors exploit. These exploits are known to lead to ransomware incidents. Travelers has identified that organizations using this VPN solution are 1.5x more likely to experience a security incident.', 'The detected VPN has a history of several critical vulnerabilities which threat actors exploit. These exploits are known to lead to ransomware incidents. Travelers has identified that organizations using this VPN solution are 1.5x more likely to experience a security incident.'),
			_Utils_Tuple2('Threat actors use phishing emails to steal user credentials and trick users into running malicious software on their systems. It is important for organizations to implement strong email security controls to minimize the chances of phishing emails reaching users who may inadvertently click on malicious links or attachments.', 'Threat actors use phishing emails to steal user credentials and trick users into running malicious software on their systems. It is important for organizations to implement strong email security controls to minimize the chances of phishing emails reaching users who may inadvertently click on malicious links or attachments.'),
			_Utils_Tuple2('When an email domain is registered but not in use for active email delivery. Domains still need to be properly secured to avoid hijacking or impersonation attempts.', 'When an email domain is registered but not in use for active email delivery. Domains still need to be properly secured to avoid hijacking or impersonation attempts.'),
			_Utils_Tuple2('Annual Revenue', 'Annual Revenue'),
			_Utils_Tuple2('Bound Date', 'Bound Date'),
			_Utils_Tuple2('Broker', 'Broker'),
			_Utils_Tuple2('Brokerage', 'Brokerage'),
			_Utils_Tuple2('Business Type', 'Business Type'),
			_Utils_Tuple2('Claims History', 'Claims History'),
			_Utils_Tuple2('Client', 'Client'),
			_Utils_Tuple2('Client Name', 'Client Name'),
			_Utils_Tuple2('Corvus Score', 'Corvus Score'),
			_Utils_Tuple2('Date Archived', 'Date Archived'),
			_Utils_Tuple2('Date Created', 'Date Created'),
			_Utils_Tuple2('Effective Date', 'Effective Date'),
			_Utils_Tuple2('Expiration Date', 'Expiration Date'),
			_Utils_Tuple2('Policy Fee', 'Policy Fee'),
			_Utils_Tuple2('Firm?', 'Firm?'),
			_Utils_Tuple2('Hostname', 'Hostname'),
			_Utils_Tuple2('Inserted Date', 'Inserted Date'),
			_Utils_Tuple2('Limit', 'Limit'),
			_Utils_Tuple2('Maximum Revenue Dollars', 'Maximum Revenue Dollars'),
			_Utils_Tuple2('Minimum Revenue Dollars', 'Minimum Revenue Dollars'),
			_Utils_Tuple2('Nature Of Business', 'Nature Of Business'),
			_Utils_Tuple2('Nature of Business Category', 'Nature of Business Category'),
			_Utils_Tuple2('Number of Controls', 'Number of Controls'),
			_Utils_Tuple2('PII Records', 'PII Records'),
			_Utils_Tuple2('Premium', 'Premium'),
			_Utils_Tuple2('TRIA', 'TRIA'),
			_Utils_Tuple2('Priority Level', 'Priority Level'),
			_Utils_Tuple2('Product Line', 'Product Line'),
			_Utils_Tuple2('Product Type', 'Product Type'),
			_Utils_Tuple2('Insights', 'Insights'),
			_Utils_Tuple2('Duplicate', 'Duplicate'),
			_Utils_Tuple2('Low Score', 'Low Score'),
			_Utils_Tuple2('Quote Type', 'Quote Type'),
			_Utils_Tuple2('Quoted Date', 'Quoted Date'),
			_Utils_Tuple2('RCP', 'RCP'),
			_Utils_Tuple2('Retention', 'Retention'),
			_Utils_Tuple2('Revenue', 'Revenue'),
			_Utils_Tuple2('Risk Class', 'Risk Class'),
			_Utils_Tuple2('Time', 'Time'),
			_Utils_Tuple2('Url', 'Url'),
			_Utils_Tuple2('Cancellation Effective Date (Policy End)', 'Cancellation Effective Date (Policy End)'),
			_Utils_Tuple2('No, Leave As-is', 'No, Leave As-is'),
			_Utils_Tuple2('Yes, Cancel Policy', 'Yes, Cancel Policy'),
			_Utils_Tuple2('Domicile Country', 'Domicile Country'),
			_Utils_Tuple2('Country', 'Country'),
			_Utils_Tuple2('Value', 'Value'),
			_Utils_Tuple2('Percentage per Country', 'Percentage per Country'),
			_Utils_Tuple2('Claim Number', 'Claim Number'),
			_Utils_Tuple2('Last Updated', 'Last Updated'),
			_Utils_Tuple2('Need to file a new claim?', 'Need to file a new claim?'),
			_Utils_Tuple2('No claims to display.', 'No claims to display.'),
			_Utils_Tuple2('Team members can view and access client information and receive emails sent to the client from the CrowBar. Adding a broker not currently on the CrowBar will create an account for that person.', 'Team members can view and access client information and receive emails sent to the client from the CrowBar. Adding a broker not currently on the CrowBar will create an account for that person.'),
			_Utils_Tuple2('Unable to load your dashboard.', 'Unable to load your dashboard.'),
			_Utils_Tuple2('Close', 'Close'),
			_Utils_Tuple2('Closed', 'Closed'),
			_Utils_Tuple2('Not Found', 'Not Found'),
			_Utils_Tuple2('Open', 'Open'),
			_Utils_Tuple2('Click to Open', 'Click to Open'),
			_Utils_Tuple2('Firm Order Noted Info', 'Firm Order Noted Info'),
			_Utils_Tuple2('On Risk Info', 'On Risk Info'),
			_Utils_Tuple2('Quote Info', 'Quote Info'),
			_Utils_Tuple2('Submission Info', 'Submission Info'),
			_Utils_Tuple2('Post Bind', 'Post Bind'),
			_Utils_Tuple2('All documents in this section are internal to Corvus only.', 'All documents in this section are internal to Corvus only.'),
			_Utils_Tuple2('UMR Number', 'UMR Number'),
			_Utils_Tuple2('XXXXXXXXXXXXXXXXX', 'XXXXXXXXXXXXXXXXX'),
			_Utils_Tuple2('No emails have been sent to Beat.', 'No emails have been sent to Beat.'),
			_Utils_Tuple2('Documents', 'Documents'),
			_Utils_Tuple2('Communications', 'Communications'),
			_Utils_Tuple2('Recommendations', 'Recommendations'),
			_Utils_Tuple2('Responded', 'Responded'),
			_Utils_Tuple2('No Action Needed', 'No Action Needed'),
			_Utils_Tuple2('Time Sensitive', 'Time Sensitive'),
			_Utils_Tuple2('Active Threat', 'Active Threat'),
			_Utils_Tuple2('Past Threat', 'Past Threat'),
			_Utils_Tuple2('Critical', 'Critical'),
			_Utils_Tuple2('High', 'High'),
			_Utils_Tuple2('Info', 'Info'),
			_Utils_Tuple2('Low', 'Low'),
			_Utils_Tuple2('Medium', 'Medium'),
			_Utils_Tuple2('Broker Team', 'Broker Team'),
			_Utils_Tuple2('Policy Cancellation Form', 'Policy Cancellation Form'),
			_Utils_Tuple2('Detection of Missing Transfer Locks for Domains.', 'Detection of Missing Transfer Locks for Domains.'),
			_Utils_Tuple2('Domain Status', 'Domain Status'),
			_Utils_Tuple2('Organizations should enable domain registry locks on their domains to prevent unauthorized domain name transfers, which can result in loss of control over domains associated with your organization.', 'Organizations should enable domain registry locks on their domains to prevent unauthorized domain name transfers, which can result in loss of control over domains associated with your organization.'),
			_Utils_Tuple2('The Cyber Risk Scan identified issues with domains associated with your organization.', 'The Cyber Risk Scan identified issues with domains associated with your organization.'),
			_Utils_Tuple2('The Cyber Risk Scan identified the following domain(s) not configured according to best practices to prevent domain hijacking:', 'The Cyber Risk Scan identified the following domain(s) not configured according to best practices to prevent domain hijacking:'),
			_Utils_Tuple2('%{num} members', '%{num} members'),
			_Utils_Tuple2('Add New Team', 'Add New Team'),
			_Utils_Tuple2('Broker Number', 'Broker Number'),
			_Utils_Tuple2('Broker Team has no Brokers', 'Broker Team has no Brokers'),
			_Utils_Tuple2('Edit Team', 'Edit Team'),
			_Utils_Tuple2('Email', 'Email'),
			_Utils_Tuple2('Manage Broker Teams', 'Manage Broker Teams'),
			_Utils_Tuple2('Download Document', 'Download Document'),
			_Utils_Tuple2('Failed to Generate Preview', 'Failed to Generate Preview'),
			_Utils_Tuple2('Generate Preview', 'Generate Preview'),
			_Utils_Tuple2('Generating Preview', 'Generating Preview'),
			_Utils_Tuple2('Self Service Upload Tool', 'Self Service Upload Tool'),
			_Utils_Tuple2('Something has gone wrong, this file should not be deleted.', 'Something has gone wrong, this file should not be deleted.'),
			_Utils_Tuple2('There was an error uploading the Document.', 'There was an error uploading the Document.'),
			_Utils_Tuple2('There was an error.', 'There was an error.'),
			_Utils_Tuple2('There was an error generating the sample.', 'There was an error generating the sample.'),
			_Utils_Tuple2('Upload Policy Form', 'Upload Policy Form'),
			_Utils_Tuple2('Upload Quote Form', 'Upload Quote Form'),
			_Utils_Tuple2('Select a Country', 'Select a Country'),
			_Utils_Tuple2('Other Admitted Country', 'Other Admitted Country'),
			_Utils_Tuple2('Rest Of World', 'Rest Of World'),
			_Utils_Tuple2('The domain is missing the ClientTransferProhibited status code.', 'The domain is missing the ClientTransferProhibited status code.'),
			_Utils_Tuple2('The security certificate has expired.', 'The security certificate has expired.'),
			_Utils_Tuple2('The security certificate is using deprecated hash algorithms such as MD5 and SHA-1.', 'The security certificate is using deprecated hash algorithms such as MD5 and SHA-1.'),
			_Utils_Tuple2('The security certificate is valid for more than 398 days.', 'The security certificate is valid for more than 398 days.'),
			_Utils_Tuple2('How will the refund be calculated?', 'How will the refund be calculated?'),
			_Utils_Tuple2('Refund Strategy', 'Refund Strategy'),
			_Utils_Tuple2('Return Premium Amount', 'Return Premium Amount'),
			_Utils_Tuple2('Remove', 'Remove'),
			_Utils_Tuple2('Add Another Broker', 'Add Another Broker'),
			_Utils_Tuple2('Underwriter', 'Underwriter'),
			_Utils_Tuple2('Address', 'Address'),
			_Utils_Tuple2('Currency', 'Currency'),
			_Utils_Tuple2('Expiry Date', 'Expiry Date'),
			_Utils_Tuple2('Inception Date', 'Inception Date'),
			_Utils_Tuple2('Industry', 'Industry'),
			_Utils_Tuple2('Insured Name', 'Insured Name'),
			_Utils_Tuple2('Primary Url', 'Primary Url'),
			_Utils_Tuple2('Save Team', 'Save Team'),
			_Utils_Tuple2('Team Leader', 'Team Leader'),
			_Utils_Tuple2('Type of Risk', 'Type of Risk'),
			_Utils_Tuple2('+ Add Country', '+ Add Country'),
			_Utils_Tuple2('Attachment Point', 'Attachment Point'),
			_Utils_Tuple2('Corvus %', 'Corvus %'),
			_Utils_Tuple2('Corvus Limit', 'Corvus Limit'),
			_Utils_Tuple2('Corvus Premium', 'Corvus Premium'),
			_Utils_Tuple2('Order Line %', 'Order Line %'),
			_Utils_Tuple2('Premium Allocation', 'Premium Allocation'),
			_Utils_Tuple2('Quote Details', 'Quote Details'),
			_Utils_Tuple2('Quote Option 1', 'Quote Option 1'),
			_Utils_Tuple2('Signed Line %', 'Signed Line %'),
			_Utils_Tuple2('Written Line %', 'Written Line %'),
			_Utils_Tuple2('Current Gross Annual Revenue', 'Current Gross Annual Revenue'),
			_Utils_Tuple2('Expiring Gross Annual Revenue', 'Expiring Gross Annual Revenue'),
			_Utils_Tuple2('IDD LIC', 'IDD LIC'),
			_Utils_Tuple2('PII Record (Max)', 'PII Record (Max)'),
			_Utils_Tuple2('PII Record (Total)', 'PII Record (Total)'),
			_Utils_Tuple2('Projected Gross Annual Revenue', 'Projected Gross Annual Revenue'),
			_Utils_Tuple2('WebSure Certificate Reference Number', 'WebSure Certificate Reference Number'),
			_Utils_Tuple2('Expired Policy UMR Number', 'Expired Policy UMR Number'),
			_Utils_Tuple2('Please enter the UMR number assigned to the expired policy you are renewing.', 'Please enter the UMR number assigned to the expired policy you are renewing.'),
			_Utils_Tuple2('Document Name', 'Document Name'),
			_Utils_Tuple2('Premium Adjustment', 'Premium Adjustment'),
			_Utils_Tuple2('Update Status', 'Update Status'),
			_Utils_Tuple2('Stamp Details', 'Stamp Details'),
			_Utils_Tuple2('Risk Allocation', 'Risk Allocation'),
			_Utils_Tuple2('+ Add Stamp', '+ Add Stamp'),
			_Utils_Tuple2('Brokerage %', 'Brokerage %'),
			_Utils_Tuple2('War Exclusion Type', 'War Exclusion Type'),
			_Utils_Tuple2('Switch to a %{targetProdType}', 'Switch to a %{targetProdType}'),
			_Utils_Tuple2('Attach to a Line Slip', 'Attach to a Line Slip'),
			_Utils_Tuple2('Caution: Are you sure you want to change this %{originalProdType} to a %{targetProdType}? All the information you entered will be saved.', 'Caution: Are you sure you want to change this %{originalProdType} to a %{targetProdType}? All the information you entered will be saved.'),
			_Utils_Tuple2('After attaching, the workflow will update to declaration %{submissionType}.', 'After attaching, the workflow will update to declaration %{submissionType}.'),
			_Utils_Tuple2('Failed to create the risk allocation, please try again.', 'Failed to create the risk allocation, please try again.'),
			_Utils_Tuple2('Failed to delete the risk allocation, please try again.', 'Failed to delete the risk allocation, please try again.'),
			_Utils_Tuple2('Failed to update the risk allocation, please try again.', 'Failed to update the risk allocation, please try again.'),
			_Utils_Tuple2('Domicile/Territorial Limit', 'Domicile/Territorial Limit'),
			_Utils_Tuple2('No Stamps Selected', 'No Stamps Selected'),
			_Utils_Tuple2('Percentage', 'Percentage'),
			_Utils_Tuple2('All risk allocations need to be saved and add up to 100%.', 'All risk allocations need to be saved and add up to 100%.'),
			_Utils_Tuple2('Create Invoice', 'Create Invoice'),
			_Utils_Tuple2('Failed to generate invoice, please try again.', 'Failed to generate invoice, please try again.'),
			_Utils_Tuple2('Generating Invoice', 'Generating Invoice'),
			_Utils_Tuple2('My Team', 'My Team'),
			_Utils_Tuple2('Resources', 'Resources'),
			_Utils_Tuple2('Settings', 'Settings'),
			_Utils_Tuple2('Sign Out', 'Sign Out'),
			_Utils_Tuple2('Authorised (External) By - Name', 'Authorised (External) By - Name'),
			_Utils_Tuple2('Authorised (Internal) By - Name', 'Authorised (Internal) By - Name'),
			_Utils_Tuple2('+ Add Risk Code', '+ Add Risk Code'),
			_Utils_Tuple2('Risk Code', 'Risk Code'),
			_Utils_Tuple2('Saving…', 'Saving…'),
			_Utils_Tuple2('%{error}', '%{error}'),
			_Utils_Tuple2('I confirm these documents have the appropriate sign off from Legal, Risk Capital Partners, Design, and Required Internal Stakeholders to be used for underwriting purposes.', 'I confirm these documents have the appropriate sign off from Legal, Risk Capital Partners, Design, and Required Internal Stakeholders to be used for underwriting purposes.'),
			_Utils_Tuple2('Save Document', 'Save Document'),
			_Utils_Tuple2('Privacy Policy', 'Privacy Policy'),
			_Utils_Tuple2('Terms and Conditions', 'Terms and Conditions'),
			_Utils_Tuple2('Terms and conditions apply.', 'Terms and conditions apply.'),
			_Utils_Tuple2('Confirm Bind', 'Confirm Bind'),
			_Utils_Tuple2('Invalid Limit', 'Invalid Limit'),
			_Utils_Tuple2('Undo', 'Undo'),
			_Utils_Tuple2('Breadcrumb', 'Breadcrumb'),
			_Utils_Tuple2('Cancellation Reason', 'Cancellation Reason'),
			_Utils_Tuple2('Send Data To Beat', 'Send Data To Beat'),
			_Utils_Tuple2('Please specify the reason for declining', 'Please specify the reason for declining'),
			_Utils_Tuple2('Reason', 'Reason'),
			_Utils_Tuple2('More details coming soon', 'More details coming soon'),
			_Utils_Tuple2('Unable to load Smart Controls. Please try again.', 'Unable to load Smart Controls. Please try again.'),
			_Utils_Tuple2('Smart Controls are the internal cybersecurity defenses we look for during the underwriting process to determine how resilient your organization is against a cyber attack. If you have security controls in %{count} areas, your organization is viewed as less likely to have a claim/security incident.', 'Smart Controls are the internal cybersecurity defenses we look for during the underwriting process to determine how resilient your organization is against a cyber attack. If you have security controls in %{count} areas, your organization is viewed as less likely to have a claim/security incident.'),
			_Utils_Tuple2('Unable to load Security Advanced. Please try again.', 'Unable to load Security Advanced. Please try again.'),
			_Utils_Tuple2('The Security Advanced module goes from basics to intermediate controls for backups, email security, network security, endpoint security, and identity and access management.', 'The Security Advanced module goes from basics to intermediate controls for backups, email security, network security, endpoint security, and identity and access management.'),
			_Utils_Tuple2('%{partial} of %{total} Complete', '%{partial} of %{total} Complete'),
			_Utils_Tuple2('Review Your Smart Controls', 'Review Your Smart Controls'),
			_Utils_Tuple2('Smart Controls', 'Smart Controls'),
			_Utils_Tuple2('Terms and conditions, including premium and discounts, are made in accordance with our underwriting guidelines. Coverage may not be available in all jurisdictions.', 'Terms and conditions, including premium and discounts, are made in accordance with our underwriting guidelines. Coverage may not be available in all jurisdictions.'),
			_Utils_Tuple2('Smart Control %{current_number} of %{total_number}:', 'Smart Control %{current_number} of %{total_number}:'),
			_Utils_Tuple2('Security Recommendations', 'Security Recommendations'),
			_Utils_Tuple2('Review the <tag>Action Center</tag> for customized security advice based on your answers.', 'Review the <tag>Action Center</tag> for customized security advice based on your answers.'),
			_Utils_Tuple2('This is where you’ll see our recommended actions based on your answers to the controls questions to the left.', 'This is where you’ll see our recommended actions based on your answers to the controls questions to the left.'),
			_Utils_Tuple2('Talk to Corvus', 'Talk to Corvus'),
			_Utils_Tuple2('Please Explain Reason (250 characters max)', 'Please Explain Reason (250 characters max)'),
			_Utils_Tuple2('The input on this tab was successfully submitted to Beat. An email will show up inside the Documents section under the Communications tab', 'The input on this tab was successfully submitted to Beat. An email will show up inside the Documents section under the Communications tab'),
			_Utils_Tuple2('The input on this tab was successfully submitted to Beat. (%{dateString}) An email will show up inside the Documents section under the Communications tab', 'The input on this tab was successfully submitted to Beat. (%{dateString}) An email will show up inside the Documents section under the Communications tab'),
			_Utils_Tuple2('Port', 'Port'),
			_Utils_Tuple2('Start an Endorsement', 'Start an Endorsement'),
			_Utils_Tuple2('Endorsements', 'Endorsements'),
			_Utils_Tuple2('Endorsement Templates Failed to Load', 'Endorsement Templates Failed to Load'),
			_Utils_Tuple2('Internal CrowBar', 'Internal CrowBar'),
			_Utils_Tuple2('Endorsement Templates Dashboard', 'Endorsement Templates Dashboard'),
			_Utils_Tuple2('Could not retrieve endorsement template.', 'Could not retrieve endorsement template.'),
			_Utils_Tuple2('Endorsement Name', 'Endorsement Name'),
			_Utils_Tuple2('Endorsement Number', 'Endorsement Number'),
			_Utils_Tuple2('Endorsement Text', 'Endorsement Text'),
			_Utils_Tuple2('Edit Template', 'Edit Template'),
			_Utils_Tuple2('Update Endorsement Template', 'Update Endorsement Template'),
			_Utils_Tuple2('Preview Template', 'Preview Template'),
			_Utils_Tuple2('Update Template', 'Update Template'),
			_Utils_Tuple2('Updating…', 'Updating…'),
			_Utils_Tuple2('Template Updated', 'Template Updated'),
			_Utils_Tuple2('Error', 'Error'),
			_Utils_Tuple2('Create Template', 'Create Template'),
			_Utils_Tuple2('Creating…', 'Creating…'),
			_Utils_Tuple2('Template Created', 'Template Created'),
			_Utils_Tuple2('Add New Input', 'Add New Input'),
			_Utils_Tuple2('Custom Endorsement Inputs', 'Custom Endorsement Inputs'),
			_Utils_Tuple2('Dates are currently not supported.', 'Dates are currently not supported.'),
			_Utils_Tuple2('Default Value', 'Default Value'),
			_Utils_Tuple2('Flat Rate', 'Flat Rate'),
			_Utils_Tuple2('Input Label', 'Input Label'),
			_Utils_Tuple2('Input Type', 'Input Type'),
			_Utils_Tuple2('Utility Classes', 'Utility Classes'),
			_Utils_Tuple2('Expected MFL', 'Expected MFL'),
			_Utils_Tuple2('Expected PML', 'Expected PML'),
			_Utils_Tuple2('Beat was updated that this Submission was declined. (%{dateString}) An email will show up inside the Documents section under the Communications tab', 'Beat was updated that this Submission was declined. (%{dateString}) An email will show up inside the Documents section under the Communications tab'),
			_Utils_Tuple2('Beat was updated that this Submission was not taken up. (%{dateString}) An email will show up inside the Documents section under the Communications tab', 'Beat was updated that this Submission was not taken up. (%{dateString}) An email will show up inside the Documents section under the Communications tab'),
			_Utils_Tuple2('Send Loss (Decline) to Beat', 'Send Loss (Decline) to Beat'),
			_Utils_Tuple2('Send Loss (Not Taken Up) to Beat', 'Send Loss (Not Taken Up) to Beat'),
			_Utils_Tuple2('Additional Premium Amount', 'Additional Premium Amount'),
			_Utils_Tuple2('Please Explain Cancellation Reason (250 characters max)', 'Please Explain Cancellation Reason (250 characters max)'),
			_Utils_Tuple2('Failed to load submission data. Please refresh the page. If you continue to see this error, please contact support.', 'Failed to load submission data. Please refresh the page. If you continue to see this error, please contact support.'),
			_Utils_Tuple2('corvusinsurance.com', 'corvusinsurance.com'),
			_Utils_Tuple2('Waiting Period (Hours)', 'Waiting Period (Hours)'),
			_Utils_Tuple2('Slip Lead', 'Slip Lead'),
			_Utils_Tuple2('Lloyds Lead', 'Lloyds Lead'),
			_Utils_Tuple2('Add (or Select) Lead', 'Add (or Select) Lead'),
			_Utils_Tuple2('Create new entry for ', 'Create new entry for '),
			_Utils_Tuple2('Settlement Due Date', 'Settlement Due Date'),
			_Utils_Tuple2('Disable Auto Quote', 'Disable Auto Quote'),
			_Utils_Tuple2('Disabling renewal Auto Quoting for <tag>%{client_name}</tag>.', 'Disabling renewal Auto Quoting for <tag>%{client_name}</tag>.'),
			_Utils_Tuple2('IELR %', 'IELR %'),
			_Utils_Tuple2('UW COR %', 'UW COR %'),
			_Utils_Tuple2('Rate Change Calculation', 'Rate Change Calculation'),
			_Utils_Tuple2('Pure Rate Change (%)', 'Pure Rate Change (%)'),
			_Utils_Tuple2('Lloyds RARC (%)', 'Lloyds RARC (%)'),
			_Utils_Tuple2('Change in Limit Attachment (%)', 'Change in Limit Attachment (%)'),
			_Utils_Tuple2('Rarc Not Comparable', 'Rarc Not Comparable'),
			_Utils_Tuple2('Quote Option %{index}', 'Quote Option %{index}'),
			_Utils_Tuple2('Corvus Score Discount (%)', 'Corvus Score Discount (%)'),
			_Utils_Tuple2('UW Load Discount %', 'UW Load Discount %'),
			_Utils_Tuple2('+ Add Quote Option', '+ Add Quote Option'),
			_Utils_Tuple2('Total Technical Premium', 'Total Technical Premium'),
			_Utils_Tuple2('Select Quote Option', 'Select Quote Option'),
			_Utils_Tuple2('Selected', 'Selected'),
			_Utils_Tuple2('Applied To Policy', 'Applied To Policy'),
			_Utils_Tuple2('Breach Event Cost', 'Breach Event Cost'),
			_Utils_Tuple2('Bricking', 'Bricking'),
			_Utils_Tuple2('Business Interruption', 'Business Interruption'),
			_Utils_Tuple2('Core Coverages', 'Core Coverages'),
			_Utils_Tuple2('Crisis Management and Notification', 'Crisis Management and Notification'),
			_Utils_Tuple2('Cyber Extortion', 'Cyber Extortion'),
			_Utils_Tuple2('Data Recovery', 'Data Recovery'),
			_Utils_Tuple2('Network Security/Privacy Liability', 'Network Security/Privacy Liability'),
			_Utils_Tuple2('No', 'No'),
			_Utils_Tuple2('PCI DSS Assessment', 'PCI DSS Assessment'),
			_Utils_Tuple2('Privacy Reg Defence and Penalties', 'Privacy Reg Defence and Penalties'),
			_Utils_Tuple2('Reputational Harm', 'Reputational Harm'),
			_Utils_Tuple2('Technology Errors and Omissions', 'Technology Errors and Omissions'),
			_Utils_Tuple2('Multimedia Liability', 'Multimedia Liability'),
			_Utils_Tuple2('Yes', 'Yes'),
			_Utils_Tuple2('Uncertain', 'Uncertain'),
			_Utils_Tuple2('N/A', 'N/A'),
			_Utils_Tuple2('Add notes here.', 'Add notes here.'),
			_Utils_Tuple2('Additional Notes', 'Additional Notes'),
			_Utils_Tuple2('A Quote Option has not been selected. Please navigate to the Quote Info tab and select a Quote Option before continuing.', 'A Quote Option has not been selected. Please navigate to the Quote Info tab and select a Quote Option before continuing.'),
			_Utils_Tuple2('Selected Quote Option', 'Selected Quote Option'),
			_Utils_Tuple2('Recommended Score', 'Recommended Score'),
			_Utils_Tuple2('The Cyber Risk Scan is the first part of your evaluation that determines your eligibility to bind or renew your policy. Below is a summary of the findings. While meeting the recommended score of 80 is not a requirement, it could result in preferred pricing.', 'The Cyber Risk Scan is the first part of your evaluation that determines your eligibility to bind or renew your policy. Below is a summary of the findings. While meeting the recommended score of 80 is not a requirement, it could result in preferred pricing.'),
			_Utils_Tuple2('Law and Jurisdiction', 'Law and Jurisdiction'),
			_Utils_Tuple2('Crypto Jacking', 'Crypto Jacking'),
			_Utils_Tuple2('Cyber Crime', 'Cyber Crime'),
			_Utils_Tuple2('Number of Specified Suppliers', 'Number of Specified Suppliers'),
			_Utils_Tuple2('Other Coverages', 'Other Coverages'),
			_Utils_Tuple2('Enter Coverage Name', 'Enter Coverage Name'),
			_Utils_Tuple2('+ Add Non-Standard Coverage', '+ Add Non-Standard Coverage'),
			_Utils_Tuple2('Non-standard Coverage', 'Non-standard Coverage'),
			_Utils_Tuple2('Specified Suppliers Limit', 'Specified Suppliers Limit'),
			_Utils_Tuple2('Telephone Phreaking', 'Telephone Phreaking'),
			_Utils_Tuple2('Unspecified Suppliers Limit', 'Unspecified Suppliers Limit'),
			_Utils_Tuple2('Unspecified Suppliers Tier', 'Unspecified Suppliers Tier'),
			_Utils_Tuple2('This submission is scheduled to Auto-quote on %{date}', 'This submission is scheduled to Auto-quote on %{date}'),
			_Utils_Tuple2('Tacit Date', 'Tacit Date'),
			_Utils_Tuple2('Set Tacit Date', 'Set Tacit Date'),
			_Utils_Tuple2('Bind Policy', 'Bind Policy'),
			_Utils_Tuple2('Add Premium Movement', 'Add Premium Movement'),
			_Utils_Tuple2('Adjusted Expiry Date', 'Adjusted Expiry Date'),
			_Utils_Tuple2('Transaction Type', 'Transaction Type'),
			_Utils_Tuple2('Added', 'Added'),
			_Utils_Tuple2('Contingent Business Interruption', 'Contingent Business Interruption'),
			_Utils_Tuple2('Cyber Extortion & Ransomware', 'Cyber Extortion & Ransomware'),
			_Utils_Tuple2('First Party Insuring Agreement', 'First Party Insuring Agreement'),
			_Utils_Tuple2('Media Liability', 'Media Liability'),
			_Utils_Tuple2('Removed', 'Removed'),
			_Utils_Tuple2('Reputational Loss', 'Reputational Loss'),
			_Utils_Tuple2('Social Engineering & Cyber Crime', 'Social Engineering & Cyber Crime'),
			_Utils_Tuple2('System Failure', 'System Failure'),
			_Utils_Tuple2('Third Party Insuring Agreement', 'Third Party Insuring Agreement'),
			_Utils_Tuple2('Changed', 'Changed'),
			_Utils_Tuple2('Insuring Agreements', 'Insuring Agreements'),
			_Utils_Tuple2('%{client_name} - %{policy_number} - Renewal of your Cyber Insurance Policy', '%{client_name} - %{policy_number} - Renewal of your Cyber Insurance Policy'),
			_Utils_Tuple2('An important part of the risk evaluation is the scan result. We have run it again for the renewal.', 'An important part of the risk evaluation is the scan result. We have run it again for the renewal.'),
			_Utils_Tuple2('Corvus Underwriting Team', 'Corvus Underwriting Team'),
			_Utils_Tuple2('Dear Madam or Sir,', 'Dear Madam or Sir,'),
			_Utils_Tuple2('Furthermore, for a successful renewal, we need some information on the current status of the implemented risk controls. We therefore ask you to complete the attached renewal questionnaire and return it to us dated and signed. Should you have any inquiries, please do not hesitate to contact us at any time.', 'Furthermore, for a successful renewal, we need some information on the current status of the implemented risk controls. We therefore ask you to complete the attached renewal questionnaire and return it to us dated and signed. Should you have any inquiries, please do not hesitate to contact us at any time.'),
			_Utils_Tuple2('On %{policy_expiration_date} your cyber insurance with Corvus will renew.', 'On %{policy_expiration_date} your cyber insurance with Corvus will renew.'),
			_Utils_Tuple2('Renewal of your Cyber Insurance Policy', 'Renewal of your Cyber Insurance Policy'),
			_Utils_Tuple2('This results shows a score above 80. This does not prevent a renewal and you can find the report attached. A higher score has a direct, positive impact on the renewal offer premium. We would be happy to meet with you and your broker to discuss ways to improve your Corvus score.', 'This results shows a score above 80. This does not prevent a renewal and you can find the report attached. A higher score has a direct, positive impact on the renewal offer premium. We would be happy to meet with you and your broker to discuss ways to improve your Corvus score.'),
			_Utils_Tuple2('Unfortunately, the scan result shows a score below 80. A score above 80 is required to renew your insurance. A higher score will also have a direct, positive impact on your renewal premium. We are happy to meet with you and your broker to discuss ways to improve your score. You can find the report of the scan', 'Unfortunately, the scan result shows a score below 80. A score above 80 is required to renew your insurance. A higher score will also have a direct, positive impact on your renewal premium. We are happy to meet with you and your broker to discuss ways to improve your score. You can find the report of the scan'),
			_Utils_Tuple2('Yours sincerely,', 'Yours sincerely,'),
			_Utils_Tuple2('Adjusted Premium Amount', 'Adjusted Premium Amount'),
			_Utils_Tuple2('Apply Premium Movement to Policy', 'Apply Premium Movement to Policy'),
			_Utils_Tuple2('Description', 'Description'),
			_Utils_Tuple2('Original Premium Amount', 'Original Premium Amount'),
			_Utils_Tuple2('Policy Extension', 'Policy Extension'),
			_Utils_Tuple2('Premium Movement Overview', 'Premium Movement Overview'),
			_Utils_Tuple2('description', 'description'),
			_Utils_Tuple2('Coverage Changes', 'Coverage Changes'),
			_Utils_Tuple2('View Coverage Changes', 'View Coverage Changes'),
			_Utils_Tuple2('If you have any questions, please do not hesitate to contact us.', 'If you have any questions, please do not hesitate to contact us.'),
			_Utils_Tuple2('In addition, we would like to point out the results of the Corvus scan: Your score is currently above 80, which is sufficient for a renewal. However, a higher score will have a direct positive impact on the renewal offer premium.', 'In addition, we would like to point out the results of the Corvus scan: Your score is currently above 80, which is sufficient for a renewal. However, a higher score will have a direct positive impact on the renewal offer premium.'),
			_Utils_Tuple2('In addition, we would like to point out the results of the Corvus scan: Your score is currently below 80. A score above 80 is a prerequisite for a renewal.', 'In addition, we would like to point out the results of the Corvus scan: Your score is currently below 80. A score above 80 is a prerequisite for a renewal.'),
			_Utils_Tuple2('On %{last_email_sent_date} we had sent you an email to renew your cyber insurance. We require the attached renewal questionnaire from you, completed in full, dated current and signed.', 'On %{last_email_sent_date} we had sent you an email to renew your cyber insurance. We require the attached renewal questionnaire from you, completed in full, dated current and signed.'),
			_Utils_Tuple2('We would be happy to meet with you, along with your broker, to discuss ways to improve your score. You can find the report of the scan attached.', 'We would be happy to meet with you, along with your broker, to discuss ways to improve your score. You can find the report of the scan attached.'),
			_Utils_Tuple2('%{client_name} - %{policy_number} - Missing information for renewal of your cyber insurance policy', '%{client_name} - %{policy_number} - Missing information for renewal of your cyber insurance policy'),
			_Utils_Tuple2('Missing information for renewal of your cyber insurance policy', 'Missing information for renewal of your cyber insurance policy'),
			_Utils_Tuple2('Quote Option', 'Quote Option'),
			_Utils_Tuple2('A Policy has not been bound. Please navigate to the On Risk tab and bind a Policy.', 'A Policy has not been bound. Please navigate to the On Risk tab and bind a Policy.'),
			_Utils_Tuple2('Finish Account Setup', 'Finish Account Setup'),
			_Utils_Tuple2('Finish account setup: %{link}', 'Finish account setup: %{link}'),
			_Utils_Tuple2('Get bindable quotes within%{tag}minutes on the CrowBar.', 'Get bindable quotes within%{tag}minutes on the CrowBar.'),
			_Utils_Tuple2('LinkedIn: %{link}', 'LinkedIn: %{link}'),
			_Utils_Tuple2('Or, send us submissions via email. Email your submissions to %{email}', 'Or, send us submissions via email. Email your submissions to %{email}'),
			_Utils_Tuple2('Or, send us submissions%{tag}via email.', 'Or, send us submissions%{tag}via email.'),
			_Utils_Tuple2('Selling resources', 'Selling resources'),
			_Utils_Tuple2('Selling resources: %{link}', 'Selling resources: %{link}'),
			_Utils_Tuple2('Should you have any questions, or need any help from us, reply directly to this message and we\'ll be happy to help out! Learn more about Corvus and the CrowBar on our website.', 'Should you have any questions, or need any help from us, reply directly to this message and we\'ll be happy to help out! Learn more about Corvus and the CrowBar on our website.'),
			_Utils_Tuple2('Sign in to the CrowBar: %{link}', 'Sign in to the CrowBar: %{link}'),
			_Utils_Tuple2('Submit online through the CrowBar. Get bindable quotes within minutes on the CrowBar.', 'Submit online through the CrowBar. Get bindable quotes within minutes on the CrowBar.'),
			_Utils_Tuple2('Submit online through%{tag}the CrowBar.', 'Submit online through%{tag}the CrowBar.'),
			_Utils_Tuple2('This email was sent to %{email}', 'This email was sent to %{email}'),
			_Utils_Tuple2('Twitter: %{link}', 'Twitter: %{link}'),
			_Utils_Tuple2('We\'ve got your CrowBar account all set up and ready to go. Once you log in, you can submit applications with just a few pieces of information and get bindable quotes back in minutes. All we need to do is create your password, so let\'s go!', 'We\'ve got your CrowBar account all set up and ready to go. Once you log in, you can submit applications with just a few pieces of information and get bindable quotes back in minutes. All we need to do is create your password, so let\'s go!'),
			_Utils_Tuple2('We\'ve got your CrowBar account all set up and ready to go. Once you log in, you can submit applications with just a few pieces of information and get bindable quotes back in minutes. All we need to do is create your password, so let\'s go! Your first quote is moments away.', 'We\'ve got your CrowBar account all set up and ready to go. Once you log in, you can submit applications with just a few pieces of information and get bindable quotes back in minutes. All we need to do is create your password, so let\'s go! Your first quote is moments away.'),
			_Utils_Tuple2('Welcome, %{user_name}!', 'Welcome, %{user_name}!'),
			_Utils_Tuple2('Your first quote is moments away.', 'Your first quote is moments away.'),
			_Utils_Tuple2('email application', 'email application'),
			_Utils_Tuple2('online application', 'online application'),
			_Utils_Tuple2('© %{year} • Corvus Insurance Holdings, Inc. • All rights reserved.', '© %{year} • Corvus Insurance Holdings, Inc. • All rights reserved.'),
			_Utils_Tuple2('Email your submissions to', 'Email your submissions to'),
			_Utils_Tuple2('This email was sent to', 'This email was sent to'),
			_Utils_Tuple2('Corvus Insurance Holdings, Inc.', 'Corvus Insurance Holdings, Inc.'),
			_Utils_Tuple2('Create Password', 'Create Password'),
			_Utils_Tuple2('Set up account', 'Set up account'),
			_Utils_Tuple2('Set up your account', 'Set up your account'),
			_Utils_Tuple2('Setting up…', 'Setting up…'),
			_Utils_Tuple2('Mid-term Adjustments have been made to the Premium. Please refer to the Post Bind tab to view, add or edit movements.', 'Mid-term Adjustments have been made to the Premium. Please refer to the Post Bind tab to view, add or edit movements.'),
			_Utils_Tuple2('A policy was successfully created for this submission on %{formattedDate}.', 'A policy was successfully created for this submission on %{formattedDate}.'),
			_Utils_Tuple2('Bound Option', 'Bound Option'),
			_Utils_Tuple2('Create Account', 'Create Account'),
			_Utils_Tuple2('Create Your Account', 'Create Your Account'),
			_Utils_Tuple2('Enter your email address to begin your account set up.', 'Enter your email address to begin your account set up.'),
			_Utils_Tuple2('Please check the email address again.', 'Please check the email address again.'),
			_Utils_Tuple2('Success, check your email for a link to create your password.', 'Success, check your email for a link to create your password.'),
			_Utils_Tuple2('Success: Please check your email for a link to create your password.', 'Success: Please check your email for a link to create your password.'),
			_Utils_Tuple2('Create New Password and Log In', 'Create New Password and Log In'),
			_Utils_Tuple2('Create Password and Sign In', 'Create Password and Sign In'),
			_Utils_Tuple2('Create Your Password', 'Create Your Password'),
			_Utils_Tuple2('Reset Your Password', 'Reset Your Password'),
			_Utils_Tuple2('Option %{num}', 'Option %{num}'),
			_Utils_Tuple2('Complete your Corvus Cyber Risk Dashboard account setup', 'Complete your Corvus Cyber Risk Dashboard account setup'),
			_Utils_Tuple2('Complete your Corvus account setup', 'Complete your Corvus account setup'),
			_Utils_Tuple2('Create Password at %{reset_url}', 'Create Password at %{reset_url}'),
			_Utils_Tuple2('Create a password, which must be at least eight characters long.', 'Create a password, which must be at least eight characters long.'),
			_Utils_Tuple2('Password set', 'Password set'),
			_Utils_Tuple2('Setting password…', 'Setting password…'),
			_Utils_Tuple2('Is Default?', 'Is Default?'),
			_Utils_Tuple2('Unable to rate until target premium calculation completes.', 'Unable to rate until target premium calculation completes.'),
			_Utils_Tuple2('5.56', '5.56'),
			_Utils_Tuple2('\n             If you have trouble scanning the code, you may enter the URL below the code into your authenticator application.\n            ', '\n             If you have trouble scanning the code, you may enter the URL below the code into your authenticator application.\n            '),
			_Utils_Tuple2('If you have trouble scanning the QR code, you can also enter the URL below into the authenticator app.', 'If you have trouble scanning the QR code, you can also enter the URL below into the authenticator app.'),
			_Utils_Tuple2('\n            To set up Multi Factor Authentication, you will need an authenticator app on your phone or computer.\n            You can scan the QR code using any such app - if you do not have an authenticator app, you can download one from the App Store.\n            ', '\n            To set up Multi Factor Authentication, you will need an authenticator app on your phone or computer.\n            You can scan the QR code using any such app - if you do not have an authenticator app, you can download one from the App Store.\n            '),
			_Utils_Tuple2('Copied', 'Copied'),
			_Utils_Tuple2('Copied!', 'Copied!'),
			_Utils_Tuple2('Copy to Clipboard', 'Copy to Clipboard'),
			_Utils_Tuple2('Copy URL', 'Copy URL'),
			_Utils_Tuple2('Approver', 'Approver'),
			_Utils_Tuple2('Send Referral', 'Send Referral'),
			_Utils_Tuple2('Summary Notes', 'Summary Notes'),
			_Utils_Tuple2('Preview Coverage Changes PDF', 'Preview Coverage Changes PDF'),
			_Utils_Tuple2('Include Year Over Year Policy Changes', 'Include Year Over Year Policy Changes'),
			_Utils_Tuple2('From: Smart Controls', 'From: Smart Controls'),
			_Utils_Tuple2('Have you completed the recommendation?', 'Have you completed the recommendation?'),
			_Utils_Tuple2('Have you looked into this issue?', 'Have you looked into this issue?'),
			_Utils_Tuple2('Back', 'Back'),
			_Utils_Tuple2('Leave us your thoughts regarding this recommendation. Our Risk Advisory team will review and be in touch.', 'Leave us your thoughts regarding this recommendation. Our Risk Advisory team will review and be in touch.'),
			_Utils_Tuple2('Send us a response. Have you taken the listed steps to close this vulnerability?', 'Send us a response. Have you taken the listed steps to close this vulnerability?'),
			_Utils_Tuple2('No response saved', 'No response saved'),
			_Utils_Tuple2('Approve Referral', 'Approve Referral'),
			_Utils_Tuple2('Approve a Referral ', 'Approve a Referral '),
			_Utils_Tuple2('This submission requires approval. ', 'This submission requires approval. '),
			_Utils_Tuple2('Approve referral for %{clientName}', 'Approve referral for %{clientName}'),
			_Utils_Tuple2('Create your Corvus Account', 'Create your Corvus Account'),
			_Utils_Tuple2('Control Description', 'Control Description'),
			_Utils_Tuple2('Controls Information', 'Controls Information'),
			_Utils_Tuple2('Description used for external communication, e.g. the pre-renewal solicitation email sent to brokers.', 'Description used for external communication, e.g. the pre-renewal solicitation email sent to brokers.'),
			_Utils_Tuple2('New/Renewal', 'New/Renewal'),
			_Utils_Tuple2('Save', 'Save'),
			_Utils_Tuple2('Enter Maximum Revenue', 'Enter Maximum Revenue'),
			_Utils_Tuple2('Enter Minimum Revenue', 'Enter Minimum Revenue'),
			_Utils_Tuple2('The proposed quoted terms are valid for %{valid_days} days and subject to the receipt, review, and acceptance of the following information:', 'The proposed quoted terms are valid for %{valid_days} days and subject to the receipt, review, and acceptance of the following information:'),
			_Utils_Tuple2('Latest referral submitted by %{name}.', 'Latest referral submitted by %{name}.'),
			_Utils_Tuple2('Submission approved by %{name}.', 'Submission approved by %{name}.'),
			_Utils_Tuple2('Start Renewal', 'Start Renewal'),
			_Utils_Tuple2('This submission is eligible for renewal.', 'This submission is eligible for renewal.'),
			_Utils_Tuple2('View Previous Policies', 'View Previous Policies'),
			_Utils_Tuple2('Alerting History', 'Alerting History'),
			_Utils_Tuple2('Detected Date', 'Detected Date'),
			_Utils_Tuple2('Failed to load the list of fingerprints.', 'Failed to load the list of fingerprints.'),
			_Utils_Tuple2('Fingerprints', 'Fingerprints'),
			_Utils_Tuple2('Fingerprints have not been loaded.', 'Fingerprints have not been loaded.'),
			_Utils_Tuple2('Internal Alerting', 'Internal Alerting'),
			_Utils_Tuple2('Loading fingerprints...', 'Loading fingerprints...'),
			_Utils_Tuple2('No fingerprints to list yet.', 'No fingerprints to list yet.'),
			_Utils_Tuple2('SENTINEL', 'SENTINEL'),
			_Utils_Tuple2('Type', 'Type'),
			_Utils_Tuple2('Breadth Cover (%)', 'Breadth Cover (%)'),
			_Utils_Tuple2('ACTIVE', 'ACTIVE'),
			_Utils_Tuple2('NOT ACTIVE', 'NOT ACTIVE'),
			_Utils_Tuple2('Back to Fingerprints', 'Back to Fingerprints'),
			_Utils_Tuple2('Detection Date', 'Detection Date'),
			_Utils_Tuple2('Threat Type', 'Threat Type'),
			_Utils_Tuple2('Line Slip', 'Line Slip'),
			_Utils_Tuple2('Corvus Total Declared Premium Income', 'Corvus Total Declared Premium Income'),
			_Utils_Tuple2('Corvus Total Expected Premium Income', 'Corvus Total Expected Premium Income'),
			_Utils_Tuple2('Line Slip Premium Overview', 'Line Slip Premium Overview'),
			_Utils_Tuple2('Total Declared Premium Income', 'Total Declared Premium Income'),
			_Utils_Tuple2('Total Expected Premium Income', 'Total Expected Premium Income'),
			_Utils_Tuple2('Retention Saver', 'Retention Saver'),
			_Utils_Tuple2('Endorsement Earned', 'Endorsement Earned'),
			_Utils_Tuple2('Endorsement Earned!', 'Endorsement Earned!'),
			_Utils_Tuple2('Continue Editing', 'Continue Editing'),
			_Utils_Tuple2('Questionnaires Complete!', 'Questionnaires Complete!'),
			_Utils_Tuple2('Not Yet Earned', 'Not Yet Earned'),
			_Utils_Tuple2('Progress Tracker', 'Progress Tracker'),
			_Utils_Tuple2('Security Advanced', 'Security Advanced'),
			_Utils_Tuple2('Your progress towards earning the Retention Reduction Endorsement is credited regardless of your answer choice.', 'Your progress towards earning the Retention Reduction Endorsement is credited regardless of your answer choice.'),
			_Utils_Tuple2('Internal Notes', 'Internal Notes'),
			_Utils_Tuple2('Endorsement Earned For Renewal', 'Endorsement Earned For Renewal'),
			_Utils_Tuple2('Other Details', 'Other Details'),
			_Utils_Tuple2('The Retention Reduction Endorsement was earned on this policy.', 'The Retention Reduction Endorsement was earned on this policy.'),
			_Utils_Tuple2('Alert', 'Alert'),
			_Utils_Tuple2('Published', 'Published'),
			_Utils_Tuple2('Corvus Adjusted Premium Amount', 'Corvus Adjusted Premium Amount'),
			_Utils_Tuple2('Corvus Original Premium Amount', 'Corvus Original Premium Amount'),
			_Utils_Tuple2('Loading Line Slip Summary…', 'Loading Line Slip Summary…'),
			_Utils_Tuple2('Deductible', 'Deductible'),
			_Utils_Tuple2('<tag>The Retention Reduction Endorsement</tag> is now live. Save up to 25% on your retention by completing the questionnaires below.', '<tag>The Retention Reduction Endorsement</tag> is now live. Save up to 25% on your retention by completing the questionnaires below.'),
			_Utils_Tuple2('Save up to <tag>25%</tag> on your retention at policy renewal by completing 2 questionnaires.', 'Save up to <tag>25%</tag> on your retention at policy renewal by completing 2 questionnaires.'),
			_Utils_Tuple2('Save up to <tag>25%</tag> on your retention simply by completing 2 questionnaires.', 'Save up to <tag>25%</tag> on your retention simply by completing 2 questionnaires.'),
			_Utils_Tuple2('Create Threat', 'Create Threat'),
			_Utils_Tuple2('Creating Threat', 'Creating Threat'),
			_Utils_Tuple2('Threat Name', 'Threat Name'),
			_Utils_Tuple2('Threats', 'Threats'),
			_Utils_Tuple2('Binder', 'Binder'),
			_Utils_Tuple2('Expiring Policy', 'Expiring Policy'),
			_Utils_Tuple2('Nature of Business: %{nob}', 'Nature of Business: %{nob}'),
			_Utils_Tuple2('Refined Nature of Business (NAICS Code)', 'Refined Nature of Business (NAICS Code)'),
			_Utils_Tuple2('Nature of Business', 'Nature of Business'),
			_Utils_Tuple2('View Referral', 'View Referral'),
			_Utils_Tuple2('Referral Comments', 'Referral Comments'),
			_Utils_Tuple2('Phasing Plan', 'Phasing Plan'),
			_Utils_Tuple2('Beat doesn\'t require all data to be completed.\n            If anything is missing in your submission,\n            an alert will indicate it after you click the button below.', 'Beat doesn\'t require all data to be completed.\n            If anything is missing in your submission,\n            an alert will indicate it after you click the button below.'),
			_Utils_Tuple2('Authorised (External) On - Date', 'Authorised (External) On - Date'),
			_Utils_Tuple2('Authorised (Internal) On - Date', 'Authorised (Internal) On - Date'),
			_Utils_Tuple2('Remove Risk Code', 'Remove Risk Code'),
			_Utils_Tuple2('Corvus is Leading Insurer', 'Corvus is Leading Insurer'),
			_Utils_Tuple2('Corvus is a Following Insurer', 'Corvus is a Following Insurer'),
			_Utils_Tuple2('Insurance Carrier', 'Insurance Carrier'),
			_Utils_Tuple2('Something is wrong with this submission\'s Quote Option. Refresh to try again, or contact support if this problem persists', 'Something is wrong with this submission\'s Quote Option. Refresh to try again, or contact support if this problem persists'),
			_Utils_Tuple2('Total Layer Limit', 'Total Layer Limit'),
			_Utils_Tuple2('Gross Premium Income Limit', 'Gross Premium Income Limit'),
			_Utils_Tuple2('PCC Accrual %', 'PCC Accrual %'),
			_Utils_Tuple2('Reporting Cap %', 'Reporting Cap %'),
			_Utils_Tuple2('Slip Commission %', 'Slip Commission %'),
			_Utils_Tuple2('UW Expenses PC %', 'UW Expenses PC %'),
			_Utils_Tuple2('Rest Of World (for Austria)', 'Rest Of World (for Austria)'),
			_Utils_Tuple2('Rest Of World (for Germany)', 'Rest Of World (for Germany)'),
			_Utils_Tuple2('View Line Slip', 'View Line Slip'),
			_Utils_Tuple2('Binder Stamps', 'Binder Stamps'),
			_Utils_Tuple2('View Associated Line Slip', 'View Associated Line Slip'),
			_Utils_Tuple2('Failed to derive Line Slip Summary due to currency mismatch', 'Failed to derive Line Slip Summary due to currency mismatch'),
			_Utils_Tuple2('Under Construction', 'Under Construction'),
			_Utils_Tuple2('Last saved', 'Last saved'),
			_Utils_Tuple2('Attach Declaration to Line Slip', 'Attach Declaration to Line Slip'),
			_Utils_Tuple2('Start Declaration Renewal', 'Start Declaration Renewal'),
			_Utils_Tuple2('Adjusted Expected Premium', 'Adjusted Expected Premium'),
			_Utils_Tuple2('Bord. Reporting Date', 'Bord. Reporting Date'),
			_Utils_Tuple2('Declared Premium', 'Declared Premium'),
			_Utils_Tuple2('Expected Premium', 'Expected Premium'),
			_Utils_Tuple2('+ Add Row', '+ Add Row'),
			_Utils_Tuple2('The recommendations below are generated from either the monthly Corvus Scan (score-impacting) or answers you provided from the Security Questionnaire modules (not score-impacting).', 'The recommendations below are generated from either the monthly Corvus Scan (score-impacting) or answers you provided from the Security Questionnaire modules (not score-impacting).'),
			_Utils_Tuple2('If this recommendation has shown up again, please take a closer look at the table for new or returned impacted assets.', 'If this recommendation has shown up again, please take a closer look at the table for new or returned impacted assets.'),
			_Utils_Tuple2('Stamp: ', 'Stamp: '),
			_Utils_Tuple2('View Expired Line Slip', 'View Expired Line Slip'),
			_Utils_Tuple2('Beat Consortium Lead', 'Beat Consortium Lead'),
			_Utils_Tuple2('Risk Capital Partner', 'Risk Capital Partner'),
			_Utils_Tuple2('Travelers UK RCP', 'Travelers UK RCP'),
			_Utils_Tuple2('Bulking Line Slip Stamps', 'Bulking Line Slip Stamps'),
			_Utils_Tuple2('Date Added', 'Date Added'),
			_Utils_Tuple2('Domain Type', 'Domain Type'),
			_Utils_Tuple2('Notes', 'Notes'),
			_Utils_Tuple2('The scan has detected critical findings on this account\'s ', 'The scan has detected critical findings on this account\'s '),
			_Utils_Tuple2('These findings result in auto-declinations when detected on the primary domain for new business accounts. ', 'These findings result in auto-declinations when detected on the primary domain for new business accounts. '),
			_Utils_Tuple2('View Details Here', 'View Details Here'),
			_Utils_Tuple2('additional domains', 'additional domains'),
			_Utils_Tuple2('Corvus Total', 'Corvus Total'),
			_Utils_Tuple2('Stamp Total', 'Stamp Total'),
			_Utils_Tuple2('Total Adjusted Premium', 'Total Adjusted Premium'),
			_Utils_Tuple2('Total Declared Premium', 'Total Declared Premium'),
			_Utils_Tuple2('Total Expected Premium', 'Total Expected Premium'),
			_Utils_Tuple2('Total Revised Premium', 'Total Revised Premium'),
			_Utils_Tuple2('Travelers Policy Number', 'Travelers Policy Number'),
			_Utils_Tuple2('Policy #: ', 'Policy #: '),
			_Utils_Tuple2('Binder Slip Phasing Plan', 'Binder Slip Phasing Plan'),
			_Utils_Tuple2('Bulking Line Slip Phasing Plan', 'Bulking Line Slip Phasing Plan'),
			_Utils_Tuple2('Corvus Totals', 'Corvus Totals'),
			_Utils_Tuple2('Stamp Totals', 'Stamp Totals'),
			_Utils_Tuple2('Haven\'t completed this state yet.', 'Haven\'t completed this state yet.'),
			_Utils_Tuple2('Summary Overview', 'Summary Overview'),
			_Utils_Tuple2('Bulking Line Slip', 'Bulking Line Slip'),
			_Utils_Tuple2('Non-Bulking Line Slip', 'Non-Bulking Line Slip'),
			_Utils_Tuple2('Monthly Bordereau Reports', 'Monthly Bordereau Reports'),
			_Utils_Tuple2('New Findings', 'New Findings'),
			_Utils_Tuple2('VPN Name', 'VPN Name'),
			_Utils_Tuple2('Send Data To Travelers', 'Send Data To Travelers'),
			_Utils_Tuple2('The input on this tab was successfully submitted to Beat. (%{dateString})', 'The input on this tab was successfully submitted to Beat. (%{dateString})'),
			_Utils_Tuple2('Travelers doesn\'t require all data to be completed.\n            If anything is missing in your submission,\n            an alert will indicate it after you click the button below.', 'Travelers doesn\'t require all data to be completed.\n            If anything is missing in your submission,\n            an alert will indicate it after you click the button below.'),
			_Utils_Tuple2('The input on this tab was successfully submitted to Travelers. (%{dateString})', 'The input on this tab was successfully submitted to Travelers. (%{dateString})'),
			_Utils_Tuple2('High Impact', 'High Impact'),
			_Utils_Tuple2('Medium Impact', 'Medium Impact'),
			_Utils_Tuple2('Policy quotes, terms and conditions, and premiums are made in accordance with Corvus Insurance\'s underwriting guidelines. Addressing the findings below does not guarantee eligibility for a renewal quote.', 'Policy quotes, terms and conditions, and premiums are made in accordance with Corvus Insurance\'s underwriting guidelines. Addressing the findings below does not guarantee eligibility for a renewal quote.'),
			_Utils_Tuple2('Third-Party Tracking Technology Type', 'Third-Party Tracking Technology Type'),
			_Utils_Tuple2('Detection of Third-Party Tracking Technology.', 'Detection of Third-Party Tracking Technology.'),
			_Utils_Tuple2('Organizations should discuss the business necessity of the identified third-party tracking technologies and that appropriate user consent is obtained. Third-party tracking technologies may create privacy concerns by sending user data to third-parties when there is not a valid business justification to do so. Plaintiffs counsel have filed many privacy class action lawsuits against companies using website tracking technologies.', 'Organizations should discuss the business necessity of the identified third-party tracking technologies and that appropriate user consent is obtained. Third-party tracking technologies may create privacy concerns by sending user data to third-parties when there is not a valid business justification to do so. Plaintiffs counsel have filed many privacy class action lawsuits against companies using website tracking technologies.'),
			_Utils_Tuple2('Organizations should review impacted website(s) for code relating to tracking technologies and determine if the benefits of using tracking technologies outweigh the potential for privacy liability. Remove the tracker by deleting the base code from the webpages of your site. It may also be present in a tag manager, such as Google Tag Manager. If your organization continues using the technology, be sure to review your cookie consent and privacy policy language.', 'Organizations should review impacted website(s) for code relating to tracking technologies and determine if the benefits of using tracking technologies outweigh the potential for privacy liability. Remove the tracker by deleting the base code from the webpages of your site. It may also be present in a tag manager, such as Google Tag Manager. If your organization continues using the technology, be sure to review your cookie consent and privacy policy language.'),
			_Utils_Tuple2('The Cyber Risk Scan identified JavaScript code embedded within a website associated with your organization that is indicative of a Third-Party Tracking Technology.', 'The Cyber Risk Scan identified JavaScript code embedded within a website associated with your organization that is indicative of a Third-Party Tracking Technology.'),
			_Utils_Tuple2('Provide the client\'s primary domain below to begin scanning.', 'Provide the client\'s primary domain below to begin scanning.'),
			_Utils_Tuple2('Scan Failed', 'Scan Failed'),
			_Utils_Tuple2('Scan Not Started', 'Scan Not Started'),
			_Utils_Tuple2('Scan in Progress…', 'Scan in Progress…'),
			_Utils_Tuple2('Something went wrong', 'Something went wrong'),
			_Utils_Tuple2('View Expired Binder', 'View Expired Binder'),
			_Utils_Tuple2('View Expired Bulking Line Slip', 'View Expired Bulking Line Slip'),
			_Utils_Tuple2('Binder Renewal', 'Binder Renewal'),
			_Utils_Tuple2('Bulking Line Slip Renewal', 'Bulking Line Slip Renewal'),
			_Utils_Tuple2('Non-Bulking Line Slip Renewal', 'Non-Bulking Line Slip Renewal'),
			_Utils_Tuple2('Disable', 'Disable'),
			_Utils_Tuple2('This submission is scheduled for an application-free renewal quote on %{date}', 'This submission is scheduled for an application-free renewal quote on %{date}'),
			_Utils_Tuple2('Disable Auto-quote', 'Disable Auto-quote'),
			_Utils_Tuple2('Disabling auto-renew for <tag>%{client_name}</tag>.', 'Disabling auto-renew for <tag>%{client_name}</tag>.'),
			_Utils_Tuple2('%{product}', '%{product}'),
			_Utils_Tuple2('%{product} Renewal', '%{product} Renewal'),
			_Utils_Tuple2('%{productTypeStr}', '%{productTypeStr}'),
			_Utils_Tuple2('%{productTypeStr} Renewal', '%{productTypeStr} Renewal'),
			_Utils_Tuple2('%{productTypeStr Submission}', '%{productTypeStr Submission}'),
			_Utils_Tuple2('%{productTypeStr} Submission', '%{productTypeStr} Submission'),
			_Utils_Tuple2('Detection of Known Exploited Vulnerabilities.', 'Detection of Known Exploited Vulnerabilities.'),
			_Utils_Tuple2('Organizations should apply the appropriate patch to impacted systems/software and ensure that a patch management process exists so that Known Exploited Vulnerabilities are patched within 48 hours.', 'Organizations should apply the appropriate patch to impacted systems/software and ensure that a patch management process exists so that Known Exploited Vulnerabilities are patched within 48 hours.'),
			_Utils_Tuple2('The Cyber Risk Scan identified %{vuln_count} Known Exploited Vulnerabilities (KEV) on %{num_servers} server(s) associated with your organization.', 'The Cyber Risk Scan identified %{vuln_count} Known Exploited Vulnerabilities (KEV) on %{num_servers} server(s) associated with your organization.'),
			_Utils_Tuple2('Please wait five minutes before refreshing the scan.', 'Please wait five minutes before refreshing the scan.'),
			_Utils_Tuple2('Scan Cancelled', 'Scan Cancelled'),
			_Utils_Tuple2('Someone has already run a scan on this primary domain within the last five minutes.', 'Someone has already run a scan on this primary domain within the last five minutes.'),
			_Utils_Tuple2('Primary website currently set to pleaseignore.com', 'Primary website currently set to pleaseignore.com'),
			_Utils_Tuple2('Scan Bypassed', 'Scan Bypassed'),
			_Utils_Tuple2('Provide the client\'s primary domain in a submission to begin scanning', 'Provide the client\'s primary domain in a submission to begin scanning'),
			_Utils_Tuple2('Learn More', 'Learn More'),
			_Utils_Tuple2('No scan risk findings detected at this time', 'No scan risk findings detected at this time'),
			_Utils_Tuple2('From: %{domain}', 'From: %{domain}'),
			_Utils_Tuple2('From: %{domain} (primary)', 'From: %{domain} (primary)'),
			_Utils_Tuple2('Score factor', 'Score factor'),
			_Utils_Tuple2('Scan findings that influence your Cyber Risk Score. The Cyber Risk Score informs the likelihood of a security or privacy event that could lead to a claim based on your external risk profile. These are intended to identify and remediate contributing risk factors for incidents that may cause financial and reputational damage.', 'Scan findings that influence your Cyber Risk Score. The Cyber Risk Score informs the likelihood of a security or privacy event that could lead to a claim based on your external risk profile. These are intended to identify and remediate contributing risk factors for incidents that may cause financial and reputational damage.'),
			_Utils_Tuple2('Underwriting factor', 'Underwriting factor'),
			_Utils_Tuple2('Components of your external risk profile identified with the Cyber Risk Scan. The findings highlight opportunities for your organization that may include preferred pricing or a streamlined renewal experience.', 'Components of your external risk profile identified with the Cyber Risk Scan. The findings highlight opportunities for your organization that may include preferred pricing or a streamlined renewal experience.'),
			_Utils_Tuple2('Pricing Factor (SBRAF)', 'Pricing Factor (SBRAF)'),
			_Utils_Tuple2('No Credit/Debit', 'No Credit/Debit'),
			_Utils_Tuple2('(No Credit/Debit)', '(No Credit/Debit)'),
			_Utils_Tuple2('No pricing factor (SBRAF) findings detected at this time.', 'No pricing factor (SBRAF) findings detected at this time.'),
			_Utils_Tuple2('Pricing Factor (SBRAF) Value: %{value}', 'Pricing Factor (SBRAF) Value: %{value}'),
			_Utils_Tuple2('These were the factors found for this insured which are causing a debit value, ordered by severity.', 'These were the factors found for this insured which are causing a debit value, ordered by severity.'),
			_Utils_Tuple2('Application-free renewal for <strong>%{client}</strong>', 'Application-free renewal for <strong>%{client}</strong>'),
			_Utils_Tuple2('Upon binding, you will receive an email confirmation with your binder documents, invoice, and post-bind subjectivities.', 'Upon binding, you will receive an email confirmation with your binder documents, invoice, and post-bind subjectivities.'),
			_Utils_Tuple2('Bind Options', 'Bind Options'),
			_Utils_Tuple2('Terrorism Risk Insurance Act is federal legislation guaranteeing the availability of insurance coverage against acts of international terrorism. Please confirm with your client before waiving as your client may then not be covered against acts of terrorism.', 'Terrorism Risk Insurance Act is federal legislation guaranteeing the availability of insurance coverage against acts of international terrorism. Please confirm with your client before waiving as your client may then not be covered against acts of terrorism.'),
			_Utils_Tuple2('Not seeing what you\'re looking for? Contact %{underwriter}', 'Not seeing what you\'re looking for? Contact %{underwriter}'),
			_Utils_Tuple2('The quote for %{client} was bound on %{bindDate} and is going to become effective on %{effectiveDate}. You will receive an email confirmation with your <strong>binder documents, invoice, and post-bind subjectivities</strong> within a few minutes. In the case you don\'t receive an email confirmation, please reach out to <a>%{underwriter}</a>.', 'The quote for %{client} was bound on %{bindDate} and is going to become effective on %{effectiveDate}. You will receive an email confirmation with your <strong>binder documents, invoice, and post-bind subjectivities</strong> within a few minutes. In the case you don\'t receive an email confirmation, please reach out to <a>%{underwriter}</a>.'),
			_Utils_Tuple2('Success! Thank you for renewing with Corvus!', 'Success! Thank you for renewing with Corvus!'),
			_Utils_Tuple2('Have a moment to complete a post-bind subjectivity?', 'Have a moment to complete a post-bind subjectivity?'),
			_Utils_Tuple2('Fill out Surplus Lines Certificate', 'Fill out Surplus Lines Certificate'),
			_Utils_Tuple2('No worries, you can still bind with us! Please contact <a>%{underwriterName}</a>.', 'No worries, you can still bind with us! Please contact <a>%{underwriterName}</a>.'),
			_Utils_Tuple2('This quote expired on %{expirationDate}.', 'This quote expired on %{expirationDate}.'),
			_Utils_Tuple2('We are not able to process this request at this time.', 'We are not able to process this request at this time.'),
			_Utils_Tuple2('From: Other Owned IP Ranges', 'From: Other Owned IP Ranges'),
			_Utils_Tuple2('Change Due To Other (%)', 'Change Due To Other (%)'),
			_Utils_Tuple2('Bordereau Reports', 'Bordereau Reports'),
			_Utils_Tuple2('Actions', 'Actions'),
			_Utils_Tuple2('No emails have been sent', 'No emails have been sent'),
			_Utils_Tuple2('Premium Assigned To Stamp Layer', 'Premium Assigned To Stamp Layer'),
			_Utils_Tuple2('Cyber Risk Insights', 'Cyber Risk Insights'),
			_Utils_Tuple2('Policyholder Engagement Insights', 'Policyholder Engagement Insights'),
			_Utils_Tuple2('INTERNAL ONLY:', 'INTERNAL ONLY:'),
			_Utils_Tuple2('Shareable: Talking Point', 'Shareable: Talking Point'),
			_Utils_Tuple2('The content below may also be found in the DLP PDF and scan results section of the Policyholder Dashboard', 'The content below may also be found in the DLP PDF and scan results section of the Policyholder Dashboard'),
			_Utils_Tuple2('Underwriter Insights', 'Underwriter Insights'),
			_Utils_Tuple2('Signal Endorsement earned', 'Signal Endorsement earned'),
			_Utils_Tuple2('Signal Endorsement earned for renewal', 'Signal Endorsement earned for renewal'),
			_Utils_Tuple2('Quota Share', 'Quota Share'),
			_Utils_Tuple2('Jira Tickets', 'Jira Tickets'),
			_Utils_Tuple2('Endorsement Not Earned', 'Endorsement Not Earned'),
			_Utils_Tuple2('Signal Endorsement', 'Signal Endorsement'),
			_Utils_Tuple2('No Jira tickets to show.', 'No Jira tickets to show.'),
			_Utils_Tuple2('Download Report', 'Download Report'),
			_Utils_Tuple2('New Questions', 'New Questions'),
			_Utils_Tuple2('Corvus London Markets', 'Corvus London Markets'),
			_Utils_Tuple2('Cyber', 'Cyber'),
			_Utils_Tuple2('Cyber EU', 'Cyber EU'),
			_Utils_Tuple2('Tech E&O', 'Tech E&O'),
			_Utils_Tuple2('Questionnaires Complete', 'Questionnaires Complete'),
			_Utils_Tuple2('Risk Advisory Interactions', 'Risk Advisory Interactions'),
			_Utils_Tuple2('This policyholder has completed both questionnaires, but does not yet have the Signal Endorsement on their current policy. If the policyholder decides to renew, the Signal Endorsement will be valid and counted as earned starting on the first day of their new policy.', 'This policyholder has completed both questionnaires, but does not yet have the Signal Endorsement on their current policy. If the policyholder decides to renew, the Signal Endorsement will be valid and counted as earned starting on the first day of their new policy.'),
			_Utils_Tuple2('Corvus Score Value: %{score}', 'Corvus Score Value: %{score}'),
			_Utils_Tuple2('Score Improvement Tool (Ransomware Only)', 'Score Improvement Tool (Ransomware Only)'),
			_Utils_Tuple2('Policy', 'Policy'),
			_Utils_Tuple2('Time of Completion', 'Time of Completion'),
			_Utils_Tuple2('Questionnaires complete', 'Questionnaires complete'),
			_Utils_Tuple2('There are new optional questions available. You have still earned the Retention Reduction Endorsement as shown. Your progress towards earning the Retention Reduction Endorsement remains credited regardless of your answer choice.', 'There are new optional questions available. You have still earned the Retention Reduction Endorsement as shown. Your progress towards earning the Retention Reduction Endorsement remains credited regardless of your answer choice.'),
			_Utils_Tuple2('You have now earned <tag>The Retention Reduction Endorsement</tag>. You are saving up to 25% on your retention thanks to completing the questionnaires below.', 'You have now earned <tag>The Retention Reduction Endorsement</tag>. You are saving up to 25% on your retention thanks to completing the questionnaires below.'),
			_Utils_Tuple2('Price Impact', 'Price Impact'),
			_Utils_Tuple2('Score Impact', 'Score Impact'),
			_Utils_Tuple2('Stamp Premium (Corvus Layer)', 'Stamp Premium (Corvus Layer)'),
			_Utils_Tuple2('Stamp Premium (Total Layer)', 'Stamp Premium (Total Layer)'),
			_Utils_Tuple2('No eligible policy.', 'No eligible policy.'),
			_Utils_Tuple2('Not eligible for Signal Endorsement', 'Not eligible for Signal Endorsement'),
			_Utils_Tuple2('Signal Endorsement not earned', 'Signal Endorsement not earned'),
			_Utils_Tuple2('Controls', 'Controls'),
			_Utils_Tuple2('Email Filtering: ', 'Email Filtering: '),
			_Utils_Tuple2('The scan has detected no controls findings at this time.', 'The scan has detected no controls findings at this time.'),
			_Utils_Tuple2('Choose One ', 'Choose One '),
			_Utils_Tuple2('Corvus is Following Insurer', 'Corvus is Following Insurer'),
			_Utils_Tuple2('Select Carrier', 'Select Carrier'),
			_Utils_Tuple2('Total Layer', 'Total Layer'),
			_Utils_Tuple2('Provided Domains', 'Provided Domains'),
			_Utils_Tuple2('+ Add Insurer', '+ Add Insurer'),
			_Utils_Tuple2('View Finding Details', 'View Finding Details'),
			_Utils_Tuple2('Pricing Factor (SBRAF) is only available for clients with Travelers cyber accounts at this time.', 'Pricing Factor (SBRAF) is only available for clients with Travelers cyber accounts at this time.'),
			_Utils_Tuple2('Pricing Factor (SBRAF) is unavailable, refresh the scan to retry.', 'Pricing Factor (SBRAF) is unavailable, refresh the scan to retry.'),
			_Utils_Tuple2('Disputed Domains', 'Disputed Domains'),
			_Utils_Tuple2('BIND CONFIRMATION FOR %{tag0} %{tag1}%{client_name}%{tag2}', 'BIND CONFIRMATION FOR %{tag0} %{tag1}%{client_name}%{tag2}'),
			_Utils_Tuple2('Bind Confirmation for %{tag0} %{tag1}%{client_name}%{tag2}', 'Bind Confirmation for %{tag0} %{tag1}%{client_name}%{tag2}'),
			_Utils_Tuple2('Eligibility for such programs is determined when you apply for coverage. Policy quotes, terms and conditions, and premiums are made in accordance with Corvus Insurance’s underwriting guidelines. The policy, not general descriptions or material within this email, will form the contract between the insured and our insurance carrier partners. Coverage may not be available in all jurisdictions.', 'Eligibility for such programs is determined when you apply for coverage. Policy quotes, terms and conditions, and premiums are made in accordance with Corvus Insurance’s underwriting guidelines. The policy, not general descriptions or material within this email, will form the contract between the insured and our insurance carrier partners. Coverage may not be available in all jurisdictions.'),
			_Utils_Tuple2('Thank you, %{tag} %{underwriter_name}', 'Thank you, %{tag} %{underwriter_name}'),
			_Utils_Tuple2('You successfully bound the account %{client_name}. The new expiration date is %{policy_expiration_date}. Your binder and invoice are attached in this email.', 'You successfully bound the account %{client_name}. The new expiration date is %{policy_expiration_date}. Your binder and invoice are attached in this email.'),
			_Utils_Tuple2('Policyholder Dashboard View', 'Policyholder Dashboard View'),
			_Utils_Tuple2('Add a Domain', 'Add a Domain'),
			_Utils_Tuple2('Please double check the UMR number is correct before continuing to Bind.', 'Please double check the UMR number is correct before continuing to Bind.'),
			_Utils_Tuple2('MFA: Step %{step} of %{totalSteps}', 'MFA: Step %{step} of %{totalSteps}'),
			_Utils_Tuple2('Go to last step', 'Go to last step'),
			_Utils_Tuple2('Here is an example of how to access this feature.', 'Here is an example of how to access this feature.'),
			_Utils_Tuple2('Locate the \'Scan QR code\' feature in the app.', 'Locate the \'Scan QR code\' feature in the app.'),
			_Utils_Tuple2('Once located, move on to the last step.', 'Once located, move on to the last step.'),
			_Utils_Tuple2('Once the authenticator app is open, locate the \'Scan QR code\' feature <tag>within the authenticator app</tag>.', 'Once the authenticator app is open, locate the \'Scan QR code\' feature <tag>within the authenticator app</tag>.'),
			_Utils_Tuple2('Scan the QR code to verify.', 'Scan the QR code to verify.'),
			_Utils_Tuple2('<tag>A new</tag> (and very secure) <tag>dawn.</tag>', '<tag>A new</tag> (and very secure) <tag>dawn.</tag>'),
			_Utils_Tuple2('By the end of 2024, MFA will be a required process for all users logging into the dashboard.', 'By the end of 2024, MFA will be a required process for all users logging into the dashboard.'),
			_Utils_Tuple2('I\'ll do it later', 'I\'ll do it later'),
			_Utils_Tuple2('Save time and opt-in today.', 'Save time and opt-in today.'),
			_Utils_Tuple2('Set up MFA', 'Set up MFA'),
			_Utils_Tuple2('Set up Multi-Factor Authentication?', 'Set up Multi-Factor Authentication?'),
			_Utils_Tuple2('Set up Multi-Factor Authentication', 'Set up Multi-Factor Authentication'),
			_Utils_Tuple2('Download an authenticator app on your mobile device if you don’t already have one. We recommend <tag>Google Authenticator</tag> or <tag>Microsoft Authenticator.</tag>', 'Download an authenticator app on your mobile device if you don’t already have one. We recommend <tag>Google Authenticator</tag> or <tag>Microsoft Authenticator.</tag>'),
			_Utils_Tuple2('Download an authenticator app.', 'Download an authenticator app.'),
			_Utils_Tuple2('Here are some more authenticator options.', 'Here are some more authenticator options.'),
			_Utils_Tuple2('Locating the \'Scan QR Code\' feature', 'Locating the \'Scan QR Code\' feature'),
			_Utils_Tuple2('Suggested authenticator apps', 'Suggested authenticator apps'),
			_Utils_Tuple2('Suggested Authenticator Apps', 'Suggested Authenticator Apps'),
			_Utils_Tuple2('For your security, Corvus now requires that users access their accounts using MFA.', 'For your security, Corvus now requires that users access their accounts using MFA.'),
			_Utils_Tuple2('For your security, <tag>Travelers now requires that users access their accounts using MFA.</tag>', 'For your security, <tag>Travelers now requires that users access their accounts using MFA.</tag>'),
			_Utils_Tuple2('MFA helps protect you against hackers, and works by asking you for additional information when you log in.', 'MFA helps protect you against hackers, and works by asking you for additional information when you log in.'),
			_Utils_Tuple2('Set up MFA today to access your dashboard.', 'Set up MFA today to access your dashboard.'),
			_Utils_Tuple2('Enter the 6-digit code generated by your Multi-Factor Authentication (MFA) app.', 'Enter the 6-digit code generated by your Multi-Factor Authentication (MFA) app.'),
			_Utils_Tuple2('Need help setting up MFA', 'Need help setting up MFA'),
			_Utils_Tuple2('Need help signing in with MFA', 'Need help signing in with MFA'),
			_Utils_Tuple2('Need help with email address entry for account setup', 'Need help with email address entry for account setup'),
			_Utils_Tuple2('Need help with email address entry for password reset', 'Need help with email address entry for password reset'),
			_Utils_Tuple2('Need help creating a password for account setup', 'Need help creating a password for account setup'),
			_Utils_Tuple2('Need help creating a new password for reset', 'Need help creating a new password for reset'),
			_Utils_Tuple2('Go to sign in page', 'Go to sign in page'),
			_Utils_Tuple2('Sign in with existing account', 'Sign in with existing account'),
			_Utils_Tuple2('Sign in to manage your Corvus Insurance dashboard.', 'Sign in to manage your Corvus Insurance dashboard.'),
			_Utils_Tuple2('You may have used Google Authenticator, Microsoft Authenticator, or a similar app on your phone to set up MFA.', 'You may have used Google Authenticator, Microsoft Authenticator, or a similar app on your phone to set up MFA.'),
			_Utils_Tuple2('I Need Help', 'I Need Help'),
			_Utils_Tuple2('Once downloaded, proceed to the next step.', 'Once downloaded, proceed to the next step.'),
			_Utils_Tuple2('Previous', 'Previous'),
			_Utils_Tuple2('Next step', 'Next step'),
			_Utils_Tuple2('Corvus by Travelers', 'Corvus by Travelers'),
			_Utils_Tuple2('Corvus by Travelers logo', 'Corvus by Travelers logo'),
			_Utils_Tuple2('close modal', 'close modal'),
			_Utils_Tuple2('delete control', 'delete control'),
			_Utils_Tuple2('delete limit retention pair', 'delete limit retention pair'),
			_Utils_Tuple2('delete endorsement', 'delete endorsement'),
			_Utils_Tuple2('Option %{indexString} Limit', 'Option %{indexString} Limit'),
			_Utils_Tuple2('Option %{indexString} Retention', 'Option %{indexString} Retention'),
			_Utils_Tuple2('Quoted At', 'Quoted At'),
			_Utils_Tuple2('Attach Pre-Filled Application as Separate PDF', 'Attach Pre-Filled Application as Separate PDF'),
			_Utils_Tuple2('Preview Corvus Application PDF', 'Preview Corvus Application PDF'),
			_Utils_Tuple2('Select Label', 'Select Label'),
			_Utils_Tuple2('Failed to retrieve Control information. Please contact support if this message persists after refresh', 'Failed to retrieve Control information. Please contact support if this message persists after refresh'),
			_Utils_Tuple2('Data Science Insights', 'Data Science Insights'),
			_Utils_Tuple2('Decline unless compensation controls are obtained.', 'Decline unless compensation controls are obtained.'),
			_Utils_Tuple2('Email Provider', 'Email Provider'),
			_Utils_Tuple2('Error loading the vulnerabilities please try again.', 'Error loading the vulnerabilities please try again.'),
			_Utils_Tuple2('Having at least 1 internal system increases vulnerability', 'Having at least 1 internal system increases vulnerability'),
			_Utils_Tuple2('Internal Hosting', 'Internal Hosting'),
			_Utils_Tuple2('Our risk model considers critical and high vulnerabilities from the national vulnerability database for relevant software detected on your public infrastructure.', 'Our risk model considers critical and high vulnerabilities from the national vulnerability database for relevant software detected on your public infrastructure.'),
			_Utils_Tuple2('Pixel Software', 'Pixel Software'),
			_Utils_Tuple2('Scan Information', 'Scan Information'),
			_Utils_Tuple2('Secure Email Provider', 'Secure Email Provider'),
			_Utils_Tuple2('This client uses %{providerName} as their email security provider.', 'This client uses %{providerName} as their email security provider.'),
			_Utils_Tuple2('This client uses %{providerName} as their email security provider. This improves email security through better phishing controls and malicious attachment detection.', 'This client uses %{providerName} as their email security provider. This improves email security through better phishing controls and malicious attachment detection.'),
			_Utils_Tuple2('Vulnerable Email Provider', 'Vulnerable Email Provider'),
			_Utils_Tuple2('EXPIRED', 'EXPIRED'),
			_Utils_Tuple2('UPCOMING', 'UPCOMING'),
			_Utils_Tuple2('Report Bind Data', 'Report Bind Data'),
			_Utils_Tuple2('Reported Binds', 'Reported Binds'),
			_Utils_Tuple2('Report Bind', 'Report Bind'),
			_Utils_Tuple2('Delete Bind Data', 'Delete Bind Data'),
			_Utils_Tuple2('Discard Edits', 'Discard Edits'),
			_Utils_Tuple2('Edit Bind', 'Edit Bind'),
			_Utils_Tuple2('Edit Bind Data', 'Edit Bind Data'),
			_Utils_Tuple2('Welcome to Corvus', 'Welcome to Corvus'),
			_Utils_Tuple2('Welcome, %{tag}%{user_name}!', 'Welcome, %{tag}%{user_name}!'),
			_Utils_Tuple2('As a Corvus policyholder, you have access to Risk Prevention Services.', 'As a Corvus policyholder, you have access to Risk Prevention Services.'),
			_Utils_Tuple2('As a Travelers CyberRisk policyholder, you have access to Risk Prevention Services provided by the team at Corvus, a subsidiary of Travelers that specializes in cyber risk.', 'As a Travelers CyberRisk policyholder, you have access to Risk Prevention Services provided by the team at Corvus, a subsidiary of Travelers that specializes in cyber risk.'),
			_Utils_Tuple2('By setting up your account, you’ll unlock access to services that have been shown to reduce the likelihood of a cyber attack by 20%.', 'By setting up your account, you’ll unlock access to services that have been shown to reduce the likelihood of a cyber attack by 20%.'),
			_Utils_Tuple2('Complete Your Account Setup', 'Complete Your Account Setup'),
			_Utils_Tuple2('Services include:', 'Services include:'),
			_Utils_Tuple2('Set Up Account', 'Set Up Account'),
			_Utils_Tuple2('The first step to accessing these benefits is to complete the setup for your account, which takes just a few minutes.', 'The first step to accessing these benefits is to complete the setup for your account, which takes just a few minutes.'),
			_Utils_Tuple2('Monthly risk scans:', 'Monthly risk scans:'),
			_Utils_Tuple2('Outpace cybercriminals with our tailored alerts, which provide you an average 15-day head start to patch', 'Outpace cybercriminals with our tailored alerts, which provide you an average 15-day head start to patch'),
			_Utils_Tuple2('Personalized threat alerts:', 'Personalized threat alerts:'),
			_Utils_Tuple2('Prioritized security recommendations:', 'Prioritized security recommendations:'),
			_Utils_Tuple2('Reduce your exposure with actionable guidance found on your Risk Dashboard', 'Reduce your exposure with actionable guidance found on your Risk Dashboard'),
			_Utils_Tuple2('Vulnerability and external IT reports at your fingertips', 'Vulnerability and external IT reports at your fingertips'),
			_Utils_Tuple2('Something went wrong…', 'Something went wrong…'),
			_Utils_Tuple2('CC', 'CC'),
			_Utils_Tuple2('Access these features and see your new Corvus Score by creating a password for your Risk Dashboard below.', 'Access these features and see your new Corvus Score by creating a password for your Risk Dashboard below.'),
			_Utils_Tuple2('Complete team setup', 'Complete team setup'),
			_Utils_Tuple2('Is someone else in your organization better fit to review this?', 'Is someone else in your organization better fit to review this?'),
			_Utils_Tuple2('Log in to See New Score', 'Log in to See New Score'),
			_Utils_Tuple2('Login to See New Score', 'Login to See New Score'),
			_Utils_Tuple2('Score', 'Score'),
			_Utils_Tuple2('See Your New Corvus Score', 'See Your New Corvus Score'),
			_Utils_Tuple2('This includes a monthly scan that identifies cybersecurity vulnerabilities from your organization\'s external IT assets, with clear directions on how to take action.', 'This includes a monthly scan that identifies cybersecurity vulnerabilities from your organization\'s external IT assets, with clear directions on how to take action.'),
			_Utils_Tuple2('We encourage account managers to provide at least one contact from their IT team in order to make the most of their policy benefits.', 'We encourage account managers to provide at least one contact from their IT team in order to make the most of their policy benefits.'),
			_Utils_Tuple2('We’ll handle the setup – we just need the name, role, and associated email address of each IT contact you’d like to add.', 'We’ll handle the setup – we just need the name, role, and associated email address of each IT contact you’d like to add.'),
			_Utils_Tuple2('Referral Sent', 'Referral Sent'),
			_Utils_Tuple2('Q%{quarter} Smart Cyber Insurance Update for %{client_name}', 'Q%{quarter} Smart Cyber Insurance Update for %{client_name}'),
			_Utils_Tuple2('Q%{quarter} Travelers %{product_line_name} Insurance Update for %{client_name}', 'Q%{quarter} Travelers %{product_line_name} Insurance Update for %{client_name}'),
			_Utils_Tuple2('Score Improvement Suggestions', 'Score Improvement Suggestions'),
			_Utils_Tuple2('Days to Renewal', 'Days to Renewal'),
			_Utils_Tuple2('There are no low score clients at this time', 'There are no low score clients at this time'),
			_Utils_Tuple2('Alerts', 'Alerts'),
			_Utils_Tuple2('If you have questions about the scan findings or score, please reach out to <a>cyberservices@travelers.com</a>.', 'If you have questions about the scan findings or score, please reach out to <a>cyberservices@travelers.com</a>.'),
			_Utils_Tuple2('Scan Findings', 'Scan Findings'),
			_Utils_Tuple2('Score Activity', 'Score Activity'),
			_Utils_Tuple2('Re-Referral Sent', 'Re-Referral Sent'),
			_Utils_Tuple2('Send Re-Referral', 'Send Re-Referral'),
			_Utils_Tuple2('Thanks for binding Smart %{product_display} coverage!', 'Thanks for binding Smart %{product_display} coverage!'),
			_Utils_Tuple2('We invite you to review our Guide to Policyholder Benefits and share this information with your client. In addition to information about claims handling, you\'ll find out more about our Risk Prevention Services, which help to prevent cyberattacks through threat alerts and the partnership of our in-house cyber experts.', 'We invite you to review our Guide to Policyholder Benefits and share this information with your client. In addition to information about claims handling, you\'ll find out more about our Risk Prevention Services, which help to prevent cyberattacks through threat alerts and the partnership of our in-house cyber experts.'),
			_Utils_Tuple2('We look forward to partnering with you and your client. ', 'We look forward to partnering with you and your client. '),
			_Utils_Tuple2('Changes', 'Changes'),
			_Utils_Tuple2('Return to Submission', 'Return to Submission'),
			_Utils_Tuple2('Your Re-Referral was sent.', 'Your Re-Referral was sent.'),
			_Utils_Tuple2('Your Referral was sent', 'Your Referral was sent'),
			_Utils_Tuple2('Re-Refer Submission', 'Re-Refer Submission'),
			_Utils_Tuple2('Reporting bind data will initiate monthly maintenance scans for active accounts.', 'Reporting bind data will initiate monthly maintenance scans for active accounts.'),
			_Utils_Tuple2('%{product_display} Documents Ready', '%{product_display} Documents Ready'),
			_Utils_Tuple2('Thanks for binding %{product_display} coverage!', 'Thanks for binding %{product_display} coverage!'),
			_Utils_Tuple2('Add Runtime Property', 'Add Runtime Property'),
			_Utils_Tuple2('Application Type', 'Application Type'),
			_Utils_Tuple2('Brokerage Name', 'Brokerage Name'),
			_Utils_Tuple2('Context', 'Context'),
			_Utils_Tuple2('Create New Runtime Rule', 'Create New Runtime Rule'),
			_Utils_Tuple2('Context Date', 'Context Date'),
			_Utils_Tuple2('Delete Property', 'Delete Property'),
			_Utils_Tuple2('Effective Date From', 'Effective Date From'),
			_Utils_Tuple2('Gross Annual Revenue', 'Gross Annual Revenue'),
			_Utils_Tuple2('Inserted At', 'Inserted At'),
			_Utils_Tuple2('Time Elapsed', 'Time Elapsed'),
			_Utils_Tuple2('Is Renewal', 'Is Renewal'),
			_Utils_Tuple2('New Rule Name', 'New Rule Name'),
			_Utils_Tuple2('Number of Properties', 'Number of Properties'),
			_Utils_Tuple2('Properties', 'Properties'),
			_Utils_Tuple2('Property ', 'Property '),
			_Utils_Tuple2('Results', 'Results'),
			_Utils_Tuple2('Rule ', 'Rule '),
			_Utils_Tuple2('Rule Name', 'Rule Name'),
			_Utils_Tuple2('Rules Engine', 'Rules Engine'),
			_Utils_Tuple2('Select Operator', 'Select Operator'),
			_Utils_Tuple2('Select Property Type', 'Select Property Type'),
			_Utils_Tuple2('Select Value', 'Select Value'),
			_Utils_Tuple2('Select Value(s)', 'Select Value(s)'),
			_Utils_Tuple2('Updated At', 'Updated At'),
			_Utils_Tuple2('View', 'View'),
			_Utils_Tuple2('Add Runtime Rule Description.', 'Add Runtime Rule Description.'),
			_Utils_Tuple2('Disabled?', 'Disabled?'),
			_Utils_Tuple2('Is Renewal?', 'Is Renewal?'),
			_Utils_Tuple2('Select Quote Request', 'Select Quote Request'),
			_Utils_Tuple2('Select Rule', 'Select Rule'),
			_Utils_Tuple2('Add Users', 'Add Users'),
			_Utils_Tuple2('Add a User', 'Add a User'),
			_Utils_Tuple2('Import Brokers', 'Import Brokers'),
			_Utils_Tuple2('Add Brokers', 'Add Brokers'),
			_Utils_Tuple2('Download CSV Template', 'Download CSV Template'),
			_Utils_Tuple2('Line', 'Line'),
			_Utils_Tuple2('Toggle Password Visibility', 'Toggle Password Visibility'),
			_Utils_Tuple2('Error verifying credentials. Please refresh the page and try again.', 'Error verifying credentials. Please refresh the page and try again.'),
			_Utils_Tuple2('%{product_display} Documents Ready for %{client_name}', '%{product_display} Documents Ready for %{client_name}'),
			_Utils_Tuple2('Some files weren\'t attached because they were too large. They can be downloaded from the Policy page.', 'Some files weren\'t attached because they were too large. They can be downloaded from the Policy page.'),
			_Utils_Tuple2('© %{year} Travelers Indemnity Company. All rights reserved. Travelers and the Travelers Umbrella logo are registered trademarks of The Travelers Indemnity Company in the U.S. and other countries.', '© %{year} Travelers Indemnity Company. All rights reserved. Travelers and the Travelers Umbrella logo are registered trademarks of The Travelers Indemnity Company in the U.S. and other countries.'),
			_Utils_Tuple2('The Corvus score was updated to absorb SBRAF for all Smart Cyber accounts. This affected score value for some accounts.', 'The Corvus score was updated to absorb SBRAF for all Smart Cyber accounts. This affected score value for some accounts.'),
			_Utils_Tuple2('Thank you for the submission. Unfortunately, we will need to take a pass on this opportunity as we are not quoting against Travelers incumbent business.', 'Thank you for the submission. Unfortunately, we will need to take a pass on this opportunity as we are not quoting against Travelers incumbent business.'),
			_Utils_Tuple2('Travelers logo', 'Travelers logo'),
			_Utils_Tuple2('Please sign in with your admin credentials to continue.', 'Please sign in with your admin credentials to continue.'),
			_Utils_Tuple2('Accessibility', 'Accessibility'),
			_Utils_Tuple2('Privacy & Security', 'Privacy & Security'),
			_Utils_Tuple2('Terms of Service', 'Terms of Service'),
			_Utils_Tuple2('Cyber Renewal Info: %{client_name} - Policy %{policy_number} - Expiring %{policy_expiration_date}', 'Cyber Renewal Info: %{client_name} - Policy %{policy_number} - Expiring %{policy_expiration_date}'),
			_Utils_Tuple2('Tech E&O Renewal Info: %{client_name} - Policy #%{policy_number} - Expiring %{policy_expiration_date}', 'Tech E&O Renewal Info: %{client_name} - Policy #%{policy_number} - Expiring %{policy_expiration_date}'),
			_Utils_Tuple2('Key Findings represent actionable factors that are currently having a negative effect on an account\'s Corvus Score, ordered by severity.', 'Key Findings represent actionable factors that are currently having a negative effect on an account\'s Corvus Score, ordered by severity.'),
			_Utils_Tuple2('Non-Actionable Findings represent risk factors negatively affecting Corvus score that may be impossible to remediate but improve an underwriter\'s understanding of score deductions. These findings are ordered by severity', 'Non-Actionable Findings represent risk factors negatively affecting Corvus score that may be impossible to remediate but improve an underwriter\'s understanding of score deductions. These findings are ordered by severity'),
			_Utils_Tuple2('Corvus partners with the following technology companies to provide additional insights into your organization’s security configurations. With your organization’s consent, Corvus will use the data from tech integration partners to identify the most critical gaps in security controls, evaluate risk, and create recommendations. And with additional visibility into your organization’s security controls for the products below, we can also simplify your renewal process.', 'Corvus partners with the following technology companies to provide additional insights into your organization’s security configurations. With your organization’s consent, Corvus will use the data from tech integration partners to identify the most critical gaps in security controls, evaluate risk, and create recommendations. And with additional visibility into your organization’s security controls for the products below, we can also simplify your renewal process.'),
			_Utils_Tuple2('The Corvus Score and Security Questionnaires are tools your organization can use to receive tailored security recommendations. During the term of your policy, we recommend that you keep an eye on both of these to ensure you are taking the appropriate steps to strengthen your security posture and reduce your cyber risk.', 'The Corvus Score and Security Questionnaires are tools your organization can use to receive tailored security recommendations. During the term of your policy, we recommend that you keep an eye on both of these to ensure you are taking the appropriate steps to strengthen your security posture and reduce your cyber risk.'),
			_Utils_Tuple2('The results from your Security Questionnaires may help determine your renewal eligibility for your insurance policy. During your term, we recommend that you keep an eye on any recommended actions to make sure you\'re in good standing for renewal.', 'The results from your Security Questionnaires may help determine your renewal eligibility for your insurance policy. During your term, we recommend that you keep an eye on any recommended actions to make sure you\'re in good standing for renewal.'),
			_Utils_Tuple2('Log in to securely access and manage your <tag>Travelers Cyber Risk Dashboard</tag>', 'Log in to securely access and manage your <tag>Travelers Cyber Risk Dashboard</tag>'),
			_Utils_Tuple2('Welcome to Travelers', 'Welcome to Travelers'),
			_Utils_Tuple2('DropdownValues are currently not supported.', 'DropdownValues are currently not supported.'),
			_Utils_Tuple2('%{productName1}, %{productName2} + %{count} more.', '%{productName1}, %{productName2} + %{count} more.'),
			_Utils_Tuple2('Set Up Your Account', 'Set Up Your Account'),
			_Utils_Tuple2('Cyber Risk Score (External Scan)', 'Cyber Risk Score (External Scan)'),
			_Utils_Tuple2('The Cyber Risk Score and Security Questionnaires are tools your organization can use to receive tailored security recommendations. During the term of your policy, we recommend that you keep an eye on both of these to ensure you are taking the appropriate steps to strengthen your security posture and reduce your cyber risk.', 'The Cyber Risk Score and Security Questionnaires are tools your organization can use to receive tailored security recommendations. During the term of your policy, we recommend that you keep an eye on both of these to ensure you are taking the appropriate steps to strengthen your security posture and reduce your cyber risk.'),
			_Utils_Tuple2('Cyber Risk Scan Findings', 'Cyber Risk Scan Findings'),
			_Utils_Tuple2('Cyber Risk Scan Results', 'Cyber Risk Scan Results'),
			_Utils_Tuple2('Cyber Risk Score', 'Cyber Risk Score'),
			_Utils_Tuple2('The Cyber Risk Scan evaluates an organization’s cyber security risk through the use of publicly available data. Our scan technology first performs automated asset discovery that leads to a security review of your public facing systems to map your organization’s external attack surface. Scan findings and recommendations help your organization identify, manage, and prioritize cyber security risk to enhance your cyber security posture. To learn more about the scan and how it works click <tag>here</tag>.', 'The Cyber Risk Scan evaluates an organization’s cyber security risk through the use of publicly available data. Our scan technology first performs automated asset discovery that leads to a security review of your public facing systems to map your organization’s external attack surface. Scan findings and recommendations help your organization identify, manage, and prioritize cyber security risk to enhance your cyber security posture. To learn more about the scan and how it works click <tag>here</tag>.'),
			_Utils_Tuple2('These findings are generated and updated monthly, following the Cyber Risk Scan.', 'These findings are generated and updated monthly, following the Cyber Risk Scan.'),
			_Utils_Tuple2('The recommendations below are generated from either the monthly Cyber Risk Scan (score-impacting) or answers you provided from the Security Questionnaire modules (not score-impacting).', 'The recommendations below are generated from either the monthly Cyber Risk Scan (score-impacting) or answers you provided from the Security Questionnaire modules (not score-impacting).'),
			_Utils_Tuple2('Protect your organization with the most important controls identified by our Cyber Risk Services Team.', 'Protect your organization with the most important controls identified by our Cyber Risk Services Team.'),
			_Utils_Tuple2('Your Travelers Claim Professional', 'Your Travelers Claim Professional'),
			_Utils_Tuple2('Additional information request failed. If the problem persists, please contact Travelers Insurance for support at <anchor>cyberservices@travelers.com</anchor>.', 'Additional information request failed. If the problem persists, please contact Travelers Insurance for support at <anchor>cyberservices@travelers.com</anchor>.'),
			_Utils_Tuple2('Cyber Risk Services recommends that all policyholders review digital assets and supporting technologies to ensure we are getting an accurate picture of your environment. If you are not the primary security owner in your company you can <anchor>add them here</anchor>.', 'Cyber Risk Services recommends that all policyholders review digital assets and supporting technologies to ensure we are getting an accurate picture of your environment. If you are not the primary security owner in your company you can <anchor>add them here</anchor>.'),
			_Utils_Tuple2('Use this area to request more information on your domains, get additional assistance on this page, or to speak with someone from our Cyber Risk Services Team.', 'Use this area to request more information on your domains, get additional assistance on this page, or to speak with someone from our Cyber Risk Services Team.'),
			_Utils_Tuple2('Your External Perimeter is composed of domains, subdomains, IP addresses, and external services that the Cyber Risk Scan derived from your organization\'s primary domain provided during the underwriting application process. We recommend that you review the assets identified on this page to ensure we are getting an accurate picture of your environment. Use the dispute buttons to raise any issues with what the scan has detected.', 'Your External Perimeter is composed of domains, subdomains, IP addresses, and external services that the Cyber Risk Scan derived from your organization\'s primary domain provided during the underwriting application process. We recommend that you review the assets identified on this page to ensure we are getting an accurate picture of your environment. Use the dispute buttons to raise any issues with what the scan has detected.'),
			_Utils_Tuple2('Your request has been successfully submitted. A member from the Cyber Risk Services Team will respond to your request shortly.', 'Your request has been successfully submitted. A member from the Cyber Risk Services Team will respond to your request shortly.'),
			_Utils_Tuple2('From: Cyber Risk Scan', 'From: Cyber Risk Scan'),
			_Utils_Tuple2('We\'d like to discuss this with Travelers', 'We\'d like to discuss this with Travelers'),
			_Utils_Tuple2('Leave us your thoughts regarding this recommendation. Our Cyber Risk Services Team will review and be in touch.', 'Leave us your thoughts regarding this recommendation. Our Cyber Risk Services Team will review and be in touch.'),
			_Utils_Tuple2('Access your cyber policy benefits now', 'Access your cyber policy benefits now'),
			_Utils_Tuple2('By setting up your account, you’ll unlock access to services that have been shown to %{tag}reduce the likelihood of a cyberattack by 20%.%{tag_}', 'By setting up your account, you’ll unlock access to services that have been shown to %{tag}reduce the likelihood of a cyberattack by 20%.%{tag_}'),
			_Utils_Tuple2('Continuous Monitoring:', 'Continuous Monitoring:'),
			_Utils_Tuple2('Our non-intrusive scan monitors your environment to provide IT security reports', 'Our non-intrusive scan monitors your environment to provide IT security reports'),
			_Utils_Tuple2('Outpace cybercriminals with alerts sent the same day new vulnerabilities are discovered', 'Outpace cybercriminals with alerts sent the same day new vulnerabilities are discovered'),
			_Utils_Tuple2('Prioritized Cybersecurity Recommendations:', 'Prioritized Cybersecurity Recommendations:'),
			_Utils_Tuple2('Reduce your exposure with tailored recommendations', 'Reduce your exposure with tailored recommendations'),
			_Utils_Tuple2('Threat Alerts:', 'Threat Alerts:'),
			_Utils_Tuple2('This field was originally prefilled with AI as "%{llmAnswer}" under the following rationale: ', 'This field was originally prefilled with AI as "%{llmAnswer}" under the following rationale: '),
			_Utils_Tuple2('This field was prefilled with AI under the following rationale: ', 'This field was prefilled with AI under the following rationale: '),
			_Utils_Tuple2('Complete your account setup now', 'Complete your account setup now'),
			_Utils_Tuple2('See your new Cyber Risk Score and recommended actions by completing your account set-up.', 'See your new Cyber Risk Score and recommended actions by completing your account set-up.'),
			_Utils_Tuple2('See your updated Cyber Risk Score', 'See your updated Cyber Risk Score'),
			_Utils_Tuple2('If you have any questions about how to use your Cyber Risk Dashboard please reach out to our team by replying to this email!', 'If you have any questions about how to use your Cyber Risk Dashboard please reach out to our team by replying to this email!'),
			_Utils_Tuple2('Thank you for finishing your account setup. %{tag}Log in any time%{tag_} to see the latest risk reports and recommendations from our team of cybersecurity experts or identify pre-vetted vendors for improving your security program.', 'Thank you for finishing your account setup. %{tag}Log in any time%{tag_} to see the latest risk reports and recommendations from our team of cybersecurity experts or identify pre-vetted vendors for improving your security program.'),
			_Utils_Tuple2('Thank you for finishing your account setup. Log in any time [%{crowbar_url_with_utm}] to see the latest risk reports and recommendations from our team of cybersecurity experts or identify pre-vetted vendors for improving your security program.', 'Thank you for finishing your account setup. Log in any time [%{crowbar_url_with_utm}] to see the latest risk reports and recommendations from our team of cybersecurity experts or identify pre-vetted vendors for improving your security program.'),
			_Utils_Tuple2('Welcome to your Cyber Risk Dashboard', 'Welcome to your Cyber Risk Dashboard'),
			_Utils_Tuple2('If you did not request this change, please email cyberservices@travelers.com.', 'If you did not request this change, please email cyberservices@travelers.com.'),
			_Utils_Tuple2('Reset Cyber Risk Dashboard Password', 'Reset Cyber Risk Dashboard Password'),
			_Utils_Tuple2('We received a request to update your password.', 'We received a request to update your password.'),
			_Utils_Tuple2('Greetings', 'Greetings'),
			_Utils_Tuple2('Q%{quarter} %{product_line_name} Insurance Update for %{client_name}', 'Q%{quarter} %{product_line_name} Insurance Update for %{client_name}'),
			_Utils_Tuple2('Complete the questionnaire to see security recommendations unique to your organization.', 'Complete the questionnaire to see security recommendations unique to your organization.'),
			_Utils_Tuple2('Completing recommended actions aligns your organization’s security posture with best practices.', 'Completing recommended actions aligns your organization’s security posture with best practices.'),
			_Utils_Tuple2('Hi %{insured}', 'Hi %{insured}'),
			_Utils_Tuple2('Review Changes', 'Review Changes'),
			_Utils_Tuple2('Time Left to Renewal', 'Time Left to Renewal'),
			_Utils_Tuple2('We\'re Here to Help', 'We\'re Here to Help'),
			_Utils_Tuple2('Your Score (External IT environment Scan):', 'Your Score (External IT environment Scan):'),
			_Utils_Tuple2('Complete your Cyber Risk Dashboard account setup', 'Complete your Cyber Risk Dashboard account setup'),
			_Utils_Tuple2('A higher score indicates reduced risk of a cyber incident. As a rule of thumb, a score in the 70s or below indicates a higher risk. Continue engaging with our risk insights and recommendations to align your organization with cybersecurity best practices.', 'A higher score indicates reduced risk of a cyber incident. As a rule of thumb, a score in the 70s or below indicates a higher risk. Continue engaging with our risk insights and recommendations to align your organization with cybersecurity best practices.'),
			_Utils_Tuple2('As a Corvus policyholder, you have access to Cyber Risk Services. As part of this service offering, we have performed a non-intrusive scan of your organization’s externally-facing environment. Below, see what’s changed since your last scan.', 'As a Corvus policyholder, you have access to Cyber Risk Services. As part of this service offering, we have performed a non-intrusive scan of your organization’s externally-facing environment. Below, see what’s changed since your last scan.'),
			_Utils_Tuple2('As a Travelers policyholder, you have access to Cyber Risk Services. As part of this service offering, we have performed a non-intrusive scan of your organization’s externally-facing environment. Below, see what’s changed since your last scan.', 'As a Travelers policyholder, you have access to Cyber Risk Services. As part of this service offering, we have performed a non-intrusive scan of your organization’s externally-facing environment. Below, see what’s changed since your last scan.'),
			_Utils_Tuple2('As you get closer to renewal, please review any recommended actions as some may take longer than expected to implement.', 'As you get closer to renewal, please review any recommended actions as some may take longer than expected to implement.'),
			_Utils_Tuple2('Get More Information about the Alert', 'Get More Information about the Alert'),
			_Utils_Tuple2('Log in any time to see the latest risk reports and recommendations from our team of cybersecurity experts or identify pre-vetted vendors for improving your security program.', 'Log in any time to see the latest risk reports and recommendations from our team of cybersecurity experts or identify pre-vetted vendors for improving your security program.'),
			_Utils_Tuple2('There are likely other members of your organization, such as an IT Manager, Security Manager, CISO or Network Admin, who will need to stay up to speed on vulnerability alerts and cybersecurity recommendations.', 'There are likely other members of your organization, such as an IT Manager, Security Manager, CISO or Network Admin, who will need to stay up to speed on vulnerability alerts and cybersecurity recommendations.'),
			_Utils_Tuple2('Please take a few seconds to review your team and add users to your organization so that we can keep them up to date on all cybersecurity issues.', 'Please take a few seconds to review your team and add users to your organization so that we can keep them up to date on all cybersecurity issues.'),
			_Utils_Tuple2('If you\'re the only person that will be managing all cybersecurity issues and responses at your organization, you\'re all set!', 'If you\'re the only person that will be managing all cybersecurity issues and responses at your organization, you\'re all set!'),
			_Utils_Tuple2('Team Setup: Action Needed', 'Team Setup: Action Needed'),
			_Utils_Tuple2('Welcome to your Cyber Risk Dashboard!', 'Welcome to your Cyber Risk Dashboard!'),
			_Utils_Tuple2('See your latest risk reports', 'See your latest risk reports'),
			_Utils_Tuple2('Your Account is Ready!', 'Your Account is Ready!'),
			_Utils_Tuple2('Complete Team Setup', 'Complete Team Setup'),
			_Utils_Tuple2('Welcome to the Cyber Risk Dashboard [%{crowbar_url_with_utm}], part of the Cyber Risk Services that are available through your %{company_name} policy.', 'Welcome to the Cyber Risk Dashboard [%{crowbar_url_with_utm}], part of the Cyber Risk Services that are available through your %{company_name} policy.'),
			_Utils_Tuple2('To ensure that Travelers emails reach your inbox, please add us to your address book.', 'To ensure that Travelers emails reach your inbox, please add us to your address book.'),
			_Utils_Tuple2('This field was orginally checked with AI under the following rationale: ', 'This field was orginally checked with AI under the following rationale: '),
			_Utils_Tuple2('This option was checked with AI under the following rationale: ', 'This option was checked with AI under the following rationale: '),
			_Utils_Tuple2('Analyzed', 'Analyzed'),
			_Utils_Tuple2('Comprehend Application', 'Comprehend Application'),
			_Utils_Tuple2('Comprehending Application', 'Comprehending Application'),
			_Utils_Tuple2('As a Corvus policyholder, you have access to the Cyber Risk Dashboard from Travelers.', 'As a Corvus policyholder, you have access to the Cyber Risk Dashboard from Travelers.'),
			_Utils_Tuple2('As a Travelers policyholder, you have access to the Cyber Risk Dashboard.', 'As a Travelers policyholder, you have access to the Cyber Risk Dashboard.'),
			_Utils_Tuple2('Welcome to the %{tag}Cyber Risk Dashboard%{tag_}, part of the Cyber Risk Services that are available through your %{company_name} policy.', 'Welcome to the %{tag}Cyber Risk Dashboard%{tag_}, part of the Cyber Risk Services that are available through your %{company_name} policy.'),
			_Utils_Tuple2('The first step to accessing these benefits is to complete the setup for your Cyber Risk Dashboard account, which takes just a few minutes.', 'The first step to accessing these benefits is to complete the setup for your Cyber Risk Dashboard account, which takes just a few minutes.'),
			_Utils_Tuple2('Your Dashboard shows the results of regular scans that identify cybersecurity vulnerabilities from your organization\'s external IT environment, with clear directions on how to take action.', 'Your Dashboard shows the results of regular scans that identify cybersecurity vulnerabilities from your organization\'s external IT environment, with clear directions on how to take action.'),
			_Utils_Tuple2('Confirm these edits are being made to the correct account.', 'Confirm these edits are being made to the correct account.'),
			_Utils_Tuple2('No, Return to Answer', 'No, Return to Answer'),
			_Utils_Tuple2('Save changes for <tag>%{clientName}</tag>?', 'Save changes for <tag>%{clientName}</tag>?'),
			_Utils_Tuple2('Travelers Insurance', 'Travelers Insurance'),
			_Utils_Tuple2('cyberrisk.travelers.com', 'cyberrisk.travelers.com'),
			_Utils_Tuple2('travelers.com', 'travelers.com'),
			_Utils_Tuple2('You Have Been Invited to a New Organization\'s Cyber Risk Dashboard', 'You Have Been Invited to a New Organization\'s Cyber Risk Dashboard'),
			_Utils_Tuple2('Log in and review', 'Log in and review'),
			_Utils_Tuple2('Reset MFA', 'Reset MFA'),
			_Utils_Tuple2('This field was originally prefilled with AI under the following rationale: ', 'This field was originally prefilled with AI under the following rationale: '),
			_Utils_Tuple2('View Travelers Knowledge Base', 'View Travelers Knowledge Base'),
			_Utils_Tuple2('Threat Monitoring', 'Threat Monitoring'),
			_Utils_Tuple2('Action Needed:', 'Action Needed:'),
			_Utils_Tuple2('Log In and Set Up New Account [%{crowbar_url_with_utm}]', 'Log In and Set Up New Account [%{crowbar_url_with_utm}]'),
			_Utils_Tuple2('Log in any time to see the latest risk reports and recommendations from our team of cybersecurity experts or identify preferred vendors for improving your security program.', 'Log in any time to see the latest risk reports and recommendations from our team of cybersecurity experts or identify preferred vendors for improving your security program.'),
			_Utils_Tuple2('You have been added to a new organization in the %{tag}Cyber Risk Dashboard%{tag_}, part of the Cyber Risk Services that are available through your Travelers policy.', 'You have been added to a new organization in the %{tag}Cyber Risk Dashboard%{tag_}, part of the Cyber Risk Services that are available through your Travelers policy.'),
			_Utils_Tuple2('You have been added to a new organization in the Cyber Risk Dashboard [%{crowbar_url_with_utm}], part of the Cyber Risk Services that are available through your Travelers policy.', 'You have been added to a new organization in the Cyber Risk Dashboard [%{crowbar_url_with_utm}], part of the Cyber Risk Services that are available through your Travelers policy.'),
			_Utils_Tuple2('Your new team is: %{client_name}.', 'Your new team is: %{client_name}.'),
			_Utils_Tuple2('Your new team is: %{tag}%{client_name}%{tag_}.', 'Your new team is: %{tag}%{client_name}%{tag_}.'),
			_Utils_Tuple2('Log In and Set Up New Account', 'Log In and Set Up New Account'),
			_Utils_Tuple2('This client is managed by Team Travelers External. Please contact support for any broker changes.', 'This client is managed by Team Travelers External. Please contact support for any broker changes.'),
			_Utils_Tuple2('Risk Services', 'Risk Services'),
			_Utils_Tuple2('New Organization', 'New Organization'),
			_Utils_Tuple2('Cyber Risk Services', 'Cyber Risk Services'),
			_Utils_Tuple2('Get in Touch with the Team', 'Get in Touch with the Team'),
			_Utils_Tuple2('Our Cyber Risk Services Team offers monitoring, tools and services that help to predict and prevent cyber threats. Organizations that engage with these services were shown to be <tag>20% less likely to experience a cyber breach</tag>, and see <tag>27% lower total claim costs per cyber breach.</tag>', 'Our Cyber Risk Services Team offers monitoring, tools and services that help to predict and prevent cyber threats. Organizations that engage with these services were shown to be <tag>20% less likely to experience a cyber breach</tag>, and see <tag>27% lower total claim costs per cyber breach.</tag>'),
			_Utils_Tuple2('Contact the Cyber Risk Services Team', 'Contact the Cyber Risk Services Team'),
			_Utils_Tuple2('We\'re here to help you leverage the services offered below.', 'We\'re here to help you leverage the services offered below.'),
			_Utils_Tuple2('$100M+ Revenue', '$100M+ Revenue'),
			_Utils_Tuple2('$1B+', '$1B+'),
			_Utils_Tuple2('$50-$100M Revenue', '$50-$100M Revenue'),
			_Utils_Tuple2('$500M -$1B AUM', '$500M -$1B AUM'),
			_Utils_Tuple2('* The Cyber Risk Services team ensures that the sensitivity of claims and timing is taken into consideration, and enough time is given for the call prior to renewal. The claim file will be accessed by Cyber Security and they will work with you, the underwriter, on renewal expectations such as to confirm admin controls, EDR, claims response, network segmentation, etc.', '* The Cyber Risk Services team ensures that the sensitivity of claims and timing is taken into consideration, and enough time is given for the call prior to renewal. The claim file will be accessed by Cyber Security and they will work with you, the underwriter, on renewal expectations such as to confirm admin controls, EDR, claims response, network segmentation, etc.'),
			_Utils_Tuple2('Expert Support ', 'Expert Support '),
			_Utils_Tuple2('Financial Institutions', 'Financial Institutions'),
			_Utils_Tuple2('Online Tools and Always-On Services', 'Online Tools and Always-On Services'),
			_Utils_Tuple2('Under $500M AUM', 'Under $500M AUM'),
			_Utils_Tuple2('Under $50M Revenue', 'Under $50M Revenue'),
			_Utils_Tuple2('Your Services', 'Your Services'),
			_Utils_Tuple2('1 hour call', '1 hour call'),
			_Utils_Tuple2('15 scans', '15 scans'),
			_Utils_Tuple2('2 hour virtual tabletop call', '2 hour virtual tabletop call'),
			_Utils_Tuple2('30 min call', '30 min call'),
			_Utils_Tuple2('30 min prep call', '30 min prep call'),
			_Utils_Tuple2('A guided call helping to identify, evaluate, and manage cybersecurity risks using the frameworks and guidelines set by the National Institute of Standards and Technology (NIST).', 'A guided call helping to identify, evaluate, and manage cybersecurity risks using the frameworks and guidelines set by the National Institute of Standards and Technology (NIST).'),
			_Utils_Tuple2('A simulated scenario that helps to test and improve your organization’s incident response capabilities. Tabletops are conducted after incident response planning has been completed. Our “30-minute prep call” offering helps your organization prepare for a tabletop exercise, while our “2-hr virtual tabletop and prep call” offers help with preparation as well as a virtual tabletop exercise.', 'A simulated scenario that helps to test and improve your organization’s incident response capabilities. Tabletops are conducted after incident response planning has been completed. Our “30-minute prep call” offering helps your organization prepare for a tabletop exercise, while our “2-hr virtual tabletop and prep call” offers help with preparation as well as a virtual tabletop exercise.'),
			_Utils_Tuple2('Incident Response Tabletop Prep Call', 'Incident Response Tabletop Prep Call'),
			_Utils_Tuple2('Our 30-minute IR Tabletop Prep Call helps your organization prepare for a tabletop exercise, a simulated scenario that will test and improve your organization’s incident response capabilities. Once you’ve completed the prep call, virtual or on-site tabletop exercises are available via third-party vendors at a reduced cost.', 'Our 30-minute IR Tabletop Prep Call helps your organization prepare for a tabletop exercise, a simulated scenario that will test and improve your organization’s incident response capabilities. Once you’ve completed the prep call, virtual or on-site tabletop exercises are available via third-party vendors at a reduced cost.'),
			_Utils_Tuple2('A two-hour simulated scenario exercise, conducted virtually, to test and improve your organization’s incident response capabilities. Tabletops are conducted after incident response planning has been completed. Prior to the exercise, we offer a 30-minute prep call to help your organization prepare. (On-site tabletops are available via third-party vendors at a reduced cost).', 'A two-hour simulated scenario exercise, conducted virtually, to test and improve your organization’s incident response capabilities. Tabletops are conducted after incident response planning has been completed. Prior to the exercise, we offer a 30-minute prep call to help your organization prepare. (On-site tabletops are available via third-party vendors at a reduced cost).'),
			_Utils_Tuple2('Assesses your organization’s external-facing assets to identify vulnerabilities and potential security threats.', 'Assesses your organization’s external-facing assets to identify vulnerabilities and potential security threats.'),
			_Utils_Tuple2('Business Continuity Planning (BCP)', 'Business Continuity Planning (BCP)'),
			_Utils_Tuple2('Business Continuity Planning Template and Guide', 'Business Continuity Planning Template and Guide'),
			_Utils_Tuple2('Incident Response Planning Template and Guide', 'Incident Response Planning Template and Guide'),
			_Utils_Tuple2('Consultation call with an attorney from one of our approved breach response counsel vendors to help your team with preparation for responding to a cybersecurity incident.', 'Consultation call with an attorney from one of our approved breach response counsel vendors to help your team with preparation for responding to a cybersecurity incident.'),
			_Utils_Tuple2('Continuous Dark Web monitoring', 'Continuous Dark Web monitoring'),
			_Utils_Tuple2('Create a plan to prepare for, detect, respond to and recover from cybersecurity incidents. Our Template and Guide offering provides you with the tools your team needs to conduct your own planning exercise. Qualifying policyholders can request a one-hour planning call with a Travelers incident response expert.', 'Create a plan to prepare for, detect, respond to and recover from cybersecurity incidents. Our Template and Guide offering provides you with the tools your team needs to conduct your own planning exercise. Qualifying policyholders can request a one-hour planning call with a Travelers incident response expert.'),
			_Utils_Tuple2('Create a plan to prepare for, detect, respond to and recover from cybersecurity incidents. Our Template and Guide offering provides you with the tools your team needs to conduct your own planning exercise. You can request a one-hour planning call with a Travelers incident response expert.', 'Create a plan to prepare for, detect, respond to and recover from cybersecurity incidents. Our Template and Guide offering provides you with the tools your team needs to conduct your own planning exercise. You can request a one-hour planning call with a Travelers incident response expert.'),
			_Utils_Tuple2('Identify essential business functions and create a plan to keep them going during and after a disruptive event. Our Template and Guide offering provides you with the tools your team needs to conduct your own planning exercise. You can request a one-hour planning call with a Travelers incident response expert.', 'Identify essential business functions and create a plan to keep them going during and after a disruptive event. Our Template and Guide offering provides you with the tools your team needs to conduct your own planning exercise. You can request a one-hour planning call with a Travelers incident response expert.'),
			_Utils_Tuple2('Identify essential business functions and create a plan to keep them going during and after a disruptive event. Our Template and Guide offering provides you with the tools your team needs to conduct your own planning exercise. Qualifying policyholders can request a one-hour planning call with a Travelers incident response expert.', 'Identify essential business functions and create a plan to keep them going during and after a disruptive event. Our Template and Guide offering provides you with the tools your team needs to conduct your own planning exercise. Qualifying policyholders can request a one-hour planning call with a Travelers incident response expert.'),
			_Utils_Tuple2('Our Template and Guide offering provides you with the tools your team needs to create a plan to prepare for, detect, respond to and recover from cybersecurity incidents.', 'Our Template and Guide offering provides you with the tools your team needs to create a plan to prepare for, detect, respond to and recover from cybersecurity incidents.'),
			_Utils_Tuple2('Our Template and Guide offering provides you with the tools your team needs to identify essential business functions and create a plan to keep them going during and after a disruptive event.', 'Our Template and Guide offering provides you with the tools your team needs to identify essential business functions and create a plan to keep them going during and after a disruptive event.'),
			_Utils_Tuple2('Cyber expert security consultations', 'Cyber expert security consultations'),
			_Utils_Tuple2('Cyber newsletters and webinars', 'Cyber newsletters and webinars'),
			_Utils_Tuple2('Discounted vendor rates', 'Discounted vendor rates'),
			_Utils_Tuple2('Employee security awareness training', 'Employee security awareness training'),
			_Utils_Tuple2('Expert NIST-based risk assessment', 'Expert NIST-based risk assessment'),
			_Utils_Tuple2('External perimeter scanning', 'External perimeter scanning'),
			_Utils_Tuple2('Get the same insights Travelers provides about your own organization’s risk profile, but for critical vendors whose security could impact your business. Up to 15 scans per policy term for qualifying policyholders.', 'Get the same insights Travelers provides about your own organization’s risk profile, but for critical vendors whose security could impact your business. Up to 15 scans per policy term for qualifying policyholders.'),
			_Utils_Tuple2('Guidance and support in deploying multi-factor authentication.', 'Guidance and support in deploying multi-factor authentication.'),
			_Utils_Tuple2('Guidance to harden your organization against future attacks after an incident has occurred.', 'Guidance to harden your organization against future attacks after an incident has occurred.'),
			_Utils_Tuple2('Help understanding current security posture and advice on a range of areas: information security, cybersecurity, compliance, and more.', 'Help understanding current security posture and advice on a range of areas: information security, cybersecurity, compliance, and more.'),
			_Utils_Tuple2('Incident Response Planning (IRP)', 'Incident Response Planning (IRP)'),
			_Utils_Tuple2('Meet a member of your dedicated team and gain an understanding of the Cyber Risk Dashboard and services available to you.', 'Meet a member of your dedicated team and gain an understanding of the Cyber Risk Dashboard and services available to you.'),
			_Utils_Tuple2('Meet the data breach coach', 'Meet the data breach coach'),
			_Utils_Tuple2('Multifactor Authentication implementation support', 'Multifactor Authentication implementation support'),
			_Utils_Tuple2('Offerings available for Travelers policyholders from our vetted, independent security partners.', 'Offerings available for Travelers policyholders from our vetted, independent security partners.'),
			_Utils_Tuple2('Ongoing scanning and analyzing dark web sources to identify any potential threats or leaked information that would indicate an intrusion has occurred and an attack may be imminent', 'Ongoing scanning and analyzing dark web sources to identify any potential threats or leaked information that would indicate an intrusion has occurred and an attack may be imminent'),
			_Utils_Tuple2('Online education training for your employees to learn about cybersecurity threats, best practices, and the importance of maintaining a secure workplace.', 'Online education training for your employees to learn about cybersecurity threats, best practices, and the importance of maintaining a secure workplace.'),
			_Utils_Tuple2('Online tool to help your organization evaluate its security posture and identify potential risks.', 'Online tool to help your organization evaluate its security posture and identify potential risks.'),
			_Utils_Tuple2('Our in-house cyber experts provide the latest developments in cybersecurity and the threat landscape to educate, share insights, and promote awareness.', 'Our in-house cyber experts provide the latest developments in cybersecurity and the threat landscape to educate, share insights, and promote awareness.'),
			_Utils_Tuple2('Personalized alerts for emerging cyber threats', 'Personalized alerts for emerging cyber threats'),
			_Utils_Tuple2('Personalized and prioritized emails that inform you of immediate threats detected by Travelers, with step-by-step guidance on the actions needed to remediate.', 'Personalized and prioritized emails that inform you of immediate threats detected by Travelers, with step-by-step guidance on the actions needed to remediate.'),
			_Utils_Tuple2('Policy onboarding call', 'Policy onboarding call'),
			_Utils_Tuple2('Post-Incident consult*', 'Post-Incident consult*'),
			_Utils_Tuple2('Scan reports for third-party vendors', 'Scan reports for third-party vendors'),
			_Utils_Tuple2('Self-service risk assessment', 'Self-service risk assessment'),
			_Utils_Tuple2('Template and guide', 'Template and guide'),
			_Utils_Tuple2('Expert Support', 'Expert Support'),
			_Utils_Tuple2('Up to 5 calls', 'Up to 5 calls'),
			_Utils_Tuple2('$1B+ Assets/AUM', '$1B+ Assets/AUM'),
			_Utils_Tuple2('$500M -$1B Assets/AUM', '$500M -$1B Assets/AUM'),
			_Utils_Tuple2('Under $500M Assets/AUM', 'Under $500M Assets/AUM'),
			_Utils_Tuple2('* On-site tabletops are available via third-party vendors at a reduced cost', '* On-site tabletops are available via third-party vendors at a reduced cost'),
			_Utils_Tuple2('Post-Incident consult', 'Post-Incident consult'),
			_Utils_Tuple2('Inquiry Details', 'Inquiry Details'),
			_Utils_Tuple2('Please give us information regarding your inquiry: which services would you like to leverage and why?', 'Please give us information regarding your inquiry: which services would you like to leverage and why?'),
			_Utils_Tuple2('Service(s) Requested', 'Service(s) Requested'),
			_Utils_Tuple2('Submit', 'Submit'),
			_Utils_Tuple2('Why would you like to leverage this/these services?', 'Why would you like to leverage this/these services?'),
			_Utils_Tuple2('Help Us Help You', 'Help Us Help You'),
			_Utils_Tuple2('I’m interested in Threat Monitoring Insights and Features', 'I’m interested in Threat Monitoring Insights and Features'),
			_Utils_Tuple2('Which of the following Threat Monitoring features would be of most interest to you?', 'Which of the following Threat Monitoring features would be of most interest to you?'),
			_Utils_Tuple2('Thank you, your input has been recorded!', 'Thank you, your input has been recorded!'),
			_Utils_Tuple2('Upon returning to this page, you will find this survey will repopulate, but you do not need to fill it out more than once.', 'Upon returning to this page, you will find this survey will repopulate, but you do not need to fill it out more than once.'),
			_Utils_Tuple2('Unable to load your Risk Services. Please try again.', 'Unable to load your Risk Services. Please try again.'),
			_Utils_Tuple2('A Cyber Risk Services team member will be responding to your request via email.', 'A Cyber Risk Services team member will be responding to your request via email.'),
			_Utils_Tuple2('OK', 'OK'),
			_Utils_Tuple2('There was an error submitting your request. Please try again.', 'There was an error submitting your request. Please try again.'),
			_Utils_Tuple2('Your request has been submitted.', 'Your request has been submitted.'),
			_Utils_Tuple2('© 2025 The Travelers Indemnity Company. All rights reserved.', '© 2025 The Travelers Indemnity Company. All rights reserved.'),
			_Utils_Tuple2('<tag>Cybersecurity Tips + Vulnerability Alerts:</tag> View past alerts and cybersecurity best practices on our knowledge base.', '<tag>Cybersecurity Tips + Vulnerability Alerts:</tag> View past alerts and cybersecurity best practices on our knowledge base.'),
			_Utils_Tuple2('Our team reviews thousands of emerging and active threats that may impact our policyholders. Using information from the Cyber Risk Scan and Security Questionnaire, we are able to selectively issue alerts to policyholders if it is likely that their organization will be impacted.', 'Our team reviews thousands of emerging and active threats that may impact our policyholders. Using information from the Cyber Risk Scan and Security Questionnaire, we are able to selectively issue alerts to policyholders if it is likely that their organization will be impacted.'),
			_Utils_Tuple2('We\'re working on making insights from our threat monitoring team more accessible. Which of the options below would be most helpful to you and your team?', 'We\'re working on making insights from our threat monitoring team more accessible. Which of the options below would be most helpful to you and your team?'),
			_Utils_Tuple2('Request to Add a Domain', 'Request to Add a Domain'),
			_Utils_Tuple2('Action required: ', 'Action required: '),
			_Utils_Tuple2('Provide your organization\'s Primary Domain', 'Provide your organization\'s Primary Domain'),
			_Utils_Tuple2('Travelers will: ', 'Travelers will: '),
			_Utils_Tuple2('Scan your organization’s external-facing assets to identify vulnerabilities and potential security threats.', 'Scan your organization’s external-facing assets to identify vulnerabilities and potential security threats.'),
			_Utils_Tuple2('Provide tailored recommended security improvements to help avoid a cyber attack.', 'Provide tailored recommended security improvements to help avoid a cyber attack.'),
			_Utils_Tuple2('Add a Primary Domain', 'Add a Primary Domain'),
			_Utils_Tuple2('I do not have a primary domain', 'I do not have a primary domain'),
			_Utils_Tuple2('Reduce cyber risk at no additional cost', 'Reduce cyber risk at no additional cost'),
			_Utils_Tuple2('Additional Context', 'Additional Context'),
			_Utils_Tuple2('If you would like to provide additional context to the Cyber Risk Services Team, please do so below.', 'If you would like to provide additional context to the Cyber Risk Services Team, please do so below.'),
			_Utils_Tuple2('Invalid domain. Please edit and try again.', 'Invalid domain. Please edit and try again.'),
			_Utils_Tuple2('Primary Domain Address', 'Primary Domain Address'),
			_Utils_Tuple2('An error occurred and the domain(s) could not be requested. Please try again after a few seconds.', 'An error occurred and the domain(s) could not be requested. Please try again after a few seconds.'),
			_Utils_Tuple2('Your Domain Address has been sent to the Cyber Risk Services team to review and add.', 'Your Domain Address has been sent to the Cyber Risk Services team to review and add.'),
			_Utils_Tuple2('A Cyber Risk Services team will review your response, and we will no longer ask you to provide a Primary Domain.', 'A Cyber Risk Services team will review your response, and we will no longer ask you to provide a Primary Domain.'),
			_Utils_Tuple2('I Do Not Have a Primary Domain', 'I Do Not Have a Primary Domain'),
			_Utils_Tuple2('Please provide detail regarding the absence of a Primary Domain for the Cyber Risk Services Team to review.', 'Please provide detail regarding the absence of a Primary Domain for the Cyber Risk Services Team to review.'),
			_Utils_Tuple2('An error occurred and your response could not be processed. Please try again after a few seconds.', 'An error occurred and your response could not be processed. Please try again after a few seconds.'),
			_Utils_Tuple2('Your response has been submitted.', 'Your response has been submitted.'),
			_Utils_Tuple2('Add a domain to see monthly scan findings.', 'Add a domain to see monthly scan findings.'),
			_Utils_Tuple2('Not Provided', 'Not Provided'),
			_Utils_Tuple2('A cyber claim should be filed immediately after becoming aware of a known or suspected cybersecurity incident, data privacy incident or other cyber event. If you have a question or think a cyber event may have occurred, contact us. A cyber claim specialist will walk you through the situation and determine the resources necessary to address your situation. Notably, if you are considering the use of outside vendors to help you respond to a cyber event,  in addition to notifying Travelers of the potential claim, you should notify Travelers that you intend to engage outside vendors and seek Travelers\' approval for the use of these vendors.', 'A cyber claim should be filed immediately after becoming aware of a known or suspected cybersecurity incident, data privacy incident or other cyber event. If you have a question or think a cyber event may have occurred, contact us. A cyber claim specialist will walk you through the situation and determine the resources necessary to address your situation. Notably, if you are considering the use of outside vendors to help you respond to a cyber event,  in addition to notifying Travelers of the potential claim, you should notify Travelers that you intend to engage outside vendors and seek Travelers\' approval for the use of these vendors.'),
			_Utils_Tuple2('After notifying Travelers of a potential cyber claim, a Travelers cyber claim specialist will reach out to discuss and triage the current situation with you, usually within an hour. This session is intended to quickly and effectively determine if computer forensics are needed and what additional assistance you may require. Typically, the claim specialist will recommend a data breach coach (an attorney who specializes in responding to cyber events). They are an essential part of managing a cyber event for your business.', 'After notifying Travelers of a potential cyber claim, a Travelers cyber claim specialist will reach out to discuss and triage the current situation with you, usually within an hour. This session is intended to quickly and effectively determine if computer forensics are needed and what additional assistance you may require. Typically, the claim specialist will recommend a data breach coach (an attorney who specializes in responding to cyber events). They are an essential part of managing a cyber event for your business.'),
			_Utils_Tuple2('BSIClaims@travelers.com', 'BSIClaims@travelers.com'),
			_Utils_Tuple2('Call: 1.800.842.8496 (available 24/7)', 'Call: 1.800.842.8496 (available 24/7)'),
			_Utils_Tuple2('Contact your agent', 'Contact your agent'),
			_Utils_Tuple2('Cyber events and breaches happen every day. It only takes one cyber event or breach to impair your company’s financial results or potentially put you out of business. The potential for a cyber event is real regardless of the size or type of your business. ', 'Cyber events and breaches happen every day. It only takes one cyber event or breach to impair your company’s financial results or potentially put you out of business. The potential for a cyber event is real regardless of the size or type of your business. '),
			_Utils_Tuple2('Depending on the type of cyber event, the Travelers cyber claim specialist may also recommend additional vendors to help you respond to the cyber event. These vendors may include digital forensics and incident response firms, data restoration and recovery firms, notification and call center vendors, credit monitoring services and public relations firms.', 'Depending on the type of cyber event, the Travelers cyber claim specialist may also recommend additional vendors to help you respond to the cyber event. These vendors may include digital forensics and incident response firms, data restoration and recovery firms, notification and call center vendors, credit monitoring services and public relations firms.'),
			_Utils_Tuple2('Do We Have a Vendor Panel and Why', 'Do We Have a Vendor Panel and Why'),
			_Utils_Tuple2('Email: ', 'Email: '),
			_Utils_Tuple2('How to Notify of a Potential Claim', 'How to Notify of a Potential Claim'),
			_Utils_Tuple2('If you need to share the panel list with someone that does not have a Cyber Risk Dashboard account, you can use this link. Please note that the Travelers claim specialist must approve a service provider before they are engaged.', 'If you need to share the panel list with someone that does not have a Cyber Risk Dashboard account, you can use this link. Please note that the Travelers claim specialist must approve a service provider before they are engaged.'),
			_Utils_Tuple2('Please navigate to the Preferred Vendors page and filter for “Incident Response” to see various vendors including data breach coaches, digital forensic and incident response firms and notification, call center and credit monitoring services.', 'Please navigate to the Preferred Vendors page and filter for “Incident Response” to see various vendors including data breach coaches, digital forensic and incident response firms and notification, call center and credit monitoring services.'),
			_Utils_Tuple2('Throughout this process, you can expect consistent communication from your claim specialist. Travelers is here when your business is in need. You and your agent will be informed and kept apprised throughout the process with direct and regular contact with the Travelers claim team during and outside business hours.', 'Throughout this process, you can expect consistent communication from your claim specialist. Travelers is here when your business is in need. You and your agent will be informed and kept apprised throughout the process with direct and regular contact with the Travelers claim team during and outside business hours.'),
			_Utils_Tuple2('To file a claim, you can use any of the following options (though if you need urgent help, we recommend calling the helpline):', 'To file a claim, you can use any of the following options (though if you need urgent help, we recommend calling the helpline):'),
			_Utils_Tuple2('Travelers has the right experience and experts to assist you in resolving a cyber event and helping you get your business back to its normal operations.', 'Travelers has the right experience and experts to assist you in resolving a cyber event and helping you get your business back to its normal operations.'),
			_Utils_Tuple2('View Preferred Vendors List PDF', 'View Preferred Vendors List PDF'),
			_Utils_Tuple2('What Vendors are on the Incident Response Panel', 'What Vendors are on the Incident Response Panel'),
			_Utils_Tuple2('When to Notify of a Potential Claim', 'When to Notify of a Potential Claim'),
			_Utils_Tuple2('What to Expect After Notifying of a Potential Claim', 'What to Expect After Notifying of a Potential Claim'),
			_Utils_Tuple2('When your business faces a cyber event, Travelers can coordinate expert resources to provide your business a seamless claims process.', 'When your business faces a cyber event, Travelers can coordinate expert resources to provide your business a seamless claims process.'),
			_Utils_Tuple2('Yes, our claim team has an established cyber incident response panel. Our panel vendors have handled thousands of cyber incidents and work regularly with each other. This ecosystem of incident response vendors provides efficiency gain for your business as they work seamlessly together. Moreover, Travelers has negotiated favorable rates with its panel vendors to help manage the costs of incident response for your business.', 'Yes, our claim team has an established cyber incident response panel. Our panel vendors have handled thousands of cyber incidents and work regularly with each other. This ecosystem of incident response vendors provides efficiency gain for your business as they work seamlessly together. Moreover, Travelers has negotiated favorable rates with its panel vendors to help manage the costs of incident response for your business.'),
			_Utils_Tuple2('Go to Preferred Vendors', 'Go to Preferred Vendors'),
			_Utils_Tuple2('Go to Claims Resources', 'Go to Claims Resources'),
			_Utils_Tuple2('Please navigate to the Claims Resources page for more information regarding filing a claim and answers to our claims FAQS.', 'Please navigate to the Claims Resources page for more information regarding filing a claim and answers to our claims FAQS.'),
			_Utils_Tuple2('Client Technology Overview: %{clientName}', 'Client Technology Overview: %{clientName}'),
			_Utils_Tuple2('Suggested Natures of Business', 'Suggested Natures of Business'),
			_Utils_Tuple2('Add Additional Domain(s)', 'Add Additional Domain(s)'),
			_Utils_Tuple2('Please provide addresses of the domain(s) you would like to add.', 'Please provide addresses of the domain(s) you would like to add.'),
			_Utils_Tuple2('Additional Address(es)', 'Additional Address(es)'),
			_Utils_Tuple2('+ Add Another Domain', '+ Add Another Domain'),
			_Utils_Tuple2('Only 5 domains may be requested at a time. Please submit and re-open request to add more.', 'Only 5 domains may be requested at a time. Please submit and re-open request to add more.'),
			_Utils_Tuple2('Incident Response Tabletop Services', 'Incident Response Tabletop Services'),
			_Utils_Tuple2('Incident Response Tabletop Services*', 'Incident Response Tabletop Services*'),
			_Utils_Tuple2('Congratulations! Based on the information we have about your organization, we have no recommendations to improve your security posture at this time! <tag>Check back monthly, as each scan may find additional information and associated recommendations.</tag>', 'Congratulations! Based on the information we have about your organization, we have no recommendations to improve your security posture at this time! <tag>Check back monthly, as each scan may find additional information and associated recommendations.</tag>'),
			_Utils_Tuple2('Fill out Security Questionnaires to help us understand your cyber risk beyond the Scan so that we can provide specific, tailored security recommendations.', 'Fill out Security Questionnaires to help us understand your cyber risk beyond the Scan so that we can provide specific, tailored security recommendations.'),
			_Utils_Tuple2('Your Domain Address(es) has been sent to the Cyber Risk Services team to review and add.', 'Your Domain Address(es) has been sent to the Cyber Risk Services team to review and add.'),
			_Utils_Tuple2('Complete Security Questionnaires', 'Complete Security Questionnaires'),
			_Utils_Tuple2('Fill out the questionnaires to receive recommended security improvements to help avoid a cyber attack.', 'Fill out the questionnaires to receive recommended security improvements to help avoid a cyber attack.'),
			_Utils_Tuple2('Potential Business Liabilities: ', 'Potential Business Liabilities: '),
			_Utils_Tuple2('Software Type: ', 'Software Type: '),
			_Utils_Tuple2('Value: ', 'Value: '),
			_Utils_Tuple2('Response Feedback: ', 'Response Feedback: '),
			_Utils_Tuple2('Approve Response', 'Approve Response'),
			_Utils_Tuple2('Reject Response', 'Reject Response'),
			_Utils_Tuple2('Client name, ID, or website', 'Client name, ID, or website'),
			_Utils_Tuple2('Must not include capital letters, "/", or ":" characters.', 'Must not include capital letters, "/", or ":" characters.'),
			_Utils_Tuple2('Detection of Internet accessible RD Web.', 'Detection of Internet accessible RD Web.'),
			_Utils_Tuple2('Microsoft Remote Desktop Web Access (Microsoft RD Web Access) allows users to remotely access desktops and applications through a Web browser. It\'s a common initial attack vector for ransomware attacks.', 'Microsoft Remote Desktop Web Access (Microsoft RD Web Access) allows users to remotely access desktops and applications through a Web browser. It\'s a common initial attack vector for ransomware attacks.'),
			_Utils_Tuple2('The Cyber Risk Scan detected the presence of Microsoft RDS Web Gateway (Microsoft RD Web) that was publicly accessible on a system associated with your organization.', 'The Cyber Risk Scan detected the presence of Microsoft RDS Web Gateway (Microsoft RD Web) that was publicly accessible on a system associated with your organization.'),
			_Utils_Tuple2('See technology overview above for nature of business suggestions and rationale.', 'See technology overview above for nature of business suggestions and rationale.'),
			_Utils_Tuple2('AI assistance available: ', 'AI assistance available: '),
			_Utils_Tuple2('Currently unavailable for this account.', 'Currently unavailable for this account.')
		]));
var $author$project$Translate$gettext = function (msgid) {
	return A2(
		$elm$core$Maybe$withDefault,
		msgid,
		A2($elm$core$Dict$get, msgid, $author$project$Translation$translations));
};
var $author$project$Login$SigninV2$Update$confirmationValidator = F2(
	function (existing, input) {
		return _Utils_eq(existing, input) ? $elm$core$Result$Ok(input) : $elm$core$Result$Err(
			$author$project$Translate$extractTemp(
				$author$project$Translate$gettext('Passwords do not match.')));
	});
var $author$project$Ports$copyTextToClipboard = _Platform_outgoingPort('copyTextToClipboard', $elm$json$Json$Encode$string);
var $author$project$UserTracking$EventName$Action = function (a) {
	return {$: 4, a: a};
};
var $author$project$Login$UserTracking$Events$mfaSetupRequirementEvent = function (requirement) {
	var requirementStr = function () {
		if (!requirement) {
			return 'Optional MFA Setup';
		} else {
			return 'Required MFA Setup';
		}
	}();
	return _Utils_Tuple2(
		'requirement',
		$elm$json$Json$Encode$string(requirementStr));
};
var $author$project$Login$UserTracking$Events$mfaSetupStepEvent = function (step) {
	var stepStr = function () {
		switch (step.$) {
			case 1:
				return 'Download Authenticator App Step';
			case 2:
				return 'Locate QR Code Feature Step';
			case 0:
				return 'MFA Setup Required Step';
			default:
				return 'Scan QR Code Step';
		}
	}();
	return _Utils_Tuple2(
		'from',
		$elm$json$Json$Encode$string(stepStr));
};
var $author$project$Login$UserTracking$Events$encodeMfaSetupEvent = function (event) {
	var eventPrefix = 'MFA Setup ';
	switch (event.$) {
		case 0:
			var requirement = event.a;
			return A3(
				$author$project$Login$UserTracking$Events$trackingData,
				$author$project$UserTracking$EventName$Action('Manual Submission With Invalid MFA Code'),
				eventPrefix + 'Enter MFA Code',
				_List_fromArray(
					[
						$author$project$Login$UserTracking$Events$mfaSetupRequirementEvent(requirement)
					]));
		case 1:
			var step = event.a;
			return A3(
				$author$project$Login$UserTracking$Events$trackingData,
				$author$project$UserTracking$EventName$LinkClicked,
				eventPrefix + 'I Need Help',
				_List_fromArray(
					[
						$author$project$Login$UserTracking$Events$mfaSetupStepEvent(step)
					]));
		case 2:
			var step = event.a;
			var requirement = event.b;
			return A3(
				$author$project$Login$UserTracking$Events$trackingData,
				$author$project$UserTracking$EventName$ButtonClicked,
				eventPrefix + 'Next Step',
				_List_fromArray(
					[
						$author$project$Login$UserTracking$Events$mfaSetupStepEvent(step),
						$author$project$Login$UserTracking$Events$mfaSetupRequirementEvent(requirement)
					]));
		case 3:
			var step = event.a;
			var requirement = event.b;
			return A3(
				$author$project$Login$UserTracking$Events$trackingData,
				$author$project$UserTracking$EventName$ButtonClicked,
				eventPrefix + 'Previous Step',
				_List_fromArray(
					[
						$author$project$Login$UserTracking$Events$mfaSetupStepEvent(step),
						$author$project$Login$UserTracking$Events$mfaSetupRequirementEvent(requirement)
					]));
		default:
			var requirement = event.a;
			return A3(
				$author$project$Login$UserTracking$Events$trackingData,
				$author$project$UserTracking$EventName$Action('Automatic Sign In With MFA Code'),
				eventPrefix + 'Enter MFA Code',
				_List_fromArray(
					[
						$author$project$Login$UserTracking$Events$mfaSetupRequirementEvent(requirement)
					]));
	}
};
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$Data$MfaCode$MfaCode = $elm$core$Basics$identity;
var $author$project$Data$MfaCode$fromString = $elm$core$Basics$identity;
var $author$project$Login$UserTracking$Events$MfaSetupOptional = 0;
var $author$project$Login$UserTracking$Events$MfaSetupRequired = 1;
var $author$project$Login$UserTracking$Events$getMfaSetupRequirement = function (isMfaSetupRequired) {
	return isMfaSetupRequired ? 1 : 0;
};
var $author$project$Login$SigninV2$Update$navigateAfterSigninCmd = F3(
	function (role, _v0, locationAfterSignin) {
		var _v1 = _Utils_Tuple2(role, locationAfterSignin);
		_v1$0:
		while (true) {
			switch (_v1.a.$) {
				case 4:
					if (!_v1.b.$) {
						break _v1$0;
					} else {
						return $elm$browser$Browser$Navigation$load('/admin');
					}
				case 6:
					if (!_v1.b.$) {
						break _v1$0;
					} else {
						var _v2 = _v1.a;
						return $elm$browser$Browser$Navigation$load('/developer');
					}
				default:
					if (!_v1.b.$) {
						break _v1$0;
					} else {
						return $elm$browser$Browser$Navigation$load('/');
					}
			}
		}
		var path = _v1.b.a;
		return A2($elm$core$String$startsWith, '//', path) ? $elm$browser$Browser$Navigation$load('/') : (A2($elm$core$String$startsWith, '/', path) ? $elm$browser$Browser$Navigation$load(path) : $elm$browser$Browser$Navigation$load('/'));
	});
var $author$project$Login$SigninV2$Update$handlePasswordFlowSigninRequestCompleted = F4(
	function (innerModel, tokenDetails, accountData, mainModel) {
		var key = mainModel.mL;
		if (accountData.$ === 3) {
			var data = accountData;
			var account = data.a;
			switch (account.$) {
				case 0:
					var session = account.a;
					var role = account.b;
					var form = A2(
						$author$project$Login$SigninV2$Model$Model,
						_Utils_update(
							innerModel,
							{BH: data}),
						$author$project$Login$SigninV2$Model$PasswordFlow(tokenDetails));
					return _Utils_Tuple2(
						_Utils_Tuple2(
							form,
							A3($author$project$Login$SigninV2$Update$navigateAfterSigninCmd, role, key, session.zG)),
						_Utils_update(
							mainModel,
							{
								w3: A2($author$project$Data$Session$Authenticated, session, role),
								yO: $elm$core$Maybe$Nothing
							}));
				case 2:
					return _Utils_Tuple2(
						_Utils_Tuple2(
							A2(
								$author$project$Login$SigninV2$Model$Model,
								_Utils_update(
									innerModel,
									{BH: data}),
								$author$project$Login$SigninV2$Model$MfaInputFlow(
									$author$project$Model$ValidationNext$unvalidated(
										$author$project$Data$MfaCode$fromString('')))),
							A2(
								$elm$core$Task$attempt,
								function (_v2) {
									return $author$project$Login$SigninV2$Model$NoOp;
								},
								$elm$browser$Browser$Dom$focus('mfaInput'))),
						mainModel);
				case 1:
					var qrCode = account.a;
					return _Utils_Tuple2(
						_Utils_Tuple2(
							A2(
								$author$project$Login$SigninV2$Model$Model,
								_Utils_update(
									innerModel,
									{BH: data}),
								A3($author$project$Login$SigninV2$Model$MfaSetupFlow, true, qrCode, $author$project$Login$MfaSetup$RequiredMfaSetup)),
							A2(
								$elm$core$Task$attempt,
								function (_v3) {
									return $author$project$Login$SigninV2$Model$NoOp;
								},
								$elm$browser$Browser$Dom$focus('mfaInput'))),
						mainModel);
				default:
					return _Utils_Tuple2(
						_Utils_Tuple2(
							A2(
								$author$project$Login$SigninV2$Model$Model,
								_Utils_update(
									innerModel,
									{BH: data}),
								$author$project$Login$SigninV2$Model$PasswordFlow(tokenDetails)),
							$elm$core$Platform$Cmd$none),
						mainModel);
			}
		} else {
			var data = accountData;
			return _Utils_Tuple2(
				_Utils_Tuple2(
					A2(
						$author$project$Login$SigninV2$Model$Model,
						_Utils_update(
							innerModel,
							{BH: data}),
						$author$project$Login$SigninV2$Model$PasswordFlow(tokenDetails)),
					$elm$core$Platform$Cmd$none),
				mainModel);
		}
	});
var $author$project$Login$SigninV2$Model$isCorvusEmail = function (checkEmail) {
	var pattern = '@corvusinsurance\\.com$';
	return A2(
		$elm$regex$Regex$contains,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString(pattern)),
		checkEmail);
};
var $author$project$Login$SigninV2$Model$isCorvusPlusAddressEmail = function (checkEmail) {
	var pattern = '.+\\+.+@corvusinsurance\\.com$';
	return A2(
		$elm$regex$Regex$contains,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString(pattern)),
		checkEmail);
};
var $author$project$Login$SigninV2$Model$isTravelersEmail = function (checkEmail) {
	var pattern = '@travelers\\.com$';
	return A2(
		$elm$regex$Regex$contains,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString(pattern)),
		checkEmail);
};
var $author$project$Data$Password$toString = function (_v0) {
	var string = _v0;
	return string;
};
var $author$project$Request$Account$resetPasswordAndSignin = F4(
	function (msg, password, resetToken, csrfToken) {
		var decoder = A2($elm$json$Json$Decode$field, 'data', $author$project$Data$Session$accountDecoder);
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'password',
						$elm$json$Json$Encode$string(
							$author$project$Data$Password$toString(password)))
					])));
		return $elm$http$Http$request(
			{
				k8: body,
				da: A2($elm$http$Http$expectJson, msg, decoder),
				dd: _List_fromArray(
					[
						A2($elm$http$Http$header, 'x-csrf-token', csrfToken)
					]),
				dg: 'POST',
				ds: $elm$core$Maybe$Nothing,
				dt: $elm$core$Maybe$Nothing,
				Cd: '/reset-signin/' + resetToken
			});
	});
var $author$project$Request$Account$locationEncoder = A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string);
var $author$project$Request$Account$signin = F5(
	function (msg, email, password, locationAfterSignin, csrfToken) {
		return A3(
			$author$project$Request$Account$doSignin,
			msg,
			csrfToken,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'email',
						$elm$json$Json$Encode$string(
							$author$project$Data$Email$toString(email))),
						_Utils_Tuple2(
						'password',
						$elm$json$Json$Encode$string(
							$author$project$Data$Password$toString(password))),
						_Utils_Tuple2(
						'location',
						$author$project$Request$Account$locationEncoder(locationAfterSignin))
					])));
	});
var $author$project$Data$MfaCode$toString = function (_v0) {
	var raw = _v0;
	return raw;
};
var $author$project$Request$Account$signinWithAndSetupMfa = F7(
	function (msg, email, password, mfaCode, sharedSecret, locationAfterSignin, csrfToken) {
		return A3(
			$author$project$Request$Account$doSignin,
			msg,
			csrfToken,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'email',
						$elm$json$Json$Encode$string(
							$author$project$Data$Email$toString(email))),
						_Utils_Tuple2(
						'password',
						$elm$json$Json$Encode$string(
							$author$project$Data$Password$toString(password))),
						_Utils_Tuple2(
						'shared_secret',
						$elm$json$Json$Encode$string(sharedSecret)),
						_Utils_Tuple2(
						'code',
						$elm$json$Json$Encode$string(
							$author$project$Data$MfaCode$toString(mfaCode))),
						_Utils_Tuple2(
						'location',
						$author$project$Request$Account$locationEncoder(locationAfterSignin))
					])));
	});
var $elm$http$Http$expectString = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		$elm$http$Http$resolve($elm$core$Result$Ok));
};
var $author$project$Request$Account$signinWithEmail = F3(
	function (msg, email, csrfToken) {
		var url = $author$project$Broker$Route$toUrl($author$project$Broker$Route$defaultSigninRoute);
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'email',
						$elm$json$Json$Encode$string(email))
					])));
		return $elm$http$Http$request(
			{
				k8: body,
				da: $elm$http$Http$expectString(msg),
				dd: _List_fromArray(
					[
						A2($elm$http$Http$header, 'x-csrf-token', csrfToken)
					]),
				dg: 'POST',
				ds: $elm$core$Maybe$Nothing,
				dt: $elm$core$Maybe$Nothing,
				Cd: url
			});
	});
var $author$project$Request$Account$signinWithMfa = F6(
	function (msg, email, password, mfaCode, locationAfterSignin, csrfToken) {
		return A3(
			$author$project$Request$Account$doSignin,
			msg,
			csrfToken,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'email',
						$elm$json$Json$Encode$string(
							$author$project$Data$Email$toString(email))),
						_Utils_Tuple2(
						'password',
						$elm$json$Json$Encode$string(
							$author$project$Data$Password$toString(password))),
						_Utils_Tuple2(
						'code',
						$elm$json$Json$Encode$string(
							$author$project$Data$MfaCode$toString(mfaCode))),
						_Utils_Tuple2(
						'location',
						$author$project$Request$Account$locationEncoder(locationAfterSignin))
					])));
	});
var $author$project$Login$SigninV2$Model$confirmationValidator = F2(
	function (existing, input) {
		return _Utils_eq(existing, input) ? $elm$core$Result$Ok(input) : $elm$core$Result$Err(
			$author$project$Translate$extractTemp(
				$author$project$Translate$gettext('Passwords do not match.')));
	});
var $author$project$Model$Validators$validatePassword = function (_v0) {
	var password = _v0;
	return A2(
		$elm$core$Result$map,
		$elm$core$Basics$identity,
		A4($author$project$Model$Validators$lengthBetween, 'Password', 8, 255, password));
};
var $author$project$Data$MfaCode$expectedLength = 6;
var $author$project$Data$MfaCode$expectedLengthString = $elm$core$String$fromInt($author$project$Data$MfaCode$expectedLength);
var $author$project$Data$MfaCode$fieldName = 'MFA Code';
var $author$project$Data$MfaCode$mfaCodeRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[0-9]{' + ($author$project$Data$MfaCode$expectedLengthString + '}$')));
var $author$project$Data$MfaCode$validateStrict = function (_v0) {
	var raw = _v0;
	return A2($elm$regex$Regex$contains, $author$project$Data$MfaCode$mfaCodeRegex, raw) ? $elm$core$Result$Ok(raw) : $elm$core$Result$Err($author$project$Data$MfaCode$fieldName + (' must be ' + ($author$project$Data$MfaCode$expectedLengthString + ' digits.')));
};
var $author$project$Login$SigninV2$Model$validate = function (_v0) {
	var details = _v0.a;
	var flow = _v0.b;
	switch (flow.$) {
		case 0:
			var mfaCode = flow.a;
			return A2(
				$author$project$Login$SigninV2$Model$Model,
				details,
				$author$project$Login$SigninV2$Model$MfaInputFlow(
					A2($author$project$Model$ValidationNext$validate, $author$project$Data$MfaCode$validateStrict, mfaCode)));
		case 1:
			var isMfaSetupRequired = flow.a;
			var qrCode = flow.b;
			var mfaSetupStep = flow.c;
			switch (mfaSetupStep.$) {
				case 0:
					return A2(
						$author$project$Login$SigninV2$Model$Model,
						details,
						A3($author$project$Login$SigninV2$Model$MfaSetupFlow, isMfaSetupRequired, qrCode, $author$project$Login$MfaSetup$RequiredMfaSetup));
				case 1:
					var modalState = mfaSetupStep.a;
					return A2(
						$author$project$Login$SigninV2$Model$Model,
						details,
						A3(
							$author$project$Login$SigninV2$Model$MfaSetupFlow,
							isMfaSetupRequired,
							qrCode,
							$author$project$Login$MfaSetup$DownloadApp(modalState)));
				case 2:
					var modalState = mfaSetupStep.a;
					return A2(
						$author$project$Login$SigninV2$Model$Model,
						details,
						A3(
							$author$project$Login$SigninV2$Model$MfaSetupFlow,
							isMfaSetupRequired,
							qrCode,
							$author$project$Login$MfaSetup$LocateQRCode(modalState)));
				default:
					var mfaCode = mfaSetupStep.a;
					var copiedToClipboard = mfaSetupStep.b;
					return A2(
						$author$project$Login$SigninV2$Model$Model,
						details,
						A3(
							$author$project$Login$SigninV2$Model$MfaSetupFlow,
							isMfaSetupRequired,
							qrCode,
							A2(
								$author$project$Login$MfaSetup$ScanQRCode,
								A2($author$project$Model$ValidationNext$validate, $author$project$Data$MfaCode$validateStrict, mfaCode),
								copiedToClipboard)));
			}
		case 2:
			var tokenDetails = flow.a;
			return A2(
				$author$project$Login$SigninV2$Model$Model,
				_Utils_update(
					details,
					{
						aW: A2($author$project$Model$ValidationNext$validate, $author$project$Model$Validators$validateEmail, details.aW),
						d$: A2($author$project$Model$ValidationNext$validate, $author$project$Model$Validators$validatePassword, details.d$)
					}),
				$author$project$Login$SigninV2$Model$PasswordFlow(tokenDetails));
		default:
			var resetPasswordData = flow.a;
			var validatedData = _Utils_update(
				resetPasswordData,
				{
					d$: A2($author$project$Model$ValidationNext$validate, $author$project$Model$Validators$validatePassword, resetPasswordData.d$),
					vO: A2(
						$author$project$Model$ValidationNext$validate,
						$author$project$Login$SigninV2$Model$confirmationValidator(
							$author$project$Model$ValidationNext$extract(resetPasswordData.d$)),
						resetPasswordData.vO)
				});
			return A2(
				$author$project$Login$SigninV2$Model$Model,
				details,
				$author$project$Login$SigninV2$Model$ResetPasswordFlow(validatedData));
	}
};
var $author$project$Login$SigninV2$Update$update = F3(
	function (msg, mainModel, model) {
		var csrfToken = mainModel.x6;
		var isStaging = mainModel.zl;
		var details = model.a;
		var flow = model.b;
		_v0$18:
		while (true) {
			switch (msg.$) {
				case 0:
					var value = msg.a;
					var updatedFlow = function () {
						switch (flow.$) {
							case 0:
								return flow;
							case 1:
								var isMfaSetupRequired = flow.a;
								var qrCode = flow.b;
								var mfaSetupStep = flow.c;
								switch (mfaSetupStep.$) {
									case 0:
										return flow;
									case 1:
										return flow;
									case 2:
										return flow;
									default:
										var mfaCode = mfaSetupStep.a;
										return A3(
											$author$project$Login$SigninV2$Model$MfaSetupFlow,
											isMfaSetupRequired,
											qrCode,
											A2($author$project$Login$MfaSetup$ScanQRCode, mfaCode, true));
								}
							case 2:
								var tokenDetails = flow.a;
								return $author$project$Login$SigninV2$Model$PasswordFlow(tokenDetails);
							default:
								return flow;
						}
					}();
					return _Utils_Tuple2(
						_Utils_Tuple2(
							A2($author$project$Login$SigninV2$Model$Model, details, updatedFlow),
							$author$project$Ports$copyTextToClipboard(value)),
						mainModel);
				case 1:
					var signInTrackingCmd = A2($author$project$UserTracking$trackUnknownUserEvent, $author$project$Login$UserTracking$Events$encodeEvent, $author$project$Login$UserTracking$Events$SignInButtonClicked);
					var _v3 = $author$project$Login$SigninV2$Model$validate(model);
					var validatedDetails = _v3.a;
					var validatedFlow = _v3.b;
					var _v4 = validatedDetails;
					var email = _v4.aW;
					var options = _v4.z8;
					var password = _v4.d$;
					switch (validatedFlow.$) {
						case 0:
							var mfaCode = validatedFlow.a;
							var _v6 = _Utils_Tuple3(mfaCode, email, password);
							if (((_v6.a.$ === 1) && (_v6.b.$ === 1)) && (_v6.c.$ === 1)) {
								var validCode = _v6.a.a;
								var validEmail = _v6.b.a;
								var validPassword = _v6.c.a;
								var signInRequest = A6(
									$author$project$Request$Account$signinWithMfa,
									A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Login$SigninV2$Model$SigninRequestCompleted),
									validEmail,
									validPassword,
									validCode,
									options.Gh,
									mainModel.x6);
								return _Utils_Tuple2(
									_Utils_Tuple2(
										A2(
											$author$project$Login$SigninV2$Model$Model,
											_Utils_update(
												validatedDetails,
												{BH: $krisajenkins$remotedata$RemoteData$Loading}),
											validatedFlow),
										$elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[signInRequest, signInTrackingCmd]))),
									mainModel);
							} else {
								return _Utils_Tuple2(
									_Utils_Tuple2(model, signInTrackingCmd),
									mainModel);
							}
						case 1:
							var required = validatedFlow.a;
							var qrCode = validatedFlow.b;
							var mfaSetupStep = validatedFlow.c;
							var _v7 = _Utils_Tuple2(mfaSetupStep, required);
							switch (_v7.a.$) {
								case 0:
									var _v8 = _v7.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
										mainModel);
								case 1:
									return _Utils_Tuple2(
										_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
										mainModel);
								case 2:
									return _Utils_Tuple2(
										_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
										mainModel);
								default:
									var _v9 = _v7.a;
									var mfaCode = _v9.a;
									var copiedToClipboard = _v9.b;
									var _v10 = _Utils_Tuple3(mfaCode, email, password);
									if (_v10.a.$ === 2) {
										var invalidCode = _v10.a;
										return _Utils_Tuple2(
											_Utils_Tuple2(
												A2(
													$author$project$Login$SigninV2$Model$Model,
													validatedDetails,
													A3(
														$author$project$Login$SigninV2$Model$MfaSetupFlow,
														required,
														qrCode,
														A2($author$project$Login$MfaSetup$ScanQRCode, invalidCode, copiedToClipboard))),
												A2(
													$author$project$UserTracking$trackUnknownUserEvent,
													$author$project$Login$UserTracking$Events$encodeMfaSetupEvent,
													$author$project$Login$UserTracking$Events$MfaSetupInvalidMfaCodeSubmission(
														$author$project$Login$UserTracking$Events$getMfaSetupRequirement(required)))),
											mainModel);
									} else {
										return _Utils_Tuple2(
											_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
											mainModel);
									}
							}
						case 2:
							var _v11 = _Utils_Tuple2(email, password);
							if ((_v11.a.$ === 1) && (_v11.b.$ === 1)) {
								var validEmail = _v11.a.a;
								var validPassword = _v11.b.a;
								var signInRequest = A5(
									$author$project$Request$Account$signin,
									A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Login$SigninV2$Model$SigninRequestCompleted),
									validEmail,
									validPassword,
									options.Gh,
									mainModel.x6);
								return _Utils_Tuple2(
									_Utils_Tuple2(
										A2(
											$author$project$Login$SigninV2$Model$Model,
											_Utils_update(
												validatedDetails,
												{BH: $krisajenkins$remotedata$RemoteData$Loading}),
											validatedFlow),
										$elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[signInRequest, signInTrackingCmd]))),
									mainModel);
							} else {
								return _Utils_Tuple2(
									_Utils_Tuple2(model, signInTrackingCmd),
									mainModel);
							}
						default:
							return _Utils_Tuple2(
								_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
								mainModel);
					}
				case 2:
					var email = A2($author$project$Model$ValidationNext$toString, $author$project$Data$Email$toString, details.aW);
					return (isStaging && $author$project$Login$SigninV2$Model$isCorvusPlusAddressEmail(email)) ? _Utils_Tuple2(
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
						mainModel) : (($author$project$Login$SigninV2$Model$isCorvusEmail(email) || $author$project$Login$SigninV2$Model$isTravelersEmail(email)) ? _Utils_Tuple2(
						_Utils_Tuple2(
							A2(
								$author$project$Login$SigninV2$Model$Model,
								_Utils_update(
									details,
									{
										d$: $author$project$Model$ValidationNext$Unvalidated('')
									}),
								flow),
							A3(
								$author$project$Request$Account$signinWithEmail,
								A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Login$SigninV2$Model$GetAuthorizeUrl),
								email,
								mainModel.x6)),
						mainModel) : _Utils_Tuple2(
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
						mainModel));
				case 3:
					var userInput = msg.a;
					var updatedDetails = _Utils_update(
						details,
						{
							aW: A3(
								$author$project$Model$ValidationNext$update,
								$author$project$Data$Email$initial(userInput),
								$author$project$Model$Validators$validateEmail,
								details.aW),
							BH: $krisajenkins$remotedata$RemoteData$NotAsked
						});
					return _Utils_Tuple2(
						_Utils_Tuple2(
							A2($author$project$Login$SigninV2$Model$Model, updatedDetails, flow),
							$elm$core$Platform$Cmd$none),
						mainModel);
				case 4:
					if (msg.a.$ === 3) {
						var authorizeUrl = msg.a.a;
						return (authorizeUrl === '') ? _Utils_Tuple2(
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
							mainModel) : _Utils_Tuple2(
							_Utils_Tuple2(
								model,
								$elm$browser$Browser$Navigation$load(authorizeUrl)),
							mainModel);
					} else {
						return _Utils_Tuple2(
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
							mainModel);
					}
				case 6:
					switch (flow.$) {
						case 0:
							return _Utils_Tuple2(
								_Utils_Tuple2(
									A2($author$project$Login$SigninV2$Model$Model, details, flow),
									$elm$core$Platform$Cmd$none),
								mainModel);
						case 1:
							var isMfaSetupRequired = flow.a;
							var qrCode = flow.b;
							var currentStep = flow.c;
							var trackingCmd = A2(
								$author$project$UserTracking$trackUnknownUserEvent,
								$author$project$Login$UserTracking$Events$encodeMfaSetupEvent,
								A2(
									$author$project$Login$UserTracking$Events$MfaSetupNextStepClicked,
									currentStep,
									$author$project$Login$UserTracking$Events$getMfaSetupRequirement(isMfaSetupRequired)));
							switch (currentStep.$) {
								case 0:
									return _Utils_Tuple2(
										_Utils_Tuple2(
											A2(
												$author$project$Login$SigninV2$Model$Model,
												details,
												A3(
													$author$project$Login$SigninV2$Model$MfaSetupFlow,
													isMfaSetupRequired,
													qrCode,
													$author$project$Login$MfaSetup$DownloadApp(1))),
											trackingCmd),
										mainModel);
								case 1:
									return _Utils_Tuple2(
										_Utils_Tuple2(
											A2(
												$author$project$Login$SigninV2$Model$Model,
												details,
												A3(
													$author$project$Login$SigninV2$Model$MfaSetupFlow,
													isMfaSetupRequired,
													qrCode,
													$author$project$Login$MfaSetup$LocateQRCode(1))),
											trackingCmd),
										mainModel);
								case 2:
									var scanStep = A2(
										$author$project$Login$MfaSetup$ScanQRCode,
										$author$project$Model$ValidationNext$unvalidated(
											$author$project$Data$MfaCode$fromString('')),
										false);
									return _Utils_Tuple2(
										_Utils_Tuple2(
											A2(
												$author$project$Login$SigninV2$Model$Model,
												details,
												A3($author$project$Login$SigninV2$Model$MfaSetupFlow, isMfaSetupRequired, qrCode, scanStep)),
											trackingCmd),
										mainModel);
								default:
									return _Utils_Tuple2(
										_Utils_Tuple2(
											A2($author$project$Login$SigninV2$Model$Model, details, flow),
											$elm$core$Platform$Cmd$none),
										mainModel);
							}
						case 2:
							return _Utils_Tuple2(
								_Utils_Tuple2(
									A2($author$project$Login$SigninV2$Model$Model, details, flow),
									$elm$core$Platform$Cmd$none),
								mainModel);
						default:
							return _Utils_Tuple2(
								_Utils_Tuple2(
									A2($author$project$Login$SigninV2$Model$Model, details, flow),
									$elm$core$Platform$Cmd$none),
								mainModel);
					}
				case 5:
					switch (flow.$) {
						case 0:
							return _Utils_Tuple2(
								_Utils_Tuple2(
									A2($author$project$Login$SigninV2$Model$Model, details, flow),
									$elm$core$Platform$Cmd$none),
								mainModel);
						case 1:
							var isMfaSetupRequired = flow.a;
							var qrCode = flow.b;
							var currentStep = flow.c;
							var trackingCmd = A2(
								$author$project$UserTracking$trackUnknownUserEvent,
								$author$project$Login$UserTracking$Events$encodeMfaSetupEvent,
								A2(
									$author$project$Login$UserTracking$Events$MfaSetupPreviousStepClicked,
									currentStep,
									$author$project$Login$UserTracking$Events$getMfaSetupRequirement(isMfaSetupRequired)));
							switch (currentStep.$) {
								case 0:
									return _Utils_Tuple2(
										_Utils_Tuple2(
											A2($author$project$Login$SigninV2$Model$Model, details, flow),
											$elm$core$Platform$Cmd$none),
										mainModel);
								case 1:
									return _Utils_Tuple2(
										_Utils_Tuple2(
											A2(
												$author$project$Login$SigninV2$Model$Model,
												details,
												A3($author$project$Login$SigninV2$Model$MfaSetupFlow, isMfaSetupRequired, qrCode, $author$project$Login$MfaSetup$RequiredMfaSetup)),
											trackingCmd),
										mainModel);
								case 2:
									return _Utils_Tuple2(
										_Utils_Tuple2(
											A2(
												$author$project$Login$SigninV2$Model$Model,
												details,
												A3(
													$author$project$Login$SigninV2$Model$MfaSetupFlow,
													isMfaSetupRequired,
													qrCode,
													$author$project$Login$MfaSetup$DownloadApp(1))),
											trackingCmd),
										mainModel);
								default:
									return _Utils_Tuple2(
										_Utils_Tuple2(
											A2(
												$author$project$Login$SigninV2$Model$Model,
												details,
												A3(
													$author$project$Login$SigninV2$Model$MfaSetupFlow,
													isMfaSetupRequired,
													qrCode,
													$author$project$Login$MfaSetup$LocateQRCode(1))),
											trackingCmd),
										mainModel);
							}
						case 2:
							return _Utils_Tuple2(
								_Utils_Tuple2(
									A2($author$project$Login$SigninV2$Model$Model, details, flow),
									$elm$core$Platform$Cmd$none),
								mainModel);
						default:
							return _Utils_Tuple2(
								_Utils_Tuple2(
									A2($author$project$Login$SigninV2$Model$Model, details, flow),
									$elm$core$Platform$Cmd$none),
								mainModel);
					}
				case 7:
					var userInput = msg.a;
					switch (flow.$) {
						case 0:
							var mfaCode = flow.a;
							var validatedCode = A3(
								$author$project$Model$ValidationNext$update,
								$author$project$Data$MfaCode$fromString(userInput),
								$author$project$Data$MfaCode$validateStrict,
								mfaCode);
							return _Utils_Tuple2(
								_Utils_Tuple2(
									A2(
										$author$project$Login$SigninV2$Model$Model,
										details,
										$author$project$Login$SigninV2$Model$MfaInputFlow(validatedCode)),
									$elm$core$Platform$Cmd$none),
								mainModel);
						case 1:
							var isMfaSetupRequired = flow.a;
							var qrCode = flow.b;
							var qrSharedSecret = qrCode.b;
							var mfaSetupStep = flow.c;
							switch (mfaSetupStep.$) {
								case 0:
									return _Utils_Tuple2(
										_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
										mainModel);
								case 1:
									return _Utils_Tuple2(
										_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
										mainModel);
								case 2:
									return _Utils_Tuple2(
										_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
										mainModel);
								default:
									var mfaCode = mfaSetupStep.a;
									var copiedToClipboard = mfaSetupStep.b;
									var updatedMfaCode = A3(
										$author$project$Model$ValidationNext$update,
										$author$project$Data$MfaCode$fromString(userInput),
										$author$project$Data$MfaCode$validateStrict,
										mfaCode);
									var updatedFlow = function (updatedMfaCode_) {
										return A3(
											$author$project$Login$SigninV2$Model$MfaSetupFlow,
											isMfaSetupRequired,
											qrCode,
											A2($author$project$Login$MfaSetup$ScanQRCode, updatedMfaCode_, copiedToClipboard));
									};
									var statelesslyValidatedMfaCode = A2($author$project$Model$ValidationNext$validate, $author$project$Data$MfaCode$validateStrict, updatedMfaCode);
									var _v18 = details;
									var email = _v18.aW;
									var options = _v18.z8;
									var password = _v18.d$;
									var _v19 = _Utils_Tuple3(statelesslyValidatedMfaCode, email, password);
									if (((_v19.a.$ === 1) && (_v19.b.$ === 1)) && (_v19.c.$ === 1)) {
										var validCode = _v19.a.a;
										var validEmail = _v19.b.a;
										var validPassword = _v19.c.a;
										var signInTrackingCmd = A2(
											$author$project$UserTracking$trackUnknownUserEvent,
											$author$project$Login$UserTracking$Events$encodeMfaSetupEvent,
											$author$project$Login$UserTracking$Events$MfaSetupSignInAfterValidMfaCodeEntered(
												$author$project$Login$UserTracking$Events$getMfaSetupRequirement(isMfaSetupRequired)));
										var signInRequest = A7(
											$author$project$Request$Account$signinWithAndSetupMfa,
											A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Login$SigninV2$Model$SigninRequestCompleted),
											validEmail,
											validPassword,
											validCode,
											qrSharedSecret,
											options.Gh,
											mainModel.x6);
										return _Utils_Tuple2(
											_Utils_Tuple2(
												A2(
													$author$project$Login$SigninV2$Model$Model,
													_Utils_update(
														details,
														{BH: $krisajenkins$remotedata$RemoteData$Loading}),
													updatedFlow(statelesslyValidatedMfaCode)),
												$elm$core$Platform$Cmd$batch(
													_List_fromArray(
														[signInRequest, signInTrackingCmd]))),
											mainModel);
									} else {
										return _Utils_Tuple2(
											_Utils_Tuple2(
												A2(
													$author$project$Login$SigninV2$Model$Model,
													details,
													updatedFlow(updatedMfaCode)),
												$elm$core$Platform$Cmd$none),
											mainModel);
									}
							}
						case 2:
							return _Utils_Tuple2(
								_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
								mainModel);
						default:
							return _Utils_Tuple2(
								_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
								mainModel);
					}
				case 8:
					switch (flow.$) {
						case 0:
							var trackingCmd = A2($author$project$UserTracking$trackUnknownUserEvent, $author$project$Login$UserTracking$Events$encodeEvent, $author$project$Login$UserTracking$Events$MfaLoginNeedHelpLinkClicked);
							return _Utils_Tuple2(
								_Utils_Tuple2(model, trackingCmd),
								mainModel);
						case 1:
							return _Utils_Tuple2(
								_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
								mainModel);
						case 2:
							return _Utils_Tuple2(
								_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
								mainModel);
						default:
							return _Utils_Tuple2(
								_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
								mainModel);
					}
				case 9:
					switch (flow.$) {
						case 0:
							return _Utils_Tuple2(
								_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
								mainModel);
						case 1:
							var mfaSetupStep = flow.c;
							var trackingCmd = A2(
								$author$project$UserTracking$trackUnknownUserEvent,
								$author$project$Login$UserTracking$Events$encodeMfaSetupEvent,
								$author$project$Login$UserTracking$Events$MfaSetupNeedHelpLinkClicked(mfaSetupStep));
							return _Utils_Tuple2(
								_Utils_Tuple2(model, trackingCmd),
								mainModel);
						case 2:
							return _Utils_Tuple2(
								_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
								mainModel);
						default:
							return _Utils_Tuple2(
								_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
								mainModel);
					}
				case 10:
					return _Utils_Tuple2(
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
						mainModel);
				case 19:
					var userInput = msg.a;
					if (flow.$ === 3) {
						var resetPasswordData = flow.a;
						var updatedResetPassword = _Utils_update(
							resetPasswordData,
							{
								d$: A3($author$project$Model$ValidationNext$update, userInput, $author$project$Model$Validators$validatePassword, resetPasswordData.d$),
								vO: $author$project$Model$ValidationNext$unvalidated(
									$author$project$Model$ValidationNext$extract(resetPasswordData.vO)),
								Iz: $krisajenkins$remotedata$RemoteData$NotAsked
							});
						return _Utils_Tuple2(
							_Utils_Tuple2(
								A2(
									$author$project$Login$SigninV2$Model$Model,
									details,
									$author$project$Login$SigninV2$Model$ResetPasswordFlow(updatedResetPassword)),
								$elm$core$Platform$Cmd$none),
							mainModel);
					} else {
						var updatedDetails = _Utils_update(
							details,
							{
								d$: A3($author$project$Model$ValidationNext$update, userInput, $author$project$Model$Validators$validatePassword, details.d$),
								BH: $krisajenkins$remotedata$RemoteData$NotAsked
							});
						return _Utils_Tuple2(
							_Utils_Tuple2(
								A2($author$project$Login$SigninV2$Model$Model, updatedDetails, flow),
								$elm$core$Platform$Cmd$none),
							mainModel);
					}
				case 11:
					var accountData = msg.a;
					switch (flow.$) {
						case 0:
							_v24$2:
							while (true) {
								switch (accountData.$) {
									case 3:
										if (!accountData.a.$) {
											var data = accountData;
											var _v25 = data.a;
											var session = _v25.a;
											var role = _v25.b;
											return _Utils_Tuple2(
												_Utils_Tuple2(
													A2(
														$author$project$Login$SigninV2$Model$Model,
														_Utils_update(
															details,
															{BH: data}),
														flow),
													A3($author$project$Login$SigninV2$Update$navigateAfterSigninCmd, role, mainModel.mL, session.zG)),
												_Utils_update(
													mainModel,
													{
														w3: A2($author$project$Data$Session$Authenticated, session, role)
													}));
										} else {
											break _v24$2;
										}
									case 2:
										if ((accountData.a.$ === 3) && (accountData.a.a === 400)) {
											var data = accountData;
											return _Utils_Tuple2(
												_Utils_Tuple2(
													A2(
														$author$project$Login$SigninV2$Model$Model,
														_Utils_update(
															details,
															{BH: data}),
														$author$project$Login$SigninV2$Model$MfaInputFlow(
															$author$project$Model$ValidationNext$unvalidated(
																$author$project$Data$MfaCode$fromString('')))),
													A2(
														$elm$core$Task$attempt,
														function (_v26) {
															return $author$project$Login$SigninV2$Model$NoOp;
														},
														$elm$browser$Browser$Dom$focus('mfaInput'))),
												mainModel);
										} else {
											break _v24$2;
										}
									default:
										break _v24$2;
								}
							}
							var data = accountData;
							return _Utils_Tuple2(
								_Utils_Tuple2(
									A2(
										$author$project$Login$SigninV2$Model$Model,
										_Utils_update(
											details,
											{BH: data}),
										flow),
									$elm$core$Platform$Cmd$none),
								mainModel);
						case 1:
							var isMfaSetupRequired = flow.a;
							var qrCode = flow.b;
							var mfaSetupStep = flow.c;
							switch (mfaSetupStep.$) {
								case 0:
									return _Utils_Tuple2(
										_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
										mainModel);
								case 1:
									return _Utils_Tuple2(
										_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
										mainModel);
								case 2:
									return _Utils_Tuple2(
										_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
										mainModel);
								default:
									var copiedToClipboard = mfaSetupStep.b;
									_v28$2:
									while (true) {
										switch (accountData.$) {
											case 3:
												if (!accountData.a.$) {
													var data = accountData;
													var _v29 = data.a;
													var session = _v29.a;
													var role = _v29.b;
													return _Utils_Tuple2(
														_Utils_Tuple2(
															A2(
																$author$project$Login$SigninV2$Model$Model,
																_Utils_update(
																	details,
																	{BH: data}),
																flow),
															A3($author$project$Login$SigninV2$Update$navigateAfterSigninCmd, role, mainModel.mL, session.zG)),
														_Utils_update(
															mainModel,
															{
																w3: A2($author$project$Data$Session$Authenticated, session, role)
															}));
												} else {
													break _v28$2;
												}
											case 2:
												if ((accountData.a.$ === 3) && (accountData.a.a === 400)) {
													var data = accountData;
													return _Utils_Tuple2(
														_Utils_Tuple2(
															A2(
																$author$project$Login$SigninV2$Model$Model,
																_Utils_update(
																	details,
																	{BH: data}),
																A3(
																	$author$project$Login$SigninV2$Model$MfaSetupFlow,
																	isMfaSetupRequired,
																	qrCode,
																	A2(
																		$author$project$Login$MfaSetup$ScanQRCode,
																		$author$project$Model$ValidationNext$unvalidated(
																			$author$project$Data$MfaCode$fromString('')),
																		copiedToClipboard))),
															A2(
																$elm$core$Task$attempt,
																function (_v30) {
																	return $author$project$Login$SigninV2$Model$NoOp;
																},
																$elm$browser$Browser$Dom$focus('mfaInput'))),
														mainModel);
												} else {
													break _v28$2;
												}
											default:
												break _v28$2;
										}
									}
									var data = accountData;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											A2(
												$author$project$Login$SigninV2$Model$Model,
												_Utils_update(
													details,
													{BH: data}),
												flow),
											$elm$core$Platform$Cmd$none),
										mainModel);
							}
						case 2:
							var tokenDetails = flow.a;
							return A4($author$project$Login$SigninV2$Update$handlePasswordFlowSigninRequestCompleted, details, tokenDetails, accountData, mainModel);
						default:
							return _Utils_Tuple2(
								_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
								mainModel);
					}
				case 12:
					switch (flow.$) {
						case 0:
							return _Utils_Tuple2(
								_Utils_Tuple2(
									A2($author$project$Login$SigninV2$Model$Model, details, flow),
									$elm$core$Platform$Cmd$none),
								mainModel);
						case 1:
							var isMfaSetupRequired = flow.a;
							var qrCode = flow.b;
							var currentStep = flow.c;
							switch (currentStep.$) {
								case 0:
									return _Utils_Tuple2(
										_Utils_Tuple2(
											A2($author$project$Login$SigninV2$Model$Model, details, flow),
											$elm$core$Platform$Cmd$none),
										mainModel);
								case 1:
									return _Utils_Tuple2(
										_Utils_Tuple2(
											A2(
												$author$project$Login$SigninV2$Model$Model,
												details,
												A3(
													$author$project$Login$SigninV2$Model$MfaSetupFlow,
													isMfaSetupRequired,
													qrCode,
													$author$project$Login$MfaSetup$DownloadApp(0))),
											$elm$core$Platform$Cmd$none),
										mainModel);
								case 2:
									return _Utils_Tuple2(
										_Utils_Tuple2(
											A2(
												$author$project$Login$SigninV2$Model$Model,
												details,
												A3(
													$author$project$Login$SigninV2$Model$MfaSetupFlow,
													isMfaSetupRequired,
													qrCode,
													$author$project$Login$MfaSetup$LocateQRCode(0))),
											$elm$core$Platform$Cmd$none),
										mainModel);
								default:
									return _Utils_Tuple2(
										_Utils_Tuple2(
											A2($author$project$Login$SigninV2$Model$Model, details, flow),
											$elm$core$Platform$Cmd$none),
										mainModel);
							}
						case 2:
							return _Utils_Tuple2(
								_Utils_Tuple2(
									A2($author$project$Login$SigninV2$Model$Model, details, flow),
									$elm$core$Platform$Cmd$none),
								mainModel);
						default:
							return _Utils_Tuple2(
								_Utils_Tuple2(
									A2($author$project$Login$SigninV2$Model$Model, details, flow),
									$elm$core$Platform$Cmd$none),
								mainModel);
					}
				case 13:
					switch (flow.$) {
						case 0:
							return _Utils_Tuple2(
								_Utils_Tuple2(
									A2($author$project$Login$SigninV2$Model$Model, details, flow),
									$elm$core$Platform$Cmd$none),
								mainModel);
						case 1:
							var isMfaSetupRequired = flow.a;
							var qrCode = flow.b;
							var currentStep = flow.c;
							switch (currentStep.$) {
								case 0:
									return _Utils_Tuple2(
										_Utils_Tuple2(
											A2($author$project$Login$SigninV2$Model$Model, details, flow),
											$elm$core$Platform$Cmd$none),
										mainModel);
								case 1:
									return _Utils_Tuple2(
										_Utils_Tuple2(
											A2(
												$author$project$Login$SigninV2$Model$Model,
												details,
												A3(
													$author$project$Login$SigninV2$Model$MfaSetupFlow,
													isMfaSetupRequired,
													qrCode,
													$author$project$Login$MfaSetup$DownloadApp(1))),
											$elm$core$Platform$Cmd$none),
										mainModel);
								case 2:
									return _Utils_Tuple2(
										_Utils_Tuple2(
											A2(
												$author$project$Login$SigninV2$Model$Model,
												details,
												A3(
													$author$project$Login$SigninV2$Model$MfaSetupFlow,
													isMfaSetupRequired,
													qrCode,
													$author$project$Login$MfaSetup$LocateQRCode(1))),
											$elm$core$Platform$Cmd$none),
										mainModel);
								default:
									return _Utils_Tuple2(
										_Utils_Tuple2(
											A2($author$project$Login$SigninV2$Model$Model, details, flow),
											$elm$core$Platform$Cmd$none),
										mainModel);
							}
						case 2:
							return _Utils_Tuple2(
								_Utils_Tuple2(
									A2($author$project$Login$SigninV2$Model$Model, details, flow),
									$elm$core$Platform$Cmd$none),
								mainModel);
						default:
							return _Utils_Tuple2(
								_Utils_Tuple2(
									A2($author$project$Login$SigninV2$Model$Model, details, flow),
									$elm$core$Platform$Cmd$none),
								mainModel);
					}
				case 14:
					switch (msg.a.$) {
						case 3:
							if ((!msg.a.a.$) && (!msg.a.a.b.$)) {
								var _v31 = msg.a.a;
								var locationAfterSignin = _v31.a.zG;
								var role = _v31.b;
								return _Utils_Tuple2(
									_Utils_Tuple2(
										model,
										A3($author$project$Login$SigninV2$Update$navigateAfterSigninCmd, role, mainModel.mL, locationAfterSignin)),
									mainModel);
							} else {
								break _v0$18;
							}
						case 2:
							if (msg.a.a.$ === 3) {
								var data = msg.a;
								var status = data.a.a;
								var _v32 = details;
								var options = _v32.z8;
								switch (flow.$) {
									case 0:
										return _Utils_Tuple2(
											_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
											mainModel);
									case 1:
										return _Utils_Tuple2(
											_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
											mainModel);
									case 2:
										var tokenDetails = flow.a;
										var _v34 = _Utils_Tuple3(status, options.nu, options.xe);
										if (((_v34.a === 401) && (!_v34.b.$)) && (!_v34.c.$)) {
											var parentBrokerageId = _v34.b.a;
											var affiliateBrokerageId = _v34.c.a;
											return _Utils_Tuple2(
												_Utils_Tuple2(
													A2(
														$author$project$Login$SigninV2$Model$Model,
														details,
														$author$project$Login$SigninV2$Model$PasswordFlow(
															_Utils_update(
																tokenDetails,
																{B5: data}))),
													A2(
														$author$project$Login$Route$navigateTo,
														mainModel.mL,
														A3(
															$author$project$Login$Route$AffiliateSignup,
															parentBrokerageId,
															affiliateBrokerageId,
															{aW: options.aW, h$: options.h$}))),
												_Utils_update(
													mainModel,
													{
														yO: $elm$core$Maybe$Just('The link you clicked is expired. Please enter your details to receive a new link.')
													}));
										} else {
											return _Utils_Tuple2(
												_Utils_Tuple2(
													A2(
														$author$project$Login$SigninV2$Model$Model,
														details,
														$author$project$Login$SigninV2$Model$PasswordFlow(
															_Utils_update(
																tokenDetails,
																{B5: data}))),
													$elm$core$Platform$Cmd$none),
												mainModel);
										}
									default:
										return _Utils_Tuple2(
											_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
											mainModel);
								}
							} else {
								break _v0$18;
							}
						default:
							break _v0$18;
					}
				case 15:
					return _Utils_Tuple2(
						_Utils_Tuple2(
							model,
							A2(
								$author$project$UserTracking$trackUnknownUserEvent,
								$author$project$Login$UserTracking$Events$encodeEvent,
								$author$project$Login$UserTracking$Events$WhoIsCorvusLinkClicked(0))),
						mainModel);
				case 16:
					var redirect = msg.a;
					return _Utils_Tuple2(
						_Utils_Tuple2(
							model,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($author$project$UserTracking$trackUnknownUserEvent, $author$project$Login$UserTracking$Events$encodeEvent, $author$project$Login$UserTracking$Events$ForgotYourPasswordLinkClicked),
										A2(
										$author$project$UserTracking$LinkTracking$redirectTo,
										$author$project$Login$Route$navigateTo(mainModel.mL),
										redirect)
									]))),
						mainModel);
				case 17:
					var redirect = msg.a;
					return _Utils_Tuple2(
						_Utils_Tuple2(
							model,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($author$project$UserTracking$trackUnknownUserEvent, $author$project$Login$UserTracking$Events$encodeEvent, $author$project$Login$UserTracking$Events$SignInWithExistingAccountLinkClicked),
										A2(
										$author$project$UserTracking$LinkTracking$redirectTo,
										$author$project$Login$Route$navigateTo(mainModel.mL),
										redirect)
									]))),
						mainModel);
				case 18:
					var userInput = msg.a;
					if (flow.$ === 3) {
						var data = flow.a;
						var updatedResetPasswordData = _Utils_update(
							data,
							{
								vO: A3(
									$author$project$Model$ValidationNext$update,
									userInput,
									$author$project$Login$SigninV2$Update$confirmationValidator(
										$author$project$Model$ValidationNext$extract(data.d$)),
									data.vO)
							});
						return _Utils_Tuple2(
							_Utils_Tuple2(
								A2(
									$author$project$Login$SigninV2$Model$Model,
									details,
									$author$project$Login$SigninV2$Model$ResetPasswordFlow(updatedResetPasswordData)),
								$elm$core$Platform$Cmd$none),
							mainModel);
					} else {
						return _Utils_Tuple2(
							_Utils_Tuple2(
								A2($author$project$Login$SigninV2$Model$Model, details, flow),
								$elm$core$Platform$Cmd$none),
							mainModel);
					}
				case 20:
					var validatedModel = $author$project$Login$SigninV2$Model$validate(model);
					var validatedDetails = validatedModel.a;
					var validatedFlow = validatedModel.b;
					if (validatedFlow.$ === 3) {
						var data = validatedFlow.a;
						var updatedResetPasswordData = _Utils_update(
							data,
							{Iz: $krisajenkins$remotedata$RemoteData$Loading});
						var _v42 = _Utils_Tuple2(data.d$, data.vO);
						if ((_v42.a.$ === 1) && (_v42.b.$ === 1)) {
							var pass = _v42.a.a;
							return _Utils_Tuple2(
								_Utils_Tuple2(
									A2(
										$author$project$Login$SigninV2$Model$Model,
										validatedDetails,
										$author$project$Login$SigninV2$Model$ResetPasswordFlow(updatedResetPasswordData)),
									A4(
										$author$project$Request$Account$resetPasswordAndSignin,
										A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Login$SigninV2$Model$ResetPasswordCompleted),
										pass,
										data.IA,
										csrfToken)),
								mainModel);
						} else {
							return _Utils_Tuple2(
								_Utils_Tuple2(validatedModel, $elm$core$Platform$Cmd$none),
								mainModel);
						}
					} else {
						return _Utils_Tuple2(
							_Utils_Tuple2(
								A2($author$project$Login$SigninV2$Model$Model, details, flow),
								$elm$core$Platform$Cmd$none),
							mainModel);
					}
				case 21:
					if (msg.a.$ === 3) {
						var data = msg.a;
						if (flow.$ === 3) {
							var resetPasswordData = flow.a;
							var email = function () {
								var _v44 = resetPasswordData.aW;
								if (!_v44.$) {
									var email_ = _v44.a;
									return A2(
										$author$project$Model$ValidationNext$validate,
										$author$project$Model$Validators$validateEmail,
										$author$project$Model$ValidationNext$Unvalidated(email_));
								} else {
									return $author$project$Model$ValidationNext$Unvalidated(
										$author$project$Data$Email$initial(''));
								}
							}();
							var updatedDetails = _Utils_update(
								details,
								{aW: email, d$: resetPasswordData.d$});
							return A4(
								$author$project$Login$SigninV2$Update$handlePasswordFlowSigninRequestCompleted,
								updatedDetails,
								{B5: data},
								data,
								mainModel);
						} else {
							return _Utils_Tuple2(
								_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
								mainModel);
						}
					} else {
						var data = msg.a;
						if (flow.$ === 3) {
							var flowData = flow.a;
							var updatedFlowData = _Utils_update(
								flowData,
								{Iz: data});
							return _Utils_Tuple2(
								_Utils_Tuple2(
									A2(
										$author$project$Login$SigninV2$Model$Model,
										details,
										$author$project$Login$SigninV2$Model$ResetPasswordFlow(updatedFlowData)),
									$elm$core$Platform$Cmd$none),
								mainModel);
						} else {
							return _Utils_Tuple2(
								_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
								mainModel);
						}
					}
				case 23:
					return _Utils_Tuple2(
						_Utils_Tuple2(
							model,
							A2(
								$author$project$UserTracking$trackUnknownUserEvent,
								$author$project$Login$UserTracking$Events$encodeEvent,
								$author$project$Login$UserTracking$Events$WhoIsCorvusLinkClicked(1))),
						mainModel);
				case 22:
					return _Utils_Tuple2(
						_Utils_Tuple2(
							model,
							A2($author$project$UserTracking$trackUnknownUserEvent, $author$project$Login$UserTracking$Events$encodeEvent, $author$project$Login$UserTracking$Events$NeedHelpLinkClicked)),
						mainModel);
				case 24:
					return _Utils_Tuple2(
						_Utils_Tuple2(
							A2(
								$author$project$Login$SigninV2$Model$Model,
								_Utils_update(
									details,
									{zi: !details.zi}),
								flow),
							$elm$core$Platform$Cmd$none),
						mainModel);
				case 25:
					return _Utils_Tuple2(
						_Utils_Tuple2(
							A2(
								$author$project$Login$SigninV2$Model$Model,
								_Utils_update(
									details,
									{zg: !details.zg}),
								flow),
							$elm$core$Platform$Cmd$none),
						mainModel);
				default:
					return _Utils_Tuple2(
						_Utils_Tuple2(
							A2(
								$author$project$Login$SigninV2$Model$Model,
								_Utils_update(
									details,
									{ze: !details.ze}),
								flow),
							$elm$core$Platform$Cmd$none),
						mainModel);
			}
		}
		var data = msg.a;
		switch (flow.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					mainModel);
			case 1:
				return _Utils_Tuple2(
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					mainModel);
			case 2:
				var tokenDetails = flow.a;
				return _Utils_Tuple2(
					_Utils_Tuple2(
						A2(
							$author$project$Login$SigninV2$Model$Model,
							details,
							$author$project$Login$SigninV2$Model$PasswordFlow(
								_Utils_update(
									tokenDetails,
									{B5: data}))),
						$elm$core$Platform$Cmd$none),
					mainModel);
			default:
				return _Utils_Tuple2(
					_Utils_Tuple2(
						A2($author$project$Login$SigninV2$Model$Model, details, flow),
						$elm$core$Platform$Cmd$none),
					mainModel);
		}
	});
var $author$project$Login$SurplusLinesLicense$Model$Error = 4;
var $author$project$Login$SurplusLinesLicense$Model$Submitted = 1;
var $author$project$Login$SurplusLinesLicense$Model$Active = 0;
var $author$project$Login$SurplusLinesLicense$Model$Expired = 2;
var $author$project$Login$SurplusLinesLicense$Update$apiResultToStatus = function (results) {
	switch (results) {
		case 2:
			return 1;
		case 1:
			return 2;
		default:
			return 0;
	}
};
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$Model$ValidationNext$allValid = $elm$core$List$all(
	function (validationResult) {
		if (validationResult.$ === 1) {
			return true;
		} else {
			return false;
		}
	});
var $author$project$Login$SurplusLinesLicense$Model$AddressCityBlurred = 0;
var $author$project$Login$SurplusLinesLicense$Model$AddressLineOneBlurred = 1;
var $author$project$Login$SurplusLinesLicense$Model$AddressLineTwoBlurred = 2;
var $author$project$Login$SurplusLinesLicense$Model$AddressPostalCodeBlurred = 3;
var $author$project$Login$SurplusLinesLicense$Model$AddressStateBlurred = 4;
var $author$project$Login$SurplusLinesLicense$Model$AttestorNameBlurred = 5;
var $author$project$Login$SurplusLinesLicense$Model$EmailBlurred = 6;
var $author$project$Login$SurplusLinesLicense$Model$FeinBlurred = 7;
var $author$project$Login$SurplusLinesLicense$Model$LicenseNumberBlurred = 8;
var $author$project$Login$SurplusLinesLicense$Model$NameBlurred = 9;
var $author$project$Login$SurplusLinesLicense$Model$PhoneBlurred = 10;
var $author$project$Login$SurplusLinesLicense$Model$TransactionIdBlurred = 11;
var $author$project$Login$SurplusLinesLicense$Model$allValidationMsgs = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
var $author$project$Login$SurplusLinesLicense$Update$addressTwoValidator = A2($author$project$Model$Validators$maxLength, 'Address Line 2', 100);
var $author$project$Model$Validators$existence = F2(
	function (fieldName, string) {
		var validateExistenceFunc = function (trimmedString) {
			return (!$elm$core$String$length(trimmedString)) ? $elm$core$Result$Err(fieldName + ' cannot be blank.') : $elm$core$Result$Ok(string);
		};
		return A2($author$project$Model$Validators$validateTrimmedString, string, validateExistenceFunc);
	});
var $author$project$Model$Validators$addressValidator = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$Validators$existence('Address'),
	A2(
		$elm$core$Basics$composeR,
		$author$project$Model$Validators$andThen(
			A2($author$project$Model$Validators$minLength, 'Address', 2)),
		$author$project$Model$Validators$andThen(
			A2($author$project$Model$Validators$maxLength, 'Address', 100))));
var $author$project$Model$Validators$cityValidator = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$Validators$existence('City'),
	A2(
		$elm$core$Basics$composeR,
		$author$project$Model$Validators$andThen(
			A2($author$project$Model$Validators$minLength, 'City', 2)),
		$author$project$Model$Validators$andThen(
			A2($author$project$Model$Validators$maxLength, 'City', 100))));
var $author$project$Model$Validators$feinValidator = function (feinNumber) {
	var feinRegex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('^(\\d{2}-\\d{7}|\\d{3}-\\d{2}-\\d{4}|\\d{9})$'));
	return A2($elm$regex$Regex$contains, feinRegex, feinNumber) ? $elm$core$Result$Ok(feinNumber) : $elm$core$Result$Err('Invalid fein');
};
var $author$project$Login$SurplusLinesLicense$Update$filingAgencyValidator = A2(
	$elm$core$Basics$composeR,
	A2($author$project$Model$Validators$maxLength, 'Filing Agency', 255),
	A2(
		$elm$core$Basics$composeR,
		$author$project$Model$Validators$andThen(
			A2($author$project$Model$Validators$minLength, 'Filing Agency', 4)),
		$author$project$Model$Validators$andThen(
			$author$project$Model$Validators$existence('Filing Agency'))));
var $author$project$Model$Validators$licenseNumberValidator = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$Validators$existence('License Number'),
	A2(
		$elm$core$Basics$composeR,
		$author$project$Model$Validators$andThen(
			A2($author$project$Model$Validators$minLength, 'License Number', 2)),
		$author$project$Model$Validators$andThen(
			A2($author$project$Model$Validators$maxLength, 'License Number', 100))));
var $author$project$Model$Validators$postalCodeRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[0-9]{5}(?:-[0-9]{4})?$'));
var $author$project$Model$Validators$validatePostalCode = F2(
	function (fieldName, postalCode) {
		return A2($elm$regex$Regex$contains, $author$project$Model$Validators$postalCodeRegex, postalCode) ? $elm$core$Result$Ok(postalCode) : $elm$core$Result$Err(fieldName + ' does not look like a valid postal code');
	});
var $author$project$Model$Validators$postalCodeValidator = $author$project$Model$Validators$validatePostalCode('Zip Code');
var $author$project$Model$Validators$stateValidator = $author$project$Model$Validators$existence('State');
var $author$project$Login$SurplusLinesLicense$Update$stricterEmailValidator = function (email) {
	var value = $author$project$Data$Email$toString(email);
	var r = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$'));
	var length = $elm$core$String$length(value);
	return (A2($elm$regex$Regex$contains, r, value) && ((length > 4) && (length < 129))) ? $elm$core$Result$Ok(
		$author$project$Data$Email$initial(value)) : $elm$core$Result$Err('Invalid Email');
};
var $author$project$Login$SurplusLinesLicense$Update$transactionIdValidator = A2(
	$elm$core$Basics$composeR,
	A2($author$project$Model$Validators$maxLength, 'Transaction ID', 100),
	$author$project$Model$Validators$andThen(
		A2($author$project$Model$Validators$minLength, 'Transaction ID', 2)));
var $author$project$Data$PhoneNumber$toString = function (phoneNumber) {
	if (!phoneNumber.$) {
		var string = phoneNumber.a;
		return string;
	} else {
		var string = phoneNumber.a;
		return string;
	}
};
var $author$project$Data$PhoneNumber$isValidPhoneNumber = function (phoneNumber) {
	var string = $author$project$Data$PhoneNumber$toString(phoneNumber);
	var r = function () {
		if (phoneNumber.$ === 1) {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('^\\+\\d{12}$'));
		} else {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('^\\(\\d{3}\\) \\d{3}\\-\\d{4}$'));
		}
	}();
	return A2($elm$regex$Regex$contains, r, string);
};
var $author$project$Data$PhoneNumber$validator = function (phone) {
	return $author$project$Data$PhoneNumber$isValidPhoneNumber(phone) ? $elm$core$Result$Ok(phone) : $elm$core$Result$Err('Invalid Phone Number');
};
var $author$project$Login$SurplusLinesLicense$Update$validateFilerForm = F2(
	function (validationMsg, formInputs) {
		switch (validationMsg) {
			case 0:
				return _Utils_update(
					formInputs,
					{
						w7: A2($author$project$Model$ValidationNext$validate, $author$project$Model$Validators$cityValidator, formInputs.w7)
					});
			case 1:
				return _Utils_update(
					formInputs,
					{
						w8: A2($author$project$Model$ValidationNext$validate, $author$project$Model$Validators$addressValidator, formInputs.w8)
					});
			case 2:
				return _Utils_update(
					formInputs,
					{
						w9: A2($author$project$Model$ValidationNext$validate, $author$project$Login$SurplusLinesLicense$Update$addressTwoValidator, formInputs.w9)
					});
			case 3:
				return _Utils_update(
					formInputs,
					{
						xa: A2($author$project$Model$ValidationNext$validate, $author$project$Model$Validators$postalCodeValidator, formInputs.xa)
					});
			case 4:
				return _Utils_update(
					formInputs,
					{
						xb: A2($author$project$Model$ValidationNext$validate, $author$project$Model$Validators$stateValidator, formInputs.xb)
					});
			case 5:
				return _Utils_update(
					formInputs,
					{
						xl: A2($author$project$Model$ValidationNext$validate, $author$project$Login$SurplusLinesLicense$Update$filingAgencyValidator, formInputs.xl)
					});
			case 6:
				return _Utils_update(
					formInputs,
					{
						aW: A2($author$project$Model$ValidationNext$validate, $author$project$Login$SurplusLinesLicense$Update$stricterEmailValidator, formInputs.aW)
					});
			case 7:
				return _Utils_update(
					formInputs,
					{
						EQ: A2($author$project$Model$ValidationNext$validate, $author$project$Model$Validators$feinValidator, formInputs.EQ)
					});
			case 8:
				return _Utils_update(
					formInputs,
					{
						F9: A2($author$project$Model$ValidationNext$validate, $author$project$Model$Validators$licenseNumberValidator, formInputs.F9)
					});
			case 9:
				return _Utils_update(
					formInputs,
					{
						yK: A2($author$project$Model$ValidationNext$validate, $author$project$Login$SurplusLinesLicense$Update$filingAgencyValidator, formInputs.yK)
					});
			case 10:
				return _Utils_update(
					formInputs,
					{
						dG: A2($author$project$Model$ValidationNext$validate, $author$project$Data$PhoneNumber$validator, formInputs.dG)
					});
			default:
				return _Utils_update(
					formInputs,
					{
						J_: A2($author$project$Model$ValidationNext$validate, $author$project$Login$SurplusLinesLicense$Update$transactionIdValidator, formInputs.J_)
					});
		}
	});
var $author$project$Login$SurplusLinesLicense$Update$canSubmit = F2(
	function (needsRevalidationFormInputs, _v0) {
		var policyholderState = _v0;
		var formInputs = A3($elm$core$List$foldl, $author$project$Login$SurplusLinesLicense$Update$validateFilerForm, needsRevalidationFormInputs, $author$project$Login$SurplusLinesLicense$Model$allValidationMsgs);
		var commonFields = _List_fromArray(
			[formInputs.w7, formInputs.w8, formInputs.w9, formInputs.xa, formInputs.xb, formInputs.xl, formInputs.yK, formInputs.F9]);
		var mostFields = (policyholderState === 'New York') ? A2($elm$core$List$cons, formInputs.EQ, commonFields) : ((policyholderState === 'New Jersey') ? A2($elm$core$List$cons, formInputs.J_, commonFields) : commonFields);
		return $author$project$Model$ValidationNext$allValid(mostFields) && ($author$project$Model$ValidationNext$isValid(formInputs.bB) && ($author$project$Model$ValidationNext$isValid(formInputs.dG) && ($author$project$Model$ValidationNext$isValid(formInputs.aW) && formInputs.zd)));
	});
var $author$project$Login$SurplusLinesLicense$Model$HasErrors = 2;
var $author$project$Login$SurplusLinesLicense$Model$markHasErrors = function (formInputs) {
	return _Utils_update(
		formInputs,
		{g2: 2});
};
var $author$project$Login$SurplusLinesLicense$Model$Validated = 1;
var $author$project$Login$SurplusLinesLicense$Model$markValidated = function (formInputs) {
	return _Utils_update(
		formInputs,
		{g2: 1});
};
var $author$project$Data$Email$isValidEmail = function (email) {
	var r = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('.+@.+\\..+'));
	var length = $elm$core$String$length(email);
	return A2($elm$regex$Regex$contains, r, email) && ((length > 4) && (length < 129));
};
var $author$project$Data$Email$parse = function (_v0) {
	var string = _v0;
	return $author$project$Data$Email$isValidEmail(string) ? $elm$core$Result$Ok(string) : $elm$core$Result$Err('Invalid Email');
};
var $author$project$Data$Email$validate = function (string) {
	return $elm$core$String$isEmpty(string) ? $author$project$Model$ValidationNext$Unvalidated('') : A2(
		$author$project$Model$ValidationNext$validate,
		$author$project$Data$Email$parse,
		$author$project$Model$ValidationNext$Unvalidated(string));
};
var $author$project$Data$PhoneNumber$parse = function (phoneNumber) {
	var string = $author$project$Data$PhoneNumber$toString(phoneNumber);
	var r = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[^0-9]'));
	return $author$project$Data$PhoneNumber$isValidPhoneNumber(phoneNumber) ? $elm$core$Result$Ok(phoneNumber) : ((($elm$core$String$length(string) === 1) && A2($elm$regex$Regex$contains, r, string)) ? $elm$core$Result$Ok(
		$author$project$Data$PhoneNumber$PhoneNumberUS('')) : $elm$core$Result$Err('Invalid Phone Number'));
};
var $author$project$Data$PhoneNumber$validate = function (string) {
	var phoneNumber = $author$project$Data$PhoneNumber$initial(string);
	return $elm$core$String$isEmpty(string) ? $author$project$Model$ValidationNext$Unvalidated(phoneNumber) : A2(
		$author$project$Model$ValidationNext$validate,
		$author$project$Data$PhoneNumber$parse,
		$author$project$Model$ValidationNext$Unvalidated(phoneNumber));
};
var $author$project$Login$SurplusLinesLicense$Update$prefillFormInputs = F2(
	function (formInputs, fetchedData) {
		var unwrapString = F2(
			function (_default, maybeString) {
				return A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _default, $author$project$Model$ValidationNext$valid, maybeString);
			});
		var unwrapRequiredString = function (maybeString) {
			return A2(
				unwrapString,
				$author$project$Model$ValidationNext$Unvalidated(''),
				maybeString);
		};
		var unwrapRequiredDate = function (maybeDate) {
			if (!maybeDate.$) {
				var date = maybeDate.a;
				return $author$project$Model$ValidationNext$valid(
					$elm$core$Maybe$Just(date));
			} else {
				return $author$project$Model$ValidationNext$unvalidated($elm$core$Maybe$Nothing);
			}
		};
		var unwrapRequiredData = F3(
			function (initialFn, validateFn, maybeString) {
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$author$project$Model$ValidationNext$Unvalidated(
						initialFn('')),
					validateFn,
					maybeString);
			});
		var unwrapRequiredEmail = function (maybeString) {
			return A3(unwrapRequiredData, $author$project$Data$Email$initial, $author$project$Data$Email$validate, maybeString);
		};
		var unwrapRequiredPhoneNumber = function (maybeString) {
			return A3(unwrapRequiredData, $author$project$Data$PhoneNumber$initial, $author$project$Data$PhoneNumber$validate, maybeString);
		};
		var unwrapOptionalString = function (maybeString) {
			return A2(
				unwrapString,
				$author$project$Model$ValidationNext$Valid(''),
				maybeString);
		};
		return _Utils_update(
			formInputs,
			{
				w7: unwrapRequiredString(fetchedData.Dk),
				w8: unwrapRequiredString(fetchedData.a7),
				w9: unwrapOptionalString(fetchedData.CC),
				xa: unwrapRequiredString(fetchedData.Z),
				xb: unwrapRequiredString(fetchedData.Jg),
				aW: unwrapRequiredEmail(fetchedData.ES),
				bB: unwrapRequiredDate(fetchedData.bB),
				EQ: unwrapRequiredString(fetchedData.EQ),
				yK: unwrapRequiredString(fetchedData.EU),
				F9: unwrapRequiredString(fetchedData.F9),
				dG: unwrapRequiredPhoneNumber(fetchedData.ET)
			});
	});
var $author$project$Login$SurplusLinesLicense$Update$maybePrefillFormInputs = F2(
	function (formInputs, fetchedData) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			formInputs,
			$author$project$Login$SurplusLinesLicense$Update$prefillFormInputs(formInputs),
			fetchedData);
	});
var $author$project$Login$SurplusLinesLicense$Model$resetHasValidInputs = function (formInputs) {
	return _Utils_update(
		formInputs,
		{g2: 0});
};
var $author$project$Login$SurplusLinesLicense$Model$SubmitCompleted = function (a) {
	return {$: 4, a: a};
};
var $author$project$PublicApi$InputObject$buildSurplusLinesFilingInput = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{jN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, jO: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, jP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, jQ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, jR: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, jS: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, jT: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, jU: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, jV: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, jW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, jX: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, jY: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, jZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, j_: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, j$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {jN: optionals____.jN, jO: optionals____.jO, jP: optionals____.jP, jQ: optionals____.jQ, jR: optionals____.jR, jS: optionals____.jS, jT: optionals____.jT, jU: optionals____.jU, jV: optionals____.jV, jW: optionals____.jW, jX: optionals____.jX, jY: optionals____.jY, jZ: optionals____.jZ, j_: optionals____.j_, j$: optionals____.j$};
};
var $author$project$Model$Ids$encodePolicyIdPublic = function (_v0) {
	var policyIdRaw = _v0;
	return policyIdRaw;
};
var $author$project$Login$SurplusLinesLicense$Update$prepareExpirationDate = function (result) {
	return $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(
		$author$project$Model$ValidationNext$extract(result));
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$optional = F2(
	function (optionalValue, toValue) {
		switch (optionalValue.$) {
			case 0:
				var value = optionalValue.a;
				return $elm$core$Maybe$Just(
					toValue(value));
			case 1:
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$null);
		}
	});
var $author$project$PublicApi$InputObject$encodeSurplusLinesFilingInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'surplusAddress',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.jN, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'surplusAddressTwo',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.jO, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'surplusCity',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.jP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'surplusExpirationDate',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.jQ,
					A2(
						$author$project$PublicApi$Scalar$unwrapEncoder,
						function ($) {
							return $.e;
						},
						$author$project$PublicApiScalarCodecs$codecs))),
				_Utils_Tuple2(
				'surplusFein',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.jR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'surplusFilerEmail',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.jS, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'surplusFilerPhoneNumber',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.jT, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'surplusFilerSignature',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.jU, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'surplusFilingAgency',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.jV, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'surplusFirstName',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.jW, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'surplusLastName',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.jX, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'surplusLicenseNumber',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.jY, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'surplusPostalCode',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.jZ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'surplusState',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j_, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'surplusTransactionId',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.j$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$PublicApi$Mutation$submitPublicSurplusLinesFiling = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'Bool',
		'submitPublicSurplusLinesFiling',
		_List_fromArray(
			[
				A3(
				$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required,
				'policyId',
				requiredArgs____.n,
				A2(
					$author$project$PublicApi$Scalar$unwrapEncoder,
					function ($) {
						return $.g;
					},
					$author$project$PublicApiScalarCodecs$codecs)),
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'surplusLinesFilingInput', requiredArgs____.Jt, $author$project$PublicApi$InputObject$encodeSurplusLinesFilingInput)
			]),
		$elm$json$Json$Decode$bool);
};
var $author$project$Data$PhoneNumber$validationResultToString = function (phoneNumber) {
	return A2($author$project$Model$ValidationNext$toString, $author$project$Data$PhoneNumber$toString, phoneNumber);
};
var $author$project$Login$SurplusLinesLicense$Update$submitSurplusLinesFilingCmd = F2(
	function (policyId, formInputs) {
		var toValue = function (field) {
			return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
				A2($author$project$Model$ValidationNext$toString, $elm$core$Basics$identity, field));
		};
		var fillSurplusLinesFilingInput = function (args) {
			return _Utils_update(
				args,
				{
					jN: toValue(formInputs.w8),
					jO: toValue(formInputs.w9),
					jP: toValue(formInputs.w7),
					jQ: $author$project$Login$SurplusLinesLicense$Update$prepareExpirationDate(formInputs.bB),
					jR: toValue(formInputs.EQ),
					jS: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
						$author$project$Data$Email$validatedToString(formInputs.aW)),
					jT: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
						$author$project$Data$PhoneNumber$validationResultToString(formInputs.dG)),
					jU: toValue(formInputs.xl),
					jV: toValue(formInputs.yK),
					jY: toValue(formInputs.F9),
					jZ: toValue(formInputs.xa),
					j_: toValue(formInputs.xb),
					j$: toValue(formInputs.J_)
				});
		};
		var submitSurplusLinesFiling = $author$project$PublicApi$Mutation$submitPublicSurplusLinesFiling(
			{
				n: $author$project$Model$Ids$encodePolicyIdPublic(policyId),
				Jt: $author$project$PublicApi$InputObject$buildSurplusLinesFilingInput(fillSurplusLinesFilingInput)
			});
		return A2($author$project$ApiRequest$publicMutation, $author$project$Login$SurplusLinesLicense$Model$SubmitCompleted, submitSurplusLinesFiling);
	});
var $author$project$Model$ValidationNext$invalid = $author$project$Model$ValidationNext$Invalid;
var $author$project$CorvusDatePicker$FailedInput = function (a) {
	return {$: 2, a: a};
};
var $author$project$CorvusDatePicker$None = {$: 1};
var $author$project$CorvusDatePicker$Picked = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $CurrySoftware$elm_datepicker$DatePicker$formatCell = function (day) {
	return $elm$html$Html$text(day);
};
var $CurrySoftware$elm_datepicker$DatePicker$Date$formatDay = function (day) {
	switch (day) {
		case 0:
			return 'Mo';
		case 1:
			return 'Tu';
		case 2:
			return 'We';
		case 3:
			return 'Th';
		case 4:
			return 'Fr';
		case 5:
			return 'Sa';
		default:
			return 'Su';
	}
};
var $CurrySoftware$elm_datepicker$DatePicker$Date$formatMonth = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $CurrySoftware$elm_datepicker$DatePicker$Date$Off = {$: 0};
var $CurrySoftware$elm_datepicker$DatePicker$off = $CurrySoftware$elm_datepicker$DatePicker$Date$Off;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$required = $elm$html$Html$Attributes$boolProperty('required');
var $CurrySoftware$elm_datepicker$DatePicker$defaultSettings = {
	rO: $CurrySoftware$elm_datepicker$DatePicker$formatCell,
	lp: $CurrySoftware$elm_datepicker$DatePicker$off,
	fm: 'elm-datepicker--',
	rW: _List_Nil,
	D9: $justinmimbs$date$Date$format('yyyy-MM-dd'),
	r7: $CurrySoftware$elm_datepicker$DatePicker$Date$formatDay,
	pW: 6,
	FA: _List_fromArray(
		[
			$elm$html$Html$Attributes$required(false)
		]),
	s_: _List_Nil,
	FE: $elm$core$Maybe$Nothing,
	FF: $elm$core$Maybe$Nothing,
	zh: $elm$core$Basics$always(false),
	tq: $CurrySoftware$elm_datepicker$DatePicker$Date$formatMonth,
	Ht: $justinmimbs$date$Date$fromIsoString,
	An: 'Please pick a date...',
	w1: $elm$core$String$fromInt
};
var $author$project$View$Util$formatDateInput = function (dateInput) {
	var _v0 = A2($elm$core$String$split, '/', dateInput);
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
		var month = _v0.a;
		var _v1 = _v0.b;
		var day = _v1.a;
		var _v2 = _v1.b;
		var year = _v2.a;
		return A2(
			$elm$core$String$join,
			'-',
			_List_fromArray(
				[year, month, day]));
	} else {
		return dateInput;
	}
};
var $author$project$View$Util$datePickerSettings = _Utils_update(
	$CurrySoftware$elm_datepicker$DatePicker$defaultSettings,
	{
		D9: $justinmimbs$date$Date$format('MM/dd/yyyy'),
		Ht: A2($elm$core$Basics$composeR, $author$project$View$Util$formatDateInput, $justinmimbs$date$Date$fromIsoString)
	});
var $CurrySoftware$elm_datepicker$DatePicker$Disabled = function (a) {
	return {$: 2, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$EmptyString = {$: 1};
var $CurrySoftware$elm_datepicker$DatePicker$FailedInput = function (a) {
	return {$: 1, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$Invalid = function (a) {
	return {$: 0, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$None = {$: 0};
var $CurrySoftware$elm_datepicker$DatePicker$Picked = function (a) {
	return {$: 2, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$update = F3(
	function (settings, msg, _v0) {
		var model = _v0;
		var forceOpen = model.dV;
		var focused = model.bE;
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bE: $elm$core$Maybe$Just(date),
							d3: date
						}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 1:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bE: $elm$core$Maybe$Just(date)
						}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 2:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bE: $elm$core$Maybe$Nothing, df: $elm$core$Maybe$Nothing, dD: false}),
					$CurrySoftware$elm_datepicker$DatePicker$Picked(date));
			case 3:
				var text = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							df: $elm$core$Maybe$Just(text)
						}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 4:
				if (forceOpen) {
					return _Utils_Tuple2(model, $CurrySoftware$elm_datepicker$DatePicker$None);
				} else {
					var dateEvent = function () {
						var _v5 = model.df;
						if (_v5.$ === 1) {
							return $CurrySoftware$elm_datepicker$DatePicker$FailedInput($CurrySoftware$elm_datepicker$DatePicker$EmptyString);
						} else {
							if (_v5.a === '') {
								return $CurrySoftware$elm_datepicker$DatePicker$FailedInput($CurrySoftware$elm_datepicker$DatePicker$EmptyString);
							} else {
								var rawInput = _v5.a;
								var _v6 = settings.Ht(rawInput);
								if (!_v6.$) {
									var date = _v6.a;
									return settings.zh(date) ? $CurrySoftware$elm_datepicker$DatePicker$FailedInput(
										$CurrySoftware$elm_datepicker$DatePicker$Disabled(date)) : $CurrySoftware$elm_datepicker$DatePicker$Picked(date);
								} else {
									var e = _v6.a;
									return $CurrySoftware$elm_datepicker$DatePicker$FailedInput(
										$CurrySoftware$elm_datepicker$DatePicker$Invalid(e));
								}
							}
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bE: function () {
									if (dateEvent.$ === 2) {
										var date = dateEvent.a;
										return $elm$core$Maybe$Just(date);
									} else {
										return model.bE;
									}
								}(),
								df: function () {
									if (dateEvent.$ === 2) {
										return $elm$core$Maybe$Nothing;
									} else {
										return model.df;
									}
								}()
							}),
						dateEvent);
				}
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dV: false, dD: true}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dD: forceOpen}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dV: true}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dV: false}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
		}
	});
var $author$project$CorvusDatePicker$update = F2(
	function (dateMsg, _v0) {
		var picker = _v0.a;
		var inputError = _v0.b;
		var _v1 = A3($CurrySoftware$elm_datepicker$DatePicker$update, $author$project$View$Util$datePickerSettings, dateMsg, picker);
		var datePicker = _v1.a;
		var msg = _v1.b;
		var _v2 = function () {
			switch (msg.$) {
				case 0:
					return _Utils_Tuple2(inputError, $author$project$CorvusDatePicker$None);
				case 1:
					var error = msg.a;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(error),
						$author$project$CorvusDatePicker$FailedInput(error));
				default:
					var date = msg.a;
					return _Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						$author$project$CorvusDatePicker$Picked(date));
			}
		}();
		var updatedError = _v2.a;
		var updatedMsg = _v2.b;
		return _Utils_Tuple2(
			A2($author$project$CorvusDatePicker$CorvusDatePicker, datePicker, updatedError),
			updatedMsg);
	});
var $author$project$Login$SurplusLinesLicense$Update$delegateToDatePicker = F2(
	function (pickerMsg, formInputs) {
		var _v0 = formInputs;
		var expirationDatePicker = _v0.yG;
		var _v1 = A2($author$project$CorvusDatePicker$update, pickerMsg, expirationDatePicker);
		var newDatePicker = _v1.a;
		var dateEvent = _v1.b;
		var _v2 = function () {
			switch (dateEvent.$) {
				case 0:
					var day = dateEvent.a;
					return _Utils_Tuple2(
						newDatePicker,
						$author$project$Model$ValidationNext$valid(
							$elm$core$Maybe$Just(day)));
				case 1:
					return _Utils_Tuple2(newDatePicker, formInputs.bB);
				default:
					return _Utils_Tuple2(
						newDatePicker,
						A2($author$project$Model$ValidationNext$invalid, 'Valid expiration must be provided', $elm$core$Maybe$Nothing));
			}
		}();
		var updatedPicker = _v2.a;
		var maybeDay = _v2.b;
		return _Utils_update(
			formInputs,
			{bB: maybeDay, yG: updatedPicker});
	});
var $author$project$Data$PhoneNumber$update = F2(
	function (input, result) {
		return A3(
			$author$project$Model$ValidationNext$update,
			$author$project$Data$PhoneNumber$initial(input),
			$author$project$Data$PhoneNumber$parse,
			result);
	});
var $author$project$Login$SurplusLinesLicense$Update$updateFilerForm = F2(
	function (fieldMsg, formInputs) {
		switch (fieldMsg.$) {
			case 0:
				return _Utils_update(
					formInputs,
					{zd: !formInputs.zd});
			case 1:
				var name = fieldMsg.a;
				return _Utils_update(
					formInputs,
					{
						xl: A3($author$project$Model$ValidationNext$update, name, $author$project$Login$SurplusLinesLicense$Update$filingAgencyValidator, formInputs.yK)
					});
			case 2:
				var city = fieldMsg.a;
				return _Utils_update(
					formInputs,
					{
						w7: A3($author$project$Model$ValidationNext$update, city, $author$project$Model$Validators$cityValidator, formInputs.w7)
					});
			case 3:
				var addressLineOne = fieldMsg.a;
				return _Utils_update(
					formInputs,
					{
						w8: A3($author$project$Model$ValidationNext$update, addressLineOne, $author$project$Model$Validators$addressValidator, formInputs.w8)
					});
			case 4:
				var addressLineTwo = fieldMsg.a;
				return _Utils_update(
					formInputs,
					{
						w9: A3($author$project$Model$ValidationNext$update, addressLineTwo, $author$project$Login$SurplusLinesLicense$Update$addressTwoValidator, formInputs.w8)
					});
			case 5:
				var postalCode = fieldMsg.a;
				return _Utils_update(
					formInputs,
					{
						xa: A3($author$project$Model$ValidationNext$update, postalCode, $author$project$Model$Validators$postalCodeValidator, formInputs.xa)
					});
			case 6:
				var state = fieldMsg.a;
				return _Utils_update(
					formInputs,
					{
						xb: A3($author$project$Model$ValidationNext$update, state, $author$project$Model$Validators$stateValidator, formInputs.xb)
					});
			case 7:
				var email = fieldMsg.a;
				return _Utils_update(
					formInputs,
					{
						aW: A3(
							$author$project$Model$ValidationNext$update,
							$author$project$Data$Email$initial(email),
							$author$project$Login$SurplusLinesLicense$Update$stricterEmailValidator,
							formInputs.aW)
					});
			case 8:
				var fein = fieldMsg.a;
				return _Utils_update(
					formInputs,
					{
						EQ: A3($author$project$Model$ValidationNext$update, fein, $author$project$Model$Validators$feinValidator, formInputs.EQ)
					});
			case 9:
				var licenseNumber = fieldMsg.a;
				return _Utils_update(
					formInputs,
					{
						F9: A3($author$project$Model$ValidationNext$update, licenseNumber, $author$project$Model$Validators$licenseNumberValidator, formInputs.F9)
					});
			case 10:
				var name = fieldMsg.a;
				return _Utils_update(
					formInputs,
					{
						yK: A3($author$project$Model$ValidationNext$update, name, $author$project$Login$SurplusLinesLicense$Update$filingAgencyValidator, formInputs.yK)
					});
			case 11:
				var phone = fieldMsg.a;
				return _Utils_update(
					formInputs,
					{
						dG: A2($author$project$Data$PhoneNumber$update, phone, formInputs.dG)
					});
			case 12:
				var pickerMsg = fieldMsg.a;
				return A2($author$project$Login$SurplusLinesLicense$Update$delegateToDatePicker, pickerMsg, formInputs);
			default:
				var transactionId = fieldMsg.a;
				return _Utils_update(
					formInputs,
					{
						J_: A3($author$project$Model$ValidationNext$update, transactionId, $author$project$Login$SurplusLinesLicense$Update$transactionIdValidator, formInputs.J_)
					});
		}
	});
var $author$project$Login$SurplusLinesLicense$Update$update = F2(
	function (msg, model) {
		var policyId = model.a;
		var policyholderState = model.b;
		var formInputs = model.c;
		var status = model.d;
		var isTravelersRequestUrl = model.e;
		switch (msg.$) {
			case 2:
				switch (msg.a.$) {
					case 3:
						var result = msg.a.a;
						return _Utils_Tuple2(
							A5(
								$author$project$Login$SurplusLinesLicense$Model$Model,
								policyId,
								result.HC,
								A2($author$project$Login$SurplusLinesLicense$Update$maybePrefillFormInputs, formInputs, result.Ju),
								$author$project$Login$SurplusLinesLicense$Update$apiResultToStatus(result.BS),
								isTravelersRequestUrl),
							$elm$core$Platform$Cmd$none);
					case 2:
						return _Utils_Tuple2(
							A5($author$project$Login$SurplusLinesLicense$Model$Model, policyId, policyholderState, formInputs, 4, isTravelersRequestUrl),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 0:
				var fieldMsg = msg.a;
				return _Utils_Tuple2(
					A5(
						$author$project$Login$SurplusLinesLicense$Model$Model,
						policyId,
						policyholderState,
						A2($author$project$Login$SurplusLinesLicense$Update$updateFilerForm, fieldMsg, formInputs),
						status,
						isTravelersRequestUrl),
					$elm$core$Platform$Cmd$none);
			case 1:
				var validationMsg = msg.a;
				var updatedFormInputs = $author$project$Login$SurplusLinesLicense$Model$resetHasValidInputs(
					A2($author$project$Login$SurplusLinesLicense$Update$validateFilerForm, validationMsg, formInputs));
				return _Utils_Tuple2(
					A5($author$project$Login$SurplusLinesLicense$Model$Model, policyId, policyholderState, updatedFormInputs, status, isTravelersRequestUrl),
					$elm$core$Platform$Cmd$none);
			case 3:
				return A2($author$project$Login$SurplusLinesLicense$Update$canSubmit, formInputs, policyholderState) ? _Utils_Tuple2(
					A5(
						$author$project$Login$SurplusLinesLicense$Model$Model,
						policyId,
						policyholderState,
						$author$project$Login$SurplusLinesLicense$Model$markValidated(formInputs),
						status,
						isTravelersRequestUrl),
					A2($author$project$Login$SurplusLinesLicense$Update$submitSurplusLinesFilingCmd, policyId, formInputs)) : _Utils_Tuple2(
					A5(
						$author$project$Login$SurplusLinesLicense$Model$Model,
						policyId,
						policyholderState,
						$author$project$Login$SurplusLinesLicense$Model$markHasErrors(formInputs),
						status,
						isTravelersRequestUrl),
					$elm$core$Platform$Cmd$none);
			default:
				if (msg.a.$ === 3) {
					return _Utils_Tuple2(
						A5($author$project$Login$SurplusLinesLicense$Model$Model, policyId, policyholderState, formInputs, 1, isTravelersRequestUrl),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Login$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = model.Ac;
				if (!_v1.$) {
					var subModel = _v1.a;
					return A2(
						$author$project$Login$Update$mapCmd,
						$author$project$Login$Model$AccountSetupMsg,
						A3(
							$author$project$Login$Update$setPage,
							model,
							$author$project$Login$Page$AccountSetup,
							A4($author$project$Login$AccountSetup$update, subMsg, model.mL, model.x6, subModel)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 1:
				var subMsg = msg.a;
				var _v2 = model.Ac;
				if (_v2.$ === 1) {
					var parentBrokerageId = _v2.a;
					var affiliateBrokerageId = _v2.b;
					var subModel = _v2.c;
					var _v3 = A6($author$project$Login$AffiliateSignup$Update$update, subMsg, parentBrokerageId, affiliateBrokerageId, model.x6, model, subModel);
					var sub = _v3.a;
					var mainModel = _v3.b;
					return A2(
						$author$project$Login$Update$mapCmd,
						$author$project$Login$Model$AffiliateSignupMsg,
						A3(
							$author$project$Login$Update$setPage,
							mainModel,
							A2($author$project$Login$Page$AffiliateSignup, parentBrokerageId, affiliateBrokerageId),
							sub));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 2:
				var subMsg = msg.a;
				var _v4 = model.Ac;
				if (_v4.$ === 2) {
					var subModel = _v4.a;
					return A2(
						$author$project$Login$Update$mapCmd,
						$author$project$Login$Model$AlertSubscriberNewMsg,
						A3(
							$author$project$Login$Update$setPage,
							model,
							$author$project$Login$Page$AlertSubscriberNew,
							A2($author$project$Login$AlertSubscriberNew$Update$update, subMsg, subModel)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 3:
				var subMsg = msg.a;
				var _v5 = model.Ac;
				if (_v5.$ === 3) {
					var subModel = _v5.a;
					return A2(
						$author$project$Login$Update$mapCmd,
						$author$project$Login$Model$AlertSubscriberUnsubscribeMsg,
						A3(
							$author$project$Login$Update$setPage,
							model,
							$author$project$Login$Page$AlertSubscriberUnsubscribe,
							A2($author$project$Login$AlertSubscriberUnsubscribe$Update$update, subMsg, subModel)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 4:
				var subMsg = msg.a;
				var _v6 = model.Ac;
				if (_v6.$ === 4) {
					var subModel = _v6.a;
					return A2(
						$author$project$Login$Update$mapCmd,
						$author$project$Login$Model$ConfirmBindFormMsg,
						A3(
							$author$project$Login$Update$setPage,
							model,
							$author$project$Login$Page$ConfirmBindForm,
							A2($author$project$Login$ConfirmBindForm$update, subMsg, subModel)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 5:
				var subMsg = msg.a;
				var _v7 = model.Ac;
				if (_v7.$ === 5) {
					var subModel = _v7.a;
					return A2(
						$author$project$Login$Update$mapCmd,
						$author$project$Login$Model$ForgotPasswordMsg,
						A3(
							$author$project$Login$Update$setPage,
							model,
							$author$project$Login$Page$ForgotPassword,
							A4($author$project$Login$ForgotPassword$Update$update, subMsg, model.mL, model.x6, subModel)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 6:
				var localTimeZone = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Gg: localTimeZone}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var url = msg.a;
				var scrollCmd = function () {
					var _v8 = url.E3;
					if (_v8.$ === 1) {
						return $elm$core$Platform$Cmd$none;
					} else {
						var fragment = _v8.a;
						return $author$project$Ports$scrollToId(
							{Fm: fragment, G4: 0});
					}
				}();
				var route = $author$project$Login$Route$fromLocation(url);
				return A3(
					$author$project$Login$Update$setRouteWithTracking,
					route,
					scrollCmd,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			case 8:
				var request = msg.a;
				if (!request.$) {
					var url = request.a;
					var model_ = _Utils_update(
						model,
						{l: '', Il: $elm$core$Maybe$Nothing});
					return _Utils_Tuple2(
						model_,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$elm$browser$Browser$Navigation$pushUrl,
									model.mL,
									$elm$url$Url$toString(url)),
									$author$project$Ports$scrollToTop(0)
								])));
				} else {
					var href = request.a;
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(href));
				}
			case 9:
				var subMsg = msg.a;
				var _v10 = model.Ac;
				if (_v10.$ === 6) {
					var subModel = _v10.a;
					return A2(
						$author$project$Login$Update$mapCmd,
						$author$project$Login$Model$RansomwareMsg,
						A3(
							$author$project$Login$Update$setPage,
							model,
							$author$project$Login$Page$Ransomware,
							A2($author$project$Login$Ransomware$Update$update, subMsg, subModel)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 10:
				var subMsg = msg.a;
				var _v11 = model.Ac;
				if (_v11.$ === 7) {
					var form = _v11.a;
					var _v12 = A3($author$project$Login$SigninV2$Update$update, subMsg, model, form);
					var sub = _v12.a;
					var mainModel = _v12.b;
					return A2(
						$author$project$Login$Update$mapCmd,
						$author$project$Login$Model$SigninMsg,
						A3($author$project$Login$Update$setPage, mainModel, $author$project$Login$Page$Signin, sub));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				var subMsg = msg.a;
				var _v13 = model.Ac;
				if (_v13.$ === 8) {
					var subModel = _v13.a;
					return A2(
						$author$project$Login$Update$mapCmd,
						$author$project$Login$Model$SurplusLinesLicenseMsg,
						A3(
							$author$project$Login$Update$setPage,
							model,
							$author$project$Login$Page$SurplusLinesLicense,
							A2($author$project$Login$SurplusLinesLicense$Update$update, subMsg, subModel)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $elm$browser$Browser$Document = F2(
	function (title, body) {
		return {k8: body, q6: title};
	});
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $author$project$Translate$doNotTranslate = $elm$core$Basics$identity;
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $author$project$Translate$Html$Attributes$alt = A2($elm$core$Basics$composeR, $author$project$Translate$extract, $elm$html$Html$Attributes$alt);
var $author$project$View$Nav$corvusTravelersSmallWhiteWithRedUmbrellaRGB = 'https://cdn.corvusinsurance.com/images/CORVUS-Travelers-SML-REV-RGB-8033e93133252c83d8a207589e94fd0f.svg';
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$View$Nav$logoPreferredWhiteCorvusByTravelers = A2(
	$elm$html$Html$img,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$src($author$project$View$Nav$corvusTravelersSmallWhiteWithRedUmbrellaRGB),
			$author$project$Translate$Html$Attributes$alt(
			$author$project$Translate$gettext('Corvus by Travelers logo'))
		]),
	_List_Nil);
var $author$project$Translate$Html$text = A2($elm$core$Basics$composeR, $author$project$Translate$extract, $elm$html$Html$text);
var $author$project$View$Nav$logoWhiteCorvusByTravelers = F2(
	function (attrs, environment) {
		var environmentLabelClasses = $elm$html$Html$Attributes$class('tw-uppercase tw-text-4xl tw-w-full tw-text-center tw-text-white');
		var environmentLabelDiv = function (label) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[environmentLabelClasses]),
				_List_fromArray(
					[
						$author$project$Translate$Html$text(label)
					]));
		};
		var environmentNodes = function () {
			switch (environment.$) {
				case 0:
					return _List_fromArray(
						[
							environmentLabelDiv(
							$author$project$Translate$doNotTranslate('Local Dev'))
						]);
				case 2:
					return _List_fromArray(
						[
							environmentLabelDiv(
							$author$project$Translate$doNotTranslate('Staging'))
						]);
				default:
					return _List_Nil;
			}
		}();
		return A2(
			$elm$html$Html$div,
			attrs,
			A2($elm$core$List$cons, $author$project$View$Nav$logoPreferredWhiteCorvusByTravelers, environmentNodes));
	});
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $author$project$Login$View$maybeOldBrowserMessage = function (browserVersion) {
	var oldBrowserMessage = function (_v2) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('oldBrowser')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('This site does not support Internet Explorer 10 or below. '),
					$elm$html$Html$text('We encourage you to '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('//bestvpn.org/outdatedbrowser')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('upgrade your browser')
						])),
					$elm$html$Html$text('. ')
				]));
	};
	if (browserVersion.$ === 5) {
		var ieVersion = browserVersion.a;
		if (!ieVersion) {
			return $elm$core$Maybe$Just(
				oldBrowserMessage(ieVersion));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $fapian$elm_html_aria$Html$Attributes$Aria$role = $elm$html$Html$Attributes$attribute('role');
var $elm_community$maybe_extra$Maybe$Extra$toList = function (m) {
	if (m.$ === 1) {
		return _List_Nil;
	} else {
		var x = m.a;
		return _List_fromArray(
			[x]);
	}
};
var $author$project$Login$View$affiliateLayout = F2(
	function (model, content) {
		var _v0 = _Utils_Tuple2(
			$elm$html$Html$Attributes$class('branded branded-new branded-cbt affiliate'),
			A2(
				$author$project$View$Nav$logoWhiteCorvusByTravelers,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('branded-footer-logo')
					]),
				model.EF));
		var mainClasses = _v0.a;
		var logo = _v0.b;
		var footer = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('branded__footer')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Powered by'),
					logo
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('main'),
					$fapian$elm_html_aria$Html$Attributes$Aria$role('main'),
					mainClasses
				]),
			_Utils_ap(
				$elm_community$maybe_extra$Maybe$Extra$toList(
					$author$project$Login$View$maybeOldBrowserMessage(model.xB)),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[content, footer]))
					])));
	});
var $elm$html$Html$span = _VirtualDom_node('span');
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$View$Util$footerElements = _List_fromArray(
	[
		A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('anchor'),
				$elm$html$Html$Attributes$href('mailto:info@corvusinsurance.com')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('info@corvusinsurance.com')
			])),
		A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('spacer')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(' | ')
			])),
		A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$target('_blank'),
				$elm$html$Html$Attributes$class('anchor'),
				$elm$html$Html$Attributes$href('https://www.corvusinsurance.com/terms-and-conditions')
			]),
		_List_fromArray(
			[
				$author$project$Translate$Html$text(
				$author$project$Translate$gettext('Terms and Conditions'))
			])),
		A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('spacer')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(' | ')
			])),
		A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$target('_blank'),
				$elm$html$Html$Attributes$class('anchor'),
				$elm$html$Html$Attributes$href('https://www.corvusinsurance.com/privacy-policy')
			]),
		_List_fromArray(
			[
				$author$project$Translate$Html$text(
				$author$project$Translate$gettext('Privacy Policy'))
			]))
	]);
var $author$project$View$Util$travelerFooterElements = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('footer-trv')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('links')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('anchor'),
								$elm$html$Html$Attributes$target('_blank'),
								$elm$html$Html$Attributes$href('https://www.travelers.com/about-travelers/legal')
							]),
						_List_fromArray(
							[
								$author$project$Translate$Html$text(
								$author$project$Translate$gettext('Terms of Service'))
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$target('_blank'),
								$elm$html$Html$Attributes$class('anchor'),
								$elm$html$Html$Attributes$href('https://www.travelers.com/about-travelers/privacy-statements')
							]),
						_List_fromArray(
							[
								$author$project$Translate$Html$text(
								$author$project$Translate$gettext('Privacy & Security'))
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$target('_blank'),
								$elm$html$Html$Attributes$class('anchor'),
								$elm$html$Html$Attributes$href('https://www.travelers.com/about-travelers/accessibility')
							]),
						_List_fromArray(
							[
								$author$project$Translate$Html$text(
								$author$project$Translate$gettext('Accessibility'))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('copyright')
					]),
				_List_fromArray(
					[
						$author$project$Translate$Html$text(
						$author$project$Translate$gettext('© 2025 The Travelers Indemnity Company. All rights reserved.'))
					]))
			]))
	]);
var $author$project$View$Util$brandedFooter = function (isTravelers) {
	return isTravelers ? $author$project$View$Util$travelerFooterElements : $author$project$View$Util$footerElements;
};
var $author$project$Login$View$basicLayout = F2(
	function (model, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('main'),
					$fapian$elm_html_aria$Html$Attributes$Aria$role('main'),
					$elm$html$Html$Attributes$class('layout')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content')
						]),
					_Utils_ap(
						$elm_community$maybe_extra$Maybe$Extra$toList(
							$author$project$Login$View$maybeOldBrowserMessage(model.xB)),
						_List_fromArray(
							[content]))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('footer')
						]),
					$author$project$View$Util$brandedFooter(model.zm))
				]));
	});
var $elm$html$Html$main_ = _VirtualDom_node('main');
var $author$project$Login$View$fixedHeightBasicLayout = F2(
	function (model, content) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('main'),
					$elm$html$Html$Attributes$class('fixed-height-layout')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content')
						]),
					_Utils_ap(
						$elm_community$maybe_extra$Maybe$Extra$toList(
							$author$project$Login$View$maybeOldBrowserMessage(model.xB)),
						_List_fromArray(
							[content]))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('footer')
						]),
					$author$project$View$Util$brandedFooter(model.zm))
				]));
	});
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$View$Svg$appendHash = F2(
	function (hashValue, path) {
		return path + ('#' + hashValue);
	});
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $author$project$Translate$Svg$Attributes$href = $elm$virtual_dom$VirtualDom$attribute('href');
var $elm$svg$Svg$Attributes$xlinkHref = function (value) {
	return A3(
		_VirtualDom_attributeNS,
		'http://www.w3.org/1999/xlink',
		'xlink:href',
		_VirtualDom_noJavaScriptUri(value));
};
var $author$project$View$Svg$href = function (value) {
	return _List_fromArray(
		[
			$elm$svg$Svg$Attributes$xlinkHref(value),
			$author$project$Translate$Svg$Attributes$href(value)
		]);
};
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$use = $elm$svg$Svg$trustedNode('use');
var $author$project$View$Svg$icon = F2(
	function (name, classes) {
		var hrefValue = A2($author$project$View$Svg$appendHash, name, 'https://cdn.corvusinsurance.com/images/icon-sprite-93837e3668b16509af70d8059d6e5c51.svg');
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class(classes + (' icon icon-' + name))
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$use,
					$author$project$View$Svg$href(hrefValue),
					_List_Nil)
				]));
	});
var $author$project$View$Svg$accountCircle = $author$project$View$Svg$icon('account-circle');
var $author$project$Login$Route$defaultSigninRoute = $author$project$Login$Route$Signin(
	A6($author$project$Login$Route$SigninRouteOptions, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
var $elm$html$Html$header = _VirtualDom_node('header');
var $fapian$elm_html_aria$Html$Attributes$Aria$boolAttribute = F2(
	function (name, val) {
		return A2(
			$elm$html$Html$Attributes$attribute,
			name,
			A2(
				$elm$json$Json$Encode$encode,
				0,
				$elm$json$Json$Encode$bool(val)));
	});
var $fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden = $fapian$elm_html_aria$Html$Attributes$Aria$boolAttribute('aria-hidden');
var $author$project$View$Nav$logoEnvironmentHelper = function (environment) {
	var environmentLabelClasses = $elm$html$Html$Attributes$class('tw-uppercase tw-text-xl tw-w-full tw-text-center tw-text-gray-800');
	var environmentLabelDiv = function (label) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[environmentLabelClasses]),
			_List_fromArray(
				[
					$author$project$Translate$Html$text(label)
				]));
	};
	switch (environment.$) {
		case 2:
			return _List_fromArray(
				[
					environmentLabelDiv(
					$author$project$Translate$doNotTranslate('Staging'))
				]);
		case 0:
			return _List_fromArray(
				[
					environmentLabelDiv(
					$author$project$Translate$doNotTranslate('Development'))
				]);
		default:
			return _List_Nil;
	}
};
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $author$project$View$Nav$linkedLogoWhiteCorvusByTravelers = F2(
	function (environment, attrs) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('tw-w-fit tw-mx-auto'),
				attrs),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true),
							$elm$html$Html$Attributes$class('tw-inline-flex [&_>_img]:!tw-w-40 [&_>_div]:!tw-text-white'),
							$elm$html$Html$Attributes$href('/'),
							$elm$html$Html$Attributes$tabindex(-1)
						]),
					A2(
						$elm$core$List$cons,
						$author$project$View$Nav$logoPreferredWhiteCorvusByTravelers,
						$author$project$View$Nav$logoEnvironmentHelper(environment)))
				]));
	});
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Login$View$nonAuthRansomwareLayout = F2(
	function (model, content) {
		var logo = A2(
			$author$project$View$Nav$linkedLogoWhiteCorvusByTravelers,
			model.EF,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tw-mb-5')
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('main'),
					$fapian$elm_html_aria$Html$Attributes$Aria$role('main'),
					$elm$html$Html$Attributes$class('layout')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$header,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('header')
						]),
					_List_fromArray(
						[
							logo,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('container container--broker')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$nav,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('header--nav')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$ul,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('global-nav')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$href(
															$author$project$Login$Route$toUrl($author$project$Login$Route$defaultSigninRoute)),
															$elm$html$Html$Attributes$class('global-nav__link')
														]),
													_List_fromArray(
														[
															$author$project$View$Svg$accountCircle('global-nav__icon'),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('flex global-nav__link-text')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Sign In')
																]))
														]))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container container--broker content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$main_,
							_List_Nil,
							_List_fromArray(
								[content])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('footer')
								]),
							$author$project$View$Util$brandedFooter(model.zm))
						]))
				]));
	});
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $author$project$View$Nav$logoTravelers = A2(
	$elm$html$Html$img,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$src('https://cdn.corvusinsurance.com/images/trv-logo-2color-large-ba35a72d2b4c0694c2655aaa8caf67fc.svg'),
			$author$project$Translate$Html$Attributes$alt(
			$author$project$Translate$gettext('Travelers logo'))
		]),
	_List_Nil);
var $author$project$View$Nav$linkedLogoTravelers = function (environment) {
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true),
				$elm$html$Html$Attributes$class('header__logo !tw-flex'),
				$elm$html$Html$Attributes$href('/'),
				$elm$html$Html$Attributes$tabindex(-1)
			]),
		A2(
			$elm$core$List$cons,
			$author$project$View$Nav$logoTravelers,
			$author$project$View$Nav$logoEnvironmentHelper(environment)));
};
var $author$project$Login$View$signinLayout = F2(
	function (model, content) {
		var mainClasses = model.zm ? $elm$html$Html$Attributes$class('branded branded-trv') : $elm$html$Html$Attributes$class('branded branded-new branded-cbt');
		var logo = model.zm ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('branded-logo')
				]),
			_List_fromArray(
				[
					$author$project$View$Nav$linkedLogoTravelers(model.EF)
				])) : A2(
			$author$project$View$Nav$logoWhiteCorvusByTravelers,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('branded-logo')
				]),
			model.EF);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('main'),
					$fapian$elm_html_aria$Html$Attributes$Aria$role('main'),
					mainClasses
				]),
			_List_fromArray(
				[
					logo,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content')
						]),
					_Utils_ap(
						$elm_community$maybe_extra$Maybe$Extra$toList(
							$author$project$Login$View$maybeOldBrowserMessage(model.xB)),
						_List_fromArray(
							[content]))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('footer', true),
									_Utils_Tuple2('footer--dark', !model.zm)
								]))
						]),
					$author$project$View$Util$brandedFooter(model.zm))
				]));
	});
var $author$project$Login$AccountSetup$CreateAccount = {$: 1};
var $author$project$Login$AccountSetup$EmailUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Login$AccountSetup$TrackSignInWithExistingAccountLinkClicked = function (a) {
	return {$: 5, a: a};
};
var $elm$html$Html$Attributes$autofocus = $elm$html$Html$Attributes$boolProperty('autofocus');
var $author$project$View$Util$displayIf = F2(
	function (shouldDisplay, htmlFunc) {
		return shouldDisplay ? htmlFunc(0) : $elm$html$Html$text('');
	});
var $author$project$Translate$Html$Attributes$autocomplete = $elm$html$Html$Attributes$attribute('autocomplete');
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$View$Branded$emailInput = F2(
	function (attrs, warning) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('branded__form-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('email-input'),
							$elm$html$Html$Attributes$class('branded__label')
						]),
					_List_fromArray(
						[
							$author$project$Translate$Html$text(
							$author$project$Translate$gettext('Email Address'))
						])),
					A2(
					$elm$html$Html$input,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$id('email-input'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$type_('email'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$name('username'),
								A2(
									$elm$core$List$cons,
									$author$project$Translate$Html$Attributes$autocomplete('username'),
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$required(true),
										A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$class('branded__input'),
											attrs)))))),
					_List_Nil),
					warning
				]));
	});
var $elm$html$Html$form = _VirtualDom_node('form');
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $author$project$Login$AccountSetup$TrackNeedHelpLinkClicked = {$: 4};
var $author$project$Login$AccountSetup$TrackWhoIsCorvusLinkClickedAccountSetup = {$: 3};
var $author$project$View$CustomerSuccess$emailAddress = 'cyberservices@travelers.com';
var $elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var $author$project$View$Util$externalNewTabLink = F2(
	function (attrs, html) {
		return A2(
			$elm$html$Html$a,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$target('_blank'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$rel('noopener noreferrer'),
					attrs)),
			html);
	});
var $author$project$View$Util$mailToHrefTranslate = F3(
	function (email, subject, maybeBody) {
		var queryifiedSubject = A2(
			$elm$url$Url$Builder$string,
			'subject',
			$author$project$Translate$extract(subject));
		var queryifiedBody = A2(
			$elm$url$Url$Builder$string,
			'body',
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $author$project$Translate$extract, maybeBody)));
		return 'mailto:' + (email + $elm$url$Url$Builder$toQuery(
			_List_fromArray(
				[queryifiedSubject, queryifiedBody])));
	});
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Login$ViewUtil$helpLinksToServicesEmail = F3(
	function (whoIsCorvusMsg, helpEmailSubject, needHelpMsg) {
		var helpEmail = A3($author$project$View$Util$mailToHrefTranslate, $author$project$View$CustomerSuccess$emailAddress, helpEmailSubject, $elm$core$Maybe$Nothing);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('branded__links !tw-mt-8')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$View$Util$externalNewTabLink,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('branded__link -who'),
							$elm$html$Html$Attributes$href('https://www.corvusinsurance.com/'),
							$elm$html$Html$Events$onClick(whoIsCorvusMsg)
						]),
					_List_fromArray(
						[
							$author$project$Translate$Html$text(
							$author$project$Translate$gettext('Who is Corvus?'))
						])),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('branded__link -help'),
							$elm$html$Html$Attributes$href(helpEmail),
							$elm$html$Html$Events$onClick(needHelpMsg),
							$elm$html$Html$Attributes$target('_blank'),
							$elm$html$Html$Attributes$rel('noopener')
						]),
					_List_fromArray(
						[
							$author$project$Translate$Html$text(
							$author$project$Translate$gettext('Need help?'))
						]))
				]));
	});
var $author$project$Login$AccountSetup$help = A3(
	$author$project$Login$ViewUtil$helpLinksToServicesEmail,
	$author$project$Login$AccountSetup$TrackWhoIsCorvusLinkClickedAccountSetup,
	$author$project$Translate$gettext('Need help with email address entry for account setup'),
	$author$project$Login$AccountSetup$TrackNeedHelpLinkClicked);
var $elm$html$Html$p = _VirtualDom_node('p');
var $author$project$View$Util$alert = F2(
	function (attributes, message) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('alert alert--warning'),
				attributes),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(message)
						]))
				]));
	});
var $author$project$View$Util$maybeAlert = F2(
	function (attributes, mMessage) {
		if (!mMessage.$) {
			var message = mMessage.a;
			return A2($author$project$View$Util$alert, attributes, message);
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Model$ValidationNext$message = function (validation) {
	if (validation.$ === 2) {
		var msg = validation.a;
		return $elm$core$Maybe$Just(msg);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $author$project$Login$AccountSetup$title_ = A2(
	$elm$html$Html$h1,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mfa-setup__header')
		]),
	_List_fromArray(
		[
			$author$project$Translate$Html$text(
			$author$project$Translate$gettext('Set up your account'))
		]));
var $author$project$UserTracking$LinkTracking$Link = function (a) {
	return {$: 0, a: a};
};
var $author$project$UserTracking$LinkTracking$None = {$: 1};
var $author$project$View$Util$onClickPreventDefaultForLinkWithHref = F2(
	function (onClickMsg, onSpecialClickMsg) {
		var mapToMsg = function (preventDefault) {
			return preventDefault ? _Utils_Tuple2(onSpecialClickMsg, false) : _Utils_Tuple2(onClickMsg, true);
		};
		var isSpecialClick = A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (isCtrl, isMeta) {
					return isCtrl || isMeta;
				}),
			A2($elm$json$Json$Decode$field, 'ctrlKey', $elm$json$Json$Decode$bool),
			A2($elm$json$Json$Decode$field, 'metaKey', $elm$json$Json$Decode$bool));
		return A2(
			$elm$html$Html$Events$preventDefaultOn,
			'click',
			A2($elm$json$Json$Decode$map, mapToMsg, isSpecialClick));
	});
var $author$project$UserTracking$LinkTracking$trackableLink = F5(
	function (toUrl, attributes, children, onClick, route) {
		var trackInteractionPartial = onClick;
		var onLinkClickHandler = A2(
			$author$project$View$Util$onClickPreventDefaultForLinkWithHref,
			trackInteractionPartial(
				$author$project$UserTracking$LinkTracking$Link(route)),
			trackInteractionPartial($author$project$UserTracking$LinkTracking$None));
		return A2(
			$elm$html$Html$a,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$target('_self'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$href(
						toUrl(route)),
					A2($elm$core$List$cons, onLinkClickHandler, attributes))),
			children);
	});
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Login$AccountSetup$accountSetupCard = F2(
	function (_v0, formElements) {
		var email = _v0.aW;
		var isTravelersRequestUrl = _v0.zm;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mfa-setup__card')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$View$Util$displayIf,
					isTravelersRequestUrl,
					function (_v1) {
						return A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__header large')
								]),
							_List_fromArray(
								[
									$author$project$Translate$Html$text(
									$author$project$Translate$gettext('Welcome to Travelers'))
								]));
					}),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('tw-flex tw-flex-col tw-pb-4 tw-gap-4  tw-leading-[1.7] mfa-setup__info', true),
									_Utils_Tuple2('account-setup ', isTravelersRequestUrl)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$View$Util$displayIf,
							!isTravelersRequestUrl,
							function (_v2) {
								return $author$project$Login$AccountSetup$title_;
							}),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tw-min-h-10 tw-text-center tw-tracking-[0.07px]')
								]),
							_List_fromArray(
								[
									$author$project$Translate$Html$text(
									$author$project$Translate$gettext('Enter your email address to begin your account set up.'))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tw-text-gray-800')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('branded__form'),
									$elm$html$Html$Events$onSubmit($author$project$Login$AccountSetup$CreateAccount)
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$View$Branded$emailInput,
									_List_fromArray(
										[
											$elm$html$Html$Events$onInput($author$project$Login$AccountSetup$EmailUpdated),
											$elm$html$Html$Attributes$value(
											A2($author$project$Model$ValidationNext$toString, $author$project$Data$Email$toString, email)),
											$elm$html$Html$Attributes$autofocus(true)
										]),
									A2(
										$author$project$View$Util$maybeAlert,
										_List_Nil,
										$author$project$Model$ValidationNext$message(email))),
								formElements))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('branded__links !tw-mt-4')
						]),
					_List_fromArray(
						[
							A5(
							$author$project$UserTracking$LinkTracking$trackableLink,
							$author$project$Login$Route$toUrl,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('branded__link existing-account')
								]),
							_List_fromArray(
								[
									$author$project$Translate$Html$text(
									$author$project$Translate$gettext('Sign in with existing account'))
								]),
							$author$project$Login$AccountSetup$TrackSignInWithExistingAccountLinkClicked,
							$author$project$Login$Route$defaultSigninRoute)
						])),
					A2(
					$author$project$View$Util$displayIf,
					!isTravelersRequestUrl,
					function (_v3) {
						return $author$project$Login$AccountSetup$help;
					})
				]));
	});
var $author$project$View$Util$alertTranslate = F2(
	function (attributes, message) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('alert alert--warning'),
				attributes),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Translate$Html$text(message)
						]))
				]));
	});
var $elm$html$Html$button = _VirtualDom_node('button');
var $author$project$Login$ViewUtil$href = function (route) {
	return $elm$html$Html$Attributes$href(
		$author$project$Login$Route$toUrl(route));
};
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $author$project$View$Svg$refresh = $author$project$View$Svg$icon('refresh');
var $author$project$View$Button$loading = F2(
	function (attrs, content) {
		return A2(
			$elm$html$Html$button,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('button button--loading'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$disabled(true),
					attrs)),
			A2(
				$elm$core$List$cons,
				$author$project$View$Svg$refresh('is-loading'),
				content));
	});
var $author$project$Login$AccountSetup$view = function (model) {
	var _v0 = model.gW;
	switch (_v0.$) {
		case 0:
			return A2(
				$author$project$Login$AccountSetup$accountSetupCard,
				model,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('branded__form-group')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button branded__button-login')
									]),
								_List_fromArray(
									[
										$author$project$Translate$Html$text(
										$author$project$Translate$gettext('Continue'))
									]))
							]))
					]));
		case 1:
			return A2(
				$author$project$Login$AccountSetup$accountSetupCard,
				model,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('branded__form-group')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$View$Button$loading,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button branded__button-login')
									]),
								_List_fromArray(
									[
										$author$project$Translate$Html$text(
										$author$project$Translate$gettext('Setting up…'))
									]))
							]))
					]));
		case 2:
			return A2(
				$author$project$Login$AccountSetup$accountSetupCard,
				model,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('branded__form-group')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button branded__button -warning')
									]),
								_List_fromArray(
									[
										$author$project$Translate$Html$text(
										$author$project$Translate$gettext('Continue'))
									])),
								A2(
								$author$project$View$Util$alertTranslate,
								_List_Nil,
								$author$project$Translate$gettext('Please check the email address again.'))
							]))
					]));
		default:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mfa-setup__card')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$View$Util$displayIf,
						!model.zm,
						function (_v1) {
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('tw-flex tw-flex-col tw-pb-4 tw-gap-4 tw-leading-[1.7]')
									]),
								_List_fromArray(
									[$author$project$Login$AccountSetup$title_]));
						}),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('alert alert--success')
							]),
						_List_fromArray(
							[
								$author$project$Translate$Html$text(
								$author$project$Translate$gettext('Success: Please check your email for a link to create your password.'))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('branded__form-group')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button branded__button-login'),
										$author$project$Login$ViewUtil$href($author$project$Login$Route$defaultSigninRoute)
									]),
								_List_fromArray(
									[
										$author$project$Translate$Html$text(
										$author$project$Translate$gettext('Go to sign in page'))
									]))
							])),
						A2(
						$author$project$View$Util$displayIf,
						!model.zm,
						function (_v2) {
							return $author$project$Login$AccountSetup$help;
						})
					]));
	}
};
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $author$project$Login$AffiliateSignup$View$failureMessage = function (failedRequest) {
	if ((failedRequest.$ === 3) && (failedRequest.a === 422)) {
		return 'Are you sure you\'re on the right page?';
	} else {
		return 'Something went wrong. Please try again.';
	}
};
var $author$project$Login$AffiliateSignup$Model$DoSignup = {$: 0};
var $author$project$Login$AffiliateSignup$Model$EmailUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Login$AffiliateSignup$View$emailInput = function (email) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('branded__form-group')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$for('email'),
						$elm$html$Html$Attributes$class('branded__label')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Email Address')
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('email'),
						$elm$html$Html$Attributes$type_('email'),
						$elm$html$Html$Attributes$class('branded__input'),
						$elm$html$Html$Events$onInput($author$project$Login$AffiliateSignup$Model$EmailUpdated),
						$elm$html$Html$Attributes$value(
						A2($author$project$Model$ValidationNext$toString, $author$project$Data$Email$toString, email))
					]),
				_List_Nil),
				A2(
				$author$project$View$Util$maybeAlert,
				_List_Nil,
				$author$project$Model$ValidationNext$message(email))
			]));
};
var $author$project$Login$AffiliateSignup$Model$NameUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Login$AffiliateSignup$View$nameInput = function (name) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('branded__form-group')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$for('name'),
						$elm$html$Html$Attributes$class('branded__label')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Full Name')
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('text'),
						$elm$html$Html$Attributes$id('name'),
						$elm$html$Html$Attributes$class('branded__input'),
						$elm$html$Html$Events$onInput($author$project$Login$AffiliateSignup$Model$NameUpdated),
						$elm$html$Html$Attributes$value(
						A2($author$project$Model$ValidationNext$toString, $elm$core$Basics$identity, name)),
						$elm$html$Html$Attributes$autofocus(true)
					]),
				_List_Nil),
				A2(
				$author$project$View$Util$maybeAlert,
				_List_Nil,
				$author$project$Model$ValidationNext$message(name))
			]));
};
var $author$project$Login$AffiliateSignup$View$theForm = F2(
	function (_v0, siblings) {
		var email = _v0.aW;
		var name = _v0.h$;
		return A2(
			$elm$html$Html$form,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('branded__form'),
					$elm$html$Html$Events$onSubmit($author$project$Login$AffiliateSignup$Model$DoSignup)
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('You will receive an email that will direct you to the Smart Cyber application.')
						])),
				A2(
					$elm$core$List$cons,
					$author$project$Login$AffiliateSignup$View$nameInput(name),
					A2(
						$elm$core$List$cons,
						$author$project$Login$AffiliateSignup$View$emailInput(email),
						siblings))));
	});
var $author$project$Login$AffiliateSignup$View$inputSection = function (model) {
	var _v0 = model.IZ;
	switch (_v0.$) {
		case 0:
			return A2(
				$author$project$Login$AffiliateSignup$View$theForm,
				model,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('branded__form-group')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button branded__button')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Request Access')
									]))
							]))
					]));
		case 1:
			return A2(
				$author$project$Login$AffiliateSignup$View$theForm,
				model,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('branded__form-group')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$View$Button$loading,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button branded__button')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Requesting…')
									]))
							]))
					]));
		case 3:
			return A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Check your email for a link to the Smart Cyber application.')
					]));
		default:
			var reason = _v0.a;
			return A2(
				$author$project$Login$AffiliateSignup$View$theForm,
				model,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('branded__form-group')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button branded__button')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Request Access')
									])),
								A2(
								$author$project$View$Util$alert,
								_List_Nil,
								$author$project$Login$AffiliateSignup$View$failureMessage(reason))
							]))
					]));
	}
};
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $author$project$Login$AffiliateSignup$View$view = F4(
	function (flashMessage, _v0, _v1, model) {
		var parentBrokerageId = _v0;
		var affiliateBrokerageId = _v1;
		var names = function () {
			if ((parentBrokerageId === 'Ke-mmMtVTN-GcQqgz7qsCg') && (affiliateBrokerageId === '99fdRE_wQL2P4cTgwkfs5Q')) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('higg-crc')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src('https://cdn.corvusinsurance.com/images/higg-crc-14372e86a3db098392d7bcd1ba854666.svg'),
									$elm$html$Html$Attributes$alt('Higginbotham | CRC')
								]),
							_List_Nil)
						]));
			} else {
				var _v2 = model.E7;
				if ((_v2.$ === 3) && (!_v2.a.$)) {
					var parentBrokerage = _v2.a.a.Hp;
					var affiliateBrokerage = _v2.a.a.xd;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('branded__broker-names')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(parentBrokerage.h$)
									])),
								$elm$html$Html$text(' has invited '),
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(affiliateBrokerage.h$)
									])),
								$elm$html$Html$text(' to Smart Cyber Insurance')
							]));
				} else {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('m-b4')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('…')
							]));
				}
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					names,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('branded__card branded__card--double')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('branded__signin')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('m-b3')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Request Access')
										])),
									A2(
									$author$project$View$Util$maybeAlert,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('m-b2')
										]),
									flashMessage),
									$author$project$Login$AffiliateSignup$View$inputSection(model)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('branded__info')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('m-b3')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Why Cyber Insurance?')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Get started now to get broad Smart Cyber coverage and valuable cyber risk services from Corvus for your clients.')
										])),
									A2(
									$elm$html$Html$ul,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('branded__list')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Get quotes in less than 5 minutes with a simple online application')
												])),
											A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Detailed IT security report delivered with each account')
												])),
											A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Easily invite your colleagues to sign up')
												]))
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('link'),
													$elm$html$Html$Attributes$href('https://info.corvusinsurance.com/hubfs/Flight/Corvus%20Flight%20R.pdf')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Learn More')
												])),
											$elm$html$Html$text(' about Smart Cyber insurance')
										]))
								]))
						]))
				]));
	});
var $author$project$Login$AlertSubscriberUnsubscribe$Model$Enabled = 1;
var $author$project$Login$AlertSubscriberUnsubscribe$Model$Loading = 0;
var $author$project$Login$AlertSubscriberNew$View$callToActionHtml = function (clientName) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Sign up to receive alerts for high-severity vulnerabilities detected for:')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('branded__client-name m-t2 m-b2')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(clientName)
					]))
			]));
};
var $author$project$Login$AlertSubscriberNew$View$failureView = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mfa-setup__card')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tw-flex tw-flex-col tw-pb-4 tw-gap-4 tw-leading-[1.7]')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mfa-setup__header')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Something went wrong')
						]))
				])),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tw-text-center')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Please '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('link'),
							$elm$html$Html$Attributes$href('mailto:support@corvusinsurance.com')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('contact support')
						])),
					$elm$html$Html$text(' for assistance subscribing to cybersecurity alerts.')
				]))
		]));
var $author$project$Login$AlertSubscriberNew$Model$Policyholder = 1;
var $author$project$Login$AlertSubscriberNew$Model$Retailer = 0;
var $author$project$Login$AlertSubscriberNew$Model$SubmitForm = {$: 0};
var $author$project$Login$AlertSubscriberNew$Model$UpdateEmail = function (a) {
	return {$: 3, a: a};
};
var $author$project$Login$AlertSubscriberNew$Model$UpdateName = function (a) {
	return {$: 2, a: a};
};
var $author$project$Login$AlertSubscriberNew$Model$UpdateSubscriberType = function (a) {
	return {$: 4, a: a};
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$View$Svg$radio = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$class('radio__icon'),
			$elm$svg$Svg$Attributes$width('24'),
			$elm$svg$Svg$Attributes$height('24'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('unchecked'),
					$elm$svg$Svg$Attributes$d('M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M12,20c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S16.4,20,12,20 z')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('checked'),
					$elm$svg$Svg$Attributes$cx('12'),
					$elm$svg$Svg$Attributes$cy('12'),
					$elm$svg$Svg$Attributes$r('5')
				]),
			_List_Nil)
		]));
var $author$project$View$Input$labeledRadio = F5(
	function (attributes, inputId, currentState, onClickMsg, content) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$id(inputId),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$type_('radio'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Events$onCheck(onClickMsg),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$checked(currentState),
								attributes)))),
				_List_Nil),
				A2(
				$elm$html$Html$label,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$for(inputId),
					attributes),
				A2($elm$core$List$cons, $author$project$View$Svg$radio, content))
			]);
	});
var $author$project$View$Input$radio = F5(
	function (attributes, inputId, currentState, onClickMsg, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('radio')
				]),
			A5($author$project$View$Input$labeledRadio, attributes, inputId, currentState, onClickMsg, content));
	});
var $author$project$Login$AlertSubscriberUnsubscribe$View$submitButton = F2(
	function (buttonText, buttonState) {
		if (!buttonState) {
			return A2(
				$author$project$View$Button$loading,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('submit'),
						$elm$html$Html$Attributes$class('button branded__button')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(buttonText)
					]));
		} else {
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('submit'),
						$elm$html$Html$Attributes$class('button branded__button')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(buttonText)
					]));
		}
	});
var $author$project$Login$AlertSubscriberNew$View$submitButtonText = 'Subscribe to Cybersecurity Alerts';
var $author$project$Login$AlertSubscriberNew$View$formView = F3(
	function (model, callToAction, buttonState) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mfa-setup__card')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tw-flex tw-flex-col tw-pb-4 tw-gap-4 tw-leading-[1.7]')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__header')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add a Subscriber')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tw-min-h-10 tw-text-center tw-tracking-[0.07px]')
								]),
							_List_fromArray(
								[callToAction]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tw-text-gray-800')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Events$onSubmit($author$project$Login$AlertSubscriberNew$Model$SubmitForm),
									$elm$html$Html$Attributes$class('branded__form')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('branded__form-group')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('branded__label')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Full Name')
												])),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('branded__input'),
													$elm$html$Html$Attributes$type_('text'),
													$elm$html$Html$Attributes$placeholder('Name'),
													$elm$html$Html$Attributes$value(
													A2($author$project$Model$ValidationNext$toString, $elm$core$Basics$identity, model.h$)),
													$elm$html$Html$Events$onInput($author$project$Login$AlertSubscriberNew$Model$UpdateName)
												]),
											_List_Nil),
											A2(
											$author$project$View$Util$maybeAlert,
											_List_Nil,
											$author$project$Model$ValidationNext$message(model.h$))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('branded__form-group')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('branded__label')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Email Address')
												])),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('branded__input'),
													$elm$html$Html$Attributes$type_('text'),
													$elm$html$Html$Attributes$placeholder('Email'),
													$elm$html$Html$Attributes$value(
													$author$project$Data$Email$validatedToString(model.aW)),
													$elm$html$Html$Events$onInput($author$project$Login$AlertSubscriberNew$Model$UpdateEmail)
												]),
											_List_Nil),
											A2(
											$author$project$View$Util$maybeAlert,
											_List_Nil,
											$author$project$Model$ValidationNext$message(model.aW))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('branded__form-group')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('branded__label')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('This subscriber is a')
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('checkbox tw-text-base tw-leading-loose')
												]),
											_List_fromArray(
												[
													A5(
													$author$project$View$Input$radio,
													_List_Nil,
													'subscriber-type_policyholder',
													$author$project$Model$ValidationNext$extract(model.Jp) === 1,
													function (_v0) {
														return $author$project$Login$AlertSubscriberNew$Model$UpdateSubscriberType(1);
													},
													_List_fromArray(
														[
															$elm$html$Html$text('Policyholder')
														])),
													A5(
													$author$project$View$Input$radio,
													_List_Nil,
													'subscriber-type_retailer',
													!$author$project$Model$ValidationNext$extract(model.Jp),
													function (_v1) {
														return $author$project$Login$AlertSubscriberNew$Model$UpdateSubscriberType(0);
													},
													_List_fromArray(
														[
															$elm$html$Html$text('Retail Broker')
														]))
												])),
											A2(
											$author$project$View$Util$maybeAlert,
											_List_Nil,
											$author$project$Model$ValidationNext$message(model.Jp))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('branded__form-group tw-text-base')
										]),
									_List_fromArray(
										[
											A2($author$project$Login$AlertSubscriberUnsubscribe$View$submitButton, $author$project$Login$AlertSubscriberNew$View$submitButtonText, buttonState)
										]))
								]))
						]))
				]));
	});
var $author$project$View$Util$loading = $author$project$View$Svg$refresh('is-loading page');
var $author$project$Login$AlertSubscriberNew$Model$Reset = {$: 6};
var $author$project$View$Svg$check = $author$project$View$Svg$icon('check');
var $author$project$Login$AlertSubscriberNew$View$successView = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mfa-setup__card tw-text-center')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('branded__success-check m-b3 *:-tw-mt-4')
				]),
			_List_fromArray(
				[
					$author$project$View$Svg$check('')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tw-flex tw-flex-col tw-pb-4 tw-gap-4 tw-leading-[1.7]')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mfa-setup__header')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Subscription Successful')
						]))
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('When the Cyber Risk Scan detects a severe cybersecurity vulnerability, all subscribers will receive an email notification.')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('branded__form-group tw-text-base !tw-text-center')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$Login$AlertSubscriberNew$Model$Reset),
							$elm$html$Html$Attributes$class('button m-t1 m-b3')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Add Another Subscriber')
						]))
				]))
		]));
var $author$project$Login$AlertSubscriberNew$View$view = function (model) {
	var _v0 = model.ft;
	switch (_v0.$) {
		case 0:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('*:!tw-fill-white')
					]),
				_List_fromArray(
					[$author$project$View$Util$loading]));
		case 1:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('*:!tw-fill-white')
					]),
				_List_fromArray(
					[$author$project$View$Util$loading]));
		case 2:
			return $author$project$Login$AlertSubscriberNew$View$failureView;
		default:
			var clientName = _v0.a;
			var _v1 = model.E1;
			switch (_v1.$) {
				case 0:
					return A3(
						$author$project$Login$AlertSubscriberNew$View$formView,
						model,
						$author$project$Login$AlertSubscriberNew$View$callToActionHtml(clientName),
						1);
				case 1:
					return A3(
						$author$project$Login$AlertSubscriberNew$View$formView,
						model,
						$author$project$Login$AlertSubscriberNew$View$callToActionHtml(clientName),
						0);
				case 2:
					return $author$project$Login$AlertSubscriberNew$View$failureView;
				default:
					return $author$project$Login$AlertSubscriberNew$View$successView;
			}
	}
};
var $author$project$Login$AlertSubscriberUnsubscribe$View$callToActionHtml = function (clientName) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Opt out from receiving cybersecurity alert emails about:')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('branded__client-name m-t2 m-b2')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(clientName)
					]))
			]));
};
var $author$project$Login$AlertSubscriberUnsubscribe$View$failureView = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mfa-setup__card tw-text-center')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tw-flex tw-flex-col tw-pb-4 tw-gap-4 tw-leading-[1.7]')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mfa-setup__header')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Something went wrong')
						]))
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Please '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('link'),
							$elm$html$Html$Attributes$href('mailto:support@corvusinsurance.com')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('contact support')
						])),
					$elm$html$Html$text(' for assistance unsubscribing from cybersecurity alerts.')
				]))
		]));
var $author$project$Login$AlertSubscriberUnsubscribe$Model$SubmitForm = {$: 2};
var $author$project$Login$AlertSubscriberUnsubscribe$Model$UpdateEmail = function (a) {
	return {$: 1, a: a};
};
var $author$project$Login$AlertSubscriberUnsubscribe$View$submitButtonText = 'Unsubscribe from Cybersecurity Alerts';
var $author$project$Login$AlertSubscriberUnsubscribe$View$formView = F3(
	function (model, callToAction, buttonState) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mfa-setup__card')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tw-flex tw-flex-col tw-pb-4 tw-gap-4 tw-leading-[1.7]')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__header')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Unsubscribe from Alert Emails')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tw-min-h-10 tw-text-center tw-tracking-[0.07px]')
								]),
							_List_fromArray(
								[callToAction]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tw-text-gray-800')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Events$onSubmit($author$project$Login$AlertSubscriberUnsubscribe$Model$SubmitForm),
									$elm$html$Html$Attributes$class('branded__form')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('branded__form-group')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('branded__label')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Email Address')
												])),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('branded__input'),
													$elm$html$Html$Attributes$type_('text'),
													$elm$html$Html$Attributes$placeholder('Email'),
													$elm$html$Html$Attributes$value(
													$author$project$Data$Email$validatedToString(model.aW)),
													$elm$html$Html$Events$onInput($author$project$Login$AlertSubscriberUnsubscribe$Model$UpdateEmail)
												]),
											_List_Nil),
											A2(
											$author$project$View$Util$maybeAlert,
											_List_Nil,
											$author$project$Model$ValidationNext$message(model.aW))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('branded__form-group tw-text-base')
										]),
									_List_fromArray(
										[
											A2($author$project$Login$AlertSubscriberUnsubscribe$View$submitButton, $author$project$Login$AlertSubscriberUnsubscribe$View$submitButtonText, buttonState)
										]))
								]))
						]))
				]));
	});
var $author$project$Login$AlertSubscriberUnsubscribe$View$resubscribeUrl = function (model) {
	return $author$project$Login$Route$toUrl(
		$author$project$Login$Route$AlertSubscriberNew(model.xM));
};
var $author$project$Login$AlertSubscriberUnsubscribe$View$successView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mfa-setup__card tw-text-center')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('branded__success-check m-b3 *:-tw-mt-4')
					]),
				_List_fromArray(
					[
						$author$project$View$Svg$check('')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('tw-flex tw-flex-col tw-pb-4 tw-gap-4 tw-leading-[1.7]')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mfa-setup__header')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Unsubscribed Successfully')
							]))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Should you change your mind about recieving alert emails about this client, you can '),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('link'),
								$elm$html$Html$Attributes$href(
								$author$project$Login$AlertSubscriberUnsubscribe$View$resubscribeUrl(model))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('click here')
							])),
						$elm$html$Html$text(' to re-subscribe.')
					]))
			]));
};
var $author$project$Login$AlertSubscriberUnsubscribe$View$view = function (model) {
	var _v0 = model.ft;
	switch (_v0.$) {
		case 0:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('*:!tw-fill-white')
					]),
				_List_fromArray(
					[$author$project$View$Util$loading]));
		case 1:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('*:!tw-fill-white')
					]),
				_List_fromArray(
					[$author$project$View$Util$loading]));
		case 2:
			return $author$project$Login$AlertSubscriberUnsubscribe$View$failureView;
		default:
			var clientName = _v0.a;
			var _v1 = model.E1;
			switch (_v1.$) {
				case 0:
					return A3(
						$author$project$Login$AlertSubscriberUnsubscribe$View$formView,
						model,
						$author$project$Login$AlertSubscriberUnsubscribe$View$callToActionHtml(clientName),
						1);
				case 1:
					return A3(
						$author$project$Login$AlertSubscriberUnsubscribe$View$formView,
						model,
						$author$project$Login$AlertSubscriberUnsubscribe$View$callToActionHtml(clientName),
						0);
				case 2:
					return $author$project$Login$AlertSubscriberUnsubscribe$View$failureView;
				default:
					return $author$project$Login$AlertSubscriberUnsubscribe$View$successView(model);
			}
	}
};
var $author$project$Login$ConfirmBindForm$Changed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Login$ConfirmBindForm$Expired = function (a) {
	return {$: 0, a: a};
};
var $author$project$View$Svg$chevronRight = $author$project$View$Svg$icon('chevron-right');
var $author$project$View$Util$getDateFormat = function () {
	var enUsFormat = 'MM/dd/yyyy';
	var _v0 = $author$project$Translate$extract(
		$author$project$Translate$gettext('en_US'));
	switch (_v0) {
		case 'en_US':
			return enUsFormat;
		case 'de_DE':
			return 'dd.MM.yyyy';
		default:
			return enUsFormat;
	}
}();
var $author$project$Login$ConfirmBindForm$formatDate = $justinmimbs$date$Date$format($author$project$View$Util$getDateFormat);
var $author$project$Translate$regex = A2(
	$elm$core$Basics$composeR,
	$elm$regex$Regex$fromString,
	$elm$core$Maybe$withDefault($elm$regex$Regex$never));
var $author$project$Translate$namedValue = F2(
	function (name, val) {
		var match = $author$project$Translate$regex('%{' + (name + '}'));
		return A2(
			$elm$regex$Regex$replace,
			match,
			function (_v0) {
				return val;
			});
	});
var $author$project$Translate$gettextN = F2(
	function (msgid, replacements) {
		return function (val) {
			return A3(
				$elm$core$List$foldl,
				F2(
					function (_v0, acc) {
						var a = _v0.a;
						var b = _v0.b;
						return A3($author$project$Translate$namedValue, a, b, acc);
					}),
				val,
				replacements);
		}(
			A2(
				$elm$core$Maybe$withDefault,
				msgid,
				A2($elm$core$Dict$get, msgid, $author$project$Translation$translations)));
	});
var $author$project$View$Nav$corvusTravelersSmallStandardRGB = 'https://cdn.corvusinsurance.com/images/CORVUS-Travelers-SML-POS-RGB-8049af7570341c9021f6dea12c41b1d8.svg';
var $author$project$View$Nav$logoStandardCorvusByTravelers = A2(
	$elm$html$Html$img,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$src($author$project$View$Nav$corvusTravelersSmallStandardRGB),
			$author$project$Translate$Html$Attributes$alt(
			$author$project$Translate$gettext('Corvus by Travelers logo'))
		]),
	_List_Nil);
var $author$project$View$Nav$logoCorvusByTravelers = F2(
	function (attrs, environment) {
		return A2(
			$elm$html$Html$div,
			attrs,
			A2(
				$elm$core$List$cons,
				$author$project$View$Nav$logoStandardCorvusByTravelers,
				$author$project$View$Nav$logoEnvironmentHelper(environment)));
	});
var $author$project$Login$ConfirmBindForm$logo = F2(
	function (environment, _v0) {
		return A2(
			$author$project$View$Nav$logoCorvusByTravelers,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('confirm-bind__logo')
				]),
			environment);
	});
var $author$project$Translate$alreadyTranslated = $elm$core$Basics$identity;
var $author$project$View$Util$centStrToDollars = function (centStr) {
	return ($elm$core$String$length(centStr) > 2) ? A3($elm$core$String$slice, 0, -2, centStr) : '0';
};
var $elm$core$String$reverse = _String_reverse;
var $elm_community$string_extra$String$Extra$breaker = F3(
	function (width, string, acc) {
		breaker:
		while (true) {
			if (string === '') {
				return $elm$core$List$reverse(acc);
			} else {
				var $temp$width = width,
					$temp$string = A2($elm$core$String$dropLeft, width, string),
					$temp$acc = A2(
					$elm$core$List$cons,
					A3($elm$core$String$slice, 0, width, string),
					acc);
				width = $temp$width;
				string = $temp$string;
				acc = $temp$acc;
				continue breaker;
			}
		}
	});
var $elm_community$string_extra$String$Extra$break = F2(
	function (width, string) {
		return ((!width) || (string === '')) ? _List_fromArray(
			[string]) : A3($elm_community$string_extra$String$Extra$breaker, width, string, _List_Nil);
	});
var $elm_community$string_extra$String$Extra$wrapWith = F3(
	function (width, separator, string) {
		return A2(
			$elm$core$String$join,
			separator,
			A2($elm_community$string_extra$String$Extra$break, width, string));
	});
var $author$project$View$Util$addSeparatorsToNumber = F2(
	function (separator, str) {
		return $elm$core$String$reverse(
			A3(
				$elm_community$string_extra$String$Extra$wrapWith,
				3,
				separator,
				$elm$core$String$reverse(str)));
	});
var $author$project$View$Util$addCommasToNumber = function (str) {
	return A2($author$project$View$Util$addSeparatorsToNumber, ',', str);
};
var $author$project$View$Util$formatMoneyStr = F2(
	function (addSeparators, money) {
		return A2($elm$core$String$startsWith, '-', money) ? ('-' + addSeparators(
			A2($elm$core$String$dropLeft, 1, money))) : addSeparators(money);
	});
var $author$project$View$Util$formatDollarsStr = function (dollars) {
	return A2($author$project$View$Util$formatMoneyStr, $author$project$View$Util$addCommasToNumber, dollars);
};
var $author$project$View$Util$formatUsdDollarsStr = function (dollars) {
	var _v0 = $author$project$View$Util$formatDollarsStr(dollars);
	if (_v0 === '') {
		return '';
	} else {
		var nonEmptyStr = _v0;
		return '$' + nonEmptyStr;
	}
};
var $author$project$View$Util$toUsdJustString = A2(
	$elm$core$Basics$composeL,
	A2($elm$core$Basics$composeL, $author$project$View$Util$formatUsdDollarsStr, $author$project$View$Util$centStrToDollars),
	$elm$core$String$fromInt);
var $author$project$Login$ConfirmBindForm$optionCard = F5(
	function (cardTitle, triaHtml, footerHtml, readyOrBoundFormData, option) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bind-option')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bind-option__title')
						]),
					_List_fromArray(
						[
							$author$project$Translate$Html$text(cardTitle)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bind-option__dates')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bind-option__data')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bind-option__data-label')
										]),
									_List_fromArray(
										[
											$author$project$Translate$Html$text(
											$author$project$Translate$gettext('Effective Date'))
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Translate$Html$text(
											$author$project$Translate$alreadyTranslated(
												$author$project$Login$ConfirmBindForm$formatDate(readyOrBoundFormData.bx)))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bind-option__data')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bind-option__data-label')
										]),
									_List_fromArray(
										[
											$author$project$Translate$Html$text(
											$author$project$Translate$gettext('Expiration Date'))
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Translate$Html$text(
											$author$project$Translate$alreadyTranslated(
												$author$project$Login$ConfirmBindForm$formatDate(readyOrBoundFormData.bB)))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bind-option__separator')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bind-option__coverage')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bind-option__data')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bind-option__data-label')
										]),
									_List_fromArray(
										[
											$author$project$Translate$Html$text(
											$author$project$Translate$gettext('Limit'))
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Translate$Html$text(
											$author$project$Translate$doNotTranslate(
												$author$project$View$Util$toUsdJustString(option.hN)))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bind-option__data')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bind-option__data-label')
										]),
									_List_fromArray(
										[
											$author$project$Translate$Html$text(
											$author$project$Translate$gettext('Retention'))
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Translate$Html$text(
											$author$project$Translate$doNotTranslate(
												$author$project$View$Util$toUsdJustString(option.cI)))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bind-option__data')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bind-option__data-label')
										]),
									_List_fromArray(
										[
											$author$project$Translate$Html$text(
											$author$project$Translate$gettext('Premium'))
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Translate$Html$text(
											$author$project$Translate$doNotTranslate(
												$author$project$View$Util$toUsdJustString(option.iq)))
										]))
								])),
							triaHtml,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bind-option__data')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bind-option__data-label')
										]),
									_List_fromArray(
										[
											$author$project$Translate$Html$text(
											$author$project$Translate$gettext('Policy Fee'))
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Translate$Html$text(
											$author$project$Translate$doNotTranslate(
												$author$project$View$Util$toUsdJustString(readyOrBoundFormData.vS)))
										]))
								]))
						])),
					footerHtml
				]));
	});
var $hecrj$html_parser$Html$Parser$Element = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $hecrj$html_parser$Html$Parser$chompOneOrMore = function (fn) {
	return A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$chompIf(fn),
		$elm$parser$Parser$chompWhile(fn));
};
var $hecrj$html_parser$Html$Parser$isSpaceCharacter = function (c) {
	return (c === ' ') || ((c === '\t') || ((c === '\n') || ((c === '\u000D') || ((c === '\u000C') || (c === '\u00A0')))));
};
var $hecrj$html_parser$Html$Parser$closingTag = function (name) {
	var chompName = A2(
		$elm$parser$Parser$andThen,
		function (closingName) {
			return _Utils_eq(
				$elm$core$String$toLower(closingName),
				name) ? $elm$parser$Parser$succeed(0) : $elm$parser$Parser$problem('closing tag does not match opening tag: ' + name);
		},
		$elm$parser$Parser$getChompedString(
			$hecrj$html_parser$Html$Parser$chompOneOrMore(
				function (c) {
					return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && (c !== '>');
				})));
	return A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<')),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('/'))),
				chompName),
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('>')));
};
var $hecrj$html_parser$Html$Parser$Comment = function (a) {
	return {$: 2, a: a};
};
var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$findSubString, str, s.G4, s.IM, s.Dv, s.c);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A4($elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.rY)) : A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.G4, newOffset) < 0,
			0,
			{Dv: newCol, rY: s.rY, p: s.p, G4: newOffset, IM: newRow, c: s.c});
	};
};
var $elm$parser$Parser$chompUntil = function (str) {
	return $elm$parser$Parser$Advanced$chompUntil(
		$elm$parser$Parser$toToken(str));
};
var $hecrj$html_parser$Html$Parser$commentString = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$token('<!')),
		$elm$parser$Parser$token('--')),
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$getChompedString(
			$elm$parser$Parser$chompUntil('-->')),
		$elm$parser$Parser$token('-->')));
var $hecrj$html_parser$Html$Parser$comment = A2($elm$parser$Parser$map, $hecrj$html_parser$Html$Parser$Comment, $hecrj$html_parser$Html$Parser$commentString);
var $hecrj$html_parser$Html$Parser$voidElements = _List_fromArray(
	['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr']);
var $hecrj$html_parser$Html$Parser$isVoidElement = function (name) {
	return A2($elm$core$List$member, name, $hecrj$html_parser$Html$Parser$voidElements);
};
var $hecrj$html_parser$Html$Parser$many = function (parser_) {
	return A2(
		$elm$parser$Parser$loop,
		_List_Nil,
		function (list) {
			return $elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$map,
						function (_new) {
							return $elm$parser$Parser$Loop(
								A2($elm$core$List$cons, _new, list));
						},
						parser_),
						$elm$parser$Parser$succeed(
						$elm$parser$Parser$Done(
							$elm$core$List$reverse(list)))
					]));
		});
};
var $hecrj$html_parser$Html$Parser$isTagAttributeCharacter = function (c) {
	return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '>') && ((c !== '/') && (c !== '=')))));
};
var $hecrj$html_parser$Html$Parser$tagAttributeName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($hecrj$html_parser$Html$Parser$isTagAttributeCharacter)));
var $hecrj$html_parser$Html$Parser$chompSemicolon = $elm$parser$Parser$chompIf(
	$elm$core$Basics$eq(';'));
var $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('Aacute', 'Á'),
			_Utils_Tuple2('aacute', 'á'),
			_Utils_Tuple2('Abreve', 'Ă'),
			_Utils_Tuple2('abreve', 'ă'),
			_Utils_Tuple2('ac', '∾'),
			_Utils_Tuple2('acd', '∿'),
			_Utils_Tuple2('acE', '∾̳'),
			_Utils_Tuple2('Acirc', 'Â'),
			_Utils_Tuple2('acirc', 'â'),
			_Utils_Tuple2('acute', '´'),
			_Utils_Tuple2('Acy', 'А'),
			_Utils_Tuple2('acy', 'а'),
			_Utils_Tuple2('AElig', 'Æ'),
			_Utils_Tuple2('aelig', 'æ'),
			_Utils_Tuple2('af', '\u2061'),
			_Utils_Tuple2('Afr', '\uD835\uDD04'),
			_Utils_Tuple2('afr', '\uD835\uDD1E'),
			_Utils_Tuple2('Agrave', 'À'),
			_Utils_Tuple2('agrave', 'à'),
			_Utils_Tuple2('alefsym', 'ℵ'),
			_Utils_Tuple2('aleph', 'ℵ'),
			_Utils_Tuple2('Alpha', 'Α'),
			_Utils_Tuple2('alpha', 'α'),
			_Utils_Tuple2('Amacr', 'Ā'),
			_Utils_Tuple2('amacr', 'ā'),
			_Utils_Tuple2('amalg', '⨿'),
			_Utils_Tuple2('amp', '&'),
			_Utils_Tuple2('AMP', '&'),
			_Utils_Tuple2('andand', '⩕'),
			_Utils_Tuple2('And', '⩓'),
			_Utils_Tuple2('and', '∧'),
			_Utils_Tuple2('andd', '⩜'),
			_Utils_Tuple2('andslope', '⩘'),
			_Utils_Tuple2('andv', '⩚'),
			_Utils_Tuple2('ang', '∠'),
			_Utils_Tuple2('ange', '⦤'),
			_Utils_Tuple2('angle', '∠'),
			_Utils_Tuple2('angmsdaa', '⦨'),
			_Utils_Tuple2('angmsdab', '⦩'),
			_Utils_Tuple2('angmsdac', '⦪'),
			_Utils_Tuple2('angmsdad', '⦫'),
			_Utils_Tuple2('angmsdae', '⦬'),
			_Utils_Tuple2('angmsdaf', '⦭'),
			_Utils_Tuple2('angmsdag', '⦮'),
			_Utils_Tuple2('angmsdah', '⦯'),
			_Utils_Tuple2('angmsd', '∡'),
			_Utils_Tuple2('angrt', '∟'),
			_Utils_Tuple2('angrtvb', '⊾'),
			_Utils_Tuple2('angrtvbd', '⦝'),
			_Utils_Tuple2('angsph', '∢'),
			_Utils_Tuple2('angst', 'Å'),
			_Utils_Tuple2('angzarr', '⍼'),
			_Utils_Tuple2('Aogon', 'Ą'),
			_Utils_Tuple2('aogon', 'ą'),
			_Utils_Tuple2('Aopf', '\uD835\uDD38'),
			_Utils_Tuple2('aopf', '\uD835\uDD52'),
			_Utils_Tuple2('apacir', '⩯'),
			_Utils_Tuple2('ap', '≈'),
			_Utils_Tuple2('apE', '⩰'),
			_Utils_Tuple2('ape', '≊'),
			_Utils_Tuple2('apid', '≋'),
			_Utils_Tuple2('apos', '\''),
			_Utils_Tuple2('ApplyFunction', '\u2061'),
			_Utils_Tuple2('approx', '≈'),
			_Utils_Tuple2('approxeq', '≊'),
			_Utils_Tuple2('Aring', 'Å'),
			_Utils_Tuple2('aring', 'å'),
			_Utils_Tuple2('Ascr', '\uD835\uDC9C'),
			_Utils_Tuple2('ascr', '\uD835\uDCB6'),
			_Utils_Tuple2('Assign', '≔'),
			_Utils_Tuple2('ast', '*'),
			_Utils_Tuple2('asymp', '≈'),
			_Utils_Tuple2('asympeq', '≍'),
			_Utils_Tuple2('Atilde', 'Ã'),
			_Utils_Tuple2('atilde', 'ã'),
			_Utils_Tuple2('Auml', 'Ä'),
			_Utils_Tuple2('auml', 'ä'),
			_Utils_Tuple2('awconint', '∳'),
			_Utils_Tuple2('awint', '⨑'),
			_Utils_Tuple2('backcong', '≌'),
			_Utils_Tuple2('backepsilon', '϶'),
			_Utils_Tuple2('backprime', '‵'),
			_Utils_Tuple2('backsim', '∽'),
			_Utils_Tuple2('backsimeq', '⋍'),
			_Utils_Tuple2('Backslash', '∖'),
			_Utils_Tuple2('Barv', '⫧'),
			_Utils_Tuple2('barvee', '⊽'),
			_Utils_Tuple2('barwed', '⌅'),
			_Utils_Tuple2('Barwed', '⌆'),
			_Utils_Tuple2('barwedge', '⌅'),
			_Utils_Tuple2('bbrk', '⎵'),
			_Utils_Tuple2('bbrktbrk', '⎶'),
			_Utils_Tuple2('bcong', '≌'),
			_Utils_Tuple2('Bcy', 'Б'),
			_Utils_Tuple2('bcy', 'б'),
			_Utils_Tuple2('bdquo', '„'),
			_Utils_Tuple2('becaus', '∵'),
			_Utils_Tuple2('because', '∵'),
			_Utils_Tuple2('Because', '∵'),
			_Utils_Tuple2('bemptyv', '⦰'),
			_Utils_Tuple2('bepsi', '϶'),
			_Utils_Tuple2('bernou', 'ℬ'),
			_Utils_Tuple2('Bernoullis', 'ℬ'),
			_Utils_Tuple2('Beta', 'Β'),
			_Utils_Tuple2('beta', 'β'),
			_Utils_Tuple2('beth', 'ℶ'),
			_Utils_Tuple2('between', '≬'),
			_Utils_Tuple2('Bfr', '\uD835\uDD05'),
			_Utils_Tuple2('bfr', '\uD835\uDD1F'),
			_Utils_Tuple2('bigcap', '⋂'),
			_Utils_Tuple2('bigcirc', '◯'),
			_Utils_Tuple2('bigcup', '⋃'),
			_Utils_Tuple2('bigodot', '⨀'),
			_Utils_Tuple2('bigoplus', '⨁'),
			_Utils_Tuple2('bigotimes', '⨂'),
			_Utils_Tuple2('bigsqcup', '⨆'),
			_Utils_Tuple2('bigstar', '★'),
			_Utils_Tuple2('bigtriangledown', '▽'),
			_Utils_Tuple2('bigtriangleup', '△'),
			_Utils_Tuple2('biguplus', '⨄'),
			_Utils_Tuple2('bigvee', '⋁'),
			_Utils_Tuple2('bigwedge', '⋀'),
			_Utils_Tuple2('bkarow', '⤍'),
			_Utils_Tuple2('blacklozenge', '⧫'),
			_Utils_Tuple2('blacksquare', '▪'),
			_Utils_Tuple2('blacktriangle', '▴'),
			_Utils_Tuple2('blacktriangledown', '▾'),
			_Utils_Tuple2('blacktriangleleft', '◂'),
			_Utils_Tuple2('blacktriangleright', '▸'),
			_Utils_Tuple2('blank', '␣'),
			_Utils_Tuple2('blk12', '▒'),
			_Utils_Tuple2('blk14', '░'),
			_Utils_Tuple2('blk34', '▓'),
			_Utils_Tuple2('block', '█'),
			_Utils_Tuple2('bne', '=⃥'),
			_Utils_Tuple2('bnequiv', '≡⃥'),
			_Utils_Tuple2('bNot', '⫭'),
			_Utils_Tuple2('bnot', '⌐'),
			_Utils_Tuple2('Bopf', '\uD835\uDD39'),
			_Utils_Tuple2('bopf', '\uD835\uDD53'),
			_Utils_Tuple2('bot', '⊥'),
			_Utils_Tuple2('bottom', '⊥'),
			_Utils_Tuple2('bowtie', '⋈'),
			_Utils_Tuple2('boxbox', '⧉'),
			_Utils_Tuple2('boxdl', '┐'),
			_Utils_Tuple2('boxdL', '╕'),
			_Utils_Tuple2('boxDl', '╖'),
			_Utils_Tuple2('boxDL', '╗'),
			_Utils_Tuple2('boxdr', '┌'),
			_Utils_Tuple2('boxdR', '╒'),
			_Utils_Tuple2('boxDr', '╓'),
			_Utils_Tuple2('boxDR', '╔'),
			_Utils_Tuple2('boxh', '─'),
			_Utils_Tuple2('boxH', '═'),
			_Utils_Tuple2('boxhd', '┬'),
			_Utils_Tuple2('boxHd', '╤'),
			_Utils_Tuple2('boxhD', '╥'),
			_Utils_Tuple2('boxHD', '╦'),
			_Utils_Tuple2('boxhu', '┴'),
			_Utils_Tuple2('boxHu', '╧'),
			_Utils_Tuple2('boxhU', '╨'),
			_Utils_Tuple2('boxHU', '╩'),
			_Utils_Tuple2('boxminus', '⊟'),
			_Utils_Tuple2('boxplus', '⊞'),
			_Utils_Tuple2('boxtimes', '⊠'),
			_Utils_Tuple2('boxul', '┘'),
			_Utils_Tuple2('boxuL', '╛'),
			_Utils_Tuple2('boxUl', '╜'),
			_Utils_Tuple2('boxUL', '╝'),
			_Utils_Tuple2('boxur', '└'),
			_Utils_Tuple2('boxuR', '╘'),
			_Utils_Tuple2('boxUr', '╙'),
			_Utils_Tuple2('boxUR', '╚'),
			_Utils_Tuple2('boxv', '│'),
			_Utils_Tuple2('boxV', '║'),
			_Utils_Tuple2('boxvh', '┼'),
			_Utils_Tuple2('boxvH', '╪'),
			_Utils_Tuple2('boxVh', '╫'),
			_Utils_Tuple2('boxVH', '╬'),
			_Utils_Tuple2('boxvl', '┤'),
			_Utils_Tuple2('boxvL', '╡'),
			_Utils_Tuple2('boxVl', '╢'),
			_Utils_Tuple2('boxVL', '╣'),
			_Utils_Tuple2('boxvr', '├'),
			_Utils_Tuple2('boxvR', '╞'),
			_Utils_Tuple2('boxVr', '╟'),
			_Utils_Tuple2('boxVR', '╠'),
			_Utils_Tuple2('bprime', '‵'),
			_Utils_Tuple2('breve', '˘'),
			_Utils_Tuple2('Breve', '˘'),
			_Utils_Tuple2('brvbar', '¦'),
			_Utils_Tuple2('bscr', '\uD835\uDCB7'),
			_Utils_Tuple2('Bscr', 'ℬ'),
			_Utils_Tuple2('bsemi', '⁏'),
			_Utils_Tuple2('bsim', '∽'),
			_Utils_Tuple2('bsime', '⋍'),
			_Utils_Tuple2('bsolb', '⧅'),
			_Utils_Tuple2('bsol', '\\'),
			_Utils_Tuple2('bsolhsub', '⟈'),
			_Utils_Tuple2('bull', '•'),
			_Utils_Tuple2('bullet', '•'),
			_Utils_Tuple2('bump', '≎'),
			_Utils_Tuple2('bumpE', '⪮'),
			_Utils_Tuple2('bumpe', '≏'),
			_Utils_Tuple2('Bumpeq', '≎'),
			_Utils_Tuple2('bumpeq', '≏'),
			_Utils_Tuple2('Cacute', 'Ć'),
			_Utils_Tuple2('cacute', 'ć'),
			_Utils_Tuple2('capand', '⩄'),
			_Utils_Tuple2('capbrcup', '⩉'),
			_Utils_Tuple2('capcap', '⩋'),
			_Utils_Tuple2('cap', '∩'),
			_Utils_Tuple2('Cap', '⋒'),
			_Utils_Tuple2('capcup', '⩇'),
			_Utils_Tuple2('capdot', '⩀'),
			_Utils_Tuple2('CapitalDifferentialD', 'ⅅ'),
			_Utils_Tuple2('caps', '∩︀'),
			_Utils_Tuple2('caret', '⁁'),
			_Utils_Tuple2('caron', 'ˇ'),
			_Utils_Tuple2('Cayleys', 'ℭ'),
			_Utils_Tuple2('ccaps', '⩍'),
			_Utils_Tuple2('Ccaron', 'Č'),
			_Utils_Tuple2('ccaron', 'č'),
			_Utils_Tuple2('Ccedil', 'Ç'),
			_Utils_Tuple2('ccedil', 'ç'),
			_Utils_Tuple2('Ccirc', 'Ĉ'),
			_Utils_Tuple2('ccirc', 'ĉ'),
			_Utils_Tuple2('Cconint', '∰'),
			_Utils_Tuple2('ccups', '⩌'),
			_Utils_Tuple2('ccupssm', '⩐'),
			_Utils_Tuple2('Cdot', 'Ċ'),
			_Utils_Tuple2('cdot', 'ċ'),
			_Utils_Tuple2('cedil', '¸'),
			_Utils_Tuple2('Cedilla', '¸'),
			_Utils_Tuple2('cemptyv', '⦲'),
			_Utils_Tuple2('cent', '¢'),
			_Utils_Tuple2('centerdot', '·'),
			_Utils_Tuple2('CenterDot', '·'),
			_Utils_Tuple2('cfr', '\uD835\uDD20'),
			_Utils_Tuple2('Cfr', 'ℭ'),
			_Utils_Tuple2('CHcy', 'Ч'),
			_Utils_Tuple2('chcy', 'ч'),
			_Utils_Tuple2('check', '✓'),
			_Utils_Tuple2('checkmark', '✓'),
			_Utils_Tuple2('Chi', 'Χ'),
			_Utils_Tuple2('chi', 'χ'),
			_Utils_Tuple2('circ', 'ˆ'),
			_Utils_Tuple2('circeq', '≗'),
			_Utils_Tuple2('circlearrowleft', '↺'),
			_Utils_Tuple2('circlearrowright', '↻'),
			_Utils_Tuple2('circledast', '⊛'),
			_Utils_Tuple2('circledcirc', '⊚'),
			_Utils_Tuple2('circleddash', '⊝'),
			_Utils_Tuple2('CircleDot', '⊙'),
			_Utils_Tuple2('circledR', '®'),
			_Utils_Tuple2('circledS', 'Ⓢ'),
			_Utils_Tuple2('CircleMinus', '⊖'),
			_Utils_Tuple2('CirclePlus', '⊕'),
			_Utils_Tuple2('CircleTimes', '⊗'),
			_Utils_Tuple2('cir', '○'),
			_Utils_Tuple2('cirE', '⧃'),
			_Utils_Tuple2('cire', '≗'),
			_Utils_Tuple2('cirfnint', '⨐'),
			_Utils_Tuple2('cirmid', '⫯'),
			_Utils_Tuple2('cirscir', '⧂'),
			_Utils_Tuple2('ClockwiseContourIntegral', '∲'),
			_Utils_Tuple2('CloseCurlyDoubleQuote', '”'),
			_Utils_Tuple2('CloseCurlyQuote', '’'),
			_Utils_Tuple2('clubs', '♣'),
			_Utils_Tuple2('clubsuit', '♣'),
			_Utils_Tuple2('colon', ':'),
			_Utils_Tuple2('Colon', '∷'),
			_Utils_Tuple2('Colone', '⩴'),
			_Utils_Tuple2('colone', '≔'),
			_Utils_Tuple2('coloneq', '≔'),
			_Utils_Tuple2('comma', ','),
			_Utils_Tuple2('commat', '@'),
			_Utils_Tuple2('comp', '∁'),
			_Utils_Tuple2('compfn', '∘'),
			_Utils_Tuple2('complement', '∁'),
			_Utils_Tuple2('complexes', 'ℂ'),
			_Utils_Tuple2('cong', '≅'),
			_Utils_Tuple2('congdot', '⩭'),
			_Utils_Tuple2('Congruent', '≡'),
			_Utils_Tuple2('conint', '∮'),
			_Utils_Tuple2('Conint', '∯'),
			_Utils_Tuple2('ContourIntegral', '∮'),
			_Utils_Tuple2('copf', '\uD835\uDD54'),
			_Utils_Tuple2('Copf', 'ℂ'),
			_Utils_Tuple2('coprod', '∐'),
			_Utils_Tuple2('Coproduct', '∐'),
			_Utils_Tuple2('copy', '©'),
			_Utils_Tuple2('COPY', '©'),
			_Utils_Tuple2('copysr', '℗'),
			_Utils_Tuple2('CounterClockwiseContourIntegral', '∳'),
			_Utils_Tuple2('crarr', '↵'),
			_Utils_Tuple2('cross', '✗'),
			_Utils_Tuple2('Cross', '⨯'),
			_Utils_Tuple2('Cscr', '\uD835\uDC9E'),
			_Utils_Tuple2('cscr', '\uD835\uDCB8'),
			_Utils_Tuple2('csub', '⫏'),
			_Utils_Tuple2('csube', '⫑'),
			_Utils_Tuple2('csup', '⫐'),
			_Utils_Tuple2('csupe', '⫒'),
			_Utils_Tuple2('ctdot', '⋯'),
			_Utils_Tuple2('cudarrl', '⤸'),
			_Utils_Tuple2('cudarrr', '⤵'),
			_Utils_Tuple2('cuepr', '⋞'),
			_Utils_Tuple2('cuesc', '⋟'),
			_Utils_Tuple2('cularr', '↶'),
			_Utils_Tuple2('cularrp', '⤽'),
			_Utils_Tuple2('cupbrcap', '⩈'),
			_Utils_Tuple2('cupcap', '⩆'),
			_Utils_Tuple2('CupCap', '≍'),
			_Utils_Tuple2('cup', '∪'),
			_Utils_Tuple2('Cup', '⋓'),
			_Utils_Tuple2('cupcup', '⩊'),
			_Utils_Tuple2('cupdot', '⊍'),
			_Utils_Tuple2('cupor', '⩅'),
			_Utils_Tuple2('cups', '∪︀'),
			_Utils_Tuple2('curarr', '↷'),
			_Utils_Tuple2('curarrm', '⤼'),
			_Utils_Tuple2('curlyeqprec', '⋞'),
			_Utils_Tuple2('curlyeqsucc', '⋟'),
			_Utils_Tuple2('curlyvee', '⋎'),
			_Utils_Tuple2('curlywedge', '⋏'),
			_Utils_Tuple2('curren', '¤'),
			_Utils_Tuple2('curvearrowleft', '↶'),
			_Utils_Tuple2('curvearrowright', '↷'),
			_Utils_Tuple2('cuvee', '⋎'),
			_Utils_Tuple2('cuwed', '⋏'),
			_Utils_Tuple2('cwconint', '∲'),
			_Utils_Tuple2('cwint', '∱'),
			_Utils_Tuple2('cylcty', '⌭'),
			_Utils_Tuple2('dagger', '†'),
			_Utils_Tuple2('Dagger', '‡'),
			_Utils_Tuple2('daleth', 'ℸ'),
			_Utils_Tuple2('darr', '↓'),
			_Utils_Tuple2('Darr', '↡'),
			_Utils_Tuple2('dArr', '⇓'),
			_Utils_Tuple2('dash', '‐'),
			_Utils_Tuple2('Dashv', '⫤'),
			_Utils_Tuple2('dashv', '⊣'),
			_Utils_Tuple2('dbkarow', '⤏'),
			_Utils_Tuple2('dblac', '˝'),
			_Utils_Tuple2('Dcaron', 'Ď'),
			_Utils_Tuple2('dcaron', 'ď'),
			_Utils_Tuple2('Dcy', 'Д'),
			_Utils_Tuple2('dcy', 'д'),
			_Utils_Tuple2('ddagger', '‡'),
			_Utils_Tuple2('ddarr', '⇊'),
			_Utils_Tuple2('DD', 'ⅅ'),
			_Utils_Tuple2('dd', 'ⅆ'),
			_Utils_Tuple2('DDotrahd', '⤑'),
			_Utils_Tuple2('ddotseq', '⩷'),
			_Utils_Tuple2('deg', '°'),
			_Utils_Tuple2('Del', '∇'),
			_Utils_Tuple2('Delta', 'Δ'),
			_Utils_Tuple2('delta', 'δ'),
			_Utils_Tuple2('demptyv', '⦱'),
			_Utils_Tuple2('dfisht', '⥿'),
			_Utils_Tuple2('Dfr', '\uD835\uDD07'),
			_Utils_Tuple2('dfr', '\uD835\uDD21'),
			_Utils_Tuple2('dHar', '⥥'),
			_Utils_Tuple2('dharl', '⇃'),
			_Utils_Tuple2('dharr', '⇂'),
			_Utils_Tuple2('DiacriticalAcute', '´'),
			_Utils_Tuple2('DiacriticalDot', '˙'),
			_Utils_Tuple2('DiacriticalDoubleAcute', '˝'),
			_Utils_Tuple2('DiacriticalGrave', '`'),
			_Utils_Tuple2('DiacriticalTilde', '˜'),
			_Utils_Tuple2('diam', '⋄'),
			_Utils_Tuple2('diamond', '⋄'),
			_Utils_Tuple2('Diamond', '⋄'),
			_Utils_Tuple2('diamondsuit', '♦'),
			_Utils_Tuple2('diams', '♦'),
			_Utils_Tuple2('die', '¨'),
			_Utils_Tuple2('DifferentialD', 'ⅆ'),
			_Utils_Tuple2('digamma', 'ϝ'),
			_Utils_Tuple2('disin', '⋲'),
			_Utils_Tuple2('div', '÷'),
			_Utils_Tuple2('divide', '÷'),
			_Utils_Tuple2('divideontimes', '⋇'),
			_Utils_Tuple2('divonx', '⋇'),
			_Utils_Tuple2('DJcy', 'Ђ'),
			_Utils_Tuple2('djcy', 'ђ'),
			_Utils_Tuple2('dlcorn', '⌞'),
			_Utils_Tuple2('dlcrop', '⌍'),
			_Utils_Tuple2('dollar', '$'),
			_Utils_Tuple2('Dopf', '\uD835\uDD3B'),
			_Utils_Tuple2('dopf', '\uD835\uDD55'),
			_Utils_Tuple2('Dot', '¨'),
			_Utils_Tuple2('dot', '˙'),
			_Utils_Tuple2('DotDot', '⃜'),
			_Utils_Tuple2('doteq', '≐'),
			_Utils_Tuple2('doteqdot', '≑'),
			_Utils_Tuple2('DotEqual', '≐'),
			_Utils_Tuple2('dotminus', '∸'),
			_Utils_Tuple2('dotplus', '∔'),
			_Utils_Tuple2('dotsquare', '⊡'),
			_Utils_Tuple2('doublebarwedge', '⌆'),
			_Utils_Tuple2('DoubleContourIntegral', '∯'),
			_Utils_Tuple2('DoubleDot', '¨'),
			_Utils_Tuple2('DoubleDownArrow', '⇓'),
			_Utils_Tuple2('DoubleLeftArrow', '⇐'),
			_Utils_Tuple2('DoubleLeftRightArrow', '⇔'),
			_Utils_Tuple2('DoubleLeftTee', '⫤'),
			_Utils_Tuple2('DoubleLongLeftArrow', '⟸'),
			_Utils_Tuple2('DoubleLongLeftRightArrow', '⟺'),
			_Utils_Tuple2('DoubleLongRightArrow', '⟹'),
			_Utils_Tuple2('DoubleRightArrow', '⇒'),
			_Utils_Tuple2('DoubleRightTee', '⊨'),
			_Utils_Tuple2('DoubleUpArrow', '⇑'),
			_Utils_Tuple2('DoubleUpDownArrow', '⇕'),
			_Utils_Tuple2('DoubleVerticalBar', '∥'),
			_Utils_Tuple2('DownArrowBar', '⤓'),
			_Utils_Tuple2('downarrow', '↓'),
			_Utils_Tuple2('DownArrow', '↓'),
			_Utils_Tuple2('Downarrow', '⇓'),
			_Utils_Tuple2('DownArrowUpArrow', '⇵'),
			_Utils_Tuple2('DownBreve', '̑'),
			_Utils_Tuple2('downdownarrows', '⇊'),
			_Utils_Tuple2('downharpoonleft', '⇃'),
			_Utils_Tuple2('downharpoonright', '⇂'),
			_Utils_Tuple2('DownLeftRightVector', '⥐'),
			_Utils_Tuple2('DownLeftTeeVector', '⥞'),
			_Utils_Tuple2('DownLeftVectorBar', '⥖'),
			_Utils_Tuple2('DownLeftVector', '↽'),
			_Utils_Tuple2('DownRightTeeVector', '⥟'),
			_Utils_Tuple2('DownRightVectorBar', '⥗'),
			_Utils_Tuple2('DownRightVector', '⇁'),
			_Utils_Tuple2('DownTeeArrow', '↧'),
			_Utils_Tuple2('DownTee', '⊤'),
			_Utils_Tuple2('drbkarow', '⤐'),
			_Utils_Tuple2('drcorn', '⌟'),
			_Utils_Tuple2('drcrop', '⌌'),
			_Utils_Tuple2('Dscr', '\uD835\uDC9F'),
			_Utils_Tuple2('dscr', '\uD835\uDCB9'),
			_Utils_Tuple2('DScy', 'Ѕ'),
			_Utils_Tuple2('dscy', 'ѕ'),
			_Utils_Tuple2('dsol', '⧶'),
			_Utils_Tuple2('Dstrok', 'Đ'),
			_Utils_Tuple2('dstrok', 'đ'),
			_Utils_Tuple2('dtdot', '⋱'),
			_Utils_Tuple2('dtri', '▿'),
			_Utils_Tuple2('dtrif', '▾'),
			_Utils_Tuple2('duarr', '⇵'),
			_Utils_Tuple2('duhar', '⥯'),
			_Utils_Tuple2('dwangle', '⦦'),
			_Utils_Tuple2('DZcy', 'Џ'),
			_Utils_Tuple2('dzcy', 'џ'),
			_Utils_Tuple2('dzigrarr', '⟿'),
			_Utils_Tuple2('Eacute', 'É'),
			_Utils_Tuple2('eacute', 'é'),
			_Utils_Tuple2('easter', '⩮'),
			_Utils_Tuple2('Ecaron', 'Ě'),
			_Utils_Tuple2('ecaron', 'ě'),
			_Utils_Tuple2('Ecirc', 'Ê'),
			_Utils_Tuple2('ecirc', 'ê'),
			_Utils_Tuple2('ecir', '≖'),
			_Utils_Tuple2('ecolon', '≕'),
			_Utils_Tuple2('Ecy', 'Э'),
			_Utils_Tuple2('ecy', 'э'),
			_Utils_Tuple2('eDDot', '⩷'),
			_Utils_Tuple2('Edot', 'Ė'),
			_Utils_Tuple2('edot', 'ė'),
			_Utils_Tuple2('eDot', '≑'),
			_Utils_Tuple2('ee', 'ⅇ'),
			_Utils_Tuple2('efDot', '≒'),
			_Utils_Tuple2('Efr', '\uD835\uDD08'),
			_Utils_Tuple2('efr', '\uD835\uDD22'),
			_Utils_Tuple2('eg', '⪚'),
			_Utils_Tuple2('Egrave', 'È'),
			_Utils_Tuple2('egrave', 'è'),
			_Utils_Tuple2('egs', '⪖'),
			_Utils_Tuple2('egsdot', '⪘'),
			_Utils_Tuple2('el', '⪙'),
			_Utils_Tuple2('Element', '∈'),
			_Utils_Tuple2('elinters', '⏧'),
			_Utils_Tuple2('ell', 'ℓ'),
			_Utils_Tuple2('els', '⪕'),
			_Utils_Tuple2('elsdot', '⪗'),
			_Utils_Tuple2('Emacr', 'Ē'),
			_Utils_Tuple2('emacr', 'ē'),
			_Utils_Tuple2('empty', '∅'),
			_Utils_Tuple2('emptyset', '∅'),
			_Utils_Tuple2('EmptySmallSquare', '◻'),
			_Utils_Tuple2('emptyv', '∅'),
			_Utils_Tuple2('EmptyVerySmallSquare', '▫'),
			_Utils_Tuple2('emsp13', '\u2004'),
			_Utils_Tuple2('emsp14', '\u2005'),
			_Utils_Tuple2('emsp', '\u2003'),
			_Utils_Tuple2('ENG', 'Ŋ'),
			_Utils_Tuple2('eng', 'ŋ'),
			_Utils_Tuple2('ensp', '\u2002'),
			_Utils_Tuple2('Eogon', 'Ę'),
			_Utils_Tuple2('eogon', 'ę'),
			_Utils_Tuple2('Eopf', '\uD835\uDD3C'),
			_Utils_Tuple2('eopf', '\uD835\uDD56'),
			_Utils_Tuple2('epar', '⋕'),
			_Utils_Tuple2('eparsl', '⧣'),
			_Utils_Tuple2('eplus', '⩱'),
			_Utils_Tuple2('epsi', 'ε'),
			_Utils_Tuple2('Epsilon', 'Ε'),
			_Utils_Tuple2('epsilon', 'ε'),
			_Utils_Tuple2('epsiv', 'ϵ'),
			_Utils_Tuple2('eqcirc', '≖'),
			_Utils_Tuple2('eqcolon', '≕'),
			_Utils_Tuple2('eqsim', '≂'),
			_Utils_Tuple2('eqslantgtr', '⪖'),
			_Utils_Tuple2('eqslantless', '⪕'),
			_Utils_Tuple2('Equal', '⩵'),
			_Utils_Tuple2('equals', '='),
			_Utils_Tuple2('EqualTilde', '≂'),
			_Utils_Tuple2('equest', '≟'),
			_Utils_Tuple2('Equilibrium', '⇌'),
			_Utils_Tuple2('equiv', '≡'),
			_Utils_Tuple2('equivDD', '⩸'),
			_Utils_Tuple2('eqvparsl', '⧥'),
			_Utils_Tuple2('erarr', '⥱'),
			_Utils_Tuple2('erDot', '≓'),
			_Utils_Tuple2('escr', 'ℯ'),
			_Utils_Tuple2('Escr', 'ℰ'),
			_Utils_Tuple2('esdot', '≐'),
			_Utils_Tuple2('Esim', '⩳'),
			_Utils_Tuple2('esim', '≂'),
			_Utils_Tuple2('Eta', 'Η'),
			_Utils_Tuple2('eta', 'η'),
			_Utils_Tuple2('ETH', 'Ð'),
			_Utils_Tuple2('eth', 'ð'),
			_Utils_Tuple2('Euml', 'Ë'),
			_Utils_Tuple2('euml', 'ë'),
			_Utils_Tuple2('euro', '€'),
			_Utils_Tuple2('excl', '!'),
			_Utils_Tuple2('exist', '∃'),
			_Utils_Tuple2('Exists', '∃'),
			_Utils_Tuple2('expectation', 'ℰ'),
			_Utils_Tuple2('exponentiale', 'ⅇ'),
			_Utils_Tuple2('ExponentialE', 'ⅇ'),
			_Utils_Tuple2('fallingdotseq', '≒'),
			_Utils_Tuple2('Fcy', 'Ф'),
			_Utils_Tuple2('fcy', 'ф'),
			_Utils_Tuple2('female', '♀'),
			_Utils_Tuple2('ffilig', 'ﬃ'),
			_Utils_Tuple2('fflig', 'ﬀ'),
			_Utils_Tuple2('ffllig', 'ﬄ'),
			_Utils_Tuple2('Ffr', '\uD835\uDD09'),
			_Utils_Tuple2('ffr', '\uD835\uDD23'),
			_Utils_Tuple2('filig', 'ﬁ'),
			_Utils_Tuple2('FilledSmallSquare', '◼'),
			_Utils_Tuple2('FilledVerySmallSquare', '▪'),
			_Utils_Tuple2('fjlig', 'fj'),
			_Utils_Tuple2('flat', '♭'),
			_Utils_Tuple2('fllig', 'ﬂ'),
			_Utils_Tuple2('fltns', '▱'),
			_Utils_Tuple2('fnof', 'ƒ'),
			_Utils_Tuple2('Fopf', '\uD835\uDD3D'),
			_Utils_Tuple2('fopf', '\uD835\uDD57'),
			_Utils_Tuple2('forall', '∀'),
			_Utils_Tuple2('ForAll', '∀'),
			_Utils_Tuple2('fork', '⋔'),
			_Utils_Tuple2('forkv', '⫙'),
			_Utils_Tuple2('Fouriertrf', 'ℱ'),
			_Utils_Tuple2('fpartint', '⨍'),
			_Utils_Tuple2('frac12', '½'),
			_Utils_Tuple2('frac13', '⅓'),
			_Utils_Tuple2('frac14', '¼'),
			_Utils_Tuple2('frac15', '⅕'),
			_Utils_Tuple2('frac16', '⅙'),
			_Utils_Tuple2('frac18', '⅛'),
			_Utils_Tuple2('frac23', '⅔'),
			_Utils_Tuple2('frac25', '⅖'),
			_Utils_Tuple2('frac34', '¾'),
			_Utils_Tuple2('frac35', '⅗'),
			_Utils_Tuple2('frac38', '⅜'),
			_Utils_Tuple2('frac45', '⅘'),
			_Utils_Tuple2('frac56', '⅚'),
			_Utils_Tuple2('frac58', '⅝'),
			_Utils_Tuple2('frac78', '⅞'),
			_Utils_Tuple2('frasl', '⁄'),
			_Utils_Tuple2('frown', '⌢'),
			_Utils_Tuple2('fscr', '\uD835\uDCBB'),
			_Utils_Tuple2('Fscr', 'ℱ'),
			_Utils_Tuple2('gacute', 'ǵ'),
			_Utils_Tuple2('Gamma', 'Γ'),
			_Utils_Tuple2('gamma', 'γ'),
			_Utils_Tuple2('Gammad', 'Ϝ'),
			_Utils_Tuple2('gammad', 'ϝ'),
			_Utils_Tuple2('gap', '⪆'),
			_Utils_Tuple2('Gbreve', 'Ğ'),
			_Utils_Tuple2('gbreve', 'ğ'),
			_Utils_Tuple2('Gcedil', 'Ģ'),
			_Utils_Tuple2('Gcirc', 'Ĝ'),
			_Utils_Tuple2('gcirc', 'ĝ'),
			_Utils_Tuple2('Gcy', 'Г'),
			_Utils_Tuple2('gcy', 'г'),
			_Utils_Tuple2('Gdot', 'Ġ'),
			_Utils_Tuple2('gdot', 'ġ'),
			_Utils_Tuple2('ge', '≥'),
			_Utils_Tuple2('gE', '≧'),
			_Utils_Tuple2('gEl', '⪌'),
			_Utils_Tuple2('gel', '⋛'),
			_Utils_Tuple2('geq', '≥'),
			_Utils_Tuple2('geqq', '≧'),
			_Utils_Tuple2('geqslant', '⩾'),
			_Utils_Tuple2('gescc', '⪩'),
			_Utils_Tuple2('ges', '⩾'),
			_Utils_Tuple2('gesdot', '⪀'),
			_Utils_Tuple2('gesdoto', '⪂'),
			_Utils_Tuple2('gesdotol', '⪄'),
			_Utils_Tuple2('gesl', '⋛︀'),
			_Utils_Tuple2('gesles', '⪔'),
			_Utils_Tuple2('Gfr', '\uD835\uDD0A'),
			_Utils_Tuple2('gfr', '\uD835\uDD24'),
			_Utils_Tuple2('gg', '≫'),
			_Utils_Tuple2('Gg', '⋙'),
			_Utils_Tuple2('ggg', '⋙'),
			_Utils_Tuple2('gimel', 'ℷ'),
			_Utils_Tuple2('GJcy', 'Ѓ'),
			_Utils_Tuple2('gjcy', 'ѓ'),
			_Utils_Tuple2('gla', '⪥'),
			_Utils_Tuple2('gl', '≷'),
			_Utils_Tuple2('glE', '⪒'),
			_Utils_Tuple2('glj', '⪤'),
			_Utils_Tuple2('gnap', '⪊'),
			_Utils_Tuple2('gnapprox', '⪊'),
			_Utils_Tuple2('gne', '⪈'),
			_Utils_Tuple2('gnE', '≩'),
			_Utils_Tuple2('gneq', '⪈'),
			_Utils_Tuple2('gneqq', '≩'),
			_Utils_Tuple2('gnsim', '⋧'),
			_Utils_Tuple2('Gopf', '\uD835\uDD3E'),
			_Utils_Tuple2('gopf', '\uD835\uDD58'),
			_Utils_Tuple2('grave', '`'),
			_Utils_Tuple2('GreaterEqual', '≥'),
			_Utils_Tuple2('GreaterEqualLess', '⋛'),
			_Utils_Tuple2('GreaterFullEqual', '≧'),
			_Utils_Tuple2('GreaterGreater', '⪢'),
			_Utils_Tuple2('GreaterLess', '≷'),
			_Utils_Tuple2('GreaterSlantEqual', '⩾'),
			_Utils_Tuple2('GreaterTilde', '≳'),
			_Utils_Tuple2('Gscr', '\uD835\uDCA2'),
			_Utils_Tuple2('gscr', 'ℊ'),
			_Utils_Tuple2('gsim', '≳'),
			_Utils_Tuple2('gsime', '⪎'),
			_Utils_Tuple2('gsiml', '⪐'),
			_Utils_Tuple2('gtcc', '⪧'),
			_Utils_Tuple2('gtcir', '⩺'),
			_Utils_Tuple2('gt', '>'),
			_Utils_Tuple2('GT', '>'),
			_Utils_Tuple2('Gt', '≫'),
			_Utils_Tuple2('gtdot', '⋗'),
			_Utils_Tuple2('gtlPar', '⦕'),
			_Utils_Tuple2('gtquest', '⩼'),
			_Utils_Tuple2('gtrapprox', '⪆'),
			_Utils_Tuple2('gtrarr', '⥸'),
			_Utils_Tuple2('gtrdot', '⋗'),
			_Utils_Tuple2('gtreqless', '⋛'),
			_Utils_Tuple2('gtreqqless', '⪌'),
			_Utils_Tuple2('gtrless', '≷'),
			_Utils_Tuple2('gtrsim', '≳'),
			_Utils_Tuple2('gvertneqq', '≩︀'),
			_Utils_Tuple2('gvnE', '≩︀'),
			_Utils_Tuple2('Hacek', 'ˇ'),
			_Utils_Tuple2('hairsp', '\u200A'),
			_Utils_Tuple2('half', '½'),
			_Utils_Tuple2('hamilt', 'ℋ'),
			_Utils_Tuple2('HARDcy', 'Ъ'),
			_Utils_Tuple2('hardcy', 'ъ'),
			_Utils_Tuple2('harrcir', '⥈'),
			_Utils_Tuple2('harr', '↔'),
			_Utils_Tuple2('hArr', '⇔'),
			_Utils_Tuple2('harrw', '↭'),
			_Utils_Tuple2('Hat', '^'),
			_Utils_Tuple2('hbar', 'ℏ'),
			_Utils_Tuple2('Hcirc', 'Ĥ'),
			_Utils_Tuple2('hcirc', 'ĥ'),
			_Utils_Tuple2('hearts', '♥'),
			_Utils_Tuple2('heartsuit', '♥'),
			_Utils_Tuple2('hellip', '…'),
			_Utils_Tuple2('hercon', '⊹'),
			_Utils_Tuple2('hfr', '\uD835\uDD25'),
			_Utils_Tuple2('Hfr', 'ℌ'),
			_Utils_Tuple2('HilbertSpace', 'ℋ'),
			_Utils_Tuple2('hksearow', '⤥'),
			_Utils_Tuple2('hkswarow', '⤦'),
			_Utils_Tuple2('hoarr', '⇿'),
			_Utils_Tuple2('homtht', '∻'),
			_Utils_Tuple2('hookleftarrow', '↩'),
			_Utils_Tuple2('hookrightarrow', '↪'),
			_Utils_Tuple2('hopf', '\uD835\uDD59'),
			_Utils_Tuple2('Hopf', 'ℍ'),
			_Utils_Tuple2('horbar', '―'),
			_Utils_Tuple2('HorizontalLine', '─'),
			_Utils_Tuple2('hscr', '\uD835\uDCBD'),
			_Utils_Tuple2('Hscr', 'ℋ'),
			_Utils_Tuple2('hslash', 'ℏ'),
			_Utils_Tuple2('Hstrok', 'Ħ'),
			_Utils_Tuple2('hstrok', 'ħ'),
			_Utils_Tuple2('HumpDownHump', '≎'),
			_Utils_Tuple2('HumpEqual', '≏'),
			_Utils_Tuple2('hybull', '⁃'),
			_Utils_Tuple2('hyphen', '‐'),
			_Utils_Tuple2('Iacute', 'Í'),
			_Utils_Tuple2('iacute', 'í'),
			_Utils_Tuple2('ic', '\u2063'),
			_Utils_Tuple2('Icirc', 'Î'),
			_Utils_Tuple2('icirc', 'î'),
			_Utils_Tuple2('Icy', 'И'),
			_Utils_Tuple2('icy', 'и'),
			_Utils_Tuple2('Idot', 'İ'),
			_Utils_Tuple2('IEcy', 'Е'),
			_Utils_Tuple2('iecy', 'е'),
			_Utils_Tuple2('iexcl', '¡'),
			_Utils_Tuple2('iff', '⇔'),
			_Utils_Tuple2('ifr', '\uD835\uDD26'),
			_Utils_Tuple2('Ifr', 'ℑ'),
			_Utils_Tuple2('Igrave', 'Ì'),
			_Utils_Tuple2('igrave', 'ì'),
			_Utils_Tuple2('ii', 'ⅈ'),
			_Utils_Tuple2('iiiint', '⨌'),
			_Utils_Tuple2('iiint', '∭'),
			_Utils_Tuple2('iinfin', '⧜'),
			_Utils_Tuple2('iiota', '℩'),
			_Utils_Tuple2('IJlig', 'Ĳ'),
			_Utils_Tuple2('ijlig', 'ĳ'),
			_Utils_Tuple2('Imacr', 'Ī'),
			_Utils_Tuple2('imacr', 'ī'),
			_Utils_Tuple2('image', 'ℑ'),
			_Utils_Tuple2('ImaginaryI', 'ⅈ'),
			_Utils_Tuple2('imagline', 'ℐ'),
			_Utils_Tuple2('imagpart', 'ℑ'),
			_Utils_Tuple2('imath', 'ı'),
			_Utils_Tuple2('Im', 'ℑ'),
			_Utils_Tuple2('imof', '⊷'),
			_Utils_Tuple2('imped', 'Ƶ'),
			_Utils_Tuple2('Implies', '⇒'),
			_Utils_Tuple2('incare', '℅'),
			_Utils_Tuple2('in', '∈'),
			_Utils_Tuple2('infin', '∞'),
			_Utils_Tuple2('infintie', '⧝'),
			_Utils_Tuple2('inodot', 'ı'),
			_Utils_Tuple2('intcal', '⊺'),
			_Utils_Tuple2('int', '∫'),
			_Utils_Tuple2('Int', '∬'),
			_Utils_Tuple2('integers', 'ℤ'),
			_Utils_Tuple2('Integral', '∫'),
			_Utils_Tuple2('intercal', '⊺'),
			_Utils_Tuple2('Intersection', '⋂'),
			_Utils_Tuple2('intlarhk', '⨗'),
			_Utils_Tuple2('intprod', '⨼'),
			_Utils_Tuple2('InvisibleComma', '\u2063'),
			_Utils_Tuple2('InvisibleTimes', '\u2062'),
			_Utils_Tuple2('IOcy', 'Ё'),
			_Utils_Tuple2('iocy', 'ё'),
			_Utils_Tuple2('Iogon', 'Į'),
			_Utils_Tuple2('iogon', 'į'),
			_Utils_Tuple2('Iopf', '\uD835\uDD40'),
			_Utils_Tuple2('iopf', '\uD835\uDD5A'),
			_Utils_Tuple2('Iota', 'Ι'),
			_Utils_Tuple2('iota', 'ι'),
			_Utils_Tuple2('iprod', '⨼'),
			_Utils_Tuple2('iquest', '¿'),
			_Utils_Tuple2('iscr', '\uD835\uDCBE'),
			_Utils_Tuple2('Iscr', 'ℐ'),
			_Utils_Tuple2('isin', '∈'),
			_Utils_Tuple2('isindot', '⋵'),
			_Utils_Tuple2('isinE', '⋹'),
			_Utils_Tuple2('isins', '⋴'),
			_Utils_Tuple2('isinsv', '⋳'),
			_Utils_Tuple2('isinv', '∈'),
			_Utils_Tuple2('it', '\u2062'),
			_Utils_Tuple2('Itilde', 'Ĩ'),
			_Utils_Tuple2('itilde', 'ĩ'),
			_Utils_Tuple2('Iukcy', 'І'),
			_Utils_Tuple2('iukcy', 'і'),
			_Utils_Tuple2('Iuml', 'Ï'),
			_Utils_Tuple2('iuml', 'ï'),
			_Utils_Tuple2('Jcirc', 'Ĵ'),
			_Utils_Tuple2('jcirc', 'ĵ'),
			_Utils_Tuple2('Jcy', 'Й'),
			_Utils_Tuple2('jcy', 'й'),
			_Utils_Tuple2('Jfr', '\uD835\uDD0D'),
			_Utils_Tuple2('jfr', '\uD835\uDD27'),
			_Utils_Tuple2('jmath', 'ȷ'),
			_Utils_Tuple2('Jopf', '\uD835\uDD41'),
			_Utils_Tuple2('jopf', '\uD835\uDD5B'),
			_Utils_Tuple2('Jscr', '\uD835\uDCA5'),
			_Utils_Tuple2('jscr', '\uD835\uDCBF'),
			_Utils_Tuple2('Jsercy', 'Ј'),
			_Utils_Tuple2('jsercy', 'ј'),
			_Utils_Tuple2('Jukcy', 'Є'),
			_Utils_Tuple2('jukcy', 'є'),
			_Utils_Tuple2('Kappa', 'Κ'),
			_Utils_Tuple2('kappa', 'κ'),
			_Utils_Tuple2('kappav', 'ϰ'),
			_Utils_Tuple2('Kcedil', 'Ķ'),
			_Utils_Tuple2('kcedil', 'ķ'),
			_Utils_Tuple2('Kcy', 'К'),
			_Utils_Tuple2('kcy', 'к'),
			_Utils_Tuple2('Kfr', '\uD835\uDD0E'),
			_Utils_Tuple2('kfr', '\uD835\uDD28'),
			_Utils_Tuple2('kgreen', 'ĸ'),
			_Utils_Tuple2('KHcy', 'Х'),
			_Utils_Tuple2('khcy', 'х'),
			_Utils_Tuple2('KJcy', 'Ќ'),
			_Utils_Tuple2('kjcy', 'ќ'),
			_Utils_Tuple2('Kopf', '\uD835\uDD42'),
			_Utils_Tuple2('kopf', '\uD835\uDD5C'),
			_Utils_Tuple2('Kscr', '\uD835\uDCA6'),
			_Utils_Tuple2('kscr', '\uD835\uDCC0'),
			_Utils_Tuple2('lAarr', '⇚'),
			_Utils_Tuple2('Lacute', 'Ĺ'),
			_Utils_Tuple2('lacute', 'ĺ'),
			_Utils_Tuple2('laemptyv', '⦴'),
			_Utils_Tuple2('lagran', 'ℒ'),
			_Utils_Tuple2('Lambda', 'Λ'),
			_Utils_Tuple2('lambda', 'λ'),
			_Utils_Tuple2('lang', '⟨'),
			_Utils_Tuple2('Lang', '⟪'),
			_Utils_Tuple2('langd', '⦑'),
			_Utils_Tuple2('langle', '⟨'),
			_Utils_Tuple2('lap', '⪅'),
			_Utils_Tuple2('Laplacetrf', 'ℒ'),
			_Utils_Tuple2('laquo', '«'),
			_Utils_Tuple2('larrb', '⇤'),
			_Utils_Tuple2('larrbfs', '⤟'),
			_Utils_Tuple2('larr', '←'),
			_Utils_Tuple2('Larr', '↞'),
			_Utils_Tuple2('lArr', '⇐'),
			_Utils_Tuple2('larrfs', '⤝'),
			_Utils_Tuple2('larrhk', '↩'),
			_Utils_Tuple2('larrlp', '↫'),
			_Utils_Tuple2('larrpl', '⤹'),
			_Utils_Tuple2('larrsim', '⥳'),
			_Utils_Tuple2('larrtl', '↢'),
			_Utils_Tuple2('latail', '⤙'),
			_Utils_Tuple2('lAtail', '⤛'),
			_Utils_Tuple2('lat', '⪫'),
			_Utils_Tuple2('late', '⪭'),
			_Utils_Tuple2('lates', '⪭︀'),
			_Utils_Tuple2('lbarr', '⤌'),
			_Utils_Tuple2('lBarr', '⤎'),
			_Utils_Tuple2('lbbrk', '❲'),
			_Utils_Tuple2('lbrace', '{'),
			_Utils_Tuple2('lbrack', '['),
			_Utils_Tuple2('lbrke', '⦋'),
			_Utils_Tuple2('lbrksld', '⦏'),
			_Utils_Tuple2('lbrkslu', '⦍'),
			_Utils_Tuple2('Lcaron', 'Ľ'),
			_Utils_Tuple2('lcaron', 'ľ'),
			_Utils_Tuple2('Lcedil', 'Ļ'),
			_Utils_Tuple2('lcedil', 'ļ'),
			_Utils_Tuple2('lceil', '⌈'),
			_Utils_Tuple2('lcub', '{'),
			_Utils_Tuple2('Lcy', 'Л'),
			_Utils_Tuple2('lcy', 'л'),
			_Utils_Tuple2('ldca', '⤶'),
			_Utils_Tuple2('ldquo', '“'),
			_Utils_Tuple2('ldquor', '„'),
			_Utils_Tuple2('ldrdhar', '⥧'),
			_Utils_Tuple2('ldrushar', '⥋'),
			_Utils_Tuple2('ldsh', '↲'),
			_Utils_Tuple2('le', '≤'),
			_Utils_Tuple2('lE', '≦'),
			_Utils_Tuple2('LeftAngleBracket', '⟨'),
			_Utils_Tuple2('LeftArrowBar', '⇤'),
			_Utils_Tuple2('leftarrow', '←'),
			_Utils_Tuple2('LeftArrow', '←'),
			_Utils_Tuple2('Leftarrow', '⇐'),
			_Utils_Tuple2('LeftArrowRightArrow', '⇆'),
			_Utils_Tuple2('leftarrowtail', '↢'),
			_Utils_Tuple2('LeftCeiling', '⌈'),
			_Utils_Tuple2('LeftDoubleBracket', '⟦'),
			_Utils_Tuple2('LeftDownTeeVector', '⥡'),
			_Utils_Tuple2('LeftDownVectorBar', '⥙'),
			_Utils_Tuple2('LeftDownVector', '⇃'),
			_Utils_Tuple2('LeftFloor', '⌊'),
			_Utils_Tuple2('leftharpoondown', '↽'),
			_Utils_Tuple2('leftharpoonup', '↼'),
			_Utils_Tuple2('leftleftarrows', '⇇'),
			_Utils_Tuple2('leftrightarrow', '↔'),
			_Utils_Tuple2('LeftRightArrow', '↔'),
			_Utils_Tuple2('Leftrightarrow', '⇔'),
			_Utils_Tuple2('leftrightarrows', '⇆'),
			_Utils_Tuple2('leftrightharpoons', '⇋'),
			_Utils_Tuple2('leftrightsquigarrow', '↭'),
			_Utils_Tuple2('LeftRightVector', '⥎'),
			_Utils_Tuple2('LeftTeeArrow', '↤'),
			_Utils_Tuple2('LeftTee', '⊣'),
			_Utils_Tuple2('LeftTeeVector', '⥚'),
			_Utils_Tuple2('leftthreetimes', '⋋'),
			_Utils_Tuple2('LeftTriangleBar', '⧏'),
			_Utils_Tuple2('LeftTriangle', '⊲'),
			_Utils_Tuple2('LeftTriangleEqual', '⊴'),
			_Utils_Tuple2('LeftUpDownVector', '⥑'),
			_Utils_Tuple2('LeftUpTeeVector', '⥠'),
			_Utils_Tuple2('LeftUpVectorBar', '⥘'),
			_Utils_Tuple2('LeftUpVector', '↿'),
			_Utils_Tuple2('LeftVectorBar', '⥒'),
			_Utils_Tuple2('LeftVector', '↼'),
			_Utils_Tuple2('lEg', '⪋'),
			_Utils_Tuple2('leg', '⋚'),
			_Utils_Tuple2('leq', '≤'),
			_Utils_Tuple2('leqq', '≦'),
			_Utils_Tuple2('leqslant', '⩽'),
			_Utils_Tuple2('lescc', '⪨'),
			_Utils_Tuple2('les', '⩽'),
			_Utils_Tuple2('lesdot', '⩿'),
			_Utils_Tuple2('lesdoto', '⪁'),
			_Utils_Tuple2('lesdotor', '⪃'),
			_Utils_Tuple2('lesg', '⋚︀'),
			_Utils_Tuple2('lesges', '⪓'),
			_Utils_Tuple2('lessapprox', '⪅'),
			_Utils_Tuple2('lessdot', '⋖'),
			_Utils_Tuple2('lesseqgtr', '⋚'),
			_Utils_Tuple2('lesseqqgtr', '⪋'),
			_Utils_Tuple2('LessEqualGreater', '⋚'),
			_Utils_Tuple2('LessFullEqual', '≦'),
			_Utils_Tuple2('LessGreater', '≶'),
			_Utils_Tuple2('lessgtr', '≶'),
			_Utils_Tuple2('LessLess', '⪡'),
			_Utils_Tuple2('lesssim', '≲'),
			_Utils_Tuple2('LessSlantEqual', '⩽'),
			_Utils_Tuple2('LessTilde', '≲'),
			_Utils_Tuple2('lfisht', '⥼'),
			_Utils_Tuple2('lfloor', '⌊'),
			_Utils_Tuple2('Lfr', '\uD835\uDD0F'),
			_Utils_Tuple2('lfr', '\uD835\uDD29'),
			_Utils_Tuple2('lg', '≶'),
			_Utils_Tuple2('lgE', '⪑'),
			_Utils_Tuple2('lHar', '⥢'),
			_Utils_Tuple2('lhard', '↽'),
			_Utils_Tuple2('lharu', '↼'),
			_Utils_Tuple2('lharul', '⥪'),
			_Utils_Tuple2('lhblk', '▄'),
			_Utils_Tuple2('LJcy', 'Љ'),
			_Utils_Tuple2('ljcy', 'љ'),
			_Utils_Tuple2('llarr', '⇇'),
			_Utils_Tuple2('ll', '≪'),
			_Utils_Tuple2('Ll', '⋘'),
			_Utils_Tuple2('llcorner', '⌞'),
			_Utils_Tuple2('Lleftarrow', '⇚'),
			_Utils_Tuple2('llhard', '⥫'),
			_Utils_Tuple2('lltri', '◺'),
			_Utils_Tuple2('Lmidot', 'Ŀ'),
			_Utils_Tuple2('lmidot', 'ŀ'),
			_Utils_Tuple2('lmoustache', '⎰'),
			_Utils_Tuple2('lmoust', '⎰'),
			_Utils_Tuple2('lnap', '⪉'),
			_Utils_Tuple2('lnapprox', '⪉'),
			_Utils_Tuple2('lne', '⪇'),
			_Utils_Tuple2('lnE', '≨'),
			_Utils_Tuple2('lneq', '⪇'),
			_Utils_Tuple2('lneqq', '≨'),
			_Utils_Tuple2('lnsim', '⋦'),
			_Utils_Tuple2('loang', '⟬'),
			_Utils_Tuple2('loarr', '⇽'),
			_Utils_Tuple2('lobrk', '⟦'),
			_Utils_Tuple2('longleftarrow', '⟵'),
			_Utils_Tuple2('LongLeftArrow', '⟵'),
			_Utils_Tuple2('Longleftarrow', '⟸'),
			_Utils_Tuple2('longleftrightarrow', '⟷'),
			_Utils_Tuple2('LongLeftRightArrow', '⟷'),
			_Utils_Tuple2('Longleftrightarrow', '⟺'),
			_Utils_Tuple2('longmapsto', '⟼'),
			_Utils_Tuple2('longrightarrow', '⟶'),
			_Utils_Tuple2('LongRightArrow', '⟶'),
			_Utils_Tuple2('Longrightarrow', '⟹'),
			_Utils_Tuple2('looparrowleft', '↫'),
			_Utils_Tuple2('looparrowright', '↬'),
			_Utils_Tuple2('lopar', '⦅'),
			_Utils_Tuple2('Lopf', '\uD835\uDD43'),
			_Utils_Tuple2('lopf', '\uD835\uDD5D'),
			_Utils_Tuple2('loplus', '⨭'),
			_Utils_Tuple2('lotimes', '⨴'),
			_Utils_Tuple2('lowast', '∗'),
			_Utils_Tuple2('lowbar', '_'),
			_Utils_Tuple2('LowerLeftArrow', '↙'),
			_Utils_Tuple2('LowerRightArrow', '↘'),
			_Utils_Tuple2('loz', '◊'),
			_Utils_Tuple2('lozenge', '◊'),
			_Utils_Tuple2('lozf', '⧫'),
			_Utils_Tuple2('lpar', '('),
			_Utils_Tuple2('lparlt', '⦓'),
			_Utils_Tuple2('lrarr', '⇆'),
			_Utils_Tuple2('lrcorner', '⌟'),
			_Utils_Tuple2('lrhar', '⇋'),
			_Utils_Tuple2('lrhard', '⥭'),
			_Utils_Tuple2('lrm', '\u200E'),
			_Utils_Tuple2('lrtri', '⊿'),
			_Utils_Tuple2('lsaquo', '‹'),
			_Utils_Tuple2('lscr', '\uD835\uDCC1'),
			_Utils_Tuple2('Lscr', 'ℒ'),
			_Utils_Tuple2('lsh', '↰'),
			_Utils_Tuple2('Lsh', '↰'),
			_Utils_Tuple2('lsim', '≲'),
			_Utils_Tuple2('lsime', '⪍'),
			_Utils_Tuple2('lsimg', '⪏'),
			_Utils_Tuple2('lsqb', '['),
			_Utils_Tuple2('lsquo', '‘'),
			_Utils_Tuple2('lsquor', '‚'),
			_Utils_Tuple2('Lstrok', 'Ł'),
			_Utils_Tuple2('lstrok', 'ł'),
			_Utils_Tuple2('ltcc', '⪦'),
			_Utils_Tuple2('ltcir', '⩹'),
			_Utils_Tuple2('lt', '<'),
			_Utils_Tuple2('LT', '<'),
			_Utils_Tuple2('Lt', '≪'),
			_Utils_Tuple2('ltdot', '⋖'),
			_Utils_Tuple2('lthree', '⋋'),
			_Utils_Tuple2('ltimes', '⋉'),
			_Utils_Tuple2('ltlarr', '⥶'),
			_Utils_Tuple2('ltquest', '⩻'),
			_Utils_Tuple2('ltri', '◃'),
			_Utils_Tuple2('ltrie', '⊴'),
			_Utils_Tuple2('ltrif', '◂'),
			_Utils_Tuple2('ltrPar', '⦖'),
			_Utils_Tuple2('lurdshar', '⥊'),
			_Utils_Tuple2('luruhar', '⥦'),
			_Utils_Tuple2('lvertneqq', '≨︀'),
			_Utils_Tuple2('lvnE', '≨︀'),
			_Utils_Tuple2('macr', '¯'),
			_Utils_Tuple2('male', '♂'),
			_Utils_Tuple2('malt', '✠'),
			_Utils_Tuple2('maltese', '✠'),
			_Utils_Tuple2('Map', '⤅'),
			_Utils_Tuple2('map', '↦'),
			_Utils_Tuple2('mapsto', '↦'),
			_Utils_Tuple2('mapstodown', '↧'),
			_Utils_Tuple2('mapstoleft', '↤'),
			_Utils_Tuple2('mapstoup', '↥'),
			_Utils_Tuple2('marker', '▮'),
			_Utils_Tuple2('mcomma', '⨩'),
			_Utils_Tuple2('Mcy', 'М'),
			_Utils_Tuple2('mcy', 'м'),
			_Utils_Tuple2('mdash', '—'),
			_Utils_Tuple2('mDDot', '∺'),
			_Utils_Tuple2('measuredangle', '∡'),
			_Utils_Tuple2('MediumSpace', '\u205F'),
			_Utils_Tuple2('Mellintrf', 'ℳ'),
			_Utils_Tuple2('Mfr', '\uD835\uDD10'),
			_Utils_Tuple2('mfr', '\uD835\uDD2A'),
			_Utils_Tuple2('mho', '℧'),
			_Utils_Tuple2('micro', 'µ'),
			_Utils_Tuple2('midast', '*'),
			_Utils_Tuple2('midcir', '⫰'),
			_Utils_Tuple2('mid', '∣'),
			_Utils_Tuple2('middot', '·'),
			_Utils_Tuple2('minusb', '⊟'),
			_Utils_Tuple2('minus', '−'),
			_Utils_Tuple2('minusd', '∸'),
			_Utils_Tuple2('minusdu', '⨪'),
			_Utils_Tuple2('MinusPlus', '∓'),
			_Utils_Tuple2('mlcp', '⫛'),
			_Utils_Tuple2('mldr', '…'),
			_Utils_Tuple2('mnplus', '∓'),
			_Utils_Tuple2('models', '⊧'),
			_Utils_Tuple2('Mopf', '\uD835\uDD44'),
			_Utils_Tuple2('mopf', '\uD835\uDD5E'),
			_Utils_Tuple2('mp', '∓'),
			_Utils_Tuple2('mscr', '\uD835\uDCC2'),
			_Utils_Tuple2('Mscr', 'ℳ'),
			_Utils_Tuple2('mstpos', '∾'),
			_Utils_Tuple2('Mu', 'Μ'),
			_Utils_Tuple2('mu', 'μ'),
			_Utils_Tuple2('multimap', '⊸'),
			_Utils_Tuple2('mumap', '⊸'),
			_Utils_Tuple2('nabla', '∇'),
			_Utils_Tuple2('Nacute', 'Ń'),
			_Utils_Tuple2('nacute', 'ń'),
			_Utils_Tuple2('nang', '∠⃒'),
			_Utils_Tuple2('nap', '≉'),
			_Utils_Tuple2('napE', '⩰̸'),
			_Utils_Tuple2('napid', '≋̸'),
			_Utils_Tuple2('napos', 'ŉ'),
			_Utils_Tuple2('napprox', '≉'),
			_Utils_Tuple2('natural', '♮'),
			_Utils_Tuple2('naturals', 'ℕ'),
			_Utils_Tuple2('natur', '♮'),
			_Utils_Tuple2('nbsp', '\u00A0'),
			_Utils_Tuple2('nbump', '≎̸'),
			_Utils_Tuple2('nbumpe', '≏̸'),
			_Utils_Tuple2('ncap', '⩃'),
			_Utils_Tuple2('Ncaron', 'Ň'),
			_Utils_Tuple2('ncaron', 'ň'),
			_Utils_Tuple2('Ncedil', 'Ņ'),
			_Utils_Tuple2('ncedil', 'ņ'),
			_Utils_Tuple2('ncong', '≇'),
			_Utils_Tuple2('ncongdot', '⩭̸'),
			_Utils_Tuple2('ncup', '⩂'),
			_Utils_Tuple2('Ncy', 'Н'),
			_Utils_Tuple2('ncy', 'н'),
			_Utils_Tuple2('ndash', '–'),
			_Utils_Tuple2('nearhk', '⤤'),
			_Utils_Tuple2('nearr', '↗'),
			_Utils_Tuple2('neArr', '⇗'),
			_Utils_Tuple2('nearrow', '↗'),
			_Utils_Tuple2('ne', '≠'),
			_Utils_Tuple2('nedot', '≐̸'),
			_Utils_Tuple2('NegativeMediumSpace', '\u200B'),
			_Utils_Tuple2('NegativeThickSpace', '\u200B'),
			_Utils_Tuple2('NegativeThinSpace', '\u200B'),
			_Utils_Tuple2('NegativeVeryThinSpace', '\u200B'),
			_Utils_Tuple2('nequiv', '≢'),
			_Utils_Tuple2('nesear', '⤨'),
			_Utils_Tuple2('nesim', '≂̸'),
			_Utils_Tuple2('NestedGreaterGreater', '≫'),
			_Utils_Tuple2('NestedLessLess', '≪'),
			_Utils_Tuple2('NewLine', '\n'),
			_Utils_Tuple2('nexist', '∄'),
			_Utils_Tuple2('nexists', '∄'),
			_Utils_Tuple2('Nfr', '\uD835\uDD11'),
			_Utils_Tuple2('nfr', '\uD835\uDD2B'),
			_Utils_Tuple2('ngE', '≧̸'),
			_Utils_Tuple2('nge', '≱'),
			_Utils_Tuple2('ngeq', '≱'),
			_Utils_Tuple2('ngeqq', '≧̸'),
			_Utils_Tuple2('ngeqslant', '⩾̸'),
			_Utils_Tuple2('nges', '⩾̸'),
			_Utils_Tuple2('nGg', '⋙̸'),
			_Utils_Tuple2('ngsim', '≵'),
			_Utils_Tuple2('nGt', '≫⃒'),
			_Utils_Tuple2('ngt', '≯'),
			_Utils_Tuple2('ngtr', '≯'),
			_Utils_Tuple2('nGtv', '≫̸'),
			_Utils_Tuple2('nharr', '↮'),
			_Utils_Tuple2('nhArr', '⇎'),
			_Utils_Tuple2('nhpar', '⫲'),
			_Utils_Tuple2('ni', '∋'),
			_Utils_Tuple2('nis', '⋼'),
			_Utils_Tuple2('nisd', '⋺'),
			_Utils_Tuple2('niv', '∋'),
			_Utils_Tuple2('NJcy', 'Њ'),
			_Utils_Tuple2('njcy', 'њ'),
			_Utils_Tuple2('nlarr', '↚'),
			_Utils_Tuple2('nlArr', '⇍'),
			_Utils_Tuple2('nldr', '‥'),
			_Utils_Tuple2('nlE', '≦̸'),
			_Utils_Tuple2('nle', '≰'),
			_Utils_Tuple2('nleftarrow', '↚'),
			_Utils_Tuple2('nLeftarrow', '⇍'),
			_Utils_Tuple2('nleftrightarrow', '↮'),
			_Utils_Tuple2('nLeftrightarrow', '⇎'),
			_Utils_Tuple2('nleq', '≰'),
			_Utils_Tuple2('nleqq', '≦̸'),
			_Utils_Tuple2('nleqslant', '⩽̸'),
			_Utils_Tuple2('nles', '⩽̸'),
			_Utils_Tuple2('nless', '≮'),
			_Utils_Tuple2('nLl', '⋘̸'),
			_Utils_Tuple2('nlsim', '≴'),
			_Utils_Tuple2('nLt', '≪⃒'),
			_Utils_Tuple2('nlt', '≮'),
			_Utils_Tuple2('nltri', '⋪'),
			_Utils_Tuple2('nltrie', '⋬'),
			_Utils_Tuple2('nLtv', '≪̸'),
			_Utils_Tuple2('nmid', '∤'),
			_Utils_Tuple2('NoBreak', '\u2060'),
			_Utils_Tuple2('NonBreakingSpace', '\u00A0'),
			_Utils_Tuple2('nopf', '\uD835\uDD5F'),
			_Utils_Tuple2('Nopf', 'ℕ'),
			_Utils_Tuple2('Not', '⫬'),
			_Utils_Tuple2('not', '¬'),
			_Utils_Tuple2('NotCongruent', '≢'),
			_Utils_Tuple2('NotCupCap', '≭'),
			_Utils_Tuple2('NotDoubleVerticalBar', '∦'),
			_Utils_Tuple2('NotElement', '∉'),
			_Utils_Tuple2('NotEqual', '≠'),
			_Utils_Tuple2('NotEqualTilde', '≂̸'),
			_Utils_Tuple2('NotExists', '∄'),
			_Utils_Tuple2('NotGreater', '≯'),
			_Utils_Tuple2('NotGreaterEqual', '≱'),
			_Utils_Tuple2('NotGreaterFullEqual', '≧̸'),
			_Utils_Tuple2('NotGreaterGreater', '≫̸'),
			_Utils_Tuple2('NotGreaterLess', '≹'),
			_Utils_Tuple2('NotGreaterSlantEqual', '⩾̸'),
			_Utils_Tuple2('NotGreaterTilde', '≵'),
			_Utils_Tuple2('NotHumpDownHump', '≎̸'),
			_Utils_Tuple2('NotHumpEqual', '≏̸'),
			_Utils_Tuple2('notin', '∉'),
			_Utils_Tuple2('notindot', '⋵̸'),
			_Utils_Tuple2('notinE', '⋹̸'),
			_Utils_Tuple2('notinva', '∉'),
			_Utils_Tuple2('notinvb', '⋷'),
			_Utils_Tuple2('notinvc', '⋶'),
			_Utils_Tuple2('NotLeftTriangleBar', '⧏̸'),
			_Utils_Tuple2('NotLeftTriangle', '⋪'),
			_Utils_Tuple2('NotLeftTriangleEqual', '⋬'),
			_Utils_Tuple2('NotLess', '≮'),
			_Utils_Tuple2('NotLessEqual', '≰'),
			_Utils_Tuple2('NotLessGreater', '≸'),
			_Utils_Tuple2('NotLessLess', '≪̸'),
			_Utils_Tuple2('NotLessSlantEqual', '⩽̸'),
			_Utils_Tuple2('NotLessTilde', '≴'),
			_Utils_Tuple2('NotNestedGreaterGreater', '⪢̸'),
			_Utils_Tuple2('NotNestedLessLess', '⪡̸'),
			_Utils_Tuple2('notni', '∌'),
			_Utils_Tuple2('notniva', '∌'),
			_Utils_Tuple2('notnivb', '⋾'),
			_Utils_Tuple2('notnivc', '⋽'),
			_Utils_Tuple2('NotPrecedes', '⊀'),
			_Utils_Tuple2('NotPrecedesEqual', '⪯̸'),
			_Utils_Tuple2('NotPrecedesSlantEqual', '⋠'),
			_Utils_Tuple2('NotReverseElement', '∌'),
			_Utils_Tuple2('NotRightTriangleBar', '⧐̸'),
			_Utils_Tuple2('NotRightTriangle', '⋫'),
			_Utils_Tuple2('NotRightTriangleEqual', '⋭'),
			_Utils_Tuple2('NotSquareSubset', '⊏̸'),
			_Utils_Tuple2('NotSquareSubsetEqual', '⋢'),
			_Utils_Tuple2('NotSquareSuperset', '⊐̸'),
			_Utils_Tuple2('NotSquareSupersetEqual', '⋣'),
			_Utils_Tuple2('NotSubset', '⊂⃒'),
			_Utils_Tuple2('NotSubsetEqual', '⊈'),
			_Utils_Tuple2('NotSucceeds', '⊁'),
			_Utils_Tuple2('NotSucceedsEqual', '⪰̸'),
			_Utils_Tuple2('NotSucceedsSlantEqual', '⋡'),
			_Utils_Tuple2('NotSucceedsTilde', '≿̸'),
			_Utils_Tuple2('NotSuperset', '⊃⃒'),
			_Utils_Tuple2('NotSupersetEqual', '⊉'),
			_Utils_Tuple2('NotTilde', '≁'),
			_Utils_Tuple2('NotTildeEqual', '≄'),
			_Utils_Tuple2('NotTildeFullEqual', '≇'),
			_Utils_Tuple2('NotTildeTilde', '≉'),
			_Utils_Tuple2('NotVerticalBar', '∤'),
			_Utils_Tuple2('nparallel', '∦'),
			_Utils_Tuple2('npar', '∦'),
			_Utils_Tuple2('nparsl', '⫽⃥'),
			_Utils_Tuple2('npart', '∂̸'),
			_Utils_Tuple2('npolint', '⨔'),
			_Utils_Tuple2('npr', '⊀'),
			_Utils_Tuple2('nprcue', '⋠'),
			_Utils_Tuple2('nprec', '⊀'),
			_Utils_Tuple2('npreceq', '⪯̸'),
			_Utils_Tuple2('npre', '⪯̸'),
			_Utils_Tuple2('nrarrc', '⤳̸'),
			_Utils_Tuple2('nrarr', '↛'),
			_Utils_Tuple2('nrArr', '⇏'),
			_Utils_Tuple2('nrarrw', '↝̸'),
			_Utils_Tuple2('nrightarrow', '↛'),
			_Utils_Tuple2('nRightarrow', '⇏'),
			_Utils_Tuple2('nrtri', '⋫'),
			_Utils_Tuple2('nrtrie', '⋭'),
			_Utils_Tuple2('nsc', '⊁'),
			_Utils_Tuple2('nsccue', '⋡'),
			_Utils_Tuple2('nsce', '⪰̸'),
			_Utils_Tuple2('Nscr', '\uD835\uDCA9'),
			_Utils_Tuple2('nscr', '\uD835\uDCC3'),
			_Utils_Tuple2('nshortmid', '∤'),
			_Utils_Tuple2('nshortparallel', '∦'),
			_Utils_Tuple2('nsim', '≁'),
			_Utils_Tuple2('nsime', '≄'),
			_Utils_Tuple2('nsimeq', '≄'),
			_Utils_Tuple2('nsmid', '∤'),
			_Utils_Tuple2('nspar', '∦'),
			_Utils_Tuple2('nsqsube', '⋢'),
			_Utils_Tuple2('nsqsupe', '⋣'),
			_Utils_Tuple2('nsub', '⊄'),
			_Utils_Tuple2('nsubE', '⫅̸'),
			_Utils_Tuple2('nsube', '⊈'),
			_Utils_Tuple2('nsubset', '⊂⃒'),
			_Utils_Tuple2('nsubseteq', '⊈'),
			_Utils_Tuple2('nsubseteqq', '⫅̸'),
			_Utils_Tuple2('nsucc', '⊁'),
			_Utils_Tuple2('nsucceq', '⪰̸'),
			_Utils_Tuple2('nsup', '⊅'),
			_Utils_Tuple2('nsupE', '⫆̸'),
			_Utils_Tuple2('nsupe', '⊉'),
			_Utils_Tuple2('nsupset', '⊃⃒'),
			_Utils_Tuple2('nsupseteq', '⊉'),
			_Utils_Tuple2('nsupseteqq', '⫆̸'),
			_Utils_Tuple2('ntgl', '≹'),
			_Utils_Tuple2('Ntilde', 'Ñ'),
			_Utils_Tuple2('ntilde', 'ñ'),
			_Utils_Tuple2('ntlg', '≸'),
			_Utils_Tuple2('ntriangleleft', '⋪'),
			_Utils_Tuple2('ntrianglelefteq', '⋬'),
			_Utils_Tuple2('ntriangleright', '⋫'),
			_Utils_Tuple2('ntrianglerighteq', '⋭'),
			_Utils_Tuple2('Nu', 'Ν'),
			_Utils_Tuple2('nu', 'ν'),
			_Utils_Tuple2('num', '#'),
			_Utils_Tuple2('numero', '№'),
			_Utils_Tuple2('numsp', '\u2007'),
			_Utils_Tuple2('nvap', '≍⃒'),
			_Utils_Tuple2('nvdash', '⊬'),
			_Utils_Tuple2('nvDash', '⊭'),
			_Utils_Tuple2('nVdash', '⊮'),
			_Utils_Tuple2('nVDash', '⊯'),
			_Utils_Tuple2('nvge', '≥⃒'),
			_Utils_Tuple2('nvgt', '>⃒'),
			_Utils_Tuple2('nvHarr', '⤄'),
			_Utils_Tuple2('nvinfin', '⧞'),
			_Utils_Tuple2('nvlArr', '⤂'),
			_Utils_Tuple2('nvle', '≤⃒'),
			_Utils_Tuple2('nvlt', '<⃒'),
			_Utils_Tuple2('nvltrie', '⊴⃒'),
			_Utils_Tuple2('nvrArr', '⤃'),
			_Utils_Tuple2('nvrtrie', '⊵⃒'),
			_Utils_Tuple2('nvsim', '∼⃒'),
			_Utils_Tuple2('nwarhk', '⤣'),
			_Utils_Tuple2('nwarr', '↖'),
			_Utils_Tuple2('nwArr', '⇖'),
			_Utils_Tuple2('nwarrow', '↖'),
			_Utils_Tuple2('nwnear', '⤧'),
			_Utils_Tuple2('Oacute', 'Ó'),
			_Utils_Tuple2('oacute', 'ó'),
			_Utils_Tuple2('oast', '⊛'),
			_Utils_Tuple2('Ocirc', 'Ô'),
			_Utils_Tuple2('ocirc', 'ô'),
			_Utils_Tuple2('ocir', '⊚'),
			_Utils_Tuple2('Ocy', 'О'),
			_Utils_Tuple2('ocy', 'о'),
			_Utils_Tuple2('odash', '⊝'),
			_Utils_Tuple2('Odblac', 'Ő'),
			_Utils_Tuple2('odblac', 'ő'),
			_Utils_Tuple2('odiv', '⨸'),
			_Utils_Tuple2('odot', '⊙'),
			_Utils_Tuple2('odsold', '⦼'),
			_Utils_Tuple2('OElig', 'Œ'),
			_Utils_Tuple2('oelig', 'œ'),
			_Utils_Tuple2('ofcir', '⦿'),
			_Utils_Tuple2('Ofr', '\uD835\uDD12'),
			_Utils_Tuple2('ofr', '\uD835\uDD2C'),
			_Utils_Tuple2('ogon', '˛'),
			_Utils_Tuple2('Ograve', 'Ò'),
			_Utils_Tuple2('ograve', 'ò'),
			_Utils_Tuple2('ogt', '⧁'),
			_Utils_Tuple2('ohbar', '⦵'),
			_Utils_Tuple2('ohm', 'Ω'),
			_Utils_Tuple2('oint', '∮'),
			_Utils_Tuple2('olarr', '↺'),
			_Utils_Tuple2('olcir', '⦾'),
			_Utils_Tuple2('olcross', '⦻'),
			_Utils_Tuple2('oline', '‾'),
			_Utils_Tuple2('olt', '⧀'),
			_Utils_Tuple2('Omacr', 'Ō'),
			_Utils_Tuple2('omacr', 'ō'),
			_Utils_Tuple2('Omega', 'Ω'),
			_Utils_Tuple2('omega', 'ω'),
			_Utils_Tuple2('Omicron', 'Ο'),
			_Utils_Tuple2('omicron', 'ο'),
			_Utils_Tuple2('omid', '⦶'),
			_Utils_Tuple2('ominus', '⊖'),
			_Utils_Tuple2('Oopf', '\uD835\uDD46'),
			_Utils_Tuple2('oopf', '\uD835\uDD60'),
			_Utils_Tuple2('opar', '⦷'),
			_Utils_Tuple2('OpenCurlyDoubleQuote', '“'),
			_Utils_Tuple2('OpenCurlyQuote', '‘'),
			_Utils_Tuple2('operp', '⦹'),
			_Utils_Tuple2('oplus', '⊕'),
			_Utils_Tuple2('orarr', '↻'),
			_Utils_Tuple2('Or', '⩔'),
			_Utils_Tuple2('or', '∨'),
			_Utils_Tuple2('ord', '⩝'),
			_Utils_Tuple2('order', 'ℴ'),
			_Utils_Tuple2('orderof', 'ℴ'),
			_Utils_Tuple2('ordf', 'ª'),
			_Utils_Tuple2('ordm', 'º'),
			_Utils_Tuple2('origof', '⊶'),
			_Utils_Tuple2('oror', '⩖'),
			_Utils_Tuple2('orslope', '⩗'),
			_Utils_Tuple2('orv', '⩛'),
			_Utils_Tuple2('oS', 'Ⓢ'),
			_Utils_Tuple2('Oscr', '\uD835\uDCAA'),
			_Utils_Tuple2('oscr', 'ℴ'),
			_Utils_Tuple2('Oslash', 'Ø'),
			_Utils_Tuple2('oslash', 'ø'),
			_Utils_Tuple2('osol', '⊘'),
			_Utils_Tuple2('Otilde', 'Õ'),
			_Utils_Tuple2('otilde', 'õ'),
			_Utils_Tuple2('otimesas', '⨶'),
			_Utils_Tuple2('Otimes', '⨷'),
			_Utils_Tuple2('otimes', '⊗'),
			_Utils_Tuple2('Ouml', 'Ö'),
			_Utils_Tuple2('ouml', 'ö'),
			_Utils_Tuple2('ovbar', '⌽'),
			_Utils_Tuple2('OverBar', '‾'),
			_Utils_Tuple2('OverBrace', '⏞'),
			_Utils_Tuple2('OverBracket', '⎴'),
			_Utils_Tuple2('OverParenthesis', '⏜'),
			_Utils_Tuple2('para', '¶'),
			_Utils_Tuple2('parallel', '∥'),
			_Utils_Tuple2('par', '∥'),
			_Utils_Tuple2('parsim', '⫳'),
			_Utils_Tuple2('parsl', '⫽'),
			_Utils_Tuple2('part', '∂'),
			_Utils_Tuple2('PartialD', '∂'),
			_Utils_Tuple2('Pcy', 'П'),
			_Utils_Tuple2('pcy', 'п'),
			_Utils_Tuple2('percnt', '%'),
			_Utils_Tuple2('period', '.'),
			_Utils_Tuple2('permil', '‰'),
			_Utils_Tuple2('perp', '⊥'),
			_Utils_Tuple2('pertenk', '‱'),
			_Utils_Tuple2('Pfr', '\uD835\uDD13'),
			_Utils_Tuple2('pfr', '\uD835\uDD2D'),
			_Utils_Tuple2('Phi', 'Φ'),
			_Utils_Tuple2('phi', 'φ'),
			_Utils_Tuple2('phiv', 'ϕ'),
			_Utils_Tuple2('phmmat', 'ℳ'),
			_Utils_Tuple2('phone', '☎'),
			_Utils_Tuple2('Pi', 'Π'),
			_Utils_Tuple2('pi', 'π'),
			_Utils_Tuple2('pitchfork', '⋔'),
			_Utils_Tuple2('piv', 'ϖ'),
			_Utils_Tuple2('planck', 'ℏ'),
			_Utils_Tuple2('planckh', 'ℎ'),
			_Utils_Tuple2('plankv', 'ℏ'),
			_Utils_Tuple2('plusacir', '⨣'),
			_Utils_Tuple2('plusb', '⊞'),
			_Utils_Tuple2('pluscir', '⨢'),
			_Utils_Tuple2('plus', '+'),
			_Utils_Tuple2('plusdo', '∔'),
			_Utils_Tuple2('plusdu', '⨥'),
			_Utils_Tuple2('pluse', '⩲'),
			_Utils_Tuple2('PlusMinus', '±'),
			_Utils_Tuple2('plusmn', '±'),
			_Utils_Tuple2('plussim', '⨦'),
			_Utils_Tuple2('plustwo', '⨧'),
			_Utils_Tuple2('pm', '±'),
			_Utils_Tuple2('Poincareplane', 'ℌ'),
			_Utils_Tuple2('pointint', '⨕'),
			_Utils_Tuple2('popf', '\uD835\uDD61'),
			_Utils_Tuple2('Popf', 'ℙ'),
			_Utils_Tuple2('pound', '£'),
			_Utils_Tuple2('prap', '⪷'),
			_Utils_Tuple2('Pr', '⪻'),
			_Utils_Tuple2('pr', '≺'),
			_Utils_Tuple2('prcue', '≼'),
			_Utils_Tuple2('precapprox', '⪷'),
			_Utils_Tuple2('prec', '≺'),
			_Utils_Tuple2('preccurlyeq', '≼'),
			_Utils_Tuple2('Precedes', '≺'),
			_Utils_Tuple2('PrecedesEqual', '⪯'),
			_Utils_Tuple2('PrecedesSlantEqual', '≼'),
			_Utils_Tuple2('PrecedesTilde', '≾'),
			_Utils_Tuple2('preceq', '⪯'),
			_Utils_Tuple2('precnapprox', '⪹'),
			_Utils_Tuple2('precneqq', '⪵'),
			_Utils_Tuple2('precnsim', '⋨'),
			_Utils_Tuple2('pre', '⪯'),
			_Utils_Tuple2('prE', '⪳'),
			_Utils_Tuple2('precsim', '≾'),
			_Utils_Tuple2('prime', '′'),
			_Utils_Tuple2('Prime', '″'),
			_Utils_Tuple2('primes', 'ℙ'),
			_Utils_Tuple2('prnap', '⪹'),
			_Utils_Tuple2('prnE', '⪵'),
			_Utils_Tuple2('prnsim', '⋨'),
			_Utils_Tuple2('prod', '∏'),
			_Utils_Tuple2('Product', '∏'),
			_Utils_Tuple2('profalar', '⌮'),
			_Utils_Tuple2('profline', '⌒'),
			_Utils_Tuple2('profsurf', '⌓'),
			_Utils_Tuple2('prop', '∝'),
			_Utils_Tuple2('Proportional', '∝'),
			_Utils_Tuple2('Proportion', '∷'),
			_Utils_Tuple2('propto', '∝'),
			_Utils_Tuple2('prsim', '≾'),
			_Utils_Tuple2('prurel', '⊰'),
			_Utils_Tuple2('Pscr', '\uD835\uDCAB'),
			_Utils_Tuple2('pscr', '\uD835\uDCC5'),
			_Utils_Tuple2('Psi', 'Ψ'),
			_Utils_Tuple2('psi', 'ψ'),
			_Utils_Tuple2('puncsp', '\u2008'),
			_Utils_Tuple2('Qfr', '\uD835\uDD14'),
			_Utils_Tuple2('qfr', '\uD835\uDD2E'),
			_Utils_Tuple2('qint', '⨌'),
			_Utils_Tuple2('qopf', '\uD835\uDD62'),
			_Utils_Tuple2('Qopf', 'ℚ'),
			_Utils_Tuple2('qprime', '⁗'),
			_Utils_Tuple2('Qscr', '\uD835\uDCAC'),
			_Utils_Tuple2('qscr', '\uD835\uDCC6'),
			_Utils_Tuple2('quaternions', 'ℍ'),
			_Utils_Tuple2('quatint', '⨖'),
			_Utils_Tuple2('quest', '?'),
			_Utils_Tuple2('questeq', '≟'),
			_Utils_Tuple2('quot', '\"'),
			_Utils_Tuple2('QUOT', '\"'),
			_Utils_Tuple2('rAarr', '⇛'),
			_Utils_Tuple2('race', '∽̱'),
			_Utils_Tuple2('Racute', 'Ŕ'),
			_Utils_Tuple2('racute', 'ŕ'),
			_Utils_Tuple2('radic', '√'),
			_Utils_Tuple2('raemptyv', '⦳'),
			_Utils_Tuple2('rang', '⟩'),
			_Utils_Tuple2('Rang', '⟫'),
			_Utils_Tuple2('rangd', '⦒'),
			_Utils_Tuple2('range', '⦥'),
			_Utils_Tuple2('rangle', '⟩'),
			_Utils_Tuple2('raquo', '»'),
			_Utils_Tuple2('rarrap', '⥵'),
			_Utils_Tuple2('rarrb', '⇥'),
			_Utils_Tuple2('rarrbfs', '⤠'),
			_Utils_Tuple2('rarrc', '⤳'),
			_Utils_Tuple2('rarr', '→'),
			_Utils_Tuple2('Rarr', '↠'),
			_Utils_Tuple2('rArr', '⇒'),
			_Utils_Tuple2('rarrfs', '⤞'),
			_Utils_Tuple2('rarrhk', '↪'),
			_Utils_Tuple2('rarrlp', '↬'),
			_Utils_Tuple2('rarrpl', '⥅'),
			_Utils_Tuple2('rarrsim', '⥴'),
			_Utils_Tuple2('Rarrtl', '⤖'),
			_Utils_Tuple2('rarrtl', '↣'),
			_Utils_Tuple2('rarrw', '↝'),
			_Utils_Tuple2('ratail', '⤚'),
			_Utils_Tuple2('rAtail', '⤜'),
			_Utils_Tuple2('ratio', '∶'),
			_Utils_Tuple2('rationals', 'ℚ'),
			_Utils_Tuple2('rbarr', '⤍'),
			_Utils_Tuple2('rBarr', '⤏'),
			_Utils_Tuple2('RBarr', '⤐'),
			_Utils_Tuple2('rbbrk', '❳'),
			_Utils_Tuple2('rbrace', '}'),
			_Utils_Tuple2('rbrack', ']'),
			_Utils_Tuple2('rbrke', '⦌'),
			_Utils_Tuple2('rbrksld', '⦎'),
			_Utils_Tuple2('rbrkslu', '⦐'),
			_Utils_Tuple2('Rcaron', 'Ř'),
			_Utils_Tuple2('rcaron', 'ř'),
			_Utils_Tuple2('Rcedil', 'Ŗ'),
			_Utils_Tuple2('rcedil', 'ŗ'),
			_Utils_Tuple2('rceil', '⌉'),
			_Utils_Tuple2('rcub', '}'),
			_Utils_Tuple2('Rcy', 'Р'),
			_Utils_Tuple2('rcy', 'р'),
			_Utils_Tuple2('rdca', '⤷'),
			_Utils_Tuple2('rdldhar', '⥩'),
			_Utils_Tuple2('rdquo', '”'),
			_Utils_Tuple2('rdquor', '”'),
			_Utils_Tuple2('rdsh', '↳'),
			_Utils_Tuple2('real', 'ℜ'),
			_Utils_Tuple2('realine', 'ℛ'),
			_Utils_Tuple2('realpart', 'ℜ'),
			_Utils_Tuple2('reals', 'ℝ'),
			_Utils_Tuple2('Re', 'ℜ'),
			_Utils_Tuple2('rect', '▭'),
			_Utils_Tuple2('reg', '®'),
			_Utils_Tuple2('REG', '®'),
			_Utils_Tuple2('ReverseElement', '∋'),
			_Utils_Tuple2('ReverseEquilibrium', '⇋'),
			_Utils_Tuple2('ReverseUpEquilibrium', '⥯'),
			_Utils_Tuple2('rfisht', '⥽'),
			_Utils_Tuple2('rfloor', '⌋'),
			_Utils_Tuple2('rfr', '\uD835\uDD2F'),
			_Utils_Tuple2('Rfr', 'ℜ'),
			_Utils_Tuple2('rHar', '⥤'),
			_Utils_Tuple2('rhard', '⇁'),
			_Utils_Tuple2('rharu', '⇀'),
			_Utils_Tuple2('rharul', '⥬'),
			_Utils_Tuple2('Rho', 'Ρ'),
			_Utils_Tuple2('rho', 'ρ'),
			_Utils_Tuple2('rhov', 'ϱ'),
			_Utils_Tuple2('RightAngleBracket', '⟩'),
			_Utils_Tuple2('RightArrowBar', '⇥'),
			_Utils_Tuple2('rightarrow', '→'),
			_Utils_Tuple2('RightArrow', '→'),
			_Utils_Tuple2('Rightarrow', '⇒'),
			_Utils_Tuple2('RightArrowLeftArrow', '⇄'),
			_Utils_Tuple2('rightarrowtail', '↣'),
			_Utils_Tuple2('RightCeiling', '⌉'),
			_Utils_Tuple2('RightDoubleBracket', '⟧'),
			_Utils_Tuple2('RightDownTeeVector', '⥝'),
			_Utils_Tuple2('RightDownVectorBar', '⥕'),
			_Utils_Tuple2('RightDownVector', '⇂'),
			_Utils_Tuple2('RightFloor', '⌋'),
			_Utils_Tuple2('rightharpoondown', '⇁'),
			_Utils_Tuple2('rightharpoonup', '⇀'),
			_Utils_Tuple2('rightleftarrows', '⇄'),
			_Utils_Tuple2('rightleftharpoons', '⇌'),
			_Utils_Tuple2('rightrightarrows', '⇉'),
			_Utils_Tuple2('rightsquigarrow', '↝'),
			_Utils_Tuple2('RightTeeArrow', '↦'),
			_Utils_Tuple2('RightTee', '⊢'),
			_Utils_Tuple2('RightTeeVector', '⥛'),
			_Utils_Tuple2('rightthreetimes', '⋌'),
			_Utils_Tuple2('RightTriangleBar', '⧐'),
			_Utils_Tuple2('RightTriangle', '⊳'),
			_Utils_Tuple2('RightTriangleEqual', '⊵'),
			_Utils_Tuple2('RightUpDownVector', '⥏'),
			_Utils_Tuple2('RightUpTeeVector', '⥜'),
			_Utils_Tuple2('RightUpVectorBar', '⥔'),
			_Utils_Tuple2('RightUpVector', '↾'),
			_Utils_Tuple2('RightVectorBar', '⥓'),
			_Utils_Tuple2('RightVector', '⇀'),
			_Utils_Tuple2('ring', '˚'),
			_Utils_Tuple2('risingdotseq', '≓'),
			_Utils_Tuple2('rlarr', '⇄'),
			_Utils_Tuple2('rlhar', '⇌'),
			_Utils_Tuple2('rlm', '\u200F'),
			_Utils_Tuple2('rmoustache', '⎱'),
			_Utils_Tuple2('rmoust', '⎱'),
			_Utils_Tuple2('rnmid', '⫮'),
			_Utils_Tuple2('roang', '⟭'),
			_Utils_Tuple2('roarr', '⇾'),
			_Utils_Tuple2('robrk', '⟧'),
			_Utils_Tuple2('ropar', '⦆'),
			_Utils_Tuple2('ropf', '\uD835\uDD63'),
			_Utils_Tuple2('Ropf', 'ℝ'),
			_Utils_Tuple2('roplus', '⨮'),
			_Utils_Tuple2('rotimes', '⨵'),
			_Utils_Tuple2('RoundImplies', '⥰'),
			_Utils_Tuple2('rpar', ')'),
			_Utils_Tuple2('rpargt', '⦔'),
			_Utils_Tuple2('rppolint', '⨒'),
			_Utils_Tuple2('rrarr', '⇉'),
			_Utils_Tuple2('Rrightarrow', '⇛'),
			_Utils_Tuple2('rsaquo', '›'),
			_Utils_Tuple2('rscr', '\uD835\uDCC7'),
			_Utils_Tuple2('Rscr', 'ℛ'),
			_Utils_Tuple2('rsh', '↱'),
			_Utils_Tuple2('Rsh', '↱'),
			_Utils_Tuple2('rsqb', ']'),
			_Utils_Tuple2('rsquo', '’'),
			_Utils_Tuple2('rsquor', '’'),
			_Utils_Tuple2('rthree', '⋌'),
			_Utils_Tuple2('rtimes', '⋊'),
			_Utils_Tuple2('rtri', '▹'),
			_Utils_Tuple2('rtrie', '⊵'),
			_Utils_Tuple2('rtrif', '▸'),
			_Utils_Tuple2('rtriltri', '⧎'),
			_Utils_Tuple2('RuleDelayed', '⧴'),
			_Utils_Tuple2('ruluhar', '⥨'),
			_Utils_Tuple2('rx', '℞'),
			_Utils_Tuple2('Sacute', 'Ś'),
			_Utils_Tuple2('sacute', 'ś'),
			_Utils_Tuple2('sbquo', '‚'),
			_Utils_Tuple2('scap', '⪸'),
			_Utils_Tuple2('Scaron', 'Š'),
			_Utils_Tuple2('scaron', 'š'),
			_Utils_Tuple2('Sc', '⪼'),
			_Utils_Tuple2('sc', '≻'),
			_Utils_Tuple2('sccue', '≽'),
			_Utils_Tuple2('sce', '⪰'),
			_Utils_Tuple2('scE', '⪴'),
			_Utils_Tuple2('Scedil', 'Ş'),
			_Utils_Tuple2('scedil', 'ş'),
			_Utils_Tuple2('Scirc', 'Ŝ'),
			_Utils_Tuple2('scirc', 'ŝ'),
			_Utils_Tuple2('scnap', '⪺'),
			_Utils_Tuple2('scnE', '⪶'),
			_Utils_Tuple2('scnsim', '⋩'),
			_Utils_Tuple2('scpolint', '⨓'),
			_Utils_Tuple2('scsim', '≿'),
			_Utils_Tuple2('Scy', 'С'),
			_Utils_Tuple2('scy', 'с'),
			_Utils_Tuple2('sdotb', '⊡'),
			_Utils_Tuple2('sdot', '⋅'),
			_Utils_Tuple2('sdote', '⩦'),
			_Utils_Tuple2('searhk', '⤥'),
			_Utils_Tuple2('searr', '↘'),
			_Utils_Tuple2('seArr', '⇘'),
			_Utils_Tuple2('searrow', '↘'),
			_Utils_Tuple2('sect', '§'),
			_Utils_Tuple2('semi', ';'),
			_Utils_Tuple2('seswar', '⤩'),
			_Utils_Tuple2('setminus', '∖'),
			_Utils_Tuple2('setmn', '∖'),
			_Utils_Tuple2('sext', '✶'),
			_Utils_Tuple2('Sfr', '\uD835\uDD16'),
			_Utils_Tuple2('sfr', '\uD835\uDD30'),
			_Utils_Tuple2('sfrown', '⌢'),
			_Utils_Tuple2('sharp', '♯'),
			_Utils_Tuple2('SHCHcy', 'Щ'),
			_Utils_Tuple2('shchcy', 'щ'),
			_Utils_Tuple2('SHcy', 'Ш'),
			_Utils_Tuple2('shcy', 'ш'),
			_Utils_Tuple2('ShortDownArrow', '↓'),
			_Utils_Tuple2('ShortLeftArrow', '←'),
			_Utils_Tuple2('shortmid', '∣'),
			_Utils_Tuple2('shortparallel', '∥'),
			_Utils_Tuple2('ShortRightArrow', '→'),
			_Utils_Tuple2('ShortUpArrow', '↑'),
			_Utils_Tuple2('shy', '\u00AD'),
			_Utils_Tuple2('Sigma', 'Σ'),
			_Utils_Tuple2('sigma', 'σ'),
			_Utils_Tuple2('sigmaf', 'ς'),
			_Utils_Tuple2('sigmav', 'ς'),
			_Utils_Tuple2('sim', '∼'),
			_Utils_Tuple2('simdot', '⩪'),
			_Utils_Tuple2('sime', '≃'),
			_Utils_Tuple2('simeq', '≃'),
			_Utils_Tuple2('simg', '⪞'),
			_Utils_Tuple2('simgE', '⪠'),
			_Utils_Tuple2('siml', '⪝'),
			_Utils_Tuple2('simlE', '⪟'),
			_Utils_Tuple2('simne', '≆'),
			_Utils_Tuple2('simplus', '⨤'),
			_Utils_Tuple2('simrarr', '⥲'),
			_Utils_Tuple2('slarr', '←'),
			_Utils_Tuple2('SmallCircle', '∘'),
			_Utils_Tuple2('smallsetminus', '∖'),
			_Utils_Tuple2('smashp', '⨳'),
			_Utils_Tuple2('smeparsl', '⧤'),
			_Utils_Tuple2('smid', '∣'),
			_Utils_Tuple2('smile', '⌣'),
			_Utils_Tuple2('smt', '⪪'),
			_Utils_Tuple2('smte', '⪬'),
			_Utils_Tuple2('smtes', '⪬︀'),
			_Utils_Tuple2('SOFTcy', 'Ь'),
			_Utils_Tuple2('softcy', 'ь'),
			_Utils_Tuple2('solbar', '⌿'),
			_Utils_Tuple2('solb', '⧄'),
			_Utils_Tuple2('sol', '/'),
			_Utils_Tuple2('Sopf', '\uD835\uDD4A'),
			_Utils_Tuple2('sopf', '\uD835\uDD64'),
			_Utils_Tuple2('spades', '♠'),
			_Utils_Tuple2('spadesuit', '♠'),
			_Utils_Tuple2('spar', '∥'),
			_Utils_Tuple2('sqcap', '⊓'),
			_Utils_Tuple2('sqcaps', '⊓︀'),
			_Utils_Tuple2('sqcup', '⊔'),
			_Utils_Tuple2('sqcups', '⊔︀'),
			_Utils_Tuple2('Sqrt', '√'),
			_Utils_Tuple2('sqsub', '⊏'),
			_Utils_Tuple2('sqsube', '⊑'),
			_Utils_Tuple2('sqsubset', '⊏'),
			_Utils_Tuple2('sqsubseteq', '⊑'),
			_Utils_Tuple2('sqsup', '⊐'),
			_Utils_Tuple2('sqsupe', '⊒'),
			_Utils_Tuple2('sqsupset', '⊐'),
			_Utils_Tuple2('sqsupseteq', '⊒'),
			_Utils_Tuple2('square', '□'),
			_Utils_Tuple2('Square', '□'),
			_Utils_Tuple2('SquareIntersection', '⊓'),
			_Utils_Tuple2('SquareSubset', '⊏'),
			_Utils_Tuple2('SquareSubsetEqual', '⊑'),
			_Utils_Tuple2('SquareSuperset', '⊐'),
			_Utils_Tuple2('SquareSupersetEqual', '⊒'),
			_Utils_Tuple2('SquareUnion', '⊔'),
			_Utils_Tuple2('squarf', '▪'),
			_Utils_Tuple2('squ', '□'),
			_Utils_Tuple2('squf', '▪'),
			_Utils_Tuple2('srarr', '→'),
			_Utils_Tuple2('Sscr', '\uD835\uDCAE'),
			_Utils_Tuple2('sscr', '\uD835\uDCC8'),
			_Utils_Tuple2('ssetmn', '∖'),
			_Utils_Tuple2('ssmile', '⌣'),
			_Utils_Tuple2('sstarf', '⋆'),
			_Utils_Tuple2('Star', '⋆'),
			_Utils_Tuple2('star', '☆'),
			_Utils_Tuple2('starf', '★'),
			_Utils_Tuple2('straightepsilon', 'ϵ'),
			_Utils_Tuple2('straightphi', 'ϕ'),
			_Utils_Tuple2('strns', '¯'),
			_Utils_Tuple2('sub', '⊂'),
			_Utils_Tuple2('Sub', '⋐'),
			_Utils_Tuple2('subdot', '⪽'),
			_Utils_Tuple2('subE', '⫅'),
			_Utils_Tuple2('sube', '⊆'),
			_Utils_Tuple2('subedot', '⫃'),
			_Utils_Tuple2('submult', '⫁'),
			_Utils_Tuple2('subnE', '⫋'),
			_Utils_Tuple2('subne', '⊊'),
			_Utils_Tuple2('subplus', '⪿'),
			_Utils_Tuple2('subrarr', '⥹'),
			_Utils_Tuple2('subset', '⊂'),
			_Utils_Tuple2('Subset', '⋐'),
			_Utils_Tuple2('subseteq', '⊆'),
			_Utils_Tuple2('subseteqq', '⫅'),
			_Utils_Tuple2('SubsetEqual', '⊆'),
			_Utils_Tuple2('subsetneq', '⊊'),
			_Utils_Tuple2('subsetneqq', '⫋'),
			_Utils_Tuple2('subsim', '⫇'),
			_Utils_Tuple2('subsub', '⫕'),
			_Utils_Tuple2('subsup', '⫓'),
			_Utils_Tuple2('succapprox', '⪸'),
			_Utils_Tuple2('succ', '≻'),
			_Utils_Tuple2('succcurlyeq', '≽'),
			_Utils_Tuple2('Succeeds', '≻'),
			_Utils_Tuple2('SucceedsEqual', '⪰'),
			_Utils_Tuple2('SucceedsSlantEqual', '≽'),
			_Utils_Tuple2('SucceedsTilde', '≿'),
			_Utils_Tuple2('succeq', '⪰'),
			_Utils_Tuple2('succnapprox', '⪺'),
			_Utils_Tuple2('succneqq', '⪶'),
			_Utils_Tuple2('succnsim', '⋩'),
			_Utils_Tuple2('succsim', '≿'),
			_Utils_Tuple2('SuchThat', '∋'),
			_Utils_Tuple2('sum', '∑'),
			_Utils_Tuple2('Sum', '∑'),
			_Utils_Tuple2('sung', '♪'),
			_Utils_Tuple2('sup1', '¹'),
			_Utils_Tuple2('sup2', '²'),
			_Utils_Tuple2('sup3', '³'),
			_Utils_Tuple2('sup', '⊃'),
			_Utils_Tuple2('Sup', '⋑'),
			_Utils_Tuple2('supdot', '⪾'),
			_Utils_Tuple2('supdsub', '⫘'),
			_Utils_Tuple2('supE', '⫆'),
			_Utils_Tuple2('supe', '⊇'),
			_Utils_Tuple2('supedot', '⫄'),
			_Utils_Tuple2('Superset', '⊃'),
			_Utils_Tuple2('SupersetEqual', '⊇'),
			_Utils_Tuple2('suphsol', '⟉'),
			_Utils_Tuple2('suphsub', '⫗'),
			_Utils_Tuple2('suplarr', '⥻'),
			_Utils_Tuple2('supmult', '⫂'),
			_Utils_Tuple2('supnE', '⫌'),
			_Utils_Tuple2('supne', '⊋'),
			_Utils_Tuple2('supplus', '⫀'),
			_Utils_Tuple2('supset', '⊃'),
			_Utils_Tuple2('Supset', '⋑'),
			_Utils_Tuple2('supseteq', '⊇'),
			_Utils_Tuple2('supseteqq', '⫆'),
			_Utils_Tuple2('supsetneq', '⊋'),
			_Utils_Tuple2('supsetneqq', '⫌'),
			_Utils_Tuple2('supsim', '⫈'),
			_Utils_Tuple2('supsub', '⫔'),
			_Utils_Tuple2('supsup', '⫖'),
			_Utils_Tuple2('swarhk', '⤦'),
			_Utils_Tuple2('swarr', '↙'),
			_Utils_Tuple2('swArr', '⇙'),
			_Utils_Tuple2('swarrow', '↙'),
			_Utils_Tuple2('swnwar', '⤪'),
			_Utils_Tuple2('szlig', 'ß'),
			_Utils_Tuple2('Tab', '\t'),
			_Utils_Tuple2('target', '⌖'),
			_Utils_Tuple2('Tau', 'Τ'),
			_Utils_Tuple2('tau', 'τ'),
			_Utils_Tuple2('tbrk', '⎴'),
			_Utils_Tuple2('Tcaron', 'Ť'),
			_Utils_Tuple2('tcaron', 'ť'),
			_Utils_Tuple2('Tcedil', 'Ţ'),
			_Utils_Tuple2('tcedil', 'ţ'),
			_Utils_Tuple2('Tcy', 'Т'),
			_Utils_Tuple2('tcy', 'т'),
			_Utils_Tuple2('tdot', '⃛'),
			_Utils_Tuple2('telrec', '⌕'),
			_Utils_Tuple2('Tfr', '\uD835\uDD17'),
			_Utils_Tuple2('tfr', '\uD835\uDD31'),
			_Utils_Tuple2('there4', '∴'),
			_Utils_Tuple2('therefore', '∴'),
			_Utils_Tuple2('Therefore', '∴'),
			_Utils_Tuple2('Theta', 'Θ'),
			_Utils_Tuple2('theta', 'θ'),
			_Utils_Tuple2('thetasym', 'ϑ'),
			_Utils_Tuple2('thetav', 'ϑ'),
			_Utils_Tuple2('thickapprox', '≈'),
			_Utils_Tuple2('thicksim', '∼'),
			_Utils_Tuple2('ThickSpace', '\u205F\u200A'),
			_Utils_Tuple2('ThinSpace', '\u2009'),
			_Utils_Tuple2('thinsp', '\u2009'),
			_Utils_Tuple2('thkap', '≈'),
			_Utils_Tuple2('thksim', '∼'),
			_Utils_Tuple2('THORN', 'Þ'),
			_Utils_Tuple2('thorn', 'þ'),
			_Utils_Tuple2('tilde', '˜'),
			_Utils_Tuple2('Tilde', '∼'),
			_Utils_Tuple2('TildeEqual', '≃'),
			_Utils_Tuple2('TildeFullEqual', '≅'),
			_Utils_Tuple2('TildeTilde', '≈'),
			_Utils_Tuple2('timesbar', '⨱'),
			_Utils_Tuple2('timesb', '⊠'),
			_Utils_Tuple2('times', '×'),
			_Utils_Tuple2('timesd', '⨰'),
			_Utils_Tuple2('tint', '∭'),
			_Utils_Tuple2('toea', '⤨'),
			_Utils_Tuple2('topbot', '⌶'),
			_Utils_Tuple2('topcir', '⫱'),
			_Utils_Tuple2('top', '⊤'),
			_Utils_Tuple2('Topf', '\uD835\uDD4B'),
			_Utils_Tuple2('topf', '\uD835\uDD65'),
			_Utils_Tuple2('topfork', '⫚'),
			_Utils_Tuple2('tosa', '⤩'),
			_Utils_Tuple2('tprime', '‴'),
			_Utils_Tuple2('trade', '™'),
			_Utils_Tuple2('TRADE', '™'),
			_Utils_Tuple2('triangle', '▵'),
			_Utils_Tuple2('triangledown', '▿'),
			_Utils_Tuple2('triangleleft', '◃'),
			_Utils_Tuple2('trianglelefteq', '⊴'),
			_Utils_Tuple2('triangleq', '≜'),
			_Utils_Tuple2('triangleright', '▹'),
			_Utils_Tuple2('trianglerighteq', '⊵'),
			_Utils_Tuple2('tridot', '◬'),
			_Utils_Tuple2('trie', '≜'),
			_Utils_Tuple2('triminus', '⨺'),
			_Utils_Tuple2('TripleDot', '⃛'),
			_Utils_Tuple2('triplus', '⨹'),
			_Utils_Tuple2('trisb', '⧍'),
			_Utils_Tuple2('tritime', '⨻'),
			_Utils_Tuple2('trpezium', '⏢'),
			_Utils_Tuple2('Tscr', '\uD835\uDCAF'),
			_Utils_Tuple2('tscr', '\uD835\uDCC9'),
			_Utils_Tuple2('TScy', 'Ц'),
			_Utils_Tuple2('tscy', 'ц'),
			_Utils_Tuple2('TSHcy', 'Ћ'),
			_Utils_Tuple2('tshcy', 'ћ'),
			_Utils_Tuple2('Tstrok', 'Ŧ'),
			_Utils_Tuple2('tstrok', 'ŧ'),
			_Utils_Tuple2('twixt', '≬'),
			_Utils_Tuple2('twoheadleftarrow', '↞'),
			_Utils_Tuple2('twoheadrightarrow', '↠'),
			_Utils_Tuple2('Uacute', 'Ú'),
			_Utils_Tuple2('uacute', 'ú'),
			_Utils_Tuple2('uarr', '↑'),
			_Utils_Tuple2('Uarr', '↟'),
			_Utils_Tuple2('uArr', '⇑'),
			_Utils_Tuple2('Uarrocir', '⥉'),
			_Utils_Tuple2('Ubrcy', 'Ў'),
			_Utils_Tuple2('ubrcy', 'ў'),
			_Utils_Tuple2('Ubreve', 'Ŭ'),
			_Utils_Tuple2('ubreve', 'ŭ'),
			_Utils_Tuple2('Ucirc', 'Û'),
			_Utils_Tuple2('ucirc', 'û'),
			_Utils_Tuple2('Ucy', 'У'),
			_Utils_Tuple2('ucy', 'у'),
			_Utils_Tuple2('udarr', '⇅'),
			_Utils_Tuple2('Udblac', 'Ű'),
			_Utils_Tuple2('udblac', 'ű'),
			_Utils_Tuple2('udhar', '⥮'),
			_Utils_Tuple2('ufisht', '⥾'),
			_Utils_Tuple2('Ufr', '\uD835\uDD18'),
			_Utils_Tuple2('ufr', '\uD835\uDD32'),
			_Utils_Tuple2('Ugrave', 'Ù'),
			_Utils_Tuple2('ugrave', 'ù'),
			_Utils_Tuple2('uHar', '⥣'),
			_Utils_Tuple2('uharl', '↿'),
			_Utils_Tuple2('uharr', '↾'),
			_Utils_Tuple2('uhblk', '▀'),
			_Utils_Tuple2('ulcorn', '⌜'),
			_Utils_Tuple2('ulcorner', '⌜'),
			_Utils_Tuple2('ulcrop', '⌏'),
			_Utils_Tuple2('ultri', '◸'),
			_Utils_Tuple2('Umacr', 'Ū'),
			_Utils_Tuple2('umacr', 'ū'),
			_Utils_Tuple2('uml', '¨'),
			_Utils_Tuple2('UnderBar', '_'),
			_Utils_Tuple2('UnderBrace', '⏟'),
			_Utils_Tuple2('UnderBracket', '⎵'),
			_Utils_Tuple2('UnderParenthesis', '⏝'),
			_Utils_Tuple2('Union', '⋃'),
			_Utils_Tuple2('UnionPlus', '⊎'),
			_Utils_Tuple2('Uogon', 'Ų'),
			_Utils_Tuple2('uogon', 'ų'),
			_Utils_Tuple2('Uopf', '\uD835\uDD4C'),
			_Utils_Tuple2('uopf', '\uD835\uDD66'),
			_Utils_Tuple2('UpArrowBar', '⤒'),
			_Utils_Tuple2('uparrow', '↑'),
			_Utils_Tuple2('UpArrow', '↑'),
			_Utils_Tuple2('Uparrow', '⇑'),
			_Utils_Tuple2('UpArrowDownArrow', '⇅'),
			_Utils_Tuple2('updownarrow', '↕'),
			_Utils_Tuple2('UpDownArrow', '↕'),
			_Utils_Tuple2('Updownarrow', '⇕'),
			_Utils_Tuple2('UpEquilibrium', '⥮'),
			_Utils_Tuple2('upharpoonleft', '↿'),
			_Utils_Tuple2('upharpoonright', '↾'),
			_Utils_Tuple2('uplus', '⊎'),
			_Utils_Tuple2('UpperLeftArrow', '↖'),
			_Utils_Tuple2('UpperRightArrow', '↗'),
			_Utils_Tuple2('upsi', 'υ'),
			_Utils_Tuple2('Upsi', 'ϒ'),
			_Utils_Tuple2('upsih', 'ϒ'),
			_Utils_Tuple2('Upsilon', 'Υ'),
			_Utils_Tuple2('upsilon', 'υ'),
			_Utils_Tuple2('UpTeeArrow', '↥'),
			_Utils_Tuple2('UpTee', '⊥'),
			_Utils_Tuple2('upuparrows', '⇈'),
			_Utils_Tuple2('urcorn', '⌝'),
			_Utils_Tuple2('urcorner', '⌝'),
			_Utils_Tuple2('urcrop', '⌎'),
			_Utils_Tuple2('Uring', 'Ů'),
			_Utils_Tuple2('uring', 'ů'),
			_Utils_Tuple2('urtri', '◹'),
			_Utils_Tuple2('Uscr', '\uD835\uDCB0'),
			_Utils_Tuple2('uscr', '\uD835\uDCCA'),
			_Utils_Tuple2('utdot', '⋰'),
			_Utils_Tuple2('Utilde', 'Ũ'),
			_Utils_Tuple2('utilde', 'ũ'),
			_Utils_Tuple2('utri', '▵'),
			_Utils_Tuple2('utrif', '▴'),
			_Utils_Tuple2('uuarr', '⇈'),
			_Utils_Tuple2('Uuml', 'Ü'),
			_Utils_Tuple2('uuml', 'ü'),
			_Utils_Tuple2('uwangle', '⦧'),
			_Utils_Tuple2('vangrt', '⦜'),
			_Utils_Tuple2('varepsilon', 'ϵ'),
			_Utils_Tuple2('varkappa', 'ϰ'),
			_Utils_Tuple2('varnothing', '∅'),
			_Utils_Tuple2('varphi', 'ϕ'),
			_Utils_Tuple2('varpi', 'ϖ'),
			_Utils_Tuple2('varpropto', '∝'),
			_Utils_Tuple2('varr', '↕'),
			_Utils_Tuple2('vArr', '⇕'),
			_Utils_Tuple2('varrho', 'ϱ'),
			_Utils_Tuple2('varsigma', 'ς'),
			_Utils_Tuple2('varsubsetneq', '⊊︀'),
			_Utils_Tuple2('varsubsetneqq', '⫋︀'),
			_Utils_Tuple2('varsupsetneq', '⊋︀'),
			_Utils_Tuple2('varsupsetneqq', '⫌︀'),
			_Utils_Tuple2('vartheta', 'ϑ'),
			_Utils_Tuple2('vartriangleleft', '⊲'),
			_Utils_Tuple2('vartriangleright', '⊳'),
			_Utils_Tuple2('vBar', '⫨'),
			_Utils_Tuple2('Vbar', '⫫'),
			_Utils_Tuple2('vBarv', '⫩'),
			_Utils_Tuple2('Vcy', 'В'),
			_Utils_Tuple2('vcy', 'в'),
			_Utils_Tuple2('vdash', '⊢'),
			_Utils_Tuple2('vDash', '⊨'),
			_Utils_Tuple2('Vdash', '⊩'),
			_Utils_Tuple2('VDash', '⊫'),
			_Utils_Tuple2('Vdashl', '⫦'),
			_Utils_Tuple2('veebar', '⊻'),
			_Utils_Tuple2('vee', '∨'),
			_Utils_Tuple2('Vee', '⋁'),
			_Utils_Tuple2('veeeq', '≚'),
			_Utils_Tuple2('vellip', '⋮'),
			_Utils_Tuple2('verbar', '|'),
			_Utils_Tuple2('Verbar', '‖'),
			_Utils_Tuple2('vert', '|'),
			_Utils_Tuple2('Vert', '‖'),
			_Utils_Tuple2('VerticalBar', '∣'),
			_Utils_Tuple2('VerticalLine', '|'),
			_Utils_Tuple2('VerticalSeparator', '❘'),
			_Utils_Tuple2('VerticalTilde', '≀'),
			_Utils_Tuple2('VeryThinSpace', '\u200A'),
			_Utils_Tuple2('Vfr', '\uD835\uDD19'),
			_Utils_Tuple2('vfr', '\uD835\uDD33'),
			_Utils_Tuple2('vltri', '⊲'),
			_Utils_Tuple2('vnsub', '⊂⃒'),
			_Utils_Tuple2('vnsup', '⊃⃒'),
			_Utils_Tuple2('Vopf', '\uD835\uDD4D'),
			_Utils_Tuple2('vopf', '\uD835\uDD67'),
			_Utils_Tuple2('vprop', '∝'),
			_Utils_Tuple2('vrtri', '⊳'),
			_Utils_Tuple2('Vscr', '\uD835\uDCB1'),
			_Utils_Tuple2('vscr', '\uD835\uDCCB'),
			_Utils_Tuple2('vsubnE', '⫋︀'),
			_Utils_Tuple2('vsubne', '⊊︀'),
			_Utils_Tuple2('vsupnE', '⫌︀'),
			_Utils_Tuple2('vsupne', '⊋︀'),
			_Utils_Tuple2('Vvdash', '⊪'),
			_Utils_Tuple2('vzigzag', '⦚'),
			_Utils_Tuple2('Wcirc', 'Ŵ'),
			_Utils_Tuple2('wcirc', 'ŵ'),
			_Utils_Tuple2('wedbar', '⩟'),
			_Utils_Tuple2('wedge', '∧'),
			_Utils_Tuple2('Wedge', '⋀'),
			_Utils_Tuple2('wedgeq', '≙'),
			_Utils_Tuple2('weierp', '℘'),
			_Utils_Tuple2('Wfr', '\uD835\uDD1A'),
			_Utils_Tuple2('wfr', '\uD835\uDD34'),
			_Utils_Tuple2('Wopf', '\uD835\uDD4E'),
			_Utils_Tuple2('wopf', '\uD835\uDD68'),
			_Utils_Tuple2('wp', '℘'),
			_Utils_Tuple2('wr', '≀'),
			_Utils_Tuple2('wreath', '≀'),
			_Utils_Tuple2('Wscr', '\uD835\uDCB2'),
			_Utils_Tuple2('wscr', '\uD835\uDCCC'),
			_Utils_Tuple2('xcap', '⋂'),
			_Utils_Tuple2('xcirc', '◯'),
			_Utils_Tuple2('xcup', '⋃'),
			_Utils_Tuple2('xdtri', '▽'),
			_Utils_Tuple2('Xfr', '\uD835\uDD1B'),
			_Utils_Tuple2('xfr', '\uD835\uDD35'),
			_Utils_Tuple2('xharr', '⟷'),
			_Utils_Tuple2('xhArr', '⟺'),
			_Utils_Tuple2('Xi', 'Ξ'),
			_Utils_Tuple2('xi', 'ξ'),
			_Utils_Tuple2('xlarr', '⟵'),
			_Utils_Tuple2('xlArr', '⟸'),
			_Utils_Tuple2('xmap', '⟼'),
			_Utils_Tuple2('xnis', '⋻'),
			_Utils_Tuple2('xodot', '⨀'),
			_Utils_Tuple2('Xopf', '\uD835\uDD4F'),
			_Utils_Tuple2('xopf', '\uD835\uDD69'),
			_Utils_Tuple2('xoplus', '⨁'),
			_Utils_Tuple2('xotime', '⨂'),
			_Utils_Tuple2('xrarr', '⟶'),
			_Utils_Tuple2('xrArr', '⟹'),
			_Utils_Tuple2('Xscr', '\uD835\uDCB3'),
			_Utils_Tuple2('xscr', '\uD835\uDCCD'),
			_Utils_Tuple2('xsqcup', '⨆'),
			_Utils_Tuple2('xuplus', '⨄'),
			_Utils_Tuple2('xutri', '△'),
			_Utils_Tuple2('xvee', '⋁'),
			_Utils_Tuple2('xwedge', '⋀'),
			_Utils_Tuple2('Yacute', 'Ý'),
			_Utils_Tuple2('yacute', 'ý'),
			_Utils_Tuple2('YAcy', 'Я'),
			_Utils_Tuple2('yacy', 'я'),
			_Utils_Tuple2('Ycirc', 'Ŷ'),
			_Utils_Tuple2('ycirc', 'ŷ'),
			_Utils_Tuple2('Ycy', 'Ы'),
			_Utils_Tuple2('ycy', 'ы'),
			_Utils_Tuple2('yen', '¥'),
			_Utils_Tuple2('Yfr', '\uD835\uDD1C'),
			_Utils_Tuple2('yfr', '\uD835\uDD36'),
			_Utils_Tuple2('YIcy', 'Ї'),
			_Utils_Tuple2('yicy', 'ї'),
			_Utils_Tuple2('Yopf', '\uD835\uDD50'),
			_Utils_Tuple2('yopf', '\uD835\uDD6A'),
			_Utils_Tuple2('Yscr', '\uD835\uDCB4'),
			_Utils_Tuple2('yscr', '\uD835\uDCCE'),
			_Utils_Tuple2('YUcy', 'Ю'),
			_Utils_Tuple2('yucy', 'ю'),
			_Utils_Tuple2('yuml', 'ÿ'),
			_Utils_Tuple2('Yuml', 'Ÿ'),
			_Utils_Tuple2('Zacute', 'Ź'),
			_Utils_Tuple2('zacute', 'ź'),
			_Utils_Tuple2('Zcaron', 'Ž'),
			_Utils_Tuple2('zcaron', 'ž'),
			_Utils_Tuple2('Zcy', 'З'),
			_Utils_Tuple2('zcy', 'з'),
			_Utils_Tuple2('Zdot', 'Ż'),
			_Utils_Tuple2('zdot', 'ż'),
			_Utils_Tuple2('zeetrf', 'ℨ'),
			_Utils_Tuple2('ZeroWidthSpace', '\u200B'),
			_Utils_Tuple2('Zeta', 'Ζ'),
			_Utils_Tuple2('zeta', 'ζ'),
			_Utils_Tuple2('zfr', '\uD835\uDD37'),
			_Utils_Tuple2('Zfr', 'ℨ'),
			_Utils_Tuple2('ZHcy', 'Ж'),
			_Utils_Tuple2('zhcy', 'ж'),
			_Utils_Tuple2('zigrarr', '⇝'),
			_Utils_Tuple2('zopf', '\uD835\uDD6B'),
			_Utils_Tuple2('Zopf', 'ℤ'),
			_Utils_Tuple2('Zscr', '\uD835\uDCB5'),
			_Utils_Tuple2('zscr', '\uD835\uDCCF'),
			_Utils_Tuple2('zwj', '\u200D'),
			_Utils_Tuple2('zwnj', '\u200C')
		]));
var $hecrj$html_parser$Html$Parser$namedCharacterReference = A2(
	$elm$parser$Parser$map,
	function (reference) {
		return A2(
			$elm$core$Maybe$withDefault,
			'&' + (reference + ';'),
			A2($elm$core$Dict$get, reference, $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict));
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isAlpha)));
var $elm$core$Char$fromCode = _Char_fromCode;
var $elm$core$Basics$pow = _Basics_pow;
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $elm$core$Char$isHexDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return ((48 <= code) && (code <= 57)) || (((65 <= code) && (code <= 70)) || ((97 <= code) && (code <= 102)));
};
var $hecrj$html_parser$Html$Parser$hexadecimal = A2(
	$elm$parser$Parser$andThen,
	function (hex) {
		var _v0 = $rtfeldman$elm_hex$Hex$fromString(
			$elm$core$String$toLower(hex));
		if (!_v0.$) {
			var value = _v0.a;
			return $elm$parser$Parser$succeed(value);
		} else {
			var error = _v0.a;
			return $elm$parser$Parser$problem(error);
		}
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isHexDigit)));
var $elm$parser$Parser$ExpectingInt = {$: 1};
var $elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
var $elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
var $elm$parser$Parser$Advanced$bumpOffset = F2(
	function (newOffset, s) {
		return {Dv: s.Dv + (newOffset - s.G4), rY: s.rY, p: s.p, G4: newOffset, IM: s.IM, c: s.c};
	});
var $elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
var $elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
var $elm$parser$Parser$Advanced$consumeExp = F2(
	function (offset, src) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 101, offset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 69, offset, src)) {
			var eOffset = offset + 1;
			var expOffset = (A3($elm$parser$Parser$Advanced$isAsciiCode, 43, eOffset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 45, eOffset, src)) ? (eOffset + 1) : eOffset;
			var newOffset = A2($elm$parser$Parser$Advanced$chompBase10, expOffset, src);
			return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
		} else {
			return offset;
		}
	});
var $elm$parser$Parser$Advanced$consumeDotAndExp = F2(
	function (offset, src) {
		return A3($elm$parser$Parser$Advanced$isAsciiCode, 46, offset, src) ? A2(
			$elm$parser$Parser$Advanced$consumeExp,
			A2($elm$parser$Parser$Advanced$chompBase10, offset + 1, src),
			src) : A2($elm$parser$Parser$Advanced$consumeExp, offset, src);
	});
var $elm$parser$Parser$Advanced$finalizeInt = F5(
	function (invalid, handler, startOffset, _v0, s) {
		var endOffset = _v0.a;
		var n = _v0.b;
		if (handler.$ === 1) {
			var x = handler.a;
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		} else {
			var toValue = handler.a;
			return _Utils_eq(startOffset, endOffset) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				_Utils_cmp(s.G4, startOffset) < 0,
				A2($elm$parser$Parser$Advanced$fromState, s, invalid)) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				toValue(n),
				A2($elm$parser$Parser$Advanced$bumpOffset, endOffset, s));
		}
	});
var $elm$parser$Parser$Advanced$finalizeFloat = F6(
	function (invalid, expecting, intSettings, floatSettings, intPair, s) {
		var intOffset = intPair.a;
		var floatOffset = A2($elm$parser$Parser$Advanced$consumeDotAndExp, intOffset, s.c);
		if (floatOffset < 0) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A4($elm$parser$Parser$Advanced$fromInfo, s.IM, s.Dv - (floatOffset + s.G4), invalid, s.rY));
		} else {
			if (_Utils_eq(s.G4, floatOffset)) {
				return A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, expecting));
			} else {
				if (_Utils_eq(intOffset, floatOffset)) {
					return A5($elm$parser$Parser$Advanced$finalizeInt, invalid, intSettings, s.G4, intPair, s);
				} else {
					if (floatSettings.$ === 1) {
						var x = floatSettings.a;
						return A2(
							$elm$parser$Parser$Advanced$Bad,
							true,
							A2($elm$parser$Parser$Advanced$fromState, s, invalid));
					} else {
						var toValue = floatSettings.a;
						var _v1 = $elm$core$String$toFloat(
							A3($elm$core$String$slice, s.G4, floatOffset, s.c));
						if (_v1.$ === 1) {
							return A2(
								$elm$parser$Parser$Advanced$Bad,
								true,
								A2($elm$parser$Parser$Advanced$fromState, s, invalid));
						} else {
							var n = _v1.a;
							return A3(
								$elm$parser$Parser$Advanced$Good,
								true,
								toValue(n),
								A2($elm$parser$Parser$Advanced$bumpOffset, floatOffset, s));
						}
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$number = function (c) {
	return function (s) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 48, s.G4, s.c)) {
			var zeroOffset = s.G4 + 1;
			var baseOffset = zeroOffset + 1;
			return A3($elm$parser$Parser$Advanced$isAsciiCode, 120, zeroOffset, s.c) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.FN,
				c.Fd,
				baseOffset,
				A2($elm$parser$Parser$Advanced$consumeBase16, baseOffset, s.c),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 111, zeroOffset, s.c) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.FN,
				c.z2,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 8, baseOffset, s.c),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 98, zeroOffset, s.c) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.FN,
				c.xn,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 2, baseOffset, s.c),
				s) : A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.FN,
				c.yF,
				c.zb,
				c.yP,
				_Utils_Tuple2(zeroOffset, 0),
				s)));
		} else {
			return A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.FN,
				c.yF,
				c.zb,
				c.yP,
				A3($elm$parser$Parser$Advanced$consumeBase, 10, s.G4, s.c),
				s);
		}
	};
};
var $elm$parser$Parser$Advanced$int = F2(
	function (expecting, invalid) {
		return $elm$parser$Parser$Advanced$number(
			{
				xn: $elm$core$Result$Err(invalid),
				yF: expecting,
				yP: $elm$core$Result$Err(invalid),
				Fd: $elm$core$Result$Err(invalid),
				zb: $elm$core$Result$Ok($elm$core$Basics$identity),
				FN: invalid,
				z2: $elm$core$Result$Err(invalid)
			});
	});
var $elm$parser$Parser$int = A2($elm$parser$Parser$Advanced$int, $elm$parser$Parser$ExpectingInt, $elm$parser$Parser$ExpectingInt);
var $hecrj$html_parser$Html$Parser$numericCharacterReference = function () {
	var codepoint = $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						function (c) {
							return (c === 'x') || (c === 'X');
						})),
				$hecrj$html_parser$Html$Parser$hexadecimal),
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq('0'))),
				$elm$parser$Parser$int)
			]));
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq('#'))),
		A2(
			$elm$parser$Parser$map,
			A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar),
			codepoint));
}();
var $hecrj$html_parser$Html$Parser$characterReference = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('&'))),
	$elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$namedCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$numericCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				$elm$parser$Parser$succeed('&')
			])));
var $hecrj$html_parser$Html$Parser$tagAttributeQuotedValue = function (quote) {
	var isQuotedValueChar = function (c) {
		return (!_Utils_eq(c, quote)) && (c !== '&');
	};
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))),
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$map,
				$elm$core$String$join(''),
				$hecrj$html_parser$Html$Parser$many(
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$getChompedString(
								$hecrj$html_parser$Html$Parser$chompOneOrMore(isQuotedValueChar)),
								$hecrj$html_parser$Html$Parser$characterReference
							])))),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))));
};
var $hecrj$html_parser$Html$Parser$oneOrMore = F2(
	function (type_, parser_) {
		return A2(
			$elm$parser$Parser$loop,
			_List_Nil,
			function (list) {
				return $elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$map,
							function (_new) {
								return $elm$parser$Parser$Loop(
									A2($elm$core$List$cons, _new, list));
							},
							parser_),
							$elm$core$List$isEmpty(list) ? $elm$parser$Parser$problem('expecting at least one ' + type_) : $elm$parser$Parser$succeed(
							$elm$parser$Parser$Done(
								$elm$core$List$reverse(list)))
						]));
			});
	});
var $hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue = function () {
	var isUnquotedValueChar = function (c) {
		return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '=') && ((c !== '<') && ((c !== '>') && ((c !== '`') && (c !== '&')))))));
	};
	return A2(
		$elm$parser$Parser$map,
		$elm$core$String$join(''),
		A2(
			$hecrj$html_parser$Html$Parser$oneOrMore,
			'attribute value',
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$getChompedString(
						$hecrj$html_parser$Html$Parser$chompOneOrMore(isUnquotedValueChar)),
						$hecrj$html_parser$Html$Parser$characterReference
					]))));
}();
var $hecrj$html_parser$Html$Parser$tagAttributeValue = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('='))),
				$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue,
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\"'),
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\'')
					]))),
			$elm$parser$Parser$succeed('')
		]));
var $hecrj$html_parser$Html$Parser$tagAttribute = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Tuple$pair),
		A2(
			$elm$parser$Parser$ignorer,
			$hecrj$html_parser$Html$Parser$tagAttributeName,
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
	A2(
		$elm$parser$Parser$ignorer,
		$hecrj$html_parser$Html$Parser$tagAttributeValue,
		$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)));
var $hecrj$html_parser$Html$Parser$tagAttributes = $hecrj$html_parser$Html$Parser$many($hecrj$html_parser$Html$Parser$tagAttribute);
var $hecrj$html_parser$Html$Parser$tagName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$chompIf($elm$core$Char$isAlphaNum),
			$elm$parser$Parser$chompWhile(
				function (c) {
					return $elm$core$Char$isAlphaNum(c) || (c === '-');
				}))));
var $hecrj$html_parser$Html$Parser$Text = function (a) {
	return {$: 0, a: a};
};
var $hecrj$html_parser$Html$Parser$text = A2(
	$elm$parser$Parser$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$join(''),
		$hecrj$html_parser$Html$Parser$Text),
	A2(
		$hecrj$html_parser$Html$Parser$oneOrMore,
		'text element',
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$getChompedString(
					$hecrj$html_parser$Html$Parser$chompOneOrMore(
						function (c) {
							return (c !== '<') && (c !== '&');
						})),
					$hecrj$html_parser$Html$Parser$characterReference
				]))));
function $hecrj$html_parser$Html$Parser$cyclic$node() {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$hecrj$html_parser$Html$Parser$text,
				$hecrj$html_parser$Html$Parser$comment,
				$hecrj$html_parser$Html$Parser$cyclic$element()
			]));
}
function $hecrj$html_parser$Html$Parser$cyclic$element() {
	return A2(
		$elm$parser$Parser$andThen,
		function (_v0) {
			var name = _v0.a;
			var attributes = _v0.b;
			return $hecrj$html_parser$Html$Parser$isVoidElement(name) ? A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A3($hecrj$html_parser$Html$Parser$Element, name, attributes, _List_Nil)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$chompIf(
								$elm$core$Basics$eq('/')),
								$elm$parser$Parser$succeed(0)
							]))),
				$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('>'))) : A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A2($hecrj$html_parser$Html$Parser$Element, name, attributes)),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('>'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$many(
						$elm$parser$Parser$backtrackable(
							$hecrj$html_parser$Html$Parser$cyclic$node())),
					$hecrj$html_parser$Html$Parser$closingTag(name)));
		},
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Tuple$pair),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$tagName,
					$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
			$hecrj$html_parser$Html$Parser$tagAttributes));
}
var $hecrj$html_parser$Html$Parser$node = $hecrj$html_parser$Html$Parser$cyclic$node();
$hecrj$html_parser$Html$Parser$cyclic$node = function () {
	return $hecrj$html_parser$Html$Parser$node;
};
var $hecrj$html_parser$Html$Parser$element = $hecrj$html_parser$Html$Parser$cyclic$element();
$hecrj$html_parser$Html$Parser$cyclic$element = function () {
	return $hecrj$html_parser$Html$Parser$element;
};
var $hecrj$html_parser$Html$Parser$run = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Result$Ok(_List_Nil) : A2(
		$elm$parser$Parser$run,
		A2($hecrj$html_parser$Html$Parser$oneOrMore, 'node', $hecrj$html_parser$Html$Parser$node),
		str);
};
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $author$project$Translate$Html$CustomParser$toVirtualDomAttribute = function (_v0) {
	var name = _v0.a;
	var value = _v0.b;
	if (name === 'class') {
		return $elm$html$Html$Attributes$class(value);
	} else {
		return A2($elm$html$Html$Attributes$attribute, name, value);
	}
};
var $author$project$Translate$Html$CustomParser$toVirtualDomEach = F2(
	function (funcs, node) {
		switch (node.$) {
			case 1:
				var name = node.a;
				var attrs = node.b;
				var children = node.c;
				var _v1 = A2($elm$core$Dict$get, name, funcs);
				if (!_v1.$) {
					switch (_v1.a.$) {
						case 0:
							var innerFunc = _v1.a.a;
							return innerFunc(
								A2($author$project$Translate$Html$CustomParser$toVirtualDomWithNodeSubstitution, funcs, children));
						case 1:
							var _v2 = _v1.a.a;
							var innerFunc = _v2.a;
							var providedAttrs = _v2.b;
							return A2(
								innerFunc,
								_Utils_ap(
									A2($elm$core$List$map, $author$project$Translate$Html$CustomParser$toVirtualDomAttribute, attrs),
									providedAttrs),
								A2($author$project$Translate$Html$CustomParser$toVirtualDomWithNodeSubstitution, funcs, children));
						default:
							var _v3 = _v1.a.a;
							var innerFunc = _v3.a;
							var providedAttrs = _v3.b;
							return A2(
								innerFunc,
								_Utils_ap(
									providedAttrs,
									A2($elm$core$List$map, $author$project$Translate$Html$CustomParser$toVirtualDomAttribute, attrs)),
								A2($author$project$Translate$Html$CustomParser$toVirtualDomWithNodeSubstitution, funcs, children));
					}
				} else {
					return A3(
						$elm$html$Html$node,
						name,
						A2($elm$core$List$map, $author$project$Translate$Html$CustomParser$toVirtualDomAttribute, attrs),
						A2($author$project$Translate$Html$CustomParser$toVirtualDomWithNodeSubstitution, funcs, children));
				}
			case 0:
				var s = node.a;
				return $elm$html$Html$text(s);
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$Translate$Html$CustomParser$toVirtualDomWithNodeSubstitution = F2(
	function (funcs, nodes) {
		return A2(
			$elm$core$List$map,
			$author$project$Translate$Html$CustomParser$toVirtualDomEach(funcs),
			nodes);
	});
var $author$project$Translate$Html$CustomParser$parseToHtml = F2(
	function (funcsList, translatedToParse) {
		var translatedToParseRaw = $author$project$Translate$extract(translatedToParse);
		return A2(
			$elm$core$Result$withDefault,
			_List_fromArray(
				[
					$elm$html$Html$text(translatedToParseRaw)
				]),
			A2(
				$elm$core$Result$map,
				$author$project$Translate$Html$CustomParser$toVirtualDomWithNodeSubstitution(
					$elm$core$Dict$fromList(funcsList)),
				$hecrj$html_parser$Html$Parser$run(translatedToParseRaw)));
	});
var $author$project$Translate$Html$CustomParser$SimpleRecursiveAppendParsedAttrs = function (a) {
	return {$: 2, a: a};
};
var $author$project$Translate$Html$CustomParser$with = F2(
	function (elmHtmlFunc, providedAttrs) {
		return $author$project$Translate$Html$CustomParser$SimpleRecursiveAppendParsedAttrs(
			_Utils_Tuple2(elmHtmlFunc, providedAttrs));
	});
var $author$project$Login$ConfirmBindForm$boundView = F3(
	function (environment, featureFlags, formData) {
		var copyMessage = A2(
			$author$project$Translate$gettextN,
			'The quote for %{client} was bound on %{bindDate} and is going to become effective on %{effectiveDate}. You will receive an email confirmation with your <strong>binder documents, invoice, and post-bind subjectivities</strong> within a few minutes. In the case you don\'t receive an email confirmation, please reach out to <a>%{underwriter}</a>.',
			_List_fromArray(
				[
					_Utils_Tuple2('client', formData.ft),
					_Utils_Tuple2(
					'bindDate',
					$author$project$Login$ConfirmBindForm$formatDate(formData.C7)),
					_Utils_Tuple2(
					'effectiveDate',
					$author$project$Login$ConfirmBindForm$formatDate(formData.bx)),
					_Utils_Tuple2('underwriter', formData.rh)
				]));
		var cardTitle = $author$project$Translate$gettext('Bound Option');
		var cardFooterHtml = A2($elm$html$Html$div, _List_Nil, _List_Nil);
		var _v0 = formData;
		var boundQuoteOption = _v0.C8;
		var cardTriaHtml = A2(
			$author$project$View$Util$displayIf,
			formData.am,
			function (_v1) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bind-option__data')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bind-option__data-label')
								]),
							_List_fromArray(
								[
									$author$project$Translate$Html$text(
									$author$project$Translate$gettext('TRIA'))
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Translate$Html$text(
									$author$project$Translate$doNotTranslate(
										$author$project$View$Util$toUsdJustString(boundQuoteOption.ov)))
								]))
						]));
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('confirm-bind')
				]),
			_List_fromArray(
				[
					A2($author$project$Login$ConfirmBindForm$logo, environment, featureFlags),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('confirm-bind__copy')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Translate$Html$text(
									$author$project$Translate$gettext('Success! Thank you for renewing with Corvus!'))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							A2(
								$author$project$Translate$Html$CustomParser$parseToHtml,
								_List_fromArray(
									[
										_Utils_Tuple2(
										'strong',
										A2($author$project$Translate$Html$CustomParser$with, $elm$html$Html$strong, _List_Nil)),
										_Utils_Tuple2(
										'a',
										A2(
											$author$project$Translate$Html$CustomParser$with,
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$href('mailto:' + formData.rg)
												])))
									]),
								copyMessage))
						])),
					A5($author$project$Login$ConfirmBindForm$optionCard, cardTitle, cardTriaHtml, cardFooterHtml, formData, boundQuoteOption),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('confirm-bind__copy')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Translate$Html$text(
									$author$project$Translate$gettext('Have a moment to complete a post-bind subjectivity?'))
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(
									$author$project$Login$Route$toUrl(
										$author$project$Login$Route$SurplusLinesLicense(formData.n)))
								]),
							_List_fromArray(
								[
									$author$project$Translate$Html$text(
									$author$project$Translate$gettext('Fill out Surplus Lines Certificate')),
									$author$project$View$Svg$chevronRight('icon teal-fill')
								]))
						]))
				]));
	});
var $author$project$Translate$gettext1 = F2(
	function (msgid, _v0) {
		var key = _v0.a;
		var arg = _v0.b;
		return A3(
			$author$project$Translate$namedValue,
			key,
			arg,
			A2(
				$elm$core$Maybe$withDefault,
				msgid,
				A2($elm$core$Dict$get, msgid, $author$project$Translation$translations)));
	});
var $author$project$Login$ConfirmBindForm$errorView = F3(
	function (environment, featureFlags, errorType) {
		var _v0 = function () {
			if (!errorType.$) {
				var expiredFormData = errorType.a;
				return _Utils_Tuple3(
					A2(
						$author$project$Translate$gettext1,
						'This quote expired on %{expirationDate}.',
						_Utils_Tuple2(
							'expirationDate',
							$author$project$Login$ConfirmBindForm$formatDate(expiredFormData.bB))),
					expiredFormData.rh,
					expiredFormData.rg);
			} else {
				var changedFormData = errorType.a;
				return _Utils_Tuple3(
					$author$project$Translate$gettext('We are not able to process this request at this time.'),
					changedFormData.rh,
					changedFormData.rg);
			}
		}();
		var heading = _v0.a;
		var underwriterName = _v0.b;
		var underwriterEmail = _v0.c;
		var copyMessage = A2(
			$author$project$Translate$gettextN,
			'No worries, you can still bind with us! Please contact <a>%{underwriterName}</a>.',
			_List_fromArray(
				[
					_Utils_Tuple2('underwriterEmail', underwriterEmail),
					_Utils_Tuple2('underwriterName', underwriterName)
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('confirm-bind')
				]),
			_List_fromArray(
				[
					A2($author$project$Login$ConfirmBindForm$logo, environment, featureFlags),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('confirm-bind__copy confirm-bind__copy--error')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Translate$Html$text(heading)
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							A2(
								$author$project$Translate$Html$CustomParser$parseToHtml,
								_List_fromArray(
									[
										_Utils_Tuple2(
										'a',
										A2(
											$author$project$Translate$Html$CustomParser$with,
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$href('mailto:' + underwriterEmail)
												])))
									]),
								copyMessage))
						]))
				]));
	});
var $author$project$Login$ConfirmBindForm$SubmitForm = {$: 3};
var $author$project$View$Svg$helpOutline = $author$project$View$Svg$icon('help-outline');
var $author$project$Login$ConfirmBindForm$ConfirmBindMobile = function (a) {
	return {$: 0, a: a};
};
var $author$project$Login$ConfirmBindForm$ToggleQuoteOptionTria = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$View$Svg$checkbox = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$class('checkbox__icon'),
			$elm$svg$Svg$Attributes$width('24'),
			$elm$svg$Svg$Attributes$height('24'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('unchecked'),
					$elm$svg$Svg$Attributes$d('M19,5v14H5V5H19 M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('indeterminate'),
					$elm$svg$Svg$Attributes$d('M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M17,13H7v-2h10V13z')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('checked'),
					$elm$svg$Svg$Attributes$d('M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M10,17l-5-5l1.4-1.4l3.6,3.6l7.6-7.6 L19,8L10,17z')
				]),
			_List_Nil)
		]));
var $author$project$View$Input$labelledCheckboxWithCustomHtml = F7(
	function (checkboxAttrs, inputId, currentState, displayText, labelAttrs, labelHtml, onClickMsg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('checkbox')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$id(inputId),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$type_('checkbox'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Events$onCheck(onClickMsg),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$checked(currentState),
									checkboxAttrs)))),
					_List_Nil),
					A2(
					$elm$html$Html$label,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$for(inputId),
						labelAttrs),
					_Utils_ap(
						_List_fromArray(
							[
								$author$project$View$Svg$checkbox,
								$elm$html$Html$text(displayText)
							]),
						labelHtml))
				]));
	});
var $author$project$View$Tooltip$viewA11y = F3(
	function (wrapperClasses, triggerIcon, tooltipContent) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(wrapperClasses + ' tool-tip-a11y-trigger'),
					$fapian$elm_html_aria$Html$Attributes$Aria$role('tooltip')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$tabindex(0)
						]),
					_List_fromArray(
						[triggerIcon])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tool-tip-a11y--top display-inline-block')
						]),
					tooltipContent)
				]));
	});
var $author$project$Login$ConfirmBindForm$optionCards = function (formData) {
	var quoteOptions = A2(
		$elm$core$List$sortBy,
		function ($) {
			return $.iq;
		},
		formData.Ia);
	var createBindOptionCard = F2(
		function (index, option) {
			var indexStr = $elm$core$String$fromInt(index + 1);
			var triaHtml = A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bind-option__data')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bind-option__data-label')
							]),
						_List_fromArray(
							[
								A7(
								$author$project$View$Input$labelledCheckboxWithCustomHtml,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$name('option-' + (indexStr + '-tria'))
									]),
								'option-' + (indexStr + '-tria'),
								option.am,
								'TRIA',
								_List_Nil,
								_List_fromArray(
									[
										A3(
										$author$project$View$Tooltip$viewA11y,
										'',
										$author$project$View$Svg$helpOutline(''),
										_List_fromArray(
											[
												$author$project$Translate$Html$text(
												$author$project$Translate$gettext('Terrorism Risk Insurance Act is federal legislation guaranteeing the availability of insurance coverage against acts of international terrorism. Please confirm with your client before waiving as your client may then not be covered against acts of terrorism.'))
											]))
									]),
								$author$project$Login$ConfirmBindForm$ToggleQuoteOptionTria(option))
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Translate$Html$text(
								$author$project$Translate$doNotTranslate(
									$author$project$View$Util$toUsdJustString(option.ov)))
							]))
					]));
			var footerHtml = A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bind-option__button')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button button--primary button--large'),
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Events$onClick(
								$author$project$Login$ConfirmBindForm$ConfirmBindMobile(option.Fm))
							]),
						_List_fromArray(
							[
								$author$project$Translate$Html$text(
								$author$project$Translate$gettext('Confirm Bind'))
							]))
					]));
			var cardTitle = A2(
				$author$project$Translate$gettext1,
				'Option %{index}',
				_Utils_Tuple2('index', indexStr));
			return A5($author$project$Login$ConfirmBindForm$optionCard, cardTitle, triaHtml, footerHtml, formData, option);
		});
	return A2($elm$core$List$indexedMap, createBindOptionCard, quoteOptions);
};
var $author$project$Login$ConfirmBindForm$SelectQuoteOption = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$View$Input$labelledCheckBox = F5(
	function (attributes, inputId, currentState, displayText, onClickMsg) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$id(inputId),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$type_('checkbox'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Events$onCheck(onClickMsg),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$checked(currentState),
								attributes)))),
				_List_Nil),
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$for(inputId)
					]),
				_List_fromArray(
					[
						$author$project$View$Svg$checkbox,
						$elm$html$Html$text(displayText)
					]))
			]);
	});
var $author$project$View$Input$checkbox = F5(
	function (attributes, inputId, currentState, displayText, onClickMsg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('checkbox')
				]),
			A5($author$project$View$Input$labelledCheckBox, attributes, inputId, currentState, displayText, onClickMsg));
	});
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $author$project$Login$ConfirmBindForm$optionRows = function (formData) {
	var quoteOptions = A2(
		$elm$core$List$sortBy,
		function ($) {
			return $.iq;
		},
		formData.Ia);
	var optionRow = F2(
		function (index, option) {
			var indexStr = $elm$core$String$fromInt(index + 1);
			return A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A5(
								$author$project$View$Input$radio,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$name('option-to-bind')
									]),
								'option-' + indexStr,
								_Utils_eq(formData.IV, option.Fm),
								$author$project$Login$ConfirmBindForm$SelectQuoteOption(option.Fm),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('confirm-bind__option-label')
											]),
										_List_fromArray(
											[
												$author$project$Translate$Html$text(
												A2(
													$author$project$Translate$gettext1,
													'Option %{num}',
													_Utils_Tuple2('num', indexStr)))
											]))
									]))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Translate$Html$text(
								$author$project$Translate$alreadyTranslated(
									$author$project$Login$ConfirmBindForm$formatDate(formData.bx)))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Translate$Html$text(
								$author$project$Translate$alreadyTranslated(
									$author$project$Login$ConfirmBindForm$formatDate(formData.bB)))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Translate$Html$text(
								$author$project$Translate$doNotTranslate(
									$author$project$View$Util$toUsdJustString(option.hN)))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Translate$Html$text(
								$author$project$Translate$doNotTranslate(
									$author$project$View$Util$toUsdJustString(option.cI)))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Translate$Html$text(
								$author$project$Translate$doNotTranslate(
									$author$project$View$Util$toUsdJustString(option.iq)))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A5(
								$author$project$View$Input$checkbox,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$name('option-' + (indexStr + '-tria'))
									]),
								'option-' + (indexStr + '-tria'),
								option.am,
								$author$project$View$Util$toUsdJustString(option.ov),
								$author$project$Login$ConfirmBindForm$ToggleQuoteOptionTria(option))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Translate$Html$text(
								$author$project$Translate$doNotTranslate(
									$author$project$View$Util$toUsdJustString(formData.vS)))
							]))
					]));
		});
	return A2($elm$core$List$indexedMap, optionRow, quoteOptions);
};
var $elm$html$Html$Attributes$scope = $elm$html$Html$Attributes$stringProperty('scope');
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $author$project$Login$ConfirmBindForm$readyView = F3(
	function (environment, featureFlags, formData) {
		var headingMessage = A2(
			$author$project$Translate$gettext1,
			'Application-free renewal for <strong>%{client}</strong>',
			_Utils_Tuple2('client', formData.ft));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('confirm-bind')
				]),
			_List_fromArray(
				[
					A2($author$project$Login$ConfirmBindForm$logo, environment, featureFlags),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('confirm-bind__copy')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_Nil,
							A2(
								$author$project$Translate$Html$CustomParser$parseToHtml,
								_List_fromArray(
									[
										_Utils_Tuple2(
										'strong',
										A2($author$project$Translate$Html$CustomParser$with, $elm$html$Html$strong, _List_Nil))
									]),
								headingMessage)),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Translate$Html$text(
									$author$project$Translate$gettext('Upon binding, you will receive an email confirmation with your binder documents, invoice, and post-bind subjectivities.'))
								]))
						])),
					A2(
					$elm$html$Html$form,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('confirm-bind__form-title')
								]),
							_List_fromArray(
								[
									$author$project$Translate$Html$text(
									$author$project$Translate$gettext('Bind Options'))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('confirm-bind__table-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$table,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$thead,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$tr,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$th,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$scope('col')
																]),
															_List_Nil),
															A2(
															$elm$html$Html$th,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$scope('col')
																]),
															_List_fromArray(
																[
																	$author$project$Translate$Html$text(
																	$author$project$Translate$gettext('Effective Date'))
																])),
															A2(
															$elm$html$Html$th,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$scope('col')
																]),
															_List_fromArray(
																[
																	$author$project$Translate$Html$text(
																	$author$project$Translate$gettext('Expiration Date'))
																])),
															A2(
															$elm$html$Html$th,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$scope('col')
																]),
															_List_fromArray(
																[
																	$author$project$Translate$Html$text(
																	$author$project$Translate$gettext('Limit'))
																])),
															A2(
															$elm$html$Html$th,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$scope('col')
																]),
															_List_fromArray(
																[
																	$author$project$Translate$Html$text(
																	$author$project$Translate$gettext('Retention'))
																])),
															A2(
															$elm$html$Html$th,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$scope('col')
																]),
															_List_fromArray(
																[
																	$author$project$Translate$Html$text(
																	$author$project$Translate$gettext('Premium'))
																])),
															A2(
															$elm$html$Html$th,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$scope('col')
																]),
															_List_fromArray(
																[
																	$author$project$Translate$Html$text(
																	$author$project$Translate$gettext('TRIA')),
																	A3(
																	$author$project$View$Tooltip$viewA11y,
																	'',
																	$author$project$View$Svg$helpOutline(''),
																	_List_fromArray(
																		[
																			$author$project$Translate$Html$text(
																			$author$project$Translate$gettext('Terrorism Risk Insurance Act is federal legislation guaranteeing the availability of insurance coverage against acts of international terrorism. Please confirm with your client before waiving as your client may then not be covered against acts of terrorism.'))
																		]))
																])),
															A2(
															$elm$html$Html$th,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$scope('col')
																]),
															_List_fromArray(
																[
																	$author$project$Translate$Html$text(
																	$author$project$Translate$gettext('Policy Fee'))
																]))
														]))
												])),
											A2(
											$elm$html$Html$tbody,
											_List_Nil,
											$author$project$Login$ConfirmBindForm$optionRows(formData))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('confirm-bind__cards-container')
								]),
							$author$project$Login$ConfirmBindForm$optionCards(formData)),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form__footer')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button button--primary'),
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Events$onClick($author$project$Login$ConfirmBindForm$SubmitForm)
										]),
									_List_fromArray(
										[
											$author$project$Translate$Html$text(
											$author$project$Translate$gettext('Confirm Bind'))
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$href('mailto:' + formData.rg)
												]),
											_List_fromArray(
												[
													$author$project$Translate$Html$text(
													A2(
														$author$project$Translate$gettext1,
														'Not seeing what you\'re looking for? Contact %{underwriter}',
														_Utils_Tuple2('underwriter', formData.rh)))
												])),
											$author$project$View$Svg$chevronRight('icon teal-fill')
										]))
								]))
						]))
				]));
	});
var $author$project$Login$ConfirmBindForm$view = F3(
	function (environment, featureFlags, model) {
		var _v0 = model.dA;
		if (_v0.$ === 3) {
			switch (_v0.a.$) {
				case 0:
					var readyFormData = _v0.a.a;
					return A3($author$project$Login$ConfirmBindForm$readyView, environment, featureFlags, readyFormData);
				case 1:
					var boundFormData = _v0.a.a;
					return A3($author$project$Login$ConfirmBindForm$boundView, environment, featureFlags, boundFormData);
				case 3:
					var expiredFormData = _v0.a.a;
					return A3(
						$author$project$Login$ConfirmBindForm$errorView,
						environment,
						featureFlags,
						$author$project$Login$ConfirmBindForm$Expired(expiredFormData));
				default:
					var changedFormData = _v0.a.a;
					return A3(
						$author$project$Login$ConfirmBindForm$errorView,
						environment,
						featureFlags,
						$author$project$Login$ConfirmBindForm$Changed(changedFormData));
			}
		} else {
			return A2($elm$html$Html$div, _List_Nil, _List_Nil);
		}
	});
var $author$project$Login$ForgotPassword$Model$EmailUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Login$ForgotPassword$Model$ForgetPassword = {$: 1};
var $author$project$Login$ForgotPassword$Model$TrackSignInWithExistingAccountLinkClicked = function (a) {
	return {$: 5, a: a};
};
var $author$project$Login$ForgotPassword$Model$TrackNeedHelpLinkClicked = {$: 4};
var $author$project$Login$ForgotPassword$Model$TrackWhoIsCorvusLinkClickedForgotPassword = {$: 3};
var $author$project$Login$ForgotPassword$View$help = A3(
	$author$project$Login$ViewUtil$helpLinksToServicesEmail,
	$author$project$Login$ForgotPassword$Model$TrackWhoIsCorvusLinkClickedForgotPassword,
	$author$project$Translate$gettext('Need help with email address entry for password reset'),
	$author$project$Login$ForgotPassword$Model$TrackNeedHelpLinkClicked);
var $author$project$Login$ForgotPassword$View$title_ = A2(
	$elm$html$Html$h1,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mfa-setup__header')
		]),
	_List_fromArray(
		[
			$author$project$Translate$Html$text(
			$author$project$Translate$gettext('Reset your Password'))
		]));
var $author$project$Login$ForgotPassword$View$forgetPasswordCard = F2(
	function (_v0, formElements) {
		var email = _v0.aW;
		var isTravelersRequestUrl = _v0.zm;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mfa-setup__card')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tw-flex tw-flex-col tw-pb-4 tw-gap-4 tw-leading-[1.7] mfa-setup__info')
						]),
					_List_fromArray(
						[
							$author$project$Login$ForgotPassword$View$title_,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tw-min-h-10 tw-text-center tw-tracking-[0.07px]')
								]),
							_List_fromArray(
								[
									$author$project$Translate$Html$text(
									$author$project$Translate$gettext('Enter your email below to receive a link to reset your password.'))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tw-text-gray-800')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('branded__form'),
									$elm$html$Html$Events$onSubmit($author$project$Login$ForgotPassword$Model$ForgetPassword)
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$View$Branded$emailInput,
									_List_fromArray(
										[
											$elm$html$Html$Events$onInput($author$project$Login$ForgotPassword$Model$EmailUpdated),
											$elm$html$Html$Attributes$value(
											A2($author$project$Model$ValidationNext$toString, $author$project$Data$Email$toString, email)),
											$elm$html$Html$Attributes$autofocus(true)
										]),
									A2(
										$author$project$View$Util$maybeAlert,
										_List_Nil,
										$author$project$Model$ValidationNext$message(email))),
								formElements))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('branded__links')
						]),
					_List_fromArray(
						[
							A5(
							$author$project$UserTracking$LinkTracking$trackableLink,
							$author$project$Login$Route$toUrl,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('branded__link existing-account')
								]),
							_List_fromArray(
								[
									$author$project$Translate$Html$text(
									$author$project$Translate$gettext('Sign in with existing account'))
								]),
							$author$project$Login$ForgotPassword$Model$TrackSignInWithExistingAccountLinkClicked,
							$author$project$Login$Route$defaultSigninRoute)
						])),
					A2(
					$author$project$View$Util$displayIf,
					!isTravelersRequestUrl,
					function (_v1) {
						return $author$project$Login$ForgotPassword$View$help;
					})
				]));
	});
var $author$project$Login$ForgotPassword$View$view = function (model) {
	var _v0 = model.gW;
	switch (_v0.$) {
		case 0:
			return A2(
				$author$project$Login$ForgotPassword$View$forgetPasswordCard,
				model,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('branded__form-group')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button branded__button-login')
									]),
								_List_fromArray(
									[
										$author$project$Translate$Html$text(
										$author$project$Translate$gettext('Reset password'))
									]))
							]))
					]));
		case 1:
			return A2(
				$author$project$Login$ForgotPassword$View$forgetPasswordCard,
				model,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('branded__form-group')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$View$Button$loading,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button branded__button-login')
									]),
								_List_fromArray(
									[
										$author$project$Translate$Html$text(
										$author$project$Translate$gettext('Resetting…'))
									]))
							]))
					]));
		case 2:
			return A2(
				$author$project$Login$ForgotPassword$View$forgetPasswordCard,
				model,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('branded__form-group')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button branded__button -warning')
									]),
								_List_fromArray(
									[
										$author$project$Translate$Html$text(
										$author$project$Translate$gettext('Reset password'))
									])),
								A2(
								$author$project$View$Util$alertTranslate,
								_List_Nil,
								$author$project$Translate$gettext('Please check the email address again.'))
							]))
					]));
		default:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mfa-setup__card')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tw-flex tw-flex-col tw-pb-4 tw-gap-4 tw-leading-[1.7]')
							]),
						_List_fromArray(
							[$author$project$Login$ForgotPassword$View$title_])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('alert alert--success')
							]),
						_List_fromArray(
							[
								$author$project$Translate$Html$text(
								$author$project$Translate$gettext('Success: Please check your email for a link to reset your password.'))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('branded__form-group')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button branded__button-login'),
										$author$project$Login$ViewUtil$href($author$project$Login$Route$defaultSigninRoute)
									]),
								_List_fromArray(
									[
										$author$project$Translate$Html$text(
										$author$project$Translate$gettext('Go to sign in page'))
									]))
							])),
						A2(
						$author$project$View$Util$displayIf,
						!model.zm,
						function (_v1) {
							return $author$project$Login$ForgotPassword$View$help;
						})
					]));
	}
};
var $author$project$Login$Ransomware$Model$EmailEntered = function (a) {
	return {$: 6, a: a};
};
var $author$project$Login$Ransomware$Model$SendNonBrokerEmail = {$: 13};
var $author$project$Login$Ransomware$View$nonBrokerMessage = function (model) {
	var _v0 = model.By;
	if (_v0.$ === 3) {
		return $elm$html$Html$text('Signed, Sealed, Delivered. Your calculation is waiting in your inbox');
	} else {
		return $elm$html$Html$text('Enter your work email address to send this calculation straight to your inbox.');
	}
};
var $author$project$Login$Ransomware$View$nonAuthButtons = function (model) {
	var showEmailAlert = function () {
		var _v4 = model.aW;
		if (_v4.$ === 2) {
			return true;
		} else {
			return false;
		}
	}();
	var button_ = function () {
		var _v1 = model.By;
		switch (_v1.$) {
			case 1:
				return A2(
					$author$project$View$Button$loading,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form__group button')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Sending…')
						]));
			case 2:
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Something went wrong')
						]));
			default:
				var emailDisabled = function () {
					var _v3 = model.aW;
					switch (_v3.$) {
						case 1:
							return false;
						case 0:
							if (_v3.a === '') {
								return true;
							} else {
								return false;
							}
						default:
							return true;
					}
				}();
				var isInvalid = function () {
					var _v2 = _Utils_Tuple2(model.ft, emailDisabled);
					if (_v2.a.$ === 1) {
						if (!_v2.b) {
							return false;
						} else {
							return true;
						}
					} else {
						return true;
					}
				}();
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form__group button'),
							$elm$html$Html$Events$onClick($author$project$Login$Ransomware$Model$SendNonBrokerEmail),
							$elm$html$Html$Attributes$disabled(isInvalid)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Email PDF')
						]));
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('m-b3')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ransomware__message')
					]),
				_List_fromArray(
					[
						$author$project$Login$Ransomware$View$nonBrokerMessage(model)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form__group flex justify-content')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('email'),
								$elm$html$Html$Attributes$type_('email'),
								$elm$html$Html$Attributes$class('form__group m-r4'),
								$elm$html$Html$Events$onInput($author$project$Login$Ransomware$Model$EmailEntered),
								$elm$html$Html$Attributes$value(
								A2($author$project$Model$ValidationNext$toString, $author$project$Data$Email$toString, model.aW))
							]),
						_List_Nil),
						button_
					])),
				A2(
				$author$project$View$Util$displayIf,
				showEmailAlert,
				function (_v0) {
					return A2(
						$author$project$View$Util$alert,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form__group button')
							]),
						'That doesn’t look like an email address');
				})
			]));
};
var $author$project$Login$Ransomware$View$buttonsSection = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ransomware__buttons-nonbroker')
			]),
		_List_fromArray(
			[
				$author$project$Login$Ransomware$View$nonAuthButtons(model)
			]));
};
var $author$project$Login$Ransomware$View$clientNameDisplay = function (name) {
	if (name === '') {
		return 'Your Client';
	} else {
		return name;
	}
};
var $author$project$Login$Ransomware$View$costSample = F2(
	function (_v0, clientName) {
		var costFifteenDaysCents = _v0.lG;
		var costSixtyDaysCents = _v0.lI;
		var costThirtyDaysCents = _v0.lJ;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ransomware__cost-sample')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('m-b2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$String$append,
								'Total estimated cost for ',
								$author$project$Login$Ransomware$View$clientNameDisplay(clientName)))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Total cyber loss estimates may be great as this calculation does not include: regulatory fines, penalties, PCI-DSS assessment expenses, cyber crime/ financial fraud, and reputational loss')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-wrap')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex-child')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Over 15 days')
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('c-accent fs-1')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$View$Util$toUsdJustString(costFifteenDaysCents))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex-child')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Over 30 days')
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('c-accent fs-1')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$View$Util$toUsdJustString(costThirtyDaysCents))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex-child')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Over 60 days')
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('c-accent fs-1')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$View$Util$toUsdJustString(costSixtyDaysCents))
										]))
								]))
						]))
				]));
	});
var $author$project$Login$Ransomware$View$industryExampleAutoDealers = $elm$html$Html$text('A luxury auto dealership with five locations was hit with a ransomware attack that completely encrypted its systems and backups. After being notified by the policyholder, Corvus recommended privacy counsel and a forensics firm who negotiated the six figure ransom down to 1/6 of its initial amount. The forensics investigation concluded no access to or exfiltration of sensitive information, and counsel advised breach notification was not required. Costs incurred included legal, forensics, extortion payment, and data recovery.');
var $author$project$Login$Ransomware$View$industryExampleConstruction = $elm$html$Html$text('A construction firm was hit with a ransomware attack and most of its servers were encrypted. After notifying Corvus under their cyber policy, the policyholder worked with recommended privacy counsel and a forensics firm. Fortunately, the firm had backups, so negotiation and payment was not necessary. After a thorough forensics investigation, it was determined that no data had been accessed or exfiltrated. Costs incurred included legal and forensics.');
var $author$project$Login$Ransomware$View$industryExampleEducation = $elm$html$Html$text('An educational services provider fell victim to a ransomware attack after a malicious actor exploited an open port to encrypt a significant portion of its servers and workstations. With the help of recommended privacy counsel and a forensics firm, the $1,000,000 ransom, to be paid in cryptocurrency, was negotiated down to low six figures. A forensic investigation revealed that no data had been accessed. Costs incurred included legal, forensics, and the extortion payment.');
var $author$project$Login$Ransomware$View$industryExampleGeneric = $elm$html$Html$text('An organization suffered a ransomware attack after an employee opened a phishing email attachment which encrypted all of its systems and workspaces. After reporting the claim to Corvus, the policyholder was introduced to recommended privacy counsel and a forensics firm. While the threat actor did not respond to contact and so no ransom could be paid, with the assistance of Corvus-approved IT vendors, the policyholder successfully restored all data. Costs incurred included legal, forensics, and data recovery.');
var $author$project$Login$Ransomware$View$industryExampleHealthcare = $elm$html$Html$text('A medical provider with multiple offices was hit with ransomware, and the threat actor demanded a seven-figure ransom in cryptocurrency. After notifying Corvus, the policyholder consulted with recommended privacy counsel and a digital forensics firm who negotiated the ransom down to a quarter of its initial amount, which the policyholder paid. The forensics investigation revealed that sensitive patient information had been exfiltrated, so the policyholder worked with counsel to draft and send notifications via letters and call center vendor.');
var $author$project$Login$Ransomware$View$industryExampleManufacturing = $elm$html$Html$text('A metal wholesaler was hit with a ransomware attack with an initial ransom of over $1,000,000 to be paid in cryptocurrency. After notifying Corvus under their cyber policy, the policyholder worked with recommended privacy counsel and a forensics firm who negotiated the ransom down to a low six figure sum, which the policyholder paid to obtain a decryption tool. Costs incurred included legal, forensics, data restoration, the extortion payment and related fees, and a claim of business interruption.');
var $author$project$Login$Ransomware$View$industryExampleRetail = $elm$html$Html$text('A retailer suffered a ransomware attack after an employee clicked a malicious link. Although a cryptocurrency ransom was demanded, the policyholder fortunately had viable, off-site backups. After notifying Corvus, recommended privacy counsel and a forensics firm determined that no personally identifiable information was exposed. Due to its solid backup practices and assistance from the Corvus-approved vendors, the policyholder was up and running within a few days. Costs incurred included legal and forensics.');
var $author$project$Login$Ransomware$View$industryExampleBody = function (natureOfBusiness) {
	switch (natureOfBusiness) {
		case 'Hardware Manufacturers':
			return $author$project$Login$Ransomware$View$industryExampleManufacturing;
		case 'Manufacturing / Distribution':
			return $author$project$Login$Ransomware$View$industryExampleManufacturing;
		case 'Healthcare Consultants':
			return $author$project$Login$Ransomware$View$industryExampleHealthcare;
		case 'Health Department':
			return $author$project$Login$Ransomware$View$industryExampleHealthcare;
		case 'Health Practitioner / Physicians / Dentists':
			return $author$project$Login$Ransomware$View$industryExampleHealthcare;
		case 'Health Services - Medical Group':
			return $author$project$Login$Ransomware$View$industryExampleHealthcare;
		case 'Hospitals':
			return $author$project$Login$Ransomware$View$industryExampleHealthcare;
		case 'Schools (K-12)':
			return $author$project$Login$Ransomware$View$industryExampleEducation;
		case 'Higher Education (College / Univ.)':
			return $author$project$Login$Ransomware$View$industryExampleEducation;
		case 'Online Retailer':
			return $author$project$Login$Ransomware$View$industryExampleRetail;
		case 'Retail Sales':
			return $author$project$Login$Ransomware$View$industryExampleRetail;
		case 'Auto Dealers':
			return $author$project$Login$Ransomware$View$industryExampleAutoDealers;
		case 'Construction Services':
			return $author$project$Login$Ransomware$View$industryExampleConstruction;
		default:
			return $author$project$Login$Ransomware$View$industryExampleGeneric;
	}
};
var $author$project$Login$Ransomware$View$scalesImage = function (isTravelersRequestUrl) {
	var url = isTravelersRequestUrl ? 'https://cdn.corvusinsurance.com/images/ransomware-computer-graphic-9ba051bf2856b716bb7a5cda0328c96e.svg' : 'https://cdn.corvusinsurance.com/images/calculator-54f540a15b7a01641bdd7928774ba42d.svg';
	return A2(
		$elm$html$Html$img,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$alt('Ransomware Calculator'),
				$elm$html$Html$Attributes$class('ransomware__img'),
				$elm$html$Html$Attributes$src(url)
			]),
		_List_Nil);
};
var $author$project$Login$Ransomware$View$industryExample = F2(
	function (maybeNoB, isTravelersRequestUrl) {
		if (!maybeNoB.$) {
			var nob = maybeNoB.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ransomware__industry-example flex align-center')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex-child')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('m-b2')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Claims example for '),
										$elm$html$Html$text(nob)
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('fs-5')
									]),
								_List_fromArray(
									[
										$author$project$Login$Ransomware$View$industryExampleBody(nob)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex-child')
							]),
						_List_fromArray(
							[
								$author$project$Login$Ransomware$View$scalesImage(isTravelersRequestUrl)
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Login$Ransomware$View$contentView = function (model) {
	var _v0 = model.AS;
	if (!_v0.$) {
		var ransomwareResult = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ransomware__content')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Login$Ransomware$View$costSample,
					ransomwareResult,
					A2($author$project$Model$ValidationNext$toString, $elm$core$Basics$identity, model.ft)),
					A2($author$project$Login$Ransomware$View$industryExample, model.D, model.zm),
					A2(
					$author$project$View$Util$displayIf,
					$elm_community$maybe_extra$Maybe$Extra$isJust(model.AS),
					function (_v1) {
						return $author$project$Login$Ransomware$View$buttonsSection(model);
					})
				]));
	} else {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ransomware__content')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ransomware__content--empty')
						]),
					_List_fromArray(
						[
							$author$project$Login$Ransomware$View$scalesImage(model.zm),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ransomware__empty-text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Hang tight, your calculation will appear here shortly…')
								]))
						]))
				]));
	}
};
var $author$project$Login$Ransomware$Model$CostOfGoodsEntered = function (a) {
	return {$: 3, a: a};
};
var $author$project$Login$Ransomware$Model$CostOfGoodsSold = 1;
var $author$project$Login$Ransomware$Model$DigitalExposureEntered = function (a) {
	return {$: 4, a: a};
};
var $author$project$Login$Ransomware$Model$RevenueReliantOnComputers = 0;
var $author$project$Login$Ransomware$Model$BreachResponseInputEntered = function (a) {
	return {$: 0, a: a};
};
var $author$project$Login$Ransomware$Model$GetCalculation = {$: 7};
var $author$project$View$Input$numbersOnly = A2(
	$elm$regex$Regex$replace,
	A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[^\\d]')),
	function (_v0) {
		return '';
	});
var $author$project$View$Input$currencyInput = F3(
	function (onInputMsg, rawValue, attributes) {
		return A2(
			$elm$html$Html$input,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Events$onInput(
					A2($elm$core$Basics$composeR, $author$project$View$Input$numbersOnly, onInputMsg)),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$type_('text'),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$value(
							$author$project$View$Util$formatUsdDollarsStr(rawValue)),
						attributes))),
			_List_Nil);
	});
var $author$project$Login$Ransomware$View$editabilityToolTipText = function (pageView) {
	if (pageView === 1) {
		return '.';
	} else {
		return '. Change this number to see how it affects the total cost.';
	}
};
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Login$Ransomware$View$tooltip = F2(
	function (header, content) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tool-tip-trigger')
				]),
			_List_fromArray(
				[
					$author$project$View$Svg$helpOutline('c-accent icon--with-text'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tool-tip')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('c-accent m-b2')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(header)
								])),
							$elm$html$Html$text(content)
						]))
				]));
	});
var $author$project$Login$Ransomware$View$breachResponseField = F2(
	function (breachResponse, pageView) {
		var isDisabled = function () {
			if (pageView === 1) {
				return true;
			} else {
				return false;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form__group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form__label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Breach Response Cost (Industry Average)'),
							A2(
							$author$project$Login$Ransomware$View$tooltip,
							'Breach Response Cost (Industry Average)',
							'This is calculated based on industry class and revenue' + $author$project$Login$Ransomware$View$editabilityToolTipText(pageView))
						])),
					A3(
					$author$project$View$Input$currencyInput,
					$author$project$Login$Ransomware$Model$BreachResponseInputEntered,
					breachResponse,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('breach-response'),
							$elm$html$Html$Attributes$placeholder('$1,000,000'),
							$elm$html$Html$Events$onBlur($author$project$Login$Ransomware$Model$GetCalculation),
							$elm$html$Html$Attributes$disabled(isDisabled)
						]))
				]));
	});
var $author$project$Login$Ransomware$Model$ClientNameEntered = function (a) {
	return {$: 1, a: a};
};
var $author$project$Login$Ransomware$Model$ClientNameValidated = {$: 2};
var $author$project$Login$Ransomware$View$clientNameField = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form__group')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form__label')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Client Name')
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form__control'),
						$elm$html$Html$Attributes$id('client-name'),
						$elm$html$Html$Events$onInput($author$project$Login$Ransomware$Model$ClientNameEntered),
						$elm$html$Html$Events$onBlur($author$project$Login$Ransomware$Model$ClientNameValidated),
						$elm$html$Html$Attributes$value(
						$author$project$Model$ValidationNext$extract(model.ft)),
						$elm$html$Html$Attributes$placeholder('Client Name'),
						$elm$html$Html$Attributes$type_('text')
					]),
				_List_Nil),
				A2(
				$author$project$View$Util$maybeAlert,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('m-t4')
					]),
				$author$project$Model$ValidationNext$message(model.ft))
			]));
};
var $author$project$Login$Ransomware$Model$DataRecoveryInputEntered = function (a) {
	return {$: 5, a: a};
};
var $author$project$Login$Ransomware$View$dataRecoveryField = F2(
	function (dataRecovery, pageView) {
		var isDisabled = function () {
			if (pageView === 1) {
				return true;
			} else {
				return false;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form__group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form__label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Data Recovery Costs (Industry Average)'),
							A2(
							$author$project$Login$Ransomware$View$tooltip,
							'Recovery Costs and Extra Expenses (Industry Average)',
							'This is calculated based on industry class and revenue' + $author$project$Login$Ransomware$View$editabilityToolTipText(pageView))
						])),
					A3(
					$author$project$View$Input$currencyInput,
					$author$project$Login$Ransomware$Model$DataRecoveryInputEntered,
					dataRecovery,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('data-recovery'),
							$elm$html$Html$Attributes$placeholder('$500,000'),
							$elm$html$Html$Events$onBlur($author$project$Login$Ransomware$Model$GetCalculation),
							$elm$html$Html$Attributes$disabled(isDisabled)
						]))
				]));
	});
var $author$project$Login$Ransomware$Model$GrossAnnualRevenueEntered = function (a) {
	return {$: 8, a: a};
};
var $author$project$Model$ValidationNext$isInvalid = function (validation) {
	if (validation.$ === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Login$Ransomware$View$grossAnnualRevenueField = function (revenue) {
	var revenueString = function () {
		var _v1 = $author$project$Model$ValidationNext$extract(revenue);
		if (!_v1) {
			return '';
		} else {
			var revenue_ = _v1;
			return $elm$core$String$fromInt(revenue_);
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form__group')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form__label')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Gross Annual Revenue'),
						A2($author$project$Login$Ransomware$View$tooltip, 'Gross Annual Revenue', 'We use this to determine annual interruption expenses and breach-related costs.')
					])),
				A3(
				$author$project$View$Input$currencyInput,
				$author$project$Login$Ransomware$Model$GrossAnnualRevenueEntered,
				revenueString,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('revenue'),
						$elm$html$Html$Attributes$placeholder('$1,000,000'),
						$elm$html$Html$Events$onBlur($author$project$Login$Ransomware$Model$GetCalculation)
					])),
				A2(
				$author$project$View$Util$displayIf,
				$author$project$Model$ValidationNext$isInvalid(revenue),
				function (_v0) {
					return A2(
						$author$project$View$Util$alert,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('m-t3')
							]),
						'Please enter revenue up to $2,000,000,000');
				})
			]));
};
var $author$project$Login$Ransomware$Model$NoBEntered = function (a) {
	return {$: 9, a: a};
};
var $author$project$Login$Ransomware$View$natureOfBusinessConfig = {
	Ee: 'Select Industry',
	Ej: $elm$core$Basics$always(false),
	FZ: $author$project$Login$Ransomware$Model$NoBEntered,
	F$: $elm$core$Basics$identity,
	F0: $elm$core$Basics$identity
};
var $author$project$View$Select$onChange = function (withSelectedValue) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$andThen, withSelectedValue, $elm$html$Html$Events$targetValue));
};
var $elm$html$Html$option = _VirtualDom_node('option');
var $elm$html$Html$select = _VirtualDom_node('select');
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $author$project$View$Select$selectedValueToItem = F3(
	function (config, items, selectedValue) {
		var selectedItem = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Basics$eq(selectedValue),
					config.F0),
				items));
		if (selectedItem.$ === 1) {
			return $elm$json$Json$Decode$fail('Invalid item selected');
		} else {
			var item = selectedItem.a;
			return $elm$json$Json$Decode$succeed(
				config.FZ(item));
		}
	});
var $author$project$View$Select$viewItem = F3(
	function (config, selectedItem, item) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$disabled(
					config.Ej(item)),
					$elm$html$Html$Attributes$value(
					config.F0(item)),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(
						A2($elm$core$Maybe$map, config.F0, selectedItem),
						$elm$core$Maybe$Just(
							config.F0(item))))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					config.F$(item))
				]));
	});
var $author$project$View$Select$viewWithAttrsAndParentClass = F5(
	function (config, selectedItem, data, attrs, parentClass) {
		var placeholderActive = function () {
			if (selectedItem.$ === 1) {
				return true;
			} else {
				var item = selectedItem.a;
				return !A2($elm$core$List$member, item, data);
			}
		}();
		var initialOption = A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$disabled(true),
					$elm$html$Html$Attributes$selected(placeholderActive)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(config.Ee)
				]));
		var colorStyle = placeholderActive ? $elm$html$Html$Attributes$class('empty') : $elm$html$Html$Attributes$class('');
		var selectAttrs = A2(
			$elm$core$List$append,
			_List_fromArray(
				[colorStyle]),
			A2(
				$elm$core$List$append,
				attrs,
				_List_fromArray(
					[
						$author$project$View$Select$onChange(
						A2($author$project$View$Select$selectedValueToItem, config, data))
					])));
		var allOptions = A2(
			$elm$core$List$cons,
			initialOption,
			A2(
				$elm$core$List$map,
				A2($author$project$View$Select$viewItem, config, selectedItem),
				data));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(parentClass, true),
							_Utils_Tuple2(
							'select--single-option',
							$elm$core$List$length(data) === 1)
						]))
				]),
			_List_fromArray(
				[
					A2($elm$html$Html$select, selectAttrs, allOptions)
				]));
	});
var $author$project$View$Select$viewWithAttrs = F4(
	function (config, selectedItem, data, attrs) {
		return A5($author$project$View$Select$viewWithAttrsAndParentClass, config, selectedItem, data, attrs, 'select-wrapper');
	});
var $author$project$Login$Ransomware$View$natureOfBusinessField = function (natureOfBusiness) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form__group')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form__label')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Nature of Business'),
						A2($author$project$Login$Ransomware$View$tooltip, 'Nature of Business', 'We use this to determine industry-wide averages for your calculation.')
					])),
				A4(
				$author$project$View$Select$viewWithAttrs,
				$author$project$Login$Ransomware$View$natureOfBusinessConfig,
				natureOfBusiness,
				$author$project$Model$NatureOfBusiness$cyber,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('nature-of-business'),
						$elm$html$Html$Attributes$class('form__control')
					]))
			]));
};
var $author$project$Login$Ransomware$Model$RansomPaymentInputEntered = function (a) {
	return {$: 11, a: a};
};
var $author$project$Login$Ransomware$View$ransomPaymentField = F2(
	function (ransom, pageView) {
		var isDisabled = function () {
			if (pageView === 1) {
				return true;
			} else {
				return false;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form__group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form__label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Ransom Payment (Industry Average)'),
							A2(
							$author$project$Login$Ransomware$View$tooltip,
							'Ransom Costs (Industry Average)',
							'This is calculated based on industry class and revenue' + $author$project$Login$Ransomware$View$editabilityToolTipText(pageView))
						])),
					A3(
					$author$project$View$Input$currencyInput,
					$author$project$Login$Ransomware$Model$RansomPaymentInputEntered,
					ransom,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('ransom-payment'),
							$elm$html$Html$Attributes$placeholder('$1,000,000'),
							$elm$html$Html$Events$onBlur($author$project$Login$Ransomware$Model$GetCalculation),
							$elm$html$Html$Attributes$disabled(isDisabled)
						]))
				]));
	});
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $author$project$View$Util$onChange = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, msg, $elm$html$Html$Events$targetValue));
};
var $elm$html$Html$Events$onMouseUp = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseup',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Attributes$step = function (n) {
	return A2($elm$html$Html$Attributes$stringProperty, 'step', n);
};
var $author$project$Login$Ransomware$View$stringPercentFromFloat = function (_float) {
	return (_float === 100.0) ? '100%' : A2(
		$elm$core$String$append,
		A3(
			$elm$core$String$slice,
			0,
			2,
			$elm$core$String$fromFloat(_float)),
		'%');
};
var $author$project$Login$Ransomware$View$sliderView = F4(
	function (slider, _float, msg, pageView) {
		var isDisabled = function () {
			if (pageView === 1) {
				return true;
			} else {
				return false;
			}
		}();
		var _v0 = function () {
			if (!slider) {
				return _Utils_Tuple2(
					'Revenue Reliant on Computers',
					'We use this to determine the annual exposure cost. This is determined by industry class' + $author$project$Login$Ransomware$View$editabilityToolTipText(pageView));
			} else {
				return _Utils_Tuple2(
					'Cost of Goods Sold',
					'We use this to determine net annual business interruption expenses. This is calculated based on industry class' + $author$project$Login$Ransomware$View$editabilityToolTipText(pageView));
			}
		}();
		var labelText = _v0.a;
		var toolTipText = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form__group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form__label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(labelText),
							A2($author$project$Login$Ransomware$View$tooltip, labelText, toolTipText),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('slider__group')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('slider__container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('range'),
													$elm$html$Html$Attributes$min('0'),
													$elm$html$Html$Attributes$max('100'),
													$elm$html$Html$Attributes$value(
													$elm$core$String$fromFloat(_float)),
													$elm$html$Html$Attributes$step('1'),
													$elm$html$Html$Attributes$class('slider'),
													$elm$html$Html$Events$onInput(msg),
													$author$project$View$Util$onChange(msg),
													$elm$html$Html$Events$onMouseUp($author$project$Login$Ransomware$Model$GetCalculation),
													$elm$html$Html$Attributes$disabled(isDisabled)
												]),
											_List_Nil),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('slider__steps')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('slider__step')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('0')
														])),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('slider__step')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('50')
														])),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('slider__step')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('100')
														]))
												]))
										])),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(
											$author$project$Login$Ransomware$View$stringPercentFromFloat(_float)),
											$elm$html$Html$Attributes$disabled(true),
											$elm$html$Html$Attributes$class('slider__value')
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Login$Ransomware$View$sliderField = F4(
	function (slider, maybeFloat, msg, pageView) {
		if (maybeFloat.$ === 1) {
			return A4($author$project$Login$Ransomware$View$sliderView, slider, 0.0, msg, pageView);
		} else {
			var _float = maybeFloat.a;
			return A4($author$project$Login$Ransomware$View$sliderView, slider, _float, msg, pageView);
		}
	});
var $author$project$Login$Ransomware$View$inputFields = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ransomware__form')
			]),
		_List_fromArray(
			[
				$author$project$Login$Ransomware$View$clientNameField(model),
				$author$project$Login$Ransomware$View$natureOfBusinessField(model.D),
				$author$project$Login$Ransomware$View$grossAnnualRevenueField(model.bG),
				A4($author$project$Login$Ransomware$View$sliderField, 0, model.yr, $author$project$Login$Ransomware$Model$DigitalExposureEntered, model.Ad),
				A4($author$project$Login$Ransomware$View$sliderField, 1, model.x2, $author$project$Login$Ransomware$Model$CostOfGoodsEntered, model.Ad),
				A2($author$project$Login$Ransomware$View$ransomPaymentField, model.AQ, model.Ad),
				A2($author$project$Login$Ransomware$View$dataRecoveryField, model.yg, model.Ad),
				A2($author$project$Login$Ransomware$View$breachResponseField, model.xw, model.Ad)
			]));
};
var $author$project$Login$Ransomware$View$mainSection = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ransomware__card')
			]),
		_List_fromArray(
			[
				$author$project$Login$Ransomware$View$inputFields(model),
				$author$project$Login$Ransomware$View$contentView(model)
			]));
};
var $author$project$View$Header$arbitrary = function (attributes) {
	return $elm$html$Html$header(
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('page-header'),
			attributes));
};
var $author$project$View$Header$pageTitle = function (text_) {
	return A2(
		$elm$html$Html$h1,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('page-header__title')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(text_)
			]));
};
var $author$project$View$Header$simple = function (text_) {
	return A2(
		$author$project$View$Header$arbitrary,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$View$Header$pageTitle(text_)
			]));
};
var $author$project$Login$Ransomware$View$view = function (model) {
	var headerTitle = model.zm ? A2(
		$elm$html$Html$h1,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ransomware__header-title')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Ransomware Calculator')
			])) : $author$project$View$Header$simple('Ransomware Calculator');
	var descriptionContent = 'Let\'s calculate the approximate cost of a ransomware event leading to a shutdown of all operations. All you need is the policyholder\'s company name, nature of business, and gross annual revenue.';
	var headerDescription = model.zm ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ransomware__header-description')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(descriptionContent)
			])) : A2(
		$elm$html$Html$p,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(descriptionContent)
			]));
	return model.zm ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ransomware')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ransomware__header-section')
					]),
				_List_fromArray(
					[headerTitle, headerDescription])),
				$author$project$Login$Ransomware$View$mainSection(model)
			])) : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ransomware')
			]),
		_List_fromArray(
			[
				headerTitle,
				headerDescription,
				$author$project$Login$Ransomware$View$mainSection(model)
			]));
};
var $author$project$Login$SigninV2$Model$CloseMfaModal = {$: 13};
var $author$project$Login$SigninV2$Model$CopyToClipboard = function (a) {
	return {$: 0, a: a};
};
var $author$project$Login$SigninV2$Model$DoSignin = {$: 1};
var $author$project$Login$SigninV2$Model$GoToNextMfaSetupStep = {$: 6};
var $author$project$Login$SigninV2$Model$GoToPreviousMfaSetupStep = {$: 5};
var $author$project$Login$SigninV2$Model$MfaCodeUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Login$SigninV2$Model$MfaSetupNeedHelpClicked = {$: 9};
var $author$project$Login$SigninV2$Model$OpenMfaModal = {$: 12};
var $krisajenkins$remotedata$RemoteData$isLoading = function (data) {
	if (data.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Login$SigninV2$Model$TrackNeedHelpLinkClicked = {$: 22};
var $author$project$Login$SigninV2$Model$TrackSignInWithExistingAccountLinkClicked = function (a) {
	return {$: 17, a: a};
};
var $author$project$Login$SigninV2$Model$TrackWhoIsCorvusLinkClickedForgotPassword = {$: 23};
var $author$project$Login$SigninV2$View$resetPasswordInfo = function (flashMessage) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('tw-min-h-10')
			]),
		$elm$core$List$singleton(
			A2(
				$elm$core$Maybe$withDefault,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tw-text-center tw-tracking-[0.07px]')
						]),
					_List_fromArray(
						[
							$author$project$Translate$Html$text(
							$author$project$Translate$gettext('Your password must be at least 8 characters.'))
						])),
				A2(
					$elm$core$Maybe$map,
					$author$project$View$Util$alert(_List_Nil),
					flashMessage))));
};
var $author$project$Login$SigninV2$Model$PasswordConfirmationUpdated = function (a) {
	return {$: 18, a: a};
};
var $author$project$Login$SigninV2$Model$PasswordUpdated = function (a) {
	return {$: 19, a: a};
};
var $author$project$Login$SigninV2$Model$ResetPassword = {$: 20};
var $author$project$Login$SigninV2$Model$VisibilityButtonClickedOnConfirmPasswordField = {$: 26};
var $author$project$Login$SigninV2$Model$VisibilityButtonClickedOnCreatePasswordField = {$: 25};
var $author$project$Translate$Html$blankElement = $elm$html$Html$text('');
var $fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel = $elm$html$Html$Attributes$attribute('aria-label');
var $author$project$Translate$Html$Attributes$Aria$ariaLabel = A2($elm$core$Basics$composeR, $author$project$Translate$extract, $fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel);
var $author$project$View$Svg$visibility = $author$project$View$Svg$icon('visibility');
var $author$project$View$Branded$passwordInputWithLabel = F8(
	function (attrs, showVisibilityButton, onClickMsg, isPasswordVisible, warning, inputId, autocompleteString, labelText) {
		var onClickAction = A2(
			$elm$html$Html$Events$preventDefaultOn,
			'click',
			$elm$json$Json$Decode$succeed(
				_Utils_Tuple2(onClickMsg, true)));
		var inputType = isPasswordVisible ? 'text' : 'password';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('branded__form-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for(inputId),
							$elm$html$Html$Attributes$class('branded__label')
						]),
					_List_fromArray(
						[
							$author$project$Translate$Html$text(labelText)
						])),
					A2(
					$elm$html$Html$input,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$id(inputId),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$type_(inputType),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$name('password'),
								A2(
									$elm$core$List$cons,
									$author$project$Translate$Html$Attributes$autocomplete(autocompleteString),
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$required(true),
										A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$class('branded__input'),
											attrs)))))),
					_List_Nil),
					A2(
					$author$project$View$Util$displayIf,
					showVisibilityButton,
					function (_v0) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('branded__input--visibility-button'),
									onClickAction,
									$author$project$Translate$Html$Attributes$Aria$ariaLabel(
									$author$project$Translate$gettext('Toggle Password Visibility'))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('button')
										]),
									_List_fromArray(
										[
											$author$project$View$Svg$visibility('')
										]))
								]));
					}),
					warning
				]));
	});
var $author$project$View$Branded$confirmNewPasswordInput = F5(
	function (attrs, displayVisibilityButton, visibilityButtonOnClickMsg, isPasswordVisible, warning) {
		return A8(
			$author$project$View$Branded$passwordInputWithLabel,
			attrs,
			displayVisibilityButton,
			visibilityButtonOnClickMsg,
			isPasswordVisible,
			warning,
			'confirmPassword',
			'new-password',
			$author$project$Translate$gettext('Confirm Password'));
	});
var $author$project$View$Svg$lock = $author$project$View$Svg$icon('lock');
var $author$project$View$Branded$emailInputDisabled = F3(
	function (attrs, warning, isTravelersRequestUrl) {
		var inputClasses = isTravelersRequestUrl ? $elm$html$Html$Attributes$class('branded__input') : $elm$html$Html$Attributes$class('!tw-p-0 !tw-border-none !tw-shadow-none !tw-bg-transparent tw-text-ellipsis');
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('branded__form-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for('email-input'),
							$elm$html$Html$Attributes$class('branded__label')
						]),
					_List_fromArray(
						[
							$author$project$Translate$Html$text(
							$author$project$Translate$gettext('Email Address'))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('tw-flex form__control disabled tw-items-center', !isTravelersRequestUrl)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$id('email-input'),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$type_('email'),
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$name('username'),
										A2(
											$elm$core$List$cons,
											$author$project$Translate$Html$Attributes$autocomplete('username off'),
											A2(
												$elm$core$List$cons,
												inputClasses,
												A2(
													$elm$core$List$cons,
													$elm$html$Html$Attributes$disabled(true),
													attrs)))))),
							_List_Nil),
							A2(
							$author$project$View$Util$displayIf,
							!isTravelersRequestUrl,
							function (_v0) {
								return $author$project$View$Svg$lock('tw-ml-2 !tw-w-4 !tw-h-4 tw-top-[2.7rem] tw-right-6 tw-text-gray-600');
							})
						])),
					warning
				]));
	});
var $author$project$View$Branded$newPasswordInput = F5(
	function (attrs, displayVisibilityButton, visibilityButtonOnClickMsg, isPasswordVisible, warning) {
		return A8(
			$author$project$View$Branded$passwordInputWithLabel,
			attrs,
			displayVisibilityButton,
			visibilityButtonOnClickMsg,
			isPasswordVisible,
			warning,
			'password',
			'new-password',
			$author$project$Translate$gettext('Create Password'));
	});
var $author$project$Login$SigninV2$View$doublePassword = F3(
	function (_v0, _v1, siblings) {
		var email = _v0.aW;
		var password = _v0.d$;
		var passwordConfirmation = _v0.vO;
		var isTravelersRequestUrl = _v1.zm;
		var isCreatePasswordVisible = _v1.zg;
		var isConfirmPasswordVisible = _v1.ze;
		var emailField = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Translate$Html$blankElement,
			A2(
				$elm$core$Maybe$map,
				function (emailStr) {
					return A3(
						$author$project$View$Branded$emailInputDisabled,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$value(emailStr)
							]),
						$author$project$Translate$Html$blankElement,
						isTravelersRequestUrl);
				},
				email));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('branded__form-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('branded__form'),
							$elm$html$Html$Events$onSubmit($author$project$Login$SigninV2$Model$ResetPassword)
						]),
					A2(
						$elm$core$List$cons,
						emailField,
						A2(
							$elm$core$List$cons,
							A5(
								$author$project$View$Branded$newPasswordInput,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput($author$project$Login$SigninV2$Model$PasswordUpdated),
										$elm$html$Html$Attributes$value(
										A2($author$project$Model$ValidationNext$toString, $author$project$Data$Password$toString, password)),
										$elm$html$Html$Attributes$autofocus(true)
									]),
								isTravelersRequestUrl,
								$author$project$Login$SigninV2$Model$VisibilityButtonClickedOnCreatePasswordField,
								isCreatePasswordVisible,
								A2(
									$author$project$View$Util$maybeAlert,
									_List_Nil,
									$author$project$Model$ValidationNext$message(password))),
							A2(
								$elm$core$List$cons,
								A5(
									$author$project$View$Branded$confirmNewPasswordInput,
									_List_fromArray(
										[
											$elm$html$Html$Events$onInput($author$project$Login$SigninV2$Model$PasswordConfirmationUpdated),
											$elm$html$Html$Attributes$value(
											A2($author$project$Model$ValidationNext$toString, $author$project$Data$Password$toString, passwordConfirmation))
										]),
									isTravelersRequestUrl,
									$author$project$Login$SigninV2$Model$VisibilityButtonClickedOnConfirmPasswordField,
									isConfirmPasswordVisible,
									A2(
										$author$project$View$Util$maybeAlert,
										_List_Nil,
										$author$project$Model$ValidationNext$message(passwordConfirmation))),
								siblings))))
				]));
	});
var $author$project$Login$SigninV2$View$resetPasswordInputSection = F2(
	function (model, details) {
		var buttonText = function () {
			var _v1 = model.I5;
			if (!_v1) {
				return $author$project$Translate$gettext('Create Password and Sign In');
			} else {
				return $author$project$Translate$gettext('Create New Password and Log In');
			}
		}();
		var _v0 = model.Iz;
		switch (_v0.$) {
			case 0:
				return A3(
					$author$project$Login$SigninV2$View$doublePassword,
					model,
					details,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button branded__button-login'),
									$elm$html$Html$Attributes$type_('submit')
								]),
							_List_fromArray(
								[
									$author$project$Translate$Html$text(buttonText)
								]))
						]));
			case 1:
				return A3(
					$author$project$Login$SigninV2$View$doublePassword,
					model,
					details,
					_List_fromArray(
						[
							A2(
							$author$project$View$Button$loading,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button branded__button-login'),
									$elm$html$Html$Attributes$type_('submit')
								]),
							_List_fromArray(
								[
									$author$project$Translate$Html$text(
									$author$project$Translate$gettext('Setting password…'))
								]))
						]));
			case 3:
				return A3(
					$author$project$Login$SigninV2$View$doublePassword,
					model,
					details,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$disabled(true),
									$elm$html$Html$Attributes$class('button branded__button-login -success'),
									$elm$html$Html$Attributes$type_('submit')
								]),
							_List_fromArray(
								[
									$author$project$Translate$Html$text(
									$author$project$Translate$gettext('Password set'))
								]))
						]));
			default:
				if ((_v0.a.$ === 3) && (_v0.a.a === 422)) {
					return A3(
						$author$project$Login$SigninV2$View$doublePassword,
						model,
						details,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button branded__button-login -warning'),
										$elm$html$Html$Attributes$type_('submit')
									]),
								_List_fromArray(
									[
										$author$project$Translate$Html$text(buttonText)
									])),
								A2(
								$author$project$View$Util$alertTranslate,
								_List_Nil,
								$author$project$Translate$gettext('Password must be at least 20 characters.'))
							]));
				} else {
					return A3(
						$author$project$Login$SigninV2$View$doublePassword,
						model,
						details,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button branded__button -warning'),
										$elm$html$Html$Attributes$type_('submit')
									]),
								_List_fromArray(
									[
										$author$project$Translate$Html$text(buttonText)
									])),
								A2(
								$author$project$View$Util$alertTranslate,
								_List_Nil,
								$author$project$Translate$gettext('Failed to set your password, please try again.'))
							]));
				}
		}
	});
var $author$project$Login$SigninV2$View$signinHeader = function (isTravelersRequestUrl) {
	var headerText = isTravelersRequestUrl ? $author$project$Translate$gettext('Welcome to Travelers') : $author$project$Translate$gettext('Sign in');
	return A2(
		$elm$html$Html$h1,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mfa-setup__header large')
			]),
		_List_fromArray(
			[
				$author$project$Translate$Html$text(headerText)
			]));
};
var $author$project$Login$SigninV2$View$resetPasswordView = F2(
	function (model, details) {
		var _v0 = function () {
			var _v1 = model.I5;
			if (!_v1) {
				return _Utils_Tuple2(
					$author$project$Translate$gettext('Create Your Password'),
					$author$project$Translate$gettext('Need help creating a password for account setup'));
			} else {
				return _Utils_Tuple2(
					$author$project$Translate$gettext('Reset Your Password'),
					$author$project$Translate$gettext('Need help creating a new password for reset'));
			}
		}();
		var title_ = _v0.a;
		var helpEmailSubject = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mfa-setup__card')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tw-flex tw-flex-col tw-pb-4 tw-gap-4 tw-leading-[1.7]')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$View$Util$displayIf,
							!model.I5,
							function (_v2) {
								return $author$project$Login$SigninV2$View$signinHeader(model.zm);
							}),
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__header')
								]),
							_List_fromArray(
								[
									$author$project$Translate$Html$text(title_)
								])),
							$author$project$Login$SigninV2$View$resetPasswordInfo(model.yO)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tw-text-gray-800')
						]),
					_List_fromArray(
						[
							A2($author$project$Login$SigninV2$View$resetPasswordInputSection, model, details)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('branded__links !tw-mt-4')
						]),
					_List_fromArray(
						[
							A5(
							$author$project$UserTracking$LinkTracking$trackableLink,
							$author$project$Login$Route$toUrl,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('branded__link existing-account')
								]),
							_List_fromArray(
								[
									$author$project$Translate$Html$text(
									$author$project$Translate$gettext('Sign in with existing account'))
								]),
							$author$project$Login$SigninV2$Model$TrackSignInWithExistingAccountLinkClicked,
							$author$project$Login$Route$defaultSigninRoute)
						])),
					A2(
					$author$project$View$Util$displayIf,
					!model.zm,
					function (_v3) {
						return A3($author$project$Login$ViewUtil$helpLinksToServicesEmail, $author$project$Login$SigninV2$Model$TrackWhoIsCorvusLinkClickedForgotPassword, helpEmailSubject, $author$project$Login$SigninV2$Model$TrackNeedHelpLinkClicked);
					})
				]));
	});
var $author$project$Login$SigninV2$View$signinRequestLoading = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mfa-setup__card')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tw-flex tw-flex-col')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mfa-setup__header')
						]),
					_List_fromArray(
						[
							$author$project$Translate$Html$text(
							$author$project$Translate$gettext('Signing in…'))
						]))
				]))
		]));
var $author$project$Login$SigninV2$Model$TrackForgotYourPasswordLinkClicked = function (a) {
	return {$: 16, a: a};
};
var $author$project$Translate$rawTemp = $elm$core$Basics$identity;
var $author$project$Login$SigninV2$View$insertLink = function (message) {
	return A2($elm$core$String$contains, 'Looks like you clicked an old link.', message) ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('alert alert-block alert--warning m-b3')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					$author$project$Translate$Html$text(
						$author$project$Translate$rawTemp(message)),
					A2(
						$author$project$Translate$Html$CustomParser$parseToHtml,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'a--1',
								A2(
									$author$project$Translate$Html$CustomParser$with,
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('link'),
											$author$project$Login$ViewUtil$href($author$project$Login$Route$ForgotPassword)
										])))
							]),
						$author$project$Translate$gettext('<a--1>Reset your Password</a--1> if you forgot it.'))))
			])) : A2(
		$author$project$View$Util$alertTranslate,
		_List_Nil,
		$author$project$Translate$rawTemp(message));
};
var $author$project$Login$SigninV2$View$info = F2(
	function (flashMessage, isTravelersRequestUrl) {
		var infoText = isTravelersRequestUrl ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tw-text-center tw-tracking-[0.07px] mfa-setup__info')
				]),
			A2(
				$author$project$Translate$Html$CustomParser$parseToHtml,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						A2($author$project$Translate$Html$CustomParser$with, $elm$html$Html$strong, _List_Nil))
					]),
				$author$project$Translate$gettext('Log in to securely access and manage your <tag>Travelers Cyber Risk Dashboard</tag>'))) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tw-text-center tw-tracking-[0.07px]')
				]),
			_List_fromArray(
				[
					$author$project$Translate$Html$text(
					$author$project$Translate$gettext('Sign in to manage your Corvus Insurance dashboard.'))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tw-min-h-10')
				]),
			$elm$core$List$singleton(
				A2(
					$elm$core$Maybe$withDefault,
					infoText,
					A2($elm$core$Maybe$map, $author$project$Login$SigninV2$View$insertLink, flashMessage))));
	});
var $author$project$Login$SigninV2$View$alertWith = function (httpError) {
	if ((httpError.$ === 3) && (httpError.a === 410)) {
		return A2(
			$author$project$View$Util$alertTranslate,
			_List_Nil,
			$author$project$Translate$gettext('Please sign in with your admin credentials to continue.'));
	} else {
		return A2(
			$author$project$View$Util$alertTranslate,
			_List_Nil,
			$author$project$Translate$gettext('Incorrect Email or Password.'));
	}
};
var $author$project$Login$SigninV2$View$disableForOkta = F2(
	function (email, isProduction) {
		var emailString = A2($author$project$Model$ValidationNext$toString, $author$project$Data$Email$toString, email);
		var oktaUser = $author$project$Login$SigninV2$Model$isCorvusEmail(emailString) || $author$project$Login$SigninV2$Model$isTravelersEmail(emailString);
		return isProduction ? oktaUser : (oktaUser && (!$author$project$Login$SigninV2$Model$isCorvusPlusAddressEmail(emailString)));
	});
var $author$project$View$Util$inlineMailTo = function (email) {
	var mailto = $elm$core$String$concat(
		_List_fromArray(
			['mailto:', email]));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('display-inline')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('link'),
						$elm$html$Html$Attributes$href(mailto)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(email)
					]))
			]));
};
var $author$project$Translate$Html$space = $elm$html$Html$text(' ');
var $author$project$View$Util$pWithInlineMailToTranslate = F2(
	function (message, email) {
		return A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Translate$Html$text(message),
					$author$project$Translate$Html$space,
					$author$project$View$Util$inlineMailTo(email),
					$elm$html$Html$text('.')
				]));
	});
var $author$project$Login$SigninV2$Model$EmailBlurred = {$: 2};
var $author$project$Login$SigninV2$Model$EmailUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Login$SigninV2$Model$VisibilityButtonClickedOnPasswordField = {$: 24};
var $author$project$View$Branded$currentPasswordInput = F5(
	function (attrs, displayVisibilityButton, visibilityButtonOnClickMsg, isPasswordVisible, warning) {
		return A8(
			$author$project$View$Branded$passwordInputWithLabel,
			attrs,
			displayVisibilityButton,
			visibilityButtonOnClickMsg,
			isPasswordVisible,
			warning,
			'password',
			'current-password',
			$author$project$Translate$gettext('Password'));
	});
var $elm$html$Html$Attributes$novalidate = $elm$html$Html$Attributes$boolProperty('noValidate');
var $author$project$Login$SigninV2$View$signinForm = F2(
	function (details, siblings) {
		var email = details.aW;
		var isProduction = details.zk;
		var password = details.d$;
		var conditionalPasswordInput = A5(
			$author$project$View$Branded$currentPasswordInput,
			_List_fromArray(
				[
					$elm$html$Html$Events$onInput($author$project$Login$SigninV2$Model$PasswordUpdated),
					$elm$html$Html$Attributes$value(
					A2($author$project$Model$ValidationNext$toString, $author$project$Data$Password$toString, password)),
					$elm$html$Html$Attributes$disabled(
					A2($author$project$Login$SigninV2$View$disableForOkta, email, isProduction))
				]),
			details.zm,
			$author$project$Login$SigninV2$Model$VisibilityButtonClickedOnPasswordField,
			details.zi,
			A2(
				$author$project$View$Util$maybeAlert,
				_List_Nil,
				$author$project$Model$ValidationNext$message(password)));
		return A2(
			$elm$html$Html$form,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('branded__form'),
					$elm$html$Html$Attributes$novalidate(true),
					$elm$html$Html$Events$onSubmit($author$project$Login$SigninV2$Model$DoSignin)
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$View$Branded$emailInput,
					_List_fromArray(
						[
							$elm$html$Html$Events$onInput($author$project$Login$SigninV2$Model$EmailUpdated),
							$elm$html$Html$Attributes$value(
							A2($author$project$Model$ValidationNext$toString, $author$project$Data$Email$toString, email)),
							$elm$html$Html$Attributes$autofocus(true),
							$elm$html$Html$Events$onBlur($author$project$Login$SigninV2$Model$EmailBlurred)
						]),
					A2(
						$author$project$View$Util$maybeAlert,
						_List_Nil,
						$author$project$Model$ValidationNext$message(email))),
				A2($elm$core$List$cons, conditionalPasswordInput, siblings)));
	});
var $author$project$Login$SigninV2$View$inputSection = function (details) {
	var email = details.aW;
	var isProduction = details.zk;
	var signinRequest = details.BH;
	switch (signinRequest.$) {
		case 0:
			return A2(
				$author$project$Login$SigninV2$View$signinForm,
				details,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('branded__form-group')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button branded__button-login'),
										$elm$html$Html$Attributes$disabled(
										A2($author$project$Login$SigninV2$View$disableForOkta, email, isProduction))
									]),
								_List_fromArray(
									[
										$author$project$Translate$Html$text(
										$author$project$Translate$gettext('Sign in'))
									]))
							]))
					]));
		case 1:
			return A2(
				$author$project$Login$SigninV2$View$signinForm,
				details,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('branded__form-group')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$View$Button$loading,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button branded__button-login')
									]),
								_List_fromArray(
									[
										$author$project$Translate$Html$text(
										$author$project$Translate$gettext('Signing in…'))
									]))
							]))
					]));
		case 3:
			switch (signinRequest.a.$) {
				case 0:
					var _v1 = signinRequest.a;
					return A2(
						$author$project$Login$SigninV2$View$signinForm,
						details,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('branded__form-group')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$disabled(true),
												$elm$html$Html$Attributes$class('button branded__button -success')
											]),
										_List_fromArray(
											[
												$author$project$Translate$Html$text(
												$author$project$Translate$gettext('Signed in'))
											]))
									]))
							]));
				case 2:
					var _v2 = signinRequest.a;
					return $author$project$Translate$Html$blankElement;
				case 1:
					return $author$project$Translate$Html$blankElement;
				default:
					var _v3 = signinRequest.a;
					return A2(
						$author$project$Login$SigninV2$View$signinForm,
						details,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('branded__form-group')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$disabled(true),
												$elm$html$Html$Attributes$class('button branded__button -warning')
											]),
										_List_fromArray(
											[
												$author$project$Translate$Html$text(
												$author$project$Translate$gettext('Signed in'))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('alert alert--block alert--warning')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$View$Util$pWithInlineMailToTranslate,
												$author$project$Translate$gettext('There is an issue with your account. Please reach out to us at'),
												'help@corvusinsurance.com')
											]))
									]))
							]));
			}
		default:
			var httpError = signinRequest.a;
			return A2(
				$author$project$Login$SigninV2$View$signinForm,
				details,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('branded__form-group')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$disabled(true),
										$elm$html$Html$Attributes$class('button branded__button -warning')
									]),
								_List_fromArray(
									[
										$author$project$Translate$Html$text(
										$author$project$Translate$gettext('Sign in'))
									])),
								$author$project$Login$SigninV2$View$alertWith(httpError)
							]))
					]));
	}
};
var $author$project$Login$SigninV2$Model$TrackWhoIsCorvusLinkClickedLogin = {$: 15};
var $author$project$Login$SigninV2$View$whoIsCorvusLink = A2(
	$author$project$View$Util$externalNewTabLink,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('branded__link -who'),
			$elm$html$Html$Attributes$href('https://www.corvusinsurance.com/'),
			$elm$html$Html$Events$onClick($author$project$Login$SigninV2$Model$TrackWhoIsCorvusLinkClickedLogin)
		]),
	_List_fromArray(
		[
			$author$project$Translate$Html$text(
			$author$project$Translate$gettext('Who is Corvus?'))
		]));
var $author$project$Login$SigninV2$View$signinView = F3(
	function (details, flashMessage, isTravelersRequestUrl) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mfa-setup__card')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tw-flex tw-flex-col tw-pb-4 tw-gap-4 tw-leading-[1.7]')
						]),
					_List_fromArray(
						[
							$author$project$Login$SigninV2$View$signinHeader(isTravelersRequestUrl),
							A2($author$project$Login$SigninV2$View$info, flashMessage, isTravelersRequestUrl)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tw-text-gray-800')
						]),
					_List_fromArray(
						[
							$author$project$Login$SigninV2$View$inputSection(details)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('branded__links')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$View$Util$displayIf,
							!isTravelersRequestUrl,
							function (_v0) {
								return $author$project$Login$SigninV2$View$whoIsCorvusLink;
							}),
							A5(
							$author$project$UserTracking$LinkTracking$trackableLink,
							$author$project$Login$Route$toUrl,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('branded__link -forgot')
								]),
							_List_fromArray(
								[
									$author$project$Translate$Html$text(
									$author$project$Translate$gettext('Forgot your password?'))
								]),
							$author$project$Login$SigninV2$Model$TrackForgotYourPasswordLinkClicked,
							$author$project$Login$Route$ForgotPassword)
						]))
				]));
	});
var $author$project$View$Modal$Config = $elm$core$Basics$identity;
var $author$project$View$Modal$body = F2(
	function (html, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				k8: $elm$core$Maybe$Just(html)
			});
	});
var $author$project$View$Modal$containerClickDecoder = function (closeMsg) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (c) {
			return A2($elm$core$String$contains, 'modal__container', c) ? $elm$json$Json$Decode$succeed(
				_Utils_Tuple2(closeMsg, true)) : $elm$json$Json$Decode$fail('noOp');
		},
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['target', 'className']),
			$elm$json$Json$Decode$string));
};
var $author$project$View$Modal$contentClass = function (width) {
	switch (width) {
		case 0:
			return $elm$html$Html$Attributes$class('modal__content--fit-content');
		case 1:
			return $elm$html$Html$Attributes$class('modal__content--full');
		case 2:
			return $elm$html$Html$Attributes$class('modal__content--large');
		case 3:
			return $elm$html$Html$Attributes$class('modal__content--medium');
		case 4:
			return $elm$html$Html$Attributes$class('modal__content--no-margin');
		case 5:
			return $elm$html$Html$Attributes$class('modal__content--small');
		default:
			return $elm$html$Html$Attributes$class('modal__content--tight');
	}
};
var $author$project$View$Modal$contentPositionClassString = function (modifier) {
	switch (modifier) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Just('modal--centered');
		default:
			return $elm$core$Maybe$Just('modal--full-fixed-margins');
	}
};
var $author$project$View$Modal$dimmerColorClassString = function (modifier) {
	switch (modifier) {
		case 0:
			return $elm$core$Maybe$Just('modal--dark');
		case 1:
			return $elm$core$Maybe$Nothing;
		case 2:
			return $elm$core$Maybe$Just('modal--light');
		case 3:
			return $elm$core$Maybe$Just('modal--lighter');
		default:
			return $elm$core$Maybe$Just('modal--transparent');
	}
};
var $author$project$View$Modal$wrapBody = $elm$core$Maybe$map(
	A2(
		$elm$core$Basics$composeL,
		$elm$html$Html$div(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal__main')
				])),
		$elm$core$List$singleton));
var $author$project$View$Modal$wrapFooter = $elm$core$Maybe$map(
	A2(
		$elm$core$Basics$composeL,
		$elm$html$Html$div(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal__footer--small')
				])),
		$elm$core$List$singleton));
var $author$project$View$Modal$wrapHeader = $elm$core$Maybe$map(
	A2(
		$elm$core$Basics$composeL,
		$elm$html$Html$div(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal__header flex justify-between align-center')
				])),
		$elm$core$List$singleton));
var $author$project$View$Modal$buildView = function (_v0) {
	var configFields = _v0;
	var topLevelClassStrings = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				$elm$core$Maybe$Just('modal'),
				$elm$core$Maybe$Just('modal__container'),
				$author$project$View$Modal$contentPositionClassString(configFields.lD),
				$author$project$View$Modal$dimmerColorClassString(configFields.l5)
			]));
	var onClickOutside = function () {
		var _v1 = configFields.pi;
		if (_v1.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var closeMsg_ = _v1.a;
			return $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$Events$stopPropagationOn,
					'click',
					$author$project$View$Modal$containerClickDecoder(closeMsg_)));
		}
	}();
	var bodyStyles = A2(
		$elm$core$List$cons,
		$elm$html$Html$Attributes$class('modal__content'),
		A2(
			$elm$core$List$cons,
			$author$project$View$Modal$contentClass(configFields.v),
			configFields.mR));
	var additionalAttrs = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[onClickOutside]));
	return A2(
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class(
				A2($elm$core$String$join, ' ', topLevelClassStrings)),
			additionalAttrs),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				bodyStyles,
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$author$project$View$Modal$wrapHeader(configFields.mw),
							$author$project$View$Modal$wrapBody(configFields.k8),
							$author$project$View$Modal$wrapFooter(configFields.mq)
						])))
			]));
};
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $author$project$View$Svg$closeX = function (classList) {
	var classes = 'closeX__icon ' + classList;
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class(classes),
				$elm$svg$Svg$Attributes$width('14'),
				$elm$svg$Svg$Attributes$height('14'),
				$elm$svg$Svg$Attributes$viewBox('0 0 14 14'),
				$elm$svg$Svg$Attributes$fill('currentColor')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M14 1.4L12.6 0L7 5.6L1.4 0L0 1.4L5.6 7L0 12.6L1.4 14L7 8.4L12.6 14L14 12.6L8.4 7L14 1.4Z')
					]),
				_List_Nil)
			]));
};
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $author$project$View$Svg$closeXTrv = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$class('closeXTrv__icon'),
			$elm$svg$Svg$Attributes$width('12'),
			$elm$svg$Svg$Attributes$height('12'),
			$elm$svg$Svg$Attributes$viewBox('0 0 12 12'),
			$elm$svg$Svg$Attributes$stroke('#007395')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M11 1L1 11 M11 11L1 1')
				]),
			_List_Nil)
		]));
var $author$project$View$Modal$DefaultDimmerColor = 1;
var $author$project$View$Modal$DefaultPosition = 0;
var $author$project$View$Modal$Medium = 3;
var $author$project$View$Modal$config = function (closeMsg) {
	return {
		k8: $elm$core$Maybe$Nothing,
		pi: $elm$core$Maybe$Just(closeMsg),
		lD: 0,
		l5: 1,
		mq: $elm$core$Maybe$Nothing,
		mw: $elm$core$Maybe$Nothing,
		mR: _List_Nil,
		v: 3
	};
};
var $author$project$View$Modal$mainBodyStyles = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{mR: attrs});
	});
var $author$project$Login$MfaSetup$authenticatorOptionsModal = function (_v0) {
	var closeMfaModal = _v0.rS;
	var showTravelersVersion = _v0.jv;
	var recommendedApps = _List_fromArray(
		['Google Authenticator', 'Microsoft Authenticator', 'Aegis Authenticator', 'Authy', 'Okta Verify']);
	var headerText = showTravelersVersion ? $author$project$Translate$gettext('Suggested Authenticator Apps') : $author$project$Translate$gettext('Suggested authenticator apps');
	var closeModalIcon = showTravelersVersion ? $author$project$View$Svg$closeXTrv : $author$project$View$Svg$closeX('');
	var body = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('tw-flex tw-flex-col')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mfa-setup__modal-close'),
						$elm$html$Html$Events$onClick(closeMfaModal)
					]),
				_List_fromArray(
					[closeModalIcon])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mfa-setup__modal-header')
					]),
				_List_fromArray(
					[
						$author$project$Translate$Html$text(headerText)
					])),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mfa-setup__recommended-apps')
					]),
				A2(
					$elm$core$List$map,
					function (app) {
						return A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Translate$Html$text(
									$author$project$Translate$doNotTranslate(app))
								]));
					},
					recommendedApps))
			]));
	return $author$project$View$Modal$buildView(
		A2(
			$author$project$View$Modal$body,
			body,
			A2(
				$author$project$View$Modal$mainBodyStyles,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mfa-setup__modal-body')
					]),
				$author$project$View$Modal$config(closeMfaModal))));
};
var $author$project$CorvusDesignSystem$cdsAttributeToHtmlAttribute = function (attr) {
	var htmlAttr = attr;
	return htmlAttr;
};
var $author$project$CorvusDesignSystem$Attribute = $elm$core$Basics$identity;
var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
var $elm$html$Html$Attributes$map = $elm$virtual_dom$VirtualDom$mapAttribute;
var $author$project$CorvusDesignSystem$class = A2(
	$elm$core$Basics$composeL,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Basics$identity,
		$elm$html$Html$Attributes$map($elm$core$Basics$never)),
	$elm$html$Html$Attributes$class);
var $author$project$CorvusDesignSystem$Button$button = F3(
	function (cdsAttributes, attrs, children) {
		var cdsAttrs = A2(
			$elm$core$List$map,
			$author$project$CorvusDesignSystem$cdsAttributeToHtmlAttribute,
			A2(
				$elm$core$List$cons,
				$author$project$CorvusDesignSystem$class('cds-button'),
				cdsAttributes));
		return A2(
			$elm$html$Html$button,
			_Utils_ap(cdsAttrs, attrs),
			children);
	});
var $author$project$View$Svg$iphone = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$class('iphone__icon'),
			$elm$svg$Svg$Attributes$width('64'),
			$elm$svg$Svg$Attributes$height('64'),
			$elm$svg$Svg$Attributes$viewBox('0 0 64 64')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M18.6663 61.333C17.1997 61.333 15.9441 60.8108 14.8997 59.7664C13.8552 58.7219 13.333 57.4664 13.333 55.9997V7.99972C13.333 6.53305 13.8552 5.27749 14.8997 4.23305C15.9441 3.1886 17.1997 2.66638 18.6663 2.66638H45.333C46.7997 2.66638 48.0552 3.1886 49.0997 4.23305C50.1441 5.27749 50.6663 6.53305 50.6663 7.99972V55.9997C50.6663 57.4664 50.1441 58.7219 49.0997 59.7664C48.0552 60.8108 46.7997 61.333 45.333 61.333H18.6663ZM18.6663 47.9997V55.9997H45.333V47.9997H18.6663ZM31.9997 54.6664C32.7552 54.6664 33.3886 54.4108 33.8997 53.8997C34.4108 53.3886 34.6663 52.7553 34.6663 51.9997C34.6663 51.2442 34.4108 50.6108 33.8997 50.0997C33.3886 49.5886 32.7552 49.333 31.9997 49.333C31.2441 49.333 30.6108 49.5886 30.0997 50.0997C29.5886 50.6108 29.333 51.2442 29.333 51.9997C29.333 52.7553 29.5886 53.3886 30.0997 53.8997C30.6108 54.4108 31.2441 54.6664 31.9997 54.6664ZM18.6663 42.6664H45.333V15.9997H18.6663V42.6664ZM18.6663 10.6664H45.333V7.99972H18.6663V10.6664Z'),
					$elm$svg$Svg$Attributes$fill('#444D59')
				]),
			_List_Nil)
		]));
var $author$project$View$Svg$iphoneTrv = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$class('iphone-trv__icon'),
			$elm$svg$Svg$Attributes$width('64'),
			$elm$svg$Svg$Attributes$height('64'),
			$elm$svg$Svg$Attributes$viewBox('0 0 64 64')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class(''),
					$elm$svg$Svg$Attributes$d('M53.3333 56.7273C53.3333 60.7018 50.3989 64 46.6667 64H17.3333C13.6011 64 10.6667 60.7018 10.6667 56.7273V7.27273C10.6667 3.2982 13.6011 0 17.3333 0H46.6667C50.3989 0 53.3333 3.2982 53.3333 7.27273V56.7273ZM46.6667 60.4444C48.3367 60.4444 49.7778 58.8247 49.7778 56.7273V7.27273C49.7778 5.17533 48.3367 3.55556 46.6667 3.55556H17.3333C15.6633 3.55556 14.2222 5.17533 14.2222 7.27273V56.7273C14.2222 58.8247 15.6633 60.4444 17.3333 60.4444H46.6667ZM32 53.3333C33.9637 53.3333 35.5556 51.7415 35.5556 49.7778C35.5556 47.8141 33.9637 46.2222 32 46.2222C30.0363 46.2222 28.4444 47.8141 28.4444 49.7778C28.4444 51.7415 30.0363 53.3333 32 53.3333Z'),
					$elm$svg$Svg$Attributes$fill('#46494D')
				]),
			_List_Nil)
		]));
var $author$project$View$Svg$pointClick = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$class('pointClick__icon'),
			$elm$svg$Svg$Attributes$width('22'),
			$elm$svg$Svg$Attributes$height('22'),
			$elm$svg$Svg$Attributes$viewBox('0 0 22 22'),
			$elm$svg$Svg$Attributes$fill('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M16.8836 10.5766H16.7759C16.5385 10.5766 16.3129 10.6288 16.1103 10.7222C15.9548 10.0038 15.3146 9.4641 14.5506 9.4641H14.4426C14.1702 9.4641 13.9138 9.53268 13.6892 9.65343C13.4477 9.07894 12.879 8.67445 12.2176 8.67445H12.1097C11.8863 8.67445 11.6733 8.72057 11.4803 8.80388V6.51993C11.4803 5.63996 10.7646 4.92444 9.88462 4.92444H9.77668C8.89695 4.92444 8.18119 5.6402 8.18119 6.51993V12.3786L7.45553 12.9294C6.87741 13.3682 6.51108 14.0067 6.42367 14.727C6.33625 15.4476 6.53934 16.1552 6.99598 16.7195L9.26062 19.5193V20.632C9.26062 21.306 9.80903 21.8547 10.483 21.8547H16.1364C16.8104 21.8547 17.359 21.3063 17.359 20.632L17.3593 19.5755C18.0828 18.6661 18.4795 17.5379 18.4795 16.3778V12.1721C18.479 11.2924 17.7635 10.5766 16.8836 10.5766ZM17.5131 16.3776C17.5131 17.3681 17.1562 18.3307 16.5088 19.088C16.4337 19.1754 16.3929 19.2867 16.3929 19.4019V20.632C16.3929 20.7735 16.2777 20.8887 16.1362 20.8887H10.483C10.3417 20.8887 10.2266 20.7735 10.2266 20.632V19.3483C10.2266 19.2377 10.1886 19.1305 10.1191 19.0445L7.747 16.1119C7.45625 15.7526 7.32682 15.302 7.3826 14.8432C7.43814 14.3846 7.67166 13.9779 8.03968 13.6985L8.18119 13.5913V14.9183C8.18119 15.1849 8.39756 15.4012 8.66416 15.4012C8.93076 15.4012 9.14713 15.1849 9.14713 14.9183V12.6227C9.14713 12.6193 9.14713 12.6164 9.14713 12.6131V6.51968C9.14713 6.17243 9.42942 5.89013 9.77668 5.89013H9.88462C10.2319 5.89013 10.5142 6.17267 10.5142 6.51968V10.2699C10.5142 10.2702 10.5142 10.2702 10.5142 10.2704L10.5166 13.3897C10.5168 13.6563 10.733 13.8722 10.9996 13.8722C11.2662 13.8719 11.4825 13.6558 11.4823 13.3887L11.4801 10.2699C11.4801 9.92268 11.7624 9.64039 12.1094 9.64039H12.2174C12.5646 9.64039 12.8469 9.92292 12.8469 10.2699V11.0596V11.0601L12.8491 13.3897C12.8493 13.6563 13.0655 13.8722 13.3321 13.8722C13.3323 13.8722 13.3323 13.8722 13.3325 13.8722C13.5991 13.8719 13.8153 13.6555 13.815 13.3887L13.8128 11.0593C13.8128 10.7121 14.0951 10.4298 14.4422 10.4298H14.5501C14.8974 10.4298 15.1796 10.7123 15.1796 11.0593V12.0465C15.1782 12.0625 15.1748 12.0779 15.1748 12.0941L15.1772 13.3899C15.1777 13.6565 15.3938 13.8719 15.6602 13.8719C15.6604 13.8719 15.6607 13.8719 15.6612 13.8719C15.9278 13.8714 16.1437 13.6548 16.1432 13.388L16.141 12.2163C16.1424 12.2013 16.1456 12.1871 16.1456 12.1719C16.1456 11.8246 16.4281 11.5423 16.7751 11.5423H16.8828C17.2301 11.5423 17.5124 11.8249 17.5124 12.1719V16.3776H17.5131Z')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M15.5746 6.28137H12.6275C12.3609 6.28137 12.1445 6.065 12.1445 5.7984C12.1445 5.5318 12.3609 5.31543 12.6275 5.31543H15.5746C15.8412 5.31543 16.0575 5.5318 16.0575 5.7984C16.0575 6.065 15.8414 6.28137 15.5746 6.28137Z')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M9.77643 4.03386C9.50983 4.03386 9.29346 3.81749 9.29346 3.55089V0.603818C9.29346 0.33722 9.50983 0.12085 9.77643 0.12085C10.043 0.12085 10.2594 0.33722 10.2594 0.603818V3.55089C10.2594 3.81773 10.0433 4.03386 9.77643 4.03386Z')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M11.8467 4.57406C11.723 4.57406 11.5996 4.52697 11.5052 4.43255C11.3166 4.24395 11.3166 3.93823 11.5052 3.74963L13.5892 1.66586C13.7778 1.47726 14.0835 1.47726 14.2721 1.66586C14.4607 1.85446 14.4607 2.16018 14.2721 2.34878L12.1881 4.43255C12.0937 4.52697 11.9701 4.57406 11.8467 4.57406Z')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M6.92614 6.28137H3.97906C3.71246 6.28137 3.49609 6.065 3.49609 5.7984C3.49609 5.5318 3.71246 5.31543 3.97906 5.31543H6.92614C7.19274 5.31543 7.40911 5.5318 7.40911 5.7984C7.40911 6.065 7.19274 6.28137 6.92614 6.28137Z')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M7.70681 4.57406C7.58317 4.57406 7.45953 4.52697 7.36535 4.43255L5.28159 2.34878C5.09299 2.16018 5.09299 1.85446 5.28159 1.66586C5.46994 1.47726 5.77615 1.47726 5.9645 1.66586L8.04827 3.74963C8.23687 3.93823 8.23687 4.24395 8.04827 4.43255C7.95409 4.52697 7.83045 4.57406 7.70681 4.57406Z')
				]),
			_List_Nil)
		]));
var $author$project$View$Svg$chevronLeft = $author$project$View$Svg$icon('chevron-left');
var $author$project$Login$MfaSetup$helpLink = function (_v0) {
	var needHelpOnClick = _v0.zW;
	var mfaHelpEmail = A3(
		$author$project$View$Util$mailToHrefTranslate,
		$author$project$View$CustomerSuccess$emailAddress,
		$author$project$Translate$gettext('Need help setting up MFA'),
		$elm$core$Maybe$Nothing);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mfa-setup__footer-button branded__link')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(needHelpOnClick),
						$elm$html$Html$Attributes$href(mfaHelpEmail),
						$elm$html$Html$Attributes$target('_blank'),
						$elm$html$Html$Attributes$rel('noopener')
					]),
				_List_fromArray(
					[
						$author$project$Translate$Html$text(
						$author$project$Translate$gettext('I Need Help'))
					]))
			]));
};
var $author$project$Login$MfaSetup$mfaCubes = function (stepNumber) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('tw-flex tw-justify-center tw-gap-3')
			]),
		function () {
			switch (stepNumber) {
				case 1:
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__cube mfa-setup__cube--light-green')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__cube mfa-setup__cube--gray')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__cube mfa-setup__cube--gray')
								]),
							_List_Nil)
						]);
				case 2:
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__cube mfa-setup__cube--light-green')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__cube mfa-setup__cube--green')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__cube mfa-setup__cube--gray')
								]),
							_List_Nil)
						]);
				case 3:
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__cube mfa-setup__cube--light-green')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__cube mfa-setup__cube--green')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__cube mfa-setup__cube--dark-green')
								]),
							_List_Nil)
						]);
				default:
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__cube mfa-setup__cube--gray')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__cube mfa-setup__cube--gray')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__cube mfa-setup__cube--gray')
								]),
							_List_Nil)
						]);
			}
		}());
};
var $author$project$Login$MfaSetup$mfaProgressBar = function (stepNumber) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mfa-setup__progress-bar')
			]),
		function () {
			switch (stepNumber) {
				case 1:
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__progress-bar-segment dark-blue left-segment')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__progress-bar-segment light-blue')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__progress-bar-segment light-blue right-segment')
								]),
							_List_Nil)
						]);
				case 2:
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__progress-bar-segment dark-blue left-segment')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__progress-bar-segment dark-blue')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__progress-bar-segment light-blue right-segment')
								]),
							_List_Nil)
						]);
				case 3:
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__progress-bar-segment dark-blue left-segment')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__progress-bar-segment dark-blue')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__progress-bar-segment dark-blue right-segment')
								]),
							_List_Nil)
						]);
				default:
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__progress-bar-segment gray left-segment')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__progress-bar-segment gray')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__progress-bar-segment gray right-segment')
								]),
							_List_Nil)
						]);
			}
		}());
};
var $author$project$Login$MfaSetup$viewMfaStep = F3(
	function (config, stepNumber, html) {
		var showTravelersVersion = config.jv;
		var totalSteps = 3;
		var stepLabel = A2(
			$author$project$Translate$gettextN,
			'MFA: Step %{step} of %{totalSteps}',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'step',
					$elm$core$String$fromInt(stepNumber)),
					_Utils_Tuple2(
					'totalSteps',
					$elm$core$String$fromInt(totalSteps))
				]));
		var progressStatus = showTravelersVersion ? $author$project$Login$MfaSetup$mfaProgressBar(stepNumber) : $author$project$Login$MfaSetup$mfaCubes(stepNumber);
		var _v0 = config;
		var previousStepOnClick = _v0.Ay;
		var previousStepButton = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mfa-setup__footer-button branded__link'),
					$elm$html$Html$Events$onClick(previousStepOnClick)
				]),
			_List_fromArray(
				[
					$author$project$View$Svg$chevronLeft('icon'),
					$author$project$Translate$Html$text(
					$author$project$Translate$gettext('Previous'))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mfa-setup__card')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mfa-setup__progress-status-section')
						]),
					_List_fromArray(
						[
							progressStatus,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__step-label')
								]),
							_List_fromArray(
								[
									$author$project$Translate$Html$text(stepLabel)
								]))
						])),
					html,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mfa-setup__footer')
						]),
					_List_fromArray(
						[
							previousStepButton,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__footer')
								]),
							_List_fromArray(
								[
									$author$project$Login$MfaSetup$helpLink(config)
								]))
						]))
				]));
	});
var $author$project$Login$MfaSetup$viewDownloadAppStep = F2(
	function (config, modalState) {
		var nextStepOnClick = config.qm;
		var openMfaModal = config.vA;
		var showTravelersVersion = config.jv;
		var stepIcon = showTravelersVersion ? $author$project$View$Svg$iphoneTrv : $author$project$View$Svg$iphone;
		var showModal = function () {
			if (!modalState) {
				return true;
			} else {
				return false;
			}
		}();
		var html = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tw-min-h-[18rem]')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__header')
								]),
							_List_fromArray(
								[
									$author$project$Translate$Html$text(
									$author$project$Translate$gettext('Download an authenticator app.'))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tw-flex tw-flex-col')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mfa-setup__svg')
										]),
									_List_fromArray(
										[stepIcon])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mfa-setup__step-description')
										]),
									A2(
										$author$project$Translate$Html$CustomParser$parseToHtml,
										_List_fromArray(
											[
												_Utils_Tuple2(
												'tag',
												A2($author$project$Translate$Html$CustomParser$with, $elm$html$Html$strong, _List_Nil))
											]),
										$author$project$Translate$gettext('Download an authenticator app on your mobile device if you don’t already have one. We recommend <tag>Google Authenticator</tag> or <tag>Microsoft Authenticator.</tag>')))
								]))
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mfa-setup__overlay-button'),
							$elm$html$Html$Events$onClick(openMfaModal)
						]),
					_List_fromArray(
						[
							$author$project$Translate$Html$text(
							$author$project$Translate$gettext('Here are some more authenticator options.')),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__locate-qr-code-example-click-icon')
								]),
							_List_fromArray(
								[$author$project$View$Svg$pointClick]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tw-flex tw-flex-col tw-gap-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mfa-setup__step-description')
								]),
							_List_fromArray(
								[
									$author$project$Translate$Html$text(
									$author$project$Translate$gettext('Once downloaded, proceed to the next step.'))
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$CorvusDesignSystem$Button$button,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id('next-step'),
											$elm$html$Html$Attributes$class('tw-w-full tw-mb-6'),
											$elm$html$Html$Events$onClick(nextStepOnClick)
										]),
									_List_fromArray(
										[
											$author$project$Translate$Html$text(
											$author$project$Translate$gettext('Next step'))
										]))
								]))
						])),
					A2(
					$author$project$View$Util$displayIf,
					showModal,
					function (_v0) {
						return $author$project$Login$MfaSetup$authenticatorOptionsModal(config);
					})
				]));
		return A3($author$project$Login$MfaSetup$viewMfaStep, config, 1, html);
	});
var $author$project$CorvusDesignSystem$Button$Fill = function (a) {
	return {$: 2, a: a};
};
var $author$project$CorvusDesignSystem$Button$Filled = 0;
var $author$project$CorvusDesignSystem$Button$Regular = 0;
var $author$project$CorvusDesignSystem$Button$Size = function (a) {
	return {$: 0, a: a};
};
var $author$project$CorvusDesignSystem$Button$buttonModifier = function (modifier) {
	return $author$project$CorvusDesignSystem$class(
		function () {
			switch (modifier.$) {
				case 0:
					switch (modifier.a) {
						case 0:
							var _v1 = modifier.a;
							return '';
						case 1:
							var _v2 = modifier.a;
							return 'cds-button--lg';
						case 2:
							var _v3 = modifier.a;
							return 'cds-button--sm';
						case 3:
							var _v4 = modifier.a;
							return 'cds-button--xs';
						default:
							var _v5 = modifier.a;
							return 'cds-button--block';
					}
				case 1:
					switch (modifier.a) {
						case 0:
							var _v6 = modifier.a;
							return '';
						case 1:
							var _v7 = modifier.a;
							return 'cds-button--warning';
						case 2:
							var _v8 = modifier.a;
							return 'cds-button--danger';
						default:
							var _v9 = modifier.a;
							return 'cds-button--neutral';
					}
				case 2:
					switch (modifier.a) {
						case 0:
							var _v10 = modifier.a;
							return '';
						case 2:
							var _v11 = modifier.a;
							return 'cds-button--outline';
						default:
							var _v12 = modifier.a;
							return 'cds-button--text';
					}
				default:
					if (!modifier.a) {
						var _v13 = modifier.a;
						return '';
					} else {
						var _v14 = modifier.a;
						return 'cds-button--loading';
					}
			}
		}());
};
var $author$project$View$Svg$locateQrCode = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$class('locate-qr-code__icon'),
			$elm$svg$Svg$Attributes$width('64'),
			$elm$svg$Svg$Attributes$height('64'),
			$elm$svg$Svg$Attributes$viewBox('0 0 64 64'),
			$elm$svg$Svg$Attributes$fill('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M13.3333 56C11.8667 56 10.6111 55.4778 9.56667 54.4333C8.52222 53.3889 8 52.1333 8 50.6667V42.6667C8 41.9111 8.25556 41.2778 8.76667 40.7667C9.27778 40.2556 9.91111 40 10.6667 40C11.4222 40 12.0556 40.2556 12.5667 40.7667C13.0778 41.2778 13.3333 41.9111 13.3333 42.6667V50.6667H21.3333C22.0889 50.6667 22.7222 50.9222 23.2333 51.4333C23.7444 51.9444 24 52.5778 24 53.3333C24 54.0889 23.7444 54.7222 23.2333 55.2333C22.7222 55.7444 22.0889 56 21.3333 56H13.3333ZM50.6667 56H42.6667C41.9111 56 41.2778 55.7444 40.7667 55.2333C40.2556 54.7222 40 54.0889 40 53.3333C40 52.5778 40.2556 51.9444 40.7667 51.4333C41.2778 50.9222 41.9111 50.6667 42.6667 50.6667H50.6667V42.6667C50.6667 41.9111 50.9222 41.2778 51.4333 40.7667C51.9444 40.2556 52.5778 40 53.3333 40C54.0889 40 54.7222 40.2556 55.2333 40.7667C55.7444 41.2778 56 41.9111 56 42.6667V50.6667C56 52.1333 55.4778 53.3889 54.4333 54.4333C53.3889 55.4778 52.1333 56 50.6667 56ZM8 21.3333V13.3333C8 11.8667 8.52222 10.6111 9.56667 9.56667C10.6111 8.52222 11.8667 8 13.3333 8H21.3333C22.0889 8 22.7222 8.25556 23.2333 8.76667C23.7444 9.27778 24 9.91111 24 10.6667C24 11.4222 23.7444 12.0556 23.2333 12.5667C22.7222 13.0778 22.0889 13.3333 21.3333 13.3333H13.3333V21.3333C13.3333 22.0889 13.0778 22.7222 12.5667 23.2333C12.0556 23.7444 11.4222 24 10.6667 24C9.91111 24 9.27778 23.7444 8.76667 23.2333C8.25556 22.7222 8 22.0889 8 21.3333ZM50.6667 21.3333V13.3333H42.6667C41.9111 13.3333 41.2778 13.0778 40.7667 12.5667C40.2556 12.0556 40 11.4222 40 10.6667C40 9.91111 40.2556 9.27778 40.7667 8.76667C41.2778 8.25556 41.9111 8 42.6667 8H50.6667C52.1333 8 53.3889 8.52222 54.4333 9.56667C55.4778 10.6111 56 11.8667 56 13.3333V21.3333C56 22.0889 55.7444 22.7222 55.2333 23.2333C54.7222 23.7444 54.0889 24 53.3333 24C52.5778 24 51.9444 23.7444 51.4333 23.2333C50.9222 22.7222 50.6667 22.0889 50.6667 21.3333Z')
				]),
			_List_Nil)
		]));
var $author$project$View$Svg$locateQrCodeTrv = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$class('locate-qr-code-trv__icon'),
			$elm$svg$Svg$Attributes$width('64'),
			$elm$svg$Svg$Attributes$height('64'),
			$elm$svg$Svg$Attributes$viewBox('0 0 64 64')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class(''),
					$elm$svg$Svg$Attributes$d('M7.11111 64C5.15556 64 3.48148 63.3037 2.08889 61.9111C0.696296 60.5185 0 58.8444 0 56.8889V46.2222C0 45.2148 0.340741 44.3704 1.02222 43.6889C1.7037 43.0074 2.54815 42.6667 3.55556 42.6667C4.56296 42.6667 5.40741 43.0074 6.08889 43.6889C6.77037 44.3704 7.11111 45.2148 7.11111 46.2222V56.8889H17.7778C18.7852 56.8889 19.6296 57.2296 20.3111 57.9111C20.9926 58.5926 21.3333 59.437 21.3333 60.4444C21.3333 61.4519 20.9926 62.2963 20.3111 62.9778C19.6296 63.6593 18.7852 64 17.7778 64H7.11111ZM56.8889 64H46.2222C45.2148 64 44.3704 63.6593 43.6889 62.9778C43.0074 62.2963 42.6667 61.4519 42.6667 60.4444C42.6667 59.437 43.0074 58.5926 43.6889 57.9111C44.3704 57.2296 45.2148 56.8889 46.2222 56.8889H56.8889V46.2222C56.8889 45.2148 57.2296 44.3704 57.9111 43.6889C58.5926 43.0074 59.437 42.6667 60.4444 42.6667C61.4519 42.6667 62.2963 43.0074 62.9778 43.6889C63.6593 44.3704 64 45.2148 64 46.2222V56.8889C64 58.8444 63.3037 60.5185 61.9111 61.9111C60.5185 63.3037 58.8444 64 56.8889 64ZM0 17.7778V7.11111C0 5.15556 0.696296 3.48148 2.08889 2.08889C3.48148 0.696296 5.15556 0 7.11111 0H17.7778C18.7852 0 19.6296 0.340741 20.3111 1.02222C20.9926 1.7037 21.3333 2.54815 21.3333 3.55556C21.3333 4.56296 20.9926 5.40741 20.3111 6.08889C19.6296 6.77037 18.7852 7.11111 17.7778 7.11111H7.11111V17.7778C7.11111 18.7852 6.77037 19.6296 6.08889 20.3111C5.40741 20.9926 4.56296 21.3333 3.55556 21.3333C2.54815 21.3333 1.7037 20.9926 1.02222 20.3111C0.340741 19.6296 0 18.7852 0 17.7778ZM56.8889 17.7778V7.11111H46.2222C45.2148 7.11111 44.3704 6.77037 43.6889 6.08889C43.0074 5.40741 42.6667 4.56296 42.6667 3.55556C42.6667 2.54815 43.0074 1.7037 43.6889 1.02222C44.3704 0.340741 45.2148 0 46.2222 0H56.8889C58.8444 0 60.5185 0.696296 61.9111 2.08889C63.3037 3.48148 64 5.15556 64 7.11111V17.7778C64 18.7852 63.6593 19.6296 62.9778 20.3111C62.2963 20.9926 61.4519 21.3333 60.4444 21.3333C59.437 21.3333 58.5926 20.9926 57.9111 20.3111C57.2296 19.6296 56.8889 18.7852 56.8889 17.7778Z'),
					$elm$svg$Svg$Attributes$fill('#46494D')
				]),
			_List_Nil)
		]));
var $author$project$Login$MfaSetup$scanQrModal = function (_v0) {
	var closeMfaModal = _v0.rS;
	var screenshotTwo = A2(
		$elm$html$Html$img,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$src('https://cdn.corvusinsurance.com/images/Group%202-a14a47146611128133489e72a91e5f8f.png'),
				$elm$html$Html$Attributes$class('tw-h-[600px]')
			]),
		_List_Nil);
	var screenshotOne = A2(
		$elm$html$Html$img,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$src('https://cdn.corvusinsurance.com/images/Group%201-8aba86274d1e34052ea527159addb691.png'),
				$elm$html$Html$Attributes$class('tw-h-[600px]')
			]),
		_List_Nil);
	var body = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('tw-flex tw-flex-col')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mfa-setup__modal-close'),
						$elm$html$Html$Events$onClick(closeMfaModal)
					]),
				_List_fromArray(
					[
						$author$project$View$Svg$closeX('')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mfa-setup__modal-header')
					]),
				_List_fromArray(
					[
						$author$project$Translate$Html$text(
						$author$project$Translate$gettext('Locating the \'Scan QR Code\' feature'))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mfa-setup__scan-screenshots')
					]),
				_List_fromArray(
					[screenshotOne, screenshotTwo]))
			]));
	return $author$project$View$Modal$buildView(
		A2(
			$author$project$View$Modal$body,
			body,
			A2(
				$author$project$View$Modal$mainBodyStyles,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mfa-setup__modal-body')
					]),
				$author$project$View$Modal$config(closeMfaModal))));
};
var $author$project$Login$MfaSetup$viewLocateQRCodeStep = F2(
	function (config, modalState) {
		var nextStepOnClick = config.qm;
		var openMfaModal = config.vA;
		var showTravelersVersion = config.jv;
		var title = A2(
			$elm$html$Html$h1,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mfa-setup__header')
				]),
			_List_fromArray(
				[
					$author$project$Translate$Html$text(
					$author$project$Translate$gettext('Locate the \'Scan QR code\' feature in the app.'))
				]));
		var stepIcon = showTravelersVersion ? $author$project$View$Svg$locateQrCodeTrv : $author$project$View$Svg$locateQrCode;
		var showModal = function () {
			if (!modalState) {
				return true;
			} else {
				return false;
			}
		}();
		var locateQrCodeIcon = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mfa-setup__locate-qr-code-icon')
				]),
			_List_fromArray(
				[stepIcon]));
		var locateQrCodeDescTranslate = $author$project$Translate$gettext('Once the authenticator app is open, locate the \'Scan QR code\' feature <tag>within the authenticator app</tag>.');
		var locateQrCodeDesc = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mfa-setup__locate-qr-code-desc')
				]),
			A2(
				$author$project$Translate$Html$CustomParser$parseToHtml,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						A2($author$project$Translate$Html$CustomParser$with, $elm$html$Html$strong, _List_Nil))
					]),
				locateQrCodeDescTranslate));
		var lastStepDesc = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mfa-setup__locate-qr-code-last-step-desc')
				]),
			_List_fromArray(
				[
					$author$project$Translate$Html$text(
					$author$project$Translate$gettext('Once located, move on to the last step.'))
				]));
		var lastStepButton = A3(
			$author$project$CorvusDesignSystem$Button$button,
			_List_fromArray(
				[
					$author$project$CorvusDesignSystem$Button$buttonModifier(
					$author$project$CorvusDesignSystem$Button$Size(0)),
					$author$project$CorvusDesignSystem$Button$buttonModifier(
					$author$project$CorvusDesignSystem$Button$Fill(0))
				]),
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('last-step'),
					$elm$html$Html$Attributes$class('mfa-setup__next-step-button'),
					$elm$html$Html$Events$onClick(nextStepOnClick)
				]),
			_List_fromArray(
				[
					$author$project$Translate$Html$text(
					$author$project$Translate$gettext('Go to last step'))
				]));
		var exampleLink = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mfa-setup__locate-qr-code-example-link')
				]),
			_List_fromArray(
				[
					$author$project$Translate$Html$text(
					$author$project$Translate$gettext('Here is an example of how to access this feature.'))
				]));
		var exampleClickIcon = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mfa-setup__locate-qr-code-example-click-icon')
				]),
			_List_fromArray(
				[$author$project$View$Svg$pointClick]));
		var exampleBox = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mfa-setup__locate-qr-code-example-box'),
					$elm$html$Html$Events$onClick(openMfaModal)
				]),
			_List_fromArray(
				[exampleLink, exampleClickIcon]));
		var stepContent = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tw-min-h-[18rem]')
						]),
					_List_fromArray(
						[title, locateQrCodeIcon, locateQrCodeDesc])),
					exampleBox,
					lastStepDesc,
					lastStepButton,
					A2(
					$author$project$View$Util$displayIf,
					showModal,
					function (_v0) {
						return $author$project$Login$MfaSetup$scanQrModal(config);
					})
				]));
		return A3($author$project$Login$MfaSetup$viewMfaStep, config, 2, stepContent);
	});
var $author$project$View$Util$displayIfWithDefault = F3(
	function (condition, defaultHtmlFunc, htmlFunc) {
		return condition ? htmlFunc(0) : defaultHtmlFunc(0);
	});
var $elm$svg$Svg$defs = $elm$svg$Svg$trustedNode('defs');
var $elm$svg$Svg$Attributes$gradientUnits = _VirtualDom_attribute('gradientUnits');
var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');
var $elm$svg$Svg$linearGradient = $elm$svg$Svg$trustedNode('linearGradient');
var $elm$svg$Svg$Attributes$offset = _VirtualDom_attribute('offset');
var $elm$svg$Svg$stop = $elm$svg$Svg$trustedNode('stop');
var $elm$svg$Svg$Attributes$stopColor = _VirtualDom_attribute('stop-color');
var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');
var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');
var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');
var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');
var $author$project$View$Svg$gradientLock = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$class('lock'),
			$elm$svg$Svg$Attributes$width('42'),
			$elm$svg$Svg$Attributes$height('54'),
			$elm$svg$Svg$Attributes$viewBox('0 0 42 54'),
			$elm$svg$Svg$Attributes$fill('none')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M36.2382 18.1112H33.6985V13.0318C33.6985 5.92068 28.1112 0.333374 21.0001 0.333374C13.889 0.333374 8.30167 5.92068 8.30167 13.0318V18.1112H5.76198C2.96833 18.1112 0.682617 20.3969 0.682617 23.1905V48.5873C0.682617 51.381 2.96833 53.6667 5.76198 53.6667H36.2382C39.0318 53.6667 41.3175 51.381 41.3175 48.5873V23.1905C41.3175 20.3969 39.0318 18.1112 36.2382 18.1112ZM21.0001 40.9683C18.2064 40.9683 15.9207 38.6826 15.9207 35.8889C15.9207 33.0953 18.2064 30.8096 21.0001 30.8096C23.7937 30.8096 26.0794 33.0953 26.0794 35.8889C26.0794 38.6826 23.7937 40.9683 21.0001 40.9683ZM28.8731 18.1112H13.1271V13.0318C13.1271 8.71433 16.6826 5.15877 21.0001 5.15877C25.3175 5.15877 28.8731 8.71433 28.8731 13.0318V18.1112Z'),
					$elm$svg$Svg$Attributes$fill('url(#paint0_linear_1045_24)')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$defs,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$linearGradient,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('paint0_linear_1045_24'),
							$elm$svg$Svg$Attributes$x1('0.682617'),
							$elm$svg$Svg$Attributes$y1('27'),
							$elm$svg$Svg$Attributes$x2('41.3175'),
							$elm$svg$Svg$Attributes$y2('27'),
							$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$stop,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$stopColor('#66FFCC')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$stop,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$stopColor('#867CFF'),
									$elm$svg$Svg$Attributes$offset('1')
								]),
							_List_Nil)
						]))
				]))
		]));
var $author$project$Login$MfaSetup$viewRequiredMfaSetupStep = function (config) {
	var nextStepOnClick = config.qm;
	var showTravelersVersion = config.jv;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mfa-setup__card')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('tw-flex tw-flex-col tw-gap-8')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('mfa-setup__header', true),
										_Utils_Tuple2('set-up-mfa', showTravelersVersion)
									]))
							]),
						_List_fromArray(
							[
								$author$project$Translate$Html$text(
								$author$project$Translate$gettext('Set up Multi-Factor Authentication'))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('mfa-setup__message-gradient', !showTravelersVersion),
										_Utils_Tuple2('mfa-setup__message', showTravelersVersion)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$View$Util$displayIf,
								!showTravelersVersion,
								function (_v0) {
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('tw-inline-block')
											]),
										_List_fromArray(
											[$author$project$View$Svg$gradientLock]));
								}),
								A3(
								$author$project$View$Util$displayIfWithDefault,
								showTravelersVersion,
								function (_v1) {
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Translate$Html$text(
												$author$project$Translate$gettext('For your security, Corvus now requires that users access their accounts using MFA.'))
											]));
								},
								function (_v2) {
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										A2(
											$author$project$Translate$Html$CustomParser$parseToHtml,
											_List_fromArray(
												[
													_Utils_Tuple2(
													'tag',
													A2($author$project$Translate$Html$CustomParser$with, $elm$html$Html$strong, _List_Nil))
												]),
											$author$project$Translate$gettext('For your security, <tag>Travelers now requires that users access their accounts using MFA.</tag>')));
								}),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Translate$Html$text(
										$author$project$Translate$gettext('MFA helps protect you against hackers, and works by asking you for additional information when you log in.'))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Translate$Html$text(
										$author$project$Translate$gettext('Set up MFA today to access your dashboard.'))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tw-flex tw-flex-col tw-gap-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A3(
										$author$project$CorvusDesignSystem$Button$button,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$id('set-up-mfa'),
												$elm$html$Html$Attributes$class('tw-w-full'),
												$elm$html$Html$Events$onClick(nextStepOnClick)
											]),
										_List_fromArray(
											[
												$author$project$Translate$Html$text(
												$author$project$Translate$gettext('Set up MFA'))
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mfa-setup__footer')
							]),
						_List_fromArray(
							[
								A2($elm$html$Html$div, _List_Nil, _List_Nil),
								$author$project$Login$MfaSetup$helpLink(config)
							]))
					]))
			]));
};
var $author$project$CorvusDesignSystem$Button$Outline = 2;
var $author$project$CorvusDesignSystem$Button$Small = 2;
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $pablohirafuji$elm_qrcode$QRCode$Quartile = 2;
var $pablohirafuji$elm_qrcode$QRCode$QRCode = $elm$core$Basics$identity;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex = F3(
	function (size, row, col) {
		return (size * row) + col;
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$isOccupy = F4(
	function (row, col, size, matrix) {
		var _v0 = A2(
			$elm$core$Array$get,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			matrix);
		if ((!_v0.$) && (!_v0.a.$)) {
			return true;
		} else {
			return false;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$nextModule = function (placement) {
	var row = placement.IM;
	var col = placement.Dv;
	var isRight = placement.dB;
	var isUp = placement.mK;
	return isRight ? _Utils_update(
		placement,
		{Dv: col - 1, dB: false}) : (isUp ? _Utils_update(
		placement,
		{Dv: col + 1, dB: true, IM: row - 1}) : _Utils_update(
		placement,
		{Dv: col + 1, dB: true, IM: row + 1}));
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$bitToColor = F2(
	function (_byte, offset) {
		return (1 & (_byte >> (7 - offset))) === 1;
	});
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setDataModule = F3(
	function (_v0, _byte, offset) {
		var size = _v0.v;
		var row = _v0.IM;
		var col = _v0.Dv;
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(
					false,
					A2($pablohirafuji$elm_qrcode$QRCode$Matrix$bitToColor, _byte, offset))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$addDataModule = F4(
	function (placement, bytes, offset, matrix) {
		addDataModule:
		while (true) {
			var size = placement.v;
			var row = placement.IM;
			var col = placement.Dv;
			if (!bytes.b) {
				return matrix;
			} else {
				var head = bytes.a;
				var tail = bytes.b;
				if (offset >= 8) {
					var $temp$placement = placement,
						$temp$bytes = tail,
						$temp$offset = 0,
						$temp$matrix = matrix;
					placement = $temp$placement;
					bytes = $temp$bytes;
					offset = $temp$offset;
					matrix = $temp$matrix;
					continue addDataModule;
				} else {
					if (col === 6) {
						var $temp$placement = _Utils_update(
							placement,
							{Dv: col - 1, dB: true}),
							$temp$bytes = bytes,
							$temp$offset = offset,
							$temp$matrix = matrix;
						placement = $temp$placement;
						bytes = $temp$bytes;
						offset = $temp$offset;
						matrix = $temp$matrix;
						continue addDataModule;
					} else {
						if (row < 0) {
							var $temp$placement = _Utils_update(
								placement,
								{Dv: col - 2, dB: true, mK: false, IM: 0}),
								$temp$bytes = bytes,
								$temp$offset = offset,
								$temp$matrix = matrix;
							placement = $temp$placement;
							bytes = $temp$bytes;
							offset = $temp$offset;
							matrix = $temp$matrix;
							continue addDataModule;
						} else {
							if (_Utils_cmp(row, size) > -1) {
								var $temp$placement = _Utils_update(
									placement,
									{Dv: col - 2, dB: true, mK: true, IM: size - 1}),
									$temp$bytes = bytes,
									$temp$offset = offset,
									$temp$matrix = matrix;
								placement = $temp$placement;
								bytes = $temp$bytes;
								offset = $temp$offset;
								matrix = $temp$matrix;
								continue addDataModule;
							} else {
								if (A4($pablohirafuji$elm_qrcode$QRCode$Matrix$isOccupy, row, col, size, matrix)) {
									var $temp$placement = $pablohirafuji$elm_qrcode$QRCode$Matrix$nextModule(placement),
										$temp$bytes = bytes,
										$temp$offset = offset,
										$temp$matrix = matrix;
									placement = $temp$placement;
									bytes = $temp$bytes;
									offset = $temp$offset;
									matrix = $temp$matrix;
									continue addDataModule;
								} else {
									var $temp$placement = $pablohirafuji$elm_qrcode$QRCode$Matrix$nextModule(placement),
										$temp$bytes = bytes,
										$temp$offset = offset + 1,
										$temp$matrix = A4($pablohirafuji$elm_qrcode$QRCode$Matrix$setDataModule, placement, head, offset, matrix);
									placement = $temp$placement;
									bytes = $temp$bytes;
									offset = $temp$offset;
									matrix = $temp$matrix;
									continue addDataModule;
								}
							}
						}
					}
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$initPlacement = function (size) {
	return {Dv: size + 1, dB: true, mK: true, IM: size + 1, v: size};
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$addData = F3(
	function (size, bytes, matrix) {
		return A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$addDataModule,
			$pablohirafuji$elm_qrcode$QRCode$Matrix$initPlacement(size),
			bytes,
			0,
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Error$AlignmentPatternNotFound = {$: 0};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPatternData = $elm$core$Array$fromList(
	_List_fromArray(
		[
			_List_Nil,
			_List_fromArray(
			[6, 18]),
			_List_fromArray(
			[6, 22]),
			_List_fromArray(
			[6, 26]),
			_List_fromArray(
			[6, 30]),
			_List_fromArray(
			[6, 34]),
			_List_fromArray(
			[6, 22, 38]),
			_List_fromArray(
			[6, 24, 42]),
			_List_fromArray(
			[6, 26, 46]),
			_List_fromArray(
			[6, 28, 50]),
			_List_fromArray(
			[6, 30, 54]),
			_List_fromArray(
			[6, 32, 58]),
			_List_fromArray(
			[6, 34, 62]),
			_List_fromArray(
			[6, 26, 46, 66]),
			_List_fromArray(
			[6, 26, 48, 70]),
			_List_fromArray(
			[6, 26, 50, 74]),
			_List_fromArray(
			[6, 30, 54, 78]),
			_List_fromArray(
			[6, 30, 56, 82]),
			_List_fromArray(
			[6, 30, 58, 86]),
			_List_fromArray(
			[6, 34, 62, 90]),
			_List_fromArray(
			[6, 28, 50, 72, 94]),
			_List_fromArray(
			[6, 26, 50, 74, 98]),
			_List_fromArray(
			[6, 30, 54, 78, 102]),
			_List_fromArray(
			[6, 28, 54, 80, 106]),
			_List_fromArray(
			[6, 32, 58, 84, 110]),
			_List_fromArray(
			[6, 30, 58, 86, 114]),
			_List_fromArray(
			[6, 34, 62, 90, 118]),
			_List_fromArray(
			[6, 26, 50, 74, 98, 122]),
			_List_fromArray(
			[6, 30, 54, 78, 102, 126]),
			_List_fromArray(
			[6, 26, 52, 78, 104, 130]),
			_List_fromArray(
			[6, 30, 56, 82, 108, 134]),
			_List_fromArray(
			[6, 34, 60, 86, 112, 138]),
			_List_fromArray(
			[6, 30, 58, 86, 114, 142]),
			_List_fromArray(
			[6, 34, 62, 90, 118, 146]),
			_List_fromArray(
			[6, 30, 54, 78, 102, 126, 150]),
			_List_fromArray(
			[6, 24, 50, 76, 102, 128, 154]),
			_List_fromArray(
			[6, 28, 54, 80, 106, 132, 158]),
			_List_fromArray(
			[6, 32, 58, 84, 110, 136, 162]),
			_List_fromArray(
			[6, 26, 54, 82, 110, 138, 166]),
			_List_fromArray(
			[6, 30, 58, 86, 114, 142, 170])
		]));
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord = F2(
	function (rows, cols) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (row, list) {
					return A3(
						$elm$core$List$foldl,
						F2(
							function (col, list_) {
								return A2(
									$elm$core$List$cons,
									_Utils_Tuple2(row, col),
									list_);
							}),
						list,
						cols);
				}),
			_List_Nil,
			rows);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$isValidAlign = F2(
	function (size, _v0) {
		var row = _v0.a;
		var col = _v0.b;
		return ((row > 10) || ((10 < col) && (_Utils_cmp(col, size - 10) < 0))) && ((_Utils_cmp(row, size - 10) < 0) || (col > 10));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentRange = A2($elm$core$List$range, -2, 2);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentColor = F2(
	function (row, col) {
		return (_Utils_eq(row, -2) || ((row === 2) || (_Utils_eq(col, -2) || ((col === 2) || ((!row) && (!col)))))) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(true, true)) : $elm$core$Maybe$Just(
			_Utils_Tuple2(true, false));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignModule = F4(
	function (size, rowPos, colPos, _v0) {
		var row = _v0.a;
		var col = _v0.b;
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row + rowPos, col + colPos),
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentColor, row, col));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignment = F3(
	function (size, _v0, matrix) {
		var row = _v0.a;
		var col = _v0.b;
		return A3(
			$elm$core$List$foldl,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignModule, size, row, col),
			matrix,
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord, $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentRange, $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentRange));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignments = F3(
	function (size, locations, matrix) {
		return A3(
			$elm$core$List$foldl,
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignment(size),
			matrix,
			A2(
				$elm$core$List$filter,
				$pablohirafuji$elm_qrcode$QRCode$Matrix$isValidAlign(size),
				A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord, locations, locations)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPattern = F3(
	function (version, size, matrix) {
		return A2(
			$elm$core$Result$map,
			function (a) {
				return A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignments, size, a, matrix);
			},
			A2(
				$elm$core$Result$fromMaybe,
				$pablohirafuji$elm_qrcode$QRCode$Error$AlignmentPatternNotFound,
				A2($elm$core$Array$get, version - 1, $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPatternData)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$darkModule = F2(
	function (version, size) {
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, (4 * version) + 9, 8),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(true, true)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderRange = A2($elm$core$List$range, 0, 8);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderColor = F2(
	function (row, col) {
		return ((1 <= row) && ((row <= 7) && ((col === 1) || (col === 7)))) || (((1 <= col) && ((col <= 7) && ((row === 1) || (row === 7)))) || ((3 <= row) && ((row <= 5) && ((3 <= col) && (col <= 5)))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFinder = F5(
	function (size, rowOffset, colOffset, _v0, matrix) {
		var row = _v0.a;
		var col = _v0.b;
		var finalRow = row + rowOffset;
		var finalCol = col + colOffset;
		return ((finalRow < 0) || ((finalCol < 0) || ((_Utils_cmp(finalRow, size) > -1) || (_Utils_cmp(finalCol, size) > -1)))) ? matrix : A3(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, finalRow, finalCol),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(
					true,
					A2($pablohirafuji$elm_qrcode$QRCode$Matrix$finderColor, row, col))),
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern = F4(
	function (size, rowOffset, colOffset, matrix) {
		return A3(
			$elm$core$List$foldl,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setFinder, size, rowOffset, colOffset),
			matrix,
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord, $pablohirafuji$elm_qrcode$QRCode$Matrix$finderRange, $pablohirafuji$elm_qrcode$QRCode$Matrix$finderRange));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskColor = F2(
	function (maybeModule, isChange) {
		if (isChange) {
			if ((!maybeModule.$) && (!maybeModule.a.a)) {
				var _v1 = maybeModule.a;
				var isDark = _v1.b;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(false, !isDark));
			} else {
				return maybeModule;
			}
		} else {
			return maybeModule;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getCoord = F2(
	function (size, index) {
		return _Utils_Tuple2(
			(index / size) | 0,
			A2($elm$core$Basics$modBy, size, index));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskFunction = F4(
	function (_function, size, index, maybeModule) {
		return A2(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskColor,
			maybeModule,
			_function(
				A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getCoord, size, index)));
	});
var $elm$core$Elm$JsArray$foldl = _JsArray_foldl;
var $elm$core$Elm$JsArray$indexedMap = _JsArray_indexedMap;
var $elm$core$Array$indexedMap = F2(
	function (func, _v0) {
		var len = _v0.a;
		var tree = _v0.c;
		var tail = _v0.d;
		var initialBuilder = {
			ag: _List_Nil,
			N: 0,
			ad: A3(
				$elm$core$Elm$JsArray$indexedMap,
				func,
				$elm$core$Array$tailIndex(len),
				tail)
		};
		var helper = F2(
			function (node, builder) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, builder, subTree);
				} else {
					var leaf = node.a;
					var offset = builder.N * $elm$core$Array$branchFactor;
					var mappedLeaf = $elm$core$Array$Leaf(
						A3($elm$core$Elm$JsArray$indexedMap, func, offset, leaf));
					return {
						ag: A2($elm$core$List$cons, mappedLeaf, builder.ag),
						N: builder.N + 1,
						ad: builder.ad
					};
				}
			});
		return A2(
			$elm$core$Array$builderToArray,
			true,
			A3($elm$core$Elm$JsArray$foldl, helper, initialBuilder, tree));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$maskFunction = function (mask) {
	switch (mask) {
		case 0:
			return function (_v1) {
				var row = _v1.a;
				var col = _v1.b;
				return !A2($elm$core$Basics$modBy, 2, row + col);
			};
		case 1:
			return function (_v2) {
				var row = _v2.a;
				return !A2($elm$core$Basics$modBy, 2, row);
			};
		case 2:
			return function (_v3) {
				var col = _v3.b;
				return !A2($elm$core$Basics$modBy, 3, col);
			};
		case 3:
			return function (_v4) {
				var row = _v4.a;
				var col = _v4.b;
				return !A2($elm$core$Basics$modBy, 3, row + col);
			};
		case 4:
			return function (_v5) {
				var row = _v5.a;
				var col = _v5.b;
				return !A2(
					$elm$core$Basics$modBy,
					2,
					$elm$core$Basics$floor(row / 2) + $elm$core$Basics$floor(col / 3));
			};
		case 5:
			return function (_v6) {
				var row = _v6.a;
				var col = _v6.b;
				return !(A2($elm$core$Basics$modBy, 2, row * col) + A2($elm$core$Basics$modBy, 3, row * col));
			};
		case 6:
			return function (_v7) {
				var row = _v7.a;
				var col = _v7.b;
				return !A2(
					$elm$core$Basics$modBy,
					2,
					A2($elm$core$Basics$modBy, 2, row * col) + A2($elm$core$Basics$modBy, 3, row * col));
			};
		default:
			return function (_v8) {
				var row = _v8.a;
				var col = _v8.b;
				return !A2(
					$elm$core$Basics$modBy,
					2,
					A2($elm$core$Basics$modBy, 3, row * col) + A2($elm$core$Basics$modBy, 2, row + col));
			};
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMask = F3(
	function (size, mask, matrix) {
		return A2(
			$elm$core$Array$indexedMap,
			A2(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskFunction,
				$pablohirafuji$elm_qrcode$QRCode$Matrix$maskFunction(mask),
				size),
			matrix);
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$breakList = F3(
	function (width, list, acc) {
		breakList:
		while (true) {
			if (!list.b) {
				return $elm$core$List$reverse(acc);
			} else {
				var $temp$width = width,
					$temp$list = A2($elm$core$List$drop, width, list),
					$temp$acc = A2(
					$elm$core$List$cons,
					A2($elm$core$List$take, width, list),
					acc);
				width = $temp$width;
				list = $temp$list;
				acc = $temp$acc;
				continue breakList;
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$isDarkModule = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map($elm$core$Tuple$second),
	$elm$core$Maybe$withDefault(false));
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score_ = F2(
	function (simplifiedList, _v0) {
		rule1Score_:
		while (true) {
			var last = _v0.a;
			var partialScore = _v0.b;
			var score = _v0.c;
			if (!simplifiedList.b) {
				return (partialScore >= 5) ? ((score + partialScore) - 2) : score;
			} else {
				var head = simplifiedList.a;
				var tail = simplifiedList.b;
				if (_Utils_eq(last, head)) {
					var $temp$simplifiedList = tail,
						$temp$_v0 = _Utils_Tuple3(last, partialScore + 1, score);
					simplifiedList = $temp$simplifiedList;
					_v0 = $temp$_v0;
					continue rule1Score_;
				} else {
					if (partialScore >= 5) {
						var $temp$simplifiedList = tail,
							$temp$_v0 = _Utils_Tuple3(head, 0, (score + partialScore) - 2);
						simplifiedList = $temp$simplifiedList;
						_v0 = $temp$_v0;
						continue rule1Score_;
					} else {
						var $temp$simplifiedList = tail,
							$temp$_v0 = _Utils_Tuple3(head, 0, score);
						simplifiedList = $temp$simplifiedList;
						_v0 = $temp$_v0;
						continue rule1Score_;
					}
				}
			}
		}
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map(
		function (a) {
			return A2(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score_,
				a,
				_Utils_Tuple3(false, 0, 0));
		}),
	$elm$core$List$sum);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score_ = F4(
	function (row1, row2, maybeLast, score) {
		rule2Score_:
		while (true) {
			if (!row1.b) {
				return score;
			} else {
				var head = row1.a;
				var tail = row1.b;
				if (!row2.b) {
					return score;
				} else {
					var head2 = row2.a;
					var tail2 = row2.b;
					if (_Utils_eq(head, head2)) {
						if (_Utils_eq(
							$elm$core$Maybe$Just(head),
							maybeLast)) {
							var $temp$row1 = tail,
								$temp$row2 = tail2,
								$temp$maybeLast = $elm$core$Maybe$Just(head),
								$temp$score = score + 3;
							row1 = $temp$row1;
							row2 = $temp$row2;
							maybeLast = $temp$maybeLast;
							score = $temp$score;
							continue rule2Score_;
						} else {
							var $temp$row1 = tail,
								$temp$row2 = tail2,
								$temp$maybeLast = $elm$core$Maybe$Just(head),
								$temp$score = score;
							row1 = $temp$row1;
							row2 = $temp$row2;
							maybeLast = $temp$maybeLast;
							score = $temp$score;
							continue rule2Score_;
						}
					} else {
						var $temp$row1 = tail,
							$temp$row2 = tail2,
							$temp$maybeLast = $elm$core$Maybe$Nothing,
							$temp$score = score;
						row1 = $temp$row1;
						row2 = $temp$row2;
						maybeLast = $temp$maybeLast;
						score = $temp$score;
						continue rule2Score_;
					}
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score = F2(
	function (list, score) {
		rule2Score:
		while (true) {
			if (list.b && list.b.b) {
				var head1 = list.a;
				var _v1 = list.b;
				var head2 = _v1.a;
				var tail = _v1.b;
				var $temp$list = tail,
					$temp$score = score + A4($pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score_, head1, head2, $elm$core$Maybe$Nothing, 0);
				list = $temp$list;
				score = $temp$score;
				continue rule2Score;
			} else {
				return score;
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score_ = F2(
	function (simplifiedList, score) {
		rule3Score_:
		while (true) {
			_v0$3:
			while (true) {
				if (!simplifiedList.b) {
					return score;
				} else {
					if (!simplifiedList.a) {
						if (((((((((((((((((((simplifiedList.b.b && (!simplifiedList.b.a)) && simplifiedList.b.b.b) && (!simplifiedList.b.b.a)) && simplifiedList.b.b.b.b) && (!simplifiedList.b.b.b.a)) && simplifiedList.b.b.b.b.b) && simplifiedList.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.b.b.b.b.a) {
							var _v1 = simplifiedList.b;
							var _v2 = _v1.b;
							var _v3 = _v2.b;
							var _v4 = _v3.b;
							var _v5 = _v4.b;
							var _v6 = _v5.b;
							var _v7 = _v6.b;
							var _v8 = _v7.b;
							var _v9 = _v8.b;
							var _v10 = _v9.b;
							var tail = _v10.b;
							var $temp$simplifiedList = tail,
								$temp$score = score + 40;
							simplifiedList = $temp$simplifiedList;
							score = $temp$score;
							continue rule3Score_;
						} else {
							break _v0$3;
						}
					} else {
						if (((((((((((((((((((simplifiedList.b.b && (!simplifiedList.b.a)) && simplifiedList.b.b.b) && simplifiedList.b.b.a) && simplifiedList.b.b.b.b) && simplifiedList.b.b.b.a) && simplifiedList.b.b.b.b.b) && simplifiedList.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.b.b.a)) {
							var _v11 = simplifiedList.b;
							var _v12 = _v11.b;
							var _v13 = _v12.b;
							var _v14 = _v13.b;
							var _v15 = _v14.b;
							var _v16 = _v15.b;
							var _v17 = _v16.b;
							var _v18 = _v17.b;
							var _v19 = _v18.b;
							var _v20 = _v19.b;
							var tail = _v20.b;
							var $temp$simplifiedList = tail,
								$temp$score = score + 40;
							simplifiedList = $temp$simplifiedList;
							score = $temp$score;
							continue rule3Score_;
						} else {
							break _v0$3;
						}
					}
				}
			}
			var head = simplifiedList.a;
			var tail = simplifiedList.b;
			var $temp$simplifiedList = tail,
				$temp$score = score;
			simplifiedList = $temp$simplifiedList;
			score = $temp$score;
			continue rule3Score_;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score = A2($elm$core$List$foldl, $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score_, 0);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule4Score = F2(
	function (size, simplifiedList) {
		var moduleCount = size * size;
		var darkCount = $elm$core$List$length(
			A2($elm$core$List$filter, $elm$core$Basics$identity, simplifiedList));
		var darkPerc = $elm$core$Basics$round((100 * darkCount) / moduleCount);
		var remOf5 = darkPerc % 5;
		var nextMult5 = $elm$core$Basics$round(
			$elm$core$Basics$abs((darkPerc + (5 - remOf5)) - 50) / 5);
		var prevMult5 = $elm$core$Basics$round(
			$elm$core$Basics$abs((darkPerc - remOf5) - 50) / 5);
		return A2($elm$core$Basics$min, prevMult5, nextMult5) * 10;
	});
var $pablohirafuji$elm_qrcode$QRCode$Helpers$transpose = function (ll) {
	transpose:
	while (true) {
		if (!ll.b) {
			return _List_Nil;
		} else {
			if (!ll.a.b) {
				var xss = ll.b;
				var $temp$ll = xss;
				ll = $temp$ll;
				continue transpose;
			} else {
				var _v1 = ll.a;
				var x = _v1.a;
				var xs = _v1.b;
				var xss = ll.b;
				var tails = A2($elm$core$List$filterMap, $elm$core$List$tail, xss);
				var heads = A2($elm$core$List$filterMap, $elm$core$List$head, xss);
				return A2(
					$elm$core$List$cons,
					A2($elm$core$List$cons, x, heads),
					$pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(
						A2($elm$core$List$cons, xs, tails)));
			}
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getMaskScore = F2(
	function (size, matrix) {
		var list = A2(
			$elm$core$List$map,
			$pablohirafuji$elm_qrcode$QRCode$Matrix$isDarkModule,
			$elm$core$Array$toList(matrix));
		var rowList = A3($pablohirafuji$elm_qrcode$QRCode$Matrix$breakList, size, list, _List_Nil);
		var transposedRowList = $pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(rowList);
		return function (b) {
			return _Utils_Tuple2(rowList, b);
		}(
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$rule4Score, size, list) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score(transposedRowList) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score(rowList) + (A2($pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score, rowList, 0) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score(transposedRowList) + $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score(rowList))))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$ecLevelToInt = function (ecLevel) {
	switch (ecLevel) {
		case 0:
			return 1;
		case 1:
			return 0;
		case 2:
			return 3;
		default:
			return 2;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit = function (_int) {
	var helper = F2(
		function (digit, int_) {
			helper:
			while (true) {
				if (!(!int_)) {
					var $temp$digit = digit + 1,
						$temp$int_ = int_ >>> 1;
					digit = $temp$digit;
					int_ = $temp$int_;
					continue helper;
				} else {
					return digit;
				}
			}
		});
	return A2(helper, 0, _int);
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$maskToInt = function (mask) {
	switch (mask) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		case 6:
			return 6;
		default:
			return 7;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeFormatInfo = F2(
	function (ecLevel, mask) {
		var g15Mask = 21522;
		var g15Int = 1335;
		var g15Digit = $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(g15Int);
		var formatInfoInt = $pablohirafuji$elm_qrcode$QRCode$Matrix$maskToInt(mask) | ($pablohirafuji$elm_qrcode$QRCode$Matrix$ecLevelToInt(ecLevel) << 3);
		var helper = function (d_) {
			helper:
			while (true) {
				if (($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g15Digit) >= 0) {
					var $temp$d_ = d_ ^ (g15Int << ($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g15Digit));
					d_ = $temp$d_;
					continue helper;
				} else {
					return g15Mask ^ (d_ | (formatInfoInt << 10));
				}
			}
		};
		var d = formatInfoInt << 10;
		return helper(d);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoHorizontal = F2(
	function (size, count) {
		return (count < 8) ? _Utils_Tuple2(8, (size - count) - 1) : ((count < 9) ? _Utils_Tuple2(8, 15 - count) : _Utils_Tuple2(8, (15 - count) - 1));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoVertical = F2(
	function (size, count) {
		return (count < 6) ? _Utils_Tuple2(count, 8) : ((count < 8) ? _Utils_Tuple2(count + 1, 8) : _Utils_Tuple2((size - 15) + count, 8));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule = F4(
	function (size, isBlack, row, col) {
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(true, isBlack)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_ = F4(
	function (size, isBlackFn, count, matrix) {
		setFormatInfo_:
		while (true) {
			if (count < 15) {
				var isBlack = isBlackFn(count);
				var _v0 = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoVertical, size, count);
				var x2 = _v0.a;
				var y2 = _v0.b;
				var _v1 = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoHorizontal, size, count);
				var x1 = _v1.a;
				var y1 = _v1.b;
				var $temp$size = size,
					$temp$isBlackFn = isBlackFn,
					$temp$count = count + 1,
					$temp$matrix = A5(
					$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule,
					size,
					isBlack,
					x2,
					y2,
					A5($pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule, size, isBlack, x1, y1, matrix));
				size = $temp$size;
				isBlackFn = $temp$isBlackFn;
				count = $temp$count;
				matrix = $temp$matrix;
				continue setFormatInfo_;
			} else {
				return matrix;
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo = F4(
	function (ecLevel, size, mask, matrix) {
		var isBlack = F2(
			function (bits_, count) {
				return (1 & (bits_ >> count)) === 1;
			});
		var bits = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$encodeFormatInfo, ecLevel, mask);
		return A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_,
			size,
			isBlack(bits),
			0,
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask_ = F5(
	function (ecLevel, size, matrix, mask, _v0) {
		var minSMatrix = _v0.a;
		var minScore = _v0.b;
		var maskedMatrix = A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo,
			ecLevel,
			size,
			mask,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$applyMask, size, mask, matrix));
		var _v1 = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getMaskScore, size, maskedMatrix);
		var maskSMatrix = _v1.a;
		var maskScore = _v1.b;
		return ((_Utils_cmp(minScore, maskScore) < 0) && (!_Utils_eq(minScore, -1))) ? _Utils_Tuple2(minSMatrix, minScore) : _Utils_Tuple2(maskSMatrix, maskScore);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern0 = 0;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern1 = 1;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern2 = 2;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern3 = 3;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern4 = 4;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern5 = 5;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern6 = 6;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern7 = 7;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$patternList = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7]);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask = F3(
	function (ecLevel, size, matrix) {
		return A3(
			$elm$core$List$foldl,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask_, ecLevel, size, matrix),
			_Utils_Tuple2(_List_Nil, -1),
			$pablohirafuji$elm_qrcode$QRCode$Matrix$patternList).a;
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$reserveFormatInfo = F2(
	function (size, matrix) {
		return A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_,
			size,
			$elm$core$Basics$always(true),
			0,
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeVersionInfo = function (version) {
	var g18Int = 7973;
	var g18Digit = $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(g18Int);
	var helper = function (d_) {
		helper:
		while (true) {
			if (($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g18Digit) >= 0) {
				var $temp$d_ = d_ ^ (g18Int << ($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g18Digit));
				d_ = $temp$d_;
				continue helper;
			} else {
				return d_ | (version << 12);
			}
		}
	};
	var d = version << 12;
	return helper(d);
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule = F3(
	function (size, isBlack, _v0) {
		var row = _v0.a;
		var col = _v0.b;
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(true, isBlack)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo_ = F4(
	function (size, isBlackFn, count, matrix) {
		setVersionInfo_:
		while (true) {
			if (count < 18) {
				var topRight = _Utils_Tuple2(
					$elm$core$Basics$floor(count / 3),
					((A2($elm$core$Basics$modBy, 3, count) + size) - 8) - 3);
				var isBlack = isBlackFn(count);
				var bottomLeft = _Utils_Tuple2(
					((A2($elm$core$Basics$modBy, 3, count) + size) - 8) - 3,
					$elm$core$Basics$floor(count / 3));
				var $temp$size = size,
					$temp$isBlackFn = isBlackFn,
					$temp$count = count + 1,
					$temp$matrix = A4(
					$pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule,
					size,
					isBlack,
					bottomLeft,
					A4($pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule, size, isBlack, topRight, matrix));
				size = $temp$size;
				isBlackFn = $temp$isBlackFn;
				count = $temp$count;
				matrix = $temp$matrix;
				continue setVersionInfo_;
			} else {
				return matrix;
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo = F3(
	function (version, size, matrix) {
		if (version >= 7) {
			var isBlack = F2(
				function (bits_, count) {
					return (1 & (bits_ >> count)) === 1;
				});
			var bits = $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeVersionInfo(version);
			return A4(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo_,
				size,
				isBlack(bits),
				0,
				matrix);
		} else {
			return matrix;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$timingColor = F2(
	function (row, col) {
		return (!A2($elm$core$Basics$modBy, 2, row + col)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(true, true)) : $elm$core$Maybe$Just(
			_Utils_Tuple2(true, false));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming = F3(
	function (size, row, col) {
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$timingColor, row, col));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$timingPattern = F2(
	function (size, matrix) {
		var range = A2($elm$core$List$range, 8, size - 9);
		return A3(
			$elm$core$List$foldl,
			function (b) {
				return A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming, size, b, 6);
			},
			A3(
				$elm$core$List$foldl,
				A2($pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming, size, 6),
				matrix,
				range),
			range);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$apply = function (_v0) {
	var ecLevel = _v0.a.yz;
	var groupInfo = _v0.a.E9;
	var bytes = _v0.b;
	var version = groupInfo.wV;
	var size = ((version - 1) * 4) + 21;
	return A2(
		$elm$core$Result$map,
		A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask, ecLevel, size),
		A2(
			$elm$core$Result$map,
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$addData, size, bytes),
			A3(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPattern,
				version,
				size,
				A2(
					$pablohirafuji$elm_qrcode$QRCode$Matrix$timingPattern,
					size,
					A3(
						$pablohirafuji$elm_qrcode$QRCode$Matrix$darkModule,
						version,
						size,
						A3(
							$pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo,
							version,
							size,
							A2(
								$pablohirafuji$elm_qrcode$QRCode$Matrix$reserveFormatInfo,
								size,
								A4(
									$pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern,
									size,
									-1,
									size - 8,
									A4(
										$pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern,
										size,
										size - 8,
										-1,
										A4(
											$pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern,
											size,
											-1,
											-1,
											A2(
												$elm$core$Array$initialize,
												size * size,
												$elm$core$Basics$always($elm$core$Maybe$Nothing))))))))))));
};
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$H = 3;
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$L = 0;
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$M = 1;
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$Q = 2;
var $pablohirafuji$elm_qrcode$QRCode$convertEC = function (ec) {
	switch (ec) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$AlignmentPatternNotFound = {$: 0};
var $pablohirafuji$elm_qrcode$QRCode$InputLengthOverflow = {$: 7};
var $pablohirafuji$elm_qrcode$QRCode$InvalidAlphanumericChar = {$: 2};
var $pablohirafuji$elm_qrcode$QRCode$InvalidNumericChar = {$: 1};
var $pablohirafuji$elm_qrcode$QRCode$InvalidUTF8Char = {$: 3};
var $pablohirafuji$elm_qrcode$QRCode$LogTableException = function (a) {
	return {$: 4, a: a};
};
var $pablohirafuji$elm_qrcode$QRCode$PolynomialModException = {$: 6};
var $pablohirafuji$elm_qrcode$QRCode$PolynomialMultiplyException = {$: 5};
var $pablohirafuji$elm_qrcode$QRCode$convertError = function (e) {
	switch (e.$) {
		case 0:
			return $pablohirafuji$elm_qrcode$QRCode$AlignmentPatternNotFound;
		case 1:
			return $pablohirafuji$elm_qrcode$QRCode$InvalidNumericChar;
		case 2:
			return $pablohirafuji$elm_qrcode$QRCode$InvalidAlphanumericChar;
		case 3:
			return $pablohirafuji$elm_qrcode$QRCode$InvalidUTF8Char;
		case 4:
			var n = e.a;
			return $pablohirafuji$elm_qrcode$QRCode$LogTableException(n);
		case 5:
			return $pablohirafuji$elm_qrcode$QRCode$PolynomialMultiplyException;
		case 6:
			return $pablohirafuji$elm_qrcode$QRCode$PolynomialModException;
		default:
			return $pablohirafuji$elm_qrcode$QRCode$InputLengthOverflow;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$firstFillerByte = 236;
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$secondFillerByte = 17;
var $pablohirafuji$elm_qrcode$QRCode$Encode$addFiller = F2(
	function (capacity, bytes) {
		var fillerLength = ((capacity / 8) | 0) - $elm$core$List$length(bytes);
		var ns = $elm$core$List$concat(
			A2(
				$elm$core$List$repeat,
				(fillerLength / 2) | 0,
				_List_fromArray(
					[$pablohirafuji$elm_qrcode$QRCode$Encode$firstFillerByte, $pablohirafuji$elm_qrcode$QRCode$Encode$secondFillerByte])));
		return (!A2($elm$core$Basics$modBy, 2, fillerLength)) ? _Utils_ap(bytes, ns) : _Utils_ap(
			bytes,
			_Utils_ap(
				ns,
				_List_fromArray(
					[$pablohirafuji$elm_qrcode$QRCode$Encode$firstFillerByte])));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$addTerminator = F3(
	function (capacity, bitsCount, bits) {
		return _Utils_ap(
			bits,
			_List_fromArray(
				[
					_Utils_Tuple2(
					0,
					A2($elm$core$Basics$min, 4, capacity - bitsCount))
				]));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes3 = function (_v0) {
	bitsToBytes3:
	while (true) {
		var _v1 = _v0.a;
		var bits = _v1.a;
		var length = _v1.b;
		var bytes = _v0.b;
		if (length >= 8) {
			var remLength = length - 8;
			var remBits = bits & ((1 << remLength) - 1);
			var _byte = bits >> remLength;
			var $temp$_v0 = _Utils_Tuple2(
				_Utils_Tuple2(remBits, remLength),
				A2($elm$core$List$cons, _byte, bytes));
			_v0 = $temp$_v0;
			continue bitsToBytes3;
		} else {
			return _Utils_Tuple2(
				_Utils_Tuple2(bits, length),
				bytes);
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes2 = F2(
	function (_v0, _v1) {
		var curBits = _v0.a;
		var curLength = _v0.b;
		var _v2 = _v1.a;
		var remBits = _v2.a;
		var remLength = _v2.b;
		var bytes = _v1.b;
		var lengthSum = curLength + remLength;
		var bitsSum = curBits | (remBits << curLength);
		return $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes3(
			_Utils_Tuple2(
				_Utils_Tuple2(bitsSum, lengthSum),
				bytes));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes1 = F2(
	function (bits, _v0) {
		bitsToBytes1:
		while (true) {
			var _v1 = _v0.a;
			var remBits = _v1.a;
			var remLength = _v1.b;
			var bytes = _v0.b;
			if (bits.b) {
				var head = bits.a;
				var tail = bits.b;
				var $temp$bits = tail,
					$temp$_v0 = A2(
					$pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes2,
					head,
					_Utils_Tuple2(
						_Utils_Tuple2(remBits, remLength),
						bytes));
				bits = $temp$bits;
				_v0 = $temp$_v0;
				continue bitsToBytes1;
			} else {
				return (!remLength) ? $elm$core$List$reverse(bytes) : $elm$core$List$reverse(
					A2($elm$core$List$cons, remBits << (8 - remLength), bytes));
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes = function (bits) {
	return A2(
		$pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes1,
		bits,
		_Utils_Tuple2(
			_Utils_Tuple2(0, 0),
			_List_Nil));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8 = 3;
var $pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength = F2(
	function (mode, version) {
		if (version <= 9) {
			switch (mode) {
				case 0:
					return 10;
				case 1:
					return 9;
				case 2:
					return 8;
				default:
					return 8;
			}
		} else {
			if (version <= 26) {
				switch (mode) {
					case 0:
						return 12;
					case 1:
						return 11;
					case 2:
						return 16;
					default:
						return 16;
				}
			} else {
				switch (mode) {
					case 0:
						return 14;
					case 1:
						return 13;
					case 2:
						return 16;
					default:
						return 16;
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicator = F2(
	function (_v0, bits) {
		var groupInfo = _v0.E9;
		var inputStr = _v0.s$;
		var mode = _v0.qf;
		var length = A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength, mode, groupInfo.wV);
		var charCount = (mode === 3) ? $elm$core$List$length(bits) : $elm$core$String$length(inputStr);
		return _Utils_Tuple2(charCount, length);
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$modeIndicator = function (mode) {
	switch (mode) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 4;
		default:
			return 4;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$addInfoAndFinalBits = function (_v0) {
	var bits = _v0.a;
	var model = _v0.b;
	return _Utils_Tuple2(
		model,
		A2(
			$pablohirafuji$elm_qrcode$QRCode$Encode$addFiller,
			model.E9.pc,
			$pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes(
				A3(
					$pablohirafuji$elm_qrcode$QRCode$Encode$addTerminator,
					model.E9.pc,
					model.rH,
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							$pablohirafuji$elm_qrcode$QRCode$Encode$modeIndicator(model.qf),
							4),
						A2(
							$elm$core$List$cons,
							A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicator, model, bits),
							bits))))));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$concatTranspose = function (_v0) {
	var model = _v0.a;
	var dataBlocks = _v0.b;
	var ecBlocks = _v0.c;
	return _Utils_Tuple2(
		model,
		$elm$core$List$concat(
			_Utils_ap(
				$pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(dataBlocks),
				$pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(ecBlocks))));
};
var $elm_community$list_extra$List$Extra$greedyGroupsOfWithStep = F3(
	function (size, step, list) {
		if ((size <= 0) || (step <= 0)) {
			return _List_Nil;
		} else {
			var go = F2(
				function (xs, acc) {
					go:
					while (true) {
						if ($elm$core$List$isEmpty(xs)) {
							return $elm$core$List$reverse(acc);
						} else {
							var $temp$xs = A2($elm$core$List$drop, step, xs),
								$temp$acc = A2(
								$elm$core$List$cons,
								A2($elm$core$List$take, size, xs),
								acc);
							xs = $temp$xs;
							acc = $temp$acc;
							continue go;
						}
					}
				});
			return A2(go, list, _List_Nil);
		}
	});
var $elm_community$list_extra$List$Extra$greedyGroupsOf = F2(
	function (size, xs) {
		return A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, size, xs);
	});
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Error$InvalidAlphanumericChar = {$: 2};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$alphanumericCodes = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('0', 0),
			_Utils_Tuple2('1', 1),
			_Utils_Tuple2('2', 2),
			_Utils_Tuple2('3', 3),
			_Utils_Tuple2('4', 4),
			_Utils_Tuple2('5', 5),
			_Utils_Tuple2('6', 6),
			_Utils_Tuple2('7', 7),
			_Utils_Tuple2('8', 8),
			_Utils_Tuple2('9', 9),
			_Utils_Tuple2('A', 10),
			_Utils_Tuple2('B', 11),
			_Utils_Tuple2('C', 12),
			_Utils_Tuple2('D', 13),
			_Utils_Tuple2('E', 14),
			_Utils_Tuple2('F', 15),
			_Utils_Tuple2('G', 16),
			_Utils_Tuple2('H', 17),
			_Utils_Tuple2('I', 18),
			_Utils_Tuple2('J', 19),
			_Utils_Tuple2('K', 20),
			_Utils_Tuple2('L', 21),
			_Utils_Tuple2('M', 22),
			_Utils_Tuple2('N', 23),
			_Utils_Tuple2('O', 24),
			_Utils_Tuple2('P', 25),
			_Utils_Tuple2('Q', 26),
			_Utils_Tuple2('R', 27),
			_Utils_Tuple2('S', 28),
			_Utils_Tuple2('T', 29),
			_Utils_Tuple2('U', 30),
			_Utils_Tuple2('V', 31),
			_Utils_Tuple2('W', 32),
			_Utils_Tuple2('X', 33),
			_Utils_Tuple2('Y', 34),
			_Utils_Tuple2('Z', 35),
			_Utils_Tuple2(' ', 36),
			_Utils_Tuple2('$', 37),
			_Utils_Tuple2('%', 38),
			_Utils_Tuple2('*', 39),
			_Utils_Tuple2('+', 40),
			_Utils_Tuple2('-', 41),
			_Utils_Tuple2('.', 42),
			_Utils_Tuple2('/', 43),
			_Utils_Tuple2(':', 44)
		]));
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode = function (_char) {
	return A2(
		$elm$core$Result$fromMaybe,
		$pablohirafuji$elm_qrcode$QRCode$Error$InvalidAlphanumericChar,
		A2($elm$core$Dict$get, _char, $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$alphanumericCodes));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toBinary = function (chars) {
	_v0$2:
	while (true) {
		if (chars.b) {
			if (chars.b.b) {
				if (!chars.b.b.b) {
					var firstChar = chars.a;
					var _v1 = chars.b;
					var secondChar = _v1.a;
					return A3(
						$elm$core$Result$map2,
						F2(
							function (firstCode, secondCode) {
								return _Utils_Tuple2((firstCode * 45) + secondCode, 11);
							}),
						$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode(firstChar),
						$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode(secondChar));
				} else {
					break _v0$2;
				}
			} else {
				var _char = chars.a;
				return A2(
					$elm$core$Result$map,
					function (a) {
						return _Utils_Tuple2(a, 6);
					},
					$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode(_char));
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Result$Err($pablohirafuji$elm_qrcode$QRCode$Error$InvalidAlphanumericChar);
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$encode = function (str) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Result$map2($elm$core$List$cons),
		$elm$core$Result$Ok(_List_Nil),
		A2(
			$elm$core$List$map,
			$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toBinary,
			A2(
				$elm_community$list_extra$List$Extra$greedyGroupsOf,
				2,
				$elm$core$String$toList(str))));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$encode = function (str) {
	return $elm$core$Result$Ok(
		A2(
			$elm$core$List$map,
			function (a) {
				return _Utils_Tuple2(
					$elm$core$Char$toCode(a),
					8);
			},
			$elm$core$String$toList(str)));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$InvalidNumericChar = {$: 1};
var $elm$core$String$fromList = _String_fromList;
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$numericLength = function (str) {
	var _v0 = $elm$core$String$length(str);
	switch (_v0) {
		case 1:
			return 4;
		case 2:
			return 7;
		default:
			return 10;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encodeHelp = function (chars) {
	var str = $elm$core$String$fromList(chars);
	return A2(
		$elm$core$Result$fromMaybe,
		$pablohirafuji$elm_qrcode$QRCode$Error$InvalidNumericChar,
		A2(
			$elm$core$Maybe$map,
			function (a) {
				return _Utils_Tuple2(
					a,
					$pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$numericLength(str));
			},
			$elm$core$String$toInt(str)));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encode = function (str) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Result$map2($elm$core$List$cons),
		$elm$core$Result$Ok(_List_Nil),
		A2(
			$elm$core$List$map,
			$pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encodeHelp,
			A2(
				$elm_community$list_extra$List$Extra$greedyGroupsOf,
				3,
				$elm$core$String$toList(str))));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$InvalidUTF8Char = {$: 3};
var $elm$bytes$Bytes$Encode$getWidth = function (builder) {
	switch (builder.$) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 4;
		case 3:
			return 1;
		case 4:
			return 2;
		case 5:
			return 4;
		case 6:
			return 4;
		case 7:
			return 8;
		case 8:
			var w = builder.a;
			return w;
		case 9:
			var w = builder.a;
			return w;
		default:
			var bs = builder.a;
			return _Bytes_width(bs);
	}
};
var $elm$bytes$Bytes$LE = 0;
var $elm$bytes$Bytes$Encode$write = F3(
	function (builder, mb, offset) {
		switch (builder.$) {
			case 0:
				var n = builder.a;
				return A3(_Bytes_write_i8, mb, offset, n);
			case 1:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i16, mb, offset, n, !e);
			case 2:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i32, mb, offset, n, !e);
			case 3:
				var n = builder.a;
				return A3(_Bytes_write_u8, mb, offset, n);
			case 4:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u16, mb, offset, n, !e);
			case 5:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u32, mb, offset, n, !e);
			case 6:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f32, mb, offset, n, !e);
			case 7:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f64, mb, offset, n, !e);
			case 8:
				var bs = builder.b;
				return A3($elm$bytes$Bytes$Encode$writeSequence, bs, mb, offset);
			case 9:
				var s = builder.b;
				return A3(_Bytes_write_string, mb, offset, s);
			default:
				var bs = builder.a;
				return A3(_Bytes_write_bytes, mb, offset, bs);
		}
	});
var $elm$bytes$Bytes$Encode$writeSequence = F3(
	function (builders, mb, offset) {
		writeSequence:
		while (true) {
			if (!builders.b) {
				return offset;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$builders = bs,
					$temp$mb = mb,
					$temp$offset = A3($elm$bytes$Bytes$Encode$write, b, mb, offset);
				builders = $temp$builders;
				mb = $temp$mb;
				offset = $temp$offset;
				continue writeSequence;
			}
		}
	});
var $elm$bytes$Bytes$Decode$decode = F2(
	function (_v0, bs) {
		var decoder = _v0;
		return A2(_Bytes_decode, decoder, bs);
	});
var $elm$bytes$Bytes$Encode$encode = _Bytes_encode;
var $elm$bytes$Bytes$Encode$getStringWidth = _Bytes_getStringWidth;
var $elm$bytes$Bytes$Decode$Decoder = $elm$core$Basics$identity;
var $elm$bytes$Bytes$Decode$loopHelp = F4(
	function (state, callback, bites, offset) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var decoder = _v0;
			var _v1 = A2(decoder, bites, offset);
			var newOffset = _v1.a;
			var step = _v1.b;
			if (!step.$) {
				var newState = step.a;
				var $temp$state = newState,
					$temp$callback = callback,
					$temp$bites = bites,
					$temp$offset = newOffset;
				state = $temp$state;
				callback = $temp$callback;
				bites = $temp$bites;
				offset = $temp$offset;
				continue loopHelp;
			} else {
				var result = step.a;
				return _Utils_Tuple2(newOffset, result);
			}
		}
	});
var $elm$bytes$Bytes$Decode$loop = F2(
	function (state, callback) {
		return A2($elm$bytes$Bytes$Decode$loopHelp, state, callback);
	});
var $elm$bytes$Bytes$Decode$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$bytes$Bytes$Decode$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$bytes$Bytes$Decode$map = F2(
	function (func, _v0) {
		var decodeA = _v0;
		return F2(
			function (bites, offset) {
				var _v1 = A2(decodeA, bites, offset);
				var aOffset = _v1.a;
				var a = _v1.b;
				return _Utils_Tuple2(
					aOffset,
					func(a));
			});
	});
var $elm$bytes$Bytes$Decode$succeed = function (a) {
	return F2(
		function (_v0, offset) {
			return _Utils_Tuple2(offset, a);
		});
};
var $elm$bytes$Bytes$Decode$unsignedInt8 = _Bytes_read_u8;
var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$step = function (_v0) {
	var n = _v0.a;
	var xs = _v0.b;
	return (n <= 0) ? $elm$bytes$Bytes$Decode$succeed(
		$elm$bytes$Bytes$Decode$Done(
			$elm$core$List$reverse(xs))) : A2(
		$elm$bytes$Bytes$Decode$map,
		function (x) {
			return $elm$bytes$Bytes$Decode$Loop(
				_Utils_Tuple2(
					n - 1,
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(x, 8),
						xs)));
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $elm$bytes$Bytes$Encode$Utf8 = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$string = function (str) {
	return A2(
		$elm$bytes$Bytes$Encode$Utf8,
		_Bytes_getStringWidth(str),
		str);
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$encode = function (str) {
	var utf8BytesWidth = $elm$bytes$Bytes$Encode$getStringWidth(str);
	var decoder = A2(
		$elm$bytes$Bytes$Decode$loop,
		_Utils_Tuple2(utf8BytesWidth, _List_Nil),
		$pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$step);
	return A2(
		$elm$core$Result$fromMaybe,
		$pablohirafuji$elm_qrcode$QRCode$Error$InvalidUTF8Char,
		A2(
			$elm$bytes$Bytes$Decode$decode,
			decoder,
			$elm$bytes$Bytes$Encode$encode(
				$elm$bytes$Bytes$Encode$string(str))));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$encoder = function (mode) {
	switch (mode) {
		case 0:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encode;
		case 1:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$encode;
		case 2:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$encode;
		default:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$encode;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$expTable = $elm$core$Array$fromList(
	_List_fromArray(
		[1, 2, 4, 8, 16, 32, 64, 128, 29, 58, 116, 232, 205, 135, 19, 38, 76, 152, 45, 90, 180, 117, 234, 201, 143, 3, 6, 12, 24, 48, 96, 192, 157, 39, 78, 156, 37, 74, 148, 53, 106, 212, 181, 119, 238, 193, 159, 35, 70, 140, 5, 10, 20, 40, 80, 160, 93, 186, 105, 210, 185, 111, 222, 161, 95, 190, 97, 194, 153, 47, 94, 188, 101, 202, 137, 15, 30, 60, 120, 240, 253, 231, 211, 187, 107, 214, 177, 127, 254, 225, 223, 163, 91, 182, 113, 226, 217, 175, 67, 134, 17, 34, 68, 136, 13, 26, 52, 104, 208, 189, 103, 206, 129, 31, 62, 124, 248, 237, 199, 147, 59, 118, 236, 197, 151, 51, 102, 204, 133, 23, 46, 92, 184, 109, 218, 169, 79, 158, 33, 66, 132, 21, 42, 84, 168, 77, 154, 41, 82, 164, 85, 170, 73, 146, 57, 114, 228, 213, 183, 115, 230, 209, 191, 99, 198, 145, 63, 126, 252, 229, 215, 179, 123, 246, 241, 255, 227, 219, 171, 75, 150, 49, 98, 196, 149, 55, 110, 220, 165, 87, 174, 65, 130, 25, 50, 100, 200, 141, 7, 14, 28, 56, 112, 224, 221, 167, 83, 166, 81, 162, 89, 178, 121, 242, 249, 239, 195, 155, 43, 86, 172, 69, 138, 9, 18, 36, 72, 144, 61, 122, 244, 245, 247, 243, 251, 235, 203, 139, 11, 22, 44, 88, 176, 125, 250, 233, 207, 131, 27, 54, 108, 216, 173, 71, 142, 1]));
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp = function (index) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Array$get,
			A2($elm$core$Basics$modBy, 255, index),
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$expTable));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$PolynomialMultiplyException = {$: 5};
var $pablohirafuji$elm_qrcode$QRCode$Error$LogTableException = function (a) {
	return {$: 4, a: a};
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$logTable = $elm$core$Array$fromList(
	_List_fromArray(
		[0, 1, 25, 2, 50, 26, 198, 3, 223, 51, 238, 27, 104, 199, 75, 4, 100, 224, 14, 52, 141, 239, 129, 28, 193, 105, 248, 200, 8, 76, 113, 5, 138, 101, 47, 225, 36, 15, 33, 53, 147, 142, 218, 240, 18, 130, 69, 29, 181, 194, 125, 106, 39, 249, 185, 201, 154, 9, 120, 77, 228, 114, 166, 6, 191, 139, 98, 102, 221, 48, 253, 226, 152, 37, 179, 16, 145, 34, 136, 54, 208, 148, 206, 143, 150, 219, 189, 241, 210, 19, 92, 131, 56, 70, 64, 30, 66, 182, 163, 195, 72, 126, 110, 107, 58, 40, 84, 250, 133, 186, 61, 202, 94, 155, 159, 10, 21, 121, 43, 78, 212, 229, 172, 115, 243, 167, 87, 7, 112, 192, 247, 140, 128, 99, 13, 103, 74, 222, 237, 49, 197, 254, 24, 227, 165, 153, 119, 38, 184, 180, 124, 17, 68, 146, 217, 35, 32, 137, 46, 55, 63, 209, 91, 149, 188, 207, 205, 144, 135, 151, 178, 220, 252, 190, 97, 242, 86, 211, 171, 20, 42, 93, 158, 132, 60, 57, 83, 71, 109, 65, 162, 31, 45, 67, 216, 183, 123, 164, 118, 196, 23, 73, 236, 127, 12, 111, 246, 108, 161, 59, 82, 41, 157, 85, 170, 251, 96, 134, 177, 187, 204, 62, 90, 203, 89, 95, 176, 156, 169, 160, 81, 11, 245, 22, 235, 122, 117, 44, 215, 79, 174, 213, 233, 230, 231, 173, 232, 116, 214, 244, 234, 168, 80, 88, 175]));
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog = function (index) {
	return (index < 1) ? $elm$core$Result$Err(
		$pablohirafuji$elm_qrcode$QRCode$Error$LogTableException(index)) : A2(
		$elm$core$Result$fromMaybe,
		$pablohirafuji$elm_qrcode$QRCode$Error$LogTableException(index),
		A2($elm$core$Array$get, index - 1, $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$logTable));
};
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getOffset = function (_v0) {
	getOffset:
	while (true) {
		var num = _v0.a;
		var offset = _v0.b;
		if (num.b) {
			var head = num.a;
			var tail = num.b;
			if (!head) {
				var $temp$_v0 = _Utils_Tuple2(tail, offset + 1);
				_v0 = $temp$_v0;
				continue getOffset;
			} else {
				return offset;
			}
		} else {
			return offset;
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial = F2(
	function (num, shift) {
		var offset = $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getOffset(
			_Utils_Tuple2(num, 0));
		var numArray = $elm$core$Array$fromList(num);
		return A2(
			$elm$core$Array$initialize,
			($elm$core$List$length(num) - offset) + shift,
			function (index) {
				return A2(
					$elm$core$Maybe$withDefault,
					0,
					A2($elm$core$Array$get, index + offset, numArray));
			});
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$multiply = F2(
	function (poly1, poly2) {
		var valuesArray = A2(
			$elm$core$List$indexedMap,
			F2(
				function (index1, value1) {
					return A2(
						$elm$core$List$indexedMap,
						F2(
							function (index2, value2) {
								return _Utils_Tuple3(index1 + index2, value1, value2);
							}),
						$elm$core$Array$toList(poly2));
				}),
			$elm$core$Array$toList(poly1));
		var process__ = F3(
			function (indexSum, num_, exp) {
				return A2(
					$elm$core$Result$fromMaybe,
					$pablohirafuji$elm_qrcode$QRCode$Error$PolynomialMultiplyException,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Bitwise$xor(exp),
						A2($elm$core$Array$get, indexSum, num_)));
			});
		var process_ = F2(
			function (_v0, num_) {
				var indexSum = _v0.a;
				var value1 = _v0.b;
				var value2 = _v0.c;
				return A2(
					$elm$core$Result$map,
					function (r) {
						return A3($elm$core$Array$set, indexSum, r, num_);
					},
					A2(
						$elm$core$Result$andThen,
						A2(process__, indexSum, num_),
						A2(
							$elm$core$Result$map,
							$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp,
							A3(
								$elm$core$Result$map2,
								$elm$core$Basics$add,
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog(value1),
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog(value2)))));
			});
		var process = F2(
			function (args, numResult) {
				return A2(
					$elm$core$Result$andThen,
					process_(args),
					numResult);
			});
		var num = A2(
			$elm$core$Array$initialize,
			($elm$core$Array$length(poly1) + $elm$core$Array$length(poly2)) - 1,
			$elm$core$Basics$always(0));
		return A2(
			$elm$core$Result$map,
			function (a) {
				return A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial, a, 0);
			},
			A2(
				$elm$core$Result$map,
				$elm$core$Array$toList,
				A3(
					$elm$core$List$foldl,
					process,
					$elm$core$Result$Ok(num),
					$elm$core$List$concat(valuesArray))));
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getECPolynomial = function (ecLength) {
	var generate = F2(
		function (count, polyResult) {
			generate:
			while (true) {
				if (_Utils_cmp(count, ecLength) < 0) {
					var $temp$count = count + 1,
						$temp$polyResult = A2(
						$elm$core$Result$andThen,
						function (a) {
							return A2(
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$multiply,
								a,
								A2(
									$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial,
									_List_fromArray(
										[
											1,
											$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp(count)
										]),
									0));
						},
						polyResult);
					count = $temp$count;
					polyResult = $temp$polyResult;
					continue generate;
				} else {
					return polyResult;
				}
			}
		});
	return A2(
		generate,
		0,
		$elm$core$Result$Ok(
			A2(
				$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial,
				_List_fromArray(
					[1]),
				0)));
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get___ = F2(
	function (ecLength, modPoly) {
		return $elm$core$Array$toList(
			A2(
				$elm$core$Array$initialize,
				ecLength,
				function (index) {
					var modIndex = (index + $elm$core$Array$length(modPoly)) - ecLength;
					return (modIndex >= 0) ? A2(
						$elm$core$Maybe$withDefault,
						0,
						A2($elm$core$Array$get, modIndex, modPoly)) : 0;
				}));
	});
var $pablohirafuji$elm_qrcode$QRCode$Error$PolynomialModException = {$: 6};
var $elm$core$Array$foldl = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldl, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldl,
			func,
			A3($elm$core$Elm$JsArray$foldl, helper, baseCase, tree),
			tail);
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod = F2(
	function (poly1, poly2) {
		if (($elm$core$Array$length(poly1) - $elm$core$Array$length(poly2)) < 0) {
			return $elm$core$Result$Ok(poly1);
		} else {
			var helper_ = F3(
				function (index2, poly1_, exp) {
					return A2(
						$elm$core$Result$fromMaybe,
						$pablohirafuji$elm_qrcode$QRCode$Error$PolynomialModException,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Bitwise$xor(exp),
							A2($elm$core$Array$get, index2, poly1_)));
				});
			var getHead = function (poly) {
				return A2(
					$elm$core$Result$andThen,
					$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog,
					A2(
						$elm$core$Result$fromMaybe,
						$pablohirafuji$elm_qrcode$QRCode$Error$PolynomialModException,
						A2($elm$core$Array$get, 0, poly)));
			};
			var ratio = A3(
				$elm$core$Result$map2,
				$elm$core$Basics$sub,
				getHead(poly1),
				getHead(poly2));
			var helper = F2(
				function (_v0, poly1_) {
					var index2 = _v0.a;
					var value2 = _v0.b;
					return A2(
						$elm$core$Result$map,
						function (r) {
							return A3($elm$core$Array$set, index2, r, poly1_);
						},
						A2(
							$elm$core$Result$andThen,
							A2(helper_, index2, poly1_),
							A2(
								$elm$core$Result$map,
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp,
								A3(
									$elm$core$Result$map2,
									$elm$core$Basics$add,
									ratio,
									$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog(value2)))));
				});
			var numFold = F2(
				function (args, poly1Result) {
					return A2(
						$elm$core$Result$andThen,
						helper(args),
						poly1Result);
				});
			var numResult = A3(
				$elm$core$Array$foldl,
				numFold,
				$elm$core$Result$Ok(poly1),
				A2(
					$elm$core$Array$indexedMap,
					F2(
						function (a, b) {
							return _Utils_Tuple2(a, b);
						}),
					poly2));
			return A2(
				$elm$core$Result$andThen,
				function (a) {
					return A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod, a, poly2);
				},
				A2(
					$elm$core$Result$map,
					function (a) {
						return A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial, a, 0);
					},
					A2($elm$core$Result$map, $elm$core$Array$toList, numResult)));
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get__ = F2(
	function (rsPoly, dataCodewords) {
		return A2(
			$elm$core$Result$map,
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get___(
				$elm$core$Array$length(rsPoly) - 1),
			A2(
				$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod,
				A2(
					$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial,
					dataCodewords,
					$elm$core$Array$length(rsPoly) - 1),
				rsPoly));
	});
var $pablohirafuji$elm_qrcode$QRCode$Helpers$listResult = F3(
	function (fun, listb, lista) {
		if (lista.b) {
			var head = lista.a;
			var tail = lista.b;
			return A2(
				$elm$core$Result$andThen,
				function (a) {
					return A3($pablohirafuji$elm_qrcode$QRCode$Helpers$listResult, fun, a, tail);
				},
				A2(
					$elm$core$Result$map,
					function (r) {
						return A2($elm$core$List$cons, r, listb);
					},
					fun(head)));
		} else {
			return $elm$core$Result$Ok(
				$elm$core$List$reverse(listb));
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get_ = F2(
	function (byteBlocks, rsPoly) {
		return A3(
			$pablohirafuji$elm_qrcode$QRCode$Helpers$listResult,
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get__(rsPoly),
			_List_Nil,
			byteBlocks);
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get = F2(
	function (ecPerBlock, byteBlocks) {
		return A2(
			$elm$core$Result$andThen,
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get_(byteBlocks),
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getECPolynomial(ecPerBlock));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$getErrorCorrection = function (_v0) {
	var model = _v0.a;
	var dataBlocks = _v0.b;
	return A2(
		$elm$core$Result$map,
		function (c) {
			return _Utils_Tuple3(model, dataBlocks, c);
		},
		A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get, model.E9.Es, dataBlocks));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric = 1;
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte = 2;
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric = 0;
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$onlyAlphanumeric = A2(
	$elm$regex$Regex$fromStringWith,
	{De: false, GH: false},
	'^[0-9A-Z $%*+\\-.\\/:]+$');
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$isValid = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (r) {
				return A2($elm$regex$Regex$contains, r, input);
			},
			$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$onlyAlphanumeric));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$only8Bit = A2(
	$elm$regex$Regex$fromStringWith,
	{De: false, GH: false},
	'^[\\u0000-\\u00ff]+$');
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$isValid = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (r) {
				return A2($elm$regex$Regex$contains, r, input);
			},
			$pablohirafuji$elm_qrcode$QRCode$Encode$Byte$only8Bit));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$onlyNumber = A2(
	$elm$regex$Regex$fromStringWith,
	{De: false, GH: false},
	'^[0-9]+$');
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$isValid = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (r) {
				return A2($elm$regex$Regex$contains, r, input);
			},
			$pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$onlyNumber));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$selectMode = function (input) {
	return $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$isValid(input) ? 0 : ($pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$isValid(input) ? 1 : ($pablohirafuji$elm_qrcode$QRCode$Encode$Byte$isValid(input) ? 2 : 3));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$InputLengthOverflow = {$: 7};
var $pablohirafuji$elm_qrcode$QRCode$Encode$filterCapacity = F3(
	function (mode, dataLength, _v0) {
		var version = _v0.wV;
		var capacity = _v0.pc;
		return _Utils_cmp(
			A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength, mode, version) + dataLength,
			capacity) < 1;
	});
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity = function (_v0) {
	var blockCount = _v0.a;
	var bytePerBlock = _v0.b;
	return blockCount * bytePerBlock;
};
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$byteCapacity = F2(
	function (group1, maybeGroup2) {
		if (!maybeGroup2.$) {
			var block2 = maybeGroup2.a;
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity(group1) + $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity(block2);
		} else {
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity(group1);
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo = F4(
	function (version, ecPerBlock, group1, maybeGroup2) {
		return {
			pc: A2($pablohirafuji$elm_qrcode$QRCode$GroupInfo$byteCapacity, group1, maybeGroup2) * 8,
			Es: ecPerBlock,
			yX: group1,
			Gs: maybeGroup2,
			wV: version
		};
	});
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataH = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		17,
		_Utils_Tuple2(1, 9),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		28,
		_Utils_Tuple2(1, 16),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		22,
		_Utils_Tuple2(2, 13),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		16,
		_Utils_Tuple2(4, 9),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		22,
		_Utils_Tuple2(2, 11),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 12))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		28,
		_Utils_Tuple2(4, 15),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		26,
		_Utils_Tuple2(4, 13),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 14))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		26,
		_Utils_Tuple2(4, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		24,
		_Utils_Tuple2(4, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		28,
		_Utils_Tuple2(6, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		24,
		_Utils_Tuple2(3, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(8, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		28,
		_Utils_Tuple2(7, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		22,
		_Utils_Tuple2(12, 11),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 12))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		24,
		_Utils_Tuple2(11, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		24,
		_Utils_Tuple2(11, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		30,
		_Utils_Tuple2(3, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(2, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(17, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		28,
		_Utils_Tuple2(2, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(19, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		26,
		_Utils_Tuple2(9, 13),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(16, 14))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		28,
		_Utils_Tuple2(15, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		30,
		_Utils_Tuple2(19, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		24,
		_Utils_Tuple2(34, 13),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		30,
		_Utils_Tuple2(16, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		30,
		_Utils_Tuple2(30, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		30,
		_Utils_Tuple2(22, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		30,
		_Utils_Tuple2(33, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		30,
		_Utils_Tuple2(12, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(28, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		30,
		_Utils_Tuple2(11, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(31, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		30,
		_Utils_Tuple2(19, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(26, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		30,
		_Utils_Tuple2(23, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(25, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		30,
		_Utils_Tuple2(23, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(28, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		30,
		_Utils_Tuple2(19, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(35, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		30,
		_Utils_Tuple2(11, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(46, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		30,
		_Utils_Tuple2(59, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		30,
		_Utils_Tuple2(22, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(41, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		30,
		_Utils_Tuple2(2, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(64, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		30,
		_Utils_Tuple2(24, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(46, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		30,
		_Utils_Tuple2(42, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(32, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		30,
		_Utils_Tuple2(10, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(67, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		30,
		_Utils_Tuple2(20, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(61, 16)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataL = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		7,
		_Utils_Tuple2(1, 19),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		10,
		_Utils_Tuple2(1, 34),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		15,
		_Utils_Tuple2(1, 55),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		20,
		_Utils_Tuple2(1, 80),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		26,
		_Utils_Tuple2(1, 108),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		18,
		_Utils_Tuple2(2, 68),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		20,
		_Utils_Tuple2(2, 78),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		24,
		_Utils_Tuple2(2, 97),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		30,
		_Utils_Tuple2(2, 116),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		18,
		_Utils_Tuple2(2, 68),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 69))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		20,
		_Utils_Tuple2(4, 81),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		24,
		_Utils_Tuple2(2, 92),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 93))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		26,
		_Utils_Tuple2(4, 107),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		30,
		_Utils_Tuple2(3, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		22,
		_Utils_Tuple2(5, 87),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 88))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		24,
		_Utils_Tuple2(5, 98),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 99))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(1, 107),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 108))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		30,
		_Utils_Tuple2(5, 120),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 121))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		28,
		_Utils_Tuple2(3, 113),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 114))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		28,
		_Utils_Tuple2(3, 107),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 108))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		28,
		_Utils_Tuple2(4, 116),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 117))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		28,
		_Utils_Tuple2(2, 111),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 112))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		30,
		_Utils_Tuple2(4, 121),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 122))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		30,
		_Utils_Tuple2(6, 117),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 118))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		26,
		_Utils_Tuple2(8, 106),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 107))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		28,
		_Utils_Tuple2(10, 114),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 115))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		30,
		_Utils_Tuple2(8, 122),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 123))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		30,
		_Utils_Tuple2(3, 117),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 118))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		30,
		_Utils_Tuple2(7, 116),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 117))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		30,
		_Utils_Tuple2(5, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		30,
		_Utils_Tuple2(13, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(3, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		30,
		_Utils_Tuple2(17, 115),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		30,
		_Utils_Tuple2(17, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		30,
		_Utils_Tuple2(13, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		30,
		_Utils_Tuple2(12, 121),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 122))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		30,
		_Utils_Tuple2(6, 121),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 122))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		30,
		_Utils_Tuple2(17, 122),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 123))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		30,
		_Utils_Tuple2(4, 122),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(18, 123))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		30,
		_Utils_Tuple2(20, 117),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 118))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		30,
		_Utils_Tuple2(19, 118),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 119)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataM = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		10,
		_Utils_Tuple2(1, 16),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		16,
		_Utils_Tuple2(1, 28),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		26,
		_Utils_Tuple2(1, 44),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		18,
		_Utils_Tuple2(2, 32),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		24,
		_Utils_Tuple2(2, 43),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		16,
		_Utils_Tuple2(4, 27),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		18,
		_Utils_Tuple2(4, 31),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		22,
		_Utils_Tuple2(2, 38),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 39))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		22,
		_Utils_Tuple2(3, 36),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 37))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		26,
		_Utils_Tuple2(4, 43),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 44))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		30,
		_Utils_Tuple2(1, 50),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 51))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		22,
		_Utils_Tuple2(6, 36),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 37))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		22,
		_Utils_Tuple2(8, 37),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 38))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		24,
		_Utils_Tuple2(4, 40),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 41))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		24,
		_Utils_Tuple2(5, 41),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 42))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		28,
		_Utils_Tuple2(7, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(3, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(10, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		26,
		_Utils_Tuple2(9, 43),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 44))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		26,
		_Utils_Tuple2(3, 44),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(11, 45))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		26,
		_Utils_Tuple2(3, 41),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 42))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		26,
		_Utils_Tuple2(17, 42),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		28,
		_Utils_Tuple2(17, 46),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		28,
		_Utils_Tuple2(4, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		28,
		_Utils_Tuple2(6, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		28,
		_Utils_Tuple2(8, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		28,
		_Utils_Tuple2(19, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		28,
		_Utils_Tuple2(22, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(3, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		28,
		_Utils_Tuple2(3, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(23, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		28,
		_Utils_Tuple2(21, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		28,
		_Utils_Tuple2(19, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		28,
		_Utils_Tuple2(2, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(29, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		28,
		_Utils_Tuple2(10, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(23, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		28,
		_Utils_Tuple2(14, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(21, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		28,
		_Utils_Tuple2(14, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(23, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		28,
		_Utils_Tuple2(12, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(26, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		28,
		_Utils_Tuple2(6, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(34, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		28,
		_Utils_Tuple2(29, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		28,
		_Utils_Tuple2(13, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(32, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		28,
		_Utils_Tuple2(40, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		28,
		_Utils_Tuple2(18, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(31, 48)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataQ = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		13,
		_Utils_Tuple2(1, 13),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		22,
		_Utils_Tuple2(1, 22),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		18,
		_Utils_Tuple2(2, 17),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		26,
		_Utils_Tuple2(2, 24),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		18,
		_Utils_Tuple2(2, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		24,
		_Utils_Tuple2(4, 19),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		18,
		_Utils_Tuple2(2, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		22,
		_Utils_Tuple2(4, 18),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 19))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		20,
		_Utils_Tuple2(4, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		24,
		_Utils_Tuple2(6, 19),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 20))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		28,
		_Utils_Tuple2(4, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		26,
		_Utils_Tuple2(4, 20),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 21))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		24,
		_Utils_Tuple2(8, 20),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 21))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		20,
		_Utils_Tuple2(11, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		30,
		_Utils_Tuple2(5, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		24,
		_Utils_Tuple2(15, 19),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 20))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(1, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(15, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		28,
		_Utils_Tuple2(17, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		26,
		_Utils_Tuple2(17, 21),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 22))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		30,
		_Utils_Tuple2(15, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		28,
		_Utils_Tuple2(17, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		30,
		_Utils_Tuple2(7, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(16, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		30,
		_Utils_Tuple2(11, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		30,
		_Utils_Tuple2(11, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(16, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		30,
		_Utils_Tuple2(7, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(22, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		28,
		_Utils_Tuple2(28, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		30,
		_Utils_Tuple2(8, 23),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(26, 24))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		30,
		_Utils_Tuple2(4, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(31, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		30,
		_Utils_Tuple2(1, 23),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(37, 24))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		30,
		_Utils_Tuple2(15, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(25, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		30,
		_Utils_Tuple2(42, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		30,
		_Utils_Tuple2(10, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(35, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		30,
		_Utils_Tuple2(29, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(19, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		30,
		_Utils_Tuple2(44, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		30,
		_Utils_Tuple2(39, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		30,
		_Utils_Tuple2(46, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		30,
		_Utils_Tuple2(49, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		30,
		_Utils_Tuple2(48, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		30,
		_Utils_Tuple2(43, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(22, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		30,
		_Utils_Tuple2(34, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(34, 25)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$getGroupData = function (ecLevel) {
	switch (ecLevel) {
		case 0:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataL;
		case 1:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataM;
		case 2:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataQ;
		default:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataH;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$getVersion = F3(
	function (ecLevel, mode, dataLength) {
		return A2(
			$elm$core$Result$fromMaybe,
			$pablohirafuji$elm_qrcode$QRCode$Error$InputLengthOverflow,
			$elm$core$List$head(
				A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.pc;
					},
					A2(
						$elm$core$List$filter,
						A2($pablohirafuji$elm_qrcode$QRCode$Encode$filterCapacity, mode, dataLength),
						$pablohirafuji$elm_qrcode$QRCode$GroupInfo$getGroupData(ecLevel)))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$versionToModel = F5(
	function (inputStr, ecLevel, mode, partialBitsCount, groupInfo) {
		return {
			rH: partialBitsCount + A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength, mode, groupInfo.wV),
			yz: ecLevel,
			E9: groupInfo,
			s$: inputStr,
			qf: mode
		};
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$selectVersion = F4(
	function (inputStr, ecLevel, mode, encodedStr) {
		var partialBitsCount = 4 + A3(
			$elm$core$List$foldl,
			F2(
				function (a, b) {
					return a.b + b;
				}),
			0,
			encodedStr);
		return A2(
			$elm$core$Result$map,
			function (b) {
				return _Utils_Tuple2(encodedStr, b);
			},
			A2(
				$elm$core$Result$map,
				A4($pablohirafuji$elm_qrcode$QRCode$Encode$versionToModel, inputStr, ecLevel, mode, partialBitsCount),
				A3($pablohirafuji$elm_qrcode$QRCode$Encode$getVersion, ecLevel, mode, partialBitsCount)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$breakList = F3(
	function (checkFinish, _v0, _v1) {
		breakList:
		while (true) {
			var times = _v0.a;
			var itemCount = _v0.b;
			var byteList = _v1.a;
			var progress = _v1.b;
			if (times > 0) {
				var remainList = A2($elm$core$List$drop, itemCount, byteList);
				var block = A2($elm$core$List$take, itemCount, byteList);
				var $temp$checkFinish = checkFinish,
					$temp$_v0 = _Utils_Tuple2(times - 1, itemCount),
					$temp$_v1 = _Utils_Tuple2(
					remainList,
					A2($elm$core$List$cons, block, progress));
				checkFinish = $temp$checkFinish;
				_v0 = $temp$_v0;
				_v1 = $temp$_v1;
				continue breakList;
			} else {
				if (checkFinish && ($elm$core$List$length(byteList) > 0)) {
					return $elm$core$Result$Err($pablohirafuji$elm_qrcode$QRCode$Error$InputLengthOverflow);
				} else {
					return $elm$core$Result$Ok(
						_Utils_Tuple2(byteList, progress));
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$toBlocks = function (_v0) {
	var model = _v0.a;
	var groupInfo = model.E9;
	var byteList = _v0.b;
	var _v1 = groupInfo.Gs;
	if (!_v1.$) {
		var group2 = _v1.a;
		return A2(
			$elm$core$Result$map,
			function (b) {
				return _Utils_Tuple2(model, b);
			},
			A2(
				$elm$core$Result$map,
				A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$List$reverse),
				A2(
					$elm$core$Result$andThen,
					A2($pablohirafuji$elm_qrcode$QRCode$Encode$breakList, true, group2),
					A3(
						$pablohirafuji$elm_qrcode$QRCode$Encode$breakList,
						false,
						groupInfo.yX,
						_Utils_Tuple2(byteList, _List_Nil)))));
	} else {
		return A2(
			$elm$core$Result$map,
			function (b) {
				return _Utils_Tuple2(model, b);
			},
			A2(
				$elm$core$Result$map,
				A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$List$reverse),
				A3(
					$pablohirafuji$elm_qrcode$QRCode$Encode$breakList,
					true,
					groupInfo.yX,
					_Utils_Tuple2(byteList, _List_Nil))));
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$encode = F2(
	function (inputStr, ecLevel) {
		var mode = $pablohirafuji$elm_qrcode$QRCode$Encode$selectMode(inputStr);
		return A2(
			$elm$core$Result$map,
			$pablohirafuji$elm_qrcode$QRCode$Encode$concatTranspose,
			A2(
				$elm$core$Result$andThen,
				$pablohirafuji$elm_qrcode$QRCode$Encode$getErrorCorrection,
				A2(
					$elm$core$Result$andThen,
					$pablohirafuji$elm_qrcode$QRCode$Encode$toBlocks,
					A2(
						$elm$core$Result$map,
						$pablohirafuji$elm_qrcode$QRCode$Encode$addInfoAndFinalBits,
						A2(
							$elm$core$Result$andThen,
							A3($pablohirafuji$elm_qrcode$QRCode$Encode$selectVersion, inputStr, ecLevel, mode),
							A2($pablohirafuji$elm_qrcode$QRCode$Encode$encoder, mode, inputStr))))));
	});
var $pablohirafuji$elm_qrcode$QRCode$fromStringWith = F2(
	function (ecLevel, input) {
		return A2(
			$elm$core$Result$mapError,
			$pablohirafuji$elm_qrcode$QRCode$convertError,
			A2(
				$elm$core$Result$andThen,
				function (_v0) {
					var encodeModel = _v0.a;
					var encodedData = _v0.b;
					return A2(
						$elm$core$Result$map,
						function (matrix) {
							return {mW: matrix, wV: encodeModel.E9.wV};
						},
						$pablohirafuji$elm_qrcode$QRCode$Matrix$apply(
							_Utils_Tuple2(encodeModel, encodedData)));
				},
				A2(
					$pablohirafuji$elm_qrcode$QRCode$Encode$encode,
					input,
					$pablohirafuji$elm_qrcode$QRCode$convertEC(ecLevel))));
	});
var $pablohirafuji$elm_qrcode$QRCode$fromString = $pablohirafuji$elm_qrcode$QRCode$fromStringWith(2);
var $author$project$Login$MfaSetup$mfaEntryDisabled = function (accountData) {
	switch (accountData.$) {
		case 1:
			return true;
		case 0:
			return false;
		case 3:
			if (!accountData.a.$) {
				var _v1 = accountData.a;
				return true;
			} else {
				return false;
			}
		default:
			return false;
	}
};
var $elm_community$maybe_extra$Maybe$Extra$orElseLazy = F2(
	function (fma, mb) {
		if (mb.$ === 1) {
			return fma(0);
		} else {
			return mb;
		}
	});
var $author$project$Login$MfaSetup$mfaEntryStatusLine = F2(
	function (accountData, mfaInput) {
		var statusLine = F2(
			function (attrs, content) {
				return A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('tw-mt-2 ff-b tw-text-sm'),
						attrs),
					content);
			});
		var statusLineJust = F2(
			function (attrs, content) {
				return $elm$core$Maybe$Just(
					A2(statusLine, attrs, content));
			});
		var maybeValidationErrorMessage = $author$project$Model$ValidationNext$message(mfaInput);
		var justIf = F2(
			function (bool, a) {
				return bool ? $elm$core$Maybe$Just(a) : $elm$core$Maybe$Nothing;
			});
		var currentMfaInputStringIsEmpty = $elm$core$String$isEmpty(
			$author$project$Data$MfaCode$toString(
				$author$project$Model$ValidationNext$extract(mfaInput)));
		return A2(
			$elm$core$Maybe$withDefault,
			A2(
				statusLine,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('tw-whitespace-pre')
					]),
				_List_fromArray(
					[$author$project$Translate$Html$space])),
			A2(
				$elm_community$maybe_extra$Maybe$Extra$orElseLazy,
				function (_v0) {
					switch (accountData.$) {
						case 1:
							return A2(
								statusLineJust,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$View$Svg$refresh('is-loading'),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('tw-ml-1')
											]),
										_List_fromArray(
											[
												$author$project$Translate$Html$text(
												$author$project$Translate$gettext('Verifying Code…'))
											]))
									]));
						case 0:
							return $elm$core$Maybe$Nothing;
						case 3:
							if (!accountData.a.$) {
								var _v2 = accountData.a;
								return A2(
									statusLineJust,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$View$Svg$refresh('is-loading'),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('tw-ml-1')
												]),
											_List_fromArray(
												[
													$author$project$Translate$Html$text(
													$author$project$Translate$gettext('Signed in'))
												]))
										]));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						default:
							if ((accountData.a.$ === 3) && (accountData.a.a === 400)) {
								return A2(
									justIf,
									currentMfaInputStringIsEmpty,
									A2(
										statusLine,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('tw-text-danger-600')
											]),
										_List_fromArray(
											[
												$author$project$Translate$Html$text(
												$author$project$Translate$gettext('Verification failed. Please check the 6-digit code and try again.'))
											])));
							} else {
								return A2(
									justIf,
									currentMfaInputStringIsEmpty,
									A2(
										statusLine,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('tw-text-danger-600')
											]),
										_List_fromArray(
											[
												$author$project$Translate$Html$text(
												$author$project$Translate$gettext('Something went wrong, please try again.'))
											])));
							}
					}
				},
				A2(
					$elm$core$Maybe$map,
					function (message) {
						return A2(
							statusLine,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tw-text-danger-600')
								]),
							_List_fromArray(
								[
									$author$project$Translate$Html$text(
									$author$project$Translate$rawTemp(message))
								]));
					},
					maybeValidationErrorMessage)));
	});
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$Translate$Html$Attributes$title = A2($elm$core$Basics$composeR, $author$project$Translate$extract, $elm$html$Html$Attributes$title);
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize = 5;
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$appendLastRect = function (_v0) {
	var lastRect = _v0.a;
	var rowLines = _v0.b;
	return A2(
		$elm$core$List$cons,
		'h' + $elm$core$String$fromInt(lastRect.Cr * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize),
		rowLines);
};
var $elm$svg$Svg$Attributes$shapeRendering = _VirtualDom_attribute('shape-rendering');
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $elm$svg$Svg$Attributes$style = _VirtualDom_attribute('style');
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$toRowLines = F2(
	function (isDark, _v0) {
		var lastRect = _v0.a;
		var rowLines = _v0.b;
		return isDark ? ((!lastRect.es) ? _Utils_Tuple2(
			_Utils_update(
				lastRect,
				{Cr: lastRect.Cr + 1}),
			rowLines) : _Utils_Tuple2(
			{es: 0, Cr: 1},
			A2(
				$elm$core$List$cons,
				$elm$core$String$concat(
					_List_fromArray(
						[
							(lastRect.Cr > 0) ? ('h' + $elm$core$String$fromInt(lastRect.Cr * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize)) : '',
							'm',
							$elm$core$String$fromInt(lastRect.es * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize),
							' 0'
						])),
				rowLines))) : _Utils_Tuple2(
			_Utils_update(
				lastRect,
				{es: lastRect.es + 1}),
			rowLines);
	});
var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewRow = F3(
	function (quietZoneSize, rowIndex, rowLines) {
		return A2(
			$elm$core$List$cons,
			'M0 ',
			A2(
				$elm$core$List$cons,
				$elm$core$String$fromInt(rowIndex * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize),
				rowLines));
	});
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewBase = F3(
	function (quietZoneSize, extraAttrs, matrix) {
		var quietZonePx = quietZoneSize * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize;
		var sizePx = $elm$core$String$fromInt(
			($elm$core$List$length(matrix) * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize) + (2 * quietZonePx));
		return A2(
			$elm$svg$Svg$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$viewBox('0 0 ' + (sizePx + (' ' + sizePx))),
						$elm$svg$Svg$Attributes$shapeRendering('crispEdges'),
						$elm$svg$Svg$Attributes$stroke('#000'),
						$elm$svg$Svg$Attributes$strokeWidth(
						$elm$core$String$fromInt($pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize) + 'px')
					]),
				extraAttrs),
			function (d) {
				return _List_fromArray(
					[
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								d,
								$elm$svg$Svg$Attributes$transform(
								'translate(' + ($elm$core$String$fromInt(quietZonePx) + (', ' + ($elm$core$String$fromFloat(quietZonePx + ($pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize / 2)) + ')')))),
								$elm$svg$Svg$Attributes$style('stroke-width: 5px')
							]),
						_List_Nil)
					]);
			}(
				$elm$svg$Svg$Attributes$d(
					$elm$core$String$concat(
						$elm$core$List$concat(
							A2(
								$elm$core$List$indexedMap,
								$pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewRow(quietZoneSize),
								A2(
									$elm$core$List$map,
									A2(
										$elm$core$Basics$composeR,
										A2(
											$elm$core$List$foldl,
											$pablohirafuji$elm_qrcode$QRCode$Render$Svg$toRowLines,
											_Utils_Tuple2(
												{es: 0, Cr: 0},
												_List_Nil)),
										A2($elm$core$Basics$composeR, $pablohirafuji$elm_qrcode$QRCode$Render$Svg$appendLastRect, $elm$core$List$reverse)),
									matrix)))))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$view = $pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewBase(4);
var $pablohirafuji$elm_qrcode$QRCode$toSvg = F2(
	function (extraAttrs, _v0) {
		var matrix = _v0.mW;
		return A2($pablohirafuji$elm_qrcode$QRCode$Render$Svg$view, extraAttrs, matrix);
	});
var $author$project$Login$MfaSetup$viewScanQRCodeStep = F5(
	function (config, accountData, qrCode, mfaInput, copiedToClipboard) {
		var title = A2(
			$elm$html$Html$h1,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mfa-setup__header')
				]),
			_List_fromArray(
				[
					$author$project$Translate$Html$text(
					$author$project$Translate$gettext('Scan the QR code to verify.'))
				]));
		var formDisabled = $author$project$Login$MfaSetup$mfaEntryDisabled(accountData);
		var entryInstructions = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mfa-setup__scan-qr-code-entry-instructions')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Translate$Html$text(
							$author$project$Translate$gettext('Once you scan the QR code, it will reveal a 6-digit code.')),
							$author$project$Translate$Html$space
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tw-font-semibold')
						]),
					_List_fromArray(
						[
							$author$project$Translate$Html$text(
							$author$project$Translate$gettext('Enter the digits in the space below.'))
						]))
				]));
		var copyButtonText = copiedToClipboard ? $author$project$Translate$Html$text(
			$author$project$Translate$gettext('Copied!')) : $author$project$Translate$Html$text(
			$author$project$Translate$gettext('Copy URL'));
		var _v0 = qrCode;
		var uri = _v0.a;
		var qr = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tw-bg-white tw-m-auto'),
					$elm$html$Html$Attributes$class('tw-w-48 tw-min-w-[2in]')
				]),
			_List_fromArray(
				[
					A2(
					$elm$core$Result$withDefault,
					$author$project$Translate$Html$text(
						$author$project$Translate$gettext('Error while encoding to QRCode.')),
					A2(
						$elm$core$Result$map,
						$pablohirafuji$elm_qrcode$QRCode$toSvg(_List_Nil),
						$pablohirafuji$elm_qrcode$QRCode$fromString(uri)))
				]));
		var _v1 = config;
		var copyToClipboardOnClick = _v1.x_;
		var mfaCodeInputUpdated = _v1.zQ;
		var signInOnClick = _v1.BE;
		var copyUrlButton = A3(
			$author$project$CorvusDesignSystem$Button$button,
			_List_fromArray(
				[
					$author$project$CorvusDesignSystem$Button$buttonModifier(
					$author$project$CorvusDesignSystem$Button$Size(2)),
					$author$project$CorvusDesignSystem$Button$buttonModifier(
					$author$project$CorvusDesignSystem$Button$Fill(2))
				]),
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					copyToClipboardOnClick(uri))
				]),
			_List_fromArray(
				[copyButtonText]));
		var urlBox = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mfa-setup__scan-qr-code-url-box')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Translate$Html$text(
							$author$project$Translate$gettext('If you have trouble scanning the QR code, you can also enter the URL below into the authenticator app.'))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('uri-and-button')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('code-uri'),
									$elm$html$Html$Attributes$class('code-uri'),
									$author$project$Translate$Html$Attributes$title(
									$author$project$Translate$doNotTranslate(uri))
								]),
							_List_fromArray(
								[
									$author$project$Translate$Html$text(
									$author$project$Translate$doNotTranslate(uri))
								])),
							copyUrlButton
						]))
				]));
		var entryForm = A2(
			$elm$html$Html$form,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('branded__form'),
						$elm$html$Html$Attributes$novalidate(true)
					]),
				formDisabled ? _List_Nil : _List_fromArray(
					[
						$elm$html$Html$Events$onSubmit(signInOnClick)
					])),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('branded__form-group')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for('mfaInput'),
									$elm$html$Html$Attributes$class('branded__label')
								]),
							_List_fromArray(
								[
									$author$project$Translate$Html$text(
									$author$project$Translate$gettext('6-Digit Code'))
								])),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('mfaInput'),
									$elm$html$Html$Attributes$type_('number'),
									$elm$html$Html$Attributes$disabled(formDisabled),
									$elm$html$Html$Attributes$class('branded__input branded__input--code'),
									$elm$html$Html$Attributes$autocomplete(false),
									$elm$html$Html$Attributes$min('0'),
									$elm$html$Html$Attributes$max('999999'),
									$elm$html$Html$Attributes$name('one-time-code'),
									$elm$html$Html$Attributes$required(true),
									$elm$html$Html$Attributes$value(
									A2($author$project$Model$ValidationNext$toString, $author$project$Data$MfaCode$toString, mfaInput)),
									$elm$html$Html$Events$onInput(mfaCodeInputUpdated)
								]),
							_List_Nil),
							A2($author$project$Login$MfaSetup$mfaEntryStatusLine, accountData, mfaInput)
						]))
				]));
		var stepContent = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tw-mb-1')
				]),
			_List_fromArray(
				[title, qr, urlBox, entryInstructions, entryForm]));
		return A3($author$project$Login$MfaSetup$viewMfaStep, config, 3, stepContent);
	});
var $author$project$Login$MfaSetup$view = F4(
	function (config, accountData, qrCode, step) {
		switch (step.$) {
			case 0:
				return $author$project$Login$MfaSetup$viewRequiredMfaSetupStep(config);
			case 1:
				var modalState = step.a;
				return A2($author$project$Login$MfaSetup$viewDownloadAppStep, config, modalState);
			case 2:
				var modalState = step.a;
				return A2($author$project$Login$MfaSetup$viewLocateQRCodeStep, config, modalState);
			default:
				var mfaInput = step.a;
				var copiedToClipboard = step.b;
				return A5($author$project$Login$MfaSetup$viewScanQRCodeStep, config, accountData, qrCode, mfaInput, copiedToClipboard);
		}
	});
var $author$project$Login$SigninV2$Model$MfaLoginNeedHelpClicked = {$: 8};
var $author$project$Login$SigninV2$View$mfaHelpLink = function () {
	var mfaHelpEmail = A3(
		$author$project$View$Util$mailToHrefTranslate,
		$author$project$View$CustomerSuccess$emailAddress,
		$author$project$Translate$gettext('Need help signing in with MFA'),
		$elm$core$Maybe$Nothing);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mfa-setup__footer-button branded__link')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$Login$SigninV2$Model$MfaLoginNeedHelpClicked),
						$elm$html$Html$Attributes$href(mfaHelpEmail),
						$elm$html$Html$Attributes$target('_blank'),
						$elm$html$Html$Attributes$rel('noopener')
					]),
				_List_fromArray(
					[
						$author$project$Translate$Html$text(
						$author$project$Translate$gettext('I Need Help'))
					]))
			]));
}();
var $author$project$Login$SigninV2$View$viewMfaCode = F2(
	function (accountData, mfaInput) {
		return A2(
			$elm$html$Html$form,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('branded__form'),
					$elm$html$Html$Attributes$novalidate(true),
					$elm$html$Html$Events$onSubmit($author$project$Login$SigninV2$Model$DoSignin)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('branded__form-group')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for('mfaInput'),
									$elm$html$Html$Attributes$class('branded__label')
								]),
							_List_fromArray(
								[
									$author$project$Translate$Html$text(
									$author$project$Translate$gettext('6-Digit Code'))
								])),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('mfaInput'),
									$elm$html$Html$Attributes$type_('number'),
									$elm$html$Html$Attributes$class('branded__input branded__input--code'),
									$elm$html$Html$Attributes$min('0'),
									$elm$html$Html$Attributes$max('999999'),
									$elm$html$Html$Attributes$name('one-time-code'),
									$author$project$Translate$Html$Attributes$autocomplete('one-time-code'),
									$elm$html$Html$Attributes$required(true),
									$elm$html$Html$Attributes$value(
									A2($author$project$Model$ValidationNext$toString, $author$project$Data$MfaCode$toString, mfaInput)),
									$elm$html$Html$Events$onInput($author$project$Login$SigninV2$Model$MfaCodeUpdated)
								]),
							_List_Nil),
							A2(
							$author$project$View$Util$maybeAlert,
							_List_Nil,
							$author$project$Model$ValidationNext$message(mfaInput))
						])),
					function () {
					switch (accountData.$) {
						case 1:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('branded__form-group')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$View$Button$loading,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button branded__button-login')
											]),
										_List_fromArray(
											[
												$author$project$Translate$Html$text(
												$author$project$Translate$gettext('Verifying Code…'))
											]))
									]));
						case 0:
							return $author$project$Translate$Html$blankElement;
						case 3:
							if (!accountData.a.$) {
								var _v1 = accountData.a;
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('branded__form-group')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$disabled(true),
													$elm$html$Html$Attributes$class('button branded__button -success')
												]),
											_List_fromArray(
												[
													$author$project$Translate$Html$text(
													$author$project$Translate$gettext('Signed in'))
												]))
										]));
							} else {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('branded__form-group')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('button branded__button-login')
												]),
											_List_fromArray(
												[
													$author$project$Translate$Html$text(
													$author$project$Translate$gettext('Verify Code'))
												]))
										]));
							}
						default:
							if ((accountData.a.$ === 3) && (accountData.a.a === 400)) {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('branded__form-group')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('button branded__button -warning')
												]),
											_List_fromArray(
												[
													$author$project$Translate$Html$text(
													$author$project$Translate$gettext('Verify Code'))
												])),
											A2(
											$author$project$View$Util$alertTranslate,
											_List_Nil,
											$author$project$Translate$gettext('Invalid multi-factor authentication (MFA) token.'))
										]));
							} else {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('branded__form-group')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('button branded__button -warning')
												]),
											_List_fromArray(
												[
													$author$project$Translate$Html$text(
													$author$project$Translate$gettext('Verify Code'))
												])),
											A2(
											$author$project$View$Util$alertTranslate,
											_List_Nil,
											$author$project$Translate$gettext('Something went wrong, please try again.'))
										]));
							}
					}
				}()
				]));
	});
var $author$project$Login$SigninV2$View$viewMfaInput = F3(
	function (accountData, mfaInput, isTravelersRequestUrl) {
		var inputDesc = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tw-text-center tw-tracking-[0.07px]')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('tw-mb-1', !isTravelersRequestUrl),
									_Utils_Tuple2('input-description', isTravelersRequestUrl)
								]))
						]),
					_List_fromArray(
						[
							$author$project$Translate$Html$text(
							$author$project$Translate$gettext('Enter the 6-digit code generated by your Multi-Factor Authentication (MFA) app.'))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('input-description', isTravelersRequestUrl)
								]))
						]),
					_List_fromArray(
						[
							$author$project$Translate$Html$text(
							$author$project$Translate$gettext('You may have used Google Authenticator, Microsoft Authenticator, or a similar app on your phone to set up MFA.'))
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mfa-setup__card')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('tw-flex tw-flex-col tw-pb-4 tw-gap-4 tw-leading-[1.7]', !isTravelersRequestUrl),
									_Utils_Tuple2('header-description', isTravelersRequestUrl)
								]))
						]),
					_List_fromArray(
						[
							$author$project$Login$SigninV2$View$signinHeader(isTravelersRequestUrl),
							inputDesc
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tw-text-gray-800')
						]),
					_List_fromArray(
						[
							A2($author$project$Login$SigninV2$View$viewMfaCode, accountData, mfaInput)
						])),
					A2(
					$author$project$View$Util$displayIf,
					!isTravelersRequestUrl,
					function (_v0) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('branded__links')
								]),
							_List_fromArray(
								[$author$project$Login$SigninV2$View$whoIsCorvusLink, $author$project$Login$SigninV2$View$mfaHelpLink]));
					})
				]));
	});
var $author$project$Login$SigninV2$View$view = F2(
	function (_v0, flashMessage) {
		var details = _v0.a;
		var flow = _v0.b;
		switch (flow.$) {
			case 0:
				var mfaCode = flow.a;
				return A3($author$project$Login$SigninV2$View$viewMfaInput, details.BH, mfaCode, details.zm);
			case 1:
				var qrCode = flow.b;
				var mfaSetupStep = flow.c;
				var config = {rS: $author$project$Login$SigninV2$Model$CloseMfaModal, x_: $author$project$Login$SigninV2$Model$CopyToClipboard, zQ: $author$project$Login$SigninV2$Model$MfaCodeUpdated, zW: $author$project$Login$SigninV2$Model$MfaSetupNeedHelpClicked, qm: $author$project$Login$SigninV2$Model$GoToNextMfaSetupStep, vA: $author$project$Login$SigninV2$Model$OpenMfaModal, Ay: $author$project$Login$SigninV2$Model$GoToPreviousMfaSetupStep, jv: details.zm, BE: $author$project$Login$SigninV2$Model$DoSignin};
				return A4($author$project$Login$MfaSetup$view, config, details.BH, qrCode, mfaSetupStep);
			case 2:
				var tokenSigninData = flow.a.B5;
				return $krisajenkins$remotedata$RemoteData$isLoading(tokenSigninData) ? $author$project$Login$SigninV2$View$signinRequestLoading : A3($author$project$Login$SigninV2$View$signinView, details, flashMessage, details.zm);
			default:
				var resetPasswordData = flow.a;
				return A2($author$project$Login$SigninV2$View$resetPasswordView, resetPasswordData, details);
		}
	});
var $author$project$Login$SurplusLinesLicense$Model$AttestationCheckboxClicked = function (a) {
	return {$: 0, a: a};
};
var $author$project$Login$SurplusLinesLicense$Model$AttestorNameInputted = function (a) {
	return {$: 1, a: a};
};
var $author$project$Login$SurplusLinesLicense$Model$FormInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Login$SurplusLinesLicense$Model$FormValidation = function (a) {
	return {$: 1, a: a};
};
var $author$project$CorvusDesignSystem$Button$Large = 1;
var $author$project$Login$SurplusLinesLicense$Model$SubmitClicked = {$: 3};
var $author$project$Login$SurplusLinesLicense$View$attestationText = 'By completing, you attest that the above information is accurate and complete. You accept the responsibility of filing the policy with the state as well as collecting tax(es) and/or fee(s) from the insured, and will remit to the filing state along with any and all required affidavits or forms. Additionally, you will be responsible for providing to the insured and/or attaching to the policy, any state required forms or documents, and will apply any and all appropriate state wordings.';
var $author$project$Login$SurplusLinesLicense$View$certificateDisclaimer = 'Please fill in the Surplus Lines (SL) Certificate requested below and submit to Corvus Insurance. Please verify or correct the information, as the broker assumes responsibility of all information provided here to be accurate.';
var $author$project$Login$SurplusLinesLicense$View$displayWhen = F2(
	function (isInvalid, helpMessage) {
		return A2(
			$author$project$View$Util$displayIf,
			isInvalid,
			function (_v0) {
				return A2(
					$author$project$View$Util$alert,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('m-t3')
						]),
					helpMessage);
			});
	});
var $author$project$Login$SurplusLinesLicense$Model$AddressCityInputted = function (a) {
	return {$: 2, a: a};
};
var $author$project$Login$SurplusLinesLicense$Model$AddressLineOneInputted = function (a) {
	return {$: 3, a: a};
};
var $author$project$Login$SurplusLinesLicense$Model$AddressLineTwoInputted = function (a) {
	return {$: 4, a: a};
};
var $author$project$Login$SurplusLinesLicense$Model$AddressPostalCodeInputted = function (a) {
	return {$: 5, a: a};
};
var $author$project$Login$SurplusLinesLicense$Model$AddressStateSelected = function (a) {
	return {$: 6, a: a};
};
var $author$project$Login$SurplusLinesLicense$Model$EmailInputted = function (a) {
	return {$: 7, a: a};
};
var $author$project$Login$SurplusLinesLicense$Model$LicenseNumberInputted = function (a) {
	return {$: 9, a: a};
};
var $author$project$Login$SurplusLinesLicense$Model$NameInputted = function (a) {
	return {$: 10, a: a};
};
var $author$project$Login$SurplusLinesLicense$Model$PhoneInputted = function (a) {
	return {$: 11, a: a};
};
var $elm_community$string_extra$String$Extra$replaceSlice = F4(
	function (substitution, start, end, string) {
		return _Utils_ap(
			A3($elm$core$String$slice, 0, start, string),
			_Utils_ap(
				substitution,
				A3(
					$elm$core$String$slice,
					end,
					$elm$core$String$length(string),
					string)));
	});
var $elm_community$string_extra$String$Extra$insertAt = F3(
	function (insert, pos, string) {
		return A4($elm_community$string_extra$String$Extra$replaceSlice, insert, pos, pos, string);
	});
var $author$project$View$Util$formatPhoneNumber = function (phoneNumber) {
	var cleanPhoneNumber = $author$project$View$Util$removePhoneNumberFormatting(phoneNumber);
	var formattedAreaCodeOpen = A3($elm_community$string_extra$String$Extra$insertAt, '(', 0, cleanPhoneNumber);
	var formattedAreaCodeClosed = A3(
		$elm_community$string_extra$String$Extra$insertAt,
		' ',
		5,
		A3($elm_community$string_extra$String$Extra$insertAt, ')', 4, formattedAreaCodeOpen));
	var formattedPhoneNumber = A3($elm_community$string_extra$String$Extra$insertAt, '-', 9, formattedAreaCodeClosed);
	return (!$elm$core$String$length(cleanPhoneNumber)) ? '' : ((($elm$core$String$length(cleanPhoneNumber) > 0) && ($elm$core$String$length(cleanPhoneNumber) <= 3)) ? formattedAreaCodeOpen : ((($elm$core$String$length(cleanPhoneNumber) > 3) && ($elm$core$String$length(cleanPhoneNumber) <= 6)) ? formattedAreaCodeClosed : ((($elm$core$String$length(cleanPhoneNumber) > 6) && ($elm$core$String$length(cleanPhoneNumber) <= 10)) ? formattedPhoneNumber : (($elm$core$String$length(cleanPhoneNumber) > 10) ? ('+' + cleanPhoneNumber) : phoneNumber))));
};
var $author$project$Login$SurplusLinesLicense$View$displayPhoneNumber = function (phoneNumber) {
	return $author$project$View$Util$formatPhoneNumber(
		$author$project$Data$PhoneNumber$validationResultToString(phoneNumber));
};
var $author$project$Login$SurplusLinesLicense$Model$ToExpirationDatePicker = function (a) {
	return {$: 12, a: a};
};
var $author$project$CorvusDatePicker$formatDateInput = function (dateInput) {
	var _v0 = A2($elm$core$String$split, '/', dateInput);
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
		var month = _v0.a;
		var _v1 = _v0.b;
		var day = _v1.a;
		var _v2 = _v1.b;
		var year = _v2.a;
		return A2(
			$elm$core$String$join,
			'-',
			_List_fromArray(
				[year, month, day]));
	} else {
		return dateInput;
	}
};
var $author$project$CorvusDatePicker$datePickerSettings = _Utils_update(
	$CurrySoftware$elm_datepicker$DatePicker$defaultSettings,
	{
		D9: $justinmimbs$date$Date$format($author$project$View$Util$getDateFormat),
		Ht: A2($elm$core$Basics$composeR, $author$project$CorvusDatePicker$formatDateInput, $justinmimbs$date$Date$fromIsoString)
	});
var $author$project$CorvusDatePicker$datePickerWarningMessageView = function (inputError) {
	switch (inputError.$) {
		case 0:
			return A2($author$project$View$Util$alert, _List_Nil, 'Invalid Date');
		case 2:
			return $elm$html$Html$text('');
		default:
			return $elm$html$Html$text('');
	}
};
var $CurrySoftware$elm_datepicker$DatePicker$isOpen = function (_v0) {
	var model = _v0;
	return model.dD;
};
var $CurrySoftware$elm_datepicker$DatePicker$Blur = {$: 6};
var $CurrySoftware$elm_datepicker$DatePicker$Focus = {$: 5};
var $CurrySoftware$elm_datepicker$DatePicker$SubmitText = {$: 4};
var $CurrySoftware$elm_datepicker$DatePicker$Text = function (a) {
	return {$: 3, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$ChangeFocus = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$date$Date$Months = 1;
var $CurrySoftware$elm_datepicker$DatePicker$MouseDown = {$: 7};
var $CurrySoftware$elm_datepicker$DatePicker$MouseUp = {$: 8};
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0;
		switch (unit) {
			case 0:
				return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
			case 1:
				var date = $justinmimbs$date$Date$toCalendarDate(rd);
				var wholeMonths = ((12 * (date.Cu - 1)) + ($justinmimbs$date$Date$monthToNumber(date.zT) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
					$elm$core$Basics$min,
					date.yi,
					A2($justinmimbs$date$Date$daysInMonth, y, m));
			case 2:
				return rd + (7 * n);
			default:
				return rd + n;
		}
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $CurrySoftware$elm_datepicker$DatePicker$Date$changeYear = F2(
	function (current, newYear) {
		var _v0 = $elm$core$String$toInt(newYear);
		if (!_v0.$) {
			var year = _v0.a;
			return A3(
				$justinmimbs$date$Date$fromCalendarDate,
				year,
				$justinmimbs$date$Date$month(current),
				$justinmimbs$date$Date$day(current));
		} else {
			return current;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$groupDates = function (dates) {
	var go = F4(
		function (i, xs, racc, acc) {
			go:
			while (true) {
				if (!xs.b) {
					return $elm$core$List$reverse(acc);
				} else {
					var x = xs.a;
					var xxs = xs.b;
					if (i === 6) {
						var $temp$i = 0,
							$temp$xs = xxs,
							$temp$racc = _List_Nil,
							$temp$acc = A2(
							$elm$core$List$cons,
							$elm$core$List$reverse(
								A2($elm$core$List$cons, x, racc)),
							acc);
						i = $temp$i;
						xs = $temp$xs;
						racc = $temp$racc;
						acc = $temp$acc;
						continue go;
					} else {
						var $temp$i = i + 1,
							$temp$xs = xxs,
							$temp$racc = A2($elm$core$List$cons, x, racc),
							$temp$acc = acc;
						i = $temp$i;
						xs = $temp$xs;
						racc = $temp$racc;
						acc = $temp$acc;
						continue go;
					}
				}
			}
		});
	return A4(go, 0, dates, _List_Nil, _List_Nil);
};
var $CurrySoftware$elm_datepicker$DatePicker$maybeOr = F2(
	function (lhs, rhs) {
		if (!rhs.$) {
			return rhs;
		} else {
			return lhs;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$mkClass = F2(
	function (_v0, c) {
		var classNamespace = _v0.fm;
		return $elm$html$Html$Attributes$class(
			_Utils_ap(classNamespace, c));
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $justinmimbs$date$Date$Day = 11;
var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
	switch (wd) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$date$Date$daysSincePreviousWeekday = F2(
	function (wd, date) {
		return A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$date$Date$weekdayNumber(date) + 7) - $justinmimbs$date$Date$weekdayToNumber(wd));
	});
var $justinmimbs$date$Date$firstOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + 1;
	});
var $justinmimbs$date$Date$quarterToMonth = function (q) {
	return $justinmimbs$date$Date$numberToMonth((q * 3) - 2);
};
var $justinmimbs$date$Date$floor = F2(
	function (interval, date) {
		var rd = date;
		switch (interval) {
			case 0:
				return $justinmimbs$date$Date$firstOfYear(
					$justinmimbs$date$Date$year(date));
			case 1:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$quarterToMonth(
						$justinmimbs$date$Date$quarter(date)));
			case 2:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$month(date));
			case 3:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 4:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 5:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 1, date);
			case 6:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 2, date);
			case 7:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 3, date);
			case 8:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 4, date);
			case 9:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 5, date);
			case 10:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 6, date);
			default:
				return date;
		}
	});
var $justinmimbs$date$Date$Days = 3;
var $justinmimbs$date$Date$Weeks = 2;
var $justinmimbs$date$Date$Years = 0;
var $justinmimbs$date$Date$intervalToUnits = function (interval) {
	switch (interval) {
		case 0:
			return _Utils_Tuple2(1, 0);
		case 1:
			return _Utils_Tuple2(3, 1);
		case 2:
			return _Utils_Tuple2(1, 1);
		case 11:
			return _Utils_Tuple2(1, 3);
		default:
			var week = interval;
			return _Utils_Tuple2(1, 2);
	}
};
var $justinmimbs$date$Date$ceiling = F2(
	function (interval, date) {
		var floored = A2($justinmimbs$date$Date$floor, interval, date);
		if (_Utils_eq(date, floored)) {
			return date;
		} else {
			var _v0 = $justinmimbs$date$Date$intervalToUnits(interval);
			var n = _v0.a;
			var unit = _v0.b;
			return A3($justinmimbs$date$Date$add, unit, n, floored);
		}
	});
var $justinmimbs$date$Date$rangeHelp = F5(
	function (unit, step, until, revList, current) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(current, until) < 0) {
				var _v0 = A3($justinmimbs$date$Date$add, unit, step, current);
				var next = _v0;
				var $temp$unit = unit,
					$temp$step = step,
					$temp$until = until,
					$temp$revList = A2($elm$core$List$cons, current, revList),
					$temp$current = next;
				unit = $temp$unit;
				step = $temp$step;
				until = $temp$until;
				revList = $temp$revList;
				current = $temp$current;
				continue rangeHelp;
			} else {
				return $elm$core$List$reverse(revList);
			}
		}
	});
var $justinmimbs$date$Date$range = F4(
	function (interval, step, _v0, _v1) {
		var start = _v0;
		var until = _v1;
		var _v2 = $justinmimbs$date$Date$intervalToUnits(interval);
		var n = _v2.a;
		var unit = _v2.b;
		var _v3 = A2($justinmimbs$date$Date$ceiling, interval, start);
		var first = _v3;
		return (_Utils_cmp(first, until) < 0) ? A5(
			$justinmimbs$date$Date$rangeHelp,
			unit,
			A2($elm$core$Basics$max, 1, step) * n,
			until,
			_List_Nil,
			first) : _List_Nil;
	});
var $justinmimbs$date$Date$Friday = 8;
var $justinmimbs$date$Date$Monday = 4;
var $justinmimbs$date$Date$Saturday = 9;
var $justinmimbs$date$Date$Sunday = 10;
var $justinmimbs$date$Date$Thursday = 7;
var $justinmimbs$date$Date$Tuesday = 5;
var $justinmimbs$date$Date$Wednesday = 6;
var $CurrySoftware$elm_datepicker$DatePicker$Date$weekdayToInterval = function (weekday) {
	switch (weekday) {
		case 0:
			return 4;
		case 1:
			return 5;
		case 2:
			return 6;
		case 3:
			return 7;
		case 4:
			return 8;
		case 5:
			return 9;
		default:
			return 10;
	}
};
var $CurrySoftware$elm_datepicker$DatePicker$prepareDates = F2(
	function (date, firstDayOfWeek) {
		var weekdayAsInterval = $CurrySoftware$elm_datepicker$DatePicker$Date$weekdayToInterval(firstDayOfWeek);
		var start = A2(
			$justinmimbs$date$Date$floor,
			weekdayAsInterval,
			A3(
				$justinmimbs$date$Date$fromCalendarDate,
				$justinmimbs$date$Date$year(date),
				$justinmimbs$date$Date$month(date),
				1));
		var firstOfMonth = A3(
			$justinmimbs$date$Date$fromCalendarDate,
			$justinmimbs$date$Date$year(date),
			$justinmimbs$date$Date$month(date),
			1);
		var end = A2(
			$justinmimbs$date$Date$ceiling,
			weekdayAsInterval,
			A3($justinmimbs$date$Date$add, 1, 1, firstOfMonth));
		return {
			x7: A4($justinmimbs$date$Date$range, 11, 1, start, end),
			r4: date
		};
	});
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $CurrySoftware$elm_datepicker$DatePicker$Pick = function (a) {
	return {$: 2, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$mkClassList = F2(
	function (_v0, cs) {
		var classNamespace = _v0.fm;
		return $elm$html$Html$Attributes$classList(
			A2(
				$elm$core$List$map,
				function (_v1) {
					var c = _v1.a;
					var b = _v1.b;
					return _Utils_Tuple2(
						_Utils_ap(classNamespace, c),
						b);
				},
				cs));
	});
var $CurrySoftware$elm_datepicker$DatePicker$viewDay = F5(
	function (settings, picked, isOtherMonth, isToday, d) {
		var disabled = settings.zh(d);
		var props = (!disabled) ? _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$CurrySoftware$elm_datepicker$DatePicker$Pick(d))
			]) : _List_Nil;
		var classList = $CurrySoftware$elm_datepicker$DatePicker$mkClassList(settings);
		return A2(
			$elm$html$Html$td,
			_Utils_ap(
				_List_fromArray(
					[
						classList(
						_List_fromArray(
							[
								_Utils_Tuple2('day', true),
								_Utils_Tuple2('disabled', disabled),
								_Utils_Tuple2(
								'picked',
								picked(d)),
								_Utils_Tuple2(
								'today',
								isToday(d)),
								_Utils_Tuple2(
								'other-month',
								isOtherMonth(d))
							]))
					]),
				props),
			_List_fromArray(
				[
					settings.rO(
					$elm$core$String$fromInt(
						$justinmimbs$date$Date$day(d)))
				]));
	});
var $CurrySoftware$elm_datepicker$DatePicker$Date$yearRange = F2(
	function (_v0, range) {
		var currentMonth = _v0.r4;
		var today = _v0.d3;
		switch (range.$) {
			case 1:
				var num = range.a;
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(currentMonth) - num,
					$justinmimbs$date$Date$year(currentMonth) + num);
			case 2:
				var start = range.a;
				var end = range.b;
				return A2($elm$core$List$range, start, end);
			case 3:
				var year_ = range.a;
				return A2(
					$elm$core$List$range,
					year_,
					$justinmimbs$date$Date$year(today));
			case 4:
				var year_ = range.a;
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(today),
					year_);
			default:
				return _List_Nil;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$yearRangeActive = function (yearRange) {
	return !_Utils_eq(yearRange, $CurrySoftware$elm_datepicker$DatePicker$Date$Off);
};
var $CurrySoftware$elm_datepicker$DatePicker$datePicker = F3(
	function (pickedDate, settings, model) {
		var focused = model.bE;
		var today = model.d3;
		var picked = function (d) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (pdate) {
						return _Utils_eq(
							$justinmimbs$date$Date$toRataDie(pdate),
							$justinmimbs$date$Date$toRataDie(d));
					},
					pickedDate));
		};
		var onChange = function (handler) {
			return A2(
				$elm$html$Html$Events$on,
				'change',
				A2($elm$json$Json$Decode$map, handler, $elm$html$Html$Events$targetValue));
		};
		var isToday = function (d) {
			return _Utils_eq(
				$justinmimbs$date$Date$toRataDie(d),
				$justinmimbs$date$Date$toRataDie(today));
		};
		var firstDayOffset = $justinmimbs$date$Date$weekdayToNumber(settings.pW) - 1;
		var dpClass = $CurrySoftware$elm_datepicker$DatePicker$mkClass(settings);
		var currentDate = A2(
			$elm$core$Maybe$withDefault,
			today,
			A2($CurrySoftware$elm_datepicker$DatePicker$maybeOr, pickedDate, focused));
		var isOtherMonth = function (d) {
			return !_Utils_eq(
				$justinmimbs$date$Date$month(currentDate),
				$justinmimbs$date$Date$month(d));
		};
		var arrow = F2(
			function (className, message) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							dpClass(className),
							$elm$html$Html$Events$onClick(message),
							$elm$html$Html$Attributes$tabindex(-1),
							$elm$html$Html$Attributes$type_('button')
						]),
					_List_Nil);
			});
		var _v0 = A2($CurrySoftware$elm_datepicker$DatePicker$prepareDates, currentDate, settings.pW);
		var currentMonth = _v0.r4;
		var currentDates = _v0.x7;
		var dayList = A2(
			$elm$core$List$map,
			function (rowDays) {
				return A2(
					$elm$html$Html$tr,
					_List_fromArray(
						[
							dpClass('row')
						]),
					A2(
						$elm$core$List$map,
						A4($CurrySoftware$elm_datepicker$DatePicker$viewDay, settings, picked, isOtherMonth, isToday),
						rowDays));
			},
			$CurrySoftware$elm_datepicker$DatePicker$groupDates(currentDates));
		var isCurrentYear = function (selectedYear) {
			return _Utils_eq(
				$justinmimbs$date$Date$year(currentMonth),
				selectedYear);
		};
		var yearOption = F2(
			function (index, selectedYear) {
				return _Utils_Tuple2(
					$elm$core$String$fromInt(index),
					A2(
						$elm$html$Html$option,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$value(
								$elm$core$String$fromInt(selectedYear)),
								$elm$html$Html$Attributes$selected(
								isCurrentYear(selectedYear))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(selectedYear))
							])));
			});
		var _v1 = function () {
			var front = function (to_) {
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(currentMonth),
					to_);
			};
			var back = function (from_) {
				return A2(
					$elm$core$List$range,
					from_,
					$justinmimbs$date$Date$year(currentMonth));
			};
			var _v2 = settings.lp;
			switch (_v2.$) {
				case 3:
					var from_ = _v2.a;
					return _Utils_Tuple2(
						front(from_ - 1),
						back(
							$justinmimbs$date$Date$year(today) + 1));
				case 4:
					var to_ = _v2.a;
					return _Utils_Tuple2(
						front(
							$justinmimbs$date$Date$year(today) - 1),
						back(to_ + 1));
				case 2:
					var from_ = _v2.a;
					var to_ = _v2.b;
					return _Utils_Tuple2(
						front(from_ - 1),
						back(to_ + 1));
				case 1:
					var y = _v2.a;
					return _Utils_Tuple2(_List_Nil, _List_Nil);
				default:
					return _Utils_Tuple2(_List_Nil, _List_Nil);
			}
		}();
		var addedYearsFront = _v1.a;
		var addedYearsBack = _v1.b;
		var dropdownYear = A3(
			$elm$html$Html$Keyed$node,
			'select',
			_List_fromArray(
				[
					onChange(
					A2(
						$elm$core$Basics$composeR,
						$CurrySoftware$elm_datepicker$DatePicker$Date$changeYear(currentDate),
						$CurrySoftware$elm_datepicker$DatePicker$ChangeFocus)),
					dpClass('year-menu')
				]),
			A2(
				$elm$core$List$indexedMap,
				yearOption,
				$elm$core$List$concat(
					_List_fromArray(
						[
							addedYearsFront,
							A2(
							$CurrySoftware$elm_datepicker$DatePicker$Date$yearRange,
							{r4: currentMonth, d3: today},
							settings.lp),
							addedYearsBack
						]))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					dpClass('picker'),
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'mousedown',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($CurrySoftware$elm_datepicker$DatePicker$MouseDown, true))),
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'mouseup',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($CurrySoftware$elm_datepicker$DatePicker$MouseUp, true)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							dpClass('picker-header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									dpClass('prev-container')
								]),
							_List_fromArray(
								[
									A2(
									arrow,
									'prev',
									$CurrySoftware$elm_datepicker$DatePicker$ChangeFocus(
										A3($justinmimbs$date$Date$add, 1, -1, currentDate)))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									dpClass('month-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											dpClass('month')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											settings.tq(
												$justinmimbs$date$Date$month(currentMonth)))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											dpClass('year')
										]),
									_List_fromArray(
										[
											(!$CurrySoftware$elm_datepicker$DatePicker$yearRangeActive(settings.lp)) ? $elm$html$Html$text(
											settings.w1(
												$justinmimbs$date$Date$year(currentMonth))) : A3(
											$elm$html$Html$Keyed$node,
											'span',
											_List_Nil,
											_List_fromArray(
												[
													_Utils_Tuple2(
													$elm$core$String$fromInt(
														$justinmimbs$date$Date$year(currentMonth)),
													dropdownYear)
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									dpClass('next-container')
								]),
							_List_fromArray(
								[
									A2(
									arrow,
									'next',
									$CurrySoftware$elm_datepicker$DatePicker$ChangeFocus(
										A3($justinmimbs$date$Date$add, 1, 1, currentDate)))
								]))
						])),
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							dpClass('table')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_fromArray(
								[
									dpClass('weekdays')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (d) {
											return A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														dpClass('dow')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														settings.r7(d))
													]));
										},
										A2(
											$elm$core$List$take,
											7,
											A2(
												$elm$core$List$drop,
												firstDayOffset,
												$elm$core$List$concat(
													A2(
														$elm$core$List$repeat,
														2,
														_List_fromArray(
															[0, 1, 2, 3, 4, 5, 6])))))))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_fromArray(
								[
									dpClass('days')
								]),
							dayList)
						]))
				]));
	});
var $elm$html$Html$Events$onFocus = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'focus',
		$elm$json$Json$Decode$succeed(msg));
};
var $CurrySoftware$elm_datepicker$DatePicker$view = F3(
	function (pickedDate, settings, _v0) {
		var datepicker = _v0;
		var model = datepicker;
		var potentialInputId = A3(
			$elm$core$Basics$composeR,
			$elm$core$List$singleton,
			$elm$core$List$filterMap($elm$core$Basics$identity),
			A2($elm$core$Maybe$map, $elm$html$Html$Attributes$id, settings.FE));
		var inputClasses = _Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(settings.fm + 'input', true)
				]),
			settings.s_);
		var inputCommon = function (xs) {
			return A2(
				$elm$html$Html$input,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(inputClasses),
							$elm$html$Html$Attributes$name(
							A2($elm$core$Maybe$withDefault, '', settings.FF)),
							$elm$html$Html$Attributes$type_('text'),
							A2(
							$elm$html$Html$Events$on,
							'change',
							$elm$json$Json$Decode$succeed($CurrySoftware$elm_datepicker$DatePicker$SubmitText)),
							$elm$html$Html$Events$onInput($CurrySoftware$elm_datepicker$DatePicker$Text),
							$elm$html$Html$Events$onBlur($CurrySoftware$elm_datepicker$DatePicker$Blur),
							$elm$html$Html$Events$onClick($CurrySoftware$elm_datepicker$DatePicker$Focus),
							$elm$html$Html$Events$onFocus($CurrySoftware$elm_datepicker$DatePicker$Focus)
						]),
					_Utils_ap(
						settings.FA,
						_Utils_ap(potentialInputId, xs))),
				_List_Nil);
		};
		var dateInput = inputCommon(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$placeholder(settings.An),
					$elm$html$Html$Attributes$value(
					A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, settings.D9, pickedDate)),
						model.df))
				]));
		var containerClassList = A2(
			$elm$core$List$cons,
			_Utils_Tuple2(settings.fm + 'container', true),
			settings.rW);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(containerClassList)
				]),
			_List_fromArray(
				[
					dateInput,
					model.dD ? A3($CurrySoftware$elm_datepicker$DatePicker$datePicker, pickedDate, settings, model) : $elm$html$Html$text('')
				]));
	});
var $author$project$CorvusDatePicker$datePickerWithCustomSettings = F4(
	function (settings, date, _v0, msgType) {
		var picker = _v0.a;
		var inputError = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('datepicker-wrapper', true),
							_Utils_Tuple2(
							'datepicker--open',
							$CurrySoftware$elm_datepicker$DatePicker$isOpen(picker)),
							_Utils_Tuple2(
							'error',
							!_Utils_eq(inputError, $elm$core$Maybe$Nothing))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					msgType,
					A3($CurrySoftware$elm_datepicker$DatePicker$view, date, settings, picker)),
					A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$html$Html$text(''),
					$author$project$CorvusDatePicker$datePickerWarningMessageView,
					inputError)
				]));
	});
var $author$project$CorvusDatePicker$view = $author$project$CorvusDatePicker$datePickerWithCustomSettings($author$project$CorvusDatePicker$datePickerSettings);
var $author$project$Login$SurplusLinesLicense$View$expirationDatePicker = function (formInputs) {
	return A3(
		$author$project$CorvusDatePicker$view,
		$author$project$Model$ValidationNext$extract(formInputs.bB),
		formInputs.yG,
		A2($elm$core$Basics$composeR, $author$project$Login$SurplusLinesLicense$Model$ToExpirationDatePicker, $author$project$Login$SurplusLinesLicense$Model$FormInput));
};
var $elm$html$Html$Attributes$maxlength = function (n) {
	return A2(
		_VirtualDom_attribute,
		'maxlength',
		$elm$core$String$fromInt(n));
};
var $author$project$Login$SurplusLinesLicense$View$mutedText = function (textMuted) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('muted')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(textMuted)
			]));
};
var $author$project$Login$SurplusLinesLicense$Model$FeinInputted = function (a) {
	return {$: 8, a: a};
};
var $author$project$Login$SurplusLinesLicense$Model$TransactionIdInputted = function (a) {
	return {$: 13, a: a};
};
var $author$project$Login$SurplusLinesLicense$View$stateDependentField = F2(
	function (policyholderState, formInputs) {
		switch (policyholderState) {
			case 'New Jersey':
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form__group form__group--half')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for('nj-transaction-id'),
									$elm$html$Html$Attributes$class('form__label form__label--required')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Transaction ID')
								])),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('nj-transaction-id'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('form__control', true),
											_Utils_Tuple2(
											'error',
											$author$project$Model$ValidationNext$isInvalid(formInputs.J_))
										])),
									$elm$html$Html$Attributes$type_('text'),
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeR, $author$project$Login$SurplusLinesLicense$Model$TransactionIdInputted, $author$project$Login$SurplusLinesLicense$Model$FormInput)),
									$elm$html$Html$Events$onBlur(
									$author$project$Login$SurplusLinesLicense$Model$FormValidation(11)),
									$elm$html$Html$Attributes$value(
									A2($author$project$Model$ValidationNext$toString, $elm$core$Basics$identity, formInputs.J_))
								]),
							_List_Nil),
							A2(
							$author$project$Login$SurplusLinesLicense$View$displayWhen,
							$author$project$Model$ValidationNext$isInvalid(formInputs.J_),
							'Invalid Transaction ID')
						]));
			case 'New York':
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form__group form__group--half')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for('ny-fein-number'),
									$elm$html$Html$Attributes$class('form__label form__label--required')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('FEIN Number')
								])),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('ny-fein-number'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('form__control', true),
											_Utils_Tuple2(
											'error',
											$author$project$Model$ValidationNext$isInvalid(formInputs.EQ))
										])),
									$elm$html$Html$Attributes$type_('text'),
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeR, $author$project$Login$SurplusLinesLicense$Model$FeinInputted, $author$project$Login$SurplusLinesLicense$Model$FormInput)),
									$elm$html$Html$Events$onBlur(
									$author$project$Login$SurplusLinesLicense$Model$FormValidation(7)),
									$elm$html$Html$Attributes$value(
									A2($author$project$Model$ValidationNext$toString, $elm$core$Basics$identity, formInputs.EQ))
								]),
							_List_Nil),
							A2(
							$author$project$Login$SurplusLinesLicense$View$displayWhen,
							$author$project$Model$ValidationNext$isInvalid(formInputs.EQ),
							'FEIN must be 9 digits')
						]));
			default:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form__group form__group--half')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('')
								]))
						]));
		}
	});
var $elm$html$Html$Attributes$hidden = $elm$html$Html$Attributes$boolProperty('hidden');
var $author$project$States$State = F2(
	function (name, abbr) {
		return {oU: abbr, h$: name};
	});
var $author$project$States$states = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'Alabama',
			A2($author$project$States$State, 'Alabama', 'AL')),
			_Utils_Tuple2(
			'Alaska',
			A2($author$project$States$State, 'Alaska', 'AK')),
			_Utils_Tuple2(
			'Arizona',
			A2($author$project$States$State, 'Arizona', 'AZ')),
			_Utils_Tuple2(
			'Arkansas',
			A2($author$project$States$State, 'Arkansas', 'AR')),
			_Utils_Tuple2(
			'California',
			A2($author$project$States$State, 'California', 'CA')),
			_Utils_Tuple2(
			'Colorado',
			A2($author$project$States$State, 'Colorado', 'CO')),
			_Utils_Tuple2(
			'Connecticut',
			A2($author$project$States$State, 'Connecticut', 'CT')),
			_Utils_Tuple2(
			'Delaware',
			A2($author$project$States$State, 'Delaware', 'DE')),
			_Utils_Tuple2(
			'District of Columbia',
			A2($author$project$States$State, 'District of Columbia', 'DC')),
			_Utils_Tuple2(
			'Florida',
			A2($author$project$States$State, 'Florida', 'FL')),
			_Utils_Tuple2(
			'Georgia',
			A2($author$project$States$State, 'Georgia', 'GA')),
			_Utils_Tuple2(
			'Hawaii',
			A2($author$project$States$State, 'Hawaii', 'HI')),
			_Utils_Tuple2(
			'Idaho',
			A2($author$project$States$State, 'Idaho', 'ID')),
			_Utils_Tuple2(
			'Illinois',
			A2($author$project$States$State, 'Illinois', 'IL')),
			_Utils_Tuple2(
			'Indiana',
			A2($author$project$States$State, 'Indiana', 'IN')),
			_Utils_Tuple2(
			'Iowa',
			A2($author$project$States$State, 'Iowa', 'IA')),
			_Utils_Tuple2(
			'Kansas',
			A2($author$project$States$State, 'Kansas', 'KS')),
			_Utils_Tuple2(
			'Kentucky',
			A2($author$project$States$State, 'Kentucky', 'KY')),
			_Utils_Tuple2(
			'Louisiana',
			A2($author$project$States$State, 'Louisiana', 'LA')),
			_Utils_Tuple2(
			'Maine',
			A2($author$project$States$State, 'Maine', 'ME')),
			_Utils_Tuple2(
			'Maryland',
			A2($author$project$States$State, 'Maryland', 'MD')),
			_Utils_Tuple2(
			'Massachusetts',
			A2($author$project$States$State, 'Massachusetts', 'MA')),
			_Utils_Tuple2(
			'Michigan',
			A2($author$project$States$State, 'Michigan', 'MI')),
			_Utils_Tuple2(
			'Minnesota',
			A2($author$project$States$State, 'Minnesota', 'MN')),
			_Utils_Tuple2(
			'Mississippi',
			A2($author$project$States$State, 'Mississippi', 'MS')),
			_Utils_Tuple2(
			'Missouri',
			A2($author$project$States$State, 'Missouri', 'MO')),
			_Utils_Tuple2(
			'Montana',
			A2($author$project$States$State, 'Montana', 'MT')),
			_Utils_Tuple2(
			'Nebraska',
			A2($author$project$States$State, 'Nebraska', 'NE')),
			_Utils_Tuple2(
			'Nevada',
			A2($author$project$States$State, 'Nevada', 'NV')),
			_Utils_Tuple2(
			'New Hampshire',
			A2($author$project$States$State, 'New Hampshire', 'NH')),
			_Utils_Tuple2(
			'New Jersey',
			A2($author$project$States$State, 'New Jersey', 'NJ')),
			_Utils_Tuple2(
			'New Mexico',
			A2($author$project$States$State, 'New Mexico', 'NM')),
			_Utils_Tuple2(
			'New York',
			A2($author$project$States$State, 'New York', 'NY')),
			_Utils_Tuple2(
			'North Carolina',
			A2($author$project$States$State, 'North Carolina', 'NC')),
			_Utils_Tuple2(
			'North Dakota',
			A2($author$project$States$State, 'North Dakota', 'ND')),
			_Utils_Tuple2(
			'Ohio',
			A2($author$project$States$State, 'Ohio', 'OH')),
			_Utils_Tuple2(
			'Oklahoma',
			A2($author$project$States$State, 'Oklahoma', 'OK')),
			_Utils_Tuple2(
			'Oregon',
			A2($author$project$States$State, 'Oregon', 'OR')),
			_Utils_Tuple2(
			'Pennsylvania',
			A2($author$project$States$State, 'Pennsylvania', 'PA')),
			_Utils_Tuple2(
			'Rhode Island',
			A2($author$project$States$State, 'Rhode Island', 'RI')),
			_Utils_Tuple2(
			'South Carolina',
			A2($author$project$States$State, 'South Carolina', 'SC')),
			_Utils_Tuple2(
			'South Dakota',
			A2($author$project$States$State, 'South Dakota', 'SD')),
			_Utils_Tuple2(
			'Tennessee',
			A2($author$project$States$State, 'Tennessee', 'TN')),
			_Utils_Tuple2(
			'Texas',
			A2($author$project$States$State, 'Texas', 'TX')),
			_Utils_Tuple2(
			'Utah',
			A2($author$project$States$State, 'Utah', 'UT')),
			_Utils_Tuple2(
			'Vermont',
			A2($author$project$States$State, 'Vermont', 'VT')),
			_Utils_Tuple2(
			'Virginia',
			A2($author$project$States$State, 'Virginia', 'VA')),
			_Utils_Tuple2(
			'Washington',
			A2($author$project$States$State, 'Washington', 'WA')),
			_Utils_Tuple2(
			'West Virginia',
			A2($author$project$States$State, 'West Virginia', 'WV')),
			_Utils_Tuple2(
			'Wisconsin',
			A2($author$project$States$State, 'Wisconsin', 'WI')),
			_Utils_Tuple2(
			'Wyoming',
			A2($author$project$States$State, 'Wyoming', 'WY')),
			_Utils_Tuple2(
			'N/A',
			A2($author$project$States$State, 'International - N/A', 'N/A'))
		]));
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$States$stateOptions = function (selectedState) {
	var selectOption = A2(
		$elm$html$Html$option,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$disabled(true),
				$elm$html$Html$Attributes$selected(
				$elm$core$String$isEmpty(selectedState)),
				$elm$html$Html$Attributes$hidden(true)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Select a State')
			]));
	return A2(
		$elm$core$List$cons,
		selectOption,
		A2(
			$elm$core$List$map,
			function (s) {
				return A2(
					$elm$html$Html$option,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$selected(
							_Utils_eq(selectedState, s.h$) || _Utils_eq(selectedState, s.oU))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(s.h$)
						]));
			},
			$elm$core$Dict$values($author$project$States$states)));
};
var $author$project$Login$SurplusLinesLicense$View$formView = function (_v0) {
	var policyholderState = _v0.b;
	var formInputs = _v0.c;
	return A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form__section')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form__group form__group--half')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for('policyholder-state'),
										$elm$html$Html$Attributes$class('form__label')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Policyholder Domiciled State')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('policyholder-state')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(policyholderState)
									]))
							])),
						A2($author$project$Login$SurplusLinesLicense$View$stateDependentField, policyholderState, formInputs),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form__group form__group--half')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for('license-number'),
										$elm$html$Html$Attributes$class('form__label')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('form__label--required')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('SL Tax Filer License Number')
											])),
										$author$project$Login$SurplusLinesLicense$View$mutedText('(Verify Accuracy or Enter Correct Number)')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('license-number'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('form__control', true),
												_Utils_Tuple2(
												'error',
												$author$project$Model$ValidationNext$isInvalid(formInputs.F9))
											])),
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeR, $author$project$Login$SurplusLinesLicense$Model$LicenseNumberInputted, $author$project$Login$SurplusLinesLicense$Model$FormInput)),
										$elm$html$Html$Events$onBlur(
										$author$project$Login$SurplusLinesLicense$Model$FormValidation(8)),
										$elm$html$Html$Attributes$value(
										A2($author$project$Model$ValidationNext$toString, $elm$core$Basics$identity, formInputs.F9))
									]),
								_List_Nil),
								A2(
								$author$project$Login$SurplusLinesLicense$View$displayWhen,
								$author$project$Model$ValidationNext$isInvalid(formInputs.F9),
								'Invalid License Number')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form__group form__group--half')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for('expiration-date'),
										$elm$html$Html$Attributes$class('form__label form__label--required')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('SL License Expiration Date')
									])),
								$author$project$Login$SurplusLinesLicense$View$expirationDatePicker(formInputs)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form__group form__group--full')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for('filing-agency'),
										$elm$html$Html$Attributes$class('form__label')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('form__label--required')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('SL Tax Filer')
											])),
										$author$project$Login$SurplusLinesLicense$View$mutedText('(Verify Accuracy or Enter Correct Name)')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('filing-agency'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('form__control', true),
												_Utils_Tuple2(
												'error',
												$author$project$Model$ValidationNext$isInvalid(formInputs.yK))
											])),
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeR, $author$project$Login$SurplusLinesLicense$Model$NameInputted, $author$project$Login$SurplusLinesLicense$Model$FormInput)),
										$elm$html$Html$Events$onBlur(
										$author$project$Login$SurplusLinesLicense$Model$FormValidation(9)),
										$elm$html$Html$Attributes$value(
										A2($author$project$Model$ValidationNext$toString, $elm$core$Basics$identity, formInputs.yK))
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form__group form__group--full')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for('address'),
										$elm$html$Html$Attributes$class('form__label form__label--required')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('SL Tax Filer Street Address')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('address'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('form__control', true),
												_Utils_Tuple2(
												'error',
												$author$project$Model$ValidationNext$isInvalid(formInputs.w8))
											])),
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeR, $author$project$Login$SurplusLinesLicense$Model$AddressLineOneInputted, $author$project$Login$SurplusLinesLicense$Model$FormInput)),
										$elm$html$Html$Events$onBlur(
										$author$project$Login$SurplusLinesLicense$Model$FormValidation(1)),
										$elm$html$Html$Attributes$value(
										A2($author$project$Model$ValidationNext$toString, $elm$core$Basics$identity, formInputs.w8))
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form__group form__group--full')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for('address-two'),
										$elm$html$Html$Attributes$class('form__label')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Address Line 2'),
										$author$project$Login$SurplusLinesLicense$View$mutedText('(Optional)')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('address-two'),
										$elm$html$Html$Attributes$class('form__control'),
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeR, $author$project$Login$SurplusLinesLicense$Model$AddressLineTwoInputted, $author$project$Login$SurplusLinesLicense$Model$FormInput)),
										$elm$html$Html$Events$onBlur(
										$author$project$Login$SurplusLinesLicense$Model$FormValidation(2)),
										$elm$html$Html$Attributes$value(
										A2($author$project$Model$ValidationNext$toString, $elm$core$Basics$identity, formInputs.w9))
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form__group form__group--third')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for('city'),
										$elm$html$Html$Attributes$class('form__label form__label--required')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('City')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('city'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('form__control', true),
												_Utils_Tuple2(
												'error',
												$author$project$Model$ValidationNext$isInvalid(formInputs.w7))
											])),
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeR, $author$project$Login$SurplusLinesLicense$Model$AddressCityInputted, $author$project$Login$SurplusLinesLicense$Model$FormInput)),
										$elm$html$Html$Events$onBlur(
										$author$project$Login$SurplusLinesLicense$Model$FormValidation(0)),
										$elm$html$Html$Attributes$value(
										A2($author$project$Model$ValidationNext$toString, $elm$core$Basics$identity, formInputs.w7))
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form__group form__group--third')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for('state'),
										$elm$html$Html$Attributes$class('form__label form__label--required')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('State')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('select-wrapper')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$select,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$id('state'),
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2('form__control', true),
														_Utils_Tuple2(
														'error',
														$author$project$Model$ValidationNext$isInvalid(formInputs.xb))
													])),
												$author$project$View$Util$onChange(
												A2($elm$core$Basics$composeR, $author$project$Login$SurplusLinesLicense$Model$AddressStateSelected, $author$project$Login$SurplusLinesLicense$Model$FormInput)),
												$elm$html$Html$Events$onBlur(
												$author$project$Login$SurplusLinesLicense$Model$FormValidation(4))
											]),
										$author$project$States$stateOptions(
											A2($author$project$Model$ValidationNext$toString, $elm$core$Basics$identity, formInputs.xb)))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form__group form__group--third')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for('postal-code'),
										$elm$html$Html$Attributes$class('form__label form__label--required')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Zip Code')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('postal-code'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('form__control', true),
												_Utils_Tuple2(
												'error',
												$author$project$Model$ValidationNext$isInvalid(formInputs.xa))
											])),
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeR, $author$project$Login$SurplusLinesLicense$Model$AddressPostalCodeInputted, $author$project$Login$SurplusLinesLicense$Model$FormInput)),
										$elm$html$Html$Events$onBlur(
										$author$project$Login$SurplusLinesLicense$Model$FormValidation(3)),
										$elm$html$Html$Attributes$value(
										A2($author$project$Model$ValidationNext$toString, $elm$core$Basics$identity, formInputs.xa))
									]),
								_List_Nil),
								A2(
								$author$project$Login$SurplusLinesLicense$View$displayWhen,
								$author$project$Model$ValidationNext$isInvalid(formInputs.xa),
								'Invalid ZIP Code')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form__group form__group--half')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for('filer-phone-number'),
										$elm$html$Html$Attributes$class('form__label form__label--required')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('SL Tax Filer Phone Number')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('filer-phone-number'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('form__control', true),
												_Utils_Tuple2(
												'error',
												$author$project$Model$ValidationNext$isInvalid(formInputs.dG))
											])),
										$elm$html$Html$Attributes$type_('tel'),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeR, $author$project$Login$SurplusLinesLicense$Model$PhoneInputted, $author$project$Login$SurplusLinesLicense$Model$FormInput)),
										$elm$html$Html$Events$onBlur(
										$author$project$Login$SurplusLinesLicense$Model$FormValidation(10)),
										$elm$html$Html$Attributes$placeholder('(123) 456-7890'),
										$elm$html$Html$Attributes$maxlength(14),
										$elm$html$Html$Attributes$value(
										$author$project$Login$SurplusLinesLicense$View$displayPhoneNumber(formInputs.dG))
									]),
								_List_Nil),
								A2(
								$author$project$Login$SurplusLinesLicense$View$displayWhen,
								$author$project$Model$ValidationNext$isInvalid(formInputs.dG),
								'Phone number must be in (###) ###-#### format.')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form__group form__group--half')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for('filer-email'),
										$elm$html$Html$Attributes$class('form__label form__label--required')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('SL Tax Filer Email')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('filer-email'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('form__control', true),
												_Utils_Tuple2(
												'error',
												$author$project$Model$ValidationNext$isInvalid(formInputs.aW))
											])),
										$elm$html$Html$Attributes$type_('email'),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeR, $author$project$Login$SurplusLinesLicense$Model$EmailInputted, $author$project$Login$SurplusLinesLicense$Model$FormInput)),
										$elm$html$Html$Events$onBlur(
										$author$project$Login$SurplusLinesLicense$Model$FormValidation(6)),
										$elm$html$Html$Attributes$placeholder('name@company.com'),
										$elm$html$Html$Attributes$value(
										$author$project$Data$Email$validatedToString(formInputs.aW))
									]),
								_List_Nil),
								A2(
								$author$project$Login$SurplusLinesLicense$View$displayWhen,
								$author$project$Model$ValidationNext$isInvalid(formInputs.aW),
								'Invalid email')
							]))
					]))
			]));
};
var $author$project$Login$SurplusLinesLicense$Model$hasErrors = function (_v0) {
	var hasValidInputs = _v0.g2;
	switch (hasValidInputs) {
		case 0:
			return false;
		case 1:
			return false;
		default:
			return true;
	}
};
var $author$project$Login$SurplusLinesLicense$View$certificateBody = function (model) {
	var formInputs = model.c;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('surplus-lines__section')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text($author$project$Login$SurplusLinesLicense$View$certificateDisclaimer)
					])),
				$author$project$Login$SurplusLinesLicense$View$formView(model),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('surplus-lines__section')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text($author$project$Login$SurplusLinesLicense$View$attestationText)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('surplus-lines__section')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form__group form__group--half')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for('filer-person-name'),
										$elm$html$Html$Attributes$class('form__label')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Your Name')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('filer-person-name'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('form__control', true),
												_Utils_Tuple2(
												'error',
												$author$project$Model$ValidationNext$isInvalid(formInputs.xl))
											])),
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeR, $author$project$Login$SurplusLinesLicense$Model$AttestorNameInputted, $author$project$Login$SurplusLinesLicense$Model$FormInput)),
										$elm$html$Html$Events$onBlur(
										$author$project$Login$SurplusLinesLicense$Model$FormValidation(5)),
										$elm$html$Html$Attributes$value(
										A2($author$project$Model$ValidationNext$toString, $elm$core$Basics$identity, formInputs.xl))
									]),
								_List_Nil),
								A2(
								$author$project$Login$SurplusLinesLicense$View$displayWhen,
								$author$project$Model$ValidationNext$isInvalid(formInputs.xl),
								'Please provide your name')
							])),
						A5(
						$author$project$View$Input$checkbox,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('surplus-lines__section')
							]),
						'attestation-filing-check',
						formInputs.zd,
						'I attest that the information provided here is accurate and up to date.',
						A2($elm$core$Basics$composeR, $author$project$Login$SurplusLinesLicense$Model$AttestationCheckboxClicked, $author$project$Login$SurplusLinesLicense$Model$FormInput)),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('surplus-lines__section')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$CorvusDesignSystem$Button$button,
								_List_fromArray(
									[
										$author$project$CorvusDesignSystem$Button$buttonModifier(
										$author$project$CorvusDesignSystem$Button$Size(1))
									]),
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$Login$SurplusLinesLicense$Model$SubmitClicked)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('surplus-lines__submit-button')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Submit')
											]))
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('m-l3')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Login$SurplusLinesLicense$View$displayWhen,
										$author$project$Login$SurplusLinesLicense$Model$hasErrors(formInputs),
										'There appears to be an error in the form. Please review.')
									]))
							]))
					]))
			]));
};
var $author$project$Login$SurplusLinesLicense$View$certificateView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('surplus-lines__body')
			]),
		_List_fromArray(
			[
				$author$project$Login$SurplusLinesLicense$View$certificateBody(model)
			]));
};
var $author$project$View$Card$Error = 0;
var $author$project$View$Card$body = F2(
	function (attrs, children) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('card__body'),
				attrs),
			children);
	});
var $author$project$View$Card$card = F2(
	function (attrs, children) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('card'),
				attrs),
			children);
	});
var $author$project$View$Card$tight = $elm$html$Html$Attributes$class('-tight');
var $author$project$View$Card$single = F2(
	function (attrs, children) {
		return A2(
			$author$project$View$Card$card,
			A2($elm$core$List$cons, $author$project$View$Card$tight, attrs),
			_List_fromArray(
				[
					A2($author$project$View$Card$body, _List_Nil, children)
				]));
	});
var $author$project$View$Card$toStatusClass = function (s) {
	switch (s) {
		case 0:
			return 'error';
		case 1:
			return '';
		case 2:
			return 'success';
		case 3:
			return 'accent';
		default:
			return 'warning';
	}
};
var $author$project$View$Card$status = function (s) {
	return $elm$html$Html$Attributes$class(
		'card--has-status ' + $author$project$View$Card$toStatusClass(s));
};
var $author$project$Login$SurplusLinesLicense$View$errorView = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('surplus-lines__card')
		]),
	_List_fromArray(
		[
			A2(
			$author$project$View$Card$single,
			_List_fromArray(
				[
					$author$project$View$Card$status(0),
					$elm$html$Html$Attributes$class('surplus-lines__card-body')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('m-b4')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('An error occurred.')
						])),
					$elm$html$Html$text('Please reload the page to try again.')
				]))
		]));
var $elm$html$Html$br = _VirtualDom_node('br');
var $author$project$Login$SurplusLinesLicense$View$expiredBody = A2(
	$elm$html$Html$p,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('We apologize, it looks like this link has expired and is no longer valid.'),
			A2($elm$html$Html$br, _List_Nil, _List_Nil),
			$elm$html$Html$text('Please reach out to your underwriter at Corvus to submit your Surplus Lines Certificate.')
		]));
var $author$project$Login$SurplusLinesLicense$View$expiredHeaderText = 'Link Expired';
var $author$project$Login$SurplusLinesLicense$View$expiredView = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('surplus-lines__card')
		]),
	_List_fromArray(
		[
			A2(
			$author$project$View$Card$single,
			_List_fromArray(
				[
					$author$project$View$Card$status(0),
					$elm$html$Html$Attributes$class('surplus-lines__card-body')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('m-b4')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text($author$project$Login$SurplusLinesLicense$View$expiredHeaderText)
						])),
					$author$project$Login$SurplusLinesLicense$View$expiredBody
				]))
		]));
var $author$project$Login$SurplusLinesLicense$View$loadingView = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('surplus-lines__card')
		]),
	_List_fromArray(
		[$author$project$View$Util$loading]));
var $author$project$View$Card$Success = 2;
var $author$project$Login$SurplusLinesLicense$View$submittedBodyText = 'Our underwriting team has received the information. If you need to make changes, please reach out to your Corvus underwriter.';
var $author$project$Login$SurplusLinesLicense$View$submittedHeaderText = 'Thank you for submitting your Surplus Lines Certificate.';
var $author$project$Login$SurplusLinesLicense$View$submittedView = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('surplus-lines__card')
		]),
	_List_fromArray(
		[
			A2(
			$author$project$View$Card$single,
			_List_fromArray(
				[
					$author$project$View$Card$status(2),
					$elm$html$Html$Attributes$class('surplus-lines__card-body')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('m-b4')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text($author$project$Login$SurplusLinesLicense$View$submittedHeaderText)
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text($author$project$Login$SurplusLinesLicense$View$submittedBodyText)
						]))
				]))
		]));
var $author$project$Login$SurplusLinesLicense$View$contentBody = function (model) {
	var status = model.d;
	switch (status) {
		case 0:
			return $author$project$Login$SurplusLinesLicense$View$certificateView(model);
		case 1:
			return $author$project$Login$SurplusLinesLicense$View$submittedView;
		case 2:
			return $author$project$Login$SurplusLinesLicense$View$expiredView;
		case 3:
			return $author$project$Login$SurplusLinesLicense$View$loadingView;
		default:
			return $author$project$Login$SurplusLinesLicense$View$errorView;
	}
};
var $author$project$Login$SurplusLinesLicense$View$pageHeader = F2(
	function (environment, _v0) {
		var logo = A2(
			$author$project$View$Nav$logoCorvusByTravelers,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('surplus-lines__logo tw-inline-flex [&_>_img]:tw-w-40')
				]),
			environment);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('surplus-lines__header')
				]),
			_List_fromArray(
				[
					logo,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('surplus-lines__title')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Surplus Lines Certificate')
								]))
						]))
				]));
	});
var $author$project$Login$SurplusLinesLicense$View$view = F3(
	function (environment, featureFlags, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('surplus-lines')
				]),
			_List_fromArray(
				[
					A2($author$project$Login$SurplusLinesLicense$View$pageHeader, environment, featureFlags),
					$author$project$Login$SurplusLinesLicense$View$contentBody(model)
				]));
	});
var $author$project$Login$View$body = function (model) {
	var _v0 = model.Ac;
	switch (_v0.$) {
		case 0:
			var subModel = _v0.a;
			return A2(
				$author$project$Login$View$signinLayout,
				model,
				A2(
					$elm$html$Html$map,
					$author$project$Login$Model$AccountSetupMsg,
					$author$project$Login$AccountSetup$view(subModel)));
		case 1:
			var parentBrokerageId = _v0.a;
			var affiliateBrokerageId = _v0.b;
			var subModel = _v0.c;
			return A2(
				$author$project$Login$View$affiliateLayout,
				model,
				A2(
					$elm$html$Html$map,
					$author$project$Login$Model$AffiliateSignupMsg,
					A4($author$project$Login$AffiliateSignup$View$view, model.yO, parentBrokerageId, affiliateBrokerageId, subModel)));
		case 2:
			var submodel = _v0.a;
			return A2(
				$author$project$Login$View$signinLayout,
				model,
				A2(
					$elm$html$Html$map,
					$author$project$Login$Model$AlertSubscriberNewMsg,
					$author$project$Login$AlertSubscriberNew$View$view(submodel)));
		case 3:
			var submodel = _v0.a;
			return A2(
				$author$project$Login$View$signinLayout,
				model,
				A2(
					$elm$html$Html$map,
					$author$project$Login$Model$AlertSubscriberUnsubscribeMsg,
					$author$project$Login$AlertSubscriberUnsubscribe$View$view(submodel)));
		case 4:
			var subModel = _v0.a;
			return A2(
				$author$project$Login$View$fixedHeightBasicLayout,
				model,
				A2(
					$elm$html$Html$map,
					$author$project$Login$Model$ConfirmBindFormMsg,
					A3($author$project$Login$ConfirmBindForm$view, model.EF, model.yI, subModel)));
		case 5:
			var subModel = _v0.a;
			return A2(
				$author$project$Login$View$signinLayout,
				model,
				A2(
					$elm$html$Html$map,
					$author$project$Login$Model$ForgotPasswordMsg,
					$author$project$Login$ForgotPassword$View$view(subModel)));
		case 6:
			var subModel = _v0.a;
			return A2(
				$author$project$Login$View$nonAuthRansomwareLayout,
				model,
				A2(
					$elm$html$Html$map,
					$author$project$Login$Model$RansomwareMsg,
					$author$project$Login$Ransomware$View$view(subModel)));
		case 7:
			var subModel = _v0.a;
			return A2(
				$author$project$Login$View$signinLayout,
				model,
				A2(
					$elm$html$Html$map,
					$author$project$Login$Model$SigninMsg,
					A2($author$project$Login$SigninV2$View$view, subModel, model.yO)));
		default:
			var subModel = _v0.a;
			return A2(
				$author$project$Login$View$basicLayout,
				model,
				A2(
					$elm$html$Html$map,
					$author$project$Login$Model$SurplusLinesLicenseMsg,
					A3($author$project$Login$SurplusLinesLicense$View$view, model.EF, model.yI, subModel)));
	}
};
var $author$project$Login$View$view = function (model) {
	return A2(
		$elm$browser$Browser$Document,
		'Cyber Insurance Coverage and Solutions',
		_List_fromArray(
			[
				$author$project$Login$View$body(model)
			]));
};
var $author$project$Login$Main$main = $elm$browser$Browser$application(
	{Fz: $author$project$Login$Main$init, Hg: $author$project$Login$Model$OnUrlChange, Hh: $author$project$Login$Model$OnUrlRequest, Jq: $author$project$Login$Update$subscriptions, Ka: $author$project$Login$Update$update, Ke: $author$project$Login$View$view});
_Platform_export({'Login':{'Main':{'init':$author$project$Login$Main$main($elm$json$Json$Decode$value)(0)}}});}(this));